/**
 * Generated by orval 🍺
 * Do not edit manually.
 * eddy-be
 * API documentation of eddy-be
 * OpenAPI spec version: 3.4.15
 */
import {
  useMutation,
  useQuery,
  useQueryClient
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  InvalidateOptions,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccessCodeControllerCreate201,
  AccessCodeControllerFindAll200Item,
  AccessCodeLoginResponseDto,
  AccessCodeResponseDto,
  ActivityBankControllerGetTemplateOpsFromGoogleSheet200Item,
  ActivityBankControllerUploadAssetBody,
  ActivityControllerFindAll200Item,
  ActivityControllerFindById200,
  ActivityControllerGetActivityScore200,
  ActivityControllerGetActivityScoreParams,
  ActivityControllerStartActivity201,
  ActivityControllerUpdate200,
  ActivityGradingCriteriaResponseDto,
  ActivityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId200,
  ActivityInstanceControllerFindActivityInstanceTaskTransactions200Item,
  ActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceId200,
  ActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceIdParams,
  ActivityInstanceControllerGetUserActivityInstances200Item,
  ActivityInstanceMetadataControllerCreate201,
  ActivityInstanceMetadataControllerFindAll200Item,
  ActivityInstanceMetadataControllerFindById200,
  ActivityMetadataResponseDto,
  ActivitySessionControllerGetActivitySessionProgress200,
  ActivitySessionControllerGetGradingCriteriaConfig200,
  ActivitySessionControllerGetGradingCriteriaConfigParams,
  ActivitySessionControllerSubmitTask201,
  ActivitySessionControllerSubmitTaskWithAudio201,
  AddTranslationDto,
  AddUserToSchoolGroupAdminDto,
  AddUsersToClassroomDto,
  AiDiffSentenceOperation,
  AiDiffSentenceRequestDto,
  AiGradeGrammarRequestDto,
  AiGradeGrammarResponseData,
  AiParseToParsedTextContentRequestDto,
  AiSentenceSimilarityRequestDto,
  AiSentenceSimilarityResponseData,
  AppControllerLoginParams,
  ApplyFeedbackDto,
  ApplyFeedbackV2Dto,
  ApplyTaxonomyTagsDto,
  ApplyTaxonomyTagsResponseDto,
  AuditLogsControllerGetActivityAuditLogsByUser200Item,
  AuditLogsControllerGetActivityAuditLogsByUserParams,
  AuditLogsControllerGetOneAuditLogsByActivityInstanceId200,
  AuditLogsControllerGetOneAuditLogsByActivityInstanceIdParams,
  AvatarControllerGetCatalogParams,
  AvatarControllerGetInventoryParams,
  AvatarSelectionWithItemsDto,
  BaseCompleteOEScaffoldingTaskDto,
  BaseCompleteOEVocabLearningTaskDto,
  BaseCompleteTaskTransactionDto,
  BaseSubmitOEScaffoldingTaskDto,
  BaseSubmitOEVocabLearningTaskDto,
  BaseSubmitTaskDto,
  BaseUpdateActivityDto,
  BatchCreateLessonAndActivitiesDto,
  BuildBlueprintDto,
  BulkCreateClassroomsUsersDto,
  BulkGetDto,
  CancelStaleLiveSessionsResultDto,
  ChangePasswordDto,
  CheatDetectionControllerFindMany200Item,
  CheatDetectionControllerFindManyParams,
  CheatDetectionResults,
  CheckNoiseDto,
  CheckNoiseResponseDto,
  CheckoutOrderResponseDto,
  Classroom,
  ClassroomActivationCode,
  ClassroomActivationCodeControllerGetByCode201,
  ClassroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomIdParams,
  ClassroomControllerBatchCreateLessonWithActivities201Item,
  ClassroomControllerCreateLessonWithActivities201,
  ClassroomControllerGetClassroomAccessCodes200Item,
  ClassroomControllerGetClassroomActivationCodes200Item,
  ClassroomControllerGetLessonHistoryInClassroom200,
  ClassroomControllerGetLessonInstances200Item,
  ClassroomControllerGetLessonInstancesByStatus200Item,
  ClassroomControllerGetLessonInstancesByStatusParams,
  ClassroomControllerGetLessonInstancesParams,
  ClassroomControllerGetLessonsInClassroom200Item,
  ClassroomIndividualReportDataResponseDto,
  ClassroomInstructorControllerGetActivitySummariesWithScoreByClassroom200,
  ClassroomInstructorControllerGetLatestLessonInstancesByStudent200,
  ClassroomInstructorControllerGetLessonAverageScoreByActivity200Item,
  ClassroomInstructorControllerGetLessonAverageScoreByActivityParams,
  ClassroomInstructorControllerGetLessonAverageStudentsScore200,
  ClassroomInstructorControllerGetLessonInstancesByClassroom200,
  ClassroomInstructorControllerGetLessonSummariesByClassroom200,
  ClassroomInstructorControllerGetLessonSummariesWithScoreByClassroom200,
  ClassroomInstructorControllerGetMispronunciationsByClassroom200Item,
  ClassroomInstructorControllerGetProgressByStudentXlsxParams,
  ClassroomInstructorControllerGetSchoolLessonStatusTableDataParams,
  ClassroomLesson,
  ClassroomLessonControllerSearchParams,
  ClassroomLessonStateControllerGetRevampLessonCardDataInClassroomParams,
  ClassroomPathStateDto,
  ClassroomReportControllerGetEoSReportDataParams,
  ClassroomReportControllerGetIndividualReportDataParams,
  ClassroomReportPrintingDataDto,
  ContextualTranslateBySearchVocabsDto,
  ContextualTranslateByVocabIdsDto,
  CourseControllerUploadCoverImageBody,
  CourseResponseDto,
  CreateAccessCodeDto,
  CreateActivityInstanceMetadataDto,
  CreateActivityMetadataDto,
  CreateAndAddActivitiesToLessonParams,
  CreateBatchUserWithAccessCodeDto,
  CreateClassroomActivationCodeDto,
  CreateClassroomDto,
  CreateClassroomLessonDto,
  CreateCourseDto,
  CreateEoSReportDto,
  CreateGroupingRunDto,
  CreateIndividualReportDto,
  CreateItemDto,
  CreateLessonAndActivitiesDto,
  CreateLessonDto,
  CreateLiveSessionDto,
  CreateLiveSessionSlotDto,
  CreateOrderDto,
  CreatePortfolioPasscodeDto,
  CreateSchoolDto,
  CreateSchoolGroupDto,
  CreateUserActionLogDto,
  CreateUserFromEmailPasswordWithMetadataDto,
  CreateUserMetadataDto,
  CreateUserWithAccessCodeDto,
  CreateUserWithMetadataDto,
  CreateUsersInClassroomDto,
  CreateVocabDto,
  CreateVocabV2Dto,
  CreateYourOwnResponseTaskTransaction,
  DataExportControllerGetShoolProgressCsvByClassroomDateParams,
  DeleteRunResultDto,
  EdetControllerGetAccessCodeGroupWithDetails200,
  EdetControllerGetAccessCodeGroups200Item,
  EdetCreateAccessCodesDto,
  EdsyCoinControllerGetCoinTransactionsParams,
  EdsyCoinTransaction,
  EdsyPointControllerGetAllUserAndClassroomPoint200Item,
  EdsyPointControllerGetAllUserPoint200Item,
  EdsyPointControllerGetUserAndClassroomPoint200,
  EdsyPointControllerGetUserPointsHistory200Item,
  EdsyPointControllerGetUserPointsHistoryParams,
  EdsyPointResponseDto,
  EdsyXPControllerGetXpTransactionsParams,
  EdsyXPResponseDto,
  EdsyXpTransactionResponseDto,
  EnsureTaxonomyTagLabelsDto,
  EnsureTaxonomyTagLabelsResponseDto,
  EquipItemDto,
  ExecuteLessonDeletionDto,
  ExportLessonTemplatesDto,
  ExtractBlueprintsDto,
  FeatureFlag,
  FeatureFlagControllerGetAllFeatureFlagsParams,
  FeatureFlagName,
  GcpStorageControllerGetGcpStorageAudioParams,
  GeneratePronunciationDraftVocabV2Dto,
  GeneratePronunciationDraftVocabV2ResponseDto,
  GeneratePronunciationVocabV2Dto,
  GeneratePronunciationVocabV2ResponseDto,
  GetSpeechDto,
  GradeLiveSessionPronunciationDto,
  GroupingRunResponseDto,
  ImportTaxonomyTagSheetDto,
  ImportTaxonomyTagSheetResponseDto,
  InvalidCourseResponseDto,
  Item,
  ItemControllerCreate201,
  ItemControllerFindAll200Item,
  ItemControllerFindAllParams,
  ItemControllerFindOne200,
  ItemControllerUpdate200,
  ItemControllerUploadImageBody,
  ItemIdDto,
  JoinLiveSessionDto,
  LeaderboardDto,
  LessonBlueprintControllerListRunsParams,
  LessonBlueprintResponseDto,
  LessonControllerCreate201,
  LessonControllerCreateAndAddActivities201,
  LessonControllerFindById200,
  LessonControllerFindByIds200Item,
  LessonControllerFindByIdsParams,
  LessonControllerGetLessonActivities200Item,
  LessonControllerGetLessonScore200,
  LessonControllerGetLessonScoreParams,
  LessonControllerStartLesson201,
  LessonControllerUpdate200,
  LessonDeletionControllerPreviewParams,
  LessonDeletionExecutionResponseDto,
  LessonDeletionPreviewResponseDto,
  LessonGradingCriteriaControllerGetLessonGradingCriteria200,
  LessonInstance,
  LessonInstanceControllerCompleteLessonInstance201,
  LessonInstanceControllerFindOne200,
  LessonInstanceControllerGetInstancesByClassroom200Item,
  LessonInstanceControllerGetInstancesByClassroomParams,
  LessonInstanceControllerGetInstancesByUserId200Item,
  LessonInstanceControllerGetInstancesByUserIdParams,
  LessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId200,
  LessonInstanceControllerGetLessonInstanceScoreByLessonInstanceIdParams,
  LessonInstanceControllerGetLessonInstanceStatusCountByUserParams,
  LessonInstanceControllerGetUserActivityInstancesByLessonInstanceId200Item,
  LessonInstanceCountResponseDto,
  LessonReportControllerGetActivityInstanceInstanceActivityReport200,
  LessonReportControllerGetLessonInstanceActivityReports200Item,
  LiveSessionClassroomControllerListParams,
  LiveSessionContentPoolDto,
  LiveSessionContentPoolTooLargeErrorDto,
  LiveSessionDetailDto,
  LiveSessionDeviceMismatchErrorDto,
  LiveSessionDto,
  LiveSessionErrorDto,
  LiveSessionListPageDto,
  LiveSessionParticipantDto,
  LiveSessionPronunciationResultDto,
  LiveSessionResultDto,
  LiveSessionRoundContentDto,
  LiveSessionSlotDto,
  LiveSessionSlotStudentItemDto,
  LiveSessionStudentCardDto,
  LiveSessionUserStatsDto,
  LiveSessionValidationErrorDto,
  LoginBodyDto,
  LoginMethodsResponseDto,
  LoginResponseDto,
  OEScaffoldingActivityInstance,
  OEScaffoldingActivityInstanceControllerCompleteActivityInstance201,
  OEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig200,
  OEScaffoldingActivityInstanceControllerSubmitTaskWithAudio201,
  OEVocabLearningActivityInstance,
  OEVocabLearningActivityInstanceControllerCompleteActivityInstance201,
  OEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig200,
  OEVocabLearningActivityInstanceControllerSubmitTaskWithAudio201,
  OpenEndedActivityInstanceControllerCompleteActivityInstance0201,
  OpenEndedActivityInstanceControllerCompleteActivityInstance1201,
  OpenEndedActivityInstanceControllerCompleteOpenAnswerTask0201,
  OpenEndedActivityInstanceControllerCompleteOpenAnswerTask1201,
  OpenEndedActivityInstanceControllerFindAll0200Item,
  OpenEndedActivityInstanceControllerFindAll1200Item,
  OpenEndedActivityInstanceControllerFindOne0200,
  OpenEndedActivityInstanceControllerFindOne1200,
  OpenEndedActivityInstanceControllerGetGradingCriteriaConfig0200,
  OpenEndedActivityInstanceControllerGetGradingCriteriaConfig1200,
  OrderResponseDto,
  OrderStatusResponseDto,
  ParaphrasingTask,
  ParsedTextContent,
  PortfolioControllerGetAudioParams,
  PortfolioLoginDto,
  PortfolioLoginResponseDto,
  PortfolioOESimpleActivityReportDto,
  PortfolioPasscodeResponseDto,
  PortfolioProgressResponseDto,
  PortfolioSimpleTwoWayActivityReportDto,
  PreviewLiveSessionContentDto,
  PubSubMessageDto,
  QuizGroupQuestionCountResponseDto,
  RefreshTaxonomyTagProgressResponseDto,
  RefreshViewTaskPerformanceDto,
  RenameRunDto,
  RepresentativeTaskContentResponseDto,
  ResolveSensesDto,
  ResolveVocabSensesResponseDto,
  ResolveVocabV2RequestDto,
  ResolveVocabV2ResponseItemDto,
  RevampLessonCardDto,
  RunWithBlueprintsResponseDto,
  SaintGabriel2026LessonDto,
  SaveBlueprintLessonDto,
  SaveSentenceUserEnglishNotebookItemDto,
  SaveVocabUserEnglishNotebookItemDto,
  School,
  SchoolControllerFindAllParams,
  SchoolControllerGetCurrentUserSchoolSettings200,
  SchoolControllerGetSchoolUsersParams,
  SchoolControllerUpdateSchoolSettings200,
  SchoolGroup,
  SchoolGroupControllerGetUserInSchoolGroupParams,
  SchoolSettingResponseDto,
  SchoolStatusTableDataDto,
  SearchUsersByCodesOrEmailsDto,
  SearchVocabDto,
  SearchVocabV2ResponseItemDto,
  SearchVocabWithTextDto,
  SemanticDuplicateCheckVocabV2Dto,
  SemanticDuplicateMatchVocabV2ResponseDto,
  SendStudentWeeklyProgressEmailDto,
  SenseCandidatesVocabV2RequestDto,
  SenseCandidatesVocabV2ResponseItemDto,
  SenseDetailVocabV2ResponseDto,
  SentenceUserEnglishNotebookItem,
  SetTaxonomyTagRelationsDto,
  SettleLiveSessionRoundDto,
  SettleLiveSessionRoundResultDto,
  SignupDto,
  SignupResponseDto,
  SignupWithClassroomActivationCodeDto,
  Simplify2026Sem2LessonDto,
  SimplifyModularLessonDto,
  SimplifyModularSheetNameDto,
  StartActivityDto,
  StartLessonDto,
  SubmitAnswerTextDto,
  SubmitMatchingAttemptDto,
  SubmitUserNotebookSentenceAudioDto,
  SubmitUserNotebookSentenceAudioResponseDto,
  SubmitUserNotebookVocabAudioDto,
  SubmitUserNotebookVocabAudioResponseDto,
  SubmitWithModelAnswerDto,
  SummaryControllerGetLeaderboard200Item,
  SummaryControllerGetScoreLeaderboard200Item,
  SummaryControllerGetUserSummary200,
  Task,
  TaskGradingCriteriaControllerGetPronunciationGradingCriteria200,
  TaskPerformanceAttemptDetailDto,
  TaskPerformanceStudentSummaryDto,
  TaskTransaction,
  TaskTransactionControllerApplyFeedback201,
  TaskTransactionControllerApplyFeedbackSuggestion201,
  TaskTransactionControllerFindOne200,
  TaskTransactionControllerSubmitMatchingAttempt201,
  TaxonomyDashboardResponseDto,
  TaxonomyTagCatalogResponseDto,
  TaxonomyTagGroupResponseDto,
  TaxonomyTagRelationResponseDto,
  TestMicErrorDto,
  TranslateTextDto,
  TranslateTextsDto,
  TranslationControllerTranslateWord201,
  TranslationResponseDto,
  UnsaveUserNotebookItemDto,
  UpdateActivityMetadataDto,
  UpdateCheatDetectionDto,
  UpdateClassroomDto,
  UpdateClassroomLessonDto,
  UpdateCourseDto,
  UpdateFeatureFlagDto,
  UpdateItemDto,
  UpdateLessonDto,
  UpdateLiveSessionDto,
  UpdateLiveSessionParticipantDto,
  UpdateLoginMethodsDto,
  UpdateSchoolDto,
  UpdateSchoolGroupDto,
  UpdateSchoolLogoWithoutFileDto,
  UpdateSchoolSettingsDto,
  UpdateSenseVocabV2Dto,
  UpdateSenseVocabV2ResponseDto,
  UpdateUserAvatarDto,
  UpdateUserDto,
  UpdateUserMetadataDto,
  UpdateUserMetadataForMeDto,
  UploadedActivityBankAssetDto,
  UpsertTaxonomyTagGroupsDto,
  User,
  UserActionLog,
  UserActionSummaryEntryDto,
  UserActionSummaryResponseDto,
  UserAvatarSelectionControllerEquipItem201,
  UserAvatarSelectionControllerGetMySelection200,
  UserAvatarsResponseDto,
  UserClassroomAccess,
  UserClassroomAccessAddUserToClassroomDto,
  UserCoinResponseDto,
  UserControllerFindByQueryParams,
  UserControllerSearchUsersParams,
  UserInventoryControllerGetUserItems200Item,
  UserInventoryControllerGetUserItemsParams,
  UserInventoryControllerPurchaseItem201,
  UserInventoryItem,
  UserMetadataControllerCreate201,
  UserMetadataControllerFindById200,
  UserMetadataControllerUpdate200,
  UserMetadataResponseDto,
  UserResourceAccessControllerGetMyWebappRoutesAccessParams,
  UserResourceAccessControllerGetResourceUsersParams,
  UserResourceAccessControllerRemoveUserFromClassroomParams,
  UserResponseDto,
  UserVocabPracticeAttemptControllerFind200Item,
  UserVocabPracticeAttemptControllerFindById200,
  UserVocabPracticeAttemptControllerFindParams,
  UsersLeaderboardDto,
  ValidCourseResponseDto,
  ValidateLessonResponseDto,
  ViewClassroomActivitySummaryControllerFind200Item,
  ViewClassroomActivitySummaryControllerFindParams,
  ViewClassroomActivitySummaryControllerRefreshViewsForClassroomFromPubSub201,
  ViewClassroomActivitySummaryControllerRefreshViewsForClassroomParams,
  ViewClassroomActivitySummaryControllerRefreshViewsForClassroomV2FromPubSub201,
  ViewClassroomLessonStatusByUserControllerFindParams,
  ViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2FromPubSub201,
  ViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2Params,
  ViewClassroomLessonStatusByUserV2,
  ViewClassroomLessonSummaryControllerFind200Item,
  ViewClassroomLessonSummaryControllerFindParams,
  ViewClassroomLessonSummaryControllerRefreshViewsForClassroomFromPubSub201,
  ViewClassroomLessonSummaryControllerRefreshViewsForClassroomLessonV2FromPubSub201,
  ViewClassroomLessonSummaryControllerRefreshViewsForClassroomParams,
  ViewClassroomUserScoreControllerFind200Item,
  ViewClassroomUserScoreControllerFindParams,
  ViewClassroomUserScoreControllerRefreshViewsForClassroomFromPubSub201,
  ViewClassroomUserScoreControllerRefreshViewsForClassroomParams,
  ViewClassroomUserScoreControllerRefreshViewsForClassroomV2FromPubSub201,
  ViewTaskPerformanceControllerFindParams,
  ViewTaskPerformanceControllerGetRepresentativeTaskContentParams,
  ViewTaskPerformanceControllerGetStudentAttemptsParams,
  ViewTaskPerformanceControllerGetStudentSummariesParams,
  ViewTaskPerformanceResponseDto,
  Vocab,
  VocabControllerAddVocabTranslation200,
  VocabControllerBulkSearch201Item,
  VocabControllerCreate201,
  VocabControllerFindAll200Item,
  VocabControllerFindAllParams,
  VocabControllerFindOne200,
  VocabControllerFindOneParams,
  VocabControllerSearch201Item,
  VocabControllerSearchWithText201Item,
  VocabUserEnglishNotebookItem,
  VocabV2ControllerListSensesParams,
  VocabV2ControllerResolveParams,
  VocabV2ControllerSearchParams,
  VocabV2ListResponseDto
} from './.';

import { customInstance } from '../mutator.ts';
import type { ErrorType , BodyType } from '../mutator.ts';
import { portfolioCustomInstance } from '../portfolioMutator.ts';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @deprecated
 * @summary Login
 */
export const appControllerLogin = (
    loginBodyDto: BodyType<LoginBodyDto>,
    params: AppControllerLoginParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LoginResponseDto>(
      {url: `/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginBodyDto,
        params, signal
    },
      options);
    }




export const getAppControllerLoginMutationKey = () => ['appControllerLogin'] as const;

export const getAppControllerLoginMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appControllerLogin>>, TError,AppControllerLoginMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof appControllerLogin>>, TError,AppControllerLoginMutationVariables, TContext> => {

const mutationKey = getAppControllerLoginMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appControllerLogin>>, AppControllerLoginMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  appControllerLogin(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppControllerLoginMutationResult = NonNullable<Awaited<ReturnType<typeof appControllerLogin>>>
    export type AppControllerLoginMutationBody = BodyType<LoginBodyDto>
    export type AppControllerLoginMutationError = ErrorType<unknown>
    export type AppControllerLoginMutationVariables = {data: BodyType<LoginBodyDto>;params: AppControllerLoginParams}

    /**
 * @deprecated
 * @summary Login
 */
export const useAppControllerLogin = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appControllerLogin>>, TError,AppControllerLoginMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appControllerLogin>>,
        TError,
        AppControllerLoginMutationVariables,
        TContext
      > => {
      return useMutation(getAppControllerLoginMutationOptions(options), queryClient);
    }

export const appControllerHealthCheck = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/health-check`, method: 'GET', signal
    },
      options);
    }




export const getAppControllerHealthCheckQueryKey = () => {
    return [
    `/health-check`
    ] as const;
    }


export const getAppControllerHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof appControllerHealthCheck>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerHealthCheck>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppControllerHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appControllerHealthCheck>>> = ({ signal }) => appControllerHealthCheck(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appControllerHealthCheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppControllerHealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof appControllerHealthCheck>>>
export type AppControllerHealthCheckQueryError = ErrorType<unknown>


export function useAppControllerHealthCheck<TData = Awaited<ReturnType<typeof appControllerHealthCheck>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerHealthCheck>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appControllerHealthCheck>>,
          TError,
          Awaited<ReturnType<typeof appControllerHealthCheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppControllerHealthCheck<TData = Awaited<ReturnType<typeof appControllerHealthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerHealthCheck>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appControllerHealthCheck>>,
          TError,
          Awaited<ReturnType<typeof appControllerHealthCheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppControllerHealthCheck<TData = Awaited<ReturnType<typeof appControllerHealthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerHealthCheck>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAppControllerHealthCheck<TData = Awaited<ReturnType<typeof appControllerHealthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerHealthCheck>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppControllerHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useAppControllerHealthCheck} query
 */
export const invalidateAppControllerHealthCheck = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getAppControllerHealthCheckQueryKey() }, options);

  return queryClient;
}

export const useSetAppControllerHealthCheckQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof appControllerHealthCheck>> | undefined | ((old: Awaited<ReturnType<typeof appControllerHealthCheck>> | undefined) => Awaited<ReturnType<typeof appControllerHealthCheck>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof appControllerHealthCheck>>>({ exact: $exactMatch, queryKey: getAppControllerHealthCheckQueryKey() }, updater);
  };
}

export const useGetAppControllerHealthCheckQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof appControllerHealthCheck>>>(getAppControllerHealthCheckQueryKey());
}



export const appControllerHealthCheckAiBe = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/health-check-ai`, method: 'GET', signal
    },
      options);
    }




export const getAppControllerHealthCheckAiBeQueryKey = () => {
    return [
    `/health-check-ai`
    ] as const;
    }


export const getAppControllerHealthCheckAiBeQueryOptions = <TData = Awaited<ReturnType<typeof appControllerHealthCheckAiBe>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerHealthCheckAiBe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppControllerHealthCheckAiBeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appControllerHealthCheckAiBe>>> = ({ signal }) => appControllerHealthCheckAiBe(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appControllerHealthCheckAiBe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppControllerHealthCheckAiBeQueryResult = NonNullable<Awaited<ReturnType<typeof appControllerHealthCheckAiBe>>>
export type AppControllerHealthCheckAiBeQueryError = ErrorType<unknown>


export function useAppControllerHealthCheckAiBe<TData = Awaited<ReturnType<typeof appControllerHealthCheckAiBe>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerHealthCheckAiBe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appControllerHealthCheckAiBe>>,
          TError,
          Awaited<ReturnType<typeof appControllerHealthCheckAiBe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppControllerHealthCheckAiBe<TData = Awaited<ReturnType<typeof appControllerHealthCheckAiBe>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerHealthCheckAiBe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appControllerHealthCheckAiBe>>,
          TError,
          Awaited<ReturnType<typeof appControllerHealthCheckAiBe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppControllerHealthCheckAiBe<TData = Awaited<ReturnType<typeof appControllerHealthCheckAiBe>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerHealthCheckAiBe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAppControllerHealthCheckAiBe<TData = Awaited<ReturnType<typeof appControllerHealthCheckAiBe>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerHealthCheckAiBe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppControllerHealthCheckAiBeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useAppControllerHealthCheckAiBe} query
 */
export const invalidateAppControllerHealthCheckAiBe = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getAppControllerHealthCheckAiBeQueryKey() }, options);

  return queryClient;
}

export const useSetAppControllerHealthCheckAiBeQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof appControllerHealthCheckAiBe>> | undefined | ((old: Awaited<ReturnType<typeof appControllerHealthCheckAiBe>> | undefined) => Awaited<ReturnType<typeof appControllerHealthCheckAiBe>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof appControllerHealthCheckAiBe>>>({ exact: $exactMatch, queryKey: getAppControllerHealthCheckAiBeQueryKey() }, updater);
  };
}

export const useGetAppControllerHealthCheckAiBeQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof appControllerHealthCheckAiBe>>>(getAppControllerHealthCheckAiBeQueryKey());
}



export const appControllerGetError = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/debug-sentry`, method: 'GET', signal
    },
      options);
    }




export const getAppControllerGetErrorQueryKey = () => {
    return [
    `/debug-sentry`
    ] as const;
    }


export const getAppControllerGetErrorQueryOptions = <TData = Awaited<ReturnType<typeof appControllerGetError>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetError>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppControllerGetErrorQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appControllerGetError>>> = ({ signal }) => appControllerGetError(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appControllerGetError>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppControllerGetErrorQueryResult = NonNullable<Awaited<ReturnType<typeof appControllerGetError>>>
export type AppControllerGetErrorQueryError = ErrorType<unknown>


export function useAppControllerGetError<TData = Awaited<ReturnType<typeof appControllerGetError>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetError>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appControllerGetError>>,
          TError,
          Awaited<ReturnType<typeof appControllerGetError>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppControllerGetError<TData = Awaited<ReturnType<typeof appControllerGetError>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetError>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appControllerGetError>>,
          TError,
          Awaited<ReturnType<typeof appControllerGetError>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppControllerGetError<TData = Awaited<ReturnType<typeof appControllerGetError>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetError>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAppControllerGetError<TData = Awaited<ReturnType<typeof appControllerGetError>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetError>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppControllerGetErrorQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useAppControllerGetError} query
 */
export const invalidateAppControllerGetError = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getAppControllerGetErrorQueryKey() }, options);

  return queryClient;
}

export const useSetAppControllerGetErrorQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof appControllerGetError>> | undefined | ((old: Awaited<ReturnType<typeof appControllerGetError>> | undefined) => Awaited<ReturnType<typeof appControllerGetError>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof appControllerGetError>>>({ exact: $exactMatch, queryKey: getAppControllerGetErrorQueryKey() }, updater);
  };
}

export const useGetAppControllerGetErrorQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof appControllerGetError>>>(getAppControllerGetErrorQueryKey());
}



export const schoolControllerCreate = (
    createSchoolDto: BodyType<CreateSchoolDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/schools`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSchoolDto, signal
    },
      options);
    }




export const getSchoolControllerCreateMutationKey = () => ['schoolControllerCreate'] as const;

export const getSchoolControllerCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof schoolControllerCreate>>, TError,SchoolControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof schoolControllerCreate>>, TError,SchoolControllerCreateMutationVariables, TContext> => {

const mutationKey = getSchoolControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof schoolControllerCreate>>, SchoolControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  schoolControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SchoolControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof schoolControllerCreate>>>
    export type SchoolControllerCreateMutationBody = BodyType<CreateSchoolDto>
    export type SchoolControllerCreateMutationError = ErrorType<unknown>
    export type SchoolControllerCreateMutationVariables = {data: BodyType<CreateSchoolDto>}

    export const useSchoolControllerCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof schoolControllerCreate>>, TError,SchoolControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof schoolControllerCreate>>,
        TError,
        SchoolControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSchoolControllerCreateMutationOptions(options), queryClient);
    }

export const schoolControllerFindAll = (
    params?: SchoolControllerFindAllParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/schools`, method: 'GET',
        params, signal
    },
      options);
    }




export const getSchoolControllerFindAllQueryKey = (params?: SchoolControllerFindAllParams,) => {
    return [
    `/schools`, ...(params ? [params] : [])
    ] as const;
    }


export const getSchoolControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof schoolControllerFindAll>>, TError = ErrorType<unknown>>(params?: SchoolControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSchoolControllerFindAllQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof schoolControllerFindAll>>> = ({ signal }) => schoolControllerFindAll(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof schoolControllerFindAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SchoolControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof schoolControllerFindAll>>>
export type SchoolControllerFindAllQueryError = ErrorType<unknown>


export function useSchoolControllerFindAll<TData = Awaited<ReturnType<typeof schoolControllerFindAll>>, TError = ErrorType<unknown>>(
 params: undefined |  SchoolControllerFindAllParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerFindAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof schoolControllerFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolControllerFindAll<TData = Awaited<ReturnType<typeof schoolControllerFindAll>>, TError = ErrorType<unknown>>(
 params?: SchoolControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerFindAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof schoolControllerFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolControllerFindAll<TData = Awaited<ReturnType<typeof schoolControllerFindAll>>, TError = ErrorType<unknown>>(
 params?: SchoolControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSchoolControllerFindAll<TData = Awaited<ReturnType<typeof schoolControllerFindAll>>, TError = ErrorType<unknown>>(
 params?: SchoolControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSchoolControllerFindAllQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useSchoolControllerFindAll} query
 */
export const invalidateSchoolControllerFindAll = async (
 queryClient: QueryClient, params?: SchoolControllerFindAllParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getSchoolControllerFindAllQueryKey(params) }, options);

  return queryClient;
}

export const useSetSchoolControllerFindAllQueryData = () => {
  const queryClient = useQueryClient();
  return (params: SchoolControllerFindAllParams | undefined,updater: Awaited<ReturnType<typeof schoolControllerFindAll>> | undefined | ((old: Awaited<ReturnType<typeof schoolControllerFindAll>> | undefined) => Awaited<ReturnType<typeof schoolControllerFindAll>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof schoolControllerFindAll>>>({ exact: $exactMatch, queryKey: getSchoolControllerFindAllQueryKey(params) }, updater);
  };
}

export const useGetSchoolControllerFindAllQueryData = () => {
  const queryClient = useQueryClient();
  return (params?: SchoolControllerFindAllParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof schoolControllerFindAll>>>(getSchoolControllerFindAllQueryKey(params));
}



export const schoolControllerFindById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/schools/${id}`, method: 'GET', signal
    },
      options);
    }




export const getSchoolControllerFindByIdQueryKey = (id: string,) => {
    return [
    `/schools/${id}`
    ] as const;
    }


export const getSchoolControllerFindByIdQueryOptions = <TData = Awaited<ReturnType<typeof schoolControllerFindById>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSchoolControllerFindByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof schoolControllerFindById>>> = ({ signal }) => schoolControllerFindById(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof schoolControllerFindById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SchoolControllerFindByIdQueryResult = NonNullable<Awaited<ReturnType<typeof schoolControllerFindById>>>
export type SchoolControllerFindByIdQueryError = ErrorType<unknown>


export function useSchoolControllerFindById<TData = Awaited<ReturnType<typeof schoolControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerFindById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof schoolControllerFindById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolControllerFindById<TData = Awaited<ReturnType<typeof schoolControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerFindById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof schoolControllerFindById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolControllerFindById<TData = Awaited<ReturnType<typeof schoolControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSchoolControllerFindById<TData = Awaited<ReturnType<typeof schoolControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSchoolControllerFindByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useSchoolControllerFindById} query
 */
export const invalidateSchoolControllerFindById = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getSchoolControllerFindByIdQueryKey(id) }, options);

  return queryClient;
}

export const useSetSchoolControllerFindByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof schoolControllerFindById>> | undefined | ((old: Awaited<ReturnType<typeof schoolControllerFindById>> | undefined) => Awaited<ReturnType<typeof schoolControllerFindById>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof schoolControllerFindById>>>({ exact: $exactMatch, queryKey: getSchoolControllerFindByIdQueryKey(id) }, updater);
  };
}

export const useGetSchoolControllerFindByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof schoolControllerFindById>>>(getSchoolControllerFindByIdQueryKey(id));
}



export const schoolControllerUpdateSchool = (
    id: string,
    updateSchoolDto: BodyType<UpdateSchoolDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<School>(
      {url: `/schools/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateSchoolDto, signal
    },
      options);
    }




export const getSchoolControllerUpdateSchoolMutationKey = () => ['schoolControllerUpdateSchool'] as const;

export const getSchoolControllerUpdateSchoolMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof schoolControllerUpdateSchool>>, TError,SchoolControllerUpdateSchoolMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof schoolControllerUpdateSchool>>, TError,SchoolControllerUpdateSchoolMutationVariables, TContext> => {

const mutationKey = getSchoolControllerUpdateSchoolMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof schoolControllerUpdateSchool>>, SchoolControllerUpdateSchoolMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  schoolControllerUpdateSchool(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SchoolControllerUpdateSchoolMutationResult = NonNullable<Awaited<ReturnType<typeof schoolControllerUpdateSchool>>>
    export type SchoolControllerUpdateSchoolMutationBody = BodyType<UpdateSchoolDto>
    export type SchoolControllerUpdateSchoolMutationError = ErrorType<unknown>
    export type SchoolControllerUpdateSchoolMutationVariables = {id: string;data: BodyType<UpdateSchoolDto>}

    export const useSchoolControllerUpdateSchool = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof schoolControllerUpdateSchool>>, TError,SchoolControllerUpdateSchoolMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof schoolControllerUpdateSchool>>,
        TError,
        SchoolControllerUpdateSchoolMutationVariables,
        TContext
      > => {
      return useMutation(getSchoolControllerUpdateSchoolMutationOptions(options), queryClient);
    }

export const schoolControllerGetSchoolClassrooms = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/schools/${id}/classrooms`, method: 'GET', signal
    },
      options);
    }




export const getSchoolControllerGetSchoolClassroomsQueryKey = (id: string,) => {
    return [
    `/schools/${id}/classrooms`
    ] as const;
    }


export const getSchoolControllerGetSchoolClassroomsQueryOptions = <TData = Awaited<ReturnType<typeof schoolControllerGetSchoolClassrooms>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolClassrooms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSchoolControllerGetSchoolClassroomsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof schoolControllerGetSchoolClassrooms>>> = ({ signal }) => schoolControllerGetSchoolClassrooms(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolClassrooms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SchoolControllerGetSchoolClassroomsQueryResult = NonNullable<Awaited<ReturnType<typeof schoolControllerGetSchoolClassrooms>>>
export type SchoolControllerGetSchoolClassroomsQueryError = ErrorType<unknown>


export function useSchoolControllerGetSchoolClassrooms<TData = Awaited<ReturnType<typeof schoolControllerGetSchoolClassrooms>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolClassrooms>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolControllerGetSchoolClassrooms>>,
          TError,
          Awaited<ReturnType<typeof schoolControllerGetSchoolClassrooms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolControllerGetSchoolClassrooms<TData = Awaited<ReturnType<typeof schoolControllerGetSchoolClassrooms>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolClassrooms>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolControllerGetSchoolClassrooms>>,
          TError,
          Awaited<ReturnType<typeof schoolControllerGetSchoolClassrooms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolControllerGetSchoolClassrooms<TData = Awaited<ReturnType<typeof schoolControllerGetSchoolClassrooms>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolClassrooms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSchoolControllerGetSchoolClassrooms<TData = Awaited<ReturnType<typeof schoolControllerGetSchoolClassrooms>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolClassrooms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSchoolControllerGetSchoolClassroomsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useSchoolControllerGetSchoolClassrooms} query
 */
export const invalidateSchoolControllerGetSchoolClassrooms = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getSchoolControllerGetSchoolClassroomsQueryKey(id) }, options);

  return queryClient;
}

export const useSetSchoolControllerGetSchoolClassroomsQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof schoolControllerGetSchoolClassrooms>> | undefined | ((old: Awaited<ReturnType<typeof schoolControllerGetSchoolClassrooms>> | undefined) => Awaited<ReturnType<typeof schoolControllerGetSchoolClassrooms>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof schoolControllerGetSchoolClassrooms>>>({ exact: $exactMatch, queryKey: getSchoolControllerGetSchoolClassroomsQueryKey(id) }, updater);
  };
}

export const useGetSchoolControllerGetSchoolClassroomsQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof schoolControllerGetSchoolClassrooms>>>(getSchoolControllerGetSchoolClassroomsQueryKey(id));
}



export const schoolControllerGetSchoolClassroomsWithStudentCount = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/schools/${id}/classrooms-with-student-count`, method: 'GET', signal
    },
      options);
    }




export const getSchoolControllerGetSchoolClassroomsWithStudentCountQueryKey = (id: string,) => {
    return [
    `/schools/${id}/classrooms-with-student-count`
    ] as const;
    }


export const getSchoolControllerGetSchoolClassroomsWithStudentCountQueryOptions = <TData = Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomsWithStudentCount>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomsWithStudentCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSchoolControllerGetSchoolClassroomsWithStudentCountQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomsWithStudentCount>>> = ({ signal }) => schoolControllerGetSchoolClassroomsWithStudentCount(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomsWithStudentCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SchoolControllerGetSchoolClassroomsWithStudentCountQueryResult = NonNullable<Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomsWithStudentCount>>>
export type SchoolControllerGetSchoolClassroomsWithStudentCountQueryError = ErrorType<unknown>


export function useSchoolControllerGetSchoolClassroomsWithStudentCount<TData = Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomsWithStudentCount>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomsWithStudentCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomsWithStudentCount>>,
          TError,
          Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomsWithStudentCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolControllerGetSchoolClassroomsWithStudentCount<TData = Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomsWithStudentCount>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomsWithStudentCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomsWithStudentCount>>,
          TError,
          Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomsWithStudentCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolControllerGetSchoolClassroomsWithStudentCount<TData = Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomsWithStudentCount>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomsWithStudentCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSchoolControllerGetSchoolClassroomsWithStudentCount<TData = Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomsWithStudentCount>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomsWithStudentCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSchoolControllerGetSchoolClassroomsWithStudentCountQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useSchoolControllerGetSchoolClassroomsWithStudentCount} query
 */
export const invalidateSchoolControllerGetSchoolClassroomsWithStudentCount = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getSchoolControllerGetSchoolClassroomsWithStudentCountQueryKey(id) }, options);

  return queryClient;
}

export const useSetSchoolControllerGetSchoolClassroomsWithStudentCountQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomsWithStudentCount>> | undefined | ((old: Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomsWithStudentCount>> | undefined) => Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomsWithStudentCount>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomsWithStudentCount>>>({ exact: $exactMatch, queryKey: getSchoolControllerGetSchoolClassroomsWithStudentCountQueryKey(id) }, updater);
  };
}

export const useGetSchoolControllerGetSchoolClassroomsWithStudentCountQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomsWithStudentCount>>>(getSchoolControllerGetSchoolClassroomsWithStudentCountQueryKey(id));
}



export const schoolControllerGetSchoolClassroomSummary = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/schools/${id}/classroom-summary`, method: 'GET', signal
    },
      options);
    }




export const getSchoolControllerGetSchoolClassroomSummaryQueryKey = (id: string,) => {
    return [
    `/schools/${id}/classroom-summary`
    ] as const;
    }


export const getSchoolControllerGetSchoolClassroomSummaryQueryOptions = <TData = Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomSummary>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSchoolControllerGetSchoolClassroomSummaryQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomSummary>>> = ({ signal }) => schoolControllerGetSchoolClassroomSummary(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SchoolControllerGetSchoolClassroomSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomSummary>>>
export type SchoolControllerGetSchoolClassroomSummaryQueryError = ErrorType<unknown>


export function useSchoolControllerGetSchoolClassroomSummary<TData = Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomSummary>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomSummary>>,
          TError,
          Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolControllerGetSchoolClassroomSummary<TData = Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomSummary>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomSummary>>,
          TError,
          Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolControllerGetSchoolClassroomSummary<TData = Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomSummary>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSchoolControllerGetSchoolClassroomSummary<TData = Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomSummary>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSchoolControllerGetSchoolClassroomSummaryQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useSchoolControllerGetSchoolClassroomSummary} query
 */
export const invalidateSchoolControllerGetSchoolClassroomSummary = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getSchoolControllerGetSchoolClassroomSummaryQueryKey(id) }, options);

  return queryClient;
}

export const useSetSchoolControllerGetSchoolClassroomSummaryQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomSummary>> | undefined | ((old: Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomSummary>> | undefined) => Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomSummary>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomSummary>>>({ exact: $exactMatch, queryKey: getSchoolControllerGetSchoolClassroomSummaryQueryKey(id) }, updater);
  };
}

export const useGetSchoolControllerGetSchoolClassroomSummaryQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof schoolControllerGetSchoolClassroomSummary>>>(getSchoolControllerGetSchoolClassroomSummaryQueryKey(id));
}



export const schoolControllerGetSchoolUsers = (
    id: string,
    params: SchoolControllerGetSchoolUsersParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/schools/${id}/users`, method: 'GET',
        params, signal
    },
      options);
    }




export const getSchoolControllerGetSchoolUsersQueryKey = (id: string,
    params?: SchoolControllerGetSchoolUsersParams,) => {
    return [
    `/schools/${id}/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getSchoolControllerGetSchoolUsersQueryOptions = <TData = Awaited<ReturnType<typeof schoolControllerGetSchoolUsers>>, TError = ErrorType<unknown>>(id: string,
    params: SchoolControllerGetSchoolUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSchoolControllerGetSchoolUsersQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof schoolControllerGetSchoolUsers>>> = ({ signal }) => schoolControllerGetSchoolUsers(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SchoolControllerGetSchoolUsersQueryResult = NonNullable<Awaited<ReturnType<typeof schoolControllerGetSchoolUsers>>>
export type SchoolControllerGetSchoolUsersQueryError = ErrorType<unknown>


export function useSchoolControllerGetSchoolUsers<TData = Awaited<ReturnType<typeof schoolControllerGetSchoolUsers>>, TError = ErrorType<unknown>>(
 id: string,
    params: SchoolControllerGetSchoolUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolControllerGetSchoolUsers>>,
          TError,
          Awaited<ReturnType<typeof schoolControllerGetSchoolUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolControllerGetSchoolUsers<TData = Awaited<ReturnType<typeof schoolControllerGetSchoolUsers>>, TError = ErrorType<unknown>>(
 id: string,
    params: SchoolControllerGetSchoolUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolControllerGetSchoolUsers>>,
          TError,
          Awaited<ReturnType<typeof schoolControllerGetSchoolUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolControllerGetSchoolUsers<TData = Awaited<ReturnType<typeof schoolControllerGetSchoolUsers>>, TError = ErrorType<unknown>>(
 id: string,
    params: SchoolControllerGetSchoolUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSchoolControllerGetSchoolUsers<TData = Awaited<ReturnType<typeof schoolControllerGetSchoolUsers>>, TError = ErrorType<unknown>>(
 id: string,
    params: SchoolControllerGetSchoolUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSchoolControllerGetSchoolUsersQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useSchoolControllerGetSchoolUsers} query
 */
export const invalidateSchoolControllerGetSchoolUsers = async (
 queryClient: QueryClient, id: string,
    params: SchoolControllerGetSchoolUsersParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getSchoolControllerGetSchoolUsersQueryKey(id,params) }, options);

  return queryClient;
}

export const useSetSchoolControllerGetSchoolUsersQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,
    params: SchoolControllerGetSchoolUsersParams | undefined,updater: Awaited<ReturnType<typeof schoolControllerGetSchoolUsers>> | undefined | ((old: Awaited<ReturnType<typeof schoolControllerGetSchoolUsers>> | undefined) => Awaited<ReturnType<typeof schoolControllerGetSchoolUsers>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof schoolControllerGetSchoolUsers>>>({ exact: $exactMatch, queryKey: getSchoolControllerGetSchoolUsersQueryKey(id,params) }, updater);
  };
}

export const useGetSchoolControllerGetSchoolUsersQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,
    params: SchoolControllerGetSchoolUsersParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof schoolControllerGetSchoolUsers>>>(getSchoolControllerGetSchoolUsersQueryKey(id,params));
}



export const schoolControllerUpdateSchoolLogo = (
    id: string,
    updateSchoolLogoWithoutFileDto: BodyType<UpdateSchoolLogoWithoutFileDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/schools/${id}/logo`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateSchoolLogoWithoutFileDto, signal
    },
      options);
    }




export const getSchoolControllerUpdateSchoolLogoMutationKey = () => ['schoolControllerUpdateSchoolLogo'] as const;

export const getSchoolControllerUpdateSchoolLogoMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof schoolControllerUpdateSchoolLogo>>, TError,SchoolControllerUpdateSchoolLogoMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof schoolControllerUpdateSchoolLogo>>, TError,SchoolControllerUpdateSchoolLogoMutationVariables, TContext> => {

const mutationKey = getSchoolControllerUpdateSchoolLogoMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof schoolControllerUpdateSchoolLogo>>, SchoolControllerUpdateSchoolLogoMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  schoolControllerUpdateSchoolLogo(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SchoolControllerUpdateSchoolLogoMutationResult = NonNullable<Awaited<ReturnType<typeof schoolControllerUpdateSchoolLogo>>>
    export type SchoolControllerUpdateSchoolLogoMutationBody = BodyType<UpdateSchoolLogoWithoutFileDto>
    export type SchoolControllerUpdateSchoolLogoMutationError = ErrorType<unknown>
    export type SchoolControllerUpdateSchoolLogoMutationVariables = {id: string;data: BodyType<UpdateSchoolLogoWithoutFileDto>}

    export const useSchoolControllerUpdateSchoolLogo = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof schoolControllerUpdateSchoolLogo>>, TError,SchoolControllerUpdateSchoolLogoMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof schoolControllerUpdateSchoolLogo>>,
        TError,
        SchoolControllerUpdateSchoolLogoMutationVariables,
        TContext
      > => {
      return useMutation(getSchoolControllerUpdateSchoolLogoMutationOptions(options), queryClient);
    }

/**
 * @summary ####################################
##### School Setting Endpoints #####
####################################
 */
export const schoolControllerGetCurrentUserSchoolSettings = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SchoolControllerGetCurrentUserSchoolSettings200>(
      {url: `/schools/me/settings`, method: 'GET', signal
    },
      options);
    }




export const getSchoolControllerGetCurrentUserSchoolSettingsQueryKey = () => {
    return [
    `/schools/me/settings`
    ] as const;
    }


export const getSchoolControllerGetCurrentUserSchoolSettingsQueryOptions = <TData = Awaited<ReturnType<typeof schoolControllerGetCurrentUserSchoolSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetCurrentUserSchoolSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSchoolControllerGetCurrentUserSchoolSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof schoolControllerGetCurrentUserSchoolSettings>>> = ({ signal }) => schoolControllerGetCurrentUserSchoolSettings(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetCurrentUserSchoolSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SchoolControllerGetCurrentUserSchoolSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof schoolControllerGetCurrentUserSchoolSettings>>>
export type SchoolControllerGetCurrentUserSchoolSettingsQueryError = ErrorType<unknown>


export function useSchoolControllerGetCurrentUserSchoolSettings<TData = Awaited<ReturnType<typeof schoolControllerGetCurrentUserSchoolSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetCurrentUserSchoolSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolControllerGetCurrentUserSchoolSettings>>,
          TError,
          Awaited<ReturnType<typeof schoolControllerGetCurrentUserSchoolSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolControllerGetCurrentUserSchoolSettings<TData = Awaited<ReturnType<typeof schoolControllerGetCurrentUserSchoolSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetCurrentUserSchoolSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolControllerGetCurrentUserSchoolSettings>>,
          TError,
          Awaited<ReturnType<typeof schoolControllerGetCurrentUserSchoolSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolControllerGetCurrentUserSchoolSettings<TData = Awaited<ReturnType<typeof schoolControllerGetCurrentUserSchoolSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetCurrentUserSchoolSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ####################################
##### School Setting Endpoints #####
####################################
 */

export function useSchoolControllerGetCurrentUserSchoolSettings<TData = Awaited<ReturnType<typeof schoolControllerGetCurrentUserSchoolSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetCurrentUserSchoolSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSchoolControllerGetCurrentUserSchoolSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useSchoolControllerGetCurrentUserSchoolSettings} query
 */
export const invalidateSchoolControllerGetCurrentUserSchoolSettings = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getSchoolControllerGetCurrentUserSchoolSettingsQueryKey() }, options);

  return queryClient;
}

/**
 * @summary ####################################
##### School Setting Endpoints #####
####################################
 */
export const useSetSchoolControllerGetCurrentUserSchoolSettingsQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof schoolControllerGetCurrentUserSchoolSettings>> | undefined | ((old: Awaited<ReturnType<typeof schoolControllerGetCurrentUserSchoolSettings>> | undefined) => Awaited<ReturnType<typeof schoolControllerGetCurrentUserSchoolSettings>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof schoolControllerGetCurrentUserSchoolSettings>>>({ exact: $exactMatch, queryKey: getSchoolControllerGetCurrentUserSchoolSettingsQueryKey() }, updater);
  };
}

/**
 * @summary ####################################
##### School Setting Endpoints #####
####################################
 */
export const useGetSchoolControllerGetCurrentUserSchoolSettingsQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof schoolControllerGetCurrentUserSchoolSettings>>>(getSchoolControllerGetCurrentUserSchoolSettingsQueryKey());
}



/**
 * @summary Get school settings by school ID
 */
export const schoolControllerGetSchoolSettings = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SchoolSettingResponseDto>(
      {url: `/schools/${id}/settings`, method: 'GET', signal
    },
      options);
    }




export const getSchoolControllerGetSchoolSettingsQueryKey = (id: string,) => {
    return [
    `/schools/${id}/settings`
    ] as const;
    }


export const getSchoolControllerGetSchoolSettingsQueryOptions = <TData = Awaited<ReturnType<typeof schoolControllerGetSchoolSettings>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSchoolControllerGetSchoolSettingsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof schoolControllerGetSchoolSettings>>> = ({ signal }) => schoolControllerGetSchoolSettings(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SchoolControllerGetSchoolSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof schoolControllerGetSchoolSettings>>>
export type SchoolControllerGetSchoolSettingsQueryError = ErrorType<unknown>


export function useSchoolControllerGetSchoolSettings<TData = Awaited<ReturnType<typeof schoolControllerGetSchoolSettings>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolControllerGetSchoolSettings>>,
          TError,
          Awaited<ReturnType<typeof schoolControllerGetSchoolSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolControllerGetSchoolSettings<TData = Awaited<ReturnType<typeof schoolControllerGetSchoolSettings>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolControllerGetSchoolSettings>>,
          TError,
          Awaited<ReturnType<typeof schoolControllerGetSchoolSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolControllerGetSchoolSettings<TData = Awaited<ReturnType<typeof schoolControllerGetSchoolSettings>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get school settings by school ID
 */

export function useSchoolControllerGetSchoolSettings<TData = Awaited<ReturnType<typeof schoolControllerGetSchoolSettings>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolControllerGetSchoolSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSchoolControllerGetSchoolSettingsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useSchoolControllerGetSchoolSettings} query
 */
export const invalidateSchoolControllerGetSchoolSettings = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getSchoolControllerGetSchoolSettingsQueryKey(id) }, options);

  return queryClient;
}

/**
 * @summary Get school settings by school ID
 */
export const useSetSchoolControllerGetSchoolSettingsQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof schoolControllerGetSchoolSettings>> | undefined | ((old: Awaited<ReturnType<typeof schoolControllerGetSchoolSettings>> | undefined) => Awaited<ReturnType<typeof schoolControllerGetSchoolSettings>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof schoolControllerGetSchoolSettings>>>({ exact: $exactMatch, queryKey: getSchoolControllerGetSchoolSettingsQueryKey(id) }, updater);
  };
}

/**
 * @summary Get school settings by school ID
 */
export const useGetSchoolControllerGetSchoolSettingsQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof schoolControllerGetSchoolSettings>>>(getSchoolControllerGetSchoolSettingsQueryKey(id));
}



export const schoolControllerUpdateSchoolSettings = (
    id: string,
    updateSchoolSettingsDto: BodyType<UpdateSchoolSettingsDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SchoolControllerUpdateSchoolSettings200>(
      {url: `/schools/${id}/settings`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateSchoolSettingsDto, signal
    },
      options);
    }




export const getSchoolControllerUpdateSchoolSettingsMutationKey = () => ['schoolControllerUpdateSchoolSettings'] as const;

export const getSchoolControllerUpdateSchoolSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof schoolControllerUpdateSchoolSettings>>, TError,SchoolControllerUpdateSchoolSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof schoolControllerUpdateSchoolSettings>>, TError,SchoolControllerUpdateSchoolSettingsMutationVariables, TContext> => {

const mutationKey = getSchoolControllerUpdateSchoolSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof schoolControllerUpdateSchoolSettings>>, SchoolControllerUpdateSchoolSettingsMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  schoolControllerUpdateSchoolSettings(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SchoolControllerUpdateSchoolSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof schoolControllerUpdateSchoolSettings>>>
    export type SchoolControllerUpdateSchoolSettingsMutationBody = BodyType<UpdateSchoolSettingsDto>
    export type SchoolControllerUpdateSchoolSettingsMutationError = ErrorType<unknown>
    export type SchoolControllerUpdateSchoolSettingsMutationVariables = {id: string;data: BodyType<UpdateSchoolSettingsDto>}

    export const useSchoolControllerUpdateSchoolSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof schoolControllerUpdateSchoolSettings>>, TError,SchoolControllerUpdateSchoolSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof schoolControllerUpdateSchoolSettings>>,
        TError,
        SchoolControllerUpdateSchoolSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getSchoolControllerUpdateSchoolSettingsMutationOptions(options), queryClient);
    }

export const gcpStorageControllerGetGcpStorageAudio = (
    params: GcpStorageControllerGetGcpStorageAudioParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/gcp-storage/audio`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGcpStorageControllerGetGcpStorageAudioQueryKey = (params?: GcpStorageControllerGetGcpStorageAudioParams,) => {
    return [
    `/gcp-storage/audio`, ...(params ? [params] : [])
    ] as const;
    }


export const getGcpStorageControllerGetGcpStorageAudioQueryOptions = <TData = Awaited<ReturnType<typeof gcpStorageControllerGetGcpStorageAudio>>, TError = ErrorType<unknown>>(params: GcpStorageControllerGetGcpStorageAudioParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gcpStorageControllerGetGcpStorageAudio>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGcpStorageControllerGetGcpStorageAudioQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gcpStorageControllerGetGcpStorageAudio>>> = ({ signal }) => gcpStorageControllerGetGcpStorageAudio(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gcpStorageControllerGetGcpStorageAudio>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GcpStorageControllerGetGcpStorageAudioQueryResult = NonNullable<Awaited<ReturnType<typeof gcpStorageControllerGetGcpStorageAudio>>>
export type GcpStorageControllerGetGcpStorageAudioQueryError = ErrorType<unknown>


export function useGcpStorageControllerGetGcpStorageAudio<TData = Awaited<ReturnType<typeof gcpStorageControllerGetGcpStorageAudio>>, TError = ErrorType<unknown>>(
 params: GcpStorageControllerGetGcpStorageAudioParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gcpStorageControllerGetGcpStorageAudio>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gcpStorageControllerGetGcpStorageAudio>>,
          TError,
          Awaited<ReturnType<typeof gcpStorageControllerGetGcpStorageAudio>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGcpStorageControllerGetGcpStorageAudio<TData = Awaited<ReturnType<typeof gcpStorageControllerGetGcpStorageAudio>>, TError = ErrorType<unknown>>(
 params: GcpStorageControllerGetGcpStorageAudioParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gcpStorageControllerGetGcpStorageAudio>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gcpStorageControllerGetGcpStorageAudio>>,
          TError,
          Awaited<ReturnType<typeof gcpStorageControllerGetGcpStorageAudio>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGcpStorageControllerGetGcpStorageAudio<TData = Awaited<ReturnType<typeof gcpStorageControllerGetGcpStorageAudio>>, TError = ErrorType<unknown>>(
 params: GcpStorageControllerGetGcpStorageAudioParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gcpStorageControllerGetGcpStorageAudio>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGcpStorageControllerGetGcpStorageAudio<TData = Awaited<ReturnType<typeof gcpStorageControllerGetGcpStorageAudio>>, TError = ErrorType<unknown>>(
 params: GcpStorageControllerGetGcpStorageAudioParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gcpStorageControllerGetGcpStorageAudio>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGcpStorageControllerGetGcpStorageAudioQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useGcpStorageControllerGetGcpStorageAudio} query
 */
export const invalidateGcpStorageControllerGetGcpStorageAudio = async (
 queryClient: QueryClient, params: GcpStorageControllerGetGcpStorageAudioParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getGcpStorageControllerGetGcpStorageAudioQueryKey(params) }, options);

  return queryClient;
}

export const useSetGcpStorageControllerGetGcpStorageAudioQueryData = () => {
  const queryClient = useQueryClient();
  return (params: GcpStorageControllerGetGcpStorageAudioParams | undefined,updater: Awaited<ReturnType<typeof gcpStorageControllerGetGcpStorageAudio>> | undefined | ((old: Awaited<ReturnType<typeof gcpStorageControllerGetGcpStorageAudio>> | undefined) => Awaited<ReturnType<typeof gcpStorageControllerGetGcpStorageAudio>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof gcpStorageControllerGetGcpStorageAudio>>>({ exact: $exactMatch, queryKey: getGcpStorageControllerGetGcpStorageAudioQueryKey(params) }, updater);
  };
}

export const useGetGcpStorageControllerGetGcpStorageAudioQueryData = () => {
  const queryClient = useQueryClient();
  return (params: GcpStorageControllerGetGcpStorageAudioParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof gcpStorageControllerGetGcpStorageAudio>>>(getGcpStorageControllerGetGcpStorageAudioQueryKey(params));
}



export const accessCodeControllerCreate = (
    createAccessCodeDto: BodyType<CreateAccessCodeDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AccessCodeControllerCreate201>(
      {url: `/access-codes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAccessCodeDto, signal
    },
      options);
    }




export const getAccessCodeControllerCreateMutationKey = () => ['accessCodeControllerCreate'] as const;

export const getAccessCodeControllerCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accessCodeControllerCreate>>, TError,AccessCodeControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof accessCodeControllerCreate>>, TError,AccessCodeControllerCreateMutationVariables, TContext> => {

const mutationKey = getAccessCodeControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accessCodeControllerCreate>>, AccessCodeControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  accessCodeControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AccessCodeControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof accessCodeControllerCreate>>>
    export type AccessCodeControllerCreateMutationBody = BodyType<CreateAccessCodeDto>
    export type AccessCodeControllerCreateMutationError = ErrorType<unknown>
    export type AccessCodeControllerCreateMutationVariables = {data: BodyType<CreateAccessCodeDto>}

    export const useAccessCodeControllerCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accessCodeControllerCreate>>, TError,AccessCodeControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof accessCodeControllerCreate>>,
        TError,
        AccessCodeControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAccessCodeControllerCreateMutationOptions(options), queryClient);
    }

export const accessCodeControllerFindAll = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AccessCodeControllerFindAll200Item[]>(
      {url: `/access-codes`, method: 'GET', signal
    },
      options);
    }




export const getAccessCodeControllerFindAllQueryKey = () => {
    return [
    `/access-codes`
    ] as const;
    }


export const getAccessCodeControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof accessCodeControllerFindAll>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accessCodeControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAccessCodeControllerFindAllQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof accessCodeControllerFindAll>>> = ({ signal }) => accessCodeControllerFindAll(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof accessCodeControllerFindAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccessCodeControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof accessCodeControllerFindAll>>>
export type AccessCodeControllerFindAllQueryError = ErrorType<unknown>


export function useAccessCodeControllerFindAll<TData = Awaited<ReturnType<typeof accessCodeControllerFindAll>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof accessCodeControllerFindAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accessCodeControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof accessCodeControllerFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccessCodeControllerFindAll<TData = Awaited<ReturnType<typeof accessCodeControllerFindAll>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accessCodeControllerFindAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accessCodeControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof accessCodeControllerFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccessCodeControllerFindAll<TData = Awaited<ReturnType<typeof accessCodeControllerFindAll>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accessCodeControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAccessCodeControllerFindAll<TData = Awaited<ReturnType<typeof accessCodeControllerFindAll>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accessCodeControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAccessCodeControllerFindAllQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useAccessCodeControllerFindAll} query
 */
export const invalidateAccessCodeControllerFindAll = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getAccessCodeControllerFindAllQueryKey() }, options);

  return queryClient;
}

export const useSetAccessCodeControllerFindAllQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof accessCodeControllerFindAll>> | undefined | ((old: Awaited<ReturnType<typeof accessCodeControllerFindAll>> | undefined) => Awaited<ReturnType<typeof accessCodeControllerFindAll>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof accessCodeControllerFindAll>>>({ exact: $exactMatch, queryKey: getAccessCodeControllerFindAllQueryKey() }, updater);
  };
}

export const useGetAccessCodeControllerFindAllQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof accessCodeControllerFindAll>>>(getAccessCodeControllerFindAllQueryKey());
}



/**
 * @summary Get access code by ID
 */
export const accessCodeControllerFindById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AccessCodeResponseDto>(
      {url: `/access-codes/${id}`, method: 'GET', signal
    },
      options);
    }




export const getAccessCodeControllerFindByIdQueryKey = (id: string,) => {
    return [
    `/access-codes/${id}`
    ] as const;
    }


export const getAccessCodeControllerFindByIdQueryOptions = <TData = Awaited<ReturnType<typeof accessCodeControllerFindById>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accessCodeControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAccessCodeControllerFindByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof accessCodeControllerFindById>>> = ({ signal }) => accessCodeControllerFindById(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof accessCodeControllerFindById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccessCodeControllerFindByIdQueryResult = NonNullable<Awaited<ReturnType<typeof accessCodeControllerFindById>>>
export type AccessCodeControllerFindByIdQueryError = ErrorType<unknown>


export function useAccessCodeControllerFindById<TData = Awaited<ReturnType<typeof accessCodeControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof accessCodeControllerFindById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accessCodeControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof accessCodeControllerFindById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccessCodeControllerFindById<TData = Awaited<ReturnType<typeof accessCodeControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accessCodeControllerFindById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accessCodeControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof accessCodeControllerFindById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccessCodeControllerFindById<TData = Awaited<ReturnType<typeof accessCodeControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accessCodeControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get access code by ID
 */

export function useAccessCodeControllerFindById<TData = Awaited<ReturnType<typeof accessCodeControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accessCodeControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAccessCodeControllerFindByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useAccessCodeControllerFindById} query
 */
export const invalidateAccessCodeControllerFindById = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getAccessCodeControllerFindByIdQueryKey(id) }, options);

  return queryClient;
}

/**
 * @summary Get access code by ID
 */
export const useSetAccessCodeControllerFindByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof accessCodeControllerFindById>> | undefined | ((old: Awaited<ReturnType<typeof accessCodeControllerFindById>> | undefined) => Awaited<ReturnType<typeof accessCodeControllerFindById>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof accessCodeControllerFindById>>>({ exact: $exactMatch, queryKey: getAccessCodeControllerFindByIdQueryKey(id) }, updater);
  };
}

/**
 * @summary Get access code by ID
 */
export const useGetAccessCodeControllerFindByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof accessCodeControllerFindById>>>(getAccessCodeControllerFindByIdQueryKey(id));
}



export const classroomLessonStateControllerFindClassroomLessonState = (
    classroomId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ClassroomPathStateDto>(
      {url: `/classroom-lesson-state/classrooms/${classroomId}`, method: 'GET', signal
    },
      options);
    }




export const getClassroomLessonStateControllerFindClassroomLessonStateQueryKey = (classroomId: string,) => {
    return [
    `/classroom-lesson-state/classrooms/${classroomId}`
    ] as const;
    }


export const getClassroomLessonStateControllerFindClassroomLessonStateQueryOptions = <TData = Awaited<ReturnType<typeof classroomLessonStateControllerFindClassroomLessonState>>, TError = ErrorType<unknown>>(classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerFindClassroomLessonState>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomLessonStateControllerFindClassroomLessonStateQueryKey(classroomId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomLessonStateControllerFindClassroomLessonState>>> = ({ signal }) => classroomLessonStateControllerFindClassroomLessonState(classroomId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerFindClassroomLessonState>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomLessonStateControllerFindClassroomLessonStateQueryResult = NonNullable<Awaited<ReturnType<typeof classroomLessonStateControllerFindClassroomLessonState>>>
export type ClassroomLessonStateControllerFindClassroomLessonStateQueryError = ErrorType<unknown>


export function useClassroomLessonStateControllerFindClassroomLessonState<TData = Awaited<ReturnType<typeof classroomLessonStateControllerFindClassroomLessonState>>, TError = ErrorType<unknown>>(
 classroomId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerFindClassroomLessonState>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomLessonStateControllerFindClassroomLessonState>>,
          TError,
          Awaited<ReturnType<typeof classroomLessonStateControllerFindClassroomLessonState>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomLessonStateControllerFindClassroomLessonState<TData = Awaited<ReturnType<typeof classroomLessonStateControllerFindClassroomLessonState>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerFindClassroomLessonState>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomLessonStateControllerFindClassroomLessonState>>,
          TError,
          Awaited<ReturnType<typeof classroomLessonStateControllerFindClassroomLessonState>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomLessonStateControllerFindClassroomLessonState<TData = Awaited<ReturnType<typeof classroomLessonStateControllerFindClassroomLessonState>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerFindClassroomLessonState>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomLessonStateControllerFindClassroomLessonState<TData = Awaited<ReturnType<typeof classroomLessonStateControllerFindClassroomLessonState>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerFindClassroomLessonState>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomLessonStateControllerFindClassroomLessonStateQueryOptions(classroomId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomLessonStateControllerFindClassroomLessonState} query
 */
export const invalidateClassroomLessonStateControllerFindClassroomLessonState = async (
 queryClient: QueryClient, classroomId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomLessonStateControllerFindClassroomLessonStateQueryKey(classroomId) }, options);

  return queryClient;
}

export const useSetClassroomLessonStateControllerFindClassroomLessonStateQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,updater: Awaited<ReturnType<typeof classroomLessonStateControllerFindClassroomLessonState>> | undefined | ((old: Awaited<ReturnType<typeof classroomLessonStateControllerFindClassroomLessonState>> | undefined) => Awaited<ReturnType<typeof classroomLessonStateControllerFindClassroomLessonState>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomLessonStateControllerFindClassroomLessonState>>>({ exact: $exactMatch, queryKey: getClassroomLessonStateControllerFindClassroomLessonStateQueryKey(classroomId) }, updater);
  };
}

export const useGetClassroomLessonStateControllerFindClassroomLessonStateQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomLessonStateControllerFindClassroomLessonState>>>(getClassroomLessonStateControllerFindClassroomLessonStateQueryKey(classroomId));
}



export const classroomLessonStateControllerFindLessonStateByClassroomId = (
    classroomId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/classroom-lesson-state/classrooms/${classroomId}/lessons`, method: 'GET', signal
    },
      options);
    }




export const getClassroomLessonStateControllerFindLessonStateByClassroomIdQueryKey = (classroomId: string,) => {
    return [
    `/classroom-lesson-state/classrooms/${classroomId}/lessons`
    ] as const;
    }


export const getClassroomLessonStateControllerFindLessonStateByClassroomIdQueryOptions = <TData = Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomId>>, TError = ErrorType<unknown>>(classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomLessonStateControllerFindLessonStateByClassroomIdQueryKey(classroomId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomId>>> = ({ signal }) => classroomLessonStateControllerFindLessonStateByClassroomId(classroomId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomLessonStateControllerFindLessonStateByClassroomIdQueryResult = NonNullable<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomId>>>
export type ClassroomLessonStateControllerFindLessonStateByClassroomIdQueryError = ErrorType<unknown>


export function useClassroomLessonStateControllerFindLessonStateByClassroomId<TData = Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomId>>, TError = ErrorType<unknown>>(
 classroomId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomId>>,
          TError,
          Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomLessonStateControllerFindLessonStateByClassroomId<TData = Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomId>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomId>>,
          TError,
          Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomLessonStateControllerFindLessonStateByClassroomId<TData = Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomId>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomLessonStateControllerFindLessonStateByClassroomId<TData = Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomId>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomLessonStateControllerFindLessonStateByClassroomIdQueryOptions(classroomId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomLessonStateControllerFindLessonStateByClassroomId} query
 */
export const invalidateClassroomLessonStateControllerFindLessonStateByClassroomId = async (
 queryClient: QueryClient, classroomId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomLessonStateControllerFindLessonStateByClassroomIdQueryKey(classroomId) }, options);

  return queryClient;
}

export const useSetClassroomLessonStateControllerFindLessonStateByClassroomIdQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,updater: Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomId>> | undefined | ((old: Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomId>> | undefined) => Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomId>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomId>>>({ exact: $exactMatch, queryKey: getClassroomLessonStateControllerFindLessonStateByClassroomIdQueryKey(classroomId) }, updater);
  };
}

export const useGetClassroomLessonStateControllerFindLessonStateByClassroomIdQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomId>>>(getClassroomLessonStateControllerFindLessonStateByClassroomIdQueryKey(classroomId));
}



export const classroomLessonStateControllerFindLessonSelectionPageData = (
    classroomId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/classroom-lesson-state/classrooms/${classroomId}/lesson-selection-page-data`, method: 'GET', signal
    },
      options);
    }




export const getClassroomLessonStateControllerFindLessonSelectionPageDataQueryKey = (classroomId: string,) => {
    return [
    `/classroom-lesson-state/classrooms/${classroomId}/lesson-selection-page-data`
    ] as const;
    }


export const getClassroomLessonStateControllerFindLessonSelectionPageDataQueryOptions = <TData = Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonSelectionPageData>>, TError = ErrorType<unknown>>(classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonSelectionPageData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomLessonStateControllerFindLessonSelectionPageDataQueryKey(classroomId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonSelectionPageData>>> = ({ signal }) => classroomLessonStateControllerFindLessonSelectionPageData(classroomId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonSelectionPageData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomLessonStateControllerFindLessonSelectionPageDataQueryResult = NonNullable<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonSelectionPageData>>>
export type ClassroomLessonStateControllerFindLessonSelectionPageDataQueryError = ErrorType<unknown>


export function useClassroomLessonStateControllerFindLessonSelectionPageData<TData = Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonSelectionPageData>>, TError = ErrorType<unknown>>(
 classroomId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonSelectionPageData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonSelectionPageData>>,
          TError,
          Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonSelectionPageData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomLessonStateControllerFindLessonSelectionPageData<TData = Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonSelectionPageData>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonSelectionPageData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonSelectionPageData>>,
          TError,
          Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonSelectionPageData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomLessonStateControllerFindLessonSelectionPageData<TData = Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonSelectionPageData>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonSelectionPageData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomLessonStateControllerFindLessonSelectionPageData<TData = Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonSelectionPageData>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonSelectionPageData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomLessonStateControllerFindLessonSelectionPageDataQueryOptions(classroomId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomLessonStateControllerFindLessonSelectionPageData} query
 */
export const invalidateClassroomLessonStateControllerFindLessonSelectionPageData = async (
 queryClient: QueryClient, classroomId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomLessonStateControllerFindLessonSelectionPageDataQueryKey(classroomId) }, options);

  return queryClient;
}

export const useSetClassroomLessonStateControllerFindLessonSelectionPageDataQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,updater: Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonSelectionPageData>> | undefined | ((old: Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonSelectionPageData>> | undefined) => Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonSelectionPageData>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonSelectionPageData>>>({ exact: $exactMatch, queryKey: getClassroomLessonStateControllerFindLessonSelectionPageDataQueryKey(classroomId) }, updater);
  };
}

export const useGetClassroomLessonStateControllerFindLessonSelectionPageDataQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonSelectionPageData>>>(getClassroomLessonStateControllerFindLessonSelectionPageDataQueryKey(classroomId));
}



export const classroomLessonStateControllerGetRevampLessonCardDataInClassroom = (
    classroomId: string,
    params?: ClassroomLessonStateControllerGetRevampLessonCardDataInClassroomParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<(RevampLessonCardDto | LiveSessionSlotStudentItemDto)[]>(
      {url: `/classroom-lesson-state/classrooms/${classroomId}/revamp-lesson-card-data`, method: 'GET',
        params, signal
    },
      options);
    }




export const getClassroomLessonStateControllerGetRevampLessonCardDataInClassroomQueryKey = (classroomId: string,
    params?: ClassroomLessonStateControllerGetRevampLessonCardDataInClassroomParams,) => {
    return [
    `/classroom-lesson-state/classrooms/${classroomId}/revamp-lesson-card-data`, ...(params ? [params] : [])
    ] as const;
    }


export const getClassroomLessonStateControllerGetRevampLessonCardDataInClassroomQueryOptions = <TData = Awaited<ReturnType<typeof classroomLessonStateControllerGetRevampLessonCardDataInClassroom>>, TError = ErrorType<unknown>>(classroomId: string,
    params?: ClassroomLessonStateControllerGetRevampLessonCardDataInClassroomParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerGetRevampLessonCardDataInClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomLessonStateControllerGetRevampLessonCardDataInClassroomQueryKey(classroomId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomLessonStateControllerGetRevampLessonCardDataInClassroom>>> = ({ signal }) => classroomLessonStateControllerGetRevampLessonCardDataInClassroom(classroomId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerGetRevampLessonCardDataInClassroom>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomLessonStateControllerGetRevampLessonCardDataInClassroomQueryResult = NonNullable<Awaited<ReturnType<typeof classroomLessonStateControllerGetRevampLessonCardDataInClassroom>>>
export type ClassroomLessonStateControllerGetRevampLessonCardDataInClassroomQueryError = ErrorType<unknown>


export function useClassroomLessonStateControllerGetRevampLessonCardDataInClassroom<TData = Awaited<ReturnType<typeof classroomLessonStateControllerGetRevampLessonCardDataInClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string,
    params: undefined |  ClassroomLessonStateControllerGetRevampLessonCardDataInClassroomParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerGetRevampLessonCardDataInClassroom>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomLessonStateControllerGetRevampLessonCardDataInClassroom>>,
          TError,
          Awaited<ReturnType<typeof classroomLessonStateControllerGetRevampLessonCardDataInClassroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomLessonStateControllerGetRevampLessonCardDataInClassroom<TData = Awaited<ReturnType<typeof classroomLessonStateControllerGetRevampLessonCardDataInClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string,
    params?: ClassroomLessonStateControllerGetRevampLessonCardDataInClassroomParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerGetRevampLessonCardDataInClassroom>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomLessonStateControllerGetRevampLessonCardDataInClassroom>>,
          TError,
          Awaited<ReturnType<typeof classroomLessonStateControllerGetRevampLessonCardDataInClassroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomLessonStateControllerGetRevampLessonCardDataInClassroom<TData = Awaited<ReturnType<typeof classroomLessonStateControllerGetRevampLessonCardDataInClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string,
    params?: ClassroomLessonStateControllerGetRevampLessonCardDataInClassroomParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerGetRevampLessonCardDataInClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomLessonStateControllerGetRevampLessonCardDataInClassroom<TData = Awaited<ReturnType<typeof classroomLessonStateControllerGetRevampLessonCardDataInClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string,
    params?: ClassroomLessonStateControllerGetRevampLessonCardDataInClassroomParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerGetRevampLessonCardDataInClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomLessonStateControllerGetRevampLessonCardDataInClassroomQueryOptions(classroomId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomLessonStateControllerGetRevampLessonCardDataInClassroom} query
 */
export const invalidateClassroomLessonStateControllerGetRevampLessonCardDataInClassroom = async (
 queryClient: QueryClient, classroomId: string,
    params?: ClassroomLessonStateControllerGetRevampLessonCardDataInClassroomParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomLessonStateControllerGetRevampLessonCardDataInClassroomQueryKey(classroomId,params) }, options);

  return queryClient;
}

export const useSetClassroomLessonStateControllerGetRevampLessonCardDataInClassroomQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    params: ClassroomLessonStateControllerGetRevampLessonCardDataInClassroomParams | undefined,updater: Awaited<ReturnType<typeof classroomLessonStateControllerGetRevampLessonCardDataInClassroom>> | undefined | ((old: Awaited<ReturnType<typeof classroomLessonStateControllerGetRevampLessonCardDataInClassroom>> | undefined) => Awaited<ReturnType<typeof classroomLessonStateControllerGetRevampLessonCardDataInClassroom>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomLessonStateControllerGetRevampLessonCardDataInClassroom>>>({ exact: $exactMatch, queryKey: getClassroomLessonStateControllerGetRevampLessonCardDataInClassroomQueryKey(classroomId,params) }, updater);
  };
}

export const useGetClassroomLessonStateControllerGetRevampLessonCardDataInClassroomQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    params?: ClassroomLessonStateControllerGetRevampLessonCardDataInClassroomParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomLessonStateControllerGetRevampLessonCardDataInClassroom>>>(getClassroomLessonStateControllerGetRevampLessonCardDataInClassroomQueryKey(classroomId,params));
}



export const classroomLessonStateControllerFindLessonStateByClassroomAndLessonId = (
    classroomId: string,
    lessonId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/classroom-lesson-state/classrooms/${classroomId}/lessons/${lessonId}`, method: 'GET', signal
    },
      options);
    }




export const getClassroomLessonStateControllerFindLessonStateByClassroomAndLessonIdQueryKey = (classroomId: string,
    lessonId: string,) => {
    return [
    `/classroom-lesson-state/classrooms/${classroomId}/lessons/${lessonId}`
    ] as const;
    }


export const getClassroomLessonStateControllerFindLessonStateByClassroomAndLessonIdQueryOptions = <TData = Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomAndLessonId>>, TError = ErrorType<unknown>>(classroomId: string,
    lessonId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomAndLessonId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomLessonStateControllerFindLessonStateByClassroomAndLessonIdQueryKey(classroomId,lessonId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomAndLessonId>>> = ({ signal }) => classroomLessonStateControllerFindLessonStateByClassroomAndLessonId(classroomId,lessonId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined && lessonId !== null && lessonId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomAndLessonId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomLessonStateControllerFindLessonStateByClassroomAndLessonIdQueryResult = NonNullable<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomAndLessonId>>>
export type ClassroomLessonStateControllerFindLessonStateByClassroomAndLessonIdQueryError = ErrorType<unknown>


export function useClassroomLessonStateControllerFindLessonStateByClassroomAndLessonId<TData = Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomAndLessonId>>, TError = ErrorType<unknown>>(
 classroomId: string,
    lessonId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomAndLessonId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomAndLessonId>>,
          TError,
          Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomAndLessonId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomLessonStateControllerFindLessonStateByClassroomAndLessonId<TData = Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomAndLessonId>>, TError = ErrorType<unknown>>(
 classroomId: string,
    lessonId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomAndLessonId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomAndLessonId>>,
          TError,
          Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomAndLessonId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomLessonStateControllerFindLessonStateByClassroomAndLessonId<TData = Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomAndLessonId>>, TError = ErrorType<unknown>>(
 classroomId: string,
    lessonId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomAndLessonId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomLessonStateControllerFindLessonStateByClassroomAndLessonId<TData = Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomAndLessonId>>, TError = ErrorType<unknown>>(
 classroomId: string,
    lessonId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomAndLessonId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomLessonStateControllerFindLessonStateByClassroomAndLessonIdQueryOptions(classroomId,lessonId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomLessonStateControllerFindLessonStateByClassroomAndLessonId} query
 */
export const invalidateClassroomLessonStateControllerFindLessonStateByClassroomAndLessonId = async (
 queryClient: QueryClient, classroomId: string,
    lessonId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomLessonStateControllerFindLessonStateByClassroomAndLessonIdQueryKey(classroomId,lessonId) }, options);

  return queryClient;
}

export const useSetClassroomLessonStateControllerFindLessonStateByClassroomAndLessonIdQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    lessonId: string,updater: Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomAndLessonId>> | undefined | ((old: Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomAndLessonId>> | undefined) => Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomAndLessonId>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomAndLessonId>>>({ exact: $exactMatch, queryKey: getClassroomLessonStateControllerFindLessonStateByClassroomAndLessonIdQueryKey(classroomId,lessonId) }, updater);
  };
}

export const useGetClassroomLessonStateControllerFindLessonStateByClassroomAndLessonIdQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    lessonId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomLessonStateControllerFindLessonStateByClassroomAndLessonId>>>(getClassroomLessonStateControllerFindLessonStateByClassroomAndLessonIdQueryKey(classroomId,lessonId));
}



export const classroomControllerCreate = (
    createClassroomDto: BodyType<CreateClassroomDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/classrooms`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createClassroomDto, signal
    },
      options);
    }




export const getClassroomControllerCreateMutationKey = () => ['classroomControllerCreate'] as const;

export const getClassroomControllerCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomControllerCreate>>, TError,ClassroomControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof classroomControllerCreate>>, TError,ClassroomControllerCreateMutationVariables, TContext> => {

const mutationKey = getClassroomControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof classroomControllerCreate>>, ClassroomControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  classroomControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClassroomControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof classroomControllerCreate>>>
    export type ClassroomControllerCreateMutationBody = BodyType<CreateClassroomDto>
    export type ClassroomControllerCreateMutationError = ErrorType<unknown>
    export type ClassroomControllerCreateMutationVariables = {data: BodyType<CreateClassroomDto>}

    export const useClassroomControllerCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomControllerCreate>>, TError,ClassroomControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof classroomControllerCreate>>,
        TError,
        ClassroomControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getClassroomControllerCreateMutationOptions(options), queryClient);
    }

export const classroomControllerFindAll = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/classrooms`, method: 'GET', signal
    },
      options);
    }




export const getClassroomControllerFindAllQueryKey = () => {
    return [
    `/classrooms`
    ] as const;
    }


export const getClassroomControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof classroomControllerFindAll>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomControllerFindAllQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomControllerFindAll>>> = ({ signal }) => classroomControllerFindAll(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomControllerFindAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof classroomControllerFindAll>>>
export type ClassroomControllerFindAllQueryError = ErrorType<unknown>


export function useClassroomControllerFindAll<TData = Awaited<ReturnType<typeof classroomControllerFindAll>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerFindAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof classroomControllerFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomControllerFindAll<TData = Awaited<ReturnType<typeof classroomControllerFindAll>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerFindAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof classroomControllerFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomControllerFindAll<TData = Awaited<ReturnType<typeof classroomControllerFindAll>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomControllerFindAll<TData = Awaited<ReturnType<typeof classroomControllerFindAll>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomControllerFindAllQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomControllerFindAll} query
 */
export const invalidateClassroomControllerFindAll = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomControllerFindAllQueryKey() }, options);

  return queryClient;
}

export const useSetClassroomControllerFindAllQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof classroomControllerFindAll>> | undefined | ((old: Awaited<ReturnType<typeof classroomControllerFindAll>> | undefined) => Awaited<ReturnType<typeof classroomControllerFindAll>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomControllerFindAll>>>({ exact: $exactMatch, queryKey: getClassroomControllerFindAllQueryKey() }, updater);
  };
}

export const useGetClassroomControllerFindAllQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomControllerFindAll>>>(getClassroomControllerFindAllQueryKey());
}



export const classroomControllerFindById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/classrooms/${id}`, method: 'GET', signal
    },
      options);
    }




export const getClassroomControllerFindByIdQueryKey = (id: string,) => {
    return [
    `/classrooms/${id}`
    ] as const;
    }


export const getClassroomControllerFindByIdQueryOptions = <TData = Awaited<ReturnType<typeof classroomControllerFindById>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomControllerFindByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomControllerFindById>>> = ({ signal }) => classroomControllerFindById(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomControllerFindById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomControllerFindByIdQueryResult = NonNullable<Awaited<ReturnType<typeof classroomControllerFindById>>>
export type ClassroomControllerFindByIdQueryError = ErrorType<unknown>


export function useClassroomControllerFindById<TData = Awaited<ReturnType<typeof classroomControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerFindById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof classroomControllerFindById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomControllerFindById<TData = Awaited<ReturnType<typeof classroomControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerFindById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof classroomControllerFindById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomControllerFindById<TData = Awaited<ReturnType<typeof classroomControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomControllerFindById<TData = Awaited<ReturnType<typeof classroomControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomControllerFindByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomControllerFindById} query
 */
export const invalidateClassroomControllerFindById = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomControllerFindByIdQueryKey(id) }, options);

  return queryClient;
}

export const useSetClassroomControllerFindByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof classroomControllerFindById>> | undefined | ((old: Awaited<ReturnType<typeof classroomControllerFindById>> | undefined) => Awaited<ReturnType<typeof classroomControllerFindById>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomControllerFindById>>>({ exact: $exactMatch, queryKey: getClassroomControllerFindByIdQueryKey(id) }, updater);
  };
}

export const useGetClassroomControllerFindByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomControllerFindById>>>(getClassroomControllerFindByIdQueryKey(id));
}



export const classroomControllerUpdateClassroomById = (
    id: string,
    updateClassroomDto: BodyType<UpdateClassroomDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Classroom>(
      {url: `/classrooms/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateClassroomDto, signal
    },
      options);
    }




export const getClassroomControllerUpdateClassroomByIdMutationKey = () => ['classroomControllerUpdateClassroomById'] as const;

export const getClassroomControllerUpdateClassroomByIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomControllerUpdateClassroomById>>, TError,ClassroomControllerUpdateClassroomByIdMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof classroomControllerUpdateClassroomById>>, TError,ClassroomControllerUpdateClassroomByIdMutationVariables, TContext> => {

const mutationKey = getClassroomControllerUpdateClassroomByIdMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof classroomControllerUpdateClassroomById>>, ClassroomControllerUpdateClassroomByIdMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  classroomControllerUpdateClassroomById(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClassroomControllerUpdateClassroomByIdMutationResult = NonNullable<Awaited<ReturnType<typeof classroomControllerUpdateClassroomById>>>
    export type ClassroomControllerUpdateClassroomByIdMutationBody = BodyType<UpdateClassroomDto>
    export type ClassroomControllerUpdateClassroomByIdMutationError = ErrorType<unknown>
    export type ClassroomControllerUpdateClassroomByIdMutationVariables = {id: string;data: BodyType<UpdateClassroomDto>}

    export const useClassroomControllerUpdateClassroomById = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomControllerUpdateClassroomById>>, TError,ClassroomControllerUpdateClassroomByIdMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof classroomControllerUpdateClassroomById>>,
        TError,
        ClassroomControllerUpdateClassroomByIdMutationVariables,
        TContext
      > => {
      return useMutation(getClassroomControllerUpdateClassroomByIdMutationOptions(options), queryClient);
    }

/**
 * @summary Return sorted lessons in classroom.
If lessonIds field exists in Classroom, sorted by array's index.
If no lessonIds, sorted by ClassroomLesson
 */
export const classroomControllerGetLessonsInClassroom = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ClassroomControllerGetLessonsInClassroom200Item[]>(
      {url: `/classrooms/${id}/lessons`, method: 'GET', signal
    },
      options);
    }




export const getClassroomControllerGetLessonsInClassroomQueryKey = (id: string,) => {
    return [
    `/classrooms/${id}/lessons`
    ] as const;
    }


export const getClassroomControllerGetLessonsInClassroomQueryOptions = <TData = Awaited<ReturnType<typeof classroomControllerGetLessonsInClassroom>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetLessonsInClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomControllerGetLessonsInClassroomQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomControllerGetLessonsInClassroom>>> = ({ signal }) => classroomControllerGetLessonsInClassroom(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetLessonsInClassroom>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomControllerGetLessonsInClassroomQueryResult = NonNullable<Awaited<ReturnType<typeof classroomControllerGetLessonsInClassroom>>>
export type ClassroomControllerGetLessonsInClassroomQueryError = ErrorType<unknown>


export function useClassroomControllerGetLessonsInClassroom<TData = Awaited<ReturnType<typeof classroomControllerGetLessonsInClassroom>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetLessonsInClassroom>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomControllerGetLessonsInClassroom>>,
          TError,
          Awaited<ReturnType<typeof classroomControllerGetLessonsInClassroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomControllerGetLessonsInClassroom<TData = Awaited<ReturnType<typeof classroomControllerGetLessonsInClassroom>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetLessonsInClassroom>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomControllerGetLessonsInClassroom>>,
          TError,
          Awaited<ReturnType<typeof classroomControllerGetLessonsInClassroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomControllerGetLessonsInClassroom<TData = Awaited<ReturnType<typeof classroomControllerGetLessonsInClassroom>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetLessonsInClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Return sorted lessons in classroom.
If lessonIds field exists in Classroom, sorted by array's index.
If no lessonIds, sorted by ClassroomLesson
 */

export function useClassroomControllerGetLessonsInClassroom<TData = Awaited<ReturnType<typeof classroomControllerGetLessonsInClassroom>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetLessonsInClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomControllerGetLessonsInClassroomQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomControllerGetLessonsInClassroom} query
 */
export const invalidateClassroomControllerGetLessonsInClassroom = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomControllerGetLessonsInClassroomQueryKey(id) }, options);

  return queryClient;
}

/**
 * @summary Return sorted lessons in classroom.
If lessonIds field exists in Classroom, sorted by array's index.
If no lessonIds, sorted by ClassroomLesson
 */
export const useSetClassroomControllerGetLessonsInClassroomQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof classroomControllerGetLessonsInClassroom>> | undefined | ((old: Awaited<ReturnType<typeof classroomControllerGetLessonsInClassroom>> | undefined) => Awaited<ReturnType<typeof classroomControllerGetLessonsInClassroom>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomControllerGetLessonsInClassroom>>>({ exact: $exactMatch, queryKey: getClassroomControllerGetLessonsInClassroomQueryKey(id) }, updater);
  };
}

/**
 * @summary Return sorted lessons in classroom.
If lessonIds field exists in Classroom, sorted by array's index.
If no lessonIds, sorted by ClassroomLesson
 */
export const useGetClassroomControllerGetLessonsInClassroomQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomControllerGetLessonsInClassroom>>>(getClassroomControllerGetLessonsInClassroomQueryKey(id));
}



export const classroomControllerGetLessonHistoryInClassroom = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ClassroomControllerGetLessonHistoryInClassroom200>(
      {url: `/classrooms/${id}/latest-lesson-instances`, method: 'GET', signal
    },
      options);
    }




export const getClassroomControllerGetLessonHistoryInClassroomQueryKey = (id: string,) => {
    return [
    `/classrooms/${id}/latest-lesson-instances`
    ] as const;
    }


export const getClassroomControllerGetLessonHistoryInClassroomQueryOptions = <TData = Awaited<ReturnType<typeof classroomControllerGetLessonHistoryInClassroom>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetLessonHistoryInClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomControllerGetLessonHistoryInClassroomQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomControllerGetLessonHistoryInClassroom>>> = ({ signal }) => classroomControllerGetLessonHistoryInClassroom(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetLessonHistoryInClassroom>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomControllerGetLessonHistoryInClassroomQueryResult = NonNullable<Awaited<ReturnType<typeof classroomControllerGetLessonHistoryInClassroom>>>
export type ClassroomControllerGetLessonHistoryInClassroomQueryError = ErrorType<unknown>


export function useClassroomControllerGetLessonHistoryInClassroom<TData = Awaited<ReturnType<typeof classroomControllerGetLessonHistoryInClassroom>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetLessonHistoryInClassroom>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomControllerGetLessonHistoryInClassroom>>,
          TError,
          Awaited<ReturnType<typeof classroomControllerGetLessonHistoryInClassroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomControllerGetLessonHistoryInClassroom<TData = Awaited<ReturnType<typeof classroomControllerGetLessonHistoryInClassroom>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetLessonHistoryInClassroom>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomControllerGetLessonHistoryInClassroom>>,
          TError,
          Awaited<ReturnType<typeof classroomControllerGetLessonHistoryInClassroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomControllerGetLessonHistoryInClassroom<TData = Awaited<ReturnType<typeof classroomControllerGetLessonHistoryInClassroom>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetLessonHistoryInClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomControllerGetLessonHistoryInClassroom<TData = Awaited<ReturnType<typeof classroomControllerGetLessonHistoryInClassroom>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetLessonHistoryInClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomControllerGetLessonHistoryInClassroomQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomControllerGetLessonHistoryInClassroom} query
 */
export const invalidateClassroomControllerGetLessonHistoryInClassroom = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomControllerGetLessonHistoryInClassroomQueryKey(id) }, options);

  return queryClient;
}

export const useSetClassroomControllerGetLessonHistoryInClassroomQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof classroomControllerGetLessonHistoryInClassroom>> | undefined | ((old: Awaited<ReturnType<typeof classroomControllerGetLessonHistoryInClassroom>> | undefined) => Awaited<ReturnType<typeof classroomControllerGetLessonHistoryInClassroom>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomControllerGetLessonHistoryInClassroom>>>({ exact: $exactMatch, queryKey: getClassroomControllerGetLessonHistoryInClassroomQueryKey(id) }, updater);
  };
}

export const useGetClassroomControllerGetLessonHistoryInClassroomQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomControllerGetLessonHistoryInClassroom>>>(getClassroomControllerGetLessonHistoryInClassroomQueryKey(id));
}



export const classroomControllerGetLessonInstances = (
    id: string,
    lessonId: string,
    params: ClassroomControllerGetLessonInstancesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ClassroomControllerGetLessonInstances200Item[]>(
      {url: `/classrooms/${id}/lessons/${lessonId}/lesson-instances`, method: 'GET',
        params, signal
    },
      options);
    }




export const getClassroomControllerGetLessonInstancesQueryKey = (id: string,
    lessonId: string,
    params?: ClassroomControllerGetLessonInstancesParams,) => {
    return [
    `/classrooms/${id}/lessons/${lessonId}/lesson-instances`, ...(params ? [params] : [])
    ] as const;
    }


export const getClassroomControllerGetLessonInstancesQueryOptions = <TData = Awaited<ReturnType<typeof classroomControllerGetLessonInstances>>, TError = ErrorType<unknown>>(id: string,
    lessonId: string,
    params: ClassroomControllerGetLessonInstancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetLessonInstances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomControllerGetLessonInstancesQueryKey(id,lessonId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomControllerGetLessonInstances>>> = ({ signal }) => classroomControllerGetLessonInstances(id,lessonId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && lessonId !== null && lessonId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetLessonInstances>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomControllerGetLessonInstancesQueryResult = NonNullable<Awaited<ReturnType<typeof classroomControllerGetLessonInstances>>>
export type ClassroomControllerGetLessonInstancesQueryError = ErrorType<unknown>


export function useClassroomControllerGetLessonInstances<TData = Awaited<ReturnType<typeof classroomControllerGetLessonInstances>>, TError = ErrorType<unknown>>(
 id: string,
    lessonId: string,
    params: ClassroomControllerGetLessonInstancesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetLessonInstances>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomControllerGetLessonInstances>>,
          TError,
          Awaited<ReturnType<typeof classroomControllerGetLessonInstances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomControllerGetLessonInstances<TData = Awaited<ReturnType<typeof classroomControllerGetLessonInstances>>, TError = ErrorType<unknown>>(
 id: string,
    lessonId: string,
    params: ClassroomControllerGetLessonInstancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetLessonInstances>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomControllerGetLessonInstances>>,
          TError,
          Awaited<ReturnType<typeof classroomControllerGetLessonInstances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomControllerGetLessonInstances<TData = Awaited<ReturnType<typeof classroomControllerGetLessonInstances>>, TError = ErrorType<unknown>>(
 id: string,
    lessonId: string,
    params: ClassroomControllerGetLessonInstancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetLessonInstances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomControllerGetLessonInstances<TData = Awaited<ReturnType<typeof classroomControllerGetLessonInstances>>, TError = ErrorType<unknown>>(
 id: string,
    lessonId: string,
    params: ClassroomControllerGetLessonInstancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetLessonInstances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomControllerGetLessonInstancesQueryOptions(id,lessonId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomControllerGetLessonInstances} query
 */
export const invalidateClassroomControllerGetLessonInstances = async (
 queryClient: QueryClient, id: string,
    lessonId: string,
    params: ClassroomControllerGetLessonInstancesParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomControllerGetLessonInstancesQueryKey(id,lessonId,params) }, options);

  return queryClient;
}

export const useSetClassroomControllerGetLessonInstancesQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,
    lessonId: string,
    params: ClassroomControllerGetLessonInstancesParams | undefined,updater: Awaited<ReturnType<typeof classroomControllerGetLessonInstances>> | undefined | ((old: Awaited<ReturnType<typeof classroomControllerGetLessonInstances>> | undefined) => Awaited<ReturnType<typeof classroomControllerGetLessonInstances>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomControllerGetLessonInstances>>>({ exact: $exactMatch, queryKey: getClassroomControllerGetLessonInstancesQueryKey(id,lessonId,params) }, updater);
  };
}

export const useGetClassroomControllerGetLessonInstancesQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,
    lessonId: string,
    params: ClassroomControllerGetLessonInstancesParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomControllerGetLessonInstances>>>(getClassroomControllerGetLessonInstancesQueryKey(id,lessonId,params));
}



export const classroomControllerCreateLessonWithActivities = (
    id: string,
    createLessonAndActivitiesDto: BodyType<CreateLessonAndActivitiesDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ClassroomControllerCreateLessonWithActivities201>(
      {url: `/classrooms/${id}/create-lesson-with-activities`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createLessonAndActivitiesDto, signal
    },
      options);
    }




export const getClassroomControllerCreateLessonWithActivitiesMutationKey = () => ['classroomControllerCreateLessonWithActivities'] as const;

export const getClassroomControllerCreateLessonWithActivitiesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomControllerCreateLessonWithActivities>>, TError,ClassroomControllerCreateLessonWithActivitiesMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof classroomControllerCreateLessonWithActivities>>, TError,ClassroomControllerCreateLessonWithActivitiesMutationVariables, TContext> => {

const mutationKey = getClassroomControllerCreateLessonWithActivitiesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof classroomControllerCreateLessonWithActivities>>, ClassroomControllerCreateLessonWithActivitiesMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  classroomControllerCreateLessonWithActivities(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClassroomControllerCreateLessonWithActivitiesMutationResult = NonNullable<Awaited<ReturnType<typeof classroomControllerCreateLessonWithActivities>>>
    export type ClassroomControllerCreateLessonWithActivitiesMutationBody = BodyType<CreateLessonAndActivitiesDto>
    export type ClassroomControllerCreateLessonWithActivitiesMutationError = ErrorType<unknown>
    export type ClassroomControllerCreateLessonWithActivitiesMutationVariables = {id: string;data: BodyType<CreateLessonAndActivitiesDto>}

    export const useClassroomControllerCreateLessonWithActivities = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomControllerCreateLessonWithActivities>>, TError,ClassroomControllerCreateLessonWithActivitiesMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof classroomControllerCreateLessonWithActivities>>,
        TError,
        ClassroomControllerCreateLessonWithActivitiesMutationVariables,
        TContext
      > => {
      return useMutation(getClassroomControllerCreateLessonWithActivitiesMutationOptions(options), queryClient);
    }

export const classroomControllerBatchCreateLessonWithActivities = (
    id: string,
    createLessonAndActivitiesDto: BodyType<CreateLessonAndActivitiesDto[]>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ClassroomControllerBatchCreateLessonWithActivities201Item[]>(
      {url: `/classrooms/${id}/batch-create-lessons-with-activities`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createLessonAndActivitiesDto, signal
    },
      options);
    }




export const getClassroomControllerBatchCreateLessonWithActivitiesMutationKey = () => ['classroomControllerBatchCreateLessonWithActivities'] as const;

export const getClassroomControllerBatchCreateLessonWithActivitiesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomControllerBatchCreateLessonWithActivities>>, TError,ClassroomControllerBatchCreateLessonWithActivitiesMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof classroomControllerBatchCreateLessonWithActivities>>, TError,ClassroomControllerBatchCreateLessonWithActivitiesMutationVariables, TContext> => {

const mutationKey = getClassroomControllerBatchCreateLessonWithActivitiesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof classroomControllerBatchCreateLessonWithActivities>>, ClassroomControllerBatchCreateLessonWithActivitiesMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  classroomControllerBatchCreateLessonWithActivities(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClassroomControllerBatchCreateLessonWithActivitiesMutationResult = NonNullable<Awaited<ReturnType<typeof classroomControllerBatchCreateLessonWithActivities>>>
    export type ClassroomControllerBatchCreateLessonWithActivitiesMutationBody = BodyType<CreateLessonAndActivitiesDto[]>
    export type ClassroomControllerBatchCreateLessonWithActivitiesMutationError = ErrorType<unknown>
    export type ClassroomControllerBatchCreateLessonWithActivitiesMutationVariables = {id: string;data: BodyType<CreateLessonAndActivitiesDto[]>}

    export const useClassroomControllerBatchCreateLessonWithActivities = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomControllerBatchCreateLessonWithActivities>>, TError,ClassroomControllerBatchCreateLessonWithActivitiesMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof classroomControllerBatchCreateLessonWithActivities>>,
        TError,
        ClassroomControllerBatchCreateLessonWithActivitiesMutationVariables,
        TContext
      > => {
      return useMutation(getClassroomControllerBatchCreateLessonWithActivitiesMutationOptions(options), queryClient);
    }

export const classroomControllerBatchCreateLessonWithActivitiesMultipleClassrooms = (
    batchCreateLessonAndActivitiesDto: BodyType<BatchCreateLessonAndActivitiesDto[]>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/classrooms/batch-create-lessons-with-activities`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: batchCreateLessonAndActivitiesDto, signal
    },
      options);
    }




export const getClassroomControllerBatchCreateLessonWithActivitiesMultipleClassroomsMutationKey = () => ['classroomControllerBatchCreateLessonWithActivitiesMultipleClassrooms'] as const;

export const getClassroomControllerBatchCreateLessonWithActivitiesMultipleClassroomsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomControllerBatchCreateLessonWithActivitiesMultipleClassrooms>>, TError,ClassroomControllerBatchCreateLessonWithActivitiesMultipleClassroomsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof classroomControllerBatchCreateLessonWithActivitiesMultipleClassrooms>>, TError,ClassroomControllerBatchCreateLessonWithActivitiesMultipleClassroomsMutationVariables, TContext> => {

const mutationKey = getClassroomControllerBatchCreateLessonWithActivitiesMultipleClassroomsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof classroomControllerBatchCreateLessonWithActivitiesMultipleClassrooms>>, ClassroomControllerBatchCreateLessonWithActivitiesMultipleClassroomsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  classroomControllerBatchCreateLessonWithActivitiesMultipleClassrooms(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClassroomControllerBatchCreateLessonWithActivitiesMultipleClassroomsMutationResult = NonNullable<Awaited<ReturnType<typeof classroomControllerBatchCreateLessonWithActivitiesMultipleClassrooms>>>
    export type ClassroomControllerBatchCreateLessonWithActivitiesMultipleClassroomsMutationBody = BodyType<BatchCreateLessonAndActivitiesDto[]>
    export type ClassroomControllerBatchCreateLessonWithActivitiesMultipleClassroomsMutationError = ErrorType<unknown>
    export type ClassroomControllerBatchCreateLessonWithActivitiesMultipleClassroomsMutationVariables = {data: BodyType<BatchCreateLessonAndActivitiesDto[]>}

    export const useClassroomControllerBatchCreateLessonWithActivitiesMultipleClassrooms = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomControllerBatchCreateLessonWithActivitiesMultipleClassrooms>>, TError,ClassroomControllerBatchCreateLessonWithActivitiesMultipleClassroomsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof classroomControllerBatchCreateLessonWithActivitiesMultipleClassrooms>>,
        TError,
        ClassroomControllerBatchCreateLessonWithActivitiesMultipleClassroomsMutationVariables,
        TContext
      > => {
      return useMutation(getClassroomControllerBatchCreateLessonWithActivitiesMultipleClassroomsMutationOptions(options), queryClient);
    }

export const classroomControllerAddUsersToClassroom = (
    id: string,
    addUsersToClassroomDto: BodyType<AddUsersToClassroomDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/classrooms/${id}/users/add`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addUsersToClassroomDto, signal
    },
      options);
    }




export const getClassroomControllerAddUsersToClassroomMutationKey = () => ['classroomControllerAddUsersToClassroom'] as const;

export const getClassroomControllerAddUsersToClassroomMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomControllerAddUsersToClassroom>>, TError,ClassroomControllerAddUsersToClassroomMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof classroomControllerAddUsersToClassroom>>, TError,ClassroomControllerAddUsersToClassroomMutationVariables, TContext> => {

const mutationKey = getClassroomControllerAddUsersToClassroomMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof classroomControllerAddUsersToClassroom>>, ClassroomControllerAddUsersToClassroomMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  classroomControllerAddUsersToClassroom(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClassroomControllerAddUsersToClassroomMutationResult = NonNullable<Awaited<ReturnType<typeof classroomControllerAddUsersToClassroom>>>
    export type ClassroomControllerAddUsersToClassroomMutationBody = BodyType<AddUsersToClassroomDto>
    export type ClassroomControllerAddUsersToClassroomMutationError = ErrorType<unknown>
    export type ClassroomControllerAddUsersToClassroomMutationVariables = {id: string;data: BodyType<AddUsersToClassroomDto>}

    export const useClassroomControllerAddUsersToClassroom = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomControllerAddUsersToClassroom>>, TError,ClassroomControllerAddUsersToClassroomMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof classroomControllerAddUsersToClassroom>>,
        TError,
        ClassroomControllerAddUsersToClassroomMutationVariables,
        TContext
      > => {
      return useMutation(getClassroomControllerAddUsersToClassroomMutationOptions(options), queryClient);
    }

export const classroomControllerGetLessonInstancesByStatus = (
    id: string,
    params: ClassroomControllerGetLessonInstancesByStatusParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ClassroomControllerGetLessonInstancesByStatus200Item[]>(
      {url: `/classrooms/${id}/lesson-instances`, method: 'GET',
        params, signal
    },
      options);
    }




export const getClassroomControllerGetLessonInstancesByStatusQueryKey = (id: string,
    params?: ClassroomControllerGetLessonInstancesByStatusParams,) => {
    return [
    `/classrooms/${id}/lesson-instances`, ...(params ? [params] : [])
    ] as const;
    }


export const getClassroomControllerGetLessonInstancesByStatusQueryOptions = <TData = Awaited<ReturnType<typeof classroomControllerGetLessonInstancesByStatus>>, TError = ErrorType<unknown>>(id: string,
    params: ClassroomControllerGetLessonInstancesByStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetLessonInstancesByStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomControllerGetLessonInstancesByStatusQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomControllerGetLessonInstancesByStatus>>> = ({ signal }) => classroomControllerGetLessonInstancesByStatus(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetLessonInstancesByStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomControllerGetLessonInstancesByStatusQueryResult = NonNullable<Awaited<ReturnType<typeof classroomControllerGetLessonInstancesByStatus>>>
export type ClassroomControllerGetLessonInstancesByStatusQueryError = ErrorType<unknown>


export function useClassroomControllerGetLessonInstancesByStatus<TData = Awaited<ReturnType<typeof classroomControllerGetLessonInstancesByStatus>>, TError = ErrorType<unknown>>(
 id: string,
    params: ClassroomControllerGetLessonInstancesByStatusParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetLessonInstancesByStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomControllerGetLessonInstancesByStatus>>,
          TError,
          Awaited<ReturnType<typeof classroomControllerGetLessonInstancesByStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomControllerGetLessonInstancesByStatus<TData = Awaited<ReturnType<typeof classroomControllerGetLessonInstancesByStatus>>, TError = ErrorType<unknown>>(
 id: string,
    params: ClassroomControllerGetLessonInstancesByStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetLessonInstancesByStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomControllerGetLessonInstancesByStatus>>,
          TError,
          Awaited<ReturnType<typeof classroomControllerGetLessonInstancesByStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomControllerGetLessonInstancesByStatus<TData = Awaited<ReturnType<typeof classroomControllerGetLessonInstancesByStatus>>, TError = ErrorType<unknown>>(
 id: string,
    params: ClassroomControllerGetLessonInstancesByStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetLessonInstancesByStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomControllerGetLessonInstancesByStatus<TData = Awaited<ReturnType<typeof classroomControllerGetLessonInstancesByStatus>>, TError = ErrorType<unknown>>(
 id: string,
    params: ClassroomControllerGetLessonInstancesByStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetLessonInstancesByStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomControllerGetLessonInstancesByStatusQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomControllerGetLessonInstancesByStatus} query
 */
export const invalidateClassroomControllerGetLessonInstancesByStatus = async (
 queryClient: QueryClient, id: string,
    params: ClassroomControllerGetLessonInstancesByStatusParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomControllerGetLessonInstancesByStatusQueryKey(id,params) }, options);

  return queryClient;
}

export const useSetClassroomControllerGetLessonInstancesByStatusQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,
    params: ClassroomControllerGetLessonInstancesByStatusParams | undefined,updater: Awaited<ReturnType<typeof classroomControllerGetLessonInstancesByStatus>> | undefined | ((old: Awaited<ReturnType<typeof classroomControllerGetLessonInstancesByStatus>> | undefined) => Awaited<ReturnType<typeof classroomControllerGetLessonInstancesByStatus>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomControllerGetLessonInstancesByStatus>>>({ exact: $exactMatch, queryKey: getClassroomControllerGetLessonInstancesByStatusQueryKey(id,params) }, updater);
  };
}

export const useGetClassroomControllerGetLessonInstancesByStatusQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,
    params: ClassroomControllerGetLessonInstancesByStatusParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomControllerGetLessonInstancesByStatus>>>(getClassroomControllerGetLessonInstancesByStatusQueryKey(id,params));
}



export const classroomControllerGetClassroomUsers = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/classrooms/${id}/users`, method: 'GET', signal
    },
      options);
    }




export const getClassroomControllerGetClassroomUsersQueryKey = (id: string,) => {
    return [
    `/classrooms/${id}/users`
    ] as const;
    }


export const getClassroomControllerGetClassroomUsersQueryOptions = <TData = Awaited<ReturnType<typeof classroomControllerGetClassroomUsers>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetClassroomUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomControllerGetClassroomUsersQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomControllerGetClassroomUsers>>> = ({ signal }) => classroomControllerGetClassroomUsers(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetClassroomUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomControllerGetClassroomUsersQueryResult = NonNullable<Awaited<ReturnType<typeof classroomControllerGetClassroomUsers>>>
export type ClassroomControllerGetClassroomUsersQueryError = ErrorType<unknown>


export function useClassroomControllerGetClassroomUsers<TData = Awaited<ReturnType<typeof classroomControllerGetClassroomUsers>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetClassroomUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomControllerGetClassroomUsers>>,
          TError,
          Awaited<ReturnType<typeof classroomControllerGetClassroomUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomControllerGetClassroomUsers<TData = Awaited<ReturnType<typeof classroomControllerGetClassroomUsers>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetClassroomUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomControllerGetClassroomUsers>>,
          TError,
          Awaited<ReturnType<typeof classroomControllerGetClassroomUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomControllerGetClassroomUsers<TData = Awaited<ReturnType<typeof classroomControllerGetClassroomUsers>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetClassroomUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomControllerGetClassroomUsers<TData = Awaited<ReturnType<typeof classroomControllerGetClassroomUsers>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetClassroomUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomControllerGetClassroomUsersQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomControllerGetClassroomUsers} query
 */
export const invalidateClassroomControllerGetClassroomUsers = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomControllerGetClassroomUsersQueryKey(id) }, options);

  return queryClient;
}

export const useSetClassroomControllerGetClassroomUsersQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof classroomControllerGetClassroomUsers>> | undefined | ((old: Awaited<ReturnType<typeof classroomControllerGetClassroomUsers>> | undefined) => Awaited<ReturnType<typeof classroomControllerGetClassroomUsers>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomControllerGetClassroomUsers>>>({ exact: $exactMatch, queryKey: getClassroomControllerGetClassroomUsersQueryKey(id) }, updater);
  };
}

export const useGetClassroomControllerGetClassroomUsersQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomControllerGetClassroomUsers>>>(getClassroomControllerGetClassroomUsersQueryKey(id));
}



export const classroomControllerGetClassroomAccessCodes = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ClassroomControllerGetClassroomAccessCodes200Item[]>(
      {url: `/classrooms/${id}/accesscodes`, method: 'GET', signal
    },
      options);
    }




export const getClassroomControllerGetClassroomAccessCodesQueryKey = (id: string,) => {
    return [
    `/classrooms/${id}/accesscodes`
    ] as const;
    }


export const getClassroomControllerGetClassroomAccessCodesQueryOptions = <TData = Awaited<ReturnType<typeof classroomControllerGetClassroomAccessCodes>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetClassroomAccessCodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomControllerGetClassroomAccessCodesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomControllerGetClassroomAccessCodes>>> = ({ signal }) => classroomControllerGetClassroomAccessCodes(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetClassroomAccessCodes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomControllerGetClassroomAccessCodesQueryResult = NonNullable<Awaited<ReturnType<typeof classroomControllerGetClassroomAccessCodes>>>
export type ClassroomControllerGetClassroomAccessCodesQueryError = ErrorType<unknown>


export function useClassroomControllerGetClassroomAccessCodes<TData = Awaited<ReturnType<typeof classroomControllerGetClassroomAccessCodes>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetClassroomAccessCodes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomControllerGetClassroomAccessCodes>>,
          TError,
          Awaited<ReturnType<typeof classroomControllerGetClassroomAccessCodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomControllerGetClassroomAccessCodes<TData = Awaited<ReturnType<typeof classroomControllerGetClassroomAccessCodes>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetClassroomAccessCodes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomControllerGetClassroomAccessCodes>>,
          TError,
          Awaited<ReturnType<typeof classroomControllerGetClassroomAccessCodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomControllerGetClassroomAccessCodes<TData = Awaited<ReturnType<typeof classroomControllerGetClassroomAccessCodes>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetClassroomAccessCodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomControllerGetClassroomAccessCodes<TData = Awaited<ReturnType<typeof classroomControllerGetClassroomAccessCodes>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetClassroomAccessCodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomControllerGetClassroomAccessCodesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomControllerGetClassroomAccessCodes} query
 */
export const invalidateClassroomControllerGetClassroomAccessCodes = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomControllerGetClassroomAccessCodesQueryKey(id) }, options);

  return queryClient;
}

export const useSetClassroomControllerGetClassroomAccessCodesQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof classroomControllerGetClassroomAccessCodes>> | undefined | ((old: Awaited<ReturnType<typeof classroomControllerGetClassroomAccessCodes>> | undefined) => Awaited<ReturnType<typeof classroomControllerGetClassroomAccessCodes>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomControllerGetClassroomAccessCodes>>>({ exact: $exactMatch, queryKey: getClassroomControllerGetClassroomAccessCodesQueryKey(id) }, updater);
  };
}

export const useGetClassroomControllerGetClassroomAccessCodesQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomControllerGetClassroomAccessCodes>>>(getClassroomControllerGetClassroomAccessCodesQueryKey(id));
}



export const classroomControllerGetClassroomActivationCodes = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ClassroomControllerGetClassroomActivationCodes200Item[]>(
      {url: `/classrooms/${id}/activation-codes`, method: 'GET', signal
    },
      options);
    }




export const getClassroomControllerGetClassroomActivationCodesQueryKey = (id: string,) => {
    return [
    `/classrooms/${id}/activation-codes`
    ] as const;
    }


export const getClassroomControllerGetClassroomActivationCodesQueryOptions = <TData = Awaited<ReturnType<typeof classroomControllerGetClassroomActivationCodes>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetClassroomActivationCodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomControllerGetClassroomActivationCodesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomControllerGetClassroomActivationCodes>>> = ({ signal }) => classroomControllerGetClassroomActivationCodes(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetClassroomActivationCodes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomControllerGetClassroomActivationCodesQueryResult = NonNullable<Awaited<ReturnType<typeof classroomControllerGetClassroomActivationCodes>>>
export type ClassroomControllerGetClassroomActivationCodesQueryError = ErrorType<unknown>


export function useClassroomControllerGetClassroomActivationCodes<TData = Awaited<ReturnType<typeof classroomControllerGetClassroomActivationCodes>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetClassroomActivationCodes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomControllerGetClassroomActivationCodes>>,
          TError,
          Awaited<ReturnType<typeof classroomControllerGetClassroomActivationCodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomControllerGetClassroomActivationCodes<TData = Awaited<ReturnType<typeof classroomControllerGetClassroomActivationCodes>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetClassroomActivationCodes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomControllerGetClassroomActivationCodes>>,
          TError,
          Awaited<ReturnType<typeof classroomControllerGetClassroomActivationCodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomControllerGetClassroomActivationCodes<TData = Awaited<ReturnType<typeof classroomControllerGetClassroomActivationCodes>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetClassroomActivationCodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomControllerGetClassroomActivationCodes<TData = Awaited<ReturnType<typeof classroomControllerGetClassroomActivationCodes>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomControllerGetClassroomActivationCodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomControllerGetClassroomActivationCodesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomControllerGetClassroomActivationCodes} query
 */
export const invalidateClassroomControllerGetClassroomActivationCodes = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomControllerGetClassroomActivationCodesQueryKey(id) }, options);

  return queryClient;
}

export const useSetClassroomControllerGetClassroomActivationCodesQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof classroomControllerGetClassroomActivationCodes>> | undefined | ((old: Awaited<ReturnType<typeof classroomControllerGetClassroomActivationCodes>> | undefined) => Awaited<ReturnType<typeof classroomControllerGetClassroomActivationCodes>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomControllerGetClassroomActivationCodes>>>({ exact: $exactMatch, queryKey: getClassroomControllerGetClassroomActivationCodesQueryKey(id) }, updater);
  };
}

export const useGetClassroomControllerGetClassroomActivationCodesQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomControllerGetClassroomActivationCodes>>>(getClassroomControllerGetClassroomActivationCodesQueryKey(id));
}



export const classroomInstructorControllerGetLessonSummariesByClassroom = (
    classroomId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ClassroomInstructorControllerGetLessonSummariesByClassroom200>(
      {url: `/classroom-summary/${classroomId}/lesson-summaries`, method: 'GET', signal
    },
      options);
    }




export const getClassroomInstructorControllerGetLessonSummariesByClassroomQueryKey = (classroomId: string,) => {
    return [
    `/classroom-summary/${classroomId}/lesson-summaries`
    ] as const;
    }


export const getClassroomInstructorControllerGetLessonSummariesByClassroomQueryOptions = <TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesByClassroom>>, TError = ErrorType<unknown>>(classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesByClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomInstructorControllerGetLessonSummariesByClassroomQueryKey(classroomId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesByClassroom>>> = ({ signal }) => classroomInstructorControllerGetLessonSummariesByClassroom(classroomId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesByClassroom>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomInstructorControllerGetLessonSummariesByClassroomQueryResult = NonNullable<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesByClassroom>>>
export type ClassroomInstructorControllerGetLessonSummariesByClassroomQueryError = ErrorType<unknown>


export function useClassroomInstructorControllerGetLessonSummariesByClassroom<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesByClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesByClassroom>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesByClassroom>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesByClassroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetLessonSummariesByClassroom<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesByClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesByClassroom>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesByClassroom>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesByClassroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetLessonSummariesByClassroom<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesByClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesByClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomInstructorControllerGetLessonSummariesByClassroom<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesByClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesByClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomInstructorControllerGetLessonSummariesByClassroomQueryOptions(classroomId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomInstructorControllerGetLessonSummariesByClassroom} query
 */
export const invalidateClassroomInstructorControllerGetLessonSummariesByClassroom = async (
 queryClient: QueryClient, classroomId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomInstructorControllerGetLessonSummariesByClassroomQueryKey(classroomId) }, options);

  return queryClient;
}

export const useSetClassroomInstructorControllerGetLessonSummariesByClassroomQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,updater: Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesByClassroom>> | undefined | ((old: Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesByClassroom>> | undefined) => Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesByClassroom>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesByClassroom>>>({ exact: $exactMatch, queryKey: getClassroomInstructorControllerGetLessonSummariesByClassroomQueryKey(classroomId) }, updater);
  };
}

export const useGetClassroomInstructorControllerGetLessonSummariesByClassroomQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesByClassroom>>>(getClassroomInstructorControllerGetLessonSummariesByClassroomQueryKey(classroomId));
}



export const classroomInstructorControllerGetLessonSummariesWithScoreByClassroom = (
    classroomId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ClassroomInstructorControllerGetLessonSummariesWithScoreByClassroom200>(
      {url: `/classroom-summary/${classroomId}/lesson-summaries-with-score`, method: 'GET', signal
    },
      options);
    }




export const getClassroomInstructorControllerGetLessonSummariesWithScoreByClassroomQueryKey = (classroomId: string,) => {
    return [
    `/classroom-summary/${classroomId}/lesson-summaries-with-score`
    ] as const;
    }


export const getClassroomInstructorControllerGetLessonSummariesWithScoreByClassroomQueryOptions = <TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesWithScoreByClassroom>>, TError = ErrorType<unknown>>(classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesWithScoreByClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomInstructorControllerGetLessonSummariesWithScoreByClassroomQueryKey(classroomId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesWithScoreByClassroom>>> = ({ signal }) => classroomInstructorControllerGetLessonSummariesWithScoreByClassroom(classroomId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesWithScoreByClassroom>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomInstructorControllerGetLessonSummariesWithScoreByClassroomQueryResult = NonNullable<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesWithScoreByClassroom>>>
export type ClassroomInstructorControllerGetLessonSummariesWithScoreByClassroomQueryError = ErrorType<unknown>


export function useClassroomInstructorControllerGetLessonSummariesWithScoreByClassroom<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesWithScoreByClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesWithScoreByClassroom>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesWithScoreByClassroom>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesWithScoreByClassroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetLessonSummariesWithScoreByClassroom<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesWithScoreByClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesWithScoreByClassroom>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesWithScoreByClassroom>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesWithScoreByClassroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetLessonSummariesWithScoreByClassroom<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesWithScoreByClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesWithScoreByClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomInstructorControllerGetLessonSummariesWithScoreByClassroom<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesWithScoreByClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesWithScoreByClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomInstructorControllerGetLessonSummariesWithScoreByClassroomQueryOptions(classroomId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomInstructorControllerGetLessonSummariesWithScoreByClassroom} query
 */
export const invalidateClassroomInstructorControllerGetLessonSummariesWithScoreByClassroom = async (
 queryClient: QueryClient, classroomId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomInstructorControllerGetLessonSummariesWithScoreByClassroomQueryKey(classroomId) }, options);

  return queryClient;
}

export const useSetClassroomInstructorControllerGetLessonSummariesWithScoreByClassroomQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,updater: Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesWithScoreByClassroom>> | undefined | ((old: Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesWithScoreByClassroom>> | undefined) => Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesWithScoreByClassroom>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesWithScoreByClassroom>>>({ exact: $exactMatch, queryKey: getClassroomInstructorControllerGetLessonSummariesWithScoreByClassroomQueryKey(classroomId) }, updater);
  };
}

export const useGetClassroomInstructorControllerGetLessonSummariesWithScoreByClassroomQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonSummariesWithScoreByClassroom>>>(getClassroomInstructorControllerGetLessonSummariesWithScoreByClassroomQueryKey(classroomId));
}



export const classroomInstructorControllerGetActivitySummariesWithScoreByClassroom = (
    classroomId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ClassroomInstructorControllerGetActivitySummariesWithScoreByClassroom200>(
      {url: `/classroom-summary/${classroomId}/activity-summaries-with-score`, method: 'GET', signal
    },
      options);
    }




export const getClassroomInstructorControllerGetActivitySummariesWithScoreByClassroomQueryKey = (classroomId: string,) => {
    return [
    `/classroom-summary/${classroomId}/activity-summaries-with-score`
    ] as const;
    }


export const getClassroomInstructorControllerGetActivitySummariesWithScoreByClassroomQueryOptions = <TData = Awaited<ReturnType<typeof classroomInstructorControllerGetActivitySummariesWithScoreByClassroom>>, TError = ErrorType<unknown>>(classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetActivitySummariesWithScoreByClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomInstructorControllerGetActivitySummariesWithScoreByClassroomQueryKey(classroomId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomInstructorControllerGetActivitySummariesWithScoreByClassroom>>> = ({ signal }) => classroomInstructorControllerGetActivitySummariesWithScoreByClassroom(classroomId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetActivitySummariesWithScoreByClassroom>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomInstructorControllerGetActivitySummariesWithScoreByClassroomQueryResult = NonNullable<Awaited<ReturnType<typeof classroomInstructorControllerGetActivitySummariesWithScoreByClassroom>>>
export type ClassroomInstructorControllerGetActivitySummariesWithScoreByClassroomQueryError = ErrorType<unknown>


export function useClassroomInstructorControllerGetActivitySummariesWithScoreByClassroom<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetActivitySummariesWithScoreByClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetActivitySummariesWithScoreByClassroom>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetActivitySummariesWithScoreByClassroom>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetActivitySummariesWithScoreByClassroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetActivitySummariesWithScoreByClassroom<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetActivitySummariesWithScoreByClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetActivitySummariesWithScoreByClassroom>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetActivitySummariesWithScoreByClassroom>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetActivitySummariesWithScoreByClassroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetActivitySummariesWithScoreByClassroom<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetActivitySummariesWithScoreByClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetActivitySummariesWithScoreByClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomInstructorControllerGetActivitySummariesWithScoreByClassroom<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetActivitySummariesWithScoreByClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetActivitySummariesWithScoreByClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomInstructorControllerGetActivitySummariesWithScoreByClassroomQueryOptions(classroomId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomInstructorControllerGetActivitySummariesWithScoreByClassroom} query
 */
export const invalidateClassroomInstructorControllerGetActivitySummariesWithScoreByClassroom = async (
 queryClient: QueryClient, classroomId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomInstructorControllerGetActivitySummariesWithScoreByClassroomQueryKey(classroomId) }, options);

  return queryClient;
}

export const useSetClassroomInstructorControllerGetActivitySummariesWithScoreByClassroomQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,updater: Awaited<ReturnType<typeof classroomInstructorControllerGetActivitySummariesWithScoreByClassroom>> | undefined | ((old: Awaited<ReturnType<typeof classroomInstructorControllerGetActivitySummariesWithScoreByClassroom>> | undefined) => Awaited<ReturnType<typeof classroomInstructorControllerGetActivitySummariesWithScoreByClassroom>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomInstructorControllerGetActivitySummariesWithScoreByClassroom>>>({ exact: $exactMatch, queryKey: getClassroomInstructorControllerGetActivitySummariesWithScoreByClassroomQueryKey(classroomId) }, updater);
  };
}

export const useGetClassroomInstructorControllerGetActivitySummariesWithScoreByClassroomQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomInstructorControllerGetActivitySummariesWithScoreByClassroom>>>(getClassroomInstructorControllerGetActivitySummariesWithScoreByClassroomQueryKey(classroomId));
}



export const classroomInstructorControllerGetLessonInstancesByClassroom = (
    classroomId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ClassroomInstructorControllerGetLessonInstancesByClassroom200>(
      {url: `/classroom-summary/${classroomId}/lesson-instances`, method: 'GET', signal
    },
      options);
    }




export const getClassroomInstructorControllerGetLessonInstancesByClassroomQueryKey = (classroomId: string,) => {
    return [
    `/classroom-summary/${classroomId}/lesson-instances`
    ] as const;
    }


export const getClassroomInstructorControllerGetLessonInstancesByClassroomQueryOptions = <TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonInstancesByClassroom>>, TError = ErrorType<unknown>>(classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonInstancesByClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomInstructorControllerGetLessonInstancesByClassroomQueryKey(classroomId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonInstancesByClassroom>>> = ({ signal }) => classroomInstructorControllerGetLessonInstancesByClassroom(classroomId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonInstancesByClassroom>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomInstructorControllerGetLessonInstancesByClassroomQueryResult = NonNullable<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonInstancesByClassroom>>>
export type ClassroomInstructorControllerGetLessonInstancesByClassroomQueryError = ErrorType<unknown>


export function useClassroomInstructorControllerGetLessonInstancesByClassroom<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonInstancesByClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonInstancesByClassroom>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetLessonInstancesByClassroom>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetLessonInstancesByClassroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetLessonInstancesByClassroom<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonInstancesByClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonInstancesByClassroom>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetLessonInstancesByClassroom>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetLessonInstancesByClassroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetLessonInstancesByClassroom<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonInstancesByClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonInstancesByClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomInstructorControllerGetLessonInstancesByClassroom<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonInstancesByClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonInstancesByClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomInstructorControllerGetLessonInstancesByClassroomQueryOptions(classroomId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomInstructorControllerGetLessonInstancesByClassroom} query
 */
export const invalidateClassroomInstructorControllerGetLessonInstancesByClassroom = async (
 queryClient: QueryClient, classroomId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomInstructorControllerGetLessonInstancesByClassroomQueryKey(classroomId) }, options);

  return queryClient;
}

export const useSetClassroomInstructorControllerGetLessonInstancesByClassroomQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,updater: Awaited<ReturnType<typeof classroomInstructorControllerGetLessonInstancesByClassroom>> | undefined | ((old: Awaited<ReturnType<typeof classroomInstructorControllerGetLessonInstancesByClassroom>> | undefined) => Awaited<ReturnType<typeof classroomInstructorControllerGetLessonInstancesByClassroom>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonInstancesByClassroom>>>({ exact: $exactMatch, queryKey: getClassroomInstructorControllerGetLessonInstancesByClassroomQueryKey(classroomId) }, updater);
  };
}

export const useGetClassroomInstructorControllerGetLessonInstancesByClassroomQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonInstancesByClassroom>>>(getClassroomInstructorControllerGetLessonInstancesByClassroomQueryKey(classroomId));
}



export const classroomInstructorControllerGetMispronunciationsByClassroom = (
    classroomId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ClassroomInstructorControllerGetMispronunciationsByClassroom200Item[]>(
      {url: `/classroom-summary/${classroomId}/mispronunciations`, method: 'GET', signal
    },
      options);
    }




export const getClassroomInstructorControllerGetMispronunciationsByClassroomQueryKey = (classroomId: string,) => {
    return [
    `/classroom-summary/${classroomId}/mispronunciations`
    ] as const;
    }


export const getClassroomInstructorControllerGetMispronunciationsByClassroomQueryOptions = <TData = Awaited<ReturnType<typeof classroomInstructorControllerGetMispronunciationsByClassroom>>, TError = ErrorType<unknown>>(classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetMispronunciationsByClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomInstructorControllerGetMispronunciationsByClassroomQueryKey(classroomId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomInstructorControllerGetMispronunciationsByClassroom>>> = ({ signal }) => classroomInstructorControllerGetMispronunciationsByClassroom(classroomId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetMispronunciationsByClassroom>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomInstructorControllerGetMispronunciationsByClassroomQueryResult = NonNullable<Awaited<ReturnType<typeof classroomInstructorControllerGetMispronunciationsByClassroom>>>
export type ClassroomInstructorControllerGetMispronunciationsByClassroomQueryError = ErrorType<unknown>


export function useClassroomInstructorControllerGetMispronunciationsByClassroom<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetMispronunciationsByClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetMispronunciationsByClassroom>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetMispronunciationsByClassroom>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetMispronunciationsByClassroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetMispronunciationsByClassroom<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetMispronunciationsByClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetMispronunciationsByClassroom>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetMispronunciationsByClassroom>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetMispronunciationsByClassroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetMispronunciationsByClassroom<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetMispronunciationsByClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetMispronunciationsByClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomInstructorControllerGetMispronunciationsByClassroom<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetMispronunciationsByClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetMispronunciationsByClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomInstructorControllerGetMispronunciationsByClassroomQueryOptions(classroomId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomInstructorControllerGetMispronunciationsByClassroom} query
 */
export const invalidateClassroomInstructorControllerGetMispronunciationsByClassroom = async (
 queryClient: QueryClient, classroomId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomInstructorControllerGetMispronunciationsByClassroomQueryKey(classroomId) }, options);

  return queryClient;
}

export const useSetClassroomInstructorControllerGetMispronunciationsByClassroomQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,updater: Awaited<ReturnType<typeof classroomInstructorControllerGetMispronunciationsByClassroom>> | undefined | ((old: Awaited<ReturnType<typeof classroomInstructorControllerGetMispronunciationsByClassroom>> | undefined) => Awaited<ReturnType<typeof classroomInstructorControllerGetMispronunciationsByClassroom>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomInstructorControllerGetMispronunciationsByClassroom>>>({ exact: $exactMatch, queryKey: getClassroomInstructorControllerGetMispronunciationsByClassroomQueryKey(classroomId) }, updater);
  };
}

export const useGetClassroomInstructorControllerGetMispronunciationsByClassroomQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomInstructorControllerGetMispronunciationsByClassroom>>>(getClassroomInstructorControllerGetMispronunciationsByClassroomQueryKey(classroomId));
}



export const classroomInstructorControllerGetLatestLessonInstancesByStudent = (
    classroomId: string,
    studentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ClassroomInstructorControllerGetLatestLessonInstancesByStudent200>(
      {url: `/classroom-summary/${classroomId}/students/${studentId}/lesson-instances`, method: 'GET', signal
    },
      options);
    }




export const getClassroomInstructorControllerGetLatestLessonInstancesByStudentQueryKey = (classroomId: string,
    studentId: string,) => {
    return [
    `/classroom-summary/${classroomId}/students/${studentId}/lesson-instances`
    ] as const;
    }


export const getClassroomInstructorControllerGetLatestLessonInstancesByStudentQueryOptions = <TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLatestLessonInstancesByStudent>>, TError = ErrorType<unknown>>(classroomId: string,
    studentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLatestLessonInstancesByStudent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomInstructorControllerGetLatestLessonInstancesByStudentQueryKey(classroomId,studentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomInstructorControllerGetLatestLessonInstancesByStudent>>> = ({ signal }) => classroomInstructorControllerGetLatestLessonInstancesByStudent(classroomId,studentId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined && studentId !== null && studentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLatestLessonInstancesByStudent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomInstructorControllerGetLatestLessonInstancesByStudentQueryResult = NonNullable<Awaited<ReturnType<typeof classroomInstructorControllerGetLatestLessonInstancesByStudent>>>
export type ClassroomInstructorControllerGetLatestLessonInstancesByStudentQueryError = ErrorType<unknown>


export function useClassroomInstructorControllerGetLatestLessonInstancesByStudent<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLatestLessonInstancesByStudent>>, TError = ErrorType<unknown>>(
 classroomId: string,
    studentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLatestLessonInstancesByStudent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetLatestLessonInstancesByStudent>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetLatestLessonInstancesByStudent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetLatestLessonInstancesByStudent<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLatestLessonInstancesByStudent>>, TError = ErrorType<unknown>>(
 classroomId: string,
    studentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLatestLessonInstancesByStudent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetLatestLessonInstancesByStudent>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetLatestLessonInstancesByStudent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetLatestLessonInstancesByStudent<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLatestLessonInstancesByStudent>>, TError = ErrorType<unknown>>(
 classroomId: string,
    studentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLatestLessonInstancesByStudent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomInstructorControllerGetLatestLessonInstancesByStudent<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLatestLessonInstancesByStudent>>, TError = ErrorType<unknown>>(
 classroomId: string,
    studentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLatestLessonInstancesByStudent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomInstructorControllerGetLatestLessonInstancesByStudentQueryOptions(classroomId,studentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomInstructorControllerGetLatestLessonInstancesByStudent} query
 */
export const invalidateClassroomInstructorControllerGetLatestLessonInstancesByStudent = async (
 queryClient: QueryClient, classroomId: string,
    studentId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomInstructorControllerGetLatestLessonInstancesByStudentQueryKey(classroomId,studentId) }, options);

  return queryClient;
}

export const useSetClassroomInstructorControllerGetLatestLessonInstancesByStudentQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    studentId: string,updater: Awaited<ReturnType<typeof classroomInstructorControllerGetLatestLessonInstancesByStudent>> | undefined | ((old: Awaited<ReturnType<typeof classroomInstructorControllerGetLatestLessonInstancesByStudent>> | undefined) => Awaited<ReturnType<typeof classroomInstructorControllerGetLatestLessonInstancesByStudent>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomInstructorControllerGetLatestLessonInstancesByStudent>>>({ exact: $exactMatch, queryKey: getClassroomInstructorControllerGetLatestLessonInstancesByStudentQueryKey(classroomId,studentId) }, updater);
  };
}

export const useGetClassroomInstructorControllerGetLatestLessonInstancesByStudentQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    studentId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomInstructorControllerGetLatestLessonInstancesByStudent>>>(getClassroomInstructorControllerGetLatestLessonInstancesByStudentQueryKey(classroomId,studentId));
}



export const classroomInstructorControllerGetRecentCompletedLessonInstancesByStudent = (
    classroomId: string,
    studentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LessonInstance[]>(
      {url: `/classroom-summary/${classroomId}/students/${studentId}/recent-instances`, method: 'GET', signal
    },
      options);
    }




export const getClassroomInstructorControllerGetRecentCompletedLessonInstancesByStudentQueryKey = (classroomId: string,
    studentId: string,) => {
    return [
    `/classroom-summary/${classroomId}/students/${studentId}/recent-instances`
    ] as const;
    }


export const getClassroomInstructorControllerGetRecentCompletedLessonInstancesByStudentQueryOptions = <TData = Awaited<ReturnType<typeof classroomInstructorControllerGetRecentCompletedLessonInstancesByStudent>>, TError = ErrorType<unknown>>(classroomId: string,
    studentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetRecentCompletedLessonInstancesByStudent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomInstructorControllerGetRecentCompletedLessonInstancesByStudentQueryKey(classroomId,studentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomInstructorControllerGetRecentCompletedLessonInstancesByStudent>>> = ({ signal }) => classroomInstructorControllerGetRecentCompletedLessonInstancesByStudent(classroomId,studentId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined && studentId !== null && studentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetRecentCompletedLessonInstancesByStudent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomInstructorControllerGetRecentCompletedLessonInstancesByStudentQueryResult = NonNullable<Awaited<ReturnType<typeof classroomInstructorControllerGetRecentCompletedLessonInstancesByStudent>>>
export type ClassroomInstructorControllerGetRecentCompletedLessonInstancesByStudentQueryError = ErrorType<unknown>


export function useClassroomInstructorControllerGetRecentCompletedLessonInstancesByStudent<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetRecentCompletedLessonInstancesByStudent>>, TError = ErrorType<unknown>>(
 classroomId: string,
    studentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetRecentCompletedLessonInstancesByStudent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetRecentCompletedLessonInstancesByStudent>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetRecentCompletedLessonInstancesByStudent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetRecentCompletedLessonInstancesByStudent<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetRecentCompletedLessonInstancesByStudent>>, TError = ErrorType<unknown>>(
 classroomId: string,
    studentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetRecentCompletedLessonInstancesByStudent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetRecentCompletedLessonInstancesByStudent>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetRecentCompletedLessonInstancesByStudent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetRecentCompletedLessonInstancesByStudent<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetRecentCompletedLessonInstancesByStudent>>, TError = ErrorType<unknown>>(
 classroomId: string,
    studentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetRecentCompletedLessonInstancesByStudent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomInstructorControllerGetRecentCompletedLessonInstancesByStudent<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetRecentCompletedLessonInstancesByStudent>>, TError = ErrorType<unknown>>(
 classroomId: string,
    studentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetRecentCompletedLessonInstancesByStudent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomInstructorControllerGetRecentCompletedLessonInstancesByStudentQueryOptions(classroomId,studentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomInstructorControllerGetRecentCompletedLessonInstancesByStudent} query
 */
export const invalidateClassroomInstructorControllerGetRecentCompletedLessonInstancesByStudent = async (
 queryClient: QueryClient, classroomId: string,
    studentId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomInstructorControllerGetRecentCompletedLessonInstancesByStudentQueryKey(classroomId,studentId) }, options);

  return queryClient;
}

export const useSetClassroomInstructorControllerGetRecentCompletedLessonInstancesByStudentQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    studentId: string,updater: Awaited<ReturnType<typeof classroomInstructorControllerGetRecentCompletedLessonInstancesByStudent>> | undefined | ((old: Awaited<ReturnType<typeof classroomInstructorControllerGetRecentCompletedLessonInstancesByStudent>> | undefined) => Awaited<ReturnType<typeof classroomInstructorControllerGetRecentCompletedLessonInstancesByStudent>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomInstructorControllerGetRecentCompletedLessonInstancesByStudent>>>({ exact: $exactMatch, queryKey: getClassroomInstructorControllerGetRecentCompletedLessonInstancesByStudentQueryKey(classroomId,studentId) }, updater);
  };
}

export const useGetClassroomInstructorControllerGetRecentCompletedLessonInstancesByStudentQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    studentId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomInstructorControllerGetRecentCompletedLessonInstancesByStudent>>>(getClassroomInstructorControllerGetRecentCompletedLessonInstancesByStudentQueryKey(classroomId,studentId));
}



export const classroomInstructorControllerGetLessonsSummaryByClassroom = (
    classroomId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/classroom-summary/${classroomId}/lessons-summary`, method: 'GET', signal
    },
      options);
    }




export const getClassroomInstructorControllerGetLessonsSummaryByClassroomQueryKey = (classroomId: string,) => {
    return [
    `/classroom-summary/${classroomId}/lessons-summary`
    ] as const;
    }


export const getClassroomInstructorControllerGetLessonsSummaryByClassroomQueryOptions = <TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonsSummaryByClassroom>>, TError = ErrorType<unknown>>(classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonsSummaryByClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomInstructorControllerGetLessonsSummaryByClassroomQueryKey(classroomId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonsSummaryByClassroom>>> = ({ signal }) => classroomInstructorControllerGetLessonsSummaryByClassroom(classroomId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonsSummaryByClassroom>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomInstructorControllerGetLessonsSummaryByClassroomQueryResult = NonNullable<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonsSummaryByClassroom>>>
export type ClassroomInstructorControllerGetLessonsSummaryByClassroomQueryError = ErrorType<unknown>


export function useClassroomInstructorControllerGetLessonsSummaryByClassroom<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonsSummaryByClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonsSummaryByClassroom>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetLessonsSummaryByClassroom>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetLessonsSummaryByClassroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetLessonsSummaryByClassroom<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonsSummaryByClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonsSummaryByClassroom>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetLessonsSummaryByClassroom>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetLessonsSummaryByClassroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetLessonsSummaryByClassroom<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonsSummaryByClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonsSummaryByClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomInstructorControllerGetLessonsSummaryByClassroom<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonsSummaryByClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonsSummaryByClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomInstructorControllerGetLessonsSummaryByClassroomQueryOptions(classroomId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomInstructorControllerGetLessonsSummaryByClassroom} query
 */
export const invalidateClassroomInstructorControllerGetLessonsSummaryByClassroom = async (
 queryClient: QueryClient, classroomId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomInstructorControllerGetLessonsSummaryByClassroomQueryKey(classroomId) }, options);

  return queryClient;
}

export const useSetClassroomInstructorControllerGetLessonsSummaryByClassroomQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,updater: Awaited<ReturnType<typeof classroomInstructorControllerGetLessonsSummaryByClassroom>> | undefined | ((old: Awaited<ReturnType<typeof classroomInstructorControllerGetLessonsSummaryByClassroom>> | undefined) => Awaited<ReturnType<typeof classroomInstructorControllerGetLessonsSummaryByClassroom>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonsSummaryByClassroom>>>({ exact: $exactMatch, queryKey: getClassroomInstructorControllerGetLessonsSummaryByClassroomQueryKey(classroomId) }, updater);
  };
}

export const useGetClassroomInstructorControllerGetLessonsSummaryByClassroomQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonsSummaryByClassroom>>>(getClassroomInstructorControllerGetLessonsSummaryByClassroomQueryKey(classroomId));
}



export const classroomInstructorControllerGetAdminLessonInstancesByLesson = (
    classroomId: string,
    lessonId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/classroom-summary/${classroomId}/lessons/${lessonId}/lesson-instances`, method: 'GET', signal
    },
      options);
    }




export const getClassroomInstructorControllerGetAdminLessonInstancesByLessonQueryKey = (classroomId: string,
    lessonId: string,) => {
    return [
    `/classroom-summary/${classroomId}/lessons/${lessonId}/lesson-instances`
    ] as const;
    }


export const getClassroomInstructorControllerGetAdminLessonInstancesByLessonQueryOptions = <TData = Awaited<ReturnType<typeof classroomInstructorControllerGetAdminLessonInstancesByLesson>>, TError = ErrorType<unknown>>(classroomId: string,
    lessonId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetAdminLessonInstancesByLesson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomInstructorControllerGetAdminLessonInstancesByLessonQueryKey(classroomId,lessonId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomInstructorControllerGetAdminLessonInstancesByLesson>>> = ({ signal }) => classroomInstructorControllerGetAdminLessonInstancesByLesson(classroomId,lessonId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined && lessonId !== null && lessonId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetAdminLessonInstancesByLesson>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomInstructorControllerGetAdminLessonInstancesByLessonQueryResult = NonNullable<Awaited<ReturnType<typeof classroomInstructorControllerGetAdminLessonInstancesByLesson>>>
export type ClassroomInstructorControllerGetAdminLessonInstancesByLessonQueryError = ErrorType<unknown>


export function useClassroomInstructorControllerGetAdminLessonInstancesByLesson<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetAdminLessonInstancesByLesson>>, TError = ErrorType<unknown>>(
 classroomId: string,
    lessonId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetAdminLessonInstancesByLesson>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetAdminLessonInstancesByLesson>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetAdminLessonInstancesByLesson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetAdminLessonInstancesByLesson<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetAdminLessonInstancesByLesson>>, TError = ErrorType<unknown>>(
 classroomId: string,
    lessonId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetAdminLessonInstancesByLesson>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetAdminLessonInstancesByLesson>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetAdminLessonInstancesByLesson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetAdminLessonInstancesByLesson<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetAdminLessonInstancesByLesson>>, TError = ErrorType<unknown>>(
 classroomId: string,
    lessonId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetAdminLessonInstancesByLesson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomInstructorControllerGetAdminLessonInstancesByLesson<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetAdminLessonInstancesByLesson>>, TError = ErrorType<unknown>>(
 classroomId: string,
    lessonId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetAdminLessonInstancesByLesson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomInstructorControllerGetAdminLessonInstancesByLessonQueryOptions(classroomId,lessonId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomInstructorControllerGetAdminLessonInstancesByLesson} query
 */
export const invalidateClassroomInstructorControllerGetAdminLessonInstancesByLesson = async (
 queryClient: QueryClient, classroomId: string,
    lessonId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomInstructorControllerGetAdminLessonInstancesByLessonQueryKey(classroomId,lessonId) }, options);

  return queryClient;
}

export const useSetClassroomInstructorControllerGetAdminLessonInstancesByLessonQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    lessonId: string,updater: Awaited<ReturnType<typeof classroomInstructorControllerGetAdminLessonInstancesByLesson>> | undefined | ((old: Awaited<ReturnType<typeof classroomInstructorControllerGetAdminLessonInstancesByLesson>> | undefined) => Awaited<ReturnType<typeof classroomInstructorControllerGetAdminLessonInstancesByLesson>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomInstructorControllerGetAdminLessonInstancesByLesson>>>({ exact: $exactMatch, queryKey: getClassroomInstructorControllerGetAdminLessonInstancesByLessonQueryKey(classroomId,lessonId) }, updater);
  };
}

export const useGetClassroomInstructorControllerGetAdminLessonInstancesByLessonQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    lessonId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomInstructorControllerGetAdminLessonInstancesByLesson>>>(getClassroomInstructorControllerGetAdminLessonInstancesByLessonQueryKey(classroomId,lessonId));
}



export const classroomInstructorControllerGetStudentsCSV = (
    classroomId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<string>(
      {url: `/classroom-summary/${classroomId}/export-students-csv`, method: 'GET', signal
    },
      options);
    }




export const getClassroomInstructorControllerGetStudentsCSVQueryKey = (classroomId: string,) => {
    return [
    `/classroom-summary/${classroomId}/export-students-csv`
    ] as const;
    }


export const getClassroomInstructorControllerGetStudentsCSVQueryOptions = <TData = Awaited<ReturnType<typeof classroomInstructorControllerGetStudentsCSV>>, TError = ErrorType<unknown>>(classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetStudentsCSV>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomInstructorControllerGetStudentsCSVQueryKey(classroomId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomInstructorControllerGetStudentsCSV>>> = ({ signal }) => classroomInstructorControllerGetStudentsCSV(classroomId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetStudentsCSV>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomInstructorControllerGetStudentsCSVQueryResult = NonNullable<Awaited<ReturnType<typeof classroomInstructorControllerGetStudentsCSV>>>
export type ClassroomInstructorControllerGetStudentsCSVQueryError = ErrorType<unknown>


export function useClassroomInstructorControllerGetStudentsCSV<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetStudentsCSV>>, TError = ErrorType<unknown>>(
 classroomId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetStudentsCSV>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetStudentsCSV>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetStudentsCSV>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetStudentsCSV<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetStudentsCSV>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetStudentsCSV>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetStudentsCSV>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetStudentsCSV>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetStudentsCSV<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetStudentsCSV>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetStudentsCSV>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomInstructorControllerGetStudentsCSV<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetStudentsCSV>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetStudentsCSV>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomInstructorControllerGetStudentsCSVQueryOptions(classroomId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomInstructorControllerGetStudentsCSV} query
 */
export const invalidateClassroomInstructorControllerGetStudentsCSV = async (
 queryClient: QueryClient, classroomId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomInstructorControllerGetStudentsCSVQueryKey(classroomId) }, options);

  return queryClient;
}

export const useSetClassroomInstructorControllerGetStudentsCSVQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,updater: Awaited<ReturnType<typeof classroomInstructorControllerGetStudentsCSV>> | undefined | ((old: Awaited<ReturnType<typeof classroomInstructorControllerGetStudentsCSV>> | undefined) => Awaited<ReturnType<typeof classroomInstructorControllerGetStudentsCSV>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomInstructorControllerGetStudentsCSV>>>({ exact: $exactMatch, queryKey: getClassroomInstructorControllerGetStudentsCSVQueryKey(classroomId) }, updater);
  };
}

export const useGetClassroomInstructorControllerGetStudentsCSVQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomInstructorControllerGetStudentsCSV>>>(getClassroomInstructorControllerGetStudentsCSVQueryKey(classroomId));
}



export const classroomInstructorControllerGetProgressXlsx = (
    classroomId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/classroom-summary/${classroomId}/export-progress-xlsx`, method: 'GET', signal
    },
      options);
    }




export const getClassroomInstructorControllerGetProgressXlsxQueryKey = (classroomId: string,) => {
    return [
    `/classroom-summary/${classroomId}/export-progress-xlsx`
    ] as const;
    }


export const getClassroomInstructorControllerGetProgressXlsxQueryOptions = <TData = Awaited<ReturnType<typeof classroomInstructorControllerGetProgressXlsx>>, TError = ErrorType<unknown>>(classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressXlsx>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomInstructorControllerGetProgressXlsxQueryKey(classroomId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressXlsx>>> = ({ signal }) => classroomInstructorControllerGetProgressXlsx(classroomId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressXlsx>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomInstructorControllerGetProgressXlsxQueryResult = NonNullable<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressXlsx>>>
export type ClassroomInstructorControllerGetProgressXlsxQueryError = ErrorType<unknown>


export function useClassroomInstructorControllerGetProgressXlsx<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetProgressXlsx>>, TError = ErrorType<unknown>>(
 classroomId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressXlsx>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetProgressXlsx>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetProgressXlsx>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetProgressXlsx<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetProgressXlsx>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressXlsx>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetProgressXlsx>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetProgressXlsx>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetProgressXlsx<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetProgressXlsx>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressXlsx>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomInstructorControllerGetProgressXlsx<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetProgressXlsx>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressXlsx>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomInstructorControllerGetProgressXlsxQueryOptions(classroomId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomInstructorControllerGetProgressXlsx} query
 */
export const invalidateClassroomInstructorControllerGetProgressXlsx = async (
 queryClient: QueryClient, classroomId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomInstructorControllerGetProgressXlsxQueryKey(classroomId) }, options);

  return queryClient;
}

export const useSetClassroomInstructorControllerGetProgressXlsxQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,updater: Awaited<ReturnType<typeof classroomInstructorControllerGetProgressXlsx>> | undefined | ((old: Awaited<ReturnType<typeof classroomInstructorControllerGetProgressXlsx>> | undefined) => Awaited<ReturnType<typeof classroomInstructorControllerGetProgressXlsx>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressXlsx>>>({ exact: $exactMatch, queryKey: getClassroomInstructorControllerGetProgressXlsxQueryKey(classroomId) }, updater);
  };
}

export const useGetClassroomInstructorControllerGetProgressXlsxQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressXlsx>>>(getClassroomInstructorControllerGetProgressXlsxQueryKey(classroomId));
}



/**
 * @summary Export progress data organized by individual students
Returns Excel file with student progress sheet only
 */
export const classroomInstructorControllerGetProgressByStudentXlsx = (
    classroomId: string,
    params?: ClassroomInstructorControllerGetProgressByStudentXlsxParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/classroom-summary/${classroomId}/export-progress-xlsx/by-student`, method: 'GET',
        params, signal
    },
      options);
    }




export const getClassroomInstructorControllerGetProgressByStudentXlsxQueryKey = (classroomId: string,
    params?: ClassroomInstructorControllerGetProgressByStudentXlsxParams,) => {
    return [
    `/classroom-summary/${classroomId}/export-progress-xlsx/by-student`, ...(params ? [params] : [])
    ] as const;
    }


export const getClassroomInstructorControllerGetProgressByStudentXlsxQueryOptions = <TData = Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByStudentXlsx>>, TError = ErrorType<unknown>>(classroomId: string,
    params?: ClassroomInstructorControllerGetProgressByStudentXlsxParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByStudentXlsx>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomInstructorControllerGetProgressByStudentXlsxQueryKey(classroomId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByStudentXlsx>>> = ({ signal }) => classroomInstructorControllerGetProgressByStudentXlsx(classroomId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByStudentXlsx>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomInstructorControllerGetProgressByStudentXlsxQueryResult = NonNullable<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByStudentXlsx>>>
export type ClassroomInstructorControllerGetProgressByStudentXlsxQueryError = ErrorType<unknown>


export function useClassroomInstructorControllerGetProgressByStudentXlsx<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByStudentXlsx>>, TError = ErrorType<unknown>>(
 classroomId: string,
    params: undefined |  ClassroomInstructorControllerGetProgressByStudentXlsxParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByStudentXlsx>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByStudentXlsx>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByStudentXlsx>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetProgressByStudentXlsx<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByStudentXlsx>>, TError = ErrorType<unknown>>(
 classroomId: string,
    params?: ClassroomInstructorControllerGetProgressByStudentXlsxParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByStudentXlsx>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByStudentXlsx>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByStudentXlsx>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetProgressByStudentXlsx<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByStudentXlsx>>, TError = ErrorType<unknown>>(
 classroomId: string,
    params?: ClassroomInstructorControllerGetProgressByStudentXlsxParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByStudentXlsx>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export progress data organized by individual students
Returns Excel file with student progress sheet only
 */

export function useClassroomInstructorControllerGetProgressByStudentXlsx<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByStudentXlsx>>, TError = ErrorType<unknown>>(
 classroomId: string,
    params?: ClassroomInstructorControllerGetProgressByStudentXlsxParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByStudentXlsx>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomInstructorControllerGetProgressByStudentXlsxQueryOptions(classroomId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomInstructorControllerGetProgressByStudentXlsx} query
 */
export const invalidateClassroomInstructorControllerGetProgressByStudentXlsx = async (
 queryClient: QueryClient, classroomId: string,
    params?: ClassroomInstructorControllerGetProgressByStudentXlsxParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomInstructorControllerGetProgressByStudentXlsxQueryKey(classroomId,params) }, options);

  return queryClient;
}

/**
 * @summary Export progress data organized by individual students
Returns Excel file with student progress sheet only
 */
export const useSetClassroomInstructorControllerGetProgressByStudentXlsxQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    params: ClassroomInstructorControllerGetProgressByStudentXlsxParams | undefined,updater: Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByStudentXlsx>> | undefined | ((old: Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByStudentXlsx>> | undefined) => Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByStudentXlsx>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByStudentXlsx>>>({ exact: $exactMatch, queryKey: getClassroomInstructorControllerGetProgressByStudentXlsxQueryKey(classroomId,params) }, updater);
  };
}

/**
 * @summary Export progress data organized by individual students
Returns Excel file with student progress sheet only
 */
export const useGetClassroomInstructorControllerGetProgressByStudentXlsxQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    params?: ClassroomInstructorControllerGetProgressByStudentXlsxParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByStudentXlsx>>>(getClassroomInstructorControllerGetProgressByStudentXlsxQueryKey(classroomId,params));
}



/**
 * @summary Export progress data organized by activities
Returns Excel file with activity progress sheet only
 */
export const classroomInstructorControllerGetProgressByActivityXlsx = (
    classroomId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/classroom-summary/${classroomId}/export-progress-xlsx/by-activity`, method: 'GET', signal
    },
      options);
    }




export const getClassroomInstructorControllerGetProgressByActivityXlsxQueryKey = (classroomId: string,) => {
    return [
    `/classroom-summary/${classroomId}/export-progress-xlsx/by-activity`
    ] as const;
    }


export const getClassroomInstructorControllerGetProgressByActivityXlsxQueryOptions = <TData = Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByActivityXlsx>>, TError = ErrorType<unknown>>(classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByActivityXlsx>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomInstructorControllerGetProgressByActivityXlsxQueryKey(classroomId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByActivityXlsx>>> = ({ signal }) => classroomInstructorControllerGetProgressByActivityXlsx(classroomId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByActivityXlsx>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomInstructorControllerGetProgressByActivityXlsxQueryResult = NonNullable<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByActivityXlsx>>>
export type ClassroomInstructorControllerGetProgressByActivityXlsxQueryError = ErrorType<unknown>


export function useClassroomInstructorControllerGetProgressByActivityXlsx<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByActivityXlsx>>, TError = ErrorType<unknown>>(
 classroomId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByActivityXlsx>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByActivityXlsx>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByActivityXlsx>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetProgressByActivityXlsx<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByActivityXlsx>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByActivityXlsx>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByActivityXlsx>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByActivityXlsx>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetProgressByActivityXlsx<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByActivityXlsx>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByActivityXlsx>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export progress data organized by activities
Returns Excel file with activity progress sheet only
 */

export function useClassroomInstructorControllerGetProgressByActivityXlsx<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByActivityXlsx>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByActivityXlsx>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomInstructorControllerGetProgressByActivityXlsxQueryOptions(classroomId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomInstructorControllerGetProgressByActivityXlsx} query
 */
export const invalidateClassroomInstructorControllerGetProgressByActivityXlsx = async (
 queryClient: QueryClient, classroomId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomInstructorControllerGetProgressByActivityXlsxQueryKey(classroomId) }, options);

  return queryClient;
}

/**
 * @summary Export progress data organized by activities
Returns Excel file with activity progress sheet only
 */
export const useSetClassroomInstructorControllerGetProgressByActivityXlsxQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,updater: Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByActivityXlsx>> | undefined | ((old: Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByActivityXlsx>> | undefined) => Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByActivityXlsx>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByActivityXlsx>>>({ exact: $exactMatch, queryKey: getClassroomInstructorControllerGetProgressByActivityXlsxQueryKey(classroomId) }, updater);
  };
}

/**
 * @summary Export progress data organized by activities
Returns Excel file with activity progress sheet only
 */
export const useGetClassroomInstructorControllerGetProgressByActivityXlsxQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomInstructorControllerGetProgressByActivityXlsx>>>(getClassroomInstructorControllerGetProgressByActivityXlsxQueryKey(classroomId));
}



export const classroomInstructorControllerGetLessonInstanceVoiceResponseByStudent = (
    classroomId: string,
    lessonInstanceId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/classroom-summary/${classroomId}/lesson-instances/${lessonInstanceId}/voice-response`, method: 'POST', signal
    },
      options);
    }




export const getClassroomInstructorControllerGetLessonInstanceVoiceResponseByStudentMutationKey = () => ['classroomInstructorControllerGetLessonInstanceVoiceResponseByStudent'] as const;

export const getClassroomInstructorControllerGetLessonInstanceVoiceResponseByStudentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonInstanceVoiceResponseByStudent>>, TError,ClassroomInstructorControllerGetLessonInstanceVoiceResponseByStudentMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonInstanceVoiceResponseByStudent>>, TError,ClassroomInstructorControllerGetLessonInstanceVoiceResponseByStudentMutationVariables, TContext> => {

const mutationKey = getClassroomInstructorControllerGetLessonInstanceVoiceResponseByStudentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonInstanceVoiceResponseByStudent>>, ClassroomInstructorControllerGetLessonInstanceVoiceResponseByStudentMutationVariables> = (props) => {
          const {classroomId,lessonInstanceId} = props ?? {};

          return  classroomInstructorControllerGetLessonInstanceVoiceResponseByStudent(classroomId,lessonInstanceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClassroomInstructorControllerGetLessonInstanceVoiceResponseByStudentMutationResult = NonNullable<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonInstanceVoiceResponseByStudent>>>

    export type ClassroomInstructorControllerGetLessonInstanceVoiceResponseByStudentMutationError = ErrorType<unknown>
    export type ClassroomInstructorControllerGetLessonInstanceVoiceResponseByStudentMutationVariables = {classroomId: string;lessonInstanceId: string}

    export const useClassroomInstructorControllerGetLessonInstanceVoiceResponseByStudent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonInstanceVoiceResponseByStudent>>, TError,ClassroomInstructorControllerGetLessonInstanceVoiceResponseByStudentMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof classroomInstructorControllerGetLessonInstanceVoiceResponseByStudent>>,
        TError,
        ClassroomInstructorControllerGetLessonInstanceVoiceResponseByStudentMutationVariables,
        TContext
      > => {
      return useMutation(getClassroomInstructorControllerGetLessonInstanceVoiceResponseByStudentMutationOptions(options), queryClient);
    }

export const classroomInstructorControllerGetLessonStudentsProgress = (
    classroomId: string,
    lessonId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/classroom-summary/${classroomId}/lessons/${lessonId}/students-progress-summary`, method: 'GET', signal
    },
      options);
    }




export const getClassroomInstructorControllerGetLessonStudentsProgressQueryKey = (classroomId: string,
    lessonId: string,) => {
    return [
    `/classroom-summary/${classroomId}/lessons/${lessonId}/students-progress-summary`
    ] as const;
    }


export const getClassroomInstructorControllerGetLessonStudentsProgressQueryOptions = <TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonStudentsProgress>>, TError = ErrorType<unknown>>(classroomId: string,
    lessonId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonStudentsProgress>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomInstructorControllerGetLessonStudentsProgressQueryKey(classroomId,lessonId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonStudentsProgress>>> = ({ signal }) => classroomInstructorControllerGetLessonStudentsProgress(classroomId,lessonId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined && lessonId !== null && lessonId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonStudentsProgress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomInstructorControllerGetLessonStudentsProgressQueryResult = NonNullable<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonStudentsProgress>>>
export type ClassroomInstructorControllerGetLessonStudentsProgressQueryError = ErrorType<unknown>


export function useClassroomInstructorControllerGetLessonStudentsProgress<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonStudentsProgress>>, TError = ErrorType<unknown>>(
 classroomId: string,
    lessonId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonStudentsProgress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetLessonStudentsProgress>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetLessonStudentsProgress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetLessonStudentsProgress<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonStudentsProgress>>, TError = ErrorType<unknown>>(
 classroomId: string,
    lessonId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonStudentsProgress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetLessonStudentsProgress>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetLessonStudentsProgress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetLessonStudentsProgress<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonStudentsProgress>>, TError = ErrorType<unknown>>(
 classroomId: string,
    lessonId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonStudentsProgress>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomInstructorControllerGetLessonStudentsProgress<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonStudentsProgress>>, TError = ErrorType<unknown>>(
 classroomId: string,
    lessonId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonStudentsProgress>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomInstructorControllerGetLessonStudentsProgressQueryOptions(classroomId,lessonId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomInstructorControllerGetLessonStudentsProgress} query
 */
export const invalidateClassroomInstructorControllerGetLessonStudentsProgress = async (
 queryClient: QueryClient, classroomId: string,
    lessonId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomInstructorControllerGetLessonStudentsProgressQueryKey(classroomId,lessonId) }, options);

  return queryClient;
}

export const useSetClassroomInstructorControllerGetLessonStudentsProgressQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    lessonId: string,updater: Awaited<ReturnType<typeof classroomInstructorControllerGetLessonStudentsProgress>> | undefined | ((old: Awaited<ReturnType<typeof classroomInstructorControllerGetLessonStudentsProgress>> | undefined) => Awaited<ReturnType<typeof classroomInstructorControllerGetLessonStudentsProgress>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonStudentsProgress>>>({ exact: $exactMatch, queryKey: getClassroomInstructorControllerGetLessonStudentsProgressQueryKey(classroomId,lessonId) }, updater);
  };
}

export const useGetClassroomInstructorControllerGetLessonStudentsProgressQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    lessonId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonStudentsProgress>>>(getClassroomInstructorControllerGetLessonStudentsProgressQueryKey(classroomId,lessonId));
}



export const classroomInstructorControllerGetLessonAverageStudentsScore = (
    classroomId: string,
    lessonId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ClassroomInstructorControllerGetLessonAverageStudentsScore200>(
      {url: `/classroom-summary/${classroomId}/lessons/${lessonId}/average-students-score`, method: 'GET', signal
    },
      options);
    }




export const getClassroomInstructorControllerGetLessonAverageStudentsScoreQueryKey = (classroomId: string,
    lessonId: string,) => {
    return [
    `/classroom-summary/${classroomId}/lessons/${lessonId}/average-students-score`
    ] as const;
    }


export const getClassroomInstructorControllerGetLessonAverageStudentsScoreQueryOptions = <TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageStudentsScore>>, TError = ErrorType<unknown>>(classroomId: string,
    lessonId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageStudentsScore>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomInstructorControllerGetLessonAverageStudentsScoreQueryKey(classroomId,lessonId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageStudentsScore>>> = ({ signal }) => classroomInstructorControllerGetLessonAverageStudentsScore(classroomId,lessonId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined && lessonId !== null && lessonId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageStudentsScore>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomInstructorControllerGetLessonAverageStudentsScoreQueryResult = NonNullable<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageStudentsScore>>>
export type ClassroomInstructorControllerGetLessonAverageStudentsScoreQueryError = ErrorType<unknown>


export function useClassroomInstructorControllerGetLessonAverageStudentsScore<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageStudentsScore>>, TError = ErrorType<unknown>>(
 classroomId: string,
    lessonId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageStudentsScore>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageStudentsScore>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageStudentsScore>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetLessonAverageStudentsScore<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageStudentsScore>>, TError = ErrorType<unknown>>(
 classroomId: string,
    lessonId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageStudentsScore>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageStudentsScore>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageStudentsScore>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetLessonAverageStudentsScore<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageStudentsScore>>, TError = ErrorType<unknown>>(
 classroomId: string,
    lessonId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageStudentsScore>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomInstructorControllerGetLessonAverageStudentsScore<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageStudentsScore>>, TError = ErrorType<unknown>>(
 classroomId: string,
    lessonId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageStudentsScore>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomInstructorControllerGetLessonAverageStudentsScoreQueryOptions(classroomId,lessonId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomInstructorControllerGetLessonAverageStudentsScore} query
 */
export const invalidateClassroomInstructorControllerGetLessonAverageStudentsScore = async (
 queryClient: QueryClient, classroomId: string,
    lessonId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomInstructorControllerGetLessonAverageStudentsScoreQueryKey(classroomId,lessonId) }, options);

  return queryClient;
}

export const useSetClassroomInstructorControllerGetLessonAverageStudentsScoreQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    lessonId: string,updater: Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageStudentsScore>> | undefined | ((old: Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageStudentsScore>> | undefined) => Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageStudentsScore>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageStudentsScore>>>({ exact: $exactMatch, queryKey: getClassroomInstructorControllerGetLessonAverageStudentsScoreQueryKey(classroomId,lessonId) }, updater);
  };
}

export const useGetClassroomInstructorControllerGetLessonAverageStudentsScoreQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    lessonId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageStudentsScore>>>(getClassroomInstructorControllerGetLessonAverageStudentsScoreQueryKey(classroomId,lessonId));
}



export const classroomInstructorControllerGetLessonAverageScoreByActivity = (
    classroomId: string,
    lessonId: string,
    params: ClassroomInstructorControllerGetLessonAverageScoreByActivityParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ClassroomInstructorControllerGetLessonAverageScoreByActivity200Item[]>(
      {url: `/classroom-summary/${classroomId}/lessons/${lessonId}/average-score-by-activity`, method: 'GET',
        params, signal
    },
      options);
    }




export const getClassroomInstructorControllerGetLessonAverageScoreByActivityQueryKey = (classroomId: string,
    lessonId: string,
    params?: ClassroomInstructorControllerGetLessonAverageScoreByActivityParams,) => {
    return [
    `/classroom-summary/${classroomId}/lessons/${lessonId}/average-score-by-activity`, ...(params ? [params] : [])
    ] as const;
    }


export const getClassroomInstructorControllerGetLessonAverageScoreByActivityQueryOptions = <TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageScoreByActivity>>, TError = ErrorType<unknown>>(classroomId: string,
    lessonId: string,
    params: ClassroomInstructorControllerGetLessonAverageScoreByActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageScoreByActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomInstructorControllerGetLessonAverageScoreByActivityQueryKey(classroomId,lessonId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageScoreByActivity>>> = ({ signal }) => classroomInstructorControllerGetLessonAverageScoreByActivity(classroomId,lessonId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined && lessonId !== null && lessonId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageScoreByActivity>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomInstructorControllerGetLessonAverageScoreByActivityQueryResult = NonNullable<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageScoreByActivity>>>
export type ClassroomInstructorControllerGetLessonAverageScoreByActivityQueryError = ErrorType<unknown>


export function useClassroomInstructorControllerGetLessonAverageScoreByActivity<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageScoreByActivity>>, TError = ErrorType<unknown>>(
 classroomId: string,
    lessonId: string,
    params: ClassroomInstructorControllerGetLessonAverageScoreByActivityParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageScoreByActivity>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageScoreByActivity>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageScoreByActivity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetLessonAverageScoreByActivity<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageScoreByActivity>>, TError = ErrorType<unknown>>(
 classroomId: string,
    lessonId: string,
    params: ClassroomInstructorControllerGetLessonAverageScoreByActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageScoreByActivity>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageScoreByActivity>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageScoreByActivity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetLessonAverageScoreByActivity<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageScoreByActivity>>, TError = ErrorType<unknown>>(
 classroomId: string,
    lessonId: string,
    params: ClassroomInstructorControllerGetLessonAverageScoreByActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageScoreByActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomInstructorControllerGetLessonAverageScoreByActivity<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageScoreByActivity>>, TError = ErrorType<unknown>>(
 classroomId: string,
    lessonId: string,
    params: ClassroomInstructorControllerGetLessonAverageScoreByActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageScoreByActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomInstructorControllerGetLessonAverageScoreByActivityQueryOptions(classroomId,lessonId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomInstructorControllerGetLessonAverageScoreByActivity} query
 */
export const invalidateClassroomInstructorControllerGetLessonAverageScoreByActivity = async (
 queryClient: QueryClient, classroomId: string,
    lessonId: string,
    params: ClassroomInstructorControllerGetLessonAverageScoreByActivityParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomInstructorControllerGetLessonAverageScoreByActivityQueryKey(classroomId,lessonId,params) }, options);

  return queryClient;
}

export const useSetClassroomInstructorControllerGetLessonAverageScoreByActivityQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    lessonId: string,
    params: ClassroomInstructorControllerGetLessonAverageScoreByActivityParams | undefined,updater: Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageScoreByActivity>> | undefined | ((old: Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageScoreByActivity>> | undefined) => Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageScoreByActivity>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageScoreByActivity>>>({ exact: $exactMatch, queryKey: getClassroomInstructorControllerGetLessonAverageScoreByActivityQueryKey(classroomId,lessonId,params) }, updater);
  };
}

export const useGetClassroomInstructorControllerGetLessonAverageScoreByActivityQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    lessonId: string,
    params: ClassroomInstructorControllerGetLessonAverageScoreByActivityParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomInstructorControllerGetLessonAverageScoreByActivity>>>(getClassroomInstructorControllerGetLessonAverageScoreByActivityQueryKey(classroomId,lessonId,params));
}



export const classroomInstructorControllerGetSchoolLessonStatusTableData = (
    classroomId: string,
    lessonId: string,
    params?: ClassroomInstructorControllerGetSchoolLessonStatusTableDataParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SchoolStatusTableDataDto[]>(
      {url: `/classroom-summary/${classroomId}/lessons/${lessonId}/status-table-data`, method: 'GET',
        params, signal
    },
      options);
    }




export const getClassroomInstructorControllerGetSchoolLessonStatusTableDataQueryKey = (classroomId: string,
    lessonId: string,
    params?: ClassroomInstructorControllerGetSchoolLessonStatusTableDataParams,) => {
    return [
    `/classroom-summary/${classroomId}/lessons/${lessonId}/status-table-data`, ...(params ? [params] : [])
    ] as const;
    }


export const getClassroomInstructorControllerGetSchoolLessonStatusTableDataQueryOptions = <TData = Awaited<ReturnType<typeof classroomInstructorControllerGetSchoolLessonStatusTableData>>, TError = ErrorType<unknown>>(classroomId: string,
    lessonId: string,
    params?: ClassroomInstructorControllerGetSchoolLessonStatusTableDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetSchoolLessonStatusTableData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomInstructorControllerGetSchoolLessonStatusTableDataQueryKey(classroomId,lessonId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomInstructorControllerGetSchoolLessonStatusTableData>>> = ({ signal }) => classroomInstructorControllerGetSchoolLessonStatusTableData(classroomId,lessonId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined && lessonId !== null && lessonId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetSchoolLessonStatusTableData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomInstructorControllerGetSchoolLessonStatusTableDataQueryResult = NonNullable<Awaited<ReturnType<typeof classroomInstructorControllerGetSchoolLessonStatusTableData>>>
export type ClassroomInstructorControllerGetSchoolLessonStatusTableDataQueryError = ErrorType<unknown>


export function useClassroomInstructorControllerGetSchoolLessonStatusTableData<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetSchoolLessonStatusTableData>>, TError = ErrorType<unknown>>(
 classroomId: string,
    lessonId: string,
    params: undefined |  ClassroomInstructorControllerGetSchoolLessonStatusTableDataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetSchoolLessonStatusTableData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetSchoolLessonStatusTableData>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetSchoolLessonStatusTableData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetSchoolLessonStatusTableData<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetSchoolLessonStatusTableData>>, TError = ErrorType<unknown>>(
 classroomId: string,
    lessonId: string,
    params?: ClassroomInstructorControllerGetSchoolLessonStatusTableDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetSchoolLessonStatusTableData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomInstructorControllerGetSchoolLessonStatusTableData>>,
          TError,
          Awaited<ReturnType<typeof classroomInstructorControllerGetSchoolLessonStatusTableData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomInstructorControllerGetSchoolLessonStatusTableData<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetSchoolLessonStatusTableData>>, TError = ErrorType<unknown>>(
 classroomId: string,
    lessonId: string,
    params?: ClassroomInstructorControllerGetSchoolLessonStatusTableDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetSchoolLessonStatusTableData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomInstructorControllerGetSchoolLessonStatusTableData<TData = Awaited<ReturnType<typeof classroomInstructorControllerGetSchoolLessonStatusTableData>>, TError = ErrorType<unknown>>(
 classroomId: string,
    lessonId: string,
    params?: ClassroomInstructorControllerGetSchoolLessonStatusTableDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomInstructorControllerGetSchoolLessonStatusTableData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomInstructorControllerGetSchoolLessonStatusTableDataQueryOptions(classroomId,lessonId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomInstructorControllerGetSchoolLessonStatusTableData} query
 */
export const invalidateClassroomInstructorControllerGetSchoolLessonStatusTableData = async (
 queryClient: QueryClient, classroomId: string,
    lessonId: string,
    params?: ClassroomInstructorControllerGetSchoolLessonStatusTableDataParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomInstructorControllerGetSchoolLessonStatusTableDataQueryKey(classroomId,lessonId,params) }, options);

  return queryClient;
}

export const useSetClassroomInstructorControllerGetSchoolLessonStatusTableDataQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    lessonId: string,
    params: ClassroomInstructorControllerGetSchoolLessonStatusTableDataParams | undefined,updater: Awaited<ReturnType<typeof classroomInstructorControllerGetSchoolLessonStatusTableData>> | undefined | ((old: Awaited<ReturnType<typeof classroomInstructorControllerGetSchoolLessonStatusTableData>> | undefined) => Awaited<ReturnType<typeof classroomInstructorControllerGetSchoolLessonStatusTableData>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomInstructorControllerGetSchoolLessonStatusTableData>>>({ exact: $exactMatch, queryKey: getClassroomInstructorControllerGetSchoolLessonStatusTableDataQueryKey(classroomId,lessonId,params) }, updater);
  };
}

export const useGetClassroomInstructorControllerGetSchoolLessonStatusTableDataQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    lessonId: string,
    params?: ClassroomInstructorControllerGetSchoolLessonStatusTableDataParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomInstructorControllerGetSchoolLessonStatusTableData>>>(getClassroomInstructorControllerGetSchoolLessonStatusTableDataQueryKey(classroomId,lessonId,params));
}



export const classroomClassroomLessonControllerFindByClassroomId = (
    classroomId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/classrooms/${classroomId}/classroom-lessons`, method: 'GET', signal
    },
      options);
    }




export const getClassroomClassroomLessonControllerFindByClassroomIdQueryKey = (classroomId: string,) => {
    return [
    `/classrooms/${classroomId}/classroom-lessons`
    ] as const;
    }


export const getClassroomClassroomLessonControllerFindByClassroomIdQueryOptions = <TData = Awaited<ReturnType<typeof classroomClassroomLessonControllerFindByClassroomId>>, TError = ErrorType<unknown>>(classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomClassroomLessonControllerFindByClassroomId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomClassroomLessonControllerFindByClassroomIdQueryKey(classroomId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomClassroomLessonControllerFindByClassroomId>>> = ({ signal }) => classroomClassroomLessonControllerFindByClassroomId(classroomId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomClassroomLessonControllerFindByClassroomId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomClassroomLessonControllerFindByClassroomIdQueryResult = NonNullable<Awaited<ReturnType<typeof classroomClassroomLessonControllerFindByClassroomId>>>
export type ClassroomClassroomLessonControllerFindByClassroomIdQueryError = ErrorType<unknown>


export function useClassroomClassroomLessonControllerFindByClassroomId<TData = Awaited<ReturnType<typeof classroomClassroomLessonControllerFindByClassroomId>>, TError = ErrorType<unknown>>(
 classroomId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomClassroomLessonControllerFindByClassroomId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomClassroomLessonControllerFindByClassroomId>>,
          TError,
          Awaited<ReturnType<typeof classroomClassroomLessonControllerFindByClassroomId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomClassroomLessonControllerFindByClassroomId<TData = Awaited<ReturnType<typeof classroomClassroomLessonControllerFindByClassroomId>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomClassroomLessonControllerFindByClassroomId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomClassroomLessonControllerFindByClassroomId>>,
          TError,
          Awaited<ReturnType<typeof classroomClassroomLessonControllerFindByClassroomId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomClassroomLessonControllerFindByClassroomId<TData = Awaited<ReturnType<typeof classroomClassroomLessonControllerFindByClassroomId>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomClassroomLessonControllerFindByClassroomId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomClassroomLessonControllerFindByClassroomId<TData = Awaited<ReturnType<typeof classroomClassroomLessonControllerFindByClassroomId>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomClassroomLessonControllerFindByClassroomId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomClassroomLessonControllerFindByClassroomIdQueryOptions(classroomId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomClassroomLessonControllerFindByClassroomId} query
 */
export const invalidateClassroomClassroomLessonControllerFindByClassroomId = async (
 queryClient: QueryClient, classroomId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomClassroomLessonControllerFindByClassroomIdQueryKey(classroomId) }, options);

  return queryClient;
}

export const useSetClassroomClassroomLessonControllerFindByClassroomIdQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,updater: Awaited<ReturnType<typeof classroomClassroomLessonControllerFindByClassroomId>> | undefined | ((old: Awaited<ReturnType<typeof classroomClassroomLessonControllerFindByClassroomId>> | undefined) => Awaited<ReturnType<typeof classroomClassroomLessonControllerFindByClassroomId>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomClassroomLessonControllerFindByClassroomId>>>({ exact: $exactMatch, queryKey: getClassroomClassroomLessonControllerFindByClassroomIdQueryKey(classroomId) }, updater);
  };
}

export const useGetClassroomClassroomLessonControllerFindByClassroomIdQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomClassroomLessonControllerFindByClassroomId>>>(getClassroomClassroomLessonControllerFindByClassroomIdQueryKey(classroomId));
}



export const classroomSemesterControllerGetClassroomReportBySemester = (
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/classroom-semester/${schoolId}/report`, method: 'GET', signal
    },
      options);
    }




export const getClassroomSemesterControllerGetClassroomReportBySemesterQueryKey = (schoolId: string,) => {
    return [
    `/classroom-semester/${schoolId}/report`
    ] as const;
    }


export const getClassroomSemesterControllerGetClassroomReportBySemesterQueryOptions = <TData = Awaited<ReturnType<typeof classroomSemesterControllerGetClassroomReportBySemester>>, TError = ErrorType<unknown>>(schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomSemesterControllerGetClassroomReportBySemester>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomSemesterControllerGetClassroomReportBySemesterQueryKey(schoolId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomSemesterControllerGetClassroomReportBySemester>>> = ({ signal }) => classroomSemesterControllerGetClassroomReportBySemester(schoolId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: schoolId !== null && schoolId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomSemesterControllerGetClassroomReportBySemester>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomSemesterControllerGetClassroomReportBySemesterQueryResult = NonNullable<Awaited<ReturnType<typeof classroomSemesterControllerGetClassroomReportBySemester>>>
export type ClassroomSemesterControllerGetClassroomReportBySemesterQueryError = ErrorType<unknown>


export function useClassroomSemesterControllerGetClassroomReportBySemester<TData = Awaited<ReturnType<typeof classroomSemesterControllerGetClassroomReportBySemester>>, TError = ErrorType<unknown>>(
 schoolId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomSemesterControllerGetClassroomReportBySemester>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomSemesterControllerGetClassroomReportBySemester>>,
          TError,
          Awaited<ReturnType<typeof classroomSemesterControllerGetClassroomReportBySemester>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomSemesterControllerGetClassroomReportBySemester<TData = Awaited<ReturnType<typeof classroomSemesterControllerGetClassroomReportBySemester>>, TError = ErrorType<unknown>>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomSemesterControllerGetClassroomReportBySemester>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomSemesterControllerGetClassroomReportBySemester>>,
          TError,
          Awaited<ReturnType<typeof classroomSemesterControllerGetClassroomReportBySemester>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomSemesterControllerGetClassroomReportBySemester<TData = Awaited<ReturnType<typeof classroomSemesterControllerGetClassroomReportBySemester>>, TError = ErrorType<unknown>>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomSemesterControllerGetClassroomReportBySemester>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomSemesterControllerGetClassroomReportBySemester<TData = Awaited<ReturnType<typeof classroomSemesterControllerGetClassroomReportBySemester>>, TError = ErrorType<unknown>>(
 schoolId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomSemesterControllerGetClassroomReportBySemester>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomSemesterControllerGetClassroomReportBySemesterQueryOptions(schoolId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomSemesterControllerGetClassroomReportBySemester} query
 */
export const invalidateClassroomSemesterControllerGetClassroomReportBySemester = async (
 queryClient: QueryClient, schoolId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomSemesterControllerGetClassroomReportBySemesterQueryKey(schoolId) }, options);

  return queryClient;
}

export const useSetClassroomSemesterControllerGetClassroomReportBySemesterQueryData = () => {
  const queryClient = useQueryClient();
  return (schoolId: string,updater: Awaited<ReturnType<typeof classroomSemesterControllerGetClassroomReportBySemester>> | undefined | ((old: Awaited<ReturnType<typeof classroomSemesterControllerGetClassroomReportBySemester>> | undefined) => Awaited<ReturnType<typeof classroomSemesterControllerGetClassroomReportBySemester>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomSemesterControllerGetClassroomReportBySemester>>>({ exact: $exactMatch, queryKey: getClassroomSemesterControllerGetClassroomReportBySemesterQueryKey(schoolId) }, updater);
  };
}

export const useGetClassroomSemesterControllerGetClassroomReportBySemesterQueryData = () => {
  const queryClient = useQueryClient();
  return (schoolId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomSemesterControllerGetClassroomReportBySemester>>>(getClassroomSemesterControllerGetClassroomReportBySemesterQueryKey(schoolId));
}



export const edsyPointControllerGetAllUserPoint = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EdsyPointControllerGetAllUserPoint200Item[]>(
      {url: `/edsy-point/all-user-point`, method: 'GET', signal
    },
      options);
    }




export const getEdsyPointControllerGetAllUserPointQueryKey = () => {
    return [
    `/edsy-point/all-user-point`
    ] as const;
    }


export const getEdsyPointControllerGetAllUserPointQueryOptions = <TData = Awaited<ReturnType<typeof edsyPointControllerGetAllUserPoint>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetAllUserPoint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEdsyPointControllerGetAllUserPointQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof edsyPointControllerGetAllUserPoint>>> = ({ signal }) => edsyPointControllerGetAllUserPoint(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetAllUserPoint>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EdsyPointControllerGetAllUserPointQueryResult = NonNullable<Awaited<ReturnType<typeof edsyPointControllerGetAllUserPoint>>>
export type EdsyPointControllerGetAllUserPointQueryError = ErrorType<unknown>


export function useEdsyPointControllerGetAllUserPoint<TData = Awaited<ReturnType<typeof edsyPointControllerGetAllUserPoint>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetAllUserPoint>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof edsyPointControllerGetAllUserPoint>>,
          TError,
          Awaited<ReturnType<typeof edsyPointControllerGetAllUserPoint>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEdsyPointControllerGetAllUserPoint<TData = Awaited<ReturnType<typeof edsyPointControllerGetAllUserPoint>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetAllUserPoint>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof edsyPointControllerGetAllUserPoint>>,
          TError,
          Awaited<ReturnType<typeof edsyPointControllerGetAllUserPoint>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEdsyPointControllerGetAllUserPoint<TData = Awaited<ReturnType<typeof edsyPointControllerGetAllUserPoint>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetAllUserPoint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useEdsyPointControllerGetAllUserPoint<TData = Awaited<ReturnType<typeof edsyPointControllerGetAllUserPoint>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetAllUserPoint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEdsyPointControllerGetAllUserPointQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useEdsyPointControllerGetAllUserPoint} query
 */
export const invalidateEdsyPointControllerGetAllUserPoint = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getEdsyPointControllerGetAllUserPointQueryKey() }, options);

  return queryClient;
}

export const useSetEdsyPointControllerGetAllUserPointQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof edsyPointControllerGetAllUserPoint>> | undefined | ((old: Awaited<ReturnType<typeof edsyPointControllerGetAllUserPoint>> | undefined) => Awaited<ReturnType<typeof edsyPointControllerGetAllUserPoint>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof edsyPointControllerGetAllUserPoint>>>({ exact: $exactMatch, queryKey: getEdsyPointControllerGetAllUserPointQueryKey() }, updater);
  };
}

export const useGetEdsyPointControllerGetAllUserPointQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof edsyPointControllerGetAllUserPoint>>>(getEdsyPointControllerGetAllUserPointQueryKey());
}



export const edsyPointControllerGetAllUserAndClassroomPoint = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EdsyPointControllerGetAllUserAndClassroomPoint200Item[]>(
      {url: `/edsy-point/all-user-and-classroom-point`, method: 'GET', signal
    },
      options);
    }




export const getEdsyPointControllerGetAllUserAndClassroomPointQueryKey = () => {
    return [
    `/edsy-point/all-user-and-classroom-point`
    ] as const;
    }


export const getEdsyPointControllerGetAllUserAndClassroomPointQueryOptions = <TData = Awaited<ReturnType<typeof edsyPointControllerGetAllUserAndClassroomPoint>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetAllUserAndClassroomPoint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEdsyPointControllerGetAllUserAndClassroomPointQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof edsyPointControllerGetAllUserAndClassroomPoint>>> = ({ signal }) => edsyPointControllerGetAllUserAndClassroomPoint(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetAllUserAndClassroomPoint>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EdsyPointControllerGetAllUserAndClassroomPointQueryResult = NonNullable<Awaited<ReturnType<typeof edsyPointControllerGetAllUserAndClassroomPoint>>>
export type EdsyPointControllerGetAllUserAndClassroomPointQueryError = ErrorType<unknown>


export function useEdsyPointControllerGetAllUserAndClassroomPoint<TData = Awaited<ReturnType<typeof edsyPointControllerGetAllUserAndClassroomPoint>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetAllUserAndClassroomPoint>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof edsyPointControllerGetAllUserAndClassroomPoint>>,
          TError,
          Awaited<ReturnType<typeof edsyPointControllerGetAllUserAndClassroomPoint>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEdsyPointControllerGetAllUserAndClassroomPoint<TData = Awaited<ReturnType<typeof edsyPointControllerGetAllUserAndClassroomPoint>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetAllUserAndClassroomPoint>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof edsyPointControllerGetAllUserAndClassroomPoint>>,
          TError,
          Awaited<ReturnType<typeof edsyPointControllerGetAllUserAndClassroomPoint>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEdsyPointControllerGetAllUserAndClassroomPoint<TData = Awaited<ReturnType<typeof edsyPointControllerGetAllUserAndClassroomPoint>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetAllUserAndClassroomPoint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useEdsyPointControllerGetAllUserAndClassroomPoint<TData = Awaited<ReturnType<typeof edsyPointControllerGetAllUserAndClassroomPoint>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetAllUserAndClassroomPoint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEdsyPointControllerGetAllUserAndClassroomPointQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useEdsyPointControllerGetAllUserAndClassroomPoint} query
 */
export const invalidateEdsyPointControllerGetAllUserAndClassroomPoint = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getEdsyPointControllerGetAllUserAndClassroomPointQueryKey() }, options);

  return queryClient;
}

export const useSetEdsyPointControllerGetAllUserAndClassroomPointQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof edsyPointControllerGetAllUserAndClassroomPoint>> | undefined | ((old: Awaited<ReturnType<typeof edsyPointControllerGetAllUserAndClassroomPoint>> | undefined) => Awaited<ReturnType<typeof edsyPointControllerGetAllUserAndClassroomPoint>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof edsyPointControllerGetAllUserAndClassroomPoint>>>({ exact: $exactMatch, queryKey: getEdsyPointControllerGetAllUserAndClassroomPointQueryKey() }, updater);
  };
}

export const useGetEdsyPointControllerGetAllUserAndClassroomPointQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof edsyPointControllerGetAllUserAndClassroomPoint>>>(getEdsyPointControllerGetAllUserAndClassroomPointQueryKey());
}



/**
 * @summary Get user point by user ID
 */
export const edsyPointControllerGetUserPoint = (
    userId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EdsyPointResponseDto>(
      {url: `/edsy-point/user-point/${userId}`, method: 'GET', signal
    },
      options);
    }




export const getEdsyPointControllerGetUserPointQueryKey = (userId: string,) => {
    return [
    `/edsy-point/user-point/${userId}`
    ] as const;
    }


export const getEdsyPointControllerGetUserPointQueryOptions = <TData = Awaited<ReturnType<typeof edsyPointControllerGetUserPoint>>, TError = ErrorType<unknown>>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetUserPoint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEdsyPointControllerGetUserPointQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof edsyPointControllerGetUserPoint>>> = ({ signal }) => edsyPointControllerGetUserPoint(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetUserPoint>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EdsyPointControllerGetUserPointQueryResult = NonNullable<Awaited<ReturnType<typeof edsyPointControllerGetUserPoint>>>
export type EdsyPointControllerGetUserPointQueryError = ErrorType<unknown>


export function useEdsyPointControllerGetUserPoint<TData = Awaited<ReturnType<typeof edsyPointControllerGetUserPoint>>, TError = ErrorType<unknown>>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetUserPoint>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof edsyPointControllerGetUserPoint>>,
          TError,
          Awaited<ReturnType<typeof edsyPointControllerGetUserPoint>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEdsyPointControllerGetUserPoint<TData = Awaited<ReturnType<typeof edsyPointControllerGetUserPoint>>, TError = ErrorType<unknown>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetUserPoint>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof edsyPointControllerGetUserPoint>>,
          TError,
          Awaited<ReturnType<typeof edsyPointControllerGetUserPoint>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEdsyPointControllerGetUserPoint<TData = Awaited<ReturnType<typeof edsyPointControllerGetUserPoint>>, TError = ErrorType<unknown>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetUserPoint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user point by user ID
 */

export function useEdsyPointControllerGetUserPoint<TData = Awaited<ReturnType<typeof edsyPointControllerGetUserPoint>>, TError = ErrorType<unknown>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetUserPoint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEdsyPointControllerGetUserPointQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useEdsyPointControllerGetUserPoint} query
 */
export const invalidateEdsyPointControllerGetUserPoint = async (
 queryClient: QueryClient, userId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getEdsyPointControllerGetUserPointQueryKey(userId) }, options);

  return queryClient;
}

/**
 * @summary Get user point by user ID
 */
export const useSetEdsyPointControllerGetUserPointQueryData = () => {
  const queryClient = useQueryClient();
  return (userId: string,updater: Awaited<ReturnType<typeof edsyPointControllerGetUserPoint>> | undefined | ((old: Awaited<ReturnType<typeof edsyPointControllerGetUserPoint>> | undefined) => Awaited<ReturnType<typeof edsyPointControllerGetUserPoint>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof edsyPointControllerGetUserPoint>>>({ exact: $exactMatch, queryKey: getEdsyPointControllerGetUserPointQueryKey(userId) }, updater);
  };
}

/**
 * @summary Get user point by user ID
 */
export const useGetEdsyPointControllerGetUserPointQueryData = () => {
  const queryClient = useQueryClient();
  return (userId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof edsyPointControllerGetUserPoint>>>(getEdsyPointControllerGetUserPointQueryKey(userId));
}



export const edsyPointControllerGetUserAndClassroomPoint = (
    classroomId: string,
    userId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EdsyPointControllerGetUserAndClassroomPoint200>(
      {url: `/edsy-point/user-and-classroom-point/classrooms/${classroomId}/users/${userId}`, method: 'GET', signal
    },
      options);
    }




export const getEdsyPointControllerGetUserAndClassroomPointQueryKey = (classroomId: string,
    userId: string,) => {
    return [
    `/edsy-point/user-and-classroom-point/classrooms/${classroomId}/users/${userId}`
    ] as const;
    }


export const getEdsyPointControllerGetUserAndClassroomPointQueryOptions = <TData = Awaited<ReturnType<typeof edsyPointControllerGetUserAndClassroomPoint>>, TError = ErrorType<unknown>>(classroomId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetUserAndClassroomPoint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEdsyPointControllerGetUserAndClassroomPointQueryKey(classroomId,userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof edsyPointControllerGetUserAndClassroomPoint>>> = ({ signal }) => edsyPointControllerGetUserAndClassroomPoint(classroomId,userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined && userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetUserAndClassroomPoint>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EdsyPointControllerGetUserAndClassroomPointQueryResult = NonNullable<Awaited<ReturnType<typeof edsyPointControllerGetUserAndClassroomPoint>>>
export type EdsyPointControllerGetUserAndClassroomPointQueryError = ErrorType<unknown>


export function useEdsyPointControllerGetUserAndClassroomPoint<TData = Awaited<ReturnType<typeof edsyPointControllerGetUserAndClassroomPoint>>, TError = ErrorType<unknown>>(
 classroomId: string,
    userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetUserAndClassroomPoint>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof edsyPointControllerGetUserAndClassroomPoint>>,
          TError,
          Awaited<ReturnType<typeof edsyPointControllerGetUserAndClassroomPoint>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEdsyPointControllerGetUserAndClassroomPoint<TData = Awaited<ReturnType<typeof edsyPointControllerGetUserAndClassroomPoint>>, TError = ErrorType<unknown>>(
 classroomId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetUserAndClassroomPoint>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof edsyPointControllerGetUserAndClassroomPoint>>,
          TError,
          Awaited<ReturnType<typeof edsyPointControllerGetUserAndClassroomPoint>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEdsyPointControllerGetUserAndClassroomPoint<TData = Awaited<ReturnType<typeof edsyPointControllerGetUserAndClassroomPoint>>, TError = ErrorType<unknown>>(
 classroomId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetUserAndClassroomPoint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useEdsyPointControllerGetUserAndClassroomPoint<TData = Awaited<ReturnType<typeof edsyPointControllerGetUserAndClassroomPoint>>, TError = ErrorType<unknown>>(
 classroomId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetUserAndClassroomPoint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEdsyPointControllerGetUserAndClassroomPointQueryOptions(classroomId,userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useEdsyPointControllerGetUserAndClassroomPoint} query
 */
export const invalidateEdsyPointControllerGetUserAndClassroomPoint = async (
 queryClient: QueryClient, classroomId: string,
    userId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getEdsyPointControllerGetUserAndClassroomPointQueryKey(classroomId,userId) }, options);

  return queryClient;
}

export const useSetEdsyPointControllerGetUserAndClassroomPointQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    userId: string,updater: Awaited<ReturnType<typeof edsyPointControllerGetUserAndClassroomPoint>> | undefined | ((old: Awaited<ReturnType<typeof edsyPointControllerGetUserAndClassroomPoint>> | undefined) => Awaited<ReturnType<typeof edsyPointControllerGetUserAndClassroomPoint>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof edsyPointControllerGetUserAndClassroomPoint>>>({ exact: $exactMatch, queryKey: getEdsyPointControllerGetUserAndClassroomPointQueryKey(classroomId,userId) }, updater);
  };
}

export const useGetEdsyPointControllerGetUserAndClassroomPointQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    userId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof edsyPointControllerGetUserAndClassroomPoint>>>(getEdsyPointControllerGetUserAndClassroomPointQueryKey(classroomId,userId));
}



export const edsyPointControllerGetLeaderboard = (
    classroomId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LeaderboardDto[]>(
      {url: `/edsy-point/leaderboard/${classroomId}`, method: 'GET', signal
    },
      options);
    }




export const getEdsyPointControllerGetLeaderboardQueryKey = (classroomId: string,) => {
    return [
    `/edsy-point/leaderboard/${classroomId}`
    ] as const;
    }


export const getEdsyPointControllerGetLeaderboardQueryOptions = <TData = Awaited<ReturnType<typeof edsyPointControllerGetLeaderboard>>, TError = ErrorType<unknown>>(classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetLeaderboard>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEdsyPointControllerGetLeaderboardQueryKey(classroomId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof edsyPointControllerGetLeaderboard>>> = ({ signal }) => edsyPointControllerGetLeaderboard(classroomId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetLeaderboard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EdsyPointControllerGetLeaderboardQueryResult = NonNullable<Awaited<ReturnType<typeof edsyPointControllerGetLeaderboard>>>
export type EdsyPointControllerGetLeaderboardQueryError = ErrorType<unknown>


export function useEdsyPointControllerGetLeaderboard<TData = Awaited<ReturnType<typeof edsyPointControllerGetLeaderboard>>, TError = ErrorType<unknown>>(
 classroomId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetLeaderboard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof edsyPointControllerGetLeaderboard>>,
          TError,
          Awaited<ReturnType<typeof edsyPointControllerGetLeaderboard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEdsyPointControllerGetLeaderboard<TData = Awaited<ReturnType<typeof edsyPointControllerGetLeaderboard>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetLeaderboard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof edsyPointControllerGetLeaderboard>>,
          TError,
          Awaited<ReturnType<typeof edsyPointControllerGetLeaderboard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEdsyPointControllerGetLeaderboard<TData = Awaited<ReturnType<typeof edsyPointControllerGetLeaderboard>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetLeaderboard>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useEdsyPointControllerGetLeaderboard<TData = Awaited<ReturnType<typeof edsyPointControllerGetLeaderboard>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetLeaderboard>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEdsyPointControllerGetLeaderboardQueryOptions(classroomId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useEdsyPointControllerGetLeaderboard} query
 */
export const invalidateEdsyPointControllerGetLeaderboard = async (
 queryClient: QueryClient, classroomId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getEdsyPointControllerGetLeaderboardQueryKey(classroomId) }, options);

  return queryClient;
}

export const useSetEdsyPointControllerGetLeaderboardQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,updater: Awaited<ReturnType<typeof edsyPointControllerGetLeaderboard>> | undefined | ((old: Awaited<ReturnType<typeof edsyPointControllerGetLeaderboard>> | undefined) => Awaited<ReturnType<typeof edsyPointControllerGetLeaderboard>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof edsyPointControllerGetLeaderboard>>>({ exact: $exactMatch, queryKey: getEdsyPointControllerGetLeaderboardQueryKey(classroomId) }, updater);
  };
}

export const useGetEdsyPointControllerGetLeaderboardQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof edsyPointControllerGetLeaderboard>>>(getEdsyPointControllerGetLeaderboardQueryKey(classroomId));
}



export const edsyPointControllerGetUserPointsHistory = (
    userId: string,
    params?: EdsyPointControllerGetUserPointsHistoryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EdsyPointControllerGetUserPointsHistory200Item[]>(
      {url: `/edsy-point/user-point/history/${userId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getEdsyPointControllerGetUserPointsHistoryQueryKey = (userId: string,
    params?: EdsyPointControllerGetUserPointsHistoryParams,) => {
    return [
    `/edsy-point/user-point/history/${userId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getEdsyPointControllerGetUserPointsHistoryQueryOptions = <TData = Awaited<ReturnType<typeof edsyPointControllerGetUserPointsHistory>>, TError = ErrorType<unknown>>(userId: string,
    params?: EdsyPointControllerGetUserPointsHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetUserPointsHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEdsyPointControllerGetUserPointsHistoryQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof edsyPointControllerGetUserPointsHistory>>> = ({ signal }) => edsyPointControllerGetUserPointsHistory(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetUserPointsHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EdsyPointControllerGetUserPointsHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof edsyPointControllerGetUserPointsHistory>>>
export type EdsyPointControllerGetUserPointsHistoryQueryError = ErrorType<unknown>


export function useEdsyPointControllerGetUserPointsHistory<TData = Awaited<ReturnType<typeof edsyPointControllerGetUserPointsHistory>>, TError = ErrorType<unknown>>(
 userId: string,
    params: undefined |  EdsyPointControllerGetUserPointsHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetUserPointsHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof edsyPointControllerGetUserPointsHistory>>,
          TError,
          Awaited<ReturnType<typeof edsyPointControllerGetUserPointsHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEdsyPointControllerGetUserPointsHistory<TData = Awaited<ReturnType<typeof edsyPointControllerGetUserPointsHistory>>, TError = ErrorType<unknown>>(
 userId: string,
    params?: EdsyPointControllerGetUserPointsHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetUserPointsHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof edsyPointControllerGetUserPointsHistory>>,
          TError,
          Awaited<ReturnType<typeof edsyPointControllerGetUserPointsHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEdsyPointControllerGetUserPointsHistory<TData = Awaited<ReturnType<typeof edsyPointControllerGetUserPointsHistory>>, TError = ErrorType<unknown>>(
 userId: string,
    params?: EdsyPointControllerGetUserPointsHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetUserPointsHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useEdsyPointControllerGetUserPointsHistory<TData = Awaited<ReturnType<typeof edsyPointControllerGetUserPointsHistory>>, TError = ErrorType<unknown>>(
 userId: string,
    params?: EdsyPointControllerGetUserPointsHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerGetUserPointsHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEdsyPointControllerGetUserPointsHistoryQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useEdsyPointControllerGetUserPointsHistory} query
 */
export const invalidateEdsyPointControllerGetUserPointsHistory = async (
 queryClient: QueryClient, userId: string,
    params?: EdsyPointControllerGetUserPointsHistoryParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getEdsyPointControllerGetUserPointsHistoryQueryKey(userId,params) }, options);

  return queryClient;
}

export const useSetEdsyPointControllerGetUserPointsHistoryQueryData = () => {
  const queryClient = useQueryClient();
  return (userId: string,
    params: EdsyPointControllerGetUserPointsHistoryParams | undefined,updater: Awaited<ReturnType<typeof edsyPointControllerGetUserPointsHistory>> | undefined | ((old: Awaited<ReturnType<typeof edsyPointControllerGetUserPointsHistory>> | undefined) => Awaited<ReturnType<typeof edsyPointControllerGetUserPointsHistory>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof edsyPointControllerGetUserPointsHistory>>>({ exact: $exactMatch, queryKey: getEdsyPointControllerGetUserPointsHistoryQueryKey(userId,params) }, updater);
  };
}

export const useGetEdsyPointControllerGetUserPointsHistoryQueryData = () => {
  const queryClient = useQueryClient();
  return (userId: string,
    params?: EdsyPointControllerGetUserPointsHistoryParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof edsyPointControllerGetUserPointsHistory>>>(getEdsyPointControllerGetUserPointsHistoryQueryKey(userId,params));
}



export const edsyPointControllerExportEdsyPointBySchoolGroupXlsx = (
    schoolGroupId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/edsy-point/school-groups/${schoolGroupId}/export-xlsx`, method: 'GET', signal
    },
      options);
    }




export const getEdsyPointControllerExportEdsyPointBySchoolGroupXlsxQueryKey = (schoolGroupId: string,) => {
    return [
    `/edsy-point/school-groups/${schoolGroupId}/export-xlsx`
    ] as const;
    }


export const getEdsyPointControllerExportEdsyPointBySchoolGroupXlsxQueryOptions = <TData = Awaited<ReturnType<typeof edsyPointControllerExportEdsyPointBySchoolGroupXlsx>>, TError = ErrorType<unknown>>(schoolGroupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerExportEdsyPointBySchoolGroupXlsx>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEdsyPointControllerExportEdsyPointBySchoolGroupXlsxQueryKey(schoolGroupId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof edsyPointControllerExportEdsyPointBySchoolGroupXlsx>>> = ({ signal }) => edsyPointControllerExportEdsyPointBySchoolGroupXlsx(schoolGroupId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: schoolGroupId !== null && schoolGroupId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerExportEdsyPointBySchoolGroupXlsx>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EdsyPointControllerExportEdsyPointBySchoolGroupXlsxQueryResult = NonNullable<Awaited<ReturnType<typeof edsyPointControllerExportEdsyPointBySchoolGroupXlsx>>>
export type EdsyPointControllerExportEdsyPointBySchoolGroupXlsxQueryError = ErrorType<unknown>


export function useEdsyPointControllerExportEdsyPointBySchoolGroupXlsx<TData = Awaited<ReturnType<typeof edsyPointControllerExportEdsyPointBySchoolGroupXlsx>>, TError = ErrorType<unknown>>(
 schoolGroupId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerExportEdsyPointBySchoolGroupXlsx>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof edsyPointControllerExportEdsyPointBySchoolGroupXlsx>>,
          TError,
          Awaited<ReturnType<typeof edsyPointControllerExportEdsyPointBySchoolGroupXlsx>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEdsyPointControllerExportEdsyPointBySchoolGroupXlsx<TData = Awaited<ReturnType<typeof edsyPointControllerExportEdsyPointBySchoolGroupXlsx>>, TError = ErrorType<unknown>>(
 schoolGroupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerExportEdsyPointBySchoolGroupXlsx>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof edsyPointControllerExportEdsyPointBySchoolGroupXlsx>>,
          TError,
          Awaited<ReturnType<typeof edsyPointControllerExportEdsyPointBySchoolGroupXlsx>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEdsyPointControllerExportEdsyPointBySchoolGroupXlsx<TData = Awaited<ReturnType<typeof edsyPointControllerExportEdsyPointBySchoolGroupXlsx>>, TError = ErrorType<unknown>>(
 schoolGroupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerExportEdsyPointBySchoolGroupXlsx>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useEdsyPointControllerExportEdsyPointBySchoolGroupXlsx<TData = Awaited<ReturnType<typeof edsyPointControllerExportEdsyPointBySchoolGroupXlsx>>, TError = ErrorType<unknown>>(
 schoolGroupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyPointControllerExportEdsyPointBySchoolGroupXlsx>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEdsyPointControllerExportEdsyPointBySchoolGroupXlsxQueryOptions(schoolGroupId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useEdsyPointControllerExportEdsyPointBySchoolGroupXlsx} query
 */
export const invalidateEdsyPointControllerExportEdsyPointBySchoolGroupXlsx = async (
 queryClient: QueryClient, schoolGroupId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getEdsyPointControllerExportEdsyPointBySchoolGroupXlsxQueryKey(schoolGroupId) }, options);

  return queryClient;
}

export const useSetEdsyPointControllerExportEdsyPointBySchoolGroupXlsxQueryData = () => {
  const queryClient = useQueryClient();
  return (schoolGroupId: string,updater: Awaited<ReturnType<typeof edsyPointControllerExportEdsyPointBySchoolGroupXlsx>> | undefined | ((old: Awaited<ReturnType<typeof edsyPointControllerExportEdsyPointBySchoolGroupXlsx>> | undefined) => Awaited<ReturnType<typeof edsyPointControllerExportEdsyPointBySchoolGroupXlsx>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof edsyPointControllerExportEdsyPointBySchoolGroupXlsx>>>({ exact: $exactMatch, queryKey: getEdsyPointControllerExportEdsyPointBySchoolGroupXlsxQueryKey(schoolGroupId) }, updater);
  };
}

export const useGetEdsyPointControllerExportEdsyPointBySchoolGroupXlsxQueryData = () => {
  const queryClient = useQueryClient();
  return (schoolGroupId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof edsyPointControllerExportEdsyPointBySchoolGroupXlsx>>>(getEdsyPointControllerExportEdsyPointBySchoolGroupXlsxQueryKey(schoolGroupId));
}



export const openEndedActivityInstanceControllerFindAll0 = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<OpenEndedActivityInstanceControllerFindAll0200Item[]>(
      {url: `/activity-instances`, method: 'GET', signal
    },
      options);
    }




export const getOpenEndedActivityInstanceControllerFindAll0QueryKey = () => {
    return [
    `/activity-instances`
    ] as const;
    }


export const getOpenEndedActivityInstanceControllerFindAll0QueryOptions = <TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll0>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll0>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOpenEndedActivityInstanceControllerFindAll0QueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll0>>> = ({ signal }) => openEndedActivityInstanceControllerFindAll0(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll0>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OpenEndedActivityInstanceControllerFindAll0QueryResult = NonNullable<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll0>>>
export type OpenEndedActivityInstanceControllerFindAll0QueryError = ErrorType<unknown>


export function useOpenEndedActivityInstanceControllerFindAll0<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll0>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll0>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll0>>,
          TError,
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll0>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpenEndedActivityInstanceControllerFindAll0<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll0>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll0>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll0>>,
          TError,
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll0>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpenEndedActivityInstanceControllerFindAll0<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll0>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll0>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOpenEndedActivityInstanceControllerFindAll0<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll0>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll0>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOpenEndedActivityInstanceControllerFindAll0QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useOpenEndedActivityInstanceControllerFindAll0} query
 */
export const invalidateOpenEndedActivityInstanceControllerFindAll0 = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getOpenEndedActivityInstanceControllerFindAll0QueryKey() }, options);

  return queryClient;
}

export const useSetOpenEndedActivityInstanceControllerFindAll0QueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll0>> | undefined | ((old: Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll0>> | undefined) => Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll0>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll0>>>({ exact: $exactMatch, queryKey: getOpenEndedActivityInstanceControllerFindAll0QueryKey() }, updater);
  };
}

export const useGetOpenEndedActivityInstanceControllerFindAll0QueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll0>>>(getOpenEndedActivityInstanceControllerFindAll0QueryKey());
}



export const activityInstanceControllerGetUserActivityInstances = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ActivityInstanceControllerGetUserActivityInstances200Item[]>(
      {url: `/activity-instances/me`, method: 'GET', signal
    },
      options);
    }




export const getActivityInstanceControllerGetUserActivityInstancesQueryKey = () => {
    return [
    `/activity-instances/me`
    ] as const;
    }


export const getActivityInstanceControllerGetUserActivityInstancesQueryOptions = <TData = Awaited<ReturnType<typeof activityInstanceControllerGetUserActivityInstances>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerGetUserActivityInstances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityInstanceControllerGetUserActivityInstancesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityInstanceControllerGetUserActivityInstances>>> = ({ signal }) => activityInstanceControllerGetUserActivityInstances(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerGetUserActivityInstances>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivityInstanceControllerGetUserActivityInstancesQueryResult = NonNullable<Awaited<ReturnType<typeof activityInstanceControllerGetUserActivityInstances>>>
export type ActivityInstanceControllerGetUserActivityInstancesQueryError = ErrorType<unknown>


export function useActivityInstanceControllerGetUserActivityInstances<TData = Awaited<ReturnType<typeof activityInstanceControllerGetUserActivityInstances>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerGetUserActivityInstances>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityInstanceControllerGetUserActivityInstances>>,
          TError,
          Awaited<ReturnType<typeof activityInstanceControllerGetUserActivityInstances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityInstanceControllerGetUserActivityInstances<TData = Awaited<ReturnType<typeof activityInstanceControllerGetUserActivityInstances>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerGetUserActivityInstances>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityInstanceControllerGetUserActivityInstances>>,
          TError,
          Awaited<ReturnType<typeof activityInstanceControllerGetUserActivityInstances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityInstanceControllerGetUserActivityInstances<TData = Awaited<ReturnType<typeof activityInstanceControllerGetUserActivityInstances>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerGetUserActivityInstances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivityInstanceControllerGetUserActivityInstances<TData = Awaited<ReturnType<typeof activityInstanceControllerGetUserActivityInstances>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerGetUserActivityInstances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivityInstanceControllerGetUserActivityInstancesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivityInstanceControllerGetUserActivityInstances} query
 */
export const invalidateActivityInstanceControllerGetUserActivityInstances = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivityInstanceControllerGetUserActivityInstancesQueryKey() }, options);

  return queryClient;
}

export const useSetActivityInstanceControllerGetUserActivityInstancesQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof activityInstanceControllerGetUserActivityInstances>> | undefined | ((old: Awaited<ReturnType<typeof activityInstanceControllerGetUserActivityInstances>> | undefined) => Awaited<ReturnType<typeof activityInstanceControllerGetUserActivityInstances>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activityInstanceControllerGetUserActivityInstances>>>({ exact: $exactMatch, queryKey: getActivityInstanceControllerGetUserActivityInstancesQueryKey() }, updater);
  };
}

export const useGetActivityInstanceControllerGetUserActivityInstancesQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activityInstanceControllerGetUserActivityInstances>>>(getActivityInstanceControllerGetUserActivityInstancesQueryKey());
}



export const openEndedActivityInstanceControllerFindOne0 = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<OpenEndedActivityInstanceControllerFindOne0200>(
      {url: `/activity-instances/${id}`, method: 'GET', signal
    },
      options);
    }




export const getOpenEndedActivityInstanceControllerFindOne0QueryKey = (id: string,) => {
    return [
    `/activity-instances/${id}`
    ] as const;
    }


export const getOpenEndedActivityInstanceControllerFindOne0QueryOptions = <TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne0>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne0>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOpenEndedActivityInstanceControllerFindOne0QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne0>>> = ({ signal }) => openEndedActivityInstanceControllerFindOne0(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne0>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OpenEndedActivityInstanceControllerFindOne0QueryResult = NonNullable<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne0>>>
export type OpenEndedActivityInstanceControllerFindOne0QueryError = ErrorType<unknown>


export function useOpenEndedActivityInstanceControllerFindOne0<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne0>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne0>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne0>>,
          TError,
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne0>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpenEndedActivityInstanceControllerFindOne0<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne0>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne0>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne0>>,
          TError,
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne0>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpenEndedActivityInstanceControllerFindOne0<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne0>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne0>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOpenEndedActivityInstanceControllerFindOne0<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne0>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne0>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOpenEndedActivityInstanceControllerFindOne0QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useOpenEndedActivityInstanceControllerFindOne0} query
 */
export const invalidateOpenEndedActivityInstanceControllerFindOne0 = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getOpenEndedActivityInstanceControllerFindOne0QueryKey(id) }, options);

  return queryClient;
}

export const useSetOpenEndedActivityInstanceControllerFindOne0QueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne0>> | undefined | ((old: Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne0>> | undefined) => Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne0>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne0>>>({ exact: $exactMatch, queryKey: getOpenEndedActivityInstanceControllerFindOne0QueryKey(id) }, updater);
  };
}

export const useGetOpenEndedActivityInstanceControllerFindOne0QueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne0>>>(getOpenEndedActivityInstanceControllerFindOne0QueryKey(id));
}



export const activityInstanceControllerDelete = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/activity-instances/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getActivityInstanceControllerDeleteMutationKey = () => ['activityInstanceControllerDelete'] as const;

export const getActivityInstanceControllerDeleteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityInstanceControllerDelete>>, TError,ActivityInstanceControllerDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activityInstanceControllerDelete>>, TError,ActivityInstanceControllerDeleteMutationVariables, TContext> => {

const mutationKey = getActivityInstanceControllerDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activityInstanceControllerDelete>>, ActivityInstanceControllerDeleteMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  activityInstanceControllerDelete(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivityInstanceControllerDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof activityInstanceControllerDelete>>>

    export type ActivityInstanceControllerDeleteMutationError = ErrorType<unknown>
    export type ActivityInstanceControllerDeleteMutationVariables = {id: string}

    export const useActivityInstanceControllerDelete = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityInstanceControllerDelete>>, TError,ActivityInstanceControllerDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activityInstanceControllerDelete>>,
        TError,
        ActivityInstanceControllerDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getActivityInstanceControllerDeleteMutationOptions(options), queryClient);
    }

export const activityInstanceControllerFindActivityInstanceTaskTransactions = (
    activityInstanceId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ActivityInstanceControllerFindActivityInstanceTaskTransactions200Item[]>(
      {url: `/activity-instances/${activityInstanceId}/task-transactions`, method: 'GET', signal
    },
      options);
    }




export const getActivityInstanceControllerFindActivityInstanceTaskTransactionsQueryKey = (activityInstanceId: string,) => {
    return [
    `/activity-instances/${activityInstanceId}/task-transactions`
    ] as const;
    }


export const getActivityInstanceControllerFindActivityInstanceTaskTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceTaskTransactions>>, TError = ErrorType<unknown>>(activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceTaskTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityInstanceControllerFindActivityInstanceTaskTransactionsQueryKey(activityInstanceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceTaskTransactions>>> = ({ signal }) => activityInstanceControllerFindActivityInstanceTaskTransactions(activityInstanceId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: activityInstanceId !== null && activityInstanceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceTaskTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivityInstanceControllerFindActivityInstanceTaskTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceTaskTransactions>>>
export type ActivityInstanceControllerFindActivityInstanceTaskTransactionsQueryError = ErrorType<unknown>


export function useActivityInstanceControllerFindActivityInstanceTaskTransactions<TData = Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceTaskTransactions>>, TError = ErrorType<unknown>>(
 activityInstanceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceTaskTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceTaskTransactions>>,
          TError,
          Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceTaskTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityInstanceControllerFindActivityInstanceTaskTransactions<TData = Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceTaskTransactions>>, TError = ErrorType<unknown>>(
 activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceTaskTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceTaskTransactions>>,
          TError,
          Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceTaskTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityInstanceControllerFindActivityInstanceTaskTransactions<TData = Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceTaskTransactions>>, TError = ErrorType<unknown>>(
 activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceTaskTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivityInstanceControllerFindActivityInstanceTaskTransactions<TData = Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceTaskTransactions>>, TError = ErrorType<unknown>>(
 activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceTaskTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivityInstanceControllerFindActivityInstanceTaskTransactionsQueryOptions(activityInstanceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivityInstanceControllerFindActivityInstanceTaskTransactions} query
 */
export const invalidateActivityInstanceControllerFindActivityInstanceTaskTransactions = async (
 queryClient: QueryClient, activityInstanceId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivityInstanceControllerFindActivityInstanceTaskTransactionsQueryKey(activityInstanceId) }, options);

  return queryClient;
}

export const useSetActivityInstanceControllerFindActivityInstanceTaskTransactionsQueryData = () => {
  const queryClient = useQueryClient();
  return (activityInstanceId: string,updater: Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceTaskTransactions>> | undefined | ((old: Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceTaskTransactions>> | undefined) => Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceTaskTransactions>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceTaskTransactions>>>({ exact: $exactMatch, queryKey: getActivityInstanceControllerFindActivityInstanceTaskTransactionsQueryKey(activityInstanceId) }, updater);
  };
}

export const useGetActivityInstanceControllerFindActivityInstanceTaskTransactionsQueryData = () => {
  const queryClient = useQueryClient();
  return (activityInstanceId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceTaskTransactions>>>(getActivityInstanceControllerFindActivityInstanceTaskTransactionsQueryKey(activityInstanceId));
}



export const activityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId = (
    activityInstanceId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ActivityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId200>(
      {url: `/activity-instances/${activityInstanceId}/metadata`, method: 'GET', signal
    },
      options);
    }




export const getActivityInstanceControllerFindActivityInstanceMetadataByActivityInstanceIdQueryKey = (activityInstanceId: string,) => {
    return [
    `/activity-instances/${activityInstanceId}/metadata`
    ] as const;
    }


export const getActivityInstanceControllerFindActivityInstanceMetadataByActivityInstanceIdQueryOptions = <TData = Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId>>, TError = ErrorType<unknown>>(activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityInstanceControllerFindActivityInstanceMetadataByActivityInstanceIdQueryKey(activityInstanceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId>>> = ({ signal }) => activityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId(activityInstanceId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: activityInstanceId !== null && activityInstanceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivityInstanceControllerFindActivityInstanceMetadataByActivityInstanceIdQueryResult = NonNullable<Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId>>>
export type ActivityInstanceControllerFindActivityInstanceMetadataByActivityInstanceIdQueryError = ErrorType<unknown>


export function useActivityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId<TData = Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId>>, TError = ErrorType<unknown>>(
 activityInstanceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId>>,
          TError,
          Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId<TData = Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId>>, TError = ErrorType<unknown>>(
 activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId>>,
          TError,
          Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId<TData = Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId>>, TError = ErrorType<unknown>>(
 activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId<TData = Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId>>, TError = ErrorType<unknown>>(
 activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivityInstanceControllerFindActivityInstanceMetadataByActivityInstanceIdQueryOptions(activityInstanceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId} query
 */
export const invalidateActivityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId = async (
 queryClient: QueryClient, activityInstanceId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivityInstanceControllerFindActivityInstanceMetadataByActivityInstanceIdQueryKey(activityInstanceId) }, options);

  return queryClient;
}

export const useSetActivityInstanceControllerFindActivityInstanceMetadataByActivityInstanceIdQueryData = () => {
  const queryClient = useQueryClient();
  return (activityInstanceId: string,updater: Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId>> | undefined | ((old: Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId>> | undefined) => Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId>>>({ exact: $exactMatch, queryKey: getActivityInstanceControllerFindActivityInstanceMetadataByActivityInstanceIdQueryKey(activityInstanceId) }, updater);
  };
}

export const useGetActivityInstanceControllerFindActivityInstanceMetadataByActivityInstanceIdQueryData = () => {
  const queryClient = useQueryClient();
  return (activityInstanceId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activityInstanceControllerFindActivityInstanceMetadataByActivityInstanceId>>>(getActivityInstanceControllerFindActivityInstanceMetadataByActivityInstanceIdQueryKey(activityInstanceId));
}



export const activityInstanceControllerGetActivityInstanceProgressByActivityInstanceId = (
    activityInstanceId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/activity-instances/${activityInstanceId}/progress`, method: 'GET', signal
    },
      options);
    }




export const getActivityInstanceControllerGetActivityInstanceProgressByActivityInstanceIdQueryKey = (activityInstanceId: string,) => {
    return [
    `/activity-instances/${activityInstanceId}/progress`
    ] as const;
    }


export const getActivityInstanceControllerGetActivityInstanceProgressByActivityInstanceIdQueryOptions = <TData = Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceProgressByActivityInstanceId>>, TError = ErrorType<unknown>>(activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceProgressByActivityInstanceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityInstanceControllerGetActivityInstanceProgressByActivityInstanceIdQueryKey(activityInstanceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceProgressByActivityInstanceId>>> = ({ signal }) => activityInstanceControllerGetActivityInstanceProgressByActivityInstanceId(activityInstanceId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: activityInstanceId !== null && activityInstanceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceProgressByActivityInstanceId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivityInstanceControllerGetActivityInstanceProgressByActivityInstanceIdQueryResult = NonNullable<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceProgressByActivityInstanceId>>>
export type ActivityInstanceControllerGetActivityInstanceProgressByActivityInstanceIdQueryError = ErrorType<unknown>


export function useActivityInstanceControllerGetActivityInstanceProgressByActivityInstanceId<TData = Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceProgressByActivityInstanceId>>, TError = ErrorType<unknown>>(
 activityInstanceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceProgressByActivityInstanceId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceProgressByActivityInstanceId>>,
          TError,
          Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceProgressByActivityInstanceId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityInstanceControllerGetActivityInstanceProgressByActivityInstanceId<TData = Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceProgressByActivityInstanceId>>, TError = ErrorType<unknown>>(
 activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceProgressByActivityInstanceId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceProgressByActivityInstanceId>>,
          TError,
          Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceProgressByActivityInstanceId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityInstanceControllerGetActivityInstanceProgressByActivityInstanceId<TData = Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceProgressByActivityInstanceId>>, TError = ErrorType<unknown>>(
 activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceProgressByActivityInstanceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivityInstanceControllerGetActivityInstanceProgressByActivityInstanceId<TData = Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceProgressByActivityInstanceId>>, TError = ErrorType<unknown>>(
 activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceProgressByActivityInstanceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivityInstanceControllerGetActivityInstanceProgressByActivityInstanceIdQueryOptions(activityInstanceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivityInstanceControllerGetActivityInstanceProgressByActivityInstanceId} query
 */
export const invalidateActivityInstanceControllerGetActivityInstanceProgressByActivityInstanceId = async (
 queryClient: QueryClient, activityInstanceId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivityInstanceControllerGetActivityInstanceProgressByActivityInstanceIdQueryKey(activityInstanceId) }, options);

  return queryClient;
}

export const useSetActivityInstanceControllerGetActivityInstanceProgressByActivityInstanceIdQueryData = () => {
  const queryClient = useQueryClient();
  return (activityInstanceId: string,updater: Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceProgressByActivityInstanceId>> | undefined | ((old: Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceProgressByActivityInstanceId>> | undefined) => Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceProgressByActivityInstanceId>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceProgressByActivityInstanceId>>>({ exact: $exactMatch, queryKey: getActivityInstanceControllerGetActivityInstanceProgressByActivityInstanceIdQueryKey(activityInstanceId) }, updater);
  };
}

export const useGetActivityInstanceControllerGetActivityInstanceProgressByActivityInstanceIdQueryData = () => {
  const queryClient = useQueryClient();
  return (activityInstanceId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceProgressByActivityInstanceId>>>(getActivityInstanceControllerGetActivityInstanceProgressByActivityInstanceIdQueryKey(activityInstanceId));
}



export const activityInstanceControllerGetActivityInstanceScoreByActivityInstanceId = (
    activityInstanceId: string,
    params?: ActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceIdParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceId200>(
      {url: `/activity-instances/${activityInstanceId}/score`, method: 'GET',
        params, signal
    },
      options);
    }




export const getActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceIdQueryKey = (activityInstanceId: string,
    params?: ActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceIdParams,) => {
    return [
    `/activity-instances/${activityInstanceId}/score`, ...(params ? [params] : [])
    ] as const;
    }


export const getActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceIdQueryOptions = <TData = Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceScoreByActivityInstanceId>>, TError = ErrorType<unknown>>(activityInstanceId: string,
    params?: ActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceScoreByActivityInstanceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceIdQueryKey(activityInstanceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceScoreByActivityInstanceId>>> = ({ signal }) => activityInstanceControllerGetActivityInstanceScoreByActivityInstanceId(activityInstanceId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: activityInstanceId !== null && activityInstanceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceScoreByActivityInstanceId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceIdQueryResult = NonNullable<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceScoreByActivityInstanceId>>>
export type ActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceIdQueryError = ErrorType<unknown>


export function useActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceId<TData = Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceScoreByActivityInstanceId>>, TError = ErrorType<unknown>>(
 activityInstanceId: string,
    params: undefined |  ActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceScoreByActivityInstanceId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceScoreByActivityInstanceId>>,
          TError,
          Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceScoreByActivityInstanceId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceId<TData = Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceScoreByActivityInstanceId>>, TError = ErrorType<unknown>>(
 activityInstanceId: string,
    params?: ActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceScoreByActivityInstanceId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceScoreByActivityInstanceId>>,
          TError,
          Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceScoreByActivityInstanceId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceId<TData = Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceScoreByActivityInstanceId>>, TError = ErrorType<unknown>>(
 activityInstanceId: string,
    params?: ActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceScoreByActivityInstanceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceId<TData = Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceScoreByActivityInstanceId>>, TError = ErrorType<unknown>>(
 activityInstanceId: string,
    params?: ActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceScoreByActivityInstanceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceIdQueryOptions(activityInstanceId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceId} query
 */
export const invalidateActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceId = async (
 queryClient: QueryClient, activityInstanceId: string,
    params?: ActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceIdParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceIdQueryKey(activityInstanceId,params) }, options);

  return queryClient;
}

export const useSetActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceIdQueryData = () => {
  const queryClient = useQueryClient();
  return (activityInstanceId: string,
    params: ActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceIdParams | undefined,updater: Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceScoreByActivityInstanceId>> | undefined | ((old: Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceScoreByActivityInstanceId>> | undefined) => Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceScoreByActivityInstanceId>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceScoreByActivityInstanceId>>>({ exact: $exactMatch, queryKey: getActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceIdQueryKey(activityInstanceId,params) }, updater);
  };
}

export const useGetActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceIdQueryData = () => {
  const queryClient = useQueryClient();
  return (activityInstanceId: string,
    params?: ActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceIdParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceScoreByActivityInstanceId>>>(getActivityInstanceControllerGetActivityInstanceScoreByActivityInstanceIdQueryKey(activityInstanceId,params));
}



export const activityInstanceControllerGetActivityInstanceCompletePageData = (
    activityInstanceId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/activity-instances/${activityInstanceId}/complete-page-data`, method: 'GET', signal
    },
      options);
    }




export const getActivityInstanceControllerGetActivityInstanceCompletePageDataQueryKey = (activityInstanceId: string,) => {
    return [
    `/activity-instances/${activityInstanceId}/complete-page-data`
    ] as const;
    }


export const getActivityInstanceControllerGetActivityInstanceCompletePageDataQueryOptions = <TData = Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceCompletePageData>>, TError = ErrorType<unknown>>(activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceCompletePageData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityInstanceControllerGetActivityInstanceCompletePageDataQueryKey(activityInstanceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceCompletePageData>>> = ({ signal }) => activityInstanceControllerGetActivityInstanceCompletePageData(activityInstanceId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: activityInstanceId !== null && activityInstanceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceCompletePageData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivityInstanceControllerGetActivityInstanceCompletePageDataQueryResult = NonNullable<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceCompletePageData>>>
export type ActivityInstanceControllerGetActivityInstanceCompletePageDataQueryError = ErrorType<unknown>


export function useActivityInstanceControllerGetActivityInstanceCompletePageData<TData = Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceCompletePageData>>, TError = ErrorType<unknown>>(
 activityInstanceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceCompletePageData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceCompletePageData>>,
          TError,
          Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceCompletePageData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityInstanceControllerGetActivityInstanceCompletePageData<TData = Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceCompletePageData>>, TError = ErrorType<unknown>>(
 activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceCompletePageData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceCompletePageData>>,
          TError,
          Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceCompletePageData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityInstanceControllerGetActivityInstanceCompletePageData<TData = Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceCompletePageData>>, TError = ErrorType<unknown>>(
 activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceCompletePageData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivityInstanceControllerGetActivityInstanceCompletePageData<TData = Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceCompletePageData>>, TError = ErrorType<unknown>>(
 activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceCompletePageData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivityInstanceControllerGetActivityInstanceCompletePageDataQueryOptions(activityInstanceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivityInstanceControllerGetActivityInstanceCompletePageData} query
 */
export const invalidateActivityInstanceControllerGetActivityInstanceCompletePageData = async (
 queryClient: QueryClient, activityInstanceId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivityInstanceControllerGetActivityInstanceCompletePageDataQueryKey(activityInstanceId) }, options);

  return queryClient;
}

export const useSetActivityInstanceControllerGetActivityInstanceCompletePageDataQueryData = () => {
  const queryClient = useQueryClient();
  return (activityInstanceId: string,updater: Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceCompletePageData>> | undefined | ((old: Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceCompletePageData>> | undefined) => Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceCompletePageData>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceCompletePageData>>>({ exact: $exactMatch, queryKey: getActivityInstanceControllerGetActivityInstanceCompletePageDataQueryKey(activityInstanceId) }, updater);
  };
}

export const useGetActivityInstanceControllerGetActivityInstanceCompletePageDataQueryData = () => {
  const queryClient = useQueryClient();
  return (activityInstanceId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activityInstanceControllerGetActivityInstanceCompletePageData>>>(getActivityInstanceControllerGetActivityInstanceCompletePageDataQueryKey(activityInstanceId));
}



export const openEndedActivityInstanceControllerFindAll1 = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<OpenEndedActivityInstanceControllerFindAll1200Item[]>(
      {url: `/open-ended-activity-instances`, method: 'GET', signal
    },
      options);
    }




export const getOpenEndedActivityInstanceControllerFindAll1QueryKey = () => {
    return [
    `/open-ended-activity-instances`
    ] as const;
    }


export const getOpenEndedActivityInstanceControllerFindAll1QueryOptions = <TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll1>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOpenEndedActivityInstanceControllerFindAll1QueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll1>>> = ({ signal }) => openEndedActivityInstanceControllerFindAll1(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OpenEndedActivityInstanceControllerFindAll1QueryResult = NonNullable<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll1>>>
export type OpenEndedActivityInstanceControllerFindAll1QueryError = ErrorType<unknown>


export function useOpenEndedActivityInstanceControllerFindAll1<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll1>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll1>>,
          TError,
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpenEndedActivityInstanceControllerFindAll1<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll1>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll1>>,
          TError,
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpenEndedActivityInstanceControllerFindAll1<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll1>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOpenEndedActivityInstanceControllerFindAll1<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll1>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOpenEndedActivityInstanceControllerFindAll1QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useOpenEndedActivityInstanceControllerFindAll1} query
 */
export const invalidateOpenEndedActivityInstanceControllerFindAll1 = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getOpenEndedActivityInstanceControllerFindAll1QueryKey() }, options);

  return queryClient;
}

export const useSetOpenEndedActivityInstanceControllerFindAll1QueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll1>> | undefined | ((old: Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll1>> | undefined) => Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll1>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll1>>>({ exact: $exactMatch, queryKey: getOpenEndedActivityInstanceControllerFindAll1QueryKey() }, updater);
  };
}

export const useGetOpenEndedActivityInstanceControllerFindAll1QueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindAll1>>>(getOpenEndedActivityInstanceControllerFindAll1QueryKey());
}



export const openEndedActivityInstanceControllerFindOne1 = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<OpenEndedActivityInstanceControllerFindOne1200>(
      {url: `/open-ended-activity-instances/${id}`, method: 'GET', signal
    },
      options);
    }




export const getOpenEndedActivityInstanceControllerFindOne1QueryKey = (id: string,) => {
    return [
    `/open-ended-activity-instances/${id}`
    ] as const;
    }


export const getOpenEndedActivityInstanceControllerFindOne1QueryOptions = <TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne1>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOpenEndedActivityInstanceControllerFindOne1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne1>>> = ({ signal }) => openEndedActivityInstanceControllerFindOne1(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OpenEndedActivityInstanceControllerFindOne1QueryResult = NonNullable<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne1>>>
export type OpenEndedActivityInstanceControllerFindOne1QueryError = ErrorType<unknown>


export function useOpenEndedActivityInstanceControllerFindOne1<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne1>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne1>>,
          TError,
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpenEndedActivityInstanceControllerFindOne1<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne1>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne1>>,
          TError,
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpenEndedActivityInstanceControllerFindOne1<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne1>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOpenEndedActivityInstanceControllerFindOne1<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne1>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOpenEndedActivityInstanceControllerFindOne1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useOpenEndedActivityInstanceControllerFindOne1} query
 */
export const invalidateOpenEndedActivityInstanceControllerFindOne1 = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getOpenEndedActivityInstanceControllerFindOne1QueryKey(id) }, options);

  return queryClient;
}

export const useSetOpenEndedActivityInstanceControllerFindOne1QueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne1>> | undefined | ((old: Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne1>> | undefined) => Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne1>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne1>>>({ exact: $exactMatch, queryKey: getOpenEndedActivityInstanceControllerFindOne1QueryKey(id) }, updater);
  };
}

export const useGetOpenEndedActivityInstanceControllerFindOne1QueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof openEndedActivityInstanceControllerFindOne1>>>(getOpenEndedActivityInstanceControllerFindOne1QueryKey(id));
}



export const openEndedActivityInstanceControllerGetNextTask0 = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/activity-instances/${id}/next-task`, method: 'GET', signal
    },
      options);
    }




export const getOpenEndedActivityInstanceControllerGetNextTask0QueryKey = (id: string,) => {
    return [
    `/activity-instances/${id}/next-task`
    ] as const;
    }


export const getOpenEndedActivityInstanceControllerGetNextTask0QueryOptions = <TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask0>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask0>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOpenEndedActivityInstanceControllerGetNextTask0QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask0>>> = ({ signal }) => openEndedActivityInstanceControllerGetNextTask0(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask0>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OpenEndedActivityInstanceControllerGetNextTask0QueryResult = NonNullable<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask0>>>
export type OpenEndedActivityInstanceControllerGetNextTask0QueryError = ErrorType<unknown>


export function useOpenEndedActivityInstanceControllerGetNextTask0<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask0>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask0>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask0>>,
          TError,
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask0>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpenEndedActivityInstanceControllerGetNextTask0<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask0>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask0>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask0>>,
          TError,
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask0>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpenEndedActivityInstanceControllerGetNextTask0<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask0>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask0>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOpenEndedActivityInstanceControllerGetNextTask0<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask0>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask0>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOpenEndedActivityInstanceControllerGetNextTask0QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useOpenEndedActivityInstanceControllerGetNextTask0} query
 */
export const invalidateOpenEndedActivityInstanceControllerGetNextTask0 = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getOpenEndedActivityInstanceControllerGetNextTask0QueryKey(id) }, options);

  return queryClient;
}

export const useSetOpenEndedActivityInstanceControllerGetNextTask0QueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask0>> | undefined | ((old: Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask0>> | undefined) => Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask0>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask0>>>({ exact: $exactMatch, queryKey: getOpenEndedActivityInstanceControllerGetNextTask0QueryKey(id) }, updater);
  };
}

export const useGetOpenEndedActivityInstanceControllerGetNextTask0QueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask0>>>(getOpenEndedActivityInstanceControllerGetNextTask0QueryKey(id));
}



export const openEndedActivityInstanceControllerGetNextTask1 = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/activity-instances/${id}/current-task-and-task-transaction`, method: 'GET', signal
    },
      options);
    }




export const getOpenEndedActivityInstanceControllerGetNextTask1QueryKey = (id: string,) => {
    return [
    `/activity-instances/${id}/current-task-and-task-transaction`
    ] as const;
    }


export const getOpenEndedActivityInstanceControllerGetNextTask1QueryOptions = <TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask1>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOpenEndedActivityInstanceControllerGetNextTask1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask1>>> = ({ signal }) => openEndedActivityInstanceControllerGetNextTask1(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OpenEndedActivityInstanceControllerGetNextTask1QueryResult = NonNullable<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask1>>>
export type OpenEndedActivityInstanceControllerGetNextTask1QueryError = ErrorType<unknown>


export function useOpenEndedActivityInstanceControllerGetNextTask1<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask1>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask1>>,
          TError,
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpenEndedActivityInstanceControllerGetNextTask1<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask1>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask1>>,
          TError,
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpenEndedActivityInstanceControllerGetNextTask1<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask1>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOpenEndedActivityInstanceControllerGetNextTask1<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask1>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOpenEndedActivityInstanceControllerGetNextTask1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useOpenEndedActivityInstanceControllerGetNextTask1} query
 */
export const invalidateOpenEndedActivityInstanceControllerGetNextTask1 = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getOpenEndedActivityInstanceControllerGetNextTask1QueryKey(id) }, options);

  return queryClient;
}

export const useSetOpenEndedActivityInstanceControllerGetNextTask1QueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask1>> | undefined | ((old: Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask1>> | undefined) => Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask1>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask1>>>({ exact: $exactMatch, queryKey: getOpenEndedActivityInstanceControllerGetNextTask1QueryKey(id) }, updater);
  };
}

export const useGetOpenEndedActivityInstanceControllerGetNextTask1QueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask1>>>(getOpenEndedActivityInstanceControllerGetNextTask1QueryKey(id));
}



export const openEndedActivityInstanceControllerGetNextTask2 = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/open-ended-activity-instances/${id}/next-task`, method: 'GET', signal
    },
      options);
    }




export const getOpenEndedActivityInstanceControllerGetNextTask2QueryKey = (id: string,) => {
    return [
    `/open-ended-activity-instances/${id}/next-task`
    ] as const;
    }


export const getOpenEndedActivityInstanceControllerGetNextTask2QueryOptions = <TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask2>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOpenEndedActivityInstanceControllerGetNextTask2QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask2>>> = ({ signal }) => openEndedActivityInstanceControllerGetNextTask2(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OpenEndedActivityInstanceControllerGetNextTask2QueryResult = NonNullable<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask2>>>
export type OpenEndedActivityInstanceControllerGetNextTask2QueryError = ErrorType<unknown>


export function useOpenEndedActivityInstanceControllerGetNextTask2<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask2>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask2>>,
          TError,
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpenEndedActivityInstanceControllerGetNextTask2<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask2>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask2>>,
          TError,
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpenEndedActivityInstanceControllerGetNextTask2<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask2>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOpenEndedActivityInstanceControllerGetNextTask2<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask2>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOpenEndedActivityInstanceControllerGetNextTask2QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useOpenEndedActivityInstanceControllerGetNextTask2} query
 */
export const invalidateOpenEndedActivityInstanceControllerGetNextTask2 = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getOpenEndedActivityInstanceControllerGetNextTask2QueryKey(id) }, options);

  return queryClient;
}

export const useSetOpenEndedActivityInstanceControllerGetNextTask2QueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask2>> | undefined | ((old: Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask2>> | undefined) => Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask2>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask2>>>({ exact: $exactMatch, queryKey: getOpenEndedActivityInstanceControllerGetNextTask2QueryKey(id) }, updater);
  };
}

export const useGetOpenEndedActivityInstanceControllerGetNextTask2QueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask2>>>(getOpenEndedActivityInstanceControllerGetNextTask2QueryKey(id));
}



export const openEndedActivityInstanceControllerGetNextTask3 = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/open-ended-activity-instances/${id}/current-task-and-task-transaction`, method: 'GET', signal
    },
      options);
    }




export const getOpenEndedActivityInstanceControllerGetNextTask3QueryKey = (id: string,) => {
    return [
    `/open-ended-activity-instances/${id}/current-task-and-task-transaction`
    ] as const;
    }


export const getOpenEndedActivityInstanceControllerGetNextTask3QueryOptions = <TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask3>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask3>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOpenEndedActivityInstanceControllerGetNextTask3QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask3>>> = ({ signal }) => openEndedActivityInstanceControllerGetNextTask3(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask3>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OpenEndedActivityInstanceControllerGetNextTask3QueryResult = NonNullable<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask3>>>
export type OpenEndedActivityInstanceControllerGetNextTask3QueryError = ErrorType<unknown>


export function useOpenEndedActivityInstanceControllerGetNextTask3<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask3>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask3>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask3>>,
          TError,
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask3>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpenEndedActivityInstanceControllerGetNextTask3<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask3>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask3>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask3>>,
          TError,
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask3>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpenEndedActivityInstanceControllerGetNextTask3<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask3>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask3>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOpenEndedActivityInstanceControllerGetNextTask3<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask3>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask3>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOpenEndedActivityInstanceControllerGetNextTask3QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useOpenEndedActivityInstanceControllerGetNextTask3} query
 */
export const invalidateOpenEndedActivityInstanceControllerGetNextTask3 = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getOpenEndedActivityInstanceControllerGetNextTask3QueryKey(id) }, options);

  return queryClient;
}

export const useSetOpenEndedActivityInstanceControllerGetNextTask3QueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask3>> | undefined | ((old: Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask3>> | undefined) => Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask3>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask3>>>({ exact: $exactMatch, queryKey: getOpenEndedActivityInstanceControllerGetNextTask3QueryKey(id) }, updater);
  };
}

export const useGetOpenEndedActivityInstanceControllerGetNextTask3QueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetNextTask3>>>(getOpenEndedActivityInstanceControllerGetNextTask3QueryKey(id));
}



export const openEndedActivityInstanceControllerGetLatestResponseAudioBlob0 = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/activity-instances/${id}/latest-response-audio-blob`, method: 'GET', signal
    },
      options);
    }




export const getOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob0QueryKey = (id: string,) => {
    return [
    `/activity-instances/${id}/latest-response-audio-blob`
    ] as const;
    }


export const getOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob0QueryOptions = <TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob0>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob0>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob0QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob0>>> = ({ signal }) => openEndedActivityInstanceControllerGetLatestResponseAudioBlob0(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob0>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OpenEndedActivityInstanceControllerGetLatestResponseAudioBlob0QueryResult = NonNullable<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob0>>>
export type OpenEndedActivityInstanceControllerGetLatestResponseAudioBlob0QueryError = ErrorType<unknown>


export function useOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob0<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob0>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob0>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob0>>,
          TError,
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob0>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob0<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob0>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob0>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob0>>,
          TError,
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob0>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob0<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob0>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob0>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob0<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob0>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob0>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob0QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob0} query
 */
export const invalidateOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob0 = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob0QueryKey(id) }, options);

  return queryClient;
}

export const useSetOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob0QueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob0>> | undefined | ((old: Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob0>> | undefined) => Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob0>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob0>>>({ exact: $exactMatch, queryKey: getOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob0QueryKey(id) }, updater);
  };
}

export const useGetOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob0QueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob0>>>(getOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob0QueryKey(id));
}



export const openEndedActivityInstanceControllerGetLatestResponseAudioBlob1 = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/open-ended-activity-instances/${id}/latest-response-audio-blob`, method: 'GET', signal
    },
      options);
    }




export const getOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob1QueryKey = (id: string,) => {
    return [
    `/open-ended-activity-instances/${id}/latest-response-audio-blob`
    ] as const;
    }


export const getOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob1QueryOptions = <TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob1>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob1>>> = ({ signal }) => openEndedActivityInstanceControllerGetLatestResponseAudioBlob1(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OpenEndedActivityInstanceControllerGetLatestResponseAudioBlob1QueryResult = NonNullable<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob1>>>
export type OpenEndedActivityInstanceControllerGetLatestResponseAudioBlob1QueryError = ErrorType<unknown>


export function useOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob1<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob1>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob1>>,
          TError,
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob1<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob1>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob1>>,
          TError,
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob1<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob1>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob1<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob1>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob1} query
 */
export const invalidateOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob1 = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob1QueryKey(id) }, options);

  return queryClient;
}

export const useSetOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob1QueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob1>> | undefined | ((old: Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob1>> | undefined) => Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob1>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob1>>>({ exact: $exactMatch, queryKey: getOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob1QueryKey(id) }, updater);
  };
}

export const useGetOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob1QueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetLatestResponseAudioBlob1>>>(getOpenEndedActivityInstanceControllerGetLatestResponseAudioBlob1QueryKey(id));
}



export const openEndedActivityInstanceControllerGetGradingCriteriaConfig0 = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<OpenEndedActivityInstanceControllerGetGradingCriteriaConfig0200>(
      {url: `/activity-instances/${id}/grading-criteria-config`, method: 'GET', signal
    },
      options);
    }




export const getOpenEndedActivityInstanceControllerGetGradingCriteriaConfig0QueryKey = (id: string,) => {
    return [
    `/activity-instances/${id}/grading-criteria-config`
    ] as const;
    }


export const getOpenEndedActivityInstanceControllerGetGradingCriteriaConfig0QueryOptions = <TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig0>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig0>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOpenEndedActivityInstanceControllerGetGradingCriteriaConfig0QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig0>>> = ({ signal }) => openEndedActivityInstanceControllerGetGradingCriteriaConfig0(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig0>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OpenEndedActivityInstanceControllerGetGradingCriteriaConfig0QueryResult = NonNullable<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig0>>>
export type OpenEndedActivityInstanceControllerGetGradingCriteriaConfig0QueryError = ErrorType<unknown>


export function useOpenEndedActivityInstanceControllerGetGradingCriteriaConfig0<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig0>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig0>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig0>>,
          TError,
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig0>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpenEndedActivityInstanceControllerGetGradingCriteriaConfig0<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig0>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig0>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig0>>,
          TError,
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig0>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpenEndedActivityInstanceControllerGetGradingCriteriaConfig0<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig0>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig0>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOpenEndedActivityInstanceControllerGetGradingCriteriaConfig0<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig0>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig0>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOpenEndedActivityInstanceControllerGetGradingCriteriaConfig0QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useOpenEndedActivityInstanceControllerGetGradingCriteriaConfig0} query
 */
export const invalidateOpenEndedActivityInstanceControllerGetGradingCriteriaConfig0 = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getOpenEndedActivityInstanceControllerGetGradingCriteriaConfig0QueryKey(id) }, options);

  return queryClient;
}

export const useSetOpenEndedActivityInstanceControllerGetGradingCriteriaConfig0QueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig0>> | undefined | ((old: Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig0>> | undefined) => Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig0>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig0>>>({ exact: $exactMatch, queryKey: getOpenEndedActivityInstanceControllerGetGradingCriteriaConfig0QueryKey(id) }, updater);
  };
}

export const useGetOpenEndedActivityInstanceControllerGetGradingCriteriaConfig0QueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig0>>>(getOpenEndedActivityInstanceControllerGetGradingCriteriaConfig0QueryKey(id));
}



export const openEndedActivityInstanceControllerGetGradingCriteriaConfig1 = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<OpenEndedActivityInstanceControllerGetGradingCriteriaConfig1200>(
      {url: `/open-ended-activity-instances/${id}/grading-criteria-config`, method: 'GET', signal
    },
      options);
    }




export const getOpenEndedActivityInstanceControllerGetGradingCriteriaConfig1QueryKey = (id: string,) => {
    return [
    `/open-ended-activity-instances/${id}/grading-criteria-config`
    ] as const;
    }


export const getOpenEndedActivityInstanceControllerGetGradingCriteriaConfig1QueryOptions = <TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig1>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOpenEndedActivityInstanceControllerGetGradingCriteriaConfig1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig1>>> = ({ signal }) => openEndedActivityInstanceControllerGetGradingCriteriaConfig1(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OpenEndedActivityInstanceControllerGetGradingCriteriaConfig1QueryResult = NonNullable<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig1>>>
export type OpenEndedActivityInstanceControllerGetGradingCriteriaConfig1QueryError = ErrorType<unknown>


export function useOpenEndedActivityInstanceControllerGetGradingCriteriaConfig1<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig1>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig1>>,
          TError,
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpenEndedActivityInstanceControllerGetGradingCriteriaConfig1<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig1>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig1>>,
          TError,
          Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpenEndedActivityInstanceControllerGetGradingCriteriaConfig1<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig1>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOpenEndedActivityInstanceControllerGetGradingCriteriaConfig1<TData = Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig1>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOpenEndedActivityInstanceControllerGetGradingCriteriaConfig1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useOpenEndedActivityInstanceControllerGetGradingCriteriaConfig1} query
 */
export const invalidateOpenEndedActivityInstanceControllerGetGradingCriteriaConfig1 = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getOpenEndedActivityInstanceControllerGetGradingCriteriaConfig1QueryKey(id) }, options);

  return queryClient;
}

export const useSetOpenEndedActivityInstanceControllerGetGradingCriteriaConfig1QueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig1>> | undefined | ((old: Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig1>> | undefined) => Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig1>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig1>>>({ exact: $exactMatch, queryKey: getOpenEndedActivityInstanceControllerGetGradingCriteriaConfig1QueryKey(id) }, updater);
  };
}

export const useGetOpenEndedActivityInstanceControllerGetGradingCriteriaConfig1QueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof openEndedActivityInstanceControllerGetGradingCriteriaConfig1>>>(getOpenEndedActivityInstanceControllerGetGradingCriteriaConfig1QueryKey(id));
}



export const openEndedActivityInstanceControllerSubmitTask0 = (
    id: string,
    taskId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/activity-instances/${id}/tasks/${taskId}/submit`, method: 'POST', signal
    },
      options);
    }




export const getOpenEndedActivityInstanceControllerSubmitTask0MutationKey = () => ['openEndedActivityInstanceControllerSubmitTask0'] as const;

export const getOpenEndedActivityInstanceControllerSubmitTask0MutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerSubmitTask0>>, TError,OpenEndedActivityInstanceControllerSubmitTask0MutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerSubmitTask0>>, TError,OpenEndedActivityInstanceControllerSubmitTask0MutationVariables, TContext> => {

const mutationKey = getOpenEndedActivityInstanceControllerSubmitTask0MutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof openEndedActivityInstanceControllerSubmitTask0>>, OpenEndedActivityInstanceControllerSubmitTask0MutationVariables> = (props) => {
          const {id,taskId} = props ?? {};

          return  openEndedActivityInstanceControllerSubmitTask0(id,taskId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OpenEndedActivityInstanceControllerSubmitTask0MutationResult = NonNullable<Awaited<ReturnType<typeof openEndedActivityInstanceControllerSubmitTask0>>>

    export type OpenEndedActivityInstanceControllerSubmitTask0MutationError = ErrorType<unknown>
    export type OpenEndedActivityInstanceControllerSubmitTask0MutationVariables = {id: string;taskId: string}

    export const useOpenEndedActivityInstanceControllerSubmitTask0 = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerSubmitTask0>>, TError,OpenEndedActivityInstanceControllerSubmitTask0MutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof openEndedActivityInstanceControllerSubmitTask0>>,
        TError,
        OpenEndedActivityInstanceControllerSubmitTask0MutationVariables,
        TContext
      > => {
      return useMutation(getOpenEndedActivityInstanceControllerSubmitTask0MutationOptions(options), queryClient);
    }

export const openEndedActivityInstanceControllerSubmitTask1 = (
    id: string,
    taskId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/open-ended-activity-instances/${id}/tasks/${taskId}/submit`, method: 'POST', signal
    },
      options);
    }




export const getOpenEndedActivityInstanceControllerSubmitTask1MutationKey = () => ['openEndedActivityInstanceControllerSubmitTask1'] as const;

export const getOpenEndedActivityInstanceControllerSubmitTask1MutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerSubmitTask1>>, TError,OpenEndedActivityInstanceControllerSubmitTask1MutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerSubmitTask1>>, TError,OpenEndedActivityInstanceControllerSubmitTask1MutationVariables, TContext> => {

const mutationKey = getOpenEndedActivityInstanceControllerSubmitTask1MutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof openEndedActivityInstanceControllerSubmitTask1>>, OpenEndedActivityInstanceControllerSubmitTask1MutationVariables> = (props) => {
          const {id,taskId} = props ?? {};

          return  openEndedActivityInstanceControllerSubmitTask1(id,taskId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OpenEndedActivityInstanceControllerSubmitTask1MutationResult = NonNullable<Awaited<ReturnType<typeof openEndedActivityInstanceControllerSubmitTask1>>>

    export type OpenEndedActivityInstanceControllerSubmitTask1MutationError = ErrorType<unknown>
    export type OpenEndedActivityInstanceControllerSubmitTask1MutationVariables = {id: string;taskId: string}

    export const useOpenEndedActivityInstanceControllerSubmitTask1 = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerSubmitTask1>>, TError,OpenEndedActivityInstanceControllerSubmitTask1MutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof openEndedActivityInstanceControllerSubmitTask1>>,
        TError,
        OpenEndedActivityInstanceControllerSubmitTask1MutationVariables,
        TContext
      > => {
      return useMutation(getOpenEndedActivityInstanceControllerSubmitTask1MutationOptions(options), queryClient);
    }

export const openEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer0 = (
    id: string,
    taskId: string,
    submitWithModelAnswerDto: BodyType<SubmitWithModelAnswerDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/activity-instances/${id}/tasks/${taskId}/submit-with-model-answer`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitWithModelAnswerDto, signal
    },
      options);
    }




export const getOpenEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer0MutationKey = () => ['openEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer0'] as const;

export const getOpenEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer0MutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer0>>, TError,OpenEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer0MutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer0>>, TError,OpenEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer0MutationVariables, TContext> => {

const mutationKey = getOpenEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer0MutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof openEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer0>>, OpenEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer0MutationVariables> = (props) => {
          const {id,taskId,data} = props ?? {};

          return  openEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer0(id,taskId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OpenEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer0MutationResult = NonNullable<Awaited<ReturnType<typeof openEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer0>>>
    export type OpenEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer0MutationBody = BodyType<SubmitWithModelAnswerDto>
    export type OpenEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer0MutationError = ErrorType<unknown>
    export type OpenEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer0MutationVariables = {id: string;taskId: string;data: BodyType<SubmitWithModelAnswerDto>}

    export const useOpenEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer0 = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer0>>, TError,OpenEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer0MutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof openEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer0>>,
        TError,
        OpenEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer0MutationVariables,
        TContext
      > => {
      return useMutation(getOpenEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer0MutationOptions(options), queryClient);
    }

export const openEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer1 = (
    id: string,
    taskId: string,
    submitWithModelAnswerDto: BodyType<SubmitWithModelAnswerDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/open-ended-activity-instances/${id}/tasks/${taskId}/submit-with-model-answer`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitWithModelAnswerDto, signal
    },
      options);
    }




export const getOpenEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer1MutationKey = () => ['openEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer1'] as const;

export const getOpenEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer1MutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer1>>, TError,OpenEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer1MutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer1>>, TError,OpenEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer1MutationVariables, TContext> => {

const mutationKey = getOpenEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer1MutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof openEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer1>>, OpenEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer1MutationVariables> = (props) => {
          const {id,taskId,data} = props ?? {};

          return  openEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer1(id,taskId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OpenEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer1MutationResult = NonNullable<Awaited<ReturnType<typeof openEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer1>>>
    export type OpenEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer1MutationBody = BodyType<SubmitWithModelAnswerDto>
    export type OpenEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer1MutationError = ErrorType<unknown>
    export type OpenEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer1MutationVariables = {id: string;taskId: string;data: BodyType<SubmitWithModelAnswerDto>}

    export const useOpenEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer1 = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer1>>, TError,OpenEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer1MutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof openEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer1>>,
        TError,
        OpenEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer1MutationVariables,
        TContext
      > => {
      return useMutation(getOpenEndedActivityInstanceControllerSubmitOpenAnswerWithModelAnswer1MutationOptions(options), queryClient);
    }

export const openEndedActivityInstanceControllerCompleteOpenAnswerTask0 = (
    id: string,
    taskTransactionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<OpenEndedActivityInstanceControllerCompleteOpenAnswerTask0201>(
      {url: `/activity-instances/${id}/task-transactions/${taskTransactionId}/complete-open-answer`, method: 'POST', signal
    },
      options);
    }




export const getOpenEndedActivityInstanceControllerCompleteOpenAnswerTask0MutationKey = () => ['openEndedActivityInstanceControllerCompleteOpenAnswerTask0'] as const;

export const getOpenEndedActivityInstanceControllerCompleteOpenAnswerTask0MutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerCompleteOpenAnswerTask0>>, TError,OpenEndedActivityInstanceControllerCompleteOpenAnswerTask0MutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerCompleteOpenAnswerTask0>>, TError,OpenEndedActivityInstanceControllerCompleteOpenAnswerTask0MutationVariables, TContext> => {

const mutationKey = getOpenEndedActivityInstanceControllerCompleteOpenAnswerTask0MutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof openEndedActivityInstanceControllerCompleteOpenAnswerTask0>>, OpenEndedActivityInstanceControllerCompleteOpenAnswerTask0MutationVariables> = (props) => {
          const {id,taskTransactionId} = props ?? {};

          return  openEndedActivityInstanceControllerCompleteOpenAnswerTask0(id,taskTransactionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OpenEndedActivityInstanceControllerCompleteOpenAnswerTask0MutationResult = NonNullable<Awaited<ReturnType<typeof openEndedActivityInstanceControllerCompleteOpenAnswerTask0>>>

    export type OpenEndedActivityInstanceControllerCompleteOpenAnswerTask0MutationError = ErrorType<unknown>
    export type OpenEndedActivityInstanceControllerCompleteOpenAnswerTask0MutationVariables = {id: string;taskTransactionId: string}

    export const useOpenEndedActivityInstanceControllerCompleteOpenAnswerTask0 = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerCompleteOpenAnswerTask0>>, TError,OpenEndedActivityInstanceControllerCompleteOpenAnswerTask0MutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof openEndedActivityInstanceControllerCompleteOpenAnswerTask0>>,
        TError,
        OpenEndedActivityInstanceControllerCompleteOpenAnswerTask0MutationVariables,
        TContext
      > => {
      return useMutation(getOpenEndedActivityInstanceControllerCompleteOpenAnswerTask0MutationOptions(options), queryClient);
    }

export const openEndedActivityInstanceControllerCompleteOpenAnswerTask1 = (
    id: string,
    taskTransactionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<OpenEndedActivityInstanceControllerCompleteOpenAnswerTask1201>(
      {url: `/open-ended-activity-instances/${id}/task-transactions/${taskTransactionId}/complete-open-answer`, method: 'POST', signal
    },
      options);
    }




export const getOpenEndedActivityInstanceControllerCompleteOpenAnswerTask1MutationKey = () => ['openEndedActivityInstanceControllerCompleteOpenAnswerTask1'] as const;

export const getOpenEndedActivityInstanceControllerCompleteOpenAnswerTask1MutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerCompleteOpenAnswerTask1>>, TError,OpenEndedActivityInstanceControllerCompleteOpenAnswerTask1MutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerCompleteOpenAnswerTask1>>, TError,OpenEndedActivityInstanceControllerCompleteOpenAnswerTask1MutationVariables, TContext> => {

const mutationKey = getOpenEndedActivityInstanceControllerCompleteOpenAnswerTask1MutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof openEndedActivityInstanceControllerCompleteOpenAnswerTask1>>, OpenEndedActivityInstanceControllerCompleteOpenAnswerTask1MutationVariables> = (props) => {
          const {id,taskTransactionId} = props ?? {};

          return  openEndedActivityInstanceControllerCompleteOpenAnswerTask1(id,taskTransactionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OpenEndedActivityInstanceControllerCompleteOpenAnswerTask1MutationResult = NonNullable<Awaited<ReturnType<typeof openEndedActivityInstanceControllerCompleteOpenAnswerTask1>>>

    export type OpenEndedActivityInstanceControllerCompleteOpenAnswerTask1MutationError = ErrorType<unknown>
    export type OpenEndedActivityInstanceControllerCompleteOpenAnswerTask1MutationVariables = {id: string;taskTransactionId: string}

    export const useOpenEndedActivityInstanceControllerCompleteOpenAnswerTask1 = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerCompleteOpenAnswerTask1>>, TError,OpenEndedActivityInstanceControllerCompleteOpenAnswerTask1MutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof openEndedActivityInstanceControllerCompleteOpenAnswerTask1>>,
        TError,
        OpenEndedActivityInstanceControllerCompleteOpenAnswerTask1MutationVariables,
        TContext
      > => {
      return useMutation(getOpenEndedActivityInstanceControllerCompleteOpenAnswerTask1MutationOptions(options), queryClient);
    }

export const openEndedActivityInstanceControllerCompleteActivityInstance0 = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<OpenEndedActivityInstanceControllerCompleteActivityInstance0201>(
      {url: `/activity-instances/${id}/complete`, method: 'POST', signal
    },
      options);
    }




export const getOpenEndedActivityInstanceControllerCompleteActivityInstance0MutationKey = () => ['openEndedActivityInstanceControllerCompleteActivityInstance0'] as const;

export const getOpenEndedActivityInstanceControllerCompleteActivityInstance0MutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerCompleteActivityInstance0>>, TError,OpenEndedActivityInstanceControllerCompleteActivityInstance0MutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerCompleteActivityInstance0>>, TError,OpenEndedActivityInstanceControllerCompleteActivityInstance0MutationVariables, TContext> => {

const mutationKey = getOpenEndedActivityInstanceControllerCompleteActivityInstance0MutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof openEndedActivityInstanceControllerCompleteActivityInstance0>>, OpenEndedActivityInstanceControllerCompleteActivityInstance0MutationVariables> = (props) => {
          const {id} = props ?? {};

          return  openEndedActivityInstanceControllerCompleteActivityInstance0(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OpenEndedActivityInstanceControllerCompleteActivityInstance0MutationResult = NonNullable<Awaited<ReturnType<typeof openEndedActivityInstanceControllerCompleteActivityInstance0>>>

    export type OpenEndedActivityInstanceControllerCompleteActivityInstance0MutationError = ErrorType<unknown>
    export type OpenEndedActivityInstanceControllerCompleteActivityInstance0MutationVariables = {id: string}

    export const useOpenEndedActivityInstanceControllerCompleteActivityInstance0 = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerCompleteActivityInstance0>>, TError,OpenEndedActivityInstanceControllerCompleteActivityInstance0MutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof openEndedActivityInstanceControllerCompleteActivityInstance0>>,
        TError,
        OpenEndedActivityInstanceControllerCompleteActivityInstance0MutationVariables,
        TContext
      > => {
      return useMutation(getOpenEndedActivityInstanceControllerCompleteActivityInstance0MutationOptions(options), queryClient);
    }

export const openEndedActivityInstanceControllerCompleteActivityInstance1 = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<OpenEndedActivityInstanceControllerCompleteActivityInstance1201>(
      {url: `/open-ended-activity-instances/${id}/complete`, method: 'POST', signal
    },
      options);
    }




export const getOpenEndedActivityInstanceControllerCompleteActivityInstance1MutationKey = () => ['openEndedActivityInstanceControllerCompleteActivityInstance1'] as const;

export const getOpenEndedActivityInstanceControllerCompleteActivityInstance1MutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerCompleteActivityInstance1>>, TError,OpenEndedActivityInstanceControllerCompleteActivityInstance1MutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerCompleteActivityInstance1>>, TError,OpenEndedActivityInstanceControllerCompleteActivityInstance1MutationVariables, TContext> => {

const mutationKey = getOpenEndedActivityInstanceControllerCompleteActivityInstance1MutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof openEndedActivityInstanceControllerCompleteActivityInstance1>>, OpenEndedActivityInstanceControllerCompleteActivityInstance1MutationVariables> = (props) => {
          const {id} = props ?? {};

          return  openEndedActivityInstanceControllerCompleteActivityInstance1(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OpenEndedActivityInstanceControllerCompleteActivityInstance1MutationResult = NonNullable<Awaited<ReturnType<typeof openEndedActivityInstanceControllerCompleteActivityInstance1>>>

    export type OpenEndedActivityInstanceControllerCompleteActivityInstance1MutationError = ErrorType<unknown>
    export type OpenEndedActivityInstanceControllerCompleteActivityInstance1MutationVariables = {id: string}

    export const useOpenEndedActivityInstanceControllerCompleteActivityInstance1 = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openEndedActivityInstanceControllerCompleteActivityInstance1>>, TError,OpenEndedActivityInstanceControllerCompleteActivityInstance1MutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof openEndedActivityInstanceControllerCompleteActivityInstance1>>,
        TError,
        OpenEndedActivityInstanceControllerCompleteActivityInstance1MutationVariables,
        TContext
      > => {
      return useMutation(getOpenEndedActivityInstanceControllerCompleteActivityInstance1MutationOptions(options), queryClient);
    }

export const taskControllerFindById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Task>(
      {url: `/tasks/${id}`, method: 'GET', signal
    },
      options);
    }




export const getTaskControllerFindByIdQueryKey = (id: string,) => {
    return [
    `/tasks/${id}`
    ] as const;
    }


export const getTaskControllerFindByIdQueryOptions = <TData = Awaited<ReturnType<typeof taskControllerFindById>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTaskControllerFindByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof taskControllerFindById>>> = ({ signal }) => taskControllerFindById(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof taskControllerFindById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TaskControllerFindByIdQueryResult = NonNullable<Awaited<ReturnType<typeof taskControllerFindById>>>
export type TaskControllerFindByIdQueryError = ErrorType<unknown>


export function useTaskControllerFindById<TData = Awaited<ReturnType<typeof taskControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskControllerFindById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof taskControllerFindById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskControllerFindById<TData = Awaited<ReturnType<typeof taskControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskControllerFindById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof taskControllerFindById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskControllerFindById<TData = Awaited<ReturnType<typeof taskControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTaskControllerFindById<TData = Awaited<ReturnType<typeof taskControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTaskControllerFindByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useTaskControllerFindById} query
 */
export const invalidateTaskControllerFindById = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getTaskControllerFindByIdQueryKey(id) }, options);

  return queryClient;
}

export const useSetTaskControllerFindByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof taskControllerFindById>> | undefined | ((old: Awaited<ReturnType<typeof taskControllerFindById>> | undefined) => Awaited<ReturnType<typeof taskControllerFindById>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof taskControllerFindById>>>({ exact: $exactMatch, queryKey: getTaskControllerFindByIdQueryKey(id) }, updater);
  };
}

export const useGetTaskControllerFindByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof taskControllerFindById>>>(getTaskControllerFindByIdQueryKey(id));
}



export const taskControllerFindTaskTransactionByTaskId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TaskTransaction>(
      {url: `/tasks/${id}/task-transaction`, method: 'GET', signal
    },
      options);
    }




export const getTaskControllerFindTaskTransactionByTaskIdQueryKey = (id: string,) => {
    return [
    `/tasks/${id}/task-transaction`
    ] as const;
    }


export const getTaskControllerFindTaskTransactionByTaskIdQueryOptions = <TData = Awaited<ReturnType<typeof taskControllerFindTaskTransactionByTaskId>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskControllerFindTaskTransactionByTaskId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTaskControllerFindTaskTransactionByTaskIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof taskControllerFindTaskTransactionByTaskId>>> = ({ signal }) => taskControllerFindTaskTransactionByTaskId(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof taskControllerFindTaskTransactionByTaskId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TaskControllerFindTaskTransactionByTaskIdQueryResult = NonNullable<Awaited<ReturnType<typeof taskControllerFindTaskTransactionByTaskId>>>
export type TaskControllerFindTaskTransactionByTaskIdQueryError = ErrorType<unknown>


export function useTaskControllerFindTaskTransactionByTaskId<TData = Awaited<ReturnType<typeof taskControllerFindTaskTransactionByTaskId>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskControllerFindTaskTransactionByTaskId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskControllerFindTaskTransactionByTaskId>>,
          TError,
          Awaited<ReturnType<typeof taskControllerFindTaskTransactionByTaskId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskControllerFindTaskTransactionByTaskId<TData = Awaited<ReturnType<typeof taskControllerFindTaskTransactionByTaskId>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskControllerFindTaskTransactionByTaskId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskControllerFindTaskTransactionByTaskId>>,
          TError,
          Awaited<ReturnType<typeof taskControllerFindTaskTransactionByTaskId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskControllerFindTaskTransactionByTaskId<TData = Awaited<ReturnType<typeof taskControllerFindTaskTransactionByTaskId>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskControllerFindTaskTransactionByTaskId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTaskControllerFindTaskTransactionByTaskId<TData = Awaited<ReturnType<typeof taskControllerFindTaskTransactionByTaskId>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskControllerFindTaskTransactionByTaskId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTaskControllerFindTaskTransactionByTaskIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useTaskControllerFindTaskTransactionByTaskId} query
 */
export const invalidateTaskControllerFindTaskTransactionByTaskId = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getTaskControllerFindTaskTransactionByTaskIdQueryKey(id) }, options);

  return queryClient;
}

export const useSetTaskControllerFindTaskTransactionByTaskIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof taskControllerFindTaskTransactionByTaskId>> | undefined | ((old: Awaited<ReturnType<typeof taskControllerFindTaskTransactionByTaskId>> | undefined) => Awaited<ReturnType<typeof taskControllerFindTaskTransactionByTaskId>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof taskControllerFindTaskTransactionByTaskId>>>({ exact: $exactMatch, queryKey: getTaskControllerFindTaskTransactionByTaskIdQueryKey(id) }, updater);
  };
}

export const useGetTaskControllerFindTaskTransactionByTaskIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof taskControllerFindTaskTransactionByTaskId>>>(getTaskControllerFindTaskTransactionByTaskIdQueryKey(id));
}



export const taskControllerReParaphrase = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ParaphrasingTask>(
      {url: `/tasks/${id}/re-paraphrase`, method: 'POST', signal
    },
      options);
    }




export const getTaskControllerReParaphraseMutationKey = () => ['taskControllerReParaphrase'] as const;

export const getTaskControllerReParaphraseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taskControllerReParaphrase>>, TError,TaskControllerReParaphraseMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof taskControllerReParaphrase>>, TError,TaskControllerReParaphraseMutationVariables, TContext> => {

const mutationKey = getTaskControllerReParaphraseMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof taskControllerReParaphrase>>, TaskControllerReParaphraseMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  taskControllerReParaphrase(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TaskControllerReParaphraseMutationResult = NonNullable<Awaited<ReturnType<typeof taskControllerReParaphrase>>>

    export type TaskControllerReParaphraseMutationError = ErrorType<unknown>
    export type TaskControllerReParaphraseMutationVariables = {id: string}

    export const useTaskControllerReParaphrase = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taskControllerReParaphrase>>, TError,TaskControllerReParaphraseMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof taskControllerReParaphrase>>,
        TError,
        TaskControllerReParaphraseMutationVariables,
        TContext
      > => {
      return useMutation(getTaskControllerReParaphraseMutationOptions(options), queryClient);
    }

export const taskControllerCanReParaphrase = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<boolean>(
      {url: `/tasks/${id}/can-re-paraphrase`, method: 'GET', signal
    },
      options);
    }




export const getTaskControllerCanReParaphraseQueryKey = (id: string,) => {
    return [
    `/tasks/${id}/can-re-paraphrase`
    ] as const;
    }


export const getTaskControllerCanReParaphraseQueryOptions = <TData = Awaited<ReturnType<typeof taskControllerCanReParaphrase>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskControllerCanReParaphrase>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTaskControllerCanReParaphraseQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof taskControllerCanReParaphrase>>> = ({ signal }) => taskControllerCanReParaphrase(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof taskControllerCanReParaphrase>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TaskControllerCanReParaphraseQueryResult = NonNullable<Awaited<ReturnType<typeof taskControllerCanReParaphrase>>>
export type TaskControllerCanReParaphraseQueryError = ErrorType<unknown>


export function useTaskControllerCanReParaphrase<TData = Awaited<ReturnType<typeof taskControllerCanReParaphrase>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskControllerCanReParaphrase>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskControllerCanReParaphrase>>,
          TError,
          Awaited<ReturnType<typeof taskControllerCanReParaphrase>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskControllerCanReParaphrase<TData = Awaited<ReturnType<typeof taskControllerCanReParaphrase>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskControllerCanReParaphrase>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskControllerCanReParaphrase>>,
          TError,
          Awaited<ReturnType<typeof taskControllerCanReParaphrase>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskControllerCanReParaphrase<TData = Awaited<ReturnType<typeof taskControllerCanReParaphrase>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskControllerCanReParaphrase>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTaskControllerCanReParaphrase<TData = Awaited<ReturnType<typeof taskControllerCanReParaphrase>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskControllerCanReParaphrase>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTaskControllerCanReParaphraseQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useTaskControllerCanReParaphrase} query
 */
export const invalidateTaskControllerCanReParaphrase = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getTaskControllerCanReParaphraseQueryKey(id) }, options);

  return queryClient;
}

export const useSetTaskControllerCanReParaphraseQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof taskControllerCanReParaphrase>> | undefined | ((old: Awaited<ReturnType<typeof taskControllerCanReParaphrase>> | undefined) => Awaited<ReturnType<typeof taskControllerCanReParaphrase>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof taskControllerCanReParaphrase>>>({ exact: $exactMatch, queryKey: getTaskControllerCanReParaphraseQueryKey(id) }, updater);
  };
}

export const useGetTaskControllerCanReParaphraseQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof taskControllerCanReParaphrase>>>(getTaskControllerCanReParaphraseQueryKey(id));
}



/**
 * @summary Question count for "question x of N" in Modular, where the session has no question groups.
Tasks expanded from a Quiz Group carry its id as `taskTemplateId`.
 */
export const taskControllerGetQuizGroupQuestionCount = (
    taskTemplateId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<QuizGroupQuestionCountResponseDto>(
      {url: `/tasks/quiz-group/${taskTemplateId}/question-count`, method: 'GET', signal
    },
      options);
    }




export const getTaskControllerGetQuizGroupQuestionCountQueryKey = (taskTemplateId: string,) => {
    return [
    `/tasks/quiz-group/${taskTemplateId}/question-count`
    ] as const;
    }


export const getTaskControllerGetQuizGroupQuestionCountQueryOptions = <TData = Awaited<ReturnType<typeof taskControllerGetQuizGroupQuestionCount>>, TError = ErrorType<unknown>>(taskTemplateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskControllerGetQuizGroupQuestionCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTaskControllerGetQuizGroupQuestionCountQueryKey(taskTemplateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof taskControllerGetQuizGroupQuestionCount>>> = ({ signal }) => taskControllerGetQuizGroupQuestionCount(taskTemplateId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: taskTemplateId !== null && taskTemplateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof taskControllerGetQuizGroupQuestionCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TaskControllerGetQuizGroupQuestionCountQueryResult = NonNullable<Awaited<ReturnType<typeof taskControllerGetQuizGroupQuestionCount>>>
export type TaskControllerGetQuizGroupQuestionCountQueryError = ErrorType<unknown>


export function useTaskControllerGetQuizGroupQuestionCount<TData = Awaited<ReturnType<typeof taskControllerGetQuizGroupQuestionCount>>, TError = ErrorType<unknown>>(
 taskTemplateId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskControllerGetQuizGroupQuestionCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskControllerGetQuizGroupQuestionCount>>,
          TError,
          Awaited<ReturnType<typeof taskControllerGetQuizGroupQuestionCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskControllerGetQuizGroupQuestionCount<TData = Awaited<ReturnType<typeof taskControllerGetQuizGroupQuestionCount>>, TError = ErrorType<unknown>>(
 taskTemplateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskControllerGetQuizGroupQuestionCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskControllerGetQuizGroupQuestionCount>>,
          TError,
          Awaited<ReturnType<typeof taskControllerGetQuizGroupQuestionCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskControllerGetQuizGroupQuestionCount<TData = Awaited<ReturnType<typeof taskControllerGetQuizGroupQuestionCount>>, TError = ErrorType<unknown>>(
 taskTemplateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskControllerGetQuizGroupQuestionCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Question count for "question x of N" in Modular, where the session has no question groups.
Tasks expanded from a Quiz Group carry its id as `taskTemplateId`.
 */

export function useTaskControllerGetQuizGroupQuestionCount<TData = Awaited<ReturnType<typeof taskControllerGetQuizGroupQuestionCount>>, TError = ErrorType<unknown>>(
 taskTemplateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskControllerGetQuizGroupQuestionCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTaskControllerGetQuizGroupQuestionCountQueryOptions(taskTemplateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useTaskControllerGetQuizGroupQuestionCount} query
 */
export const invalidateTaskControllerGetQuizGroupQuestionCount = async (
 queryClient: QueryClient, taskTemplateId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getTaskControllerGetQuizGroupQuestionCountQueryKey(taskTemplateId) }, options);

  return queryClient;
}

/**
 * @summary Question count for "question x of N" in Modular, where the session has no question groups.
Tasks expanded from a Quiz Group carry its id as `taskTemplateId`.
 */
export const useSetTaskControllerGetQuizGroupQuestionCountQueryData = () => {
  const queryClient = useQueryClient();
  return (taskTemplateId: string,updater: Awaited<ReturnType<typeof taskControllerGetQuizGroupQuestionCount>> | undefined | ((old: Awaited<ReturnType<typeof taskControllerGetQuizGroupQuestionCount>> | undefined) => Awaited<ReturnType<typeof taskControllerGetQuizGroupQuestionCount>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof taskControllerGetQuizGroupQuestionCount>>>({ exact: $exactMatch, queryKey: getTaskControllerGetQuizGroupQuestionCountQueryKey(taskTemplateId) }, updater);
  };
}

/**
 * @summary Question count for "question x of N" in Modular, where the session has no question groups.
Tasks expanded from a Quiz Group carry its id as `taskTemplateId`.
 */
export const useGetTaskControllerGetQuizGroupQuestionCountQueryData = () => {
  const queryClient = useQueryClient();
  return (taskTemplateId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof taskControllerGetQuizGroupQuestionCount>>>(getTaskControllerGetQuizGroupQuestionCountQueryKey(taskTemplateId));
}



export const createYourOwnResponseTaskControllerUseHelper = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CreateYourOwnResponseTaskTransaction>(
      {url: `/cyor-task/${id}/use-helper`, method: 'POST', signal
    },
      options);
    }




export const getCreateYourOwnResponseTaskControllerUseHelperMutationKey = () => ['createYourOwnResponseTaskControllerUseHelper'] as const;

export const getCreateYourOwnResponseTaskControllerUseHelperMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createYourOwnResponseTaskControllerUseHelper>>, TError,CreateYourOwnResponseTaskControllerUseHelperMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createYourOwnResponseTaskControllerUseHelper>>, TError,CreateYourOwnResponseTaskControllerUseHelperMutationVariables, TContext> => {

const mutationKey = getCreateYourOwnResponseTaskControllerUseHelperMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createYourOwnResponseTaskControllerUseHelper>>, CreateYourOwnResponseTaskControllerUseHelperMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  createYourOwnResponseTaskControllerUseHelper(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateYourOwnResponseTaskControllerUseHelperMutationResult = NonNullable<Awaited<ReturnType<typeof createYourOwnResponseTaskControllerUseHelper>>>

    export type CreateYourOwnResponseTaskControllerUseHelperMutationError = ErrorType<unknown>
    export type CreateYourOwnResponseTaskControllerUseHelperMutationVariables = {id: string}

    export const useCreateYourOwnResponseTaskControllerUseHelper = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createYourOwnResponseTaskControllerUseHelper>>, TError,CreateYourOwnResponseTaskControllerUseHelperMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createYourOwnResponseTaskControllerUseHelper>>,
        TError,
        CreateYourOwnResponseTaskControllerUseHelperMutationVariables,
        TContext
      > => {
      return useMutation(getCreateYourOwnResponseTaskControllerUseHelperMutationOptions(options), queryClient);
    }

export const aiBeControllerDiffSentence = (
    aiDiffSentenceRequestDto: BodyType<AiDiffSentenceRequestDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AiDiffSentenceOperation[]>(
      {url: `/ai/diff-sentence`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aiDiffSentenceRequestDto, signal
    },
      options);
    }




export const getAiBeControllerDiffSentenceMutationKey = () => ['aiBeControllerDiffSentence'] as const;

export const getAiBeControllerDiffSentenceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiBeControllerDiffSentence>>, TError,AiBeControllerDiffSentenceMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof aiBeControllerDiffSentence>>, TError,AiBeControllerDiffSentenceMutationVariables, TContext> => {

const mutationKey = getAiBeControllerDiffSentenceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aiBeControllerDiffSentence>>, AiBeControllerDiffSentenceMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  aiBeControllerDiffSentence(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AiBeControllerDiffSentenceMutationResult = NonNullable<Awaited<ReturnType<typeof aiBeControllerDiffSentence>>>
    export type AiBeControllerDiffSentenceMutationBody = BodyType<AiDiffSentenceRequestDto>
    export type AiBeControllerDiffSentenceMutationError = ErrorType<unknown>
    export type AiBeControllerDiffSentenceMutationVariables = {data: BodyType<AiDiffSentenceRequestDto>}

    export const useAiBeControllerDiffSentence = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiBeControllerDiffSentence>>, TError,AiBeControllerDiffSentenceMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof aiBeControllerDiffSentence>>,
        TError,
        AiBeControllerDiffSentenceMutationVariables,
        TContext
      > => {
      return useMutation(getAiBeControllerDiffSentenceMutationOptions(options), queryClient);
    }

export const aiBeControllerGetSentenceSimilarity = (
    aiSentenceSimilarityRequestDto: BodyType<AiSentenceSimilarityRequestDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AiSentenceSimilarityResponseData>(
      {url: `/ai/sentence-similarity`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aiSentenceSimilarityRequestDto, signal
    },
      options);
    }




export const getAiBeControllerGetSentenceSimilarityMutationKey = () => ['aiBeControllerGetSentenceSimilarity'] as const;

export const getAiBeControllerGetSentenceSimilarityMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiBeControllerGetSentenceSimilarity>>, TError,AiBeControllerGetSentenceSimilarityMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof aiBeControllerGetSentenceSimilarity>>, TError,AiBeControllerGetSentenceSimilarityMutationVariables, TContext> => {

const mutationKey = getAiBeControllerGetSentenceSimilarityMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aiBeControllerGetSentenceSimilarity>>, AiBeControllerGetSentenceSimilarityMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  aiBeControllerGetSentenceSimilarity(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AiBeControllerGetSentenceSimilarityMutationResult = NonNullable<Awaited<ReturnType<typeof aiBeControllerGetSentenceSimilarity>>>
    export type AiBeControllerGetSentenceSimilarityMutationBody = BodyType<AiSentenceSimilarityRequestDto>
    export type AiBeControllerGetSentenceSimilarityMutationError = ErrorType<unknown>
    export type AiBeControllerGetSentenceSimilarityMutationVariables = {data: BodyType<AiSentenceSimilarityRequestDto>}

    export const useAiBeControllerGetSentenceSimilarity = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiBeControllerGetSentenceSimilarity>>, TError,AiBeControllerGetSentenceSimilarityMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof aiBeControllerGetSentenceSimilarity>>,
        TError,
        AiBeControllerGetSentenceSimilarityMutationVariables,
        TContext
      > => {
      return useMutation(getAiBeControllerGetSentenceSimilarityMutationOptions(options), queryClient);
    }

export const aiBeControllerGetParsedTextContent = (
    aiParseToParsedTextContentRequestDto: BodyType<AiParseToParsedTextContentRequestDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ParsedTextContent[]>(
      {url: `/ai/parse-text-content`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aiParseToParsedTextContentRequestDto, signal
    },
      options);
    }




export const getAiBeControllerGetParsedTextContentMutationKey = () => ['aiBeControllerGetParsedTextContent'] as const;

export const getAiBeControllerGetParsedTextContentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiBeControllerGetParsedTextContent>>, TError,AiBeControllerGetParsedTextContentMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof aiBeControllerGetParsedTextContent>>, TError,AiBeControllerGetParsedTextContentMutationVariables, TContext> => {

const mutationKey = getAiBeControllerGetParsedTextContentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aiBeControllerGetParsedTextContent>>, AiBeControllerGetParsedTextContentMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  aiBeControllerGetParsedTextContent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AiBeControllerGetParsedTextContentMutationResult = NonNullable<Awaited<ReturnType<typeof aiBeControllerGetParsedTextContent>>>
    export type AiBeControllerGetParsedTextContentMutationBody = BodyType<AiParseToParsedTextContentRequestDto>
    export type AiBeControllerGetParsedTextContentMutationError = ErrorType<unknown>
    export type AiBeControllerGetParsedTextContentMutationVariables = {data: BodyType<AiParseToParsedTextContentRequestDto>}

    export const useAiBeControllerGetParsedTextContent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiBeControllerGetParsedTextContent>>, TError,AiBeControllerGetParsedTextContentMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof aiBeControllerGetParsedTextContent>>,
        TError,
        AiBeControllerGetParsedTextContentMutationVariables,
        TContext
      > => {
      return useMutation(getAiBeControllerGetParsedTextContentMutationOptions(options), queryClient);
    }

export const aiBeControllerGetGrammarFeedBack = (
    aiGradeGrammarRequestDto: BodyType<AiGradeGrammarRequestDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AiGradeGrammarResponseData>(
      {url: `/ai/grade-grammar`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aiGradeGrammarRequestDto, signal
    },
      options);
    }




export const getAiBeControllerGetGrammarFeedBackMutationKey = () => ['aiBeControllerGetGrammarFeedBack'] as const;

export const getAiBeControllerGetGrammarFeedBackMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiBeControllerGetGrammarFeedBack>>, TError,AiBeControllerGetGrammarFeedBackMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof aiBeControllerGetGrammarFeedBack>>, TError,AiBeControllerGetGrammarFeedBackMutationVariables, TContext> => {

const mutationKey = getAiBeControllerGetGrammarFeedBackMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aiBeControllerGetGrammarFeedBack>>, AiBeControllerGetGrammarFeedBackMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  aiBeControllerGetGrammarFeedBack(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AiBeControllerGetGrammarFeedBackMutationResult = NonNullable<Awaited<ReturnType<typeof aiBeControllerGetGrammarFeedBack>>>
    export type AiBeControllerGetGrammarFeedBackMutationBody = BodyType<AiGradeGrammarRequestDto>
    export type AiBeControllerGetGrammarFeedBackMutationError = ErrorType<unknown>
    export type AiBeControllerGetGrammarFeedBackMutationVariables = {data: BodyType<AiGradeGrammarRequestDto>}

    export const useAiBeControllerGetGrammarFeedBack = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiBeControllerGetGrammarFeedBack>>, TError,AiBeControllerGetGrammarFeedBackMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof aiBeControllerGetGrammarFeedBack>>,
        TError,
        AiBeControllerGetGrammarFeedBackMutationVariables,
        TContext
      > => {
      return useMutation(getAiBeControllerGetGrammarFeedBackMutationOptions(options), queryClient);
    }

export const featureFlagControllerGetFeatureFlags = (
    featureFlagName: BodyType<FeatureFlagName[]>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FeatureFlag[]>(
      {url: `/feature-flags/get-by-ids`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: featureFlagName, signal
    },
      options);
    }




export const getFeatureFlagControllerGetFeatureFlagsMutationKey = () => ['featureFlagControllerGetFeatureFlags'] as const;

export const getFeatureFlagControllerGetFeatureFlagsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof featureFlagControllerGetFeatureFlags>>, TError,FeatureFlagControllerGetFeatureFlagsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof featureFlagControllerGetFeatureFlags>>, TError,FeatureFlagControllerGetFeatureFlagsMutationVariables, TContext> => {

const mutationKey = getFeatureFlagControllerGetFeatureFlagsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof featureFlagControllerGetFeatureFlags>>, FeatureFlagControllerGetFeatureFlagsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  featureFlagControllerGetFeatureFlags(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FeatureFlagControllerGetFeatureFlagsMutationResult = NonNullable<Awaited<ReturnType<typeof featureFlagControllerGetFeatureFlags>>>
    export type FeatureFlagControllerGetFeatureFlagsMutationBody = BodyType<FeatureFlagName[]>
    export type FeatureFlagControllerGetFeatureFlagsMutationError = ErrorType<unknown>
    export type FeatureFlagControllerGetFeatureFlagsMutationVariables = {data: BodyType<FeatureFlagName[]>}

    export const useFeatureFlagControllerGetFeatureFlags = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof featureFlagControllerGetFeatureFlags>>, TError,FeatureFlagControllerGetFeatureFlagsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof featureFlagControllerGetFeatureFlags>>,
        TError,
        FeatureFlagControllerGetFeatureFlagsMutationVariables,
        TContext
      > => {
      return useMutation(getFeatureFlagControllerGetFeatureFlagsMutationOptions(options), queryClient);
    }

export const featureFlagControllerGetAllFeatureFlags = (
    params?: FeatureFlagControllerGetAllFeatureFlagsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FeatureFlag[]>(
      {url: `/feature-flags`, method: 'GET',
        params, signal
    },
      options);
    }




export const getFeatureFlagControllerGetAllFeatureFlagsQueryKey = (params?: FeatureFlagControllerGetAllFeatureFlagsParams,) => {
    return [
    `/feature-flags`, ...(params ? [params] : [])
    ] as const;
    }


export const getFeatureFlagControllerGetAllFeatureFlagsQueryOptions = <TData = Awaited<ReturnType<typeof featureFlagControllerGetAllFeatureFlags>>, TError = ErrorType<unknown>>(params?: FeatureFlagControllerGetAllFeatureFlagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagControllerGetAllFeatureFlags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeatureFlagControllerGetAllFeatureFlagsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof featureFlagControllerGetAllFeatureFlags>>> = ({ signal }) => featureFlagControllerGetAllFeatureFlags(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof featureFlagControllerGetAllFeatureFlags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FeatureFlagControllerGetAllFeatureFlagsQueryResult = NonNullable<Awaited<ReturnType<typeof featureFlagControllerGetAllFeatureFlags>>>
export type FeatureFlagControllerGetAllFeatureFlagsQueryError = ErrorType<unknown>


export function useFeatureFlagControllerGetAllFeatureFlags<TData = Awaited<ReturnType<typeof featureFlagControllerGetAllFeatureFlags>>, TError = ErrorType<unknown>>(
 params: undefined |  FeatureFlagControllerGetAllFeatureFlagsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagControllerGetAllFeatureFlags>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof featureFlagControllerGetAllFeatureFlags>>,
          TError,
          Awaited<ReturnType<typeof featureFlagControllerGetAllFeatureFlags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFeatureFlagControllerGetAllFeatureFlags<TData = Awaited<ReturnType<typeof featureFlagControllerGetAllFeatureFlags>>, TError = ErrorType<unknown>>(
 params?: FeatureFlagControllerGetAllFeatureFlagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagControllerGetAllFeatureFlags>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof featureFlagControllerGetAllFeatureFlags>>,
          TError,
          Awaited<ReturnType<typeof featureFlagControllerGetAllFeatureFlags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFeatureFlagControllerGetAllFeatureFlags<TData = Awaited<ReturnType<typeof featureFlagControllerGetAllFeatureFlags>>, TError = ErrorType<unknown>>(
 params?: FeatureFlagControllerGetAllFeatureFlagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagControllerGetAllFeatureFlags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useFeatureFlagControllerGetAllFeatureFlags<TData = Awaited<ReturnType<typeof featureFlagControllerGetAllFeatureFlags>>, TError = ErrorType<unknown>>(
 params?: FeatureFlagControllerGetAllFeatureFlagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagControllerGetAllFeatureFlags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFeatureFlagControllerGetAllFeatureFlagsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useFeatureFlagControllerGetAllFeatureFlags} query
 */
export const invalidateFeatureFlagControllerGetAllFeatureFlags = async (
 queryClient: QueryClient, params?: FeatureFlagControllerGetAllFeatureFlagsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getFeatureFlagControllerGetAllFeatureFlagsQueryKey(params) }, options);

  return queryClient;
}

export const useSetFeatureFlagControllerGetAllFeatureFlagsQueryData = () => {
  const queryClient = useQueryClient();
  return (params: FeatureFlagControllerGetAllFeatureFlagsParams | undefined,updater: Awaited<ReturnType<typeof featureFlagControllerGetAllFeatureFlags>> | undefined | ((old: Awaited<ReturnType<typeof featureFlagControllerGetAllFeatureFlags>> | undefined) => Awaited<ReturnType<typeof featureFlagControllerGetAllFeatureFlags>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof featureFlagControllerGetAllFeatureFlags>>>({ exact: $exactMatch, queryKey: getFeatureFlagControllerGetAllFeatureFlagsQueryKey(params) }, updater);
  };
}

export const useGetFeatureFlagControllerGetAllFeatureFlagsQueryData = () => {
  const queryClient = useQueryClient();
  return (params?: FeatureFlagControllerGetAllFeatureFlagsParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof featureFlagControllerGetAllFeatureFlags>>>(getFeatureFlagControllerGetAllFeatureFlagsQueryKey(params));
}



export const featureFlagControllerUpdateFeatureFlag = (
    id: string,
    updateFeatureFlagDto: BodyType<UpdateFeatureFlagDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FeatureFlag>(
      {url: `/feature-flags/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateFeatureFlagDto, signal
    },
      options);
    }




export const getFeatureFlagControllerUpdateFeatureFlagMutationKey = () => ['featureFlagControllerUpdateFeatureFlag'] as const;

export const getFeatureFlagControllerUpdateFeatureFlagMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof featureFlagControllerUpdateFeatureFlag>>, TError,FeatureFlagControllerUpdateFeatureFlagMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof featureFlagControllerUpdateFeatureFlag>>, TError,FeatureFlagControllerUpdateFeatureFlagMutationVariables, TContext> => {

const mutationKey = getFeatureFlagControllerUpdateFeatureFlagMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof featureFlagControllerUpdateFeatureFlag>>, FeatureFlagControllerUpdateFeatureFlagMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  featureFlagControllerUpdateFeatureFlag(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FeatureFlagControllerUpdateFeatureFlagMutationResult = NonNullable<Awaited<ReturnType<typeof featureFlagControllerUpdateFeatureFlag>>>
    export type FeatureFlagControllerUpdateFeatureFlagMutationBody = BodyType<UpdateFeatureFlagDto>
    export type FeatureFlagControllerUpdateFeatureFlagMutationError = ErrorType<unknown>
    export type FeatureFlagControllerUpdateFeatureFlagMutationVariables = {id: string;data: BodyType<UpdateFeatureFlagDto>}

    export const useFeatureFlagControllerUpdateFeatureFlag = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof featureFlagControllerUpdateFeatureFlag>>, TError,FeatureFlagControllerUpdateFeatureFlagMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof featureFlagControllerUpdateFeatureFlag>>,
        TError,
        FeatureFlagControllerUpdateFeatureFlagMutationVariables,
        TContext
      > => {
      return useMutation(getFeatureFlagControllerUpdateFeatureFlagMutationOptions(options), queryClient);
    }

export const taskTransactionControllerFindOne = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TaskTransactionControllerFindOne200>(
      {url: `/task-transactions/${id}`, method: 'GET', signal
    },
      options);
    }




export const getTaskTransactionControllerFindOneQueryKey = (id: string,) => {
    return [
    `/task-transactions/${id}`
    ] as const;
    }


export const getTaskTransactionControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof taskTransactionControllerFindOne>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskTransactionControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTaskTransactionControllerFindOneQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof taskTransactionControllerFindOne>>> = ({ signal }) => taskTransactionControllerFindOne(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof taskTransactionControllerFindOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TaskTransactionControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof taskTransactionControllerFindOne>>>
export type TaskTransactionControllerFindOneQueryError = ErrorType<unknown>


export function useTaskTransactionControllerFindOne<TData = Awaited<ReturnType<typeof taskTransactionControllerFindOne>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskTransactionControllerFindOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskTransactionControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof taskTransactionControllerFindOne>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskTransactionControllerFindOne<TData = Awaited<ReturnType<typeof taskTransactionControllerFindOne>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskTransactionControllerFindOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskTransactionControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof taskTransactionControllerFindOne>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskTransactionControllerFindOne<TData = Awaited<ReturnType<typeof taskTransactionControllerFindOne>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskTransactionControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTaskTransactionControllerFindOne<TData = Awaited<ReturnType<typeof taskTransactionControllerFindOne>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskTransactionControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTaskTransactionControllerFindOneQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useTaskTransactionControllerFindOne} query
 */
export const invalidateTaskTransactionControllerFindOne = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getTaskTransactionControllerFindOneQueryKey(id) }, options);

  return queryClient;
}

export const useSetTaskTransactionControllerFindOneQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof taskTransactionControllerFindOne>> | undefined | ((old: Awaited<ReturnType<typeof taskTransactionControllerFindOne>> | undefined) => Awaited<ReturnType<typeof taskTransactionControllerFindOne>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof taskTransactionControllerFindOne>>>({ exact: $exactMatch, queryKey: getTaskTransactionControllerFindOneQueryKey(id) }, updater);
  };
}

export const useGetTaskTransactionControllerFindOneQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof taskTransactionControllerFindOne>>>(getTaskTransactionControllerFindOneQueryKey(id));
}



export const taskTransactionControllerApplyFeedbackSuggestion = (
    id: string,
    applyFeedbackDto: BodyType<ApplyFeedbackDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TaskTransactionControllerApplyFeedbackSuggestion201>(
      {url: `/task-transactions/${id}/apply-feedback`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: applyFeedbackDto, signal
    },
      options);
    }




export const getTaskTransactionControllerApplyFeedbackSuggestionMutationKey = () => ['taskTransactionControllerApplyFeedbackSuggestion'] as const;

export const getTaskTransactionControllerApplyFeedbackSuggestionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taskTransactionControllerApplyFeedbackSuggestion>>, TError,TaskTransactionControllerApplyFeedbackSuggestionMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof taskTransactionControllerApplyFeedbackSuggestion>>, TError,TaskTransactionControllerApplyFeedbackSuggestionMutationVariables, TContext> => {

const mutationKey = getTaskTransactionControllerApplyFeedbackSuggestionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof taskTransactionControllerApplyFeedbackSuggestion>>, TaskTransactionControllerApplyFeedbackSuggestionMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  taskTransactionControllerApplyFeedbackSuggestion(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TaskTransactionControllerApplyFeedbackSuggestionMutationResult = NonNullable<Awaited<ReturnType<typeof taskTransactionControllerApplyFeedbackSuggestion>>>
    export type TaskTransactionControllerApplyFeedbackSuggestionMutationBody = BodyType<ApplyFeedbackDto>
    export type TaskTransactionControllerApplyFeedbackSuggestionMutationError = ErrorType<unknown>
    export type TaskTransactionControllerApplyFeedbackSuggestionMutationVariables = {id: string;data: BodyType<ApplyFeedbackDto>}

    export const useTaskTransactionControllerApplyFeedbackSuggestion = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taskTransactionControllerApplyFeedbackSuggestion>>, TError,TaskTransactionControllerApplyFeedbackSuggestionMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof taskTransactionControllerApplyFeedbackSuggestion>>,
        TError,
        TaskTransactionControllerApplyFeedbackSuggestionMutationVariables,
        TContext
      > => {
      return useMutation(getTaskTransactionControllerApplyFeedbackSuggestionMutationOptions(options), queryClient);
    }

export const taskTransactionControllerApplyFeedback = (
    id: string,
    applyFeedbackV2Dto: BodyType<ApplyFeedbackV2Dto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TaskTransactionControllerApplyFeedback201>(
      {url: `/task-transactions/${id}/apply-feedback-v2`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: applyFeedbackV2Dto, signal
    },
      options);
    }




export const getTaskTransactionControllerApplyFeedbackMutationKey = () => ['taskTransactionControllerApplyFeedback'] as const;

export const getTaskTransactionControllerApplyFeedbackMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taskTransactionControllerApplyFeedback>>, TError,TaskTransactionControllerApplyFeedbackMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof taskTransactionControllerApplyFeedback>>, TError,TaskTransactionControllerApplyFeedbackMutationVariables, TContext> => {

const mutationKey = getTaskTransactionControllerApplyFeedbackMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof taskTransactionControllerApplyFeedback>>, TaskTransactionControllerApplyFeedbackMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  taskTransactionControllerApplyFeedback(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TaskTransactionControllerApplyFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof taskTransactionControllerApplyFeedback>>>
    export type TaskTransactionControllerApplyFeedbackMutationBody = BodyType<ApplyFeedbackV2Dto>
    export type TaskTransactionControllerApplyFeedbackMutationError = ErrorType<unknown>
    export type TaskTransactionControllerApplyFeedbackMutationVariables = {id: string;data: BodyType<ApplyFeedbackV2Dto>}

    export const useTaskTransactionControllerApplyFeedback = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taskTransactionControllerApplyFeedback>>, TError,TaskTransactionControllerApplyFeedbackMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof taskTransactionControllerApplyFeedback>>,
        TError,
        TaskTransactionControllerApplyFeedbackMutationVariables,
        TContext
      > => {
      return useMutation(getTaskTransactionControllerApplyFeedbackMutationOptions(options), queryClient);
    }

/**
 * @summary An endpoint for MatchingVocabTaskTransaction and StimuliMatchingTaskTransaction
 */
export const taskTransactionControllerSubmitMatchingAttempt = (
    id: string,
    submitMatchingAttemptDto: BodyType<SubmitMatchingAttemptDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TaskTransactionControllerSubmitMatchingAttempt201>(
      {url: `/task-transactions/${id}/submit-matching-vocab-attempt`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitMatchingAttemptDto, signal
    },
      options);
    }




export const getTaskTransactionControllerSubmitMatchingAttemptMutationKey = () => ['taskTransactionControllerSubmitMatchingAttempt'] as const;

export const getTaskTransactionControllerSubmitMatchingAttemptMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taskTransactionControllerSubmitMatchingAttempt>>, TError,TaskTransactionControllerSubmitMatchingAttemptMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof taskTransactionControllerSubmitMatchingAttempt>>, TError,TaskTransactionControllerSubmitMatchingAttemptMutationVariables, TContext> => {

const mutationKey = getTaskTransactionControllerSubmitMatchingAttemptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof taskTransactionControllerSubmitMatchingAttempt>>, TaskTransactionControllerSubmitMatchingAttemptMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  taskTransactionControllerSubmitMatchingAttempt(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TaskTransactionControllerSubmitMatchingAttemptMutationResult = NonNullable<Awaited<ReturnType<typeof taskTransactionControllerSubmitMatchingAttempt>>>
    export type TaskTransactionControllerSubmitMatchingAttemptMutationBody = BodyType<SubmitMatchingAttemptDto>
    export type TaskTransactionControllerSubmitMatchingAttemptMutationError = ErrorType<unknown>
    export type TaskTransactionControllerSubmitMatchingAttemptMutationVariables = {id: string;data: BodyType<SubmitMatchingAttemptDto>}

    /**
 * @summary An endpoint for MatchingVocabTaskTransaction and StimuliMatchingTaskTransaction
 */
export const useTaskTransactionControllerSubmitMatchingAttempt = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taskTransactionControllerSubmitMatchingAttempt>>, TError,TaskTransactionControllerSubmitMatchingAttemptMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof taskTransactionControllerSubmitMatchingAttempt>>,
        TError,
        TaskTransactionControllerSubmitMatchingAttemptMutationVariables,
        TContext
      > => {
      return useMutation(getTaskTransactionControllerSubmitMatchingAttemptMutationOptions(options), queryClient);
    }

export const userVocabPracticeAttemptControllerFindById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserVocabPracticeAttemptControllerFindById200>(
      {url: `/user-vocab-practice-attempts/${id}`, method: 'GET', signal
    },
      options);
    }




export const getUserVocabPracticeAttemptControllerFindByIdQueryKey = (id: string,) => {
    return [
    `/user-vocab-practice-attempts/${id}`
    ] as const;
    }


export const getUserVocabPracticeAttemptControllerFindByIdQueryOptions = <TData = Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFindById>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserVocabPracticeAttemptControllerFindByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFindById>>> = ({ signal }) => userVocabPracticeAttemptControllerFindById(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFindById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserVocabPracticeAttemptControllerFindByIdQueryResult = NonNullable<Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFindById>>>
export type UserVocabPracticeAttemptControllerFindByIdQueryError = ErrorType<unknown>


export function useUserVocabPracticeAttemptControllerFindById<TData = Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFindById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFindById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserVocabPracticeAttemptControllerFindById<TData = Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFindById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFindById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserVocabPracticeAttemptControllerFindById<TData = Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserVocabPracticeAttemptControllerFindById<TData = Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserVocabPracticeAttemptControllerFindByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useUserVocabPracticeAttemptControllerFindById} query
 */
export const invalidateUserVocabPracticeAttemptControllerFindById = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getUserVocabPracticeAttemptControllerFindByIdQueryKey(id) }, options);

  return queryClient;
}

export const useSetUserVocabPracticeAttemptControllerFindByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFindById>> | undefined | ((old: Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFindById>> | undefined) => Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFindById>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFindById>>>({ exact: $exactMatch, queryKey: getUserVocabPracticeAttemptControllerFindByIdQueryKey(id) }, updater);
  };
}

export const useGetUserVocabPracticeAttemptControllerFindByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFindById>>>(getUserVocabPracticeAttemptControllerFindByIdQueryKey(id));
}



export const userVocabPracticeAttemptControllerFind = (
    params?: UserVocabPracticeAttemptControllerFindParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserVocabPracticeAttemptControllerFind200Item[]>(
      {url: `/user-vocab-practice-attempts`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUserVocabPracticeAttemptControllerFindQueryKey = (params?: UserVocabPracticeAttemptControllerFindParams,) => {
    return [
    `/user-vocab-practice-attempts`, ...(params ? [params] : [])
    ] as const;
    }


export const getUserVocabPracticeAttemptControllerFindQueryOptions = <TData = Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFind>>, TError = ErrorType<unknown>>(params?: UserVocabPracticeAttemptControllerFindParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFind>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserVocabPracticeAttemptControllerFindQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFind>>> = ({ signal }) => userVocabPracticeAttemptControllerFind(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFind>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserVocabPracticeAttemptControllerFindQueryResult = NonNullable<Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFind>>>
export type UserVocabPracticeAttemptControllerFindQueryError = ErrorType<unknown>


export function useUserVocabPracticeAttemptControllerFind<TData = Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFind>>, TError = ErrorType<unknown>>(
 params: undefined |  UserVocabPracticeAttemptControllerFindParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFind>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFind>>,
          TError,
          Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFind>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserVocabPracticeAttemptControllerFind<TData = Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFind>>, TError = ErrorType<unknown>>(
 params?: UserVocabPracticeAttemptControllerFindParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFind>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFind>>,
          TError,
          Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFind>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserVocabPracticeAttemptControllerFind<TData = Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFind>>, TError = ErrorType<unknown>>(
 params?: UserVocabPracticeAttemptControllerFindParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFind>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserVocabPracticeAttemptControllerFind<TData = Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFind>>, TError = ErrorType<unknown>>(
 params?: UserVocabPracticeAttemptControllerFindParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFind>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserVocabPracticeAttemptControllerFindQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useUserVocabPracticeAttemptControllerFind} query
 */
export const invalidateUserVocabPracticeAttemptControllerFind = async (
 queryClient: QueryClient, params?: UserVocabPracticeAttemptControllerFindParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getUserVocabPracticeAttemptControllerFindQueryKey(params) }, options);

  return queryClient;
}

export const useSetUserVocabPracticeAttemptControllerFindQueryData = () => {
  const queryClient = useQueryClient();
  return (params: UserVocabPracticeAttemptControllerFindParams | undefined,updater: Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFind>> | undefined | ((old: Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFind>> | undefined) => Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFind>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFind>>>({ exact: $exactMatch, queryKey: getUserVocabPracticeAttemptControllerFindQueryKey(params) }, updater);
  };
}

export const useGetUserVocabPracticeAttemptControllerFindQueryData = () => {
  const queryClient = useQueryClient();
  return (params?: UserVocabPracticeAttemptControllerFindParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof userVocabPracticeAttemptControllerFind>>>(getUserVocabPracticeAttemptControllerFindQueryKey(params));
}



export const vocabControllerCreate = (
    createVocabDto: BodyType<CreateVocabDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<VocabControllerCreate201>(
      {url: `/vocabs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createVocabDto, signal
    },
      options);
    }




export const getVocabControllerCreateMutationKey = () => ['vocabControllerCreate'] as const;

export const getVocabControllerCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabControllerCreate>>, TError,VocabControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof vocabControllerCreate>>, TError,VocabControllerCreateMutationVariables, TContext> => {

const mutationKey = getVocabControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vocabControllerCreate>>, VocabControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vocabControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VocabControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof vocabControllerCreate>>>
    export type VocabControllerCreateMutationBody = BodyType<CreateVocabDto>
    export type VocabControllerCreateMutationError = ErrorType<unknown>
    export type VocabControllerCreateMutationVariables = {data: BodyType<CreateVocabDto>}

    export const useVocabControllerCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabControllerCreate>>, TError,VocabControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vocabControllerCreate>>,
        TError,
        VocabControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getVocabControllerCreateMutationOptions(options), queryClient);
    }

export const vocabControllerFindAll = (
    params?: VocabControllerFindAllParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<VocabControllerFindAll200Item[]>(
      {url: `/vocabs`, method: 'GET',
        params, signal
    },
      options);
    }




export const getVocabControllerFindAllQueryKey = (params?: VocabControllerFindAllParams,) => {
    return [
    `/vocabs`, ...(params ? [params] : [])
    ] as const;
    }


export const getVocabControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof vocabControllerFindAll>>, TError = ErrorType<unknown>>(params?: VocabControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vocabControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVocabControllerFindAllQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vocabControllerFindAll>>> = ({ signal }) => vocabControllerFindAll(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vocabControllerFindAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VocabControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof vocabControllerFindAll>>>
export type VocabControllerFindAllQueryError = ErrorType<unknown>


export function useVocabControllerFindAll<TData = Awaited<ReturnType<typeof vocabControllerFindAll>>, TError = ErrorType<unknown>>(
 params: undefined |  VocabControllerFindAllParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vocabControllerFindAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vocabControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof vocabControllerFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVocabControllerFindAll<TData = Awaited<ReturnType<typeof vocabControllerFindAll>>, TError = ErrorType<unknown>>(
 params?: VocabControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vocabControllerFindAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vocabControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof vocabControllerFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVocabControllerFindAll<TData = Awaited<ReturnType<typeof vocabControllerFindAll>>, TError = ErrorType<unknown>>(
 params?: VocabControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vocabControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVocabControllerFindAll<TData = Awaited<ReturnType<typeof vocabControllerFindAll>>, TError = ErrorType<unknown>>(
 params?: VocabControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vocabControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVocabControllerFindAllQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useVocabControllerFindAll} query
 */
export const invalidateVocabControllerFindAll = async (
 queryClient: QueryClient, params?: VocabControllerFindAllParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getVocabControllerFindAllQueryKey(params) }, options);

  return queryClient;
}

export const useSetVocabControllerFindAllQueryData = () => {
  const queryClient = useQueryClient();
  return (params: VocabControllerFindAllParams | undefined,updater: Awaited<ReturnType<typeof vocabControllerFindAll>> | undefined | ((old: Awaited<ReturnType<typeof vocabControllerFindAll>> | undefined) => Awaited<ReturnType<typeof vocabControllerFindAll>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof vocabControllerFindAll>>>({ exact: $exactMatch, queryKey: getVocabControllerFindAllQueryKey(params) }, updater);
  };
}

export const useGetVocabControllerFindAllQueryData = () => {
  const queryClient = useQueryClient();
  return (params?: VocabControllerFindAllParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof vocabControllerFindAll>>>(getVocabControllerFindAllQueryKey(params));
}



export const vocabControllerFindOne = (
    id: string,
    params?: VocabControllerFindOneParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<VocabControllerFindOne200>(
      {url: `/vocabs/${id}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getVocabControllerFindOneQueryKey = (id: string,
    params?: VocabControllerFindOneParams,) => {
    return [
    `/vocabs/${id}`, ...(params ? [params] : [])
    ] as const;
    }


export const getVocabControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof vocabControllerFindOne>>, TError = ErrorType<unknown>>(id: string,
    params?: VocabControllerFindOneParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vocabControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVocabControllerFindOneQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vocabControllerFindOne>>> = ({ signal }) => vocabControllerFindOne(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vocabControllerFindOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VocabControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof vocabControllerFindOne>>>
export type VocabControllerFindOneQueryError = ErrorType<unknown>


export function useVocabControllerFindOne<TData = Awaited<ReturnType<typeof vocabControllerFindOne>>, TError = ErrorType<unknown>>(
 id: string,
    params: undefined |  VocabControllerFindOneParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vocabControllerFindOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vocabControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof vocabControllerFindOne>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVocabControllerFindOne<TData = Awaited<ReturnType<typeof vocabControllerFindOne>>, TError = ErrorType<unknown>>(
 id: string,
    params?: VocabControllerFindOneParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vocabControllerFindOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vocabControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof vocabControllerFindOne>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVocabControllerFindOne<TData = Awaited<ReturnType<typeof vocabControllerFindOne>>, TError = ErrorType<unknown>>(
 id: string,
    params?: VocabControllerFindOneParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vocabControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVocabControllerFindOne<TData = Awaited<ReturnType<typeof vocabControllerFindOne>>, TError = ErrorType<unknown>>(
 id: string,
    params?: VocabControllerFindOneParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vocabControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVocabControllerFindOneQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useVocabControllerFindOne} query
 */
export const invalidateVocabControllerFindOne = async (
 queryClient: QueryClient, id: string,
    params?: VocabControllerFindOneParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getVocabControllerFindOneQueryKey(id,params) }, options);

  return queryClient;
}

export const useSetVocabControllerFindOneQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,
    params: VocabControllerFindOneParams | undefined,updater: Awaited<ReturnType<typeof vocabControllerFindOne>> | undefined | ((old: Awaited<ReturnType<typeof vocabControllerFindOne>> | undefined) => Awaited<ReturnType<typeof vocabControllerFindOne>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof vocabControllerFindOne>>>({ exact: $exactMatch, queryKey: getVocabControllerFindOneQueryKey(id,params) }, updater);
  };
}

export const useGetVocabControllerFindOneQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,
    params?: VocabControllerFindOneParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof vocabControllerFindOne>>>(getVocabControllerFindOneQueryKey(id,params));
}



export const vocabControllerFindByIds = (
    bulkGetDto: BodyType<BulkGetDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Vocab[]>(
      {url: `/vocabs/bulk-get`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkGetDto, signal
    },
      options);
    }




export const getVocabControllerFindByIdsMutationKey = () => ['vocabControllerFindByIds'] as const;

export const getVocabControllerFindByIdsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabControllerFindByIds>>, TError,VocabControllerFindByIdsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof vocabControllerFindByIds>>, TError,VocabControllerFindByIdsMutationVariables, TContext> => {

const mutationKey = getVocabControllerFindByIdsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vocabControllerFindByIds>>, VocabControllerFindByIdsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vocabControllerFindByIds(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VocabControllerFindByIdsMutationResult = NonNullable<Awaited<ReturnType<typeof vocabControllerFindByIds>>>
    export type VocabControllerFindByIdsMutationBody = BodyType<BulkGetDto>
    export type VocabControllerFindByIdsMutationError = ErrorType<unknown>
    export type VocabControllerFindByIdsMutationVariables = {data: BodyType<BulkGetDto>}

    export const useVocabControllerFindByIds = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabControllerFindByIds>>, TError,VocabControllerFindByIdsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vocabControllerFindByIds>>,
        TError,
        VocabControllerFindByIdsMutationVariables,
        TContext
      > => {
      return useMutation(getVocabControllerFindByIdsMutationOptions(options), queryClient);
    }

export const vocabControllerSearchWithText = (
    searchVocabWithTextDto: BodyType<SearchVocabWithTextDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<VocabControllerSearchWithText201Item[]>(
      {url: `/vocabs/search-with-text`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: searchVocabWithTextDto, signal
    },
      options);
    }




export const getVocabControllerSearchWithTextMutationKey = () => ['vocabControllerSearchWithText'] as const;

export const getVocabControllerSearchWithTextMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabControllerSearchWithText>>, TError,VocabControllerSearchWithTextMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof vocabControllerSearchWithText>>, TError,VocabControllerSearchWithTextMutationVariables, TContext> => {

const mutationKey = getVocabControllerSearchWithTextMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vocabControllerSearchWithText>>, VocabControllerSearchWithTextMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vocabControllerSearchWithText(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VocabControllerSearchWithTextMutationResult = NonNullable<Awaited<ReturnType<typeof vocabControllerSearchWithText>>>
    export type VocabControllerSearchWithTextMutationBody = BodyType<SearchVocabWithTextDto>
    export type VocabControllerSearchWithTextMutationError = ErrorType<unknown>
    export type VocabControllerSearchWithTextMutationVariables = {data: BodyType<SearchVocabWithTextDto>}

    export const useVocabControllerSearchWithText = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabControllerSearchWithText>>, TError,VocabControllerSearchWithTextMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vocabControllerSearchWithText>>,
        TError,
        VocabControllerSearchWithTextMutationVariables,
        TContext
      > => {
      return useMutation(getVocabControllerSearchWithTextMutationOptions(options), queryClient);
    }

export const vocabControllerSearch = (
    searchVocabDto: BodyType<SearchVocabDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<VocabControllerSearch201Item[]>(
      {url: `/vocabs/search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: searchVocabDto, signal
    },
      options);
    }




export const getVocabControllerSearchMutationKey = () => ['vocabControllerSearch'] as const;

export const getVocabControllerSearchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabControllerSearch>>, TError,VocabControllerSearchMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof vocabControllerSearch>>, TError,VocabControllerSearchMutationVariables, TContext> => {

const mutationKey = getVocabControllerSearchMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vocabControllerSearch>>, VocabControllerSearchMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vocabControllerSearch(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VocabControllerSearchMutationResult = NonNullable<Awaited<ReturnType<typeof vocabControllerSearch>>>
    export type VocabControllerSearchMutationBody = BodyType<SearchVocabDto>
    export type VocabControllerSearchMutationError = ErrorType<unknown>
    export type VocabControllerSearchMutationVariables = {data: BodyType<SearchVocabDto>}

    export const useVocabControllerSearch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabControllerSearch>>, TError,VocabControllerSearchMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vocabControllerSearch>>,
        TError,
        VocabControllerSearchMutationVariables,
        TContext
      > => {
      return useMutation(getVocabControllerSearchMutationOptions(options), queryClient);
    }

export const vocabControllerBulkSearch = (
    vocabControllerBulkSearchBody: BodyType<string[]>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<VocabControllerBulkSearch201Item[]>(
      {url: `/vocabs/bulk-search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: vocabControllerBulkSearchBody, signal
    },
      options);
    }




export const getVocabControllerBulkSearchMutationKey = () => ['vocabControllerBulkSearch'] as const;

export const getVocabControllerBulkSearchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabControllerBulkSearch>>, TError,VocabControllerBulkSearchMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof vocabControllerBulkSearch>>, TError,VocabControllerBulkSearchMutationVariables, TContext> => {

const mutationKey = getVocabControllerBulkSearchMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vocabControllerBulkSearch>>, VocabControllerBulkSearchMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vocabControllerBulkSearch(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VocabControllerBulkSearchMutationResult = NonNullable<Awaited<ReturnType<typeof vocabControllerBulkSearch>>>
    export type VocabControllerBulkSearchMutationBody = BodyType<string[]>
    export type VocabControllerBulkSearchMutationError = ErrorType<unknown>
    export type VocabControllerBulkSearchMutationVariables = {data: BodyType<string[]>}

    export const useVocabControllerBulkSearch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabControllerBulkSearch>>, TError,VocabControllerBulkSearchMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vocabControllerBulkSearch>>,
        TError,
        VocabControllerBulkSearchMutationVariables,
        TContext
      > => {
      return useMutation(getVocabControllerBulkSearchMutationOptions(options), queryClient);
    }

export const vocabControllerAddVocabTranslation = (
    vocabId: string,
    addTranslationDto: BodyType<AddTranslationDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<VocabControllerAddVocabTranslation200>(
      {url: `/vocabs/${vocabId}/add-translation`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: addTranslationDto, signal
    },
      options);
    }




export const getVocabControllerAddVocabTranslationMutationKey = () => ['vocabControllerAddVocabTranslation'] as const;

export const getVocabControllerAddVocabTranslationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabControllerAddVocabTranslation>>, TError,VocabControllerAddVocabTranslationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof vocabControllerAddVocabTranslation>>, TError,VocabControllerAddVocabTranslationMutationVariables, TContext> => {

const mutationKey = getVocabControllerAddVocabTranslationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vocabControllerAddVocabTranslation>>, VocabControllerAddVocabTranslationMutationVariables> = (props) => {
          const {vocabId,data} = props ?? {};

          return  vocabControllerAddVocabTranslation(vocabId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VocabControllerAddVocabTranslationMutationResult = NonNullable<Awaited<ReturnType<typeof vocabControllerAddVocabTranslation>>>
    export type VocabControllerAddVocabTranslationMutationBody = BodyType<AddTranslationDto>
    export type VocabControllerAddVocabTranslationMutationError = ErrorType<unknown>
    export type VocabControllerAddVocabTranslationMutationVariables = {vocabId: string;data: BodyType<AddTranslationDto>}

    export const useVocabControllerAddVocabTranslation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabControllerAddVocabTranslation>>, TError,VocabControllerAddVocabTranslationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vocabControllerAddVocabTranslation>>,
        TError,
        VocabControllerAddVocabTranslationMutationVariables,
        TContext
      > => {
      return useMutation(getVocabControllerAddVocabTranslationMutationOptions(options), queryClient);
    }

export const oEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/oe-vocab-learning-activity-instances/${id}/current-task-and-task-transaction`, method: 'GET', signal
    },
      options);
    }




export const getOEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransactionQueryKey = (id: string,) => {
    return [
    `/oe-vocab-learning-activity-instances/${id}/current-task-and-task-transaction`
    ] as const;
    }


export const getOEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransactionQueryOptions = <TData = Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransactionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction>>> = ({ signal }) => oEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransactionQueryResult = NonNullable<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction>>>
export type OEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransactionQueryError = ErrorType<unknown>


export function useOEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction<TData = Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction>>,
          TError,
          Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction<TData = Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction>>,
          TError,
          Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction<TData = Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction<TData = Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransactionQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useOEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction} query
 */
export const invalidateOEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getOEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransactionQueryKey(id) }, options);

  return queryClient;
}

export const useSetOEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransactionQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction>> | undefined | ((old: Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction>> | undefined) => Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction>>>({ exact: $exactMatch, queryKey: getOEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransactionQueryKey(id) }, updater);
  };
}

export const useGetOEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransactionQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransaction>>>(getOEVocabLearningActivityInstanceControllerGetNextTaskAndTaskTransactionQueryKey(id));
}



export const oEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/oe-vocab-learning-activity-instances/${id}/latest-response-audio-blob`, method: 'GET', signal
    },
      options);
    }




export const getOEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlobQueryKey = (id: string,) => {
    return [
    `/oe-vocab-learning-activity-instances/${id}/latest-response-audio-blob`
    ] as const;
    }


export const getOEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlobQueryOptions = <TData = Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlobQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob>>> = ({ signal }) => oEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlobQueryResult = NonNullable<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob>>>
export type OEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlobQueryError = ErrorType<unknown>


export function useOEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob<TData = Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob>>,
          TError,
          Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob<TData = Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob>>,
          TError,
          Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob<TData = Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob<TData = Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlobQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useOEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob} query
 */
export const invalidateOEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getOEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlobQueryKey(id) }, options);

  return queryClient;
}

export const useSetOEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlobQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob>> | undefined | ((old: Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob>> | undefined) => Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob>>>({ exact: $exactMatch, queryKey: getOEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlobQueryKey(id) }, updater);
  };
}

export const useGetOEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlobQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlob>>>(getOEVocabLearningActivityInstanceControllerGetLatestResponseAudioBlobQueryKey(id));
}



export const oEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<OEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig200>(
      {url: `/oe-vocab-learning-activity-instances/${id}/grading-criteria-config`, method: 'GET', signal
    },
      options);
    }




export const getOEVocabLearningActivityInstanceControllerGetGradingCriteriaConfigQueryKey = (id: string,) => {
    return [
    `/oe-vocab-learning-activity-instances/${id}/grading-criteria-config`
    ] as const;
    }


export const getOEVocabLearningActivityInstanceControllerGetGradingCriteriaConfigQueryOptions = <TData = Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOEVocabLearningActivityInstanceControllerGetGradingCriteriaConfigQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig>>> = ({ signal }) => oEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OEVocabLearningActivityInstanceControllerGetGradingCriteriaConfigQueryResult = NonNullable<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig>>>
export type OEVocabLearningActivityInstanceControllerGetGradingCriteriaConfigQueryError = ErrorType<unknown>


export function useOEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig<TData = Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig>>,
          TError,
          Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig<TData = Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig>>,
          TError,
          Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig<TData = Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig<TData = Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOEVocabLearningActivityInstanceControllerGetGradingCriteriaConfigQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useOEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig} query
 */
export const invalidateOEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getOEVocabLearningActivityInstanceControllerGetGradingCriteriaConfigQueryKey(id) }, options);

  return queryClient;
}

export const useSetOEVocabLearningActivityInstanceControllerGetGradingCriteriaConfigQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig>> | undefined | ((old: Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig>> | undefined) => Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig>>>({ exact: $exactMatch, queryKey: getOEVocabLearningActivityInstanceControllerGetGradingCriteriaConfigQueryKey(id) }, updater);
  };
}

export const useGetOEVocabLearningActivityInstanceControllerGetGradingCriteriaConfigQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerGetGradingCriteriaConfig>>>(getOEVocabLearningActivityInstanceControllerGetGradingCriteriaConfigQueryKey(id));
}



export const oEVocabLearningActivityInstanceControllerSubmitTaskWithAudio = (
    id: string,
    taskId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<OEVocabLearningActivityInstanceControllerSubmitTaskWithAudio201>(
      {url: `/oe-vocab-learning-activity-instances/${id}/tasks/${taskId}/submit-audio`, method: 'POST', signal
    },
      options);
    }




export const getOEVocabLearningActivityInstanceControllerSubmitTaskWithAudioMutationKey = () => ['oEVocabLearningActivityInstanceControllerSubmitTaskWithAudio'] as const;

export const getOEVocabLearningActivityInstanceControllerSubmitTaskWithAudioMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerSubmitTaskWithAudio>>, TError,OEVocabLearningActivityInstanceControllerSubmitTaskWithAudioMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerSubmitTaskWithAudio>>, TError,OEVocabLearningActivityInstanceControllerSubmitTaskWithAudioMutationVariables, TContext> => {

const mutationKey = getOEVocabLearningActivityInstanceControllerSubmitTaskWithAudioMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerSubmitTaskWithAudio>>, OEVocabLearningActivityInstanceControllerSubmitTaskWithAudioMutationVariables> = (props) => {
          const {id,taskId} = props ?? {};

          return  oEVocabLearningActivityInstanceControllerSubmitTaskWithAudio(id,taskId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OEVocabLearningActivityInstanceControllerSubmitTaskWithAudioMutationResult = NonNullable<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerSubmitTaskWithAudio>>>

    export type OEVocabLearningActivityInstanceControllerSubmitTaskWithAudioMutationError = ErrorType<unknown>
    export type OEVocabLearningActivityInstanceControllerSubmitTaskWithAudioMutationVariables = {id: string;taskId: string}

    export const useOEVocabLearningActivityInstanceControllerSubmitTaskWithAudio = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerSubmitTaskWithAudio>>, TError,OEVocabLearningActivityInstanceControllerSubmitTaskWithAudioMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerSubmitTaskWithAudio>>,
        TError,
        OEVocabLearningActivityInstanceControllerSubmitTaskWithAudioMutationVariables,
        TContext
      > => {
      return useMutation(getOEVocabLearningActivityInstanceControllerSubmitTaskWithAudioMutationOptions(options), queryClient);
    }

export const oEVocabLearningActivityInstanceControllerSubmitTask = (
    id: string,
    taskId: string,
    baseSubmitOEVocabLearningTaskDto: BodyType<BaseSubmitOEVocabLearningTaskDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TaskTransaction>(
      {url: `/oe-vocab-learning-activity-instances/${id}/tasks/${taskId}/submit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: baseSubmitOEVocabLearningTaskDto, signal
    },
      options);
    }




export const getOEVocabLearningActivityInstanceControllerSubmitTaskMutationKey = () => ['oEVocabLearningActivityInstanceControllerSubmitTask'] as const;

export const getOEVocabLearningActivityInstanceControllerSubmitTaskMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerSubmitTask>>, TError,OEVocabLearningActivityInstanceControllerSubmitTaskMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerSubmitTask>>, TError,OEVocabLearningActivityInstanceControllerSubmitTaskMutationVariables, TContext> => {

const mutationKey = getOEVocabLearningActivityInstanceControllerSubmitTaskMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerSubmitTask>>, OEVocabLearningActivityInstanceControllerSubmitTaskMutationVariables> = (props) => {
          const {id,taskId,data} = props ?? {};

          return  oEVocabLearningActivityInstanceControllerSubmitTask(id,taskId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OEVocabLearningActivityInstanceControllerSubmitTaskMutationResult = NonNullable<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerSubmitTask>>>
    export type OEVocabLearningActivityInstanceControllerSubmitTaskMutationBody = BodyType<BaseSubmitOEVocabLearningTaskDto>
    export type OEVocabLearningActivityInstanceControllerSubmitTaskMutationError = ErrorType<unknown>
    export type OEVocabLearningActivityInstanceControllerSubmitTaskMutationVariables = {id: string;taskId: string;data: BodyType<BaseSubmitOEVocabLearningTaskDto>}

    export const useOEVocabLearningActivityInstanceControllerSubmitTask = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerSubmitTask>>, TError,OEVocabLearningActivityInstanceControllerSubmitTaskMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerSubmitTask>>,
        TError,
        OEVocabLearningActivityInstanceControllerSubmitTaskMutationVariables,
        TContext
      > => {
      return useMutation(getOEVocabLearningActivityInstanceControllerSubmitTaskMutationOptions(options), queryClient);
    }

export const oEVocabLearningActivityInstanceControllerCompleteTaskTransaction = (
    id: string,
    taskTransactionId: string,
    baseCompleteOEVocabLearningTaskDto: BodyType<BaseCompleteOEVocabLearningTaskDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<OEVocabLearningActivityInstance>(
      {url: `/oe-vocab-learning-activity-instances/${id}/task-transactions/${taskTransactionId}/complete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: baseCompleteOEVocabLearningTaskDto, signal
    },
      options);
    }




export const getOEVocabLearningActivityInstanceControllerCompleteTaskTransactionMutationKey = () => ['oEVocabLearningActivityInstanceControllerCompleteTaskTransaction'] as const;

export const getOEVocabLearningActivityInstanceControllerCompleteTaskTransactionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerCompleteTaskTransaction>>, TError,OEVocabLearningActivityInstanceControllerCompleteTaskTransactionMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerCompleteTaskTransaction>>, TError,OEVocabLearningActivityInstanceControllerCompleteTaskTransactionMutationVariables, TContext> => {

const mutationKey = getOEVocabLearningActivityInstanceControllerCompleteTaskTransactionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerCompleteTaskTransaction>>, OEVocabLearningActivityInstanceControllerCompleteTaskTransactionMutationVariables> = (props) => {
          const {id,taskTransactionId,data} = props ?? {};

          return  oEVocabLearningActivityInstanceControllerCompleteTaskTransaction(id,taskTransactionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OEVocabLearningActivityInstanceControllerCompleteTaskTransactionMutationResult = NonNullable<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerCompleteTaskTransaction>>>
    export type OEVocabLearningActivityInstanceControllerCompleteTaskTransactionMutationBody = BodyType<BaseCompleteOEVocabLearningTaskDto>
    export type OEVocabLearningActivityInstanceControllerCompleteTaskTransactionMutationError = ErrorType<unknown>
    export type OEVocabLearningActivityInstanceControllerCompleteTaskTransactionMutationVariables = {id: string;taskTransactionId: string;data: BodyType<BaseCompleteOEVocabLearningTaskDto>}

    export const useOEVocabLearningActivityInstanceControllerCompleteTaskTransaction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerCompleteTaskTransaction>>, TError,OEVocabLearningActivityInstanceControllerCompleteTaskTransactionMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerCompleteTaskTransaction>>,
        TError,
        OEVocabLearningActivityInstanceControllerCompleteTaskTransactionMutationVariables,
        TContext
      > => {
      return useMutation(getOEVocabLearningActivityInstanceControllerCompleteTaskTransactionMutationOptions(options), queryClient);
    }

export const oEVocabLearningActivityInstanceControllerCompleteActivityInstance = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<OEVocabLearningActivityInstanceControllerCompleteActivityInstance201>(
      {url: `/oe-vocab-learning-activity-instances/${id}/complete`, method: 'POST', signal
    },
      options);
    }




export const getOEVocabLearningActivityInstanceControllerCompleteActivityInstanceMutationKey = () => ['oEVocabLearningActivityInstanceControllerCompleteActivityInstance'] as const;

export const getOEVocabLearningActivityInstanceControllerCompleteActivityInstanceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerCompleteActivityInstance>>, TError,OEVocabLearningActivityInstanceControllerCompleteActivityInstanceMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerCompleteActivityInstance>>, TError,OEVocabLearningActivityInstanceControllerCompleteActivityInstanceMutationVariables, TContext> => {

const mutationKey = getOEVocabLearningActivityInstanceControllerCompleteActivityInstanceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerCompleteActivityInstance>>, OEVocabLearningActivityInstanceControllerCompleteActivityInstanceMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  oEVocabLearningActivityInstanceControllerCompleteActivityInstance(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OEVocabLearningActivityInstanceControllerCompleteActivityInstanceMutationResult = NonNullable<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerCompleteActivityInstance>>>

    export type OEVocabLearningActivityInstanceControllerCompleteActivityInstanceMutationError = ErrorType<unknown>
    export type OEVocabLearningActivityInstanceControllerCompleteActivityInstanceMutationVariables = {id: string}

    export const useOEVocabLearningActivityInstanceControllerCompleteActivityInstance = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerCompleteActivityInstance>>, TError,OEVocabLearningActivityInstanceControllerCompleteActivityInstanceMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof oEVocabLearningActivityInstanceControllerCompleteActivityInstance>>,
        TError,
        OEVocabLearningActivityInstanceControllerCompleteActivityInstanceMutationVariables,
        TContext
      > => {
      return useMutation(getOEVocabLearningActivityInstanceControllerCompleteActivityInstanceMutationOptions(options), queryClient);
    }

export const activityInstanceMetadataControllerCreate = (
    createActivityInstanceMetadataDto: BodyType<CreateActivityInstanceMetadataDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ActivityInstanceMetadataControllerCreate201>(
      {url: `/activity-instances-metadata`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createActivityInstanceMetadataDto, signal
    },
      options);
    }




export const getActivityInstanceMetadataControllerCreateMutationKey = () => ['activityInstanceMetadataControllerCreate'] as const;

export const getActivityInstanceMetadataControllerCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityInstanceMetadataControllerCreate>>, TError,ActivityInstanceMetadataControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activityInstanceMetadataControllerCreate>>, TError,ActivityInstanceMetadataControllerCreateMutationVariables, TContext> => {

const mutationKey = getActivityInstanceMetadataControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activityInstanceMetadataControllerCreate>>, ActivityInstanceMetadataControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  activityInstanceMetadataControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivityInstanceMetadataControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof activityInstanceMetadataControllerCreate>>>
    export type ActivityInstanceMetadataControllerCreateMutationBody = BodyType<CreateActivityInstanceMetadataDto>
    export type ActivityInstanceMetadataControllerCreateMutationError = ErrorType<unknown>
    export type ActivityInstanceMetadataControllerCreateMutationVariables = {data: BodyType<CreateActivityInstanceMetadataDto>}

    export const useActivityInstanceMetadataControllerCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityInstanceMetadataControllerCreate>>, TError,ActivityInstanceMetadataControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activityInstanceMetadataControllerCreate>>,
        TError,
        ActivityInstanceMetadataControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getActivityInstanceMetadataControllerCreateMutationOptions(options), queryClient);
    }

export const activityInstanceMetadataControllerFindAll = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ActivityInstanceMetadataControllerFindAll200Item[]>(
      {url: `/activity-instances-metadata`, method: 'GET', signal
    },
      options);
    }




export const getActivityInstanceMetadataControllerFindAllQueryKey = () => {
    return [
    `/activity-instances-metadata`
    ] as const;
    }


export const getActivityInstanceMetadataControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof activityInstanceMetadataControllerFindAll>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceMetadataControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityInstanceMetadataControllerFindAllQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityInstanceMetadataControllerFindAll>>> = ({ signal }) => activityInstanceMetadataControllerFindAll(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityInstanceMetadataControllerFindAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivityInstanceMetadataControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof activityInstanceMetadataControllerFindAll>>>
export type ActivityInstanceMetadataControllerFindAllQueryError = ErrorType<unknown>


export function useActivityInstanceMetadataControllerFindAll<TData = Awaited<ReturnType<typeof activityInstanceMetadataControllerFindAll>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceMetadataControllerFindAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityInstanceMetadataControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof activityInstanceMetadataControllerFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityInstanceMetadataControllerFindAll<TData = Awaited<ReturnType<typeof activityInstanceMetadataControllerFindAll>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceMetadataControllerFindAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityInstanceMetadataControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof activityInstanceMetadataControllerFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityInstanceMetadataControllerFindAll<TData = Awaited<ReturnType<typeof activityInstanceMetadataControllerFindAll>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceMetadataControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivityInstanceMetadataControllerFindAll<TData = Awaited<ReturnType<typeof activityInstanceMetadataControllerFindAll>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceMetadataControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivityInstanceMetadataControllerFindAllQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivityInstanceMetadataControllerFindAll} query
 */
export const invalidateActivityInstanceMetadataControllerFindAll = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivityInstanceMetadataControllerFindAllQueryKey() }, options);

  return queryClient;
}

export const useSetActivityInstanceMetadataControllerFindAllQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof activityInstanceMetadataControllerFindAll>> | undefined | ((old: Awaited<ReturnType<typeof activityInstanceMetadataControllerFindAll>> | undefined) => Awaited<ReturnType<typeof activityInstanceMetadataControllerFindAll>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activityInstanceMetadataControllerFindAll>>>({ exact: $exactMatch, queryKey: getActivityInstanceMetadataControllerFindAllQueryKey() }, updater);
  };
}

export const useGetActivityInstanceMetadataControllerFindAllQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activityInstanceMetadataControllerFindAll>>>(getActivityInstanceMetadataControllerFindAllQueryKey());
}



export const activityInstanceMetadataControllerFindById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ActivityInstanceMetadataControllerFindById200>(
      {url: `/activity-instances-metadata/${id}`, method: 'GET', signal
    },
      options);
    }




export const getActivityInstanceMetadataControllerFindByIdQueryKey = (id: string,) => {
    return [
    `/activity-instances-metadata/${id}`
    ] as const;
    }


export const getActivityInstanceMetadataControllerFindByIdQueryOptions = <TData = Awaited<ReturnType<typeof activityInstanceMetadataControllerFindById>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceMetadataControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityInstanceMetadataControllerFindByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityInstanceMetadataControllerFindById>>> = ({ signal }) => activityInstanceMetadataControllerFindById(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityInstanceMetadataControllerFindById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivityInstanceMetadataControllerFindByIdQueryResult = NonNullable<Awaited<ReturnType<typeof activityInstanceMetadataControllerFindById>>>
export type ActivityInstanceMetadataControllerFindByIdQueryError = ErrorType<unknown>


export function useActivityInstanceMetadataControllerFindById<TData = Awaited<ReturnType<typeof activityInstanceMetadataControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceMetadataControllerFindById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityInstanceMetadataControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof activityInstanceMetadataControllerFindById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityInstanceMetadataControllerFindById<TData = Awaited<ReturnType<typeof activityInstanceMetadataControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceMetadataControllerFindById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityInstanceMetadataControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof activityInstanceMetadataControllerFindById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityInstanceMetadataControllerFindById<TData = Awaited<ReturnType<typeof activityInstanceMetadataControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceMetadataControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivityInstanceMetadataControllerFindById<TData = Awaited<ReturnType<typeof activityInstanceMetadataControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityInstanceMetadataControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivityInstanceMetadataControllerFindByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivityInstanceMetadataControllerFindById} query
 */
export const invalidateActivityInstanceMetadataControllerFindById = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivityInstanceMetadataControllerFindByIdQueryKey(id) }, options);

  return queryClient;
}

export const useSetActivityInstanceMetadataControllerFindByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof activityInstanceMetadataControllerFindById>> | undefined | ((old: Awaited<ReturnType<typeof activityInstanceMetadataControllerFindById>> | undefined) => Awaited<ReturnType<typeof activityInstanceMetadataControllerFindById>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activityInstanceMetadataControllerFindById>>>({ exact: $exactMatch, queryKey: getActivityInstanceMetadataControllerFindByIdQueryKey(id) }, updater);
  };
}

export const useGetActivityInstanceMetadataControllerFindByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activityInstanceMetadataControllerFindById>>>(getActivityInstanceMetadataControllerFindByIdQueryKey(id));
}



/**
 * @summary Get default activity grading criteria
 */
export const activityGradingCriteriaControllerGetActivityGradingCriteria = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ActivityGradingCriteriaResponseDto>(
      {url: `/activity-grading-criteria`, method: 'GET', signal
    },
      options);
    }




export const getActivityGradingCriteriaControllerGetActivityGradingCriteriaQueryKey = () => {
    return [
    `/activity-grading-criteria`
    ] as const;
    }


export const getActivityGradingCriteriaControllerGetActivityGradingCriteriaQueryOptions = <TData = Awaited<ReturnType<typeof activityGradingCriteriaControllerGetActivityGradingCriteria>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityGradingCriteriaControllerGetActivityGradingCriteria>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityGradingCriteriaControllerGetActivityGradingCriteriaQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityGradingCriteriaControllerGetActivityGradingCriteria>>> = ({ signal }) => activityGradingCriteriaControllerGetActivityGradingCriteria(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityGradingCriteriaControllerGetActivityGradingCriteria>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivityGradingCriteriaControllerGetActivityGradingCriteriaQueryResult = NonNullable<Awaited<ReturnType<typeof activityGradingCriteriaControllerGetActivityGradingCriteria>>>
export type ActivityGradingCriteriaControllerGetActivityGradingCriteriaQueryError = ErrorType<unknown>


export function useActivityGradingCriteriaControllerGetActivityGradingCriteria<TData = Awaited<ReturnType<typeof activityGradingCriteriaControllerGetActivityGradingCriteria>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityGradingCriteriaControllerGetActivityGradingCriteria>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityGradingCriteriaControllerGetActivityGradingCriteria>>,
          TError,
          Awaited<ReturnType<typeof activityGradingCriteriaControllerGetActivityGradingCriteria>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityGradingCriteriaControllerGetActivityGradingCriteria<TData = Awaited<ReturnType<typeof activityGradingCriteriaControllerGetActivityGradingCriteria>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityGradingCriteriaControllerGetActivityGradingCriteria>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityGradingCriteriaControllerGetActivityGradingCriteria>>,
          TError,
          Awaited<ReturnType<typeof activityGradingCriteriaControllerGetActivityGradingCriteria>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityGradingCriteriaControllerGetActivityGradingCriteria<TData = Awaited<ReturnType<typeof activityGradingCriteriaControllerGetActivityGradingCriteria>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityGradingCriteriaControllerGetActivityGradingCriteria>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get default activity grading criteria
 */

export function useActivityGradingCriteriaControllerGetActivityGradingCriteria<TData = Awaited<ReturnType<typeof activityGradingCriteriaControllerGetActivityGradingCriteria>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityGradingCriteriaControllerGetActivityGradingCriteria>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivityGradingCriteriaControllerGetActivityGradingCriteriaQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivityGradingCriteriaControllerGetActivityGradingCriteria} query
 */
export const invalidateActivityGradingCriteriaControllerGetActivityGradingCriteria = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivityGradingCriteriaControllerGetActivityGradingCriteriaQueryKey() }, options);

  return queryClient;
}

/**
 * @summary Get default activity grading criteria
 */
export const useSetActivityGradingCriteriaControllerGetActivityGradingCriteriaQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof activityGradingCriteriaControllerGetActivityGradingCriteria>> | undefined | ((old: Awaited<ReturnType<typeof activityGradingCriteriaControllerGetActivityGradingCriteria>> | undefined) => Awaited<ReturnType<typeof activityGradingCriteriaControllerGetActivityGradingCriteria>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activityGradingCriteriaControllerGetActivityGradingCriteria>>>({ exact: $exactMatch, queryKey: getActivityGradingCriteriaControllerGetActivityGradingCriteriaQueryKey() }, updater);
  };
}

/**
 * @summary Get default activity grading criteria
 */
export const useGetActivityGradingCriteriaControllerGetActivityGradingCriteriaQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activityGradingCriteriaControllerGetActivityGradingCriteria>>>(getActivityGradingCriteriaControllerGetActivityGradingCriteriaQueryKey());
}



export const oEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/oe-scaffolding-activity-instances/${id}/current-task-and-task-transaction`, method: 'GET', signal
    },
      options);
    }




export const getOEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransactionQueryKey = (id: string,) => {
    return [
    `/oe-scaffolding-activity-instances/${id}/current-task-and-task-transaction`
    ] as const;
    }


export const getOEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransactionQueryOptions = <TData = Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransactionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction>>> = ({ signal }) => oEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransactionQueryResult = NonNullable<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction>>>
export type OEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransactionQueryError = ErrorType<unknown>


export function useOEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction<TData = Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction>>,
          TError,
          Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction<TData = Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction>>,
          TError,
          Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction<TData = Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction<TData = Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransactionQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useOEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction} query
 */
export const invalidateOEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getOEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransactionQueryKey(id) }, options);

  return queryClient;
}

export const useSetOEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransactionQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction>> | undefined | ((old: Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction>> | undefined) => Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction>>>({ exact: $exactMatch, queryKey: getOEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransactionQueryKey(id) }, updater);
  };
}

export const useGetOEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransactionQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransaction>>>(getOEScaffoldingActivityInstanceControllerGetCurrentTaskAndTaskTransactionQueryKey(id));
}



export const oEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/oe-scaffolding-activity-instances/${id}/latest-response-audio-blob`, method: 'GET', signal
    },
      options);
    }




export const getOEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlobQueryKey = (id: string,) => {
    return [
    `/oe-scaffolding-activity-instances/${id}/latest-response-audio-blob`
    ] as const;
    }


export const getOEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlobQueryOptions = <TData = Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlobQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob>>> = ({ signal }) => oEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlobQueryResult = NonNullable<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob>>>
export type OEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlobQueryError = ErrorType<unknown>


export function useOEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob<TData = Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob>>,
          TError,
          Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob<TData = Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob>>,
          TError,
          Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob<TData = Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob<TData = Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlobQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useOEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob} query
 */
export const invalidateOEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getOEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlobQueryKey(id) }, options);

  return queryClient;
}

export const useSetOEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlobQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob>> | undefined | ((old: Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob>> | undefined) => Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob>>>({ exact: $exactMatch, queryKey: getOEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlobQueryKey(id) }, updater);
  };
}

export const useGetOEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlobQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlob>>>(getOEScaffoldingActivityInstanceControllerGetLatestResponseAudioBlobQueryKey(id));
}



export const oEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<OEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig200>(
      {url: `/oe-scaffolding-activity-instances/${id}/grading-criteria-config`, method: 'GET', signal
    },
      options);
    }




export const getOEScaffoldingActivityInstanceControllerGetGradingCriteriaConfigQueryKey = (id: string,) => {
    return [
    `/oe-scaffolding-activity-instances/${id}/grading-criteria-config`
    ] as const;
    }


export const getOEScaffoldingActivityInstanceControllerGetGradingCriteriaConfigQueryOptions = <TData = Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOEScaffoldingActivityInstanceControllerGetGradingCriteriaConfigQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig>>> = ({ signal }) => oEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OEScaffoldingActivityInstanceControllerGetGradingCriteriaConfigQueryResult = NonNullable<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig>>>
export type OEScaffoldingActivityInstanceControllerGetGradingCriteriaConfigQueryError = ErrorType<unknown>


export function useOEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig<TData = Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig>>,
          TError,
          Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig<TData = Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig>>,
          TError,
          Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig<TData = Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig<TData = Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOEScaffoldingActivityInstanceControllerGetGradingCriteriaConfigQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useOEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig} query
 */
export const invalidateOEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getOEScaffoldingActivityInstanceControllerGetGradingCriteriaConfigQueryKey(id) }, options);

  return queryClient;
}

export const useSetOEScaffoldingActivityInstanceControllerGetGradingCriteriaConfigQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig>> | undefined | ((old: Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig>> | undefined) => Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig>>>({ exact: $exactMatch, queryKey: getOEScaffoldingActivityInstanceControllerGetGradingCriteriaConfigQueryKey(id) }, updater);
  };
}

export const useGetOEScaffoldingActivityInstanceControllerGetGradingCriteriaConfigQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerGetGradingCriteriaConfig>>>(getOEScaffoldingActivityInstanceControllerGetGradingCriteriaConfigQueryKey(id));
}



export const oEScaffoldingActivityInstanceControllerSubmitTask = (
    id: string,
    taskId: string,
    baseSubmitOEScaffoldingTaskDto: BodyType<BaseSubmitOEScaffoldingTaskDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TaskTransaction>(
      {url: `/oe-scaffolding-activity-instances/${id}/tasks/${taskId}/submit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: baseSubmitOEScaffoldingTaskDto, signal
    },
      options);
    }




export const getOEScaffoldingActivityInstanceControllerSubmitTaskMutationKey = () => ['oEScaffoldingActivityInstanceControllerSubmitTask'] as const;

export const getOEScaffoldingActivityInstanceControllerSubmitTaskMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerSubmitTask>>, TError,OEScaffoldingActivityInstanceControllerSubmitTaskMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerSubmitTask>>, TError,OEScaffoldingActivityInstanceControllerSubmitTaskMutationVariables, TContext> => {

const mutationKey = getOEScaffoldingActivityInstanceControllerSubmitTaskMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerSubmitTask>>, OEScaffoldingActivityInstanceControllerSubmitTaskMutationVariables> = (props) => {
          const {id,taskId,data} = props ?? {};

          return  oEScaffoldingActivityInstanceControllerSubmitTask(id,taskId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OEScaffoldingActivityInstanceControllerSubmitTaskMutationResult = NonNullable<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerSubmitTask>>>
    export type OEScaffoldingActivityInstanceControllerSubmitTaskMutationBody = BodyType<BaseSubmitOEScaffoldingTaskDto>
    export type OEScaffoldingActivityInstanceControllerSubmitTaskMutationError = ErrorType<unknown>
    export type OEScaffoldingActivityInstanceControllerSubmitTaskMutationVariables = {id: string;taskId: string;data: BodyType<BaseSubmitOEScaffoldingTaskDto>}

    export const useOEScaffoldingActivityInstanceControllerSubmitTask = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerSubmitTask>>, TError,OEScaffoldingActivityInstanceControllerSubmitTaskMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerSubmitTask>>,
        TError,
        OEScaffoldingActivityInstanceControllerSubmitTaskMutationVariables,
        TContext
      > => {
      return useMutation(getOEScaffoldingActivityInstanceControllerSubmitTaskMutationOptions(options), queryClient);
    }

export const oEScaffoldingActivityInstanceControllerSubmitTaskWithAudio = (
    id: string,
    taskId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<OEScaffoldingActivityInstanceControllerSubmitTaskWithAudio201>(
      {url: `/oe-scaffolding-activity-instances/${id}/tasks/${taskId}/submit-audio`, method: 'POST', signal
    },
      options);
    }




export const getOEScaffoldingActivityInstanceControllerSubmitTaskWithAudioMutationKey = () => ['oEScaffoldingActivityInstanceControllerSubmitTaskWithAudio'] as const;

export const getOEScaffoldingActivityInstanceControllerSubmitTaskWithAudioMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerSubmitTaskWithAudio>>, TError,OEScaffoldingActivityInstanceControllerSubmitTaskWithAudioMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerSubmitTaskWithAudio>>, TError,OEScaffoldingActivityInstanceControllerSubmitTaskWithAudioMutationVariables, TContext> => {

const mutationKey = getOEScaffoldingActivityInstanceControllerSubmitTaskWithAudioMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerSubmitTaskWithAudio>>, OEScaffoldingActivityInstanceControllerSubmitTaskWithAudioMutationVariables> = (props) => {
          const {id,taskId} = props ?? {};

          return  oEScaffoldingActivityInstanceControllerSubmitTaskWithAudio(id,taskId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OEScaffoldingActivityInstanceControllerSubmitTaskWithAudioMutationResult = NonNullable<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerSubmitTaskWithAudio>>>

    export type OEScaffoldingActivityInstanceControllerSubmitTaskWithAudioMutationError = ErrorType<unknown>
    export type OEScaffoldingActivityInstanceControllerSubmitTaskWithAudioMutationVariables = {id: string;taskId: string}

    export const useOEScaffoldingActivityInstanceControllerSubmitTaskWithAudio = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerSubmitTaskWithAudio>>, TError,OEScaffoldingActivityInstanceControllerSubmitTaskWithAudioMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerSubmitTaskWithAudio>>,
        TError,
        OEScaffoldingActivityInstanceControllerSubmitTaskWithAudioMutationVariables,
        TContext
      > => {
      return useMutation(getOEScaffoldingActivityInstanceControllerSubmitTaskWithAudioMutationOptions(options), queryClient);
    }

export const oEScaffoldingActivityInstanceControllerCompleteTaskTransaction = (
    activityInstanceId: string,
    taskTransactionId: string,
    baseCompleteOEScaffoldingTaskDto: BodyType<BaseCompleteOEScaffoldingTaskDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<OEScaffoldingActivityInstance>(
      {url: `/oe-scaffolding-activity-instances/${activityInstanceId}/task-transactions/${taskTransactionId}/complete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: baseCompleteOEScaffoldingTaskDto, signal
    },
      options);
    }




export const getOEScaffoldingActivityInstanceControllerCompleteTaskTransactionMutationKey = () => ['oEScaffoldingActivityInstanceControllerCompleteTaskTransaction'] as const;

export const getOEScaffoldingActivityInstanceControllerCompleteTaskTransactionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerCompleteTaskTransaction>>, TError,OEScaffoldingActivityInstanceControllerCompleteTaskTransactionMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerCompleteTaskTransaction>>, TError,OEScaffoldingActivityInstanceControllerCompleteTaskTransactionMutationVariables, TContext> => {

const mutationKey = getOEScaffoldingActivityInstanceControllerCompleteTaskTransactionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerCompleteTaskTransaction>>, OEScaffoldingActivityInstanceControllerCompleteTaskTransactionMutationVariables> = (props) => {
          const {activityInstanceId,taskTransactionId,data} = props ?? {};

          return  oEScaffoldingActivityInstanceControllerCompleteTaskTransaction(activityInstanceId,taskTransactionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OEScaffoldingActivityInstanceControllerCompleteTaskTransactionMutationResult = NonNullable<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerCompleteTaskTransaction>>>
    export type OEScaffoldingActivityInstanceControllerCompleteTaskTransactionMutationBody = BodyType<BaseCompleteOEScaffoldingTaskDto>
    export type OEScaffoldingActivityInstanceControllerCompleteTaskTransactionMutationError = ErrorType<unknown>
    export type OEScaffoldingActivityInstanceControllerCompleteTaskTransactionMutationVariables = {activityInstanceId: string;taskTransactionId: string;data: BodyType<BaseCompleteOEScaffoldingTaskDto>}

    export const useOEScaffoldingActivityInstanceControllerCompleteTaskTransaction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerCompleteTaskTransaction>>, TError,OEScaffoldingActivityInstanceControllerCompleteTaskTransactionMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerCompleteTaskTransaction>>,
        TError,
        OEScaffoldingActivityInstanceControllerCompleteTaskTransactionMutationVariables,
        TContext
      > => {
      return useMutation(getOEScaffoldingActivityInstanceControllerCompleteTaskTransactionMutationOptions(options), queryClient);
    }

export const oEScaffoldingActivityInstanceControllerCompleteActivityInstance = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<OEScaffoldingActivityInstanceControllerCompleteActivityInstance201>(
      {url: `/oe-scaffolding-activity-instances/${id}/complete`, method: 'POST', signal
    },
      options);
    }




export const getOEScaffoldingActivityInstanceControllerCompleteActivityInstanceMutationKey = () => ['oEScaffoldingActivityInstanceControllerCompleteActivityInstance'] as const;

export const getOEScaffoldingActivityInstanceControllerCompleteActivityInstanceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerCompleteActivityInstance>>, TError,OEScaffoldingActivityInstanceControllerCompleteActivityInstanceMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerCompleteActivityInstance>>, TError,OEScaffoldingActivityInstanceControllerCompleteActivityInstanceMutationVariables, TContext> => {

const mutationKey = getOEScaffoldingActivityInstanceControllerCompleteActivityInstanceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerCompleteActivityInstance>>, OEScaffoldingActivityInstanceControllerCompleteActivityInstanceMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  oEScaffoldingActivityInstanceControllerCompleteActivityInstance(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OEScaffoldingActivityInstanceControllerCompleteActivityInstanceMutationResult = NonNullable<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerCompleteActivityInstance>>>

    export type OEScaffoldingActivityInstanceControllerCompleteActivityInstanceMutationError = ErrorType<unknown>
    export type OEScaffoldingActivityInstanceControllerCompleteActivityInstanceMutationVariables = {id: string}

    export const useOEScaffoldingActivityInstanceControllerCompleteActivityInstance = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerCompleteActivityInstance>>, TError,OEScaffoldingActivityInstanceControllerCompleteActivityInstanceMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof oEScaffoldingActivityInstanceControllerCompleteActivityInstance>>,
        TError,
        OEScaffoldingActivityInstanceControllerCompleteActivityInstanceMutationVariables,
        TContext
      > => {
      return useMutation(getOEScaffoldingActivityInstanceControllerCompleteActivityInstanceMutationOptions(options), queryClient);
    }

export const taskGradingCriteriaControllerGetPronunciationGradingCriteria = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TaskGradingCriteriaControllerGetPronunciationGradingCriteria200>(
      {url: `/task-grading-criteria/pronunciation`, method: 'GET', signal
    },
      options);
    }




export const getTaskGradingCriteriaControllerGetPronunciationGradingCriteriaQueryKey = () => {
    return [
    `/task-grading-criteria/pronunciation`
    ] as const;
    }


export const getTaskGradingCriteriaControllerGetPronunciationGradingCriteriaQueryOptions = <TData = Awaited<ReturnType<typeof taskGradingCriteriaControllerGetPronunciationGradingCriteria>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskGradingCriteriaControllerGetPronunciationGradingCriteria>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTaskGradingCriteriaControllerGetPronunciationGradingCriteriaQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof taskGradingCriteriaControllerGetPronunciationGradingCriteria>>> = ({ signal }) => taskGradingCriteriaControllerGetPronunciationGradingCriteria(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof taskGradingCriteriaControllerGetPronunciationGradingCriteria>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TaskGradingCriteriaControllerGetPronunciationGradingCriteriaQueryResult = NonNullable<Awaited<ReturnType<typeof taskGradingCriteriaControllerGetPronunciationGradingCriteria>>>
export type TaskGradingCriteriaControllerGetPronunciationGradingCriteriaQueryError = ErrorType<unknown>


export function useTaskGradingCriteriaControllerGetPronunciationGradingCriteria<TData = Awaited<ReturnType<typeof taskGradingCriteriaControllerGetPronunciationGradingCriteria>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskGradingCriteriaControllerGetPronunciationGradingCriteria>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskGradingCriteriaControllerGetPronunciationGradingCriteria>>,
          TError,
          Awaited<ReturnType<typeof taskGradingCriteriaControllerGetPronunciationGradingCriteria>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskGradingCriteriaControllerGetPronunciationGradingCriteria<TData = Awaited<ReturnType<typeof taskGradingCriteriaControllerGetPronunciationGradingCriteria>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskGradingCriteriaControllerGetPronunciationGradingCriteria>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskGradingCriteriaControllerGetPronunciationGradingCriteria>>,
          TError,
          Awaited<ReturnType<typeof taskGradingCriteriaControllerGetPronunciationGradingCriteria>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskGradingCriteriaControllerGetPronunciationGradingCriteria<TData = Awaited<ReturnType<typeof taskGradingCriteriaControllerGetPronunciationGradingCriteria>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskGradingCriteriaControllerGetPronunciationGradingCriteria>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTaskGradingCriteriaControllerGetPronunciationGradingCriteria<TData = Awaited<ReturnType<typeof taskGradingCriteriaControllerGetPronunciationGradingCriteria>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskGradingCriteriaControllerGetPronunciationGradingCriteria>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTaskGradingCriteriaControllerGetPronunciationGradingCriteriaQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useTaskGradingCriteriaControllerGetPronunciationGradingCriteria} query
 */
export const invalidateTaskGradingCriteriaControllerGetPronunciationGradingCriteria = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getTaskGradingCriteriaControllerGetPronunciationGradingCriteriaQueryKey() }, options);

  return queryClient;
}

export const useSetTaskGradingCriteriaControllerGetPronunciationGradingCriteriaQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof taskGradingCriteriaControllerGetPronunciationGradingCriteria>> | undefined | ((old: Awaited<ReturnType<typeof taskGradingCriteriaControllerGetPronunciationGradingCriteria>> | undefined) => Awaited<ReturnType<typeof taskGradingCriteriaControllerGetPronunciationGradingCriteria>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof taskGradingCriteriaControllerGetPronunciationGradingCriteria>>>({ exact: $exactMatch, queryKey: getTaskGradingCriteriaControllerGetPronunciationGradingCriteriaQueryKey() }, updater);
  };
}

export const useGetTaskGradingCriteriaControllerGetPronunciationGradingCriteriaQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof taskGradingCriteriaControllerGetPronunciationGradingCriteria>>>(getTaskGradingCriteriaControllerGetPronunciationGradingCriteriaQueryKey());
}



export const cheatDetectionControllerFindMany = (
    params?: CheatDetectionControllerFindManyParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CheatDetectionControllerFindMany200Item[]>(
      {url: `/cheat-detection`, method: 'GET',
        params, signal
    },
      options);
    }




export const getCheatDetectionControllerFindManyQueryKey = (params?: CheatDetectionControllerFindManyParams,) => {
    return [
    `/cheat-detection`, ...(params ? [params] : [])
    ] as const;
    }


export const getCheatDetectionControllerFindManyQueryOptions = <TData = Awaited<ReturnType<typeof cheatDetectionControllerFindMany>>, TError = ErrorType<unknown>>(params?: CheatDetectionControllerFindManyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cheatDetectionControllerFindMany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheatDetectionControllerFindManyQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof cheatDetectionControllerFindMany>>> = ({ signal }) => cheatDetectionControllerFindMany(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cheatDetectionControllerFindMany>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CheatDetectionControllerFindManyQueryResult = NonNullable<Awaited<ReturnType<typeof cheatDetectionControllerFindMany>>>
export type CheatDetectionControllerFindManyQueryError = ErrorType<unknown>


export function useCheatDetectionControllerFindMany<TData = Awaited<ReturnType<typeof cheatDetectionControllerFindMany>>, TError = ErrorType<unknown>>(
 params: undefined |  CheatDetectionControllerFindManyParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof cheatDetectionControllerFindMany>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof cheatDetectionControllerFindMany>>,
          TError,
          Awaited<ReturnType<typeof cheatDetectionControllerFindMany>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCheatDetectionControllerFindMany<TData = Awaited<ReturnType<typeof cheatDetectionControllerFindMany>>, TError = ErrorType<unknown>>(
 params?: CheatDetectionControllerFindManyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cheatDetectionControllerFindMany>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof cheatDetectionControllerFindMany>>,
          TError,
          Awaited<ReturnType<typeof cheatDetectionControllerFindMany>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCheatDetectionControllerFindMany<TData = Awaited<ReturnType<typeof cheatDetectionControllerFindMany>>, TError = ErrorType<unknown>>(
 params?: CheatDetectionControllerFindManyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cheatDetectionControllerFindMany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCheatDetectionControllerFindMany<TData = Awaited<ReturnType<typeof cheatDetectionControllerFindMany>>, TError = ErrorType<unknown>>(
 params?: CheatDetectionControllerFindManyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cheatDetectionControllerFindMany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCheatDetectionControllerFindManyQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useCheatDetectionControllerFindMany} query
 */
export const invalidateCheatDetectionControllerFindMany = async (
 queryClient: QueryClient, params?: CheatDetectionControllerFindManyParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getCheatDetectionControllerFindManyQueryKey(params) }, options);

  return queryClient;
}

export const useSetCheatDetectionControllerFindManyQueryData = () => {
  const queryClient = useQueryClient();
  return (params: CheatDetectionControllerFindManyParams | undefined,updater: Awaited<ReturnType<typeof cheatDetectionControllerFindMany>> | undefined | ((old: Awaited<ReturnType<typeof cheatDetectionControllerFindMany>> | undefined) => Awaited<ReturnType<typeof cheatDetectionControllerFindMany>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof cheatDetectionControllerFindMany>>>({ exact: $exactMatch, queryKey: getCheatDetectionControllerFindManyQueryKey(params) }, updater);
  };
}

export const useGetCheatDetectionControllerFindManyQueryData = () => {
  const queryClient = useQueryClient();
  return (params?: CheatDetectionControllerFindManyParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof cheatDetectionControllerFindMany>>>(getCheatDetectionControllerFindManyQueryKey(params));
}



export const cheatDetectionControllerUpdate = (
    cheatDetectionId: string,
    updateCheatDetectionDto: BodyType<UpdateCheatDetectionDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CheatDetectionResults>(
      {url: `/cheat-detection/${cheatDetectionId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCheatDetectionDto, signal
    },
      options);
    }




export const getCheatDetectionControllerUpdateMutationKey = () => ['cheatDetectionControllerUpdate'] as const;

export const getCheatDetectionControllerUpdateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cheatDetectionControllerUpdate>>, TError,CheatDetectionControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cheatDetectionControllerUpdate>>, TError,CheatDetectionControllerUpdateMutationVariables, TContext> => {

const mutationKey = getCheatDetectionControllerUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cheatDetectionControllerUpdate>>, CheatDetectionControllerUpdateMutationVariables> = (props) => {
          const {cheatDetectionId,data} = props ?? {};

          return  cheatDetectionControllerUpdate(cheatDetectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheatDetectionControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof cheatDetectionControllerUpdate>>>
    export type CheatDetectionControllerUpdateMutationBody = BodyType<UpdateCheatDetectionDto>
    export type CheatDetectionControllerUpdateMutationError = ErrorType<unknown>
    export type CheatDetectionControllerUpdateMutationVariables = {cheatDetectionId: string;data: BodyType<UpdateCheatDetectionDto>}

    export const useCheatDetectionControllerUpdate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cheatDetectionControllerUpdate>>, TError,CheatDetectionControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cheatDetectionControllerUpdate>>,
        TError,
        CheatDetectionControllerUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getCheatDetectionControllerUpdateMutationOptions(options), queryClient);
    }

export const lessonControllerCreate = (
    createLessonDto: BodyType<CreateLessonDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LessonControllerCreate201>(
      {url: `/lessons`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createLessonDto, signal
    },
      options);
    }




export const getLessonControllerCreateMutationKey = () => ['lessonControllerCreate'] as const;

export const getLessonControllerCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonControllerCreate>>, TError,LessonControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof lessonControllerCreate>>, TError,LessonControllerCreateMutationVariables, TContext> => {

const mutationKey = getLessonControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof lessonControllerCreate>>, LessonControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  lessonControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LessonControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof lessonControllerCreate>>>
    export type LessonControllerCreateMutationBody = BodyType<CreateLessonDto>
    export type LessonControllerCreateMutationError = ErrorType<unknown>
    export type LessonControllerCreateMutationVariables = {data: BodyType<CreateLessonDto>}

    export const useLessonControllerCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonControllerCreate>>, TError,LessonControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof lessonControllerCreate>>,
        TError,
        LessonControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getLessonControllerCreateMutationOptions(options), queryClient);
    }

export const lessonControllerFindByIds = (
    params: LessonControllerFindByIdsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LessonControllerFindByIds200Item[]>(
      {url: `/lessons`, method: 'GET',
        params, signal
    },
      options);
    }




export const getLessonControllerFindByIdsQueryKey = (params?: LessonControllerFindByIdsParams,) => {
    return [
    `/lessons`, ...(params ? [params] : [])
    ] as const;
    }


export const getLessonControllerFindByIdsQueryOptions = <TData = Awaited<ReturnType<typeof lessonControllerFindByIds>>, TError = ErrorType<unknown>>(params: LessonControllerFindByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonControllerFindByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLessonControllerFindByIdsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lessonControllerFindByIds>>> = ({ signal }) => lessonControllerFindByIds(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lessonControllerFindByIds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LessonControllerFindByIdsQueryResult = NonNullable<Awaited<ReturnType<typeof lessonControllerFindByIds>>>
export type LessonControllerFindByIdsQueryError = ErrorType<unknown>


export function useLessonControllerFindByIds<TData = Awaited<ReturnType<typeof lessonControllerFindByIds>>, TError = ErrorType<unknown>>(
 params: LessonControllerFindByIdsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonControllerFindByIds>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonControllerFindByIds>>,
          TError,
          Awaited<ReturnType<typeof lessonControllerFindByIds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonControllerFindByIds<TData = Awaited<ReturnType<typeof lessonControllerFindByIds>>, TError = ErrorType<unknown>>(
 params: LessonControllerFindByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonControllerFindByIds>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonControllerFindByIds>>,
          TError,
          Awaited<ReturnType<typeof lessonControllerFindByIds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonControllerFindByIds<TData = Awaited<ReturnType<typeof lessonControllerFindByIds>>, TError = ErrorType<unknown>>(
 params: LessonControllerFindByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonControllerFindByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLessonControllerFindByIds<TData = Awaited<ReturnType<typeof lessonControllerFindByIds>>, TError = ErrorType<unknown>>(
 params: LessonControllerFindByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonControllerFindByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLessonControllerFindByIdsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLessonControllerFindByIds} query
 */
export const invalidateLessonControllerFindByIds = async (
 queryClient: QueryClient, params: LessonControllerFindByIdsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLessonControllerFindByIdsQueryKey(params) }, options);

  return queryClient;
}

export const useSetLessonControllerFindByIdsQueryData = () => {
  const queryClient = useQueryClient();
  return (params: LessonControllerFindByIdsParams | undefined,updater: Awaited<ReturnType<typeof lessonControllerFindByIds>> | undefined | ((old: Awaited<ReturnType<typeof lessonControllerFindByIds>> | undefined) => Awaited<ReturnType<typeof lessonControllerFindByIds>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof lessonControllerFindByIds>>>({ exact: $exactMatch, queryKey: getLessonControllerFindByIdsQueryKey(params) }, updater);
  };
}

export const useGetLessonControllerFindByIdsQueryData = () => {
  const queryClient = useQueryClient();
  return (params: LessonControllerFindByIdsParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof lessonControllerFindByIds>>>(getLessonControllerFindByIdsQueryKey(params));
}



export const lessonControllerUpdate = (
    id: string,
    updateLessonDto: BodyType<UpdateLessonDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LessonControllerUpdate200>(
      {url: `/lessons/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateLessonDto, signal
    },
      options);
    }




export const getLessonControllerUpdateMutationKey = () => ['lessonControllerUpdate'] as const;

export const getLessonControllerUpdateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonControllerUpdate>>, TError,LessonControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof lessonControllerUpdate>>, TError,LessonControllerUpdateMutationVariables, TContext> => {

const mutationKey = getLessonControllerUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof lessonControllerUpdate>>, LessonControllerUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  lessonControllerUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LessonControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof lessonControllerUpdate>>>
    export type LessonControllerUpdateMutationBody = BodyType<UpdateLessonDto>
    export type LessonControllerUpdateMutationError = ErrorType<unknown>
    export type LessonControllerUpdateMutationVariables = {id: string;data: BodyType<UpdateLessonDto>}

    export const useLessonControllerUpdate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonControllerUpdate>>, TError,LessonControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof lessonControllerUpdate>>,
        TError,
        LessonControllerUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getLessonControllerUpdateMutationOptions(options), queryClient);
    }

export const lessonControllerFindById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LessonControllerFindById200>(
      {url: `/lessons/${id}`, method: 'GET', signal
    },
      options);
    }




export const getLessonControllerFindByIdQueryKey = (id: string,) => {
    return [
    `/lessons/${id}`
    ] as const;
    }


export const getLessonControllerFindByIdQueryOptions = <TData = Awaited<ReturnType<typeof lessonControllerFindById>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLessonControllerFindByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lessonControllerFindById>>> = ({ signal }) => lessonControllerFindById(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lessonControllerFindById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LessonControllerFindByIdQueryResult = NonNullable<Awaited<ReturnType<typeof lessonControllerFindById>>>
export type LessonControllerFindByIdQueryError = ErrorType<unknown>


export function useLessonControllerFindById<TData = Awaited<ReturnType<typeof lessonControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonControllerFindById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof lessonControllerFindById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonControllerFindById<TData = Awaited<ReturnType<typeof lessonControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonControllerFindById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof lessonControllerFindById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonControllerFindById<TData = Awaited<ReturnType<typeof lessonControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLessonControllerFindById<TData = Awaited<ReturnType<typeof lessonControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLessonControllerFindByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLessonControllerFindById} query
 */
export const invalidateLessonControllerFindById = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLessonControllerFindByIdQueryKey(id) }, options);

  return queryClient;
}

export const useSetLessonControllerFindByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof lessonControllerFindById>> | undefined | ((old: Awaited<ReturnType<typeof lessonControllerFindById>> | undefined) => Awaited<ReturnType<typeof lessonControllerFindById>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof lessonControllerFindById>>>({ exact: $exactMatch, queryKey: getLessonControllerFindByIdQueryKey(id) }, updater);
  };
}

export const useGetLessonControllerFindByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof lessonControllerFindById>>>(getLessonControllerFindByIdQueryKey(id));
}



export const lessonControllerGetLessonScore = (
    id: string,
    params?: LessonControllerGetLessonScoreParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LessonControllerGetLessonScore200>(
      {url: `/lessons/${id}/score`, method: 'GET',
        params, signal
    },
      options);
    }




export const getLessonControllerGetLessonScoreQueryKey = (id: string,
    params?: LessonControllerGetLessonScoreParams,) => {
    return [
    `/lessons/${id}/score`, ...(params ? [params] : [])
    ] as const;
    }


export const getLessonControllerGetLessonScoreQueryOptions = <TData = Awaited<ReturnType<typeof lessonControllerGetLessonScore>>, TError = ErrorType<unknown>>(id: string,
    params?: LessonControllerGetLessonScoreParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonControllerGetLessonScore>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLessonControllerGetLessonScoreQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lessonControllerGetLessonScore>>> = ({ signal }) => lessonControllerGetLessonScore(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lessonControllerGetLessonScore>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LessonControllerGetLessonScoreQueryResult = NonNullable<Awaited<ReturnType<typeof lessonControllerGetLessonScore>>>
export type LessonControllerGetLessonScoreQueryError = ErrorType<unknown>


export function useLessonControllerGetLessonScore<TData = Awaited<ReturnType<typeof lessonControllerGetLessonScore>>, TError = ErrorType<unknown>>(
 id: string,
    params: undefined |  LessonControllerGetLessonScoreParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonControllerGetLessonScore>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonControllerGetLessonScore>>,
          TError,
          Awaited<ReturnType<typeof lessonControllerGetLessonScore>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonControllerGetLessonScore<TData = Awaited<ReturnType<typeof lessonControllerGetLessonScore>>, TError = ErrorType<unknown>>(
 id: string,
    params?: LessonControllerGetLessonScoreParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonControllerGetLessonScore>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonControllerGetLessonScore>>,
          TError,
          Awaited<ReturnType<typeof lessonControllerGetLessonScore>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonControllerGetLessonScore<TData = Awaited<ReturnType<typeof lessonControllerGetLessonScore>>, TError = ErrorType<unknown>>(
 id: string,
    params?: LessonControllerGetLessonScoreParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonControllerGetLessonScore>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLessonControllerGetLessonScore<TData = Awaited<ReturnType<typeof lessonControllerGetLessonScore>>, TError = ErrorType<unknown>>(
 id: string,
    params?: LessonControllerGetLessonScoreParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonControllerGetLessonScore>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLessonControllerGetLessonScoreQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLessonControllerGetLessonScore} query
 */
export const invalidateLessonControllerGetLessonScore = async (
 queryClient: QueryClient, id: string,
    params?: LessonControllerGetLessonScoreParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLessonControllerGetLessonScoreQueryKey(id,params) }, options);

  return queryClient;
}

export const useSetLessonControllerGetLessonScoreQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,
    params: LessonControllerGetLessonScoreParams | undefined,updater: Awaited<ReturnType<typeof lessonControllerGetLessonScore>> | undefined | ((old: Awaited<ReturnType<typeof lessonControllerGetLessonScore>> | undefined) => Awaited<ReturnType<typeof lessonControllerGetLessonScore>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof lessonControllerGetLessonScore>>>({ exact: $exactMatch, queryKey: getLessonControllerGetLessonScoreQueryKey(id,params) }, updater);
  };
}

export const useGetLessonControllerGetLessonScoreQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,
    params?: LessonControllerGetLessonScoreParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof lessonControllerGetLessonScore>>>(getLessonControllerGetLessonScoreQueryKey(id,params));
}



export const lessonControllerGetLessonActivities = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LessonControllerGetLessonActivities200Item[]>(
      {url: `/lessons/${id}/activities`, method: 'GET', signal
    },
      options);
    }




export const getLessonControllerGetLessonActivitiesQueryKey = (id: string,) => {
    return [
    `/lessons/${id}/activities`
    ] as const;
    }


export const getLessonControllerGetLessonActivitiesQueryOptions = <TData = Awaited<ReturnType<typeof lessonControllerGetLessonActivities>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonControllerGetLessonActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLessonControllerGetLessonActivitiesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lessonControllerGetLessonActivities>>> = ({ signal }) => lessonControllerGetLessonActivities(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lessonControllerGetLessonActivities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LessonControllerGetLessonActivitiesQueryResult = NonNullable<Awaited<ReturnType<typeof lessonControllerGetLessonActivities>>>
export type LessonControllerGetLessonActivitiesQueryError = ErrorType<unknown>


export function useLessonControllerGetLessonActivities<TData = Awaited<ReturnType<typeof lessonControllerGetLessonActivities>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonControllerGetLessonActivities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonControllerGetLessonActivities>>,
          TError,
          Awaited<ReturnType<typeof lessonControllerGetLessonActivities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonControllerGetLessonActivities<TData = Awaited<ReturnType<typeof lessonControllerGetLessonActivities>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonControllerGetLessonActivities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonControllerGetLessonActivities>>,
          TError,
          Awaited<ReturnType<typeof lessonControllerGetLessonActivities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonControllerGetLessonActivities<TData = Awaited<ReturnType<typeof lessonControllerGetLessonActivities>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonControllerGetLessonActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLessonControllerGetLessonActivities<TData = Awaited<ReturnType<typeof lessonControllerGetLessonActivities>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonControllerGetLessonActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLessonControllerGetLessonActivitiesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLessonControllerGetLessonActivities} query
 */
export const invalidateLessonControllerGetLessonActivities = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLessonControllerGetLessonActivitiesQueryKey(id) }, options);

  return queryClient;
}

export const useSetLessonControllerGetLessonActivitiesQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof lessonControllerGetLessonActivities>> | undefined | ((old: Awaited<ReturnType<typeof lessonControllerGetLessonActivities>> | undefined) => Awaited<ReturnType<typeof lessonControllerGetLessonActivities>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof lessonControllerGetLessonActivities>>>({ exact: $exactMatch, queryKey: getLessonControllerGetLessonActivitiesQueryKey(id) }, updater);
  };
}

export const useGetLessonControllerGetLessonActivitiesQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof lessonControllerGetLessonActivities>>>(getLessonControllerGetLessonActivitiesQueryKey(id));
}



export const lessonControllerCreateAndAddActivities = (
    createAndAddActivitiesToLessonParams: BodyType<CreateAndAddActivitiesToLessonParams>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LessonControllerCreateAndAddActivities201>(
      {url: `/lessons/activities`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAndAddActivitiesToLessonParams, signal
    },
      options);
    }




export const getLessonControllerCreateAndAddActivitiesMutationKey = () => ['lessonControllerCreateAndAddActivities'] as const;

export const getLessonControllerCreateAndAddActivitiesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonControllerCreateAndAddActivities>>, TError,LessonControllerCreateAndAddActivitiesMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof lessonControllerCreateAndAddActivities>>, TError,LessonControllerCreateAndAddActivitiesMutationVariables, TContext> => {

const mutationKey = getLessonControllerCreateAndAddActivitiesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof lessonControllerCreateAndAddActivities>>, LessonControllerCreateAndAddActivitiesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  lessonControllerCreateAndAddActivities(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LessonControllerCreateAndAddActivitiesMutationResult = NonNullable<Awaited<ReturnType<typeof lessonControllerCreateAndAddActivities>>>
    export type LessonControllerCreateAndAddActivitiesMutationBody = BodyType<CreateAndAddActivitiesToLessonParams>
    export type LessonControllerCreateAndAddActivitiesMutationError = ErrorType<unknown>
    export type LessonControllerCreateAndAddActivitiesMutationVariables = {data: BodyType<CreateAndAddActivitiesToLessonParams>}

    export const useLessonControllerCreateAndAddActivities = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonControllerCreateAndAddActivities>>, TError,LessonControllerCreateAndAddActivitiesMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof lessonControllerCreateAndAddActivities>>,
        TError,
        LessonControllerCreateAndAddActivitiesMutationVariables,
        TContext
      > => {
      return useMutation(getLessonControllerCreateAndAddActivitiesMutationOptions(options), queryClient);
    }

export const lessonControllerStartLesson = (
    id: string,
    startLessonDto: BodyType<StartLessonDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LessonControllerStartLesson201>(
      {url: `/lessons/${id}/start-lesson`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: startLessonDto, signal
    },
      options);
    }




export const getLessonControllerStartLessonMutationKey = () => ['lessonControllerStartLesson'] as const;

export const getLessonControllerStartLessonMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonControllerStartLesson>>, TError,LessonControllerStartLessonMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof lessonControllerStartLesson>>, TError,LessonControllerStartLessonMutationVariables, TContext> => {

const mutationKey = getLessonControllerStartLessonMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof lessonControllerStartLesson>>, LessonControllerStartLessonMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  lessonControllerStartLesson(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LessonControllerStartLessonMutationResult = NonNullable<Awaited<ReturnType<typeof lessonControllerStartLesson>>>
    export type LessonControllerStartLessonMutationBody = BodyType<StartLessonDto>
    export type LessonControllerStartLessonMutationError = ErrorType<unknown>
    export type LessonControllerStartLessonMutationVariables = {id: string;data: BodyType<StartLessonDto>}

    export const useLessonControllerStartLesson = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonControllerStartLesson>>, TError,LessonControllerStartLessonMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof lessonControllerStartLesson>>,
        TError,
        LessonControllerStartLessonMutationVariables,
        TContext
      > => {
      return useMutation(getLessonControllerStartLessonMutationOptions(options), queryClient);
    }

export const lessonInstanceControllerGetInstancesByUserId = (
    params: LessonInstanceControllerGetInstancesByUserIdParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LessonInstanceControllerGetInstancesByUserId200Item[]>(
      {url: `/lesson-instances`, method: 'GET',
        params, signal
    },
      options);
    }




export const getLessonInstanceControllerGetInstancesByUserIdQueryKey = (params?: LessonInstanceControllerGetInstancesByUserIdParams,) => {
    return [
    `/lesson-instances`, ...(params ? [params] : [])
    ] as const;
    }


export const getLessonInstanceControllerGetInstancesByUserIdQueryOptions = <TData = Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByUserId>>, TError = ErrorType<unknown>>(params: LessonInstanceControllerGetInstancesByUserIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByUserId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLessonInstanceControllerGetInstancesByUserIdQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByUserId>>> = ({ signal }) => lessonInstanceControllerGetInstancesByUserId(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LessonInstanceControllerGetInstancesByUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByUserId>>>
export type LessonInstanceControllerGetInstancesByUserIdQueryError = ErrorType<unknown>


export function useLessonInstanceControllerGetInstancesByUserId<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByUserId>>, TError = ErrorType<unknown>>(
 params: LessonInstanceControllerGetInstancesByUserIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByUserId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByUserId>>,
          TError,
          Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonInstanceControllerGetInstancesByUserId<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByUserId>>, TError = ErrorType<unknown>>(
 params: LessonInstanceControllerGetInstancesByUserIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByUserId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByUserId>>,
          TError,
          Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonInstanceControllerGetInstancesByUserId<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByUserId>>, TError = ErrorType<unknown>>(
 params: LessonInstanceControllerGetInstancesByUserIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByUserId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLessonInstanceControllerGetInstancesByUserId<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByUserId>>, TError = ErrorType<unknown>>(
 params: LessonInstanceControllerGetInstancesByUserIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByUserId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLessonInstanceControllerGetInstancesByUserIdQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLessonInstanceControllerGetInstancesByUserId} query
 */
export const invalidateLessonInstanceControllerGetInstancesByUserId = async (
 queryClient: QueryClient, params: LessonInstanceControllerGetInstancesByUserIdParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLessonInstanceControllerGetInstancesByUserIdQueryKey(params) }, options);

  return queryClient;
}

export const useSetLessonInstanceControllerGetInstancesByUserIdQueryData = () => {
  const queryClient = useQueryClient();
  return (params: LessonInstanceControllerGetInstancesByUserIdParams | undefined,updater: Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByUserId>> | undefined | ((old: Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByUserId>> | undefined) => Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByUserId>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByUserId>>>({ exact: $exactMatch, queryKey: getLessonInstanceControllerGetInstancesByUserIdQueryKey(params) }, updater);
  };
}

export const useGetLessonInstanceControllerGetInstancesByUserIdQueryData = () => {
  const queryClient = useQueryClient();
  return (params: LessonInstanceControllerGetInstancesByUserIdParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByUserId>>>(getLessonInstanceControllerGetInstancesByUserIdQueryKey(params));
}



export const lessonInstanceControllerFindOne = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LessonInstanceControllerFindOne200>(
      {url: `/lesson-instances/${id}`, method: 'GET', signal
    },
      options);
    }




export const getLessonInstanceControllerFindOneQueryKey = (id: string,) => {
    return [
    `/lesson-instances/${id}`
    ] as const;
    }


export const getLessonInstanceControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof lessonInstanceControllerFindOne>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLessonInstanceControllerFindOneQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lessonInstanceControllerFindOne>>> = ({ signal }) => lessonInstanceControllerFindOne(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerFindOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LessonInstanceControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof lessonInstanceControllerFindOne>>>
export type LessonInstanceControllerFindOneQueryError = ErrorType<unknown>


export function useLessonInstanceControllerFindOne<TData = Awaited<ReturnType<typeof lessonInstanceControllerFindOne>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerFindOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonInstanceControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof lessonInstanceControllerFindOne>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonInstanceControllerFindOne<TData = Awaited<ReturnType<typeof lessonInstanceControllerFindOne>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerFindOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonInstanceControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof lessonInstanceControllerFindOne>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonInstanceControllerFindOne<TData = Awaited<ReturnType<typeof lessonInstanceControllerFindOne>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLessonInstanceControllerFindOne<TData = Awaited<ReturnType<typeof lessonInstanceControllerFindOne>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLessonInstanceControllerFindOneQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLessonInstanceControllerFindOne} query
 */
export const invalidateLessonInstanceControllerFindOne = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLessonInstanceControllerFindOneQueryKey(id) }, options);

  return queryClient;
}

export const useSetLessonInstanceControllerFindOneQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof lessonInstanceControllerFindOne>> | undefined | ((old: Awaited<ReturnType<typeof lessonInstanceControllerFindOne>> | undefined) => Awaited<ReturnType<typeof lessonInstanceControllerFindOne>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof lessonInstanceControllerFindOne>>>({ exact: $exactMatch, queryKey: getLessonInstanceControllerFindOneQueryKey(id) }, updater);
  };
}

export const useGetLessonInstanceControllerFindOneQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof lessonInstanceControllerFindOne>>>(getLessonInstanceControllerFindOneQueryKey(id));
}



export const lessonInstanceControllerDelete = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/lesson-instances/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getLessonInstanceControllerDeleteMutationKey = () => ['lessonInstanceControllerDelete'] as const;

export const getLessonInstanceControllerDeleteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonInstanceControllerDelete>>, TError,LessonInstanceControllerDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof lessonInstanceControllerDelete>>, TError,LessonInstanceControllerDeleteMutationVariables, TContext> => {

const mutationKey = getLessonInstanceControllerDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof lessonInstanceControllerDelete>>, LessonInstanceControllerDeleteMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  lessonInstanceControllerDelete(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LessonInstanceControllerDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof lessonInstanceControllerDelete>>>

    export type LessonInstanceControllerDeleteMutationError = ErrorType<unknown>
    export type LessonInstanceControllerDeleteMutationVariables = {id: string}

    export const useLessonInstanceControllerDelete = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonInstanceControllerDelete>>, TError,LessonInstanceControllerDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof lessonInstanceControllerDelete>>,
        TError,
        LessonInstanceControllerDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getLessonInstanceControllerDeleteMutationOptions(options), queryClient);
    }

export const lessonInstanceControllerGetLessonInstancesActivities = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/lesson-instances/${id}/activities`, method: 'GET', signal
    },
      options);
    }




export const getLessonInstanceControllerGetLessonInstancesActivitiesQueryKey = (id: string,) => {
    return [
    `/lesson-instances/${id}/activities`
    ] as const;
    }


export const getLessonInstanceControllerGetLessonInstancesActivitiesQueryOptions = <TData = Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstancesActivities>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstancesActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLessonInstanceControllerGetLessonInstancesActivitiesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstancesActivities>>> = ({ signal }) => lessonInstanceControllerGetLessonInstancesActivities(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstancesActivities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LessonInstanceControllerGetLessonInstancesActivitiesQueryResult = NonNullable<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstancesActivities>>>
export type LessonInstanceControllerGetLessonInstancesActivitiesQueryError = ErrorType<unknown>


export function useLessonInstanceControllerGetLessonInstancesActivities<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstancesActivities>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstancesActivities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstancesActivities>>,
          TError,
          Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstancesActivities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonInstanceControllerGetLessonInstancesActivities<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstancesActivities>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstancesActivities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstancesActivities>>,
          TError,
          Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstancesActivities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonInstanceControllerGetLessonInstancesActivities<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstancesActivities>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstancesActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLessonInstanceControllerGetLessonInstancesActivities<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstancesActivities>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstancesActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLessonInstanceControllerGetLessonInstancesActivitiesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLessonInstanceControllerGetLessonInstancesActivities} query
 */
export const invalidateLessonInstanceControllerGetLessonInstancesActivities = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLessonInstanceControllerGetLessonInstancesActivitiesQueryKey(id) }, options);

  return queryClient;
}

export const useSetLessonInstanceControllerGetLessonInstancesActivitiesQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstancesActivities>> | undefined | ((old: Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstancesActivities>> | undefined) => Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstancesActivities>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstancesActivities>>>({ exact: $exactMatch, queryKey: getLessonInstanceControllerGetLessonInstancesActivitiesQueryKey(id) }, updater);
  };
}

export const useGetLessonInstanceControllerGetLessonInstancesActivitiesQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstancesActivities>>>(getLessonInstanceControllerGetLessonInstancesActivitiesQueryKey(id));
}



export const lessonInstanceControllerGetRevampActivityCardData = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/lesson-instances/${id}/revamp-activity-card-data`, method: 'GET', signal
    },
      options);
    }




export const getLessonInstanceControllerGetRevampActivityCardDataQueryKey = (id: string,) => {
    return [
    `/lesson-instances/${id}/revamp-activity-card-data`
    ] as const;
    }


export const getLessonInstanceControllerGetRevampActivityCardDataQueryOptions = <TData = Awaited<ReturnType<typeof lessonInstanceControllerGetRevampActivityCardData>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetRevampActivityCardData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLessonInstanceControllerGetRevampActivityCardDataQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lessonInstanceControllerGetRevampActivityCardData>>> = ({ signal }) => lessonInstanceControllerGetRevampActivityCardData(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetRevampActivityCardData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LessonInstanceControllerGetRevampActivityCardDataQueryResult = NonNullable<Awaited<ReturnType<typeof lessonInstanceControllerGetRevampActivityCardData>>>
export type LessonInstanceControllerGetRevampActivityCardDataQueryError = ErrorType<unknown>


export function useLessonInstanceControllerGetRevampActivityCardData<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetRevampActivityCardData>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetRevampActivityCardData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonInstanceControllerGetRevampActivityCardData>>,
          TError,
          Awaited<ReturnType<typeof lessonInstanceControllerGetRevampActivityCardData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonInstanceControllerGetRevampActivityCardData<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetRevampActivityCardData>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetRevampActivityCardData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonInstanceControllerGetRevampActivityCardData>>,
          TError,
          Awaited<ReturnType<typeof lessonInstanceControllerGetRevampActivityCardData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonInstanceControllerGetRevampActivityCardData<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetRevampActivityCardData>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetRevampActivityCardData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLessonInstanceControllerGetRevampActivityCardData<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetRevampActivityCardData>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetRevampActivityCardData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLessonInstanceControllerGetRevampActivityCardDataQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLessonInstanceControllerGetRevampActivityCardData} query
 */
export const invalidateLessonInstanceControllerGetRevampActivityCardData = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLessonInstanceControllerGetRevampActivityCardDataQueryKey(id) }, options);

  return queryClient;
}

export const useSetLessonInstanceControllerGetRevampActivityCardDataQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof lessonInstanceControllerGetRevampActivityCardData>> | undefined | ((old: Awaited<ReturnType<typeof lessonInstanceControllerGetRevampActivityCardData>> | undefined) => Awaited<ReturnType<typeof lessonInstanceControllerGetRevampActivityCardData>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof lessonInstanceControllerGetRevampActivityCardData>>>({ exact: $exactMatch, queryKey: getLessonInstanceControllerGetRevampActivityCardDataQueryKey(id) }, updater);
  };
}

export const useGetLessonInstanceControllerGetRevampActivityCardDataQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof lessonInstanceControllerGetRevampActivityCardData>>>(getLessonInstanceControllerGetRevampActivityCardDataQueryKey(id));
}



export const lessonInstanceControllerGetActivitiesWithAllTransactions = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/lesson-instances/${id}/activities-with-all-transaction`, method: 'GET', signal
    },
      options);
    }




export const getLessonInstanceControllerGetActivitiesWithAllTransactionsQueryKey = (id: string,) => {
    return [
    `/lesson-instances/${id}/activities-with-all-transaction`
    ] as const;
    }


export const getLessonInstanceControllerGetActivitiesWithAllTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof lessonInstanceControllerGetActivitiesWithAllTransactions>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetActivitiesWithAllTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLessonInstanceControllerGetActivitiesWithAllTransactionsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lessonInstanceControllerGetActivitiesWithAllTransactions>>> = ({ signal }) => lessonInstanceControllerGetActivitiesWithAllTransactions(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetActivitiesWithAllTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LessonInstanceControllerGetActivitiesWithAllTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof lessonInstanceControllerGetActivitiesWithAllTransactions>>>
export type LessonInstanceControllerGetActivitiesWithAllTransactionsQueryError = ErrorType<unknown>


export function useLessonInstanceControllerGetActivitiesWithAllTransactions<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetActivitiesWithAllTransactions>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetActivitiesWithAllTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonInstanceControllerGetActivitiesWithAllTransactions>>,
          TError,
          Awaited<ReturnType<typeof lessonInstanceControllerGetActivitiesWithAllTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonInstanceControllerGetActivitiesWithAllTransactions<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetActivitiesWithAllTransactions>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetActivitiesWithAllTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonInstanceControllerGetActivitiesWithAllTransactions>>,
          TError,
          Awaited<ReturnType<typeof lessonInstanceControllerGetActivitiesWithAllTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonInstanceControllerGetActivitiesWithAllTransactions<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetActivitiesWithAllTransactions>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetActivitiesWithAllTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLessonInstanceControllerGetActivitiesWithAllTransactions<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetActivitiesWithAllTransactions>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetActivitiesWithAllTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLessonInstanceControllerGetActivitiesWithAllTransactionsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLessonInstanceControllerGetActivitiesWithAllTransactions} query
 */
export const invalidateLessonInstanceControllerGetActivitiesWithAllTransactions = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLessonInstanceControllerGetActivitiesWithAllTransactionsQueryKey(id) }, options);

  return queryClient;
}

export const useSetLessonInstanceControllerGetActivitiesWithAllTransactionsQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof lessonInstanceControllerGetActivitiesWithAllTransactions>> | undefined | ((old: Awaited<ReturnType<typeof lessonInstanceControllerGetActivitiesWithAllTransactions>> | undefined) => Awaited<ReturnType<typeof lessonInstanceControllerGetActivitiesWithAllTransactions>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof lessonInstanceControllerGetActivitiesWithAllTransactions>>>({ exact: $exactMatch, queryKey: getLessonInstanceControllerGetActivitiesWithAllTransactionsQueryKey(id) }, updater);
  };
}

export const useGetLessonInstanceControllerGetActivitiesWithAllTransactionsQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof lessonInstanceControllerGetActivitiesWithAllTransactions>>>(getLessonInstanceControllerGetActivitiesWithAllTransactionsQueryKey(id));
}



export const lessonInstanceControllerGetUserActivityInstancesByLessonInstanceId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LessonInstanceControllerGetUserActivityInstancesByLessonInstanceId200Item[]>(
      {url: `/lesson-instances/${id}/user-activity-instances`, method: 'GET', signal
    },
      options);
    }




export const getLessonInstanceControllerGetUserActivityInstancesByLessonInstanceIdQueryKey = (id: string,) => {
    return [
    `/lesson-instances/${id}/user-activity-instances`
    ] as const;
    }


export const getLessonInstanceControllerGetUserActivityInstancesByLessonInstanceIdQueryOptions = <TData = Awaited<ReturnType<typeof lessonInstanceControllerGetUserActivityInstancesByLessonInstanceId>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetUserActivityInstancesByLessonInstanceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLessonInstanceControllerGetUserActivityInstancesByLessonInstanceIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lessonInstanceControllerGetUserActivityInstancesByLessonInstanceId>>> = ({ signal }) => lessonInstanceControllerGetUserActivityInstancesByLessonInstanceId(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetUserActivityInstancesByLessonInstanceId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LessonInstanceControllerGetUserActivityInstancesByLessonInstanceIdQueryResult = NonNullable<Awaited<ReturnType<typeof lessonInstanceControllerGetUserActivityInstancesByLessonInstanceId>>>
export type LessonInstanceControllerGetUserActivityInstancesByLessonInstanceIdQueryError = ErrorType<unknown>


export function useLessonInstanceControllerGetUserActivityInstancesByLessonInstanceId<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetUserActivityInstancesByLessonInstanceId>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetUserActivityInstancesByLessonInstanceId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonInstanceControllerGetUserActivityInstancesByLessonInstanceId>>,
          TError,
          Awaited<ReturnType<typeof lessonInstanceControllerGetUserActivityInstancesByLessonInstanceId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonInstanceControllerGetUserActivityInstancesByLessonInstanceId<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetUserActivityInstancesByLessonInstanceId>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetUserActivityInstancesByLessonInstanceId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonInstanceControllerGetUserActivityInstancesByLessonInstanceId>>,
          TError,
          Awaited<ReturnType<typeof lessonInstanceControllerGetUserActivityInstancesByLessonInstanceId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonInstanceControllerGetUserActivityInstancesByLessonInstanceId<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetUserActivityInstancesByLessonInstanceId>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetUserActivityInstancesByLessonInstanceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLessonInstanceControllerGetUserActivityInstancesByLessonInstanceId<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetUserActivityInstancesByLessonInstanceId>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetUserActivityInstancesByLessonInstanceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLessonInstanceControllerGetUserActivityInstancesByLessonInstanceIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLessonInstanceControllerGetUserActivityInstancesByLessonInstanceId} query
 */
export const invalidateLessonInstanceControllerGetUserActivityInstancesByLessonInstanceId = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLessonInstanceControllerGetUserActivityInstancesByLessonInstanceIdQueryKey(id) }, options);

  return queryClient;
}

export const useSetLessonInstanceControllerGetUserActivityInstancesByLessonInstanceIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof lessonInstanceControllerGetUserActivityInstancesByLessonInstanceId>> | undefined | ((old: Awaited<ReturnType<typeof lessonInstanceControllerGetUserActivityInstancesByLessonInstanceId>> | undefined) => Awaited<ReturnType<typeof lessonInstanceControllerGetUserActivityInstancesByLessonInstanceId>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof lessonInstanceControllerGetUserActivityInstancesByLessonInstanceId>>>({ exact: $exactMatch, queryKey: getLessonInstanceControllerGetUserActivityInstancesByLessonInstanceIdQueryKey(id) }, updater);
  };
}

export const useGetLessonInstanceControllerGetUserActivityInstancesByLessonInstanceIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof lessonInstanceControllerGetUserActivityInstancesByLessonInstanceId>>>(getLessonInstanceControllerGetUserActivityInstancesByLessonInstanceIdQueryKey(id));
}



export const lessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId = (
    id: string,
    params?: LessonInstanceControllerGetLessonInstanceScoreByLessonInstanceIdParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId200>(
      {url: `/lesson-instances/${id}/score`, method: 'GET',
        params, signal
    },
      options);
    }




export const getLessonInstanceControllerGetLessonInstanceScoreByLessonInstanceIdQueryKey = (id: string,
    params?: LessonInstanceControllerGetLessonInstanceScoreByLessonInstanceIdParams,) => {
    return [
    `/lesson-instances/${id}/score`, ...(params ? [params] : [])
    ] as const;
    }


export const getLessonInstanceControllerGetLessonInstanceScoreByLessonInstanceIdQueryOptions = <TData = Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId>>, TError = ErrorType<unknown>>(id: string,
    params?: LessonInstanceControllerGetLessonInstanceScoreByLessonInstanceIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLessonInstanceControllerGetLessonInstanceScoreByLessonInstanceIdQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId>>> = ({ signal }) => lessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LessonInstanceControllerGetLessonInstanceScoreByLessonInstanceIdQueryResult = NonNullable<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId>>>
export type LessonInstanceControllerGetLessonInstanceScoreByLessonInstanceIdQueryError = ErrorType<unknown>


export function useLessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId>>, TError = ErrorType<unknown>>(
 id: string,
    params: undefined |  LessonInstanceControllerGetLessonInstanceScoreByLessonInstanceIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId>>,
          TError,
          Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId>>, TError = ErrorType<unknown>>(
 id: string,
    params?: LessonInstanceControllerGetLessonInstanceScoreByLessonInstanceIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId>>,
          TError,
          Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId>>, TError = ErrorType<unknown>>(
 id: string,
    params?: LessonInstanceControllerGetLessonInstanceScoreByLessonInstanceIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId>>, TError = ErrorType<unknown>>(
 id: string,
    params?: LessonInstanceControllerGetLessonInstanceScoreByLessonInstanceIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLessonInstanceControllerGetLessonInstanceScoreByLessonInstanceIdQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId} query
 */
export const invalidateLessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId = async (
 queryClient: QueryClient, id: string,
    params?: LessonInstanceControllerGetLessonInstanceScoreByLessonInstanceIdParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLessonInstanceControllerGetLessonInstanceScoreByLessonInstanceIdQueryKey(id,params) }, options);

  return queryClient;
}

export const useSetLessonInstanceControllerGetLessonInstanceScoreByLessonInstanceIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,
    params: LessonInstanceControllerGetLessonInstanceScoreByLessonInstanceIdParams | undefined,updater: Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId>> | undefined | ((old: Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId>> | undefined) => Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId>>>({ exact: $exactMatch, queryKey: getLessonInstanceControllerGetLessonInstanceScoreByLessonInstanceIdQueryKey(id,params) }, updater);
  };
}

export const useGetLessonInstanceControllerGetLessonInstanceScoreByLessonInstanceIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,
    params?: LessonInstanceControllerGetLessonInstanceScoreByLessonInstanceIdParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceScoreByLessonInstanceId>>>(getLessonInstanceControllerGetLessonInstanceScoreByLessonInstanceIdQueryKey(id,params));
}



export const lessonInstanceControllerCompleteLessonInstance = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LessonInstanceControllerCompleteLessonInstance201>(
      {url: `/lesson-instances/${id}/complete`, method: 'POST', signal
    },
      options);
    }




export const getLessonInstanceControllerCompleteLessonInstanceMutationKey = () => ['lessonInstanceControllerCompleteLessonInstance'] as const;

export const getLessonInstanceControllerCompleteLessonInstanceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonInstanceControllerCompleteLessonInstance>>, TError,LessonInstanceControllerCompleteLessonInstanceMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof lessonInstanceControllerCompleteLessonInstance>>, TError,LessonInstanceControllerCompleteLessonInstanceMutationVariables, TContext> => {

const mutationKey = getLessonInstanceControllerCompleteLessonInstanceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof lessonInstanceControllerCompleteLessonInstance>>, LessonInstanceControllerCompleteLessonInstanceMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  lessonInstanceControllerCompleteLessonInstance(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LessonInstanceControllerCompleteLessonInstanceMutationResult = NonNullable<Awaited<ReturnType<typeof lessonInstanceControllerCompleteLessonInstance>>>

    export type LessonInstanceControllerCompleteLessonInstanceMutationError = ErrorType<unknown>
    export type LessonInstanceControllerCompleteLessonInstanceMutationVariables = {id: string}

    export const useLessonInstanceControllerCompleteLessonInstance = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonInstanceControllerCompleteLessonInstance>>, TError,LessonInstanceControllerCompleteLessonInstanceMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof lessonInstanceControllerCompleteLessonInstance>>,
        TError,
        LessonInstanceControllerCompleteLessonInstanceMutationVariables,
        TContext
      > => {
      return useMutation(getLessonInstanceControllerCompleteLessonInstanceMutationOptions(options), queryClient);
    }

export const lessonInstanceControllerGetTransactionsForReport = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/lesson-instances/${id}/report-transactions`, method: 'GET', signal
    },
      options);
    }




export const getLessonInstanceControllerGetTransactionsForReportQueryKey = (id: string,) => {
    return [
    `/lesson-instances/${id}/report-transactions`
    ] as const;
    }


export const getLessonInstanceControllerGetTransactionsForReportQueryOptions = <TData = Awaited<ReturnType<typeof lessonInstanceControllerGetTransactionsForReport>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetTransactionsForReport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLessonInstanceControllerGetTransactionsForReportQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lessonInstanceControllerGetTransactionsForReport>>> = ({ signal }) => lessonInstanceControllerGetTransactionsForReport(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetTransactionsForReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LessonInstanceControllerGetTransactionsForReportQueryResult = NonNullable<Awaited<ReturnType<typeof lessonInstanceControllerGetTransactionsForReport>>>
export type LessonInstanceControllerGetTransactionsForReportQueryError = ErrorType<unknown>


export function useLessonInstanceControllerGetTransactionsForReport<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetTransactionsForReport>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetTransactionsForReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonInstanceControllerGetTransactionsForReport>>,
          TError,
          Awaited<ReturnType<typeof lessonInstanceControllerGetTransactionsForReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonInstanceControllerGetTransactionsForReport<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetTransactionsForReport>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetTransactionsForReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonInstanceControllerGetTransactionsForReport>>,
          TError,
          Awaited<ReturnType<typeof lessonInstanceControllerGetTransactionsForReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonInstanceControllerGetTransactionsForReport<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetTransactionsForReport>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetTransactionsForReport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLessonInstanceControllerGetTransactionsForReport<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetTransactionsForReport>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetTransactionsForReport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLessonInstanceControllerGetTransactionsForReportQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLessonInstanceControllerGetTransactionsForReport} query
 */
export const invalidateLessonInstanceControllerGetTransactionsForReport = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLessonInstanceControllerGetTransactionsForReportQueryKey(id) }, options);

  return queryClient;
}

export const useSetLessonInstanceControllerGetTransactionsForReportQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof lessonInstanceControllerGetTransactionsForReport>> | undefined | ((old: Awaited<ReturnType<typeof lessonInstanceControllerGetTransactionsForReport>> | undefined) => Awaited<ReturnType<typeof lessonInstanceControllerGetTransactionsForReport>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof lessonInstanceControllerGetTransactionsForReport>>>({ exact: $exactMatch, queryKey: getLessonInstanceControllerGetTransactionsForReportQueryKey(id) }, updater);
  };
}

export const useGetLessonInstanceControllerGetTransactionsForReportQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof lessonInstanceControllerGetTransactionsForReport>>>(getLessonInstanceControllerGetTransactionsForReportQueryKey(id));
}



export const lessonInstanceControllerGetInstancesByClassroom = (
    id: string,
    params?: LessonInstanceControllerGetInstancesByClassroomParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LessonInstanceControllerGetInstancesByClassroom200Item[]>(
      {url: `/lesson-instances/classroom/${id}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getLessonInstanceControllerGetInstancesByClassroomQueryKey = (id: string,
    params?: LessonInstanceControllerGetInstancesByClassroomParams,) => {
    return [
    `/lesson-instances/classroom/${id}`, ...(params ? [params] : [])
    ] as const;
    }


export const getLessonInstanceControllerGetInstancesByClassroomQueryOptions = <TData = Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByClassroom>>, TError = ErrorType<unknown>>(id: string,
    params?: LessonInstanceControllerGetInstancesByClassroomParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLessonInstanceControllerGetInstancesByClassroomQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByClassroom>>> = ({ signal }) => lessonInstanceControllerGetInstancesByClassroom(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByClassroom>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LessonInstanceControllerGetInstancesByClassroomQueryResult = NonNullable<Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByClassroom>>>
export type LessonInstanceControllerGetInstancesByClassroomQueryError = ErrorType<unknown>


export function useLessonInstanceControllerGetInstancesByClassroom<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByClassroom>>, TError = ErrorType<unknown>>(
 id: string,
    params: undefined |  LessonInstanceControllerGetInstancesByClassroomParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByClassroom>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByClassroom>>,
          TError,
          Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByClassroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonInstanceControllerGetInstancesByClassroom<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByClassroom>>, TError = ErrorType<unknown>>(
 id: string,
    params?: LessonInstanceControllerGetInstancesByClassroomParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByClassroom>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByClassroom>>,
          TError,
          Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByClassroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonInstanceControllerGetInstancesByClassroom<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByClassroom>>, TError = ErrorType<unknown>>(
 id: string,
    params?: LessonInstanceControllerGetInstancesByClassroomParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLessonInstanceControllerGetInstancesByClassroom<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByClassroom>>, TError = ErrorType<unknown>>(
 id: string,
    params?: LessonInstanceControllerGetInstancesByClassroomParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLessonInstanceControllerGetInstancesByClassroomQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLessonInstanceControllerGetInstancesByClassroom} query
 */
export const invalidateLessonInstanceControllerGetInstancesByClassroom = async (
 queryClient: QueryClient, id: string,
    params?: LessonInstanceControllerGetInstancesByClassroomParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLessonInstanceControllerGetInstancesByClassroomQueryKey(id,params) }, options);

  return queryClient;
}

export const useSetLessonInstanceControllerGetInstancesByClassroomQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,
    params: LessonInstanceControllerGetInstancesByClassroomParams | undefined,updater: Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByClassroom>> | undefined | ((old: Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByClassroom>> | undefined) => Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByClassroom>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByClassroom>>>({ exact: $exactMatch, queryKey: getLessonInstanceControllerGetInstancesByClassroomQueryKey(id,params) }, updater);
  };
}

export const useGetLessonInstanceControllerGetInstancesByClassroomQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,
    params?: LessonInstanceControllerGetInstancesByClassroomParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof lessonInstanceControllerGetInstancesByClassroom>>>(getLessonInstanceControllerGetInstancesByClassroomQueryKey(id,params));
}



/**
 * @summary Get lesson instance count by status for current user
 */
export const lessonInstanceControllerGetLessonInstanceStatusCountByUser = (
    params: LessonInstanceControllerGetLessonInstanceStatusCountByUserParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LessonInstanceCountResponseDto>(
      {url: `/lesson-instances/me/count`, method: 'GET',
        params, signal
    },
      options);
    }




export const getLessonInstanceControllerGetLessonInstanceStatusCountByUserQueryKey = (params?: LessonInstanceControllerGetLessonInstanceStatusCountByUserParams,) => {
    return [
    `/lesson-instances/me/count`, ...(params ? [params] : [])
    ] as const;
    }


export const getLessonInstanceControllerGetLessonInstanceStatusCountByUserQueryOptions = <TData = Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceStatusCountByUser>>, TError = ErrorType<unknown>>(params: LessonInstanceControllerGetLessonInstanceStatusCountByUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceStatusCountByUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLessonInstanceControllerGetLessonInstanceStatusCountByUserQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceStatusCountByUser>>> = ({ signal }) => lessonInstanceControllerGetLessonInstanceStatusCountByUser(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceStatusCountByUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LessonInstanceControllerGetLessonInstanceStatusCountByUserQueryResult = NonNullable<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceStatusCountByUser>>>
export type LessonInstanceControllerGetLessonInstanceStatusCountByUserQueryError = ErrorType<unknown>


export function useLessonInstanceControllerGetLessonInstanceStatusCountByUser<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceStatusCountByUser>>, TError = ErrorType<unknown>>(
 params: LessonInstanceControllerGetLessonInstanceStatusCountByUserParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceStatusCountByUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceStatusCountByUser>>,
          TError,
          Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceStatusCountByUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonInstanceControllerGetLessonInstanceStatusCountByUser<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceStatusCountByUser>>, TError = ErrorType<unknown>>(
 params: LessonInstanceControllerGetLessonInstanceStatusCountByUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceStatusCountByUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceStatusCountByUser>>,
          TError,
          Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceStatusCountByUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonInstanceControllerGetLessonInstanceStatusCountByUser<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceStatusCountByUser>>, TError = ErrorType<unknown>>(
 params: LessonInstanceControllerGetLessonInstanceStatusCountByUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceStatusCountByUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get lesson instance count by status for current user
 */

export function useLessonInstanceControllerGetLessonInstanceStatusCountByUser<TData = Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceStatusCountByUser>>, TError = ErrorType<unknown>>(
 params: LessonInstanceControllerGetLessonInstanceStatusCountByUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceStatusCountByUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLessonInstanceControllerGetLessonInstanceStatusCountByUserQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLessonInstanceControllerGetLessonInstanceStatusCountByUser} query
 */
export const invalidateLessonInstanceControllerGetLessonInstanceStatusCountByUser = async (
 queryClient: QueryClient, params: LessonInstanceControllerGetLessonInstanceStatusCountByUserParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLessonInstanceControllerGetLessonInstanceStatusCountByUserQueryKey(params) }, options);

  return queryClient;
}

/**
 * @summary Get lesson instance count by status for current user
 */
export const useSetLessonInstanceControllerGetLessonInstanceStatusCountByUserQueryData = () => {
  const queryClient = useQueryClient();
  return (params: LessonInstanceControllerGetLessonInstanceStatusCountByUserParams | undefined,updater: Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceStatusCountByUser>> | undefined | ((old: Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceStatusCountByUser>> | undefined) => Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceStatusCountByUser>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceStatusCountByUser>>>({ exact: $exactMatch, queryKey: getLessonInstanceControllerGetLessonInstanceStatusCountByUserQueryKey(params) }, updater);
  };
}

/**
 * @summary Get lesson instance count by status for current user
 */
export const useGetLessonInstanceControllerGetLessonInstanceStatusCountByUserQueryData = () => {
  const queryClient = useQueryClient();
  return (params: LessonInstanceControllerGetLessonInstanceStatusCountByUserParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof lessonInstanceControllerGetLessonInstanceStatusCountByUser>>>(getLessonInstanceControllerGetLessonInstanceStatusCountByUserQueryKey(params));
}



export const activityMetadataControllerCreate = (
    createActivityMetadataDto: BodyType<CreateActivityMetadataDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ActivityMetadataResponseDto>(
      {url: `/activity-metadata`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createActivityMetadataDto, signal
    },
      options);
    }




export const getActivityMetadataControllerCreateMutationKey = () => ['activityMetadataControllerCreate'] as const;

export const getActivityMetadataControllerCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityMetadataControllerCreate>>, TError,ActivityMetadataControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activityMetadataControllerCreate>>, TError,ActivityMetadataControllerCreateMutationVariables, TContext> => {

const mutationKey = getActivityMetadataControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activityMetadataControllerCreate>>, ActivityMetadataControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  activityMetadataControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivityMetadataControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof activityMetadataControllerCreate>>>
    export type ActivityMetadataControllerCreateMutationBody = BodyType<CreateActivityMetadataDto>
    export type ActivityMetadataControllerCreateMutationError = ErrorType<unknown>
    export type ActivityMetadataControllerCreateMutationVariables = {data: BodyType<CreateActivityMetadataDto>}

    export const useActivityMetadataControllerCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityMetadataControllerCreate>>, TError,ActivityMetadataControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activityMetadataControllerCreate>>,
        TError,
        ActivityMetadataControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getActivityMetadataControllerCreateMutationOptions(options), queryClient);
    }

export const activityMetadataControllerFindAll = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ActivityMetadataResponseDto[]>(
      {url: `/activity-metadata`, method: 'GET', signal
    },
      options);
    }




export const getActivityMetadataControllerFindAllQueryKey = () => {
    return [
    `/activity-metadata`
    ] as const;
    }


export const getActivityMetadataControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof activityMetadataControllerFindAll>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityMetadataControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityMetadataControllerFindAllQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityMetadataControllerFindAll>>> = ({ signal }) => activityMetadataControllerFindAll(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityMetadataControllerFindAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivityMetadataControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof activityMetadataControllerFindAll>>>
export type ActivityMetadataControllerFindAllQueryError = ErrorType<unknown>


export function useActivityMetadataControllerFindAll<TData = Awaited<ReturnType<typeof activityMetadataControllerFindAll>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityMetadataControllerFindAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityMetadataControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof activityMetadataControllerFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityMetadataControllerFindAll<TData = Awaited<ReturnType<typeof activityMetadataControllerFindAll>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityMetadataControllerFindAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityMetadataControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof activityMetadataControllerFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityMetadataControllerFindAll<TData = Awaited<ReturnType<typeof activityMetadataControllerFindAll>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityMetadataControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivityMetadataControllerFindAll<TData = Awaited<ReturnType<typeof activityMetadataControllerFindAll>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityMetadataControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivityMetadataControllerFindAllQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivityMetadataControllerFindAll} query
 */
export const invalidateActivityMetadataControllerFindAll = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivityMetadataControllerFindAllQueryKey() }, options);

  return queryClient;
}

export const useSetActivityMetadataControllerFindAllQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof activityMetadataControllerFindAll>> | undefined | ((old: Awaited<ReturnType<typeof activityMetadataControllerFindAll>> | undefined) => Awaited<ReturnType<typeof activityMetadataControllerFindAll>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activityMetadataControllerFindAll>>>({ exact: $exactMatch, queryKey: getActivityMetadataControllerFindAllQueryKey() }, updater);
  };
}

export const useGetActivityMetadataControllerFindAllQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activityMetadataControllerFindAll>>>(getActivityMetadataControllerFindAllQueryKey());
}



export const activityMetadataControllerFindById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ActivityMetadataResponseDto>(
      {url: `/activity-metadata/${id}`, method: 'GET', signal
    },
      options);
    }




export const getActivityMetadataControllerFindByIdQueryKey = (id: string,) => {
    return [
    `/activity-metadata/${id}`
    ] as const;
    }


export const getActivityMetadataControllerFindByIdQueryOptions = <TData = Awaited<ReturnType<typeof activityMetadataControllerFindById>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityMetadataControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityMetadataControllerFindByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityMetadataControllerFindById>>> = ({ signal }) => activityMetadataControllerFindById(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityMetadataControllerFindById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivityMetadataControllerFindByIdQueryResult = NonNullable<Awaited<ReturnType<typeof activityMetadataControllerFindById>>>
export type ActivityMetadataControllerFindByIdQueryError = ErrorType<unknown>


export function useActivityMetadataControllerFindById<TData = Awaited<ReturnType<typeof activityMetadataControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityMetadataControllerFindById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityMetadataControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof activityMetadataControllerFindById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityMetadataControllerFindById<TData = Awaited<ReturnType<typeof activityMetadataControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityMetadataControllerFindById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityMetadataControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof activityMetadataControllerFindById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityMetadataControllerFindById<TData = Awaited<ReturnType<typeof activityMetadataControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityMetadataControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivityMetadataControllerFindById<TData = Awaited<ReturnType<typeof activityMetadataControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityMetadataControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivityMetadataControllerFindByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivityMetadataControllerFindById} query
 */
export const invalidateActivityMetadataControllerFindById = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivityMetadataControllerFindByIdQueryKey(id) }, options);

  return queryClient;
}

export const useSetActivityMetadataControllerFindByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof activityMetadataControllerFindById>> | undefined | ((old: Awaited<ReturnType<typeof activityMetadataControllerFindById>> | undefined) => Awaited<ReturnType<typeof activityMetadataControllerFindById>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activityMetadataControllerFindById>>>({ exact: $exactMatch, queryKey: getActivityMetadataControllerFindByIdQueryKey(id) }, updater);
  };
}

export const useGetActivityMetadataControllerFindByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activityMetadataControllerFindById>>>(getActivityMetadataControllerFindByIdQueryKey(id));
}



export const activityMetadataControllerUpdate = (
    id: string,
    updateActivityMetadataDto: BodyType<UpdateActivityMetadataDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ActivityMetadataResponseDto>(
      {url: `/activity-metadata/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateActivityMetadataDto, signal
    },
      options);
    }




export const getActivityMetadataControllerUpdateMutationKey = () => ['activityMetadataControllerUpdate'] as const;

export const getActivityMetadataControllerUpdateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityMetadataControllerUpdate>>, TError,ActivityMetadataControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activityMetadataControllerUpdate>>, TError,ActivityMetadataControllerUpdateMutationVariables, TContext> => {

const mutationKey = getActivityMetadataControllerUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activityMetadataControllerUpdate>>, ActivityMetadataControllerUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  activityMetadataControllerUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivityMetadataControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof activityMetadataControllerUpdate>>>
    export type ActivityMetadataControllerUpdateMutationBody = BodyType<UpdateActivityMetadataDto>
    export type ActivityMetadataControllerUpdateMutationError = ErrorType<unknown>
    export type ActivityMetadataControllerUpdateMutationVariables = {id: string;data: BodyType<UpdateActivityMetadataDto>}

    export const useActivityMetadataControllerUpdate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityMetadataControllerUpdate>>, TError,ActivityMetadataControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activityMetadataControllerUpdate>>,
        TError,
        ActivityMetadataControllerUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getActivityMetadataControllerUpdateMutationOptions(options), queryClient);
    }

/**
 * @summary Get current user total XP
 */
export const edsyXPControllerGetUserXP = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EdsyXPResponseDto>(
      {url: `/edsy-xp/me`, method: 'GET', signal
    },
      options);
    }




export const getEdsyXPControllerGetUserXPQueryKey = () => {
    return [
    `/edsy-xp/me`
    ] as const;
    }


export const getEdsyXPControllerGetUserXPQueryOptions = <TData = Awaited<ReturnType<typeof edsyXPControllerGetUserXP>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyXPControllerGetUserXP>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEdsyXPControllerGetUserXPQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof edsyXPControllerGetUserXP>>> = ({ signal }) => edsyXPControllerGetUserXP(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof edsyXPControllerGetUserXP>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EdsyXPControllerGetUserXPQueryResult = NonNullable<Awaited<ReturnType<typeof edsyXPControllerGetUserXP>>>
export type EdsyXPControllerGetUserXPQueryError = ErrorType<unknown>


export function useEdsyXPControllerGetUserXP<TData = Awaited<ReturnType<typeof edsyXPControllerGetUserXP>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyXPControllerGetUserXP>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof edsyXPControllerGetUserXP>>,
          TError,
          Awaited<ReturnType<typeof edsyXPControllerGetUserXP>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEdsyXPControllerGetUserXP<TData = Awaited<ReturnType<typeof edsyXPControllerGetUserXP>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyXPControllerGetUserXP>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof edsyXPControllerGetUserXP>>,
          TError,
          Awaited<ReturnType<typeof edsyXPControllerGetUserXP>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEdsyXPControllerGetUserXP<TData = Awaited<ReturnType<typeof edsyXPControllerGetUserXP>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyXPControllerGetUserXP>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current user total XP
 */

export function useEdsyXPControllerGetUserXP<TData = Awaited<ReturnType<typeof edsyXPControllerGetUserXP>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyXPControllerGetUserXP>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEdsyXPControllerGetUserXPQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useEdsyXPControllerGetUserXP} query
 */
export const invalidateEdsyXPControllerGetUserXP = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getEdsyXPControllerGetUserXPQueryKey() }, options);

  return queryClient;
}

/**
 * @summary Get current user total XP
 */
export const useSetEdsyXPControllerGetUserXPQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof edsyXPControllerGetUserXP>> | undefined | ((old: Awaited<ReturnType<typeof edsyXPControllerGetUserXP>> | undefined) => Awaited<ReturnType<typeof edsyXPControllerGetUserXP>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof edsyXPControllerGetUserXP>>>({ exact: $exactMatch, queryKey: getEdsyXPControllerGetUserXPQueryKey() }, updater);
  };
}

/**
 * @summary Get current user total XP
 */
export const useGetEdsyXPControllerGetUserXPQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof edsyXPControllerGetUserXP>>>(getEdsyXPControllerGetUserXPQueryKey());
}



/**
 * @summary Get XP transactions for current user
 */
export const edsyXPControllerGetXpTransactions = (
    params?: EdsyXPControllerGetXpTransactionsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EdsyXpTransactionResponseDto[]>(
      {url: `/edsy-xp/me/transactions`, method: 'GET',
        params, signal
    },
      options);
    }




export const getEdsyXPControllerGetXpTransactionsQueryKey = (params?: EdsyXPControllerGetXpTransactionsParams,) => {
    return [
    `/edsy-xp/me/transactions`, ...(params ? [params] : [])
    ] as const;
    }


export const getEdsyXPControllerGetXpTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof edsyXPControllerGetXpTransactions>>, TError = ErrorType<unknown>>(params?: EdsyXPControllerGetXpTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyXPControllerGetXpTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEdsyXPControllerGetXpTransactionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof edsyXPControllerGetXpTransactions>>> = ({ signal }) => edsyXPControllerGetXpTransactions(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof edsyXPControllerGetXpTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EdsyXPControllerGetXpTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof edsyXPControllerGetXpTransactions>>>
export type EdsyXPControllerGetXpTransactionsQueryError = ErrorType<unknown>


export function useEdsyXPControllerGetXpTransactions<TData = Awaited<ReturnType<typeof edsyXPControllerGetXpTransactions>>, TError = ErrorType<unknown>>(
 params: undefined |  EdsyXPControllerGetXpTransactionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyXPControllerGetXpTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof edsyXPControllerGetXpTransactions>>,
          TError,
          Awaited<ReturnType<typeof edsyXPControllerGetXpTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEdsyXPControllerGetXpTransactions<TData = Awaited<ReturnType<typeof edsyXPControllerGetXpTransactions>>, TError = ErrorType<unknown>>(
 params?: EdsyXPControllerGetXpTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyXPControllerGetXpTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof edsyXPControllerGetXpTransactions>>,
          TError,
          Awaited<ReturnType<typeof edsyXPControllerGetXpTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEdsyXPControllerGetXpTransactions<TData = Awaited<ReturnType<typeof edsyXPControllerGetXpTransactions>>, TError = ErrorType<unknown>>(
 params?: EdsyXPControllerGetXpTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyXPControllerGetXpTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get XP transactions for current user
 */

export function useEdsyXPControllerGetXpTransactions<TData = Awaited<ReturnType<typeof edsyXPControllerGetXpTransactions>>, TError = ErrorType<unknown>>(
 params?: EdsyXPControllerGetXpTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyXPControllerGetXpTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEdsyXPControllerGetXpTransactionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useEdsyXPControllerGetXpTransactions} query
 */
export const invalidateEdsyXPControllerGetXpTransactions = async (
 queryClient: QueryClient, params?: EdsyXPControllerGetXpTransactionsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getEdsyXPControllerGetXpTransactionsQueryKey(params) }, options);

  return queryClient;
}

/**
 * @summary Get XP transactions for current user
 */
export const useSetEdsyXPControllerGetXpTransactionsQueryData = () => {
  const queryClient = useQueryClient();
  return (params: EdsyXPControllerGetXpTransactionsParams | undefined,updater: Awaited<ReturnType<typeof edsyXPControllerGetXpTransactions>> | undefined | ((old: Awaited<ReturnType<typeof edsyXPControllerGetXpTransactions>> | undefined) => Awaited<ReturnType<typeof edsyXPControllerGetXpTransactions>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof edsyXPControllerGetXpTransactions>>>({ exact: $exactMatch, queryKey: getEdsyXPControllerGetXpTransactionsQueryKey(params) }, updater);
  };
}

/**
 * @summary Get XP transactions for current user
 */
export const useGetEdsyXPControllerGetXpTransactionsQueryData = () => {
  const queryClient = useQueryClient();
  return (params?: EdsyXPControllerGetXpTransactionsParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof edsyXPControllerGetXpTransactions>>>(getEdsyXPControllerGetXpTransactionsQueryKey(params));
}



/**
 * @summary Re-aggregate XP for a specific user (admin only)
 */
export const edsyXPControllerReAggregateUserXP = (
    userId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/edsy-xp/admin/re-aggregate/${userId}`, method: 'POST', signal
    },
      options);
    }




export const getEdsyXPControllerReAggregateUserXPMutationKey = () => ['edsyXPControllerReAggregateUserXP'] as const;

export const getEdsyXPControllerReAggregateUserXPMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof edsyXPControllerReAggregateUserXP>>, TError,EdsyXPControllerReAggregateUserXPMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof edsyXPControllerReAggregateUserXP>>, TError,EdsyXPControllerReAggregateUserXPMutationVariables, TContext> => {

const mutationKey = getEdsyXPControllerReAggregateUserXPMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof edsyXPControllerReAggregateUserXP>>, EdsyXPControllerReAggregateUserXPMutationVariables> = (props) => {
          const {userId} = props ?? {};

          return  edsyXPControllerReAggregateUserXP(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EdsyXPControllerReAggregateUserXPMutationResult = NonNullable<Awaited<ReturnType<typeof edsyXPControllerReAggregateUserXP>>>

    export type EdsyXPControllerReAggregateUserXPMutationError = ErrorType<unknown>
    export type EdsyXPControllerReAggregateUserXPMutationVariables = {userId: string}

    /**
 * @summary Re-aggregate XP for a specific user (admin only)
 */
export const useEdsyXPControllerReAggregateUserXP = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof edsyXPControllerReAggregateUserXP>>, TError,EdsyXPControllerReAggregateUserXPMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof edsyXPControllerReAggregateUserXP>>,
        TError,
        EdsyXPControllerReAggregateUserXPMutationVariables,
        TContext
      > => {
      return useMutation(getEdsyXPControllerReAggregateUserXPMutationOptions(options), queryClient);
    }

/**
 * @summary Get coin transactions for current user
 */
export const edsyCoinControllerGetCoinTransactions = (
    params?: EdsyCoinControllerGetCoinTransactionsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EdsyCoinTransaction[]>(
      {url: `/edsy-coin/me/transactions`, method: 'GET',
        params, signal
    },
      options);
    }




export const getEdsyCoinControllerGetCoinTransactionsQueryKey = (params?: EdsyCoinControllerGetCoinTransactionsParams,) => {
    return [
    `/edsy-coin/me/transactions`, ...(params ? [params] : [])
    ] as const;
    }


export const getEdsyCoinControllerGetCoinTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof edsyCoinControllerGetCoinTransactions>>, TError = ErrorType<unknown>>(params?: EdsyCoinControllerGetCoinTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyCoinControllerGetCoinTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEdsyCoinControllerGetCoinTransactionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof edsyCoinControllerGetCoinTransactions>>> = ({ signal }) => edsyCoinControllerGetCoinTransactions(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof edsyCoinControllerGetCoinTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EdsyCoinControllerGetCoinTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof edsyCoinControllerGetCoinTransactions>>>
export type EdsyCoinControllerGetCoinTransactionsQueryError = ErrorType<unknown>


export function useEdsyCoinControllerGetCoinTransactions<TData = Awaited<ReturnType<typeof edsyCoinControllerGetCoinTransactions>>, TError = ErrorType<unknown>>(
 params: undefined |  EdsyCoinControllerGetCoinTransactionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyCoinControllerGetCoinTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof edsyCoinControllerGetCoinTransactions>>,
          TError,
          Awaited<ReturnType<typeof edsyCoinControllerGetCoinTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEdsyCoinControllerGetCoinTransactions<TData = Awaited<ReturnType<typeof edsyCoinControllerGetCoinTransactions>>, TError = ErrorType<unknown>>(
 params?: EdsyCoinControllerGetCoinTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyCoinControllerGetCoinTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof edsyCoinControllerGetCoinTransactions>>,
          TError,
          Awaited<ReturnType<typeof edsyCoinControllerGetCoinTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEdsyCoinControllerGetCoinTransactions<TData = Awaited<ReturnType<typeof edsyCoinControllerGetCoinTransactions>>, TError = ErrorType<unknown>>(
 params?: EdsyCoinControllerGetCoinTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyCoinControllerGetCoinTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get coin transactions for current user
 */

export function useEdsyCoinControllerGetCoinTransactions<TData = Awaited<ReturnType<typeof edsyCoinControllerGetCoinTransactions>>, TError = ErrorType<unknown>>(
 params?: EdsyCoinControllerGetCoinTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyCoinControllerGetCoinTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEdsyCoinControllerGetCoinTransactionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useEdsyCoinControllerGetCoinTransactions} query
 */
export const invalidateEdsyCoinControllerGetCoinTransactions = async (
 queryClient: QueryClient, params?: EdsyCoinControllerGetCoinTransactionsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getEdsyCoinControllerGetCoinTransactionsQueryKey(params) }, options);

  return queryClient;
}

/**
 * @summary Get coin transactions for current user
 */
export const useSetEdsyCoinControllerGetCoinTransactionsQueryData = () => {
  const queryClient = useQueryClient();
  return (params: EdsyCoinControllerGetCoinTransactionsParams | undefined,updater: Awaited<ReturnType<typeof edsyCoinControllerGetCoinTransactions>> | undefined | ((old: Awaited<ReturnType<typeof edsyCoinControllerGetCoinTransactions>> | undefined) => Awaited<ReturnType<typeof edsyCoinControllerGetCoinTransactions>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof edsyCoinControllerGetCoinTransactions>>>({ exact: $exactMatch, queryKey: getEdsyCoinControllerGetCoinTransactionsQueryKey(params) }, updater);
  };
}

/**
 * @summary Get coin transactions for current user
 */
export const useGetEdsyCoinControllerGetCoinTransactionsQueryData = () => {
  const queryClient = useQueryClient();
  return (params?: EdsyCoinControllerGetCoinTransactionsParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof edsyCoinControllerGetCoinTransactions>>>(getEdsyCoinControllerGetCoinTransactionsQueryKey(params));
}



/**
 * @summary Get user coin balance
 */
export const edsyCoinControllerGetUserCoin = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserCoinResponseDto>(
      {url: `/edsy-coin/me`, method: 'GET', signal
    },
      options);
    }




export const getEdsyCoinControllerGetUserCoinQueryKey = () => {
    return [
    `/edsy-coin/me`
    ] as const;
    }


export const getEdsyCoinControllerGetUserCoinQueryOptions = <TData = Awaited<ReturnType<typeof edsyCoinControllerGetUserCoin>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyCoinControllerGetUserCoin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEdsyCoinControllerGetUserCoinQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof edsyCoinControllerGetUserCoin>>> = ({ signal }) => edsyCoinControllerGetUserCoin(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof edsyCoinControllerGetUserCoin>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EdsyCoinControllerGetUserCoinQueryResult = NonNullable<Awaited<ReturnType<typeof edsyCoinControllerGetUserCoin>>>
export type EdsyCoinControllerGetUserCoinQueryError = ErrorType<unknown>


export function useEdsyCoinControllerGetUserCoin<TData = Awaited<ReturnType<typeof edsyCoinControllerGetUserCoin>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyCoinControllerGetUserCoin>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof edsyCoinControllerGetUserCoin>>,
          TError,
          Awaited<ReturnType<typeof edsyCoinControllerGetUserCoin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEdsyCoinControllerGetUserCoin<TData = Awaited<ReturnType<typeof edsyCoinControllerGetUserCoin>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyCoinControllerGetUserCoin>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof edsyCoinControllerGetUserCoin>>,
          TError,
          Awaited<ReturnType<typeof edsyCoinControllerGetUserCoin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEdsyCoinControllerGetUserCoin<TData = Awaited<ReturnType<typeof edsyCoinControllerGetUserCoin>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyCoinControllerGetUserCoin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user coin balance
 */

export function useEdsyCoinControllerGetUserCoin<TData = Awaited<ReturnType<typeof edsyCoinControllerGetUserCoin>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edsyCoinControllerGetUserCoin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEdsyCoinControllerGetUserCoinQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useEdsyCoinControllerGetUserCoin} query
 */
export const invalidateEdsyCoinControllerGetUserCoin = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getEdsyCoinControllerGetUserCoinQueryKey() }, options);

  return queryClient;
}

/**
 * @summary Get user coin balance
 */
export const useSetEdsyCoinControllerGetUserCoinQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof edsyCoinControllerGetUserCoin>> | undefined | ((old: Awaited<ReturnType<typeof edsyCoinControllerGetUserCoin>> | undefined) => Awaited<ReturnType<typeof edsyCoinControllerGetUserCoin>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof edsyCoinControllerGetUserCoin>>>({ exact: $exactMatch, queryKey: getEdsyCoinControllerGetUserCoinQueryKey() }, updater);
  };
}

/**
 * @summary Get user coin balance
 */
export const useGetEdsyCoinControllerGetUserCoinQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof edsyCoinControllerGetUserCoin>>>(getEdsyCoinControllerGetUserCoinQueryKey());
}



/**
 * @summary Re-aggregate coins for a specific user (admin only)
 */
export const edsyCoinControllerReAggregateUserCoin = (
    userId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/edsy-coin/admin/re-aggregate/${userId}`, method: 'POST', signal
    },
      options);
    }




export const getEdsyCoinControllerReAggregateUserCoinMutationKey = () => ['edsyCoinControllerReAggregateUserCoin'] as const;

export const getEdsyCoinControllerReAggregateUserCoinMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof edsyCoinControllerReAggregateUserCoin>>, TError,EdsyCoinControllerReAggregateUserCoinMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof edsyCoinControllerReAggregateUserCoin>>, TError,EdsyCoinControllerReAggregateUserCoinMutationVariables, TContext> => {

const mutationKey = getEdsyCoinControllerReAggregateUserCoinMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof edsyCoinControllerReAggregateUserCoin>>, EdsyCoinControllerReAggregateUserCoinMutationVariables> = (props) => {
          const {userId} = props ?? {};

          return  edsyCoinControllerReAggregateUserCoin(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EdsyCoinControllerReAggregateUserCoinMutationResult = NonNullable<Awaited<ReturnType<typeof edsyCoinControllerReAggregateUserCoin>>>

    export type EdsyCoinControllerReAggregateUserCoinMutationError = ErrorType<unknown>
    export type EdsyCoinControllerReAggregateUserCoinMutationVariables = {userId: string}

    /**
 * @summary Re-aggregate coins for a specific user (admin only)
 */
export const useEdsyCoinControllerReAggregateUserCoin = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof edsyCoinControllerReAggregateUserCoin>>, TError,EdsyCoinControllerReAggregateUserCoinMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof edsyCoinControllerReAggregateUserCoin>>,
        TError,
        EdsyCoinControllerReAggregateUserCoinMutationVariables,
        TContext
      > => {
      return useMutation(getEdsyCoinControllerReAggregateUserCoinMutationOptions(options), queryClient);
    }

export const auditLogsControllerGetOneAuditLogsByActivityInstanceId = (
    params: AuditLogsControllerGetOneAuditLogsByActivityInstanceIdParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AuditLogsControllerGetOneAuditLogsByActivityInstanceId200>(
      {url: `/audit-logs/by-resource-id/most-recent`, method: 'GET',
        params, signal
    },
      options);
    }




export const getAuditLogsControllerGetOneAuditLogsByActivityInstanceIdQueryKey = (params?: AuditLogsControllerGetOneAuditLogsByActivityInstanceIdParams,) => {
    return [
    `/audit-logs/by-resource-id/most-recent`, ...(params ? [params] : [])
    ] as const;
    }


export const getAuditLogsControllerGetOneAuditLogsByActivityInstanceIdQueryOptions = <TData = Awaited<ReturnType<typeof auditLogsControllerGetOneAuditLogsByActivityInstanceId>>, TError = ErrorType<unknown>>(params: AuditLogsControllerGetOneAuditLogsByActivityInstanceIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditLogsControllerGetOneAuditLogsByActivityInstanceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuditLogsControllerGetOneAuditLogsByActivityInstanceIdQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof auditLogsControllerGetOneAuditLogsByActivityInstanceId>>> = ({ signal }) => auditLogsControllerGetOneAuditLogsByActivityInstanceId(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof auditLogsControllerGetOneAuditLogsByActivityInstanceId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuditLogsControllerGetOneAuditLogsByActivityInstanceIdQueryResult = NonNullable<Awaited<ReturnType<typeof auditLogsControllerGetOneAuditLogsByActivityInstanceId>>>
export type AuditLogsControllerGetOneAuditLogsByActivityInstanceIdQueryError = ErrorType<unknown>


export function useAuditLogsControllerGetOneAuditLogsByActivityInstanceId<TData = Awaited<ReturnType<typeof auditLogsControllerGetOneAuditLogsByActivityInstanceId>>, TError = ErrorType<unknown>>(
 params: AuditLogsControllerGetOneAuditLogsByActivityInstanceIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditLogsControllerGetOneAuditLogsByActivityInstanceId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditLogsControllerGetOneAuditLogsByActivityInstanceId>>,
          TError,
          Awaited<ReturnType<typeof auditLogsControllerGetOneAuditLogsByActivityInstanceId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditLogsControllerGetOneAuditLogsByActivityInstanceId<TData = Awaited<ReturnType<typeof auditLogsControllerGetOneAuditLogsByActivityInstanceId>>, TError = ErrorType<unknown>>(
 params: AuditLogsControllerGetOneAuditLogsByActivityInstanceIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditLogsControllerGetOneAuditLogsByActivityInstanceId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditLogsControllerGetOneAuditLogsByActivityInstanceId>>,
          TError,
          Awaited<ReturnType<typeof auditLogsControllerGetOneAuditLogsByActivityInstanceId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditLogsControllerGetOneAuditLogsByActivityInstanceId<TData = Awaited<ReturnType<typeof auditLogsControllerGetOneAuditLogsByActivityInstanceId>>, TError = ErrorType<unknown>>(
 params: AuditLogsControllerGetOneAuditLogsByActivityInstanceIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditLogsControllerGetOneAuditLogsByActivityInstanceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAuditLogsControllerGetOneAuditLogsByActivityInstanceId<TData = Awaited<ReturnType<typeof auditLogsControllerGetOneAuditLogsByActivityInstanceId>>, TError = ErrorType<unknown>>(
 params: AuditLogsControllerGetOneAuditLogsByActivityInstanceIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditLogsControllerGetOneAuditLogsByActivityInstanceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuditLogsControllerGetOneAuditLogsByActivityInstanceIdQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useAuditLogsControllerGetOneAuditLogsByActivityInstanceId} query
 */
export const invalidateAuditLogsControllerGetOneAuditLogsByActivityInstanceId = async (
 queryClient: QueryClient, params: AuditLogsControllerGetOneAuditLogsByActivityInstanceIdParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getAuditLogsControllerGetOneAuditLogsByActivityInstanceIdQueryKey(params) }, options);

  return queryClient;
}

export const useSetAuditLogsControllerGetOneAuditLogsByActivityInstanceIdQueryData = () => {
  const queryClient = useQueryClient();
  return (params: AuditLogsControllerGetOneAuditLogsByActivityInstanceIdParams | undefined,updater: Awaited<ReturnType<typeof auditLogsControllerGetOneAuditLogsByActivityInstanceId>> | undefined | ((old: Awaited<ReturnType<typeof auditLogsControllerGetOneAuditLogsByActivityInstanceId>> | undefined) => Awaited<ReturnType<typeof auditLogsControllerGetOneAuditLogsByActivityInstanceId>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof auditLogsControllerGetOneAuditLogsByActivityInstanceId>>>({ exact: $exactMatch, queryKey: getAuditLogsControllerGetOneAuditLogsByActivityInstanceIdQueryKey(params) }, updater);
  };
}

export const useGetAuditLogsControllerGetOneAuditLogsByActivityInstanceIdQueryData = () => {
  const queryClient = useQueryClient();
  return (params: AuditLogsControllerGetOneAuditLogsByActivityInstanceIdParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof auditLogsControllerGetOneAuditLogsByActivityInstanceId>>>(getAuditLogsControllerGetOneAuditLogsByActivityInstanceIdQueryKey(params));
}



export const auditLogsControllerGetActivityAuditLogsByUser = (
    userId: string,
    params?: AuditLogsControllerGetActivityAuditLogsByUserParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AuditLogsControllerGetActivityAuditLogsByUser200Item[]>(
      {url: `/audit-logs/users/${userId}/activities`, method: 'GET',
        params, signal
    },
      options);
    }




export const getAuditLogsControllerGetActivityAuditLogsByUserQueryKey = (userId: string,
    params?: AuditLogsControllerGetActivityAuditLogsByUserParams,) => {
    return [
    `/audit-logs/users/${userId}/activities`, ...(params ? [params] : [])
    ] as const;
    }


export const getAuditLogsControllerGetActivityAuditLogsByUserQueryOptions = <TData = Awaited<ReturnType<typeof auditLogsControllerGetActivityAuditLogsByUser>>, TError = ErrorType<unknown>>(userId: string,
    params?: AuditLogsControllerGetActivityAuditLogsByUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditLogsControllerGetActivityAuditLogsByUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuditLogsControllerGetActivityAuditLogsByUserQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof auditLogsControllerGetActivityAuditLogsByUser>>> = ({ signal }) => auditLogsControllerGetActivityAuditLogsByUser(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof auditLogsControllerGetActivityAuditLogsByUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuditLogsControllerGetActivityAuditLogsByUserQueryResult = NonNullable<Awaited<ReturnType<typeof auditLogsControllerGetActivityAuditLogsByUser>>>
export type AuditLogsControllerGetActivityAuditLogsByUserQueryError = ErrorType<unknown>


export function useAuditLogsControllerGetActivityAuditLogsByUser<TData = Awaited<ReturnType<typeof auditLogsControllerGetActivityAuditLogsByUser>>, TError = ErrorType<unknown>>(
 userId: string,
    params: undefined |  AuditLogsControllerGetActivityAuditLogsByUserParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditLogsControllerGetActivityAuditLogsByUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditLogsControllerGetActivityAuditLogsByUser>>,
          TError,
          Awaited<ReturnType<typeof auditLogsControllerGetActivityAuditLogsByUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditLogsControllerGetActivityAuditLogsByUser<TData = Awaited<ReturnType<typeof auditLogsControllerGetActivityAuditLogsByUser>>, TError = ErrorType<unknown>>(
 userId: string,
    params?: AuditLogsControllerGetActivityAuditLogsByUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditLogsControllerGetActivityAuditLogsByUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditLogsControllerGetActivityAuditLogsByUser>>,
          TError,
          Awaited<ReturnType<typeof auditLogsControllerGetActivityAuditLogsByUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditLogsControllerGetActivityAuditLogsByUser<TData = Awaited<ReturnType<typeof auditLogsControllerGetActivityAuditLogsByUser>>, TError = ErrorType<unknown>>(
 userId: string,
    params?: AuditLogsControllerGetActivityAuditLogsByUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditLogsControllerGetActivityAuditLogsByUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAuditLogsControllerGetActivityAuditLogsByUser<TData = Awaited<ReturnType<typeof auditLogsControllerGetActivityAuditLogsByUser>>, TError = ErrorType<unknown>>(
 userId: string,
    params?: AuditLogsControllerGetActivityAuditLogsByUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditLogsControllerGetActivityAuditLogsByUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuditLogsControllerGetActivityAuditLogsByUserQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useAuditLogsControllerGetActivityAuditLogsByUser} query
 */
export const invalidateAuditLogsControllerGetActivityAuditLogsByUser = async (
 queryClient: QueryClient, userId: string,
    params?: AuditLogsControllerGetActivityAuditLogsByUserParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getAuditLogsControllerGetActivityAuditLogsByUserQueryKey(userId,params) }, options);

  return queryClient;
}

export const useSetAuditLogsControllerGetActivityAuditLogsByUserQueryData = () => {
  const queryClient = useQueryClient();
  return (userId: string,
    params: AuditLogsControllerGetActivityAuditLogsByUserParams | undefined,updater: Awaited<ReturnType<typeof auditLogsControllerGetActivityAuditLogsByUser>> | undefined | ((old: Awaited<ReturnType<typeof auditLogsControllerGetActivityAuditLogsByUser>> | undefined) => Awaited<ReturnType<typeof auditLogsControllerGetActivityAuditLogsByUser>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof auditLogsControllerGetActivityAuditLogsByUser>>>({ exact: $exactMatch, queryKey: getAuditLogsControllerGetActivityAuditLogsByUserQueryKey(userId,params) }, updater);
  };
}

export const useGetAuditLogsControllerGetActivityAuditLogsByUserQueryData = () => {
  const queryClient = useQueryClient();
  return (userId: string,
    params?: AuditLogsControllerGetActivityAuditLogsByUserParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof auditLogsControllerGetActivityAuditLogsByUser>>>(getAuditLogsControllerGetActivityAuditLogsByUserQueryKey(userId,params));
}



export const activityControllerUpdate = (
    id: string,
    baseUpdateActivityDto: BodyType<BaseUpdateActivityDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ActivityControllerUpdate200>(
      {url: `/activities/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: baseUpdateActivityDto, signal
    },
      options);
    }




export const getActivityControllerUpdateMutationKey = () => ['activityControllerUpdate'] as const;

export const getActivityControllerUpdateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityControllerUpdate>>, TError,ActivityControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activityControllerUpdate>>, TError,ActivityControllerUpdateMutationVariables, TContext> => {

const mutationKey = getActivityControllerUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activityControllerUpdate>>, ActivityControllerUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  activityControllerUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivityControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof activityControllerUpdate>>>
    export type ActivityControllerUpdateMutationBody = BodyType<BaseUpdateActivityDto>
    export type ActivityControllerUpdateMutationError = ErrorType<unknown>
    export type ActivityControllerUpdateMutationVariables = {id: string;data: BodyType<BaseUpdateActivityDto>}

    export const useActivityControllerUpdate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityControllerUpdate>>, TError,ActivityControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activityControllerUpdate>>,
        TError,
        ActivityControllerUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getActivityControllerUpdateMutationOptions(options), queryClient);
    }

export const activityControllerFindById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ActivityControllerFindById200>(
      {url: `/activities/${id}`, method: 'GET', signal
    },
      options);
    }




export const getActivityControllerFindByIdQueryKey = (id: string,) => {
    return [
    `/activities/${id}`
    ] as const;
    }


export const getActivityControllerFindByIdQueryOptions = <TData = Awaited<ReturnType<typeof activityControllerFindById>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityControllerFindByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityControllerFindById>>> = ({ signal }) => activityControllerFindById(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityControllerFindById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivityControllerFindByIdQueryResult = NonNullable<Awaited<ReturnType<typeof activityControllerFindById>>>
export type ActivityControllerFindByIdQueryError = ErrorType<unknown>


export function useActivityControllerFindById<TData = Awaited<ReturnType<typeof activityControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityControllerFindById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof activityControllerFindById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityControllerFindById<TData = Awaited<ReturnType<typeof activityControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityControllerFindById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof activityControllerFindById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityControllerFindById<TData = Awaited<ReturnType<typeof activityControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivityControllerFindById<TData = Awaited<ReturnType<typeof activityControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivityControllerFindByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivityControllerFindById} query
 */
export const invalidateActivityControllerFindById = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivityControllerFindByIdQueryKey(id) }, options);

  return queryClient;
}

export const useSetActivityControllerFindByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof activityControllerFindById>> | undefined | ((old: Awaited<ReturnType<typeof activityControllerFindById>> | undefined) => Awaited<ReturnType<typeof activityControllerFindById>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activityControllerFindById>>>({ exact: $exactMatch, queryKey: getActivityControllerFindByIdQueryKey(id) }, updater);
  };
}

export const useGetActivityControllerFindByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activityControllerFindById>>>(getActivityControllerFindByIdQueryKey(id));
}



export const activityControllerFindAll = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ActivityControllerFindAll200Item[]>(
      {url: `/activities`, method: 'GET', signal
    },
      options);
    }




export const getActivityControllerFindAllQueryKey = () => {
    return [
    `/activities`
    ] as const;
    }


export const getActivityControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof activityControllerFindAll>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityControllerFindAllQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityControllerFindAll>>> = ({ signal }) => activityControllerFindAll(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityControllerFindAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivityControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof activityControllerFindAll>>>
export type ActivityControllerFindAllQueryError = ErrorType<unknown>


export function useActivityControllerFindAll<TData = Awaited<ReturnType<typeof activityControllerFindAll>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityControllerFindAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof activityControllerFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityControllerFindAll<TData = Awaited<ReturnType<typeof activityControllerFindAll>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityControllerFindAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof activityControllerFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityControllerFindAll<TData = Awaited<ReturnType<typeof activityControllerFindAll>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivityControllerFindAll<TData = Awaited<ReturnType<typeof activityControllerFindAll>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivityControllerFindAllQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivityControllerFindAll} query
 */
export const invalidateActivityControllerFindAll = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivityControllerFindAllQueryKey() }, options);

  return queryClient;
}

export const useSetActivityControllerFindAllQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof activityControllerFindAll>> | undefined | ((old: Awaited<ReturnType<typeof activityControllerFindAll>> | undefined) => Awaited<ReturnType<typeof activityControllerFindAll>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activityControllerFindAll>>>({ exact: $exactMatch, queryKey: getActivityControllerFindAllQueryKey() }, updater);
  };
}

export const useGetActivityControllerFindAllQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activityControllerFindAll>>>(getActivityControllerFindAllQueryKey());
}



export const activityControllerGetActivityScore = (
    id: string,
    params: ActivityControllerGetActivityScoreParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ActivityControllerGetActivityScore200>(
      {url: `/activities/${id}/score`, method: 'GET',
        params, signal
    },
      options);
    }




export const getActivityControllerGetActivityScoreQueryKey = (id: string,
    params?: ActivityControllerGetActivityScoreParams,) => {
    return [
    `/activities/${id}/score`, ...(params ? [params] : [])
    ] as const;
    }


export const getActivityControllerGetActivityScoreQueryOptions = <TData = Awaited<ReturnType<typeof activityControllerGetActivityScore>>, TError = ErrorType<unknown>>(id: string,
    params: ActivityControllerGetActivityScoreParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityControllerGetActivityScore>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityControllerGetActivityScoreQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityControllerGetActivityScore>>> = ({ signal }) => activityControllerGetActivityScore(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityControllerGetActivityScore>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivityControllerGetActivityScoreQueryResult = NonNullable<Awaited<ReturnType<typeof activityControllerGetActivityScore>>>
export type ActivityControllerGetActivityScoreQueryError = ErrorType<unknown>


export function useActivityControllerGetActivityScore<TData = Awaited<ReturnType<typeof activityControllerGetActivityScore>>, TError = ErrorType<unknown>>(
 id: string,
    params: ActivityControllerGetActivityScoreParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityControllerGetActivityScore>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityControllerGetActivityScore>>,
          TError,
          Awaited<ReturnType<typeof activityControllerGetActivityScore>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityControllerGetActivityScore<TData = Awaited<ReturnType<typeof activityControllerGetActivityScore>>, TError = ErrorType<unknown>>(
 id: string,
    params: ActivityControllerGetActivityScoreParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityControllerGetActivityScore>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityControllerGetActivityScore>>,
          TError,
          Awaited<ReturnType<typeof activityControllerGetActivityScore>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityControllerGetActivityScore<TData = Awaited<ReturnType<typeof activityControllerGetActivityScore>>, TError = ErrorType<unknown>>(
 id: string,
    params: ActivityControllerGetActivityScoreParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityControllerGetActivityScore>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivityControllerGetActivityScore<TData = Awaited<ReturnType<typeof activityControllerGetActivityScore>>, TError = ErrorType<unknown>>(
 id: string,
    params: ActivityControllerGetActivityScoreParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityControllerGetActivityScore>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivityControllerGetActivityScoreQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivityControllerGetActivityScore} query
 */
export const invalidateActivityControllerGetActivityScore = async (
 queryClient: QueryClient, id: string,
    params: ActivityControllerGetActivityScoreParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivityControllerGetActivityScoreQueryKey(id,params) }, options);

  return queryClient;
}

export const useSetActivityControllerGetActivityScoreQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,
    params: ActivityControllerGetActivityScoreParams | undefined,updater: Awaited<ReturnType<typeof activityControllerGetActivityScore>> | undefined | ((old: Awaited<ReturnType<typeof activityControllerGetActivityScore>> | undefined) => Awaited<ReturnType<typeof activityControllerGetActivityScore>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activityControllerGetActivityScore>>>({ exact: $exactMatch, queryKey: getActivityControllerGetActivityScoreQueryKey(id,params) }, updater);
  };
}

export const useGetActivityControllerGetActivityScoreQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,
    params: ActivityControllerGetActivityScoreParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activityControllerGetActivityScore>>>(getActivityControllerGetActivityScoreQueryKey(id,params));
}



export const activityControllerStartActivity = (
    id: string,
    startActivityDto: BodyType<StartActivityDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ActivityControllerStartActivity201>(
      {url: `/activities/${id}/start-activity`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: startActivityDto, signal
    },
      options);
    }




export const getActivityControllerStartActivityMutationKey = () => ['activityControllerStartActivity'] as const;

export const getActivityControllerStartActivityMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityControllerStartActivity>>, TError,ActivityControllerStartActivityMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activityControllerStartActivity>>, TError,ActivityControllerStartActivityMutationVariables, TContext> => {

const mutationKey = getActivityControllerStartActivityMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activityControllerStartActivity>>, ActivityControllerStartActivityMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  activityControllerStartActivity(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivityControllerStartActivityMutationResult = NonNullable<Awaited<ReturnType<typeof activityControllerStartActivity>>>
    export type ActivityControllerStartActivityMutationBody = BodyType<StartActivityDto>
    export type ActivityControllerStartActivityMutationError = ErrorType<unknown>
    export type ActivityControllerStartActivityMutationVariables = {id: string;data: BodyType<StartActivityDto>}

    export const useActivityControllerStartActivity = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityControllerStartActivity>>, TError,ActivityControllerStartActivityMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activityControllerStartActivity>>,
        TError,
        ActivityControllerStartActivityMutationVariables,
        TContext
      > => {
      return useMutation(getActivityControllerStartActivityMutationOptions(options), queryClient);
    }

export const activityControllerFindActivityMetadataByActivityId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ActivityMetadataResponseDto>(
      {url: `/activities/${id}/metadata`, method: 'GET', signal
    },
      options);
    }




export const getActivityControllerFindActivityMetadataByActivityIdQueryKey = (id: string,) => {
    return [
    `/activities/${id}/metadata`
    ] as const;
    }


export const getActivityControllerFindActivityMetadataByActivityIdQueryOptions = <TData = Awaited<ReturnType<typeof activityControllerFindActivityMetadataByActivityId>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityControllerFindActivityMetadataByActivityId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityControllerFindActivityMetadataByActivityIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityControllerFindActivityMetadataByActivityId>>> = ({ signal }) => activityControllerFindActivityMetadataByActivityId(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityControllerFindActivityMetadataByActivityId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivityControllerFindActivityMetadataByActivityIdQueryResult = NonNullable<Awaited<ReturnType<typeof activityControllerFindActivityMetadataByActivityId>>>
export type ActivityControllerFindActivityMetadataByActivityIdQueryError = ErrorType<unknown>


export function useActivityControllerFindActivityMetadataByActivityId<TData = Awaited<ReturnType<typeof activityControllerFindActivityMetadataByActivityId>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityControllerFindActivityMetadataByActivityId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityControllerFindActivityMetadataByActivityId>>,
          TError,
          Awaited<ReturnType<typeof activityControllerFindActivityMetadataByActivityId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityControllerFindActivityMetadataByActivityId<TData = Awaited<ReturnType<typeof activityControllerFindActivityMetadataByActivityId>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityControllerFindActivityMetadataByActivityId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityControllerFindActivityMetadataByActivityId>>,
          TError,
          Awaited<ReturnType<typeof activityControllerFindActivityMetadataByActivityId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityControllerFindActivityMetadataByActivityId<TData = Awaited<ReturnType<typeof activityControllerFindActivityMetadataByActivityId>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityControllerFindActivityMetadataByActivityId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivityControllerFindActivityMetadataByActivityId<TData = Awaited<ReturnType<typeof activityControllerFindActivityMetadataByActivityId>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityControllerFindActivityMetadataByActivityId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivityControllerFindActivityMetadataByActivityIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivityControllerFindActivityMetadataByActivityId} query
 */
export const invalidateActivityControllerFindActivityMetadataByActivityId = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivityControllerFindActivityMetadataByActivityIdQueryKey(id) }, options);

  return queryClient;
}

export const useSetActivityControllerFindActivityMetadataByActivityIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof activityControllerFindActivityMetadataByActivityId>> | undefined | ((old: Awaited<ReturnType<typeof activityControllerFindActivityMetadataByActivityId>> | undefined) => Awaited<ReturnType<typeof activityControllerFindActivityMetadataByActivityId>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activityControllerFindActivityMetadataByActivityId>>>({ exact: $exactMatch, queryKey: getActivityControllerFindActivityMetadataByActivityIdQueryKey(id) }, updater);
  };
}

export const useGetActivityControllerFindActivityMetadataByActivityIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activityControllerFindActivityMetadataByActivityId>>>(getActivityControllerFindActivityMetadataByActivityIdQueryKey(id));
}



/**
 * @summary List live taxonomy tags, groups, and tagged content for a classroom
 */
export const taxonomyTagAdminControllerListCatalog = (
    classroomId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TaxonomyTagCatalogResponseDto>(
      {url: `/classrooms/${classroomId}/taxonomy-tags`, method: 'GET', signal
    },
      options);
    }




export const getTaxonomyTagAdminControllerListCatalogQueryKey = (classroomId: string,) => {
    return [
    `/classrooms/${classroomId}/taxonomy-tags`
    ] as const;
    }


export const getTaxonomyTagAdminControllerListCatalogQueryOptions = <TData = Awaited<ReturnType<typeof taxonomyTagAdminControllerListCatalog>>, TError = ErrorType<unknown>>(classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taxonomyTagAdminControllerListCatalog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTaxonomyTagAdminControllerListCatalogQueryKey(classroomId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof taxonomyTagAdminControllerListCatalog>>> = ({ signal }) => taxonomyTagAdminControllerListCatalog(classroomId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof taxonomyTagAdminControllerListCatalog>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TaxonomyTagAdminControllerListCatalogQueryResult = NonNullable<Awaited<ReturnType<typeof taxonomyTagAdminControllerListCatalog>>>
export type TaxonomyTagAdminControllerListCatalogQueryError = ErrorType<unknown>


export function useTaxonomyTagAdminControllerListCatalog<TData = Awaited<ReturnType<typeof taxonomyTagAdminControllerListCatalog>>, TError = ErrorType<unknown>>(
 classroomId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof taxonomyTagAdminControllerListCatalog>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof taxonomyTagAdminControllerListCatalog>>,
          TError,
          Awaited<ReturnType<typeof taxonomyTagAdminControllerListCatalog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaxonomyTagAdminControllerListCatalog<TData = Awaited<ReturnType<typeof taxonomyTagAdminControllerListCatalog>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taxonomyTagAdminControllerListCatalog>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof taxonomyTagAdminControllerListCatalog>>,
          TError,
          Awaited<ReturnType<typeof taxonomyTagAdminControllerListCatalog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaxonomyTagAdminControllerListCatalog<TData = Awaited<ReturnType<typeof taxonomyTagAdminControllerListCatalog>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taxonomyTagAdminControllerListCatalog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List live taxonomy tags, groups, and tagged content for a classroom
 */

export function useTaxonomyTagAdminControllerListCatalog<TData = Awaited<ReturnType<typeof taxonomyTagAdminControllerListCatalog>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taxonomyTagAdminControllerListCatalog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTaxonomyTagAdminControllerListCatalogQueryOptions(classroomId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useTaxonomyTagAdminControllerListCatalog} query
 */
export const invalidateTaxonomyTagAdminControllerListCatalog = async (
 queryClient: QueryClient, classroomId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getTaxonomyTagAdminControllerListCatalogQueryKey(classroomId) }, options);

  return queryClient;
}

/**
 * @summary List live taxonomy tags, groups, and tagged content for a classroom
 */
export const useSetTaxonomyTagAdminControllerListCatalogQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,updater: Awaited<ReturnType<typeof taxonomyTagAdminControllerListCatalog>> | undefined | ((old: Awaited<ReturnType<typeof taxonomyTagAdminControllerListCatalog>> | undefined) => Awaited<ReturnType<typeof taxonomyTagAdminControllerListCatalog>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof taxonomyTagAdminControllerListCatalog>>>({ exact: $exactMatch, queryKey: getTaxonomyTagAdminControllerListCatalogQueryKey(classroomId) }, updater);
  };
}

/**
 * @summary List live taxonomy tags, groups, and tagged content for a classroom
 */
export const useGetTaxonomyTagAdminControllerListCatalogQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof taxonomyTagAdminControllerListCatalog>>>(getTaxonomyTagAdminControllerListCatalogQueryKey(classroomId));
}



/**
 * @summary Create labels and upsert groups in one request
 */
export const taxonomyTagAdminControllerApply = (
    classroomId: string,
    applyTaxonomyTagsDto: BodyType<ApplyTaxonomyTagsDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ApplyTaxonomyTagsResponseDto>(
      {url: `/classrooms/${classroomId}/taxonomy-tags/apply`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: applyTaxonomyTagsDto, signal
    },
      options);
    }




export const getTaxonomyTagAdminControllerApplyMutationKey = () => ['taxonomyTagAdminControllerApply'] as const;

export const getTaxonomyTagAdminControllerApplyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taxonomyTagAdminControllerApply>>, TError,TaxonomyTagAdminControllerApplyMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof taxonomyTagAdminControllerApply>>, TError,TaxonomyTagAdminControllerApplyMutationVariables, TContext> => {

const mutationKey = getTaxonomyTagAdminControllerApplyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof taxonomyTagAdminControllerApply>>, TaxonomyTagAdminControllerApplyMutationVariables> = (props) => {
          const {classroomId,data} = props ?? {};

          return  taxonomyTagAdminControllerApply(classroomId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TaxonomyTagAdminControllerApplyMutationResult = NonNullable<Awaited<ReturnType<typeof taxonomyTagAdminControllerApply>>>
    export type TaxonomyTagAdminControllerApplyMutationBody = BodyType<ApplyTaxonomyTagsDto>
    export type TaxonomyTagAdminControllerApplyMutationError = ErrorType<unknown>
    export type TaxonomyTagAdminControllerApplyMutationVariables = {classroomId: string;data: BodyType<ApplyTaxonomyTagsDto>}

    /**
 * @summary Create labels and upsert groups in one request
 */
export const useTaxonomyTagAdminControllerApply = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taxonomyTagAdminControllerApply>>, TError,TaxonomyTagAdminControllerApplyMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof taxonomyTagAdminControllerApply>>,
        TError,
        TaxonomyTagAdminControllerApplyMutationVariables,
        TContext
      > => {
      return useMutation(getTaxonomyTagAdminControllerApplyMutationOptions(options), queryClient);
    }

/**
 * @summary Ensure classroom taxonomy labels exist and return tag ids
 */
export const taxonomyTagAdminControllerEnsureLabels = (
    classroomId: string,
    ensureTaxonomyTagLabelsDto: BodyType<EnsureTaxonomyTagLabelsDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EnsureTaxonomyTagLabelsResponseDto>(
      {url: `/classrooms/${classroomId}/taxonomy-tags/labels`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: ensureTaxonomyTagLabelsDto, signal
    },
      options);
    }




export const getTaxonomyTagAdminControllerEnsureLabelsMutationKey = () => ['taxonomyTagAdminControllerEnsureLabels'] as const;

export const getTaxonomyTagAdminControllerEnsureLabelsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taxonomyTagAdminControllerEnsureLabels>>, TError,TaxonomyTagAdminControllerEnsureLabelsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof taxonomyTagAdminControllerEnsureLabels>>, TError,TaxonomyTagAdminControllerEnsureLabelsMutationVariables, TContext> => {

const mutationKey = getTaxonomyTagAdminControllerEnsureLabelsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof taxonomyTagAdminControllerEnsureLabels>>, TaxonomyTagAdminControllerEnsureLabelsMutationVariables> = (props) => {
          const {classroomId,data} = props ?? {};

          return  taxonomyTagAdminControllerEnsureLabels(classroomId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TaxonomyTagAdminControllerEnsureLabelsMutationResult = NonNullable<Awaited<ReturnType<typeof taxonomyTagAdminControllerEnsureLabels>>>
    export type TaxonomyTagAdminControllerEnsureLabelsMutationBody = BodyType<EnsureTaxonomyTagLabelsDto>
    export type TaxonomyTagAdminControllerEnsureLabelsMutationError = ErrorType<unknown>
    export type TaxonomyTagAdminControllerEnsureLabelsMutationVariables = {classroomId: string;data: BodyType<EnsureTaxonomyTagLabelsDto>}

    /**
 * @summary Ensure classroom taxonomy labels exist and return tag ids
 */
export const useTaxonomyTagAdminControllerEnsureLabels = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taxonomyTagAdminControllerEnsureLabels>>, TError,TaxonomyTagAdminControllerEnsureLabelsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof taxonomyTagAdminControllerEnsureLabels>>,
        TError,
        TaxonomyTagAdminControllerEnsureLabelsMutationVariables,
        TContext
      > => {
      return useMutation(getTaxonomyTagAdminControllerEnsureLabelsMutationOptions(options), queryClient);
    }

/**
 * @summary Set taxonomy tag relations for nodes; empty tagIds soft-deletes
 */
export const taxonomyTagAdminControllerSetRelations = (
    classroomId: string,
    setTaxonomyTagRelationsDto: BodyType<SetTaxonomyTagRelationsDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TaxonomyTagRelationResponseDto[]>(
      {url: `/classrooms/${classroomId}/taxonomy-tags/relations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setTaxonomyTagRelationsDto, signal
    },
      options);
    }




export const getTaxonomyTagAdminControllerSetRelationsMutationKey = () => ['taxonomyTagAdminControllerSetRelations'] as const;

export const getTaxonomyTagAdminControllerSetRelationsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taxonomyTagAdminControllerSetRelations>>, TError,TaxonomyTagAdminControllerSetRelationsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof taxonomyTagAdminControllerSetRelations>>, TError,TaxonomyTagAdminControllerSetRelationsMutationVariables, TContext> => {

const mutationKey = getTaxonomyTagAdminControllerSetRelationsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof taxonomyTagAdminControllerSetRelations>>, TaxonomyTagAdminControllerSetRelationsMutationVariables> = (props) => {
          const {classroomId,data} = props ?? {};

          return  taxonomyTagAdminControllerSetRelations(classroomId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TaxonomyTagAdminControllerSetRelationsMutationResult = NonNullable<Awaited<ReturnType<typeof taxonomyTagAdminControllerSetRelations>>>
    export type TaxonomyTagAdminControllerSetRelationsMutationBody = BodyType<SetTaxonomyTagRelationsDto>
    export type TaxonomyTagAdminControllerSetRelationsMutationError = ErrorType<unknown>
    export type TaxonomyTagAdminControllerSetRelationsMutationVariables = {classroomId: string;data: BodyType<SetTaxonomyTagRelationsDto>}

    /**
 * @summary Set taxonomy tag relations for nodes; empty tagIds soft-deletes
 */
export const useTaxonomyTagAdminControllerSetRelations = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taxonomyTagAdminControllerSetRelations>>, TError,TaxonomyTagAdminControllerSetRelationsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof taxonomyTagAdminControllerSetRelations>>,
        TError,
        TaxonomyTagAdminControllerSetRelationsMutationVariables,
        TContext
      > => {
      return useMutation(getTaxonomyTagAdminControllerSetRelationsMutationOptions(options), queryClient);
    }

/**
 * @summary Upsert taxonomy tag groups by name; empty tagIds soft-deletes
 */
export const taxonomyTagAdminControllerUpsertGroups = (
    classroomId: string,
    upsertTaxonomyTagGroupsDto: BodyType<UpsertTaxonomyTagGroupsDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TaxonomyTagGroupResponseDto[]>(
      {url: `/classrooms/${classroomId}/taxonomy-tags/groups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: upsertTaxonomyTagGroupsDto, signal
    },
      options);
    }




export const getTaxonomyTagAdminControllerUpsertGroupsMutationKey = () => ['taxonomyTagAdminControllerUpsertGroups'] as const;

export const getTaxonomyTagAdminControllerUpsertGroupsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taxonomyTagAdminControllerUpsertGroups>>, TError,TaxonomyTagAdminControllerUpsertGroupsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof taxonomyTagAdminControllerUpsertGroups>>, TError,TaxonomyTagAdminControllerUpsertGroupsMutationVariables, TContext> => {

const mutationKey = getTaxonomyTagAdminControllerUpsertGroupsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof taxonomyTagAdminControllerUpsertGroups>>, TaxonomyTagAdminControllerUpsertGroupsMutationVariables> = (props) => {
          const {classroomId,data} = props ?? {};

          return  taxonomyTagAdminControllerUpsertGroups(classroomId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TaxonomyTagAdminControllerUpsertGroupsMutationResult = NonNullable<Awaited<ReturnType<typeof taxonomyTagAdminControllerUpsertGroups>>>
    export type TaxonomyTagAdminControllerUpsertGroupsMutationBody = BodyType<UpsertTaxonomyTagGroupsDto>
    export type TaxonomyTagAdminControllerUpsertGroupsMutationError = ErrorType<unknown>
    export type TaxonomyTagAdminControllerUpsertGroupsMutationVariables = {classroomId: string;data: BodyType<UpsertTaxonomyTagGroupsDto>}

    /**
 * @summary Upsert taxonomy tag groups by name; empty tagIds soft-deletes
 */
export const useTaxonomyTagAdminControllerUpsertGroups = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taxonomyTagAdminControllerUpsertGroups>>, TError,TaxonomyTagAdminControllerUpsertGroupsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof taxonomyTagAdminControllerUpsertGroups>>,
        TError,
        TaxonomyTagAdminControllerUpsertGroupsMutationVariables,
        TContext
      > => {
      return useMutation(getTaxonomyTagAdminControllerUpsertGroupsMutationOptions(options), queryClient);
    }

/**
 * @summary Read taxonomy tag groups and labels from a one-sheet Google Spreadsheet
 */
export const taxonomyTagSheetImportControllerImportFromGoogleSheet = (
    importTaxonomyTagSheetDto: BodyType<ImportTaxonomyTagSheetDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ImportTaxonomyTagSheetResponseDto>(
      {url: `/taxonomy-tags/import-from-google-sheet`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: importTaxonomyTagSheetDto, signal
    },
      options);
    }




export const getTaxonomyTagSheetImportControllerImportFromGoogleSheetMutationKey = () => ['taxonomyTagSheetImportControllerImportFromGoogleSheet'] as const;

export const getTaxonomyTagSheetImportControllerImportFromGoogleSheetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taxonomyTagSheetImportControllerImportFromGoogleSheet>>, TError,TaxonomyTagSheetImportControllerImportFromGoogleSheetMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof taxonomyTagSheetImportControllerImportFromGoogleSheet>>, TError,TaxonomyTagSheetImportControllerImportFromGoogleSheetMutationVariables, TContext> => {

const mutationKey = getTaxonomyTagSheetImportControllerImportFromGoogleSheetMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof taxonomyTagSheetImportControllerImportFromGoogleSheet>>, TaxonomyTagSheetImportControllerImportFromGoogleSheetMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  taxonomyTagSheetImportControllerImportFromGoogleSheet(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TaxonomyTagSheetImportControllerImportFromGoogleSheetMutationResult = NonNullable<Awaited<ReturnType<typeof taxonomyTagSheetImportControllerImportFromGoogleSheet>>>
    export type TaxonomyTagSheetImportControllerImportFromGoogleSheetMutationBody = BodyType<ImportTaxonomyTagSheetDto>
    export type TaxonomyTagSheetImportControllerImportFromGoogleSheetMutationError = ErrorType<unknown>
    export type TaxonomyTagSheetImportControllerImportFromGoogleSheetMutationVariables = {data: BodyType<ImportTaxonomyTagSheetDto>}

    /**
 * @summary Read taxonomy tag groups and labels from a one-sheet Google Spreadsheet
 */
export const useTaxonomyTagSheetImportControllerImportFromGoogleSheet = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taxonomyTagSheetImportControllerImportFromGoogleSheet>>, TError,TaxonomyTagSheetImportControllerImportFromGoogleSheetMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof taxonomyTagSheetImportControllerImportFromGoogleSheet>>,
        TError,
        TaxonomyTagSheetImportControllerImportFromGoogleSheetMutationVariables,
        TContext
      > => {
      return useMutation(getTaxonomyTagSheetImportControllerImportFromGoogleSheetMutationOptions(options), queryClient);
    }

export const taxonomyDashboardControllerGet = (
    classroomId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TaxonomyDashboardResponseDto>(
      {url: `/classrooms/${classroomId}/taxonomy-tags/dashboard`, method: 'GET', signal
    },
      options);
    }




export const getTaxonomyDashboardControllerGetQueryKey = (classroomId: string,) => {
    return [
    `/classrooms/${classroomId}/taxonomy-tags/dashboard`
    ] as const;
    }


export const getTaxonomyDashboardControllerGetQueryOptions = <TData = Awaited<ReturnType<typeof taxonomyDashboardControllerGet>>, TError = ErrorType<void>>(classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taxonomyDashboardControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTaxonomyDashboardControllerGetQueryKey(classroomId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof taxonomyDashboardControllerGet>>> = ({ signal }) => taxonomyDashboardControllerGet(classroomId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof taxonomyDashboardControllerGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TaxonomyDashboardControllerGetQueryResult = NonNullable<Awaited<ReturnType<typeof taxonomyDashboardControllerGet>>>
export type TaxonomyDashboardControllerGetQueryError = ErrorType<void>


export function useTaxonomyDashboardControllerGet<TData = Awaited<ReturnType<typeof taxonomyDashboardControllerGet>>, TError = ErrorType<void>>(
 classroomId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof taxonomyDashboardControllerGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof taxonomyDashboardControllerGet>>,
          TError,
          Awaited<ReturnType<typeof taxonomyDashboardControllerGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaxonomyDashboardControllerGet<TData = Awaited<ReturnType<typeof taxonomyDashboardControllerGet>>, TError = ErrorType<void>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taxonomyDashboardControllerGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof taxonomyDashboardControllerGet>>,
          TError,
          Awaited<ReturnType<typeof taxonomyDashboardControllerGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaxonomyDashboardControllerGet<TData = Awaited<ReturnType<typeof taxonomyDashboardControllerGet>>, TError = ErrorType<void>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taxonomyDashboardControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTaxonomyDashboardControllerGet<TData = Awaited<ReturnType<typeof taxonomyDashboardControllerGet>>, TError = ErrorType<void>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taxonomyDashboardControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTaxonomyDashboardControllerGetQueryOptions(classroomId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useTaxonomyDashboardControllerGet} query
 */
export const invalidateTaxonomyDashboardControllerGet = async (
 queryClient: QueryClient, classroomId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getTaxonomyDashboardControllerGetQueryKey(classroomId) }, options);

  return queryClient;
}

export const useSetTaxonomyDashboardControllerGetQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,updater: Awaited<ReturnType<typeof taxonomyDashboardControllerGet>> | undefined | ((old: Awaited<ReturnType<typeof taxonomyDashboardControllerGet>> | undefined) => Awaited<ReturnType<typeof taxonomyDashboardControllerGet>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof taxonomyDashboardControllerGet>>>({ exact: $exactMatch, queryKey: getTaxonomyDashboardControllerGetQueryKey(classroomId) }, updater);
  };
}

export const useGetTaxonomyDashboardControllerGetQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof taxonomyDashboardControllerGet>>>(getTaxonomyDashboardControllerGetQueryKey(classroomId));
}



export const lessonGradingCriteriaControllerGetLessonGradingCriteria = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LessonGradingCriteriaControllerGetLessonGradingCriteria200>(
      {url: `/lesson-grading-criteria`, method: 'GET', signal
    },
      options);
    }




export const getLessonGradingCriteriaControllerGetLessonGradingCriteriaQueryKey = () => {
    return [
    `/lesson-grading-criteria`
    ] as const;
    }


export const getLessonGradingCriteriaControllerGetLessonGradingCriteriaQueryOptions = <TData = Awaited<ReturnType<typeof lessonGradingCriteriaControllerGetLessonGradingCriteria>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonGradingCriteriaControllerGetLessonGradingCriteria>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLessonGradingCriteriaControllerGetLessonGradingCriteriaQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lessonGradingCriteriaControllerGetLessonGradingCriteria>>> = ({ signal }) => lessonGradingCriteriaControllerGetLessonGradingCriteria(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lessonGradingCriteriaControllerGetLessonGradingCriteria>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LessonGradingCriteriaControllerGetLessonGradingCriteriaQueryResult = NonNullable<Awaited<ReturnType<typeof lessonGradingCriteriaControllerGetLessonGradingCriteria>>>
export type LessonGradingCriteriaControllerGetLessonGradingCriteriaQueryError = ErrorType<unknown>


export function useLessonGradingCriteriaControllerGetLessonGradingCriteria<TData = Awaited<ReturnType<typeof lessonGradingCriteriaControllerGetLessonGradingCriteria>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonGradingCriteriaControllerGetLessonGradingCriteria>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonGradingCriteriaControllerGetLessonGradingCriteria>>,
          TError,
          Awaited<ReturnType<typeof lessonGradingCriteriaControllerGetLessonGradingCriteria>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonGradingCriteriaControllerGetLessonGradingCriteria<TData = Awaited<ReturnType<typeof lessonGradingCriteriaControllerGetLessonGradingCriteria>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonGradingCriteriaControllerGetLessonGradingCriteria>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonGradingCriteriaControllerGetLessonGradingCriteria>>,
          TError,
          Awaited<ReturnType<typeof lessonGradingCriteriaControllerGetLessonGradingCriteria>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonGradingCriteriaControllerGetLessonGradingCriteria<TData = Awaited<ReturnType<typeof lessonGradingCriteriaControllerGetLessonGradingCriteria>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonGradingCriteriaControllerGetLessonGradingCriteria>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLessonGradingCriteriaControllerGetLessonGradingCriteria<TData = Awaited<ReturnType<typeof lessonGradingCriteriaControllerGetLessonGradingCriteria>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonGradingCriteriaControllerGetLessonGradingCriteria>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLessonGradingCriteriaControllerGetLessonGradingCriteriaQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLessonGradingCriteriaControllerGetLessonGradingCriteria} query
 */
export const invalidateLessonGradingCriteriaControllerGetLessonGradingCriteria = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLessonGradingCriteriaControllerGetLessonGradingCriteriaQueryKey() }, options);

  return queryClient;
}

export const useSetLessonGradingCriteriaControllerGetLessonGradingCriteriaQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof lessonGradingCriteriaControllerGetLessonGradingCriteria>> | undefined | ((old: Awaited<ReturnType<typeof lessonGradingCriteriaControllerGetLessonGradingCriteria>> | undefined) => Awaited<ReturnType<typeof lessonGradingCriteriaControllerGetLessonGradingCriteria>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof lessonGradingCriteriaControllerGetLessonGradingCriteria>>>({ exact: $exactMatch, queryKey: getLessonGradingCriteriaControllerGetLessonGradingCriteriaQueryKey() }, updater);
  };
}

export const useGetLessonGradingCriteriaControllerGetLessonGradingCriteriaQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof lessonGradingCriteriaControllerGetLessonGradingCriteria>>>(getLessonGradingCriteriaControllerGetLessonGradingCriteriaQueryKey());
}



/**
 * @summary Own "Competitions won" count for the profile (EDSY-1722)
 */
export const liveSessionControllerGetMyStats = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LiveSessionUserStatsDto>(
      {url: `/live-sessions/me/stats`, method: 'GET', signal
    },
      options);
    }




export const getLiveSessionControllerGetMyStatsQueryKey = () => {
    return [
    `/live-sessions/me/stats`
    ] as const;
    }


export const getLiveSessionControllerGetMyStatsQueryOptions = <TData = Awaited<ReturnType<typeof liveSessionControllerGetMyStats>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetMyStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLiveSessionControllerGetMyStatsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof liveSessionControllerGetMyStats>>> = ({ signal }) => liveSessionControllerGetMyStats(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetMyStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LiveSessionControllerGetMyStatsQueryResult = NonNullable<Awaited<ReturnType<typeof liveSessionControllerGetMyStats>>>
export type LiveSessionControllerGetMyStatsQueryError = ErrorType<unknown>


export function useLiveSessionControllerGetMyStats<TData = Awaited<ReturnType<typeof liveSessionControllerGetMyStats>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetMyStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof liveSessionControllerGetMyStats>>,
          TError,
          Awaited<ReturnType<typeof liveSessionControllerGetMyStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLiveSessionControllerGetMyStats<TData = Awaited<ReturnType<typeof liveSessionControllerGetMyStats>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetMyStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof liveSessionControllerGetMyStats>>,
          TError,
          Awaited<ReturnType<typeof liveSessionControllerGetMyStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLiveSessionControllerGetMyStats<TData = Awaited<ReturnType<typeof liveSessionControllerGetMyStats>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetMyStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Own "Competitions won" count for the profile (EDSY-1722)
 */

export function useLiveSessionControllerGetMyStats<TData = Awaited<ReturnType<typeof liveSessionControllerGetMyStats>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetMyStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLiveSessionControllerGetMyStatsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLiveSessionControllerGetMyStats} query
 */
export const invalidateLiveSessionControllerGetMyStats = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLiveSessionControllerGetMyStatsQueryKey() }, options);

  return queryClient;
}

/**
 * @summary Own "Competitions won" count for the profile (EDSY-1722)
 */
export const useSetLiveSessionControllerGetMyStatsQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof liveSessionControllerGetMyStats>> | undefined | ((old: Awaited<ReturnType<typeof liveSessionControllerGetMyStats>> | undefined) => Awaited<ReturnType<typeof liveSessionControllerGetMyStats>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof liveSessionControllerGetMyStats>>>({ exact: $exactMatch, queryKey: getLiveSessionControllerGetMyStatsQueryKey() }, updater);
  };
}

/**
 * @summary Own "Competitions won" count for the profile (EDSY-1722)
 */
export const useGetLiveSessionControllerGetMyStatsQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof liveSessionControllerGetMyStats>>>(getLiveSessionControllerGetMyStatsQueryKey());
}



/**
 * @summary Nightly job — cancel stale RUNNING / OPEN sessions and resume stuck rewards (EDSY-1714)
 */
export const liveSessionControllerCancelStale = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CancelStaleLiveSessionsResultDto>(
      {url: `/live-sessions/cancel-stale`, method: 'POST', signal
    },
      options);
    }




export const getLiveSessionControllerCancelStaleMutationKey = () => ['liveSessionControllerCancelStale'] as const;

export const getLiveSessionControllerCancelStaleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerCancelStale>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerCancelStale>>, TError,void, TContext> => {

const mutationKey = getLiveSessionControllerCancelStaleMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof liveSessionControllerCancelStale>>, void> = () => {


          return  liveSessionControllerCancelStale(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LiveSessionControllerCancelStaleMutationResult = NonNullable<Awaited<ReturnType<typeof liveSessionControllerCancelStale>>>

    export type LiveSessionControllerCancelStaleMutationError = ErrorType<unknown>


    /**
 * @summary Nightly job — cancel stale RUNNING / OPEN sessions and resume stuck rewards (EDSY-1714)
 */
export const useLiveSessionControllerCancelStale = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerCancelStale>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof liveSessionControllerCancelStale>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLiveSessionControllerCancelStaleMutationOptions(options), queryClient);
    }

/**
 * @summary Grade one recorded word for live sessions (EDSY-1706)
 */
export const liveSessionControllerGradePronunciation = (
    gradeLiveSessionPronunciationDto: BodyType<GradeLiveSessionPronunciationDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {

      const formData = new FormData();
if(gradeLiveSessionPronunciationDto.file !== undefined) {
 formData.append(`file`, gradeLiveSessionPronunciationDto.file);
 }
formData.append(`referenceText`, gradeLiveSessionPronunciationDto.referenceText);
if(gradeLiveSessionPronunciationDto.partOfSpeech !== undefined) {
 formData.append(`partOfSpeech`, gradeLiveSessionPronunciationDto.partOfSpeech);
 }

      return customInstance<LiveSessionPronunciationResultDto>(
      {url: `/live-sessions/pronunciation`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getLiveSessionControllerGradePronunciationMutationKey = () => ['liveSessionControllerGradePronunciation'] as const;

export const getLiveSessionControllerGradePronunciationMutationOptions = <TError = ErrorType<void | LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerGradePronunciation>>, TError,LiveSessionControllerGradePronunciationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerGradePronunciation>>, TError,LiveSessionControllerGradePronunciationMutationVariables, TContext> => {

const mutationKey = getLiveSessionControllerGradePronunciationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof liveSessionControllerGradePronunciation>>, LiveSessionControllerGradePronunciationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  liveSessionControllerGradePronunciation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LiveSessionControllerGradePronunciationMutationResult = NonNullable<Awaited<ReturnType<typeof liveSessionControllerGradePronunciation>>>
    export type LiveSessionControllerGradePronunciationMutationBody = BodyType<GradeLiveSessionPronunciationDto>
    export type LiveSessionControllerGradePronunciationMutationError = ErrorType<void | LiveSessionErrorDto>
    export type LiveSessionControllerGradePronunciationMutationVariables = {data: BodyType<GradeLiveSessionPronunciationDto>}

    /**
 * @summary Grade one recorded word for live sessions (EDSY-1706)
 */
export const useLiveSessionControllerGradePronunciation = <TError = ErrorType<void | LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerGradePronunciation>>, TError,LiveSessionControllerGradePronunciationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof liveSessionControllerGradePronunciation>>,
        TError,
        LiveSessionControllerGradePronunciationMutationVariables,
        TContext
      > => {
      return useMutation(getLiveSessionControllerGradePronunciationMutationOptions(options), queryClient);
    }

/**
 * @summary Create a DRAFT session and sweep its content pool (EDSY-1705)
 */
export const liveSessionControllerCreate = (
    createLiveSessionDto: BodyType<CreateLiveSessionDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LiveSessionDto>(
      {url: `/live-sessions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createLiveSessionDto, signal
    },
      options);
    }




export const getLiveSessionControllerCreateMutationKey = () => ['liveSessionControllerCreate'] as const;

export const getLiveSessionControllerCreateMutationOptions = <TError = ErrorType<LiveSessionContentPoolTooLargeErrorDto | LiveSessionValidationErrorDto | LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerCreate>>, TError,LiveSessionControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerCreate>>, TError,LiveSessionControllerCreateMutationVariables, TContext> => {

const mutationKey = getLiveSessionControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof liveSessionControllerCreate>>, LiveSessionControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  liveSessionControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LiveSessionControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof liveSessionControllerCreate>>>
    export type LiveSessionControllerCreateMutationBody = BodyType<CreateLiveSessionDto>
    export type LiveSessionControllerCreateMutationError = ErrorType<LiveSessionContentPoolTooLargeErrorDto | LiveSessionValidationErrorDto | LiveSessionErrorDto>
    export type LiveSessionControllerCreateMutationVariables = {data: BodyType<CreateLiveSessionDto>}

    /**
 * @summary Create a DRAFT session and sweep its content pool (EDSY-1705)
 */
export const useLiveSessionControllerCreate = <TError = ErrorType<LiveSessionContentPoolTooLargeErrorDto | LiveSessionValidationErrorDto | LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerCreate>>, TError,LiveSessionControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof liveSessionControllerCreate>>,
        TError,
        LiveSessionControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getLiveSessionControllerCreateMutationOptions(options), queryClient);
    }

/**
 * @summary Each round's content pool for unsaved lessons and rounds — lets the form flag an empty round (EDSY-1885)
 */
export const liveSessionControllerPreviewContent = (
    previewLiveSessionContentDto: BodyType<PreviewLiveSessionContentDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LiveSessionRoundContentDto>(
      {url: `/live-sessions/content-preview`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: previewLiveSessionContentDto, signal
    },
      options);
    }




export const getLiveSessionControllerPreviewContentMutationKey = () => ['liveSessionControllerPreviewContent'] as const;

export const getLiveSessionControllerPreviewContentMutationOptions = <TError = ErrorType<LiveSessionContentPoolTooLargeErrorDto | LiveSessionValidationErrorDto | LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerPreviewContent>>, TError,LiveSessionControllerPreviewContentMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerPreviewContent>>, TError,LiveSessionControllerPreviewContentMutationVariables, TContext> => {

const mutationKey = getLiveSessionControllerPreviewContentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof liveSessionControllerPreviewContent>>, LiveSessionControllerPreviewContentMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  liveSessionControllerPreviewContent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LiveSessionControllerPreviewContentMutationResult = NonNullable<Awaited<ReturnType<typeof liveSessionControllerPreviewContent>>>
    export type LiveSessionControllerPreviewContentMutationBody = BodyType<PreviewLiveSessionContentDto>
    export type LiveSessionControllerPreviewContentMutationError = ErrorType<LiveSessionContentPoolTooLargeErrorDto | LiveSessionValidationErrorDto | LiveSessionErrorDto>
    export type LiveSessionControllerPreviewContentMutationVariables = {data: BodyType<PreviewLiveSessionContentDto>}

    /**
 * @summary Each round's content pool for unsaved lessons and rounds — lets the form flag an empty round (EDSY-1885)
 */
export const useLiveSessionControllerPreviewContent = <TError = ErrorType<LiveSessionContentPoolTooLargeErrorDto | LiveSessionValidationErrorDto | LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerPreviewContent>>, TError,LiveSessionControllerPreviewContentMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof liveSessionControllerPreviewContent>>,
        TError,
        LiveSessionControllerPreviewContentMutationVariables,
        TContext
      > => {
      return useMutation(getLiveSessionControllerPreviewContentMutationOptions(options), queryClient);
    }

/**
 * @summary Session details + serverTime for clock-skew correction
 */
export const liveSessionControllerGetById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LiveSessionDetailDto>(
      {url: `/live-sessions/${id}`, method: 'GET', signal
    },
      options);
    }




export const getLiveSessionControllerGetByIdQueryKey = (id: string,) => {
    return [
    `/live-sessions/${id}`
    ] as const;
    }


export const getLiveSessionControllerGetByIdQueryOptions = <TData = Awaited<ReturnType<typeof liveSessionControllerGetById>>, TError = ErrorType<LiveSessionErrorDto>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLiveSessionControllerGetByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof liveSessionControllerGetById>>> = ({ signal }) => liveSessionControllerGetById(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LiveSessionControllerGetByIdQueryResult = NonNullable<Awaited<ReturnType<typeof liveSessionControllerGetById>>>
export type LiveSessionControllerGetByIdQueryError = ErrorType<LiveSessionErrorDto>


export function useLiveSessionControllerGetById<TData = Awaited<ReturnType<typeof liveSessionControllerGetById>>, TError = ErrorType<LiveSessionErrorDto>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof liveSessionControllerGetById>>,
          TError,
          Awaited<ReturnType<typeof liveSessionControllerGetById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLiveSessionControllerGetById<TData = Awaited<ReturnType<typeof liveSessionControllerGetById>>, TError = ErrorType<LiveSessionErrorDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof liveSessionControllerGetById>>,
          TError,
          Awaited<ReturnType<typeof liveSessionControllerGetById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLiveSessionControllerGetById<TData = Awaited<ReturnType<typeof liveSessionControllerGetById>>, TError = ErrorType<LiveSessionErrorDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Session details + serverTime for clock-skew correction
 */

export function useLiveSessionControllerGetById<TData = Awaited<ReturnType<typeof liveSessionControllerGetById>>, TError = ErrorType<LiveSessionErrorDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLiveSessionControllerGetByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLiveSessionControllerGetById} query
 */
export const invalidateLiveSessionControllerGetById = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLiveSessionControllerGetByIdQueryKey(id) }, options);

  return queryClient;
}

/**
 * @summary Session details + serverTime for clock-skew correction
 */
export const useSetLiveSessionControllerGetByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof liveSessionControllerGetById>> | undefined | ((old: Awaited<ReturnType<typeof liveSessionControllerGetById>> | undefined) => Awaited<ReturnType<typeof liveSessionControllerGetById>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof liveSessionControllerGetById>>>({ exact: $exactMatch, queryKey: getLiveSessionControllerGetByIdQueryKey(id) }, updater);
  };
}

/**
 * @summary Session details + serverTime for clock-skew correction
 */
export const useGetLiveSessionControllerGetByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof liveSessionControllerGetById>>>(getLiveSessionControllerGetByIdQueryKey(id));
}



/**
 * @summary Edit name / rounds (DRAFT or OPEN) or lessonIds (DRAFT only — rewrites the pool); an empty body writes nothing
 */
export const liveSessionControllerUpdate = (
    id: string,
    updateLiveSessionDto: BodyType<UpdateLiveSessionDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LiveSessionDto>(
      {url: `/live-sessions/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateLiveSessionDto, signal
    },
      options);
    }




export const getLiveSessionControllerUpdateMutationKey = () => ['liveSessionControllerUpdate'] as const;

export const getLiveSessionControllerUpdateMutationOptions = <TError = ErrorType<LiveSessionContentPoolTooLargeErrorDto | LiveSessionValidationErrorDto | LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerUpdate>>, TError,LiveSessionControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerUpdate>>, TError,LiveSessionControllerUpdateMutationVariables, TContext> => {

const mutationKey = getLiveSessionControllerUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof liveSessionControllerUpdate>>, LiveSessionControllerUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  liveSessionControllerUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LiveSessionControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof liveSessionControllerUpdate>>>
    export type LiveSessionControllerUpdateMutationBody = BodyType<UpdateLiveSessionDto>
    export type LiveSessionControllerUpdateMutationError = ErrorType<LiveSessionContentPoolTooLargeErrorDto | LiveSessionValidationErrorDto | LiveSessionErrorDto>
    export type LiveSessionControllerUpdateMutationVariables = {id: string;data: BodyType<UpdateLiveSessionDto>}

    /**
 * @summary Edit name / rounds (DRAFT or OPEN) or lessonIds (DRAFT only — rewrites the pool); an empty body writes nothing
 */
export const useLiveSessionControllerUpdate = <TError = ErrorType<LiveSessionContentPoolTooLargeErrorDto | LiveSessionValidationErrorDto | LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerUpdate>>, TError,LiveSessionControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof liveSessionControllerUpdate>>,
        TError,
        LiveSessionControllerUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getLiveSessionControllerUpdateMutationOptions(options), queryClient);
    }

/**
 * @summary Hard-delete a DRAFT session and its content pool
 */
export const liveSessionControllerRemove = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/live-sessions/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getLiveSessionControllerRemoveMutationKey = () => ['liveSessionControllerRemove'] as const;

export const getLiveSessionControllerRemoveMutationOptions = <TError = ErrorType<LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerRemove>>, TError,LiveSessionControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerRemove>>, TError,LiveSessionControllerRemoveMutationVariables, TContext> => {

const mutationKey = getLiveSessionControllerRemoveMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof liveSessionControllerRemove>>, LiveSessionControllerRemoveMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  liveSessionControllerRemove(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LiveSessionControllerRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof liveSessionControllerRemove>>>

    export type LiveSessionControllerRemoveMutationError = ErrorType<LiveSessionErrorDto>
    export type LiveSessionControllerRemoveMutationVariables = {id: string}

    /**
 * @summary Hard-delete a DRAFT session and its content pool
 */
export const useLiveSessionControllerRemove = <TError = ErrorType<LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerRemove>>, TError,LiveSessionControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof liveSessionControllerRemove>>,
        TError,
        LiveSessionControllerRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getLiveSessionControllerRemoveMutationOptions(options), queryClient);
    }

/**
 * @summary DRAFT → OPEN; students start seeing the card
 */
export const liveSessionControllerOpen = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LiveSessionDto>(
      {url: `/live-sessions/${id}/open`, method: 'POST', signal
    },
      options);
    }




export const getLiveSessionControllerOpenMutationKey = () => ['liveSessionControllerOpen'] as const;

export const getLiveSessionControllerOpenMutationOptions = <TError = ErrorType<LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerOpen>>, TError,LiveSessionControllerOpenMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerOpen>>, TError,LiveSessionControllerOpenMutationVariables, TContext> => {

const mutationKey = getLiveSessionControllerOpenMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof liveSessionControllerOpen>>, LiveSessionControllerOpenMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  liveSessionControllerOpen(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LiveSessionControllerOpenMutationResult = NonNullable<Awaited<ReturnType<typeof liveSessionControllerOpen>>>

    export type LiveSessionControllerOpenMutationError = ErrorType<LiveSessionErrorDto>
    export type LiveSessionControllerOpenMutationVariables = {id: string}

    /**
 * @summary DRAFT → OPEN; students start seeing the card
 */
export const useLiveSessionControllerOpen = <TError = ErrorType<LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerOpen>>, TError,LiveSessionControllerOpenMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof liveSessionControllerOpen>>,
        TError,
        LiveSessionControllerOpenMutationVariables,
        TContext
      > => {
      return useMutation(getLiveSessionControllerOpenMutationOptions(options), queryClient);
    }

/**
 * @summary OPEN → RUNNING at round 0; closes joining; needs at least one participant
 */
export const liveSessionControllerStart = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LiveSessionDto>(
      {url: `/live-sessions/${id}/start`, method: 'POST', signal
    },
      options);
    }




export const getLiveSessionControllerStartMutationKey = () => ['liveSessionControllerStart'] as const;

export const getLiveSessionControllerStartMutationOptions = <TError = ErrorType<LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerStart>>, TError,LiveSessionControllerStartMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerStart>>, TError,LiveSessionControllerStartMutationVariables, TContext> => {

const mutationKey = getLiveSessionControllerStartMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof liveSessionControllerStart>>, LiveSessionControllerStartMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  liveSessionControllerStart(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LiveSessionControllerStartMutationResult = NonNullable<Awaited<ReturnType<typeof liveSessionControllerStart>>>

    export type LiveSessionControllerStartMutationError = ErrorType<LiveSessionErrorDto>
    export type LiveSessionControllerStartMutationVariables = {id: string}

    /**
 * @summary OPEN → RUNNING at round 0; closes joining; needs at least one participant
 */
export const useLiveSessionControllerStart = <TError = ErrorType<LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerStart>>, TError,LiveSessionControllerStartMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof liveSessionControllerStart>>,
        TError,
        LiveSessionControllerStartMutationVariables,
        TContext
      > => {
      return useMutation(getLiveSessionControllerStartMutationOptions(options), queryClient);
    }

/**
 * @summary Rank the finished round by cumulative score; a repeat, a past round or a closed session is a no-op (alreadySettled)
 */
export const liveSessionControllerSettleRound = (
    id: string,
    settleLiveSessionRoundDto: BodyType<SettleLiveSessionRoundDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SettleLiveSessionRoundResultDto>(
      {url: `/live-sessions/${id}/settle-round`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: settleLiveSessionRoundDto, signal
    },
      options);
    }




export const getLiveSessionControllerSettleRoundMutationKey = () => ['liveSessionControllerSettleRound'] as const;

export const getLiveSessionControllerSettleRoundMutationOptions = <TError = ErrorType<LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerSettleRound>>, TError,LiveSessionControllerSettleRoundMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerSettleRound>>, TError,LiveSessionControllerSettleRoundMutationVariables, TContext> => {

const mutationKey = getLiveSessionControllerSettleRoundMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof liveSessionControllerSettleRound>>, LiveSessionControllerSettleRoundMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  liveSessionControllerSettleRound(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LiveSessionControllerSettleRoundMutationResult = NonNullable<Awaited<ReturnType<typeof liveSessionControllerSettleRound>>>
    export type LiveSessionControllerSettleRoundMutationBody = BodyType<SettleLiveSessionRoundDto>
    export type LiveSessionControllerSettleRoundMutationError = ErrorType<LiveSessionErrorDto>
    export type LiveSessionControllerSettleRoundMutationVariables = {id: string;data: BodyType<SettleLiveSessionRoundDto>}

    /**
 * @summary Rank the finished round by cumulative score; a repeat, a past round or a closed session is a no-op (alreadySettled)
 */
export const useLiveSessionControllerSettleRound = <TError = ErrorType<LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerSettleRound>>, TError,LiveSessionControllerSettleRoundMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof liveSessionControllerSettleRound>>,
        TError,
        LiveSessionControllerSettleRoundMutationVariables,
        TContext
      > => {
      return useMutation(getLiveSessionControllerSettleRoundMutationOptions(options), queryClient);
    }

/**
 * @summary Advance to the next round, settling the round being left if settle-round never ran
 */
export const liveSessionControllerNextRound = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LiveSessionDto>(
      {url: `/live-sessions/${id}/next-round`, method: 'POST', signal
    },
      options);
    }




export const getLiveSessionControllerNextRoundMutationKey = () => ['liveSessionControllerNextRound'] as const;

export const getLiveSessionControllerNextRoundMutationOptions = <TError = ErrorType<LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerNextRound>>, TError,LiveSessionControllerNextRoundMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerNextRound>>, TError,LiveSessionControllerNextRoundMutationVariables, TContext> => {

const mutationKey = getLiveSessionControllerNextRoundMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof liveSessionControllerNextRound>>, LiveSessionControllerNextRoundMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  liveSessionControllerNextRound(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LiveSessionControllerNextRoundMutationResult = NonNullable<Awaited<ReturnType<typeof liveSessionControllerNextRound>>>

    export type LiveSessionControllerNextRoundMutationError = ErrorType<LiveSessionErrorDto>
    export type LiveSessionControllerNextRoundMutationVariables = {id: string}

    /**
 * @summary Advance to the next round, settling the round being left if settle-round never ran
 */
export const useLiveSessionControllerNextRound = <TError = ErrorType<LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerNextRound>>, TError,LiveSessionControllerNextRoundMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof liveSessionControllerNextRound>>,
        TError,
        LiveSessionControllerNextRoundMutationVariables,
        TContext
      > => {
      return useMutation(getLiveSessionControllerNextRoundMutationOptions(options), queryClient);
    }

/**
 * @summary RUNNING → ENDED, rank and reward; OPEN → CANCELED with no ranking; re-calling on ENDED resumes unfinished rewards
 */
export const liveSessionControllerEnd = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LiveSessionDto>(
      {url: `/live-sessions/${id}/end`, method: 'POST', signal
    },
      options);
    }




export const getLiveSessionControllerEndMutationKey = () => ['liveSessionControllerEnd'] as const;

export const getLiveSessionControllerEndMutationOptions = <TError = ErrorType<LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerEnd>>, TError,LiveSessionControllerEndMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerEnd>>, TError,LiveSessionControllerEndMutationVariables, TContext> => {

const mutationKey = getLiveSessionControllerEndMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof liveSessionControllerEnd>>, LiveSessionControllerEndMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  liveSessionControllerEnd(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LiveSessionControllerEndMutationResult = NonNullable<Awaited<ReturnType<typeof liveSessionControllerEnd>>>

    export type LiveSessionControllerEndMutationError = ErrorType<LiveSessionErrorDto>
    export type LiveSessionControllerEndMutationVariables = {id: string}

    /**
 * @summary RUNNING → ENDED, rank and reward; OPEN → CANCELED with no ranking; re-calling on ENDED resumes unfinished rewards
 */
export const useLiveSessionControllerEnd = <TError = ErrorType<LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerEnd>>, TError,LiveSessionControllerEndMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof liveSessionControllerEnd>>,
        TError,
        LiveSessionControllerEndMutationVariables,
        TContext
      > => {
      return useMutation(getLiveSessionControllerEndMutationOptions(options), queryClient);
    }

/**
 * @summary Join (OPEN) or rejoin (OPEN / RUNNING — returns the participant unchanged on the same device); deviceId is required, omit displayName to Skip (EDSY-1705 / EDSY-1721 / EDSY-1772 / EDSY-1870)
 */
export const liveSessionControllerJoin = (
    id: string,
    joinLiveSessionDto: BodyType<JoinLiveSessionDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LiveSessionParticipantDto>(
      {url: `/live-sessions/${id}/join`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: joinLiveSessionDto, signal
    },
      options);
    }




export const getLiveSessionControllerJoinMutationKey = () => ['liveSessionControllerJoin'] as const;

export const getLiveSessionControllerJoinMutationOptions = <TError = ErrorType<LiveSessionValidationErrorDto | LiveSessionErrorDto | LiveSessionDeviceMismatchErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerJoin>>, TError,LiveSessionControllerJoinMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerJoin>>, TError,LiveSessionControllerJoinMutationVariables, TContext> => {

const mutationKey = getLiveSessionControllerJoinMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof liveSessionControllerJoin>>, LiveSessionControllerJoinMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  liveSessionControllerJoin(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LiveSessionControllerJoinMutationResult = NonNullable<Awaited<ReturnType<typeof liveSessionControllerJoin>>>
    export type LiveSessionControllerJoinMutationBody = BodyType<JoinLiveSessionDto>
    export type LiveSessionControllerJoinMutationError = ErrorType<LiveSessionValidationErrorDto | LiveSessionErrorDto | LiveSessionDeviceMismatchErrorDto>
    export type LiveSessionControllerJoinMutationVariables = {id: string;data: BodyType<JoinLiveSessionDto>}

    /**
 * @summary Join (OPEN) or rejoin (OPEN / RUNNING — returns the participant unchanged on the same device); deviceId is required, omit displayName to Skip (EDSY-1705 / EDSY-1721 / EDSY-1772 / EDSY-1870)
 */
export const useLiveSessionControllerJoin = <TError = ErrorType<LiveSessionValidationErrorDto | LiveSessionErrorDto | LiveSessionDeviceMismatchErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerJoin>>, TError,LiveSessionControllerJoinMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof liveSessionControllerJoin>>,
        TError,
        LiveSessionControllerJoinMutationVariables,
        TContext
      > => {
      return useMutation(getLiveSessionControllerJoinMutationOptions(options), queryClient);
    }

/**
 * @summary OPEN: leave the waiting room — the participant is deleted and may join again (EDSY-1712). RUNNING: leave for good — no rejoin; points, rank and rewards stay; a repeat is a no-op (EDSY-1772)
 */
export const liveSessionControllerLeave = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/live-sessions/${id}/leave`, method: 'POST', signal
    },
      options);
    }




export const getLiveSessionControllerLeaveMutationKey = () => ['liveSessionControllerLeave'] as const;

export const getLiveSessionControllerLeaveMutationOptions = <TError = ErrorType<LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerLeave>>, TError,LiveSessionControllerLeaveMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerLeave>>, TError,LiveSessionControllerLeaveMutationVariables, TContext> => {

const mutationKey = getLiveSessionControllerLeaveMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof liveSessionControllerLeave>>, LiveSessionControllerLeaveMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  liveSessionControllerLeave(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LiveSessionControllerLeaveMutationResult = NonNullable<Awaited<ReturnType<typeof liveSessionControllerLeave>>>

    export type LiveSessionControllerLeaveMutationError = ErrorType<LiveSessionErrorDto>
    export type LiveSessionControllerLeaveMutationVariables = {id: string}

    /**
 * @summary OPEN: leave the waiting room — the participant is deleted and may join again (EDSY-1712). RUNNING: leave for good — no rejoin; points, rank and rewards stay; a repeat is a no-op (EDSY-1772)
 */
export const useLiveSessionControllerLeave = <TError = ErrorType<LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerLeave>>, TError,LiveSessionControllerLeaveMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof liveSessionControllerLeave>>,
        TError,
        LiveSessionControllerLeaveMutationVariables,
        TContext
      > => {
      return useMutation(getLiveSessionControllerLeaveMutationOptions(options), queryClient);
    }

/**
 * @summary Edit own display name while OPEN; blank resets to the real name (EDSY-1721)
 */
export const liveSessionControllerUpdateMyParticipant = (
    id: string,
    updateLiveSessionParticipantDto: BodyType<UpdateLiveSessionParticipantDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LiveSessionParticipantDto>(
      {url: `/live-sessions/${id}/participants/me`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateLiveSessionParticipantDto, signal
    },
      options);
    }




export const getLiveSessionControllerUpdateMyParticipantMutationKey = () => ['liveSessionControllerUpdateMyParticipant'] as const;

export const getLiveSessionControllerUpdateMyParticipantMutationOptions = <TError = ErrorType<LiveSessionValidationErrorDto | LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerUpdateMyParticipant>>, TError,LiveSessionControllerUpdateMyParticipantMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerUpdateMyParticipant>>, TError,LiveSessionControllerUpdateMyParticipantMutationVariables, TContext> => {

const mutationKey = getLiveSessionControllerUpdateMyParticipantMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof liveSessionControllerUpdateMyParticipant>>, LiveSessionControllerUpdateMyParticipantMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  liveSessionControllerUpdateMyParticipant(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LiveSessionControllerUpdateMyParticipantMutationResult = NonNullable<Awaited<ReturnType<typeof liveSessionControllerUpdateMyParticipant>>>
    export type LiveSessionControllerUpdateMyParticipantMutationBody = BodyType<UpdateLiveSessionParticipantDto>
    export type LiveSessionControllerUpdateMyParticipantMutationError = ErrorType<LiveSessionValidationErrorDto | LiveSessionErrorDto>
    export type LiveSessionControllerUpdateMyParticipantMutationVariables = {id: string;data: BodyType<UpdateLiveSessionParticipantDto>}

    /**
 * @summary Edit own display name while OPEN; blank resets to the real name (EDSY-1721)
 */
export const useLiveSessionControllerUpdateMyParticipant = <TError = ErrorType<LiveSessionValidationErrorDto | LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionControllerUpdateMyParticipant>>, TError,LiveSessionControllerUpdateMyParticipantMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof liveSessionControllerUpdateMyParticipant>>,
        TError,
        LiveSessionControllerUpdateMyParticipantMutationVariables,
        TContext
      > => {
      return useMutation(getLiveSessionControllerUpdateMyParticipantMutationOptions(options), queryClient);
    }

/**
 * @summary Each round's content pool — the FE generates questions from it (EDSY-1702, EDSY-1858)
 */
export const liveSessionControllerGetRoundContent = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LiveSessionRoundContentDto>(
      {url: `/live-sessions/${id}/round-content`, method: 'GET', signal
    },
      options);
    }




export const getLiveSessionControllerGetRoundContentQueryKey = (id: string,) => {
    return [
    `/live-sessions/${id}/round-content`
    ] as const;
    }


export const getLiveSessionControllerGetRoundContentQueryOptions = <TData = Awaited<ReturnType<typeof liveSessionControllerGetRoundContent>>, TError = ErrorType<LiveSessionErrorDto | void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetRoundContent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLiveSessionControllerGetRoundContentQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof liveSessionControllerGetRoundContent>>> = ({ signal }) => liveSessionControllerGetRoundContent(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetRoundContent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LiveSessionControllerGetRoundContentQueryResult = NonNullable<Awaited<ReturnType<typeof liveSessionControllerGetRoundContent>>>
export type LiveSessionControllerGetRoundContentQueryError = ErrorType<LiveSessionErrorDto | void>


export function useLiveSessionControllerGetRoundContent<TData = Awaited<ReturnType<typeof liveSessionControllerGetRoundContent>>, TError = ErrorType<LiveSessionErrorDto | void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetRoundContent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof liveSessionControllerGetRoundContent>>,
          TError,
          Awaited<ReturnType<typeof liveSessionControllerGetRoundContent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLiveSessionControllerGetRoundContent<TData = Awaited<ReturnType<typeof liveSessionControllerGetRoundContent>>, TError = ErrorType<LiveSessionErrorDto | void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetRoundContent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof liveSessionControllerGetRoundContent>>,
          TError,
          Awaited<ReturnType<typeof liveSessionControllerGetRoundContent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLiveSessionControllerGetRoundContent<TData = Awaited<ReturnType<typeof liveSessionControllerGetRoundContent>>, TError = ErrorType<LiveSessionErrorDto | void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetRoundContent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Each round's content pool — the FE generates questions from it (EDSY-1702, EDSY-1858)
 */

export function useLiveSessionControllerGetRoundContent<TData = Awaited<ReturnType<typeof liveSessionControllerGetRoundContent>>, TError = ErrorType<LiveSessionErrorDto | void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetRoundContent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLiveSessionControllerGetRoundContentQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLiveSessionControllerGetRoundContent} query
 */
export const invalidateLiveSessionControllerGetRoundContent = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLiveSessionControllerGetRoundContentQueryKey(id) }, options);

  return queryClient;
}

/**
 * @summary Each round's content pool — the FE generates questions from it (EDSY-1702, EDSY-1858)
 */
export const useSetLiveSessionControllerGetRoundContentQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof liveSessionControllerGetRoundContent>> | undefined | ((old: Awaited<ReturnType<typeof liveSessionControllerGetRoundContent>> | undefined) => Awaited<ReturnType<typeof liveSessionControllerGetRoundContent>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof liveSessionControllerGetRoundContent>>>({ exact: $exactMatch, queryKey: getLiveSessionControllerGetRoundContentQueryKey(id) }, updater);
  };
}

/**
 * @summary Each round's content pool — the FE generates questions from it (EDSY-1702, EDSY-1858)
 */
export const useGetLiveSessionControllerGetRoundContentQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof liveSessionControllerGetRoundContent>>>(getLiveSessionControllerGetRoundContentQueryKey(id));
}



/**
 * @deprecated
 * @summary First round's content pool — deprecated, for clients from before EDSY-1858; use round-content
 */
export const liveSessionControllerGetContent = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LiveSessionContentPoolDto>(
      {url: `/live-sessions/${id}/content`, method: 'GET', signal
    },
      options);
    }




export const getLiveSessionControllerGetContentQueryKey = (id: string,) => {
    return [
    `/live-sessions/${id}/content`
    ] as const;
    }


export const getLiveSessionControllerGetContentQueryOptions = <TData = Awaited<ReturnType<typeof liveSessionControllerGetContent>>, TError = ErrorType<LiveSessionErrorDto | void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetContent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLiveSessionControllerGetContentQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof liveSessionControllerGetContent>>> = ({ signal }) => liveSessionControllerGetContent(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetContent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LiveSessionControllerGetContentQueryResult = NonNullable<Awaited<ReturnType<typeof liveSessionControllerGetContent>>>
export type LiveSessionControllerGetContentQueryError = ErrorType<LiveSessionErrorDto | void>


export function useLiveSessionControllerGetContent<TData = Awaited<ReturnType<typeof liveSessionControllerGetContent>>, TError = ErrorType<LiveSessionErrorDto | void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetContent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof liveSessionControllerGetContent>>,
          TError,
          Awaited<ReturnType<typeof liveSessionControllerGetContent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLiveSessionControllerGetContent<TData = Awaited<ReturnType<typeof liveSessionControllerGetContent>>, TError = ErrorType<LiveSessionErrorDto | void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetContent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof liveSessionControllerGetContent>>,
          TError,
          Awaited<ReturnType<typeof liveSessionControllerGetContent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLiveSessionControllerGetContent<TData = Awaited<ReturnType<typeof liveSessionControllerGetContent>>, TError = ErrorType<LiveSessionErrorDto | void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetContent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary First round's content pool — deprecated, for clients from before EDSY-1858; use round-content
 */

export function useLiveSessionControllerGetContent<TData = Awaited<ReturnType<typeof liveSessionControllerGetContent>>, TError = ErrorType<LiveSessionErrorDto | void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetContent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLiveSessionControllerGetContentQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @deprecated
 * @summary Invalidates the {@link useLiveSessionControllerGetContent} query
 */
export const invalidateLiveSessionControllerGetContent = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLiveSessionControllerGetContentQueryKey(id) }, options);

  return queryClient;
}

/**
 * @deprecated
 * @summary First round's content pool — deprecated, for clients from before EDSY-1858; use round-content
 */
export const useSetLiveSessionControllerGetContentQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof liveSessionControllerGetContent>> | undefined | ((old: Awaited<ReturnType<typeof liveSessionControllerGetContent>> | undefined) => Awaited<ReturnType<typeof liveSessionControllerGetContent>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof liveSessionControllerGetContent>>>({ exact: $exactMatch, queryKey: getLiveSessionControllerGetContentQueryKey(id) }, updater);
  };
}

/**
 * @deprecated
 * @summary First round's content pool — deprecated, for clients from before EDSY-1858; use round-content
 */
export const useGetLiveSessionControllerGetContentQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof liveSessionControllerGetContent>>>(getLiveSessionControllerGetContentQueryKey(id));
}



/**
 * @summary Final ranking with the XP / coins actually rewarded
 */
export const liveSessionControllerGetResult = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LiveSessionResultDto>(
      {url: `/live-sessions/${id}/result`, method: 'GET', signal
    },
      options);
    }




export const getLiveSessionControllerGetResultQueryKey = (id: string,) => {
    return [
    `/live-sessions/${id}/result`
    ] as const;
    }


export const getLiveSessionControllerGetResultQueryOptions = <TData = Awaited<ReturnType<typeof liveSessionControllerGetResult>>, TError = ErrorType<LiveSessionErrorDto>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetResult>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLiveSessionControllerGetResultQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof liveSessionControllerGetResult>>> = ({ signal }) => liveSessionControllerGetResult(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetResult>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LiveSessionControllerGetResultQueryResult = NonNullable<Awaited<ReturnType<typeof liveSessionControllerGetResult>>>
export type LiveSessionControllerGetResultQueryError = ErrorType<LiveSessionErrorDto>


export function useLiveSessionControllerGetResult<TData = Awaited<ReturnType<typeof liveSessionControllerGetResult>>, TError = ErrorType<LiveSessionErrorDto>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetResult>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof liveSessionControllerGetResult>>,
          TError,
          Awaited<ReturnType<typeof liveSessionControllerGetResult>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLiveSessionControllerGetResult<TData = Awaited<ReturnType<typeof liveSessionControllerGetResult>>, TError = ErrorType<LiveSessionErrorDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetResult>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof liveSessionControllerGetResult>>,
          TError,
          Awaited<ReturnType<typeof liveSessionControllerGetResult>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLiveSessionControllerGetResult<TData = Awaited<ReturnType<typeof liveSessionControllerGetResult>>, TError = ErrorType<LiveSessionErrorDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetResult>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Final ranking with the XP / coins actually rewarded
 */

export function useLiveSessionControllerGetResult<TData = Awaited<ReturnType<typeof liveSessionControllerGetResult>>, TError = ErrorType<LiveSessionErrorDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionControllerGetResult>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLiveSessionControllerGetResultQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLiveSessionControllerGetResult} query
 */
export const invalidateLiveSessionControllerGetResult = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLiveSessionControllerGetResultQueryKey(id) }, options);

  return queryClient;
}

/**
 * @summary Final ranking with the XP / coins actually rewarded
 */
export const useSetLiveSessionControllerGetResultQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof liveSessionControllerGetResult>> | undefined | ((old: Awaited<ReturnType<typeof liveSessionControllerGetResult>> | undefined) => Awaited<ReturnType<typeof liveSessionControllerGetResult>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof liveSessionControllerGetResult>>>({ exact: $exactMatch, queryKey: getLiveSessionControllerGetResultQueryKey(id) }, updater);
  };
}

/**
 * @summary Final ranking with the XP / coins actually rewarded
 */
export const useGetLiveSessionControllerGetResultQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof liveSessionControllerGetResult>>>(getLiveSessionControllerGetResultQueryKey(id));
}



/**
 * Leaves out lesson-path slot sessions and sessions canceled before they started. Refetch on mount / focus and when the OPEN-session listener reports added or removed (DRAFT changes show on the next mount / focus); on modified (participantCount changed) only while participantCount <= 5, the size of previewParticipants — the listener itself carries the live join count.
 * @summary Student Class Challenge tab: the 20 newest ad-hoc sessions, DRAFT included, newest first
 */
export const liveSessionClassroomControllerListForStudent = (
    classroomId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LiveSessionStudentCardDto[]>(
      {url: `/classrooms/${classroomId}/live-sessions/student`, method: 'GET', signal
    },
      options);
    }




export const getLiveSessionClassroomControllerListForStudentQueryKey = (classroomId: string,) => {
    return [
    `/classrooms/${classroomId}/live-sessions/student`
    ] as const;
    }


export const getLiveSessionClassroomControllerListForStudentQueryOptions = <TData = Awaited<ReturnType<typeof liveSessionClassroomControllerListForStudent>>, TError = ErrorType<void>>(classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionClassroomControllerListForStudent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLiveSessionClassroomControllerListForStudentQueryKey(classroomId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof liveSessionClassroomControllerListForStudent>>> = ({ signal }) => liveSessionClassroomControllerListForStudent(classroomId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof liveSessionClassroomControllerListForStudent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LiveSessionClassroomControllerListForStudentQueryResult = NonNullable<Awaited<ReturnType<typeof liveSessionClassroomControllerListForStudent>>>
export type LiveSessionClassroomControllerListForStudentQueryError = ErrorType<void>


export function useLiveSessionClassroomControllerListForStudent<TData = Awaited<ReturnType<typeof liveSessionClassroomControllerListForStudent>>, TError = ErrorType<void>>(
 classroomId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionClassroomControllerListForStudent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof liveSessionClassroomControllerListForStudent>>,
          TError,
          Awaited<ReturnType<typeof liveSessionClassroomControllerListForStudent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLiveSessionClassroomControllerListForStudent<TData = Awaited<ReturnType<typeof liveSessionClassroomControllerListForStudent>>, TError = ErrorType<void>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionClassroomControllerListForStudent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof liveSessionClassroomControllerListForStudent>>,
          TError,
          Awaited<ReturnType<typeof liveSessionClassroomControllerListForStudent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLiveSessionClassroomControllerListForStudent<TData = Awaited<ReturnType<typeof liveSessionClassroomControllerListForStudent>>, TError = ErrorType<void>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionClassroomControllerListForStudent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Student Class Challenge tab: the 20 newest ad-hoc sessions, DRAFT included, newest first
 */

export function useLiveSessionClassroomControllerListForStudent<TData = Awaited<ReturnType<typeof liveSessionClassroomControllerListForStudent>>, TError = ErrorType<void>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionClassroomControllerListForStudent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLiveSessionClassroomControllerListForStudentQueryOptions(classroomId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLiveSessionClassroomControllerListForStudent} query
 */
export const invalidateLiveSessionClassroomControllerListForStudent = async (
 queryClient: QueryClient, classroomId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLiveSessionClassroomControllerListForStudentQueryKey(classroomId) }, options);

  return queryClient;
}

/**
 * @summary Student Class Challenge tab: the 20 newest ad-hoc sessions, DRAFT included, newest first
 */
export const useSetLiveSessionClassroomControllerListForStudentQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,updater: Awaited<ReturnType<typeof liveSessionClassroomControllerListForStudent>> | undefined | ((old: Awaited<ReturnType<typeof liveSessionClassroomControllerListForStudent>> | undefined) => Awaited<ReturnType<typeof liveSessionClassroomControllerListForStudent>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof liveSessionClassroomControllerListForStudent>>>({ exact: $exactMatch, queryKey: getLiveSessionClassroomControllerListForStudentQueryKey(classroomId) }, updater);
  };
}

/**
 * @summary Student Class Challenge tab: the 20 newest ad-hoc sessions, DRAFT included, newest first
 */
export const useGetLiveSessionClassroomControllerListForStudentQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof liveSessionClassroomControllerListForStudent>>>(getLiveSessionClassroomControllerListForStudentQueryKey(classroomId));
}



/**
 * @summary Teacher's session list, one page at a time, DRAFT included; newest first unless sortBy says otherwise
 */
export const liveSessionClassroomControllerList = (
    classroomId: string,
    params?: LiveSessionClassroomControllerListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LiveSessionListPageDto>(
      {url: `/classrooms/${classroomId}/live-sessions`, method: 'GET',
        params, signal
    },
      options);
    }




export const getLiveSessionClassroomControllerListQueryKey = (classroomId: string,
    params?: LiveSessionClassroomControllerListParams,) => {
    return [
    `/classrooms/${classroomId}/live-sessions`, ...(params ? [params] : [])
    ] as const;
    }


export const getLiveSessionClassroomControllerListQueryOptions = <TData = Awaited<ReturnType<typeof liveSessionClassroomControllerList>>, TError = ErrorType<LiveSessionValidationErrorDto | void>>(classroomId: string,
    params?: LiveSessionClassroomControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionClassroomControllerList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLiveSessionClassroomControllerListQueryKey(classroomId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof liveSessionClassroomControllerList>>> = ({ signal }) => liveSessionClassroomControllerList(classroomId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof liveSessionClassroomControllerList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LiveSessionClassroomControllerListQueryResult = NonNullable<Awaited<ReturnType<typeof liveSessionClassroomControllerList>>>
export type LiveSessionClassroomControllerListQueryError = ErrorType<LiveSessionValidationErrorDto | void>


export function useLiveSessionClassroomControllerList<TData = Awaited<ReturnType<typeof liveSessionClassroomControllerList>>, TError = ErrorType<LiveSessionValidationErrorDto | void>>(
 classroomId: string,
    params: undefined |  LiveSessionClassroomControllerListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionClassroomControllerList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof liveSessionClassroomControllerList>>,
          TError,
          Awaited<ReturnType<typeof liveSessionClassroomControllerList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLiveSessionClassroomControllerList<TData = Awaited<ReturnType<typeof liveSessionClassroomControllerList>>, TError = ErrorType<LiveSessionValidationErrorDto | void>>(
 classroomId: string,
    params?: LiveSessionClassroomControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionClassroomControllerList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof liveSessionClassroomControllerList>>,
          TError,
          Awaited<ReturnType<typeof liveSessionClassroomControllerList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLiveSessionClassroomControllerList<TData = Awaited<ReturnType<typeof liveSessionClassroomControllerList>>, TError = ErrorType<LiveSessionValidationErrorDto | void>>(
 classroomId: string,
    params?: LiveSessionClassroomControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionClassroomControllerList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Teacher's session list, one page at a time, DRAFT included; newest first unless sortBy says otherwise
 */

export function useLiveSessionClassroomControllerList<TData = Awaited<ReturnType<typeof liveSessionClassroomControllerList>>, TError = ErrorType<LiveSessionValidationErrorDto | void>>(
 classroomId: string,
    params?: LiveSessionClassroomControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof liveSessionClassroomControllerList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLiveSessionClassroomControllerListQueryOptions(classroomId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLiveSessionClassroomControllerList} query
 */
export const invalidateLiveSessionClassroomControllerList = async (
 queryClient: QueryClient, classroomId: string,
    params?: LiveSessionClassroomControllerListParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLiveSessionClassroomControllerListQueryKey(classroomId,params) }, options);

  return queryClient;
}

/**
 * @summary Teacher's session list, one page at a time, DRAFT included; newest first unless sortBy says otherwise
 */
export const useSetLiveSessionClassroomControllerListQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    params: LiveSessionClassroomControllerListParams | undefined,updater: Awaited<ReturnType<typeof liveSessionClassroomControllerList>> | undefined | ((old: Awaited<ReturnType<typeof liveSessionClassroomControllerList>> | undefined) => Awaited<ReturnType<typeof liveSessionClassroomControllerList>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof liveSessionClassroomControllerList>>>({ exact: $exactMatch, queryKey: getLiveSessionClassroomControllerListQueryKey(classroomId,params) }, updater);
  };
}

/**
 * @summary Teacher's session list, one page at a time, DRAFT included; newest first unless sortBy says otherwise
 */
export const useGetLiveSessionClassroomControllerListQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    params?: LiveSessionClassroomControllerListParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof liveSessionClassroomControllerList>>>(getLiveSessionClassroomControllerListQueryKey(classroomId,params));
}



/**
 * @summary Admin — place a DRAFT Live Session slot in a classroom lesson path (EDSY-1851)
 */
export const liveSessionSlotControllerCreate = (
    createLiveSessionSlotDto: BodyType<CreateLiveSessionSlotDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LiveSessionSlotDto>(
      {url: `/live-session-slots`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createLiveSessionSlotDto, signal
    },
      options);
    }




export const getLiveSessionSlotControllerCreateMutationKey = () => ['liveSessionSlotControllerCreate'] as const;

export const getLiveSessionSlotControllerCreateMutationOptions = <TError = ErrorType<void | LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionSlotControllerCreate>>, TError,LiveSessionSlotControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof liveSessionSlotControllerCreate>>, TError,LiveSessionSlotControllerCreateMutationVariables, TContext> => {

const mutationKey = getLiveSessionSlotControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof liveSessionSlotControllerCreate>>, LiveSessionSlotControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  liveSessionSlotControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LiveSessionSlotControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof liveSessionSlotControllerCreate>>>
    export type LiveSessionSlotControllerCreateMutationBody = BodyType<CreateLiveSessionSlotDto>
    export type LiveSessionSlotControllerCreateMutationError = ErrorType<void | LiveSessionErrorDto>
    export type LiveSessionSlotControllerCreateMutationVariables = {data: BodyType<CreateLiveSessionSlotDto>}

    /**
 * @summary Admin — place a DRAFT Live Session slot in a classroom lesson path (EDSY-1851)
 */
export const useLiveSessionSlotControllerCreate = <TError = ErrorType<void | LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionSlotControllerCreate>>, TError,LiveSessionSlotControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof liveSessionSlotControllerCreate>>,
        TError,
        LiveSessionSlotControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getLiveSessionSlotControllerCreateMutationOptions(options), queryClient);
    }

/**
 * @summary Admin — edit the name, lessons or rounds of a DRAFT slot session; a lesson change rewrites the pools
 */
export const liveSessionSlotControllerUpdate = (
    classroomLessonId: string,
    updateLiveSessionDto: BodyType<UpdateLiveSessionDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LiveSessionDto>(
      {url: `/live-session-slots/${classroomLessonId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateLiveSessionDto, signal
    },
      options);
    }




export const getLiveSessionSlotControllerUpdateMutationKey = () => ['liveSessionSlotControllerUpdate'] as const;

export const getLiveSessionSlotControllerUpdateMutationOptions = <TError = ErrorType<void | LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionSlotControllerUpdate>>, TError,LiveSessionSlotControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof liveSessionSlotControllerUpdate>>, TError,LiveSessionSlotControllerUpdateMutationVariables, TContext> => {

const mutationKey = getLiveSessionSlotControllerUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof liveSessionSlotControllerUpdate>>, LiveSessionSlotControllerUpdateMutationVariables> = (props) => {
          const {classroomLessonId,data} = props ?? {};

          return  liveSessionSlotControllerUpdate(classroomLessonId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LiveSessionSlotControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof liveSessionSlotControllerUpdate>>>
    export type LiveSessionSlotControllerUpdateMutationBody = BodyType<UpdateLiveSessionDto>
    export type LiveSessionSlotControllerUpdateMutationError = ErrorType<void | LiveSessionErrorDto>
    export type LiveSessionSlotControllerUpdateMutationVariables = {classroomLessonId: string;data: BodyType<UpdateLiveSessionDto>}

    /**
 * @summary Admin — edit the name, lessons or rounds of a DRAFT slot session; a lesson change rewrites the pools
 */
export const useLiveSessionSlotControllerUpdate = <TError = ErrorType<void | LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionSlotControllerUpdate>>, TError,LiveSessionSlotControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof liveSessionSlotControllerUpdate>>,
        TError,
        LiveSessionSlotControllerUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getLiveSessionSlotControllerUpdateMutationOptions(options), queryClient);
    }

/**
 * @summary Admin — remove a DRAFT or CANCELED slot and close the gap in the lesson path
 */
export const liveSessionSlotControllerDelete = (
    classroomLessonId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/live-session-slots/${classroomLessonId}`, method: 'DELETE', signal
    },
      options);
    }




export const getLiveSessionSlotControllerDeleteMutationKey = () => ['liveSessionSlotControllerDelete'] as const;

export const getLiveSessionSlotControllerDeleteMutationOptions = <TError = ErrorType<void | LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionSlotControllerDelete>>, TError,LiveSessionSlotControllerDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof liveSessionSlotControllerDelete>>, TError,LiveSessionSlotControllerDeleteMutationVariables, TContext> => {

const mutationKey = getLiveSessionSlotControllerDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof liveSessionSlotControllerDelete>>, LiveSessionSlotControllerDeleteMutationVariables> = (props) => {
          const {classroomLessonId} = props ?? {};

          return  liveSessionSlotControllerDelete(classroomLessonId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LiveSessionSlotControllerDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof liveSessionSlotControllerDelete>>>

    export type LiveSessionSlotControllerDeleteMutationError = ErrorType<void | LiveSessionErrorDto>
    export type LiveSessionSlotControllerDeleteMutationVariables = {classroomLessonId: string}

    /**
 * @summary Admin — remove a DRAFT or CANCELED slot and close the gap in the lesson path
 */
export const useLiveSessionSlotControllerDelete = <TError = ErrorType<void | LiveSessionErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liveSessionSlotControllerDelete>>, TError,LiveSessionSlotControllerDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof liveSessionSlotControllerDelete>>,
        TError,
        LiveSessionSlotControllerDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getLiveSessionSlotControllerDeleteMutationOptions(options), queryClient);
    }

/**
 * @summary Get current user's avatar selection
 */
export const userAvatarSelectionControllerGetMySelection = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserAvatarSelectionControllerGetMySelection200>(
      {url: `/user-avatar-selection/me`, method: 'GET', signal
    },
      options);
    }




export const getUserAvatarSelectionControllerGetMySelectionQueryKey = () => {
    return [
    `/user-avatar-selection/me`
    ] as const;
    }


export const getUserAvatarSelectionControllerGetMySelectionQueryOptions = <TData = Awaited<ReturnType<typeof userAvatarSelectionControllerGetMySelection>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userAvatarSelectionControllerGetMySelection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserAvatarSelectionControllerGetMySelectionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userAvatarSelectionControllerGetMySelection>>> = ({ signal }) => userAvatarSelectionControllerGetMySelection(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userAvatarSelectionControllerGetMySelection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserAvatarSelectionControllerGetMySelectionQueryResult = NonNullable<Awaited<ReturnType<typeof userAvatarSelectionControllerGetMySelection>>>
export type UserAvatarSelectionControllerGetMySelectionQueryError = ErrorType<unknown>


export function useUserAvatarSelectionControllerGetMySelection<TData = Awaited<ReturnType<typeof userAvatarSelectionControllerGetMySelection>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userAvatarSelectionControllerGetMySelection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userAvatarSelectionControllerGetMySelection>>,
          TError,
          Awaited<ReturnType<typeof userAvatarSelectionControllerGetMySelection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserAvatarSelectionControllerGetMySelection<TData = Awaited<ReturnType<typeof userAvatarSelectionControllerGetMySelection>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userAvatarSelectionControllerGetMySelection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userAvatarSelectionControllerGetMySelection>>,
          TError,
          Awaited<ReturnType<typeof userAvatarSelectionControllerGetMySelection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserAvatarSelectionControllerGetMySelection<TData = Awaited<ReturnType<typeof userAvatarSelectionControllerGetMySelection>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userAvatarSelectionControllerGetMySelection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current user's avatar selection
 */

export function useUserAvatarSelectionControllerGetMySelection<TData = Awaited<ReturnType<typeof userAvatarSelectionControllerGetMySelection>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userAvatarSelectionControllerGetMySelection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserAvatarSelectionControllerGetMySelectionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useUserAvatarSelectionControllerGetMySelection} query
 */
export const invalidateUserAvatarSelectionControllerGetMySelection = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getUserAvatarSelectionControllerGetMySelectionQueryKey() }, options);

  return queryClient;
}

/**
 * @summary Get current user's avatar selection
 */
export const useSetUserAvatarSelectionControllerGetMySelectionQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof userAvatarSelectionControllerGetMySelection>> | undefined | ((old: Awaited<ReturnType<typeof userAvatarSelectionControllerGetMySelection>> | undefined) => Awaited<ReturnType<typeof userAvatarSelectionControllerGetMySelection>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof userAvatarSelectionControllerGetMySelection>>>({ exact: $exactMatch, queryKey: getUserAvatarSelectionControllerGetMySelectionQueryKey() }, updater);
  };
}

/**
 * @summary Get current user's avatar selection
 */
export const useGetUserAvatarSelectionControllerGetMySelectionQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof userAvatarSelectionControllerGetMySelection>>>(getUserAvatarSelectionControllerGetMySelectionQueryKey());
}



/**
 * @summary Equip an owned item into its avatar slot
 */
export const userAvatarSelectionControllerEquipItem = (
    equipItemDto: BodyType<EquipItemDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserAvatarSelectionControllerEquipItem201>(
      {url: `/user-avatar-selection/me/equip`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: equipItemDto, signal
    },
      options);
    }




export const getUserAvatarSelectionControllerEquipItemMutationKey = () => ['userAvatarSelectionControllerEquipItem'] as const;

export const getUserAvatarSelectionControllerEquipItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userAvatarSelectionControllerEquipItem>>, TError,UserAvatarSelectionControllerEquipItemMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userAvatarSelectionControllerEquipItem>>, TError,UserAvatarSelectionControllerEquipItemMutationVariables, TContext> => {

const mutationKey = getUserAvatarSelectionControllerEquipItemMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userAvatarSelectionControllerEquipItem>>, UserAvatarSelectionControllerEquipItemMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  userAvatarSelectionControllerEquipItem(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserAvatarSelectionControllerEquipItemMutationResult = NonNullable<Awaited<ReturnType<typeof userAvatarSelectionControllerEquipItem>>>
    export type UserAvatarSelectionControllerEquipItemMutationBody = BodyType<EquipItemDto>
    export type UserAvatarSelectionControllerEquipItemMutationError = ErrorType<unknown>
    export type UserAvatarSelectionControllerEquipItemMutationVariables = {data: BodyType<EquipItemDto>}

    /**
 * @summary Equip an owned item into its avatar slot
 */
export const useUserAvatarSelectionControllerEquipItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userAvatarSelectionControllerEquipItem>>, TError,UserAvatarSelectionControllerEquipItemMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userAvatarSelectionControllerEquipItem>>,
        TError,
        UserAvatarSelectionControllerEquipItemMutationVariables,
        TContext
      > => {
      return useMutation(getUserAvatarSelectionControllerEquipItemMutationOptions(options), queryClient);
    }

/**
 * @summary Create an item (Admin)
 */
export const itemControllerCreate = (
    createItemDto: BodyType<CreateItemDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ItemControllerCreate201>(
      {url: `/items`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createItemDto, signal
    },
      options);
    }




export const getItemControllerCreateMutationKey = () => ['itemControllerCreate'] as const;

export const getItemControllerCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof itemControllerCreate>>, TError,ItemControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof itemControllerCreate>>, TError,ItemControllerCreateMutationVariables, TContext> => {

const mutationKey = getItemControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof itemControllerCreate>>, ItemControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  itemControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ItemControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof itemControllerCreate>>>
    export type ItemControllerCreateMutationBody = BodyType<CreateItemDto>
    export type ItemControllerCreateMutationError = ErrorType<unknown>
    export type ItemControllerCreateMutationVariables = {data: BodyType<CreateItemDto>}

    /**
 * @summary Create an item (Admin)
 */
export const useItemControllerCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof itemControllerCreate>>, TError,ItemControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof itemControllerCreate>>,
        TError,
        ItemControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getItemControllerCreateMutationOptions(options), queryClient);
    }

/**
 * @summary Get items. Admin: category optional. Others: category required.
 */
export const itemControllerFindAll = (
    params?: ItemControllerFindAllParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ItemControllerFindAll200Item[]>(
      {url: `/items`, method: 'GET',
        params, signal
    },
      options);
    }




export const getItemControllerFindAllQueryKey = (params?: ItemControllerFindAllParams,) => {
    return [
    `/items`, ...(params ? [params] : [])
    ] as const;
    }


export const getItemControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof itemControllerFindAll>>, TError = ErrorType<unknown>>(params?: ItemControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof itemControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getItemControllerFindAllQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof itemControllerFindAll>>> = ({ signal }) => itemControllerFindAll(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof itemControllerFindAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ItemControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof itemControllerFindAll>>>
export type ItemControllerFindAllQueryError = ErrorType<unknown>


export function useItemControllerFindAll<TData = Awaited<ReturnType<typeof itemControllerFindAll>>, TError = ErrorType<unknown>>(
 params: undefined |  ItemControllerFindAllParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof itemControllerFindAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof itemControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof itemControllerFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useItemControllerFindAll<TData = Awaited<ReturnType<typeof itemControllerFindAll>>, TError = ErrorType<unknown>>(
 params?: ItemControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof itemControllerFindAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof itemControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof itemControllerFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useItemControllerFindAll<TData = Awaited<ReturnType<typeof itemControllerFindAll>>, TError = ErrorType<unknown>>(
 params?: ItemControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof itemControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get items. Admin: category optional. Others: category required.
 */

export function useItemControllerFindAll<TData = Awaited<ReturnType<typeof itemControllerFindAll>>, TError = ErrorType<unknown>>(
 params?: ItemControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof itemControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getItemControllerFindAllQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useItemControllerFindAll} query
 */
export const invalidateItemControllerFindAll = async (
 queryClient: QueryClient, params?: ItemControllerFindAllParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getItemControllerFindAllQueryKey(params) }, options);

  return queryClient;
}

/**
 * @summary Get items. Admin: category optional. Others: category required.
 */
export const useSetItemControllerFindAllQueryData = () => {
  const queryClient = useQueryClient();
  return (params: ItemControllerFindAllParams | undefined,updater: Awaited<ReturnType<typeof itemControllerFindAll>> | undefined | ((old: Awaited<ReturnType<typeof itemControllerFindAll>> | undefined) => Awaited<ReturnType<typeof itemControllerFindAll>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof itemControllerFindAll>>>({ exact: $exactMatch, queryKey: getItemControllerFindAllQueryKey(params) }, updater);
  };
}

/**
 * @summary Get items. Admin: category optional. Others: category required.
 */
export const useGetItemControllerFindAllQueryData = () => {
  const queryClient = useQueryClient();
  return (params?: ItemControllerFindAllParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof itemControllerFindAll>>>(getItemControllerFindAllQueryKey(params));
}



/**
 * @summary Get an item by id
 */
export const itemControllerFindOne = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ItemControllerFindOne200>(
      {url: `/items/${id}`, method: 'GET', signal
    },
      options);
    }




export const getItemControllerFindOneQueryKey = (id: string,) => {
    return [
    `/items/${id}`
    ] as const;
    }


export const getItemControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof itemControllerFindOne>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof itemControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getItemControllerFindOneQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof itemControllerFindOne>>> = ({ signal }) => itemControllerFindOne(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof itemControllerFindOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ItemControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof itemControllerFindOne>>>
export type ItemControllerFindOneQueryError = ErrorType<unknown>


export function useItemControllerFindOne<TData = Awaited<ReturnType<typeof itemControllerFindOne>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof itemControllerFindOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof itemControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof itemControllerFindOne>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useItemControllerFindOne<TData = Awaited<ReturnType<typeof itemControllerFindOne>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof itemControllerFindOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof itemControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof itemControllerFindOne>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useItemControllerFindOne<TData = Awaited<ReturnType<typeof itemControllerFindOne>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof itemControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get an item by id
 */

export function useItemControllerFindOne<TData = Awaited<ReturnType<typeof itemControllerFindOne>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof itemControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getItemControllerFindOneQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useItemControllerFindOne} query
 */
export const invalidateItemControllerFindOne = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getItemControllerFindOneQueryKey(id) }, options);

  return queryClient;
}

/**
 * @summary Get an item by id
 */
export const useSetItemControllerFindOneQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof itemControllerFindOne>> | undefined | ((old: Awaited<ReturnType<typeof itemControllerFindOne>> | undefined) => Awaited<ReturnType<typeof itemControllerFindOne>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof itemControllerFindOne>>>({ exact: $exactMatch, queryKey: getItemControllerFindOneQueryKey(id) }, updater);
  };
}

/**
 * @summary Get an item by id
 */
export const useGetItemControllerFindOneQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof itemControllerFindOne>>>(getItemControllerFindOneQueryKey(id));
}



/**
 * @summary Update an item (Admin)
 */
export const itemControllerUpdate = (
    id: string,
    updateItemDto: BodyType<UpdateItemDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ItemControllerUpdate200>(
      {url: `/items/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateItemDto, signal
    },
      options);
    }




export const getItemControllerUpdateMutationKey = () => ['itemControllerUpdate'] as const;

export const getItemControllerUpdateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof itemControllerUpdate>>, TError,ItemControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof itemControllerUpdate>>, TError,ItemControllerUpdateMutationVariables, TContext> => {

const mutationKey = getItemControllerUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof itemControllerUpdate>>, ItemControllerUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  itemControllerUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ItemControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof itemControllerUpdate>>>
    export type ItemControllerUpdateMutationBody = BodyType<UpdateItemDto>
    export type ItemControllerUpdateMutationError = ErrorType<unknown>
    export type ItemControllerUpdateMutationVariables = {id: string;data: BodyType<UpdateItemDto>}

    /**
 * @summary Update an item (Admin)
 */
export const useItemControllerUpdate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof itemControllerUpdate>>, TError,ItemControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof itemControllerUpdate>>,
        TError,
        ItemControllerUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getItemControllerUpdateMutationOptions(options), queryClient);
    }

/**
 * @summary Delete an item (Admin)
 */
export const itemControllerDelete = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/items/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getItemControllerDeleteMutationKey = () => ['itemControllerDelete'] as const;

export const getItemControllerDeleteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof itemControllerDelete>>, TError,ItemControllerDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof itemControllerDelete>>, TError,ItemControllerDeleteMutationVariables, TContext> => {

const mutationKey = getItemControllerDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof itemControllerDelete>>, ItemControllerDeleteMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  itemControllerDelete(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ItemControllerDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof itemControllerDelete>>>

    export type ItemControllerDeleteMutationError = ErrorType<unknown>
    export type ItemControllerDeleteMutationVariables = {id: string}

    /**
 * @summary Delete an item (Admin)
 */
export const useItemControllerDelete = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof itemControllerDelete>>, TError,ItemControllerDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof itemControllerDelete>>,
        TError,
        ItemControllerDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getItemControllerDeleteMutationOptions(options), queryClient);
    }

/**
 * @summary Upload item image to GCS (Admin)
 */
export const itemControllerUploadImage = (
    category: 'AVATAR' | 'AVATAR_HEAD_ACCESSORY' | 'AVATAR_BACKGROUND',
    itemControllerUploadImageBody: BodyType<ItemControllerUploadImageBody>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {

      const formData = new FormData();
if(itemControllerUploadImageBody.file !== undefined) {
 formData.append(`file`, itemControllerUploadImageBody.file);
 }

      return customInstance<void>(
      {url: `/items/upload-image/${category}`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getItemControllerUploadImageMutationKey = () => ['itemControllerUploadImage'] as const;

export const getItemControllerUploadImageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof itemControllerUploadImage>>, TError,ItemControllerUploadImageMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof itemControllerUploadImage>>, TError,ItemControllerUploadImageMutationVariables, TContext> => {

const mutationKey = getItemControllerUploadImageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof itemControllerUploadImage>>, ItemControllerUploadImageMutationVariables> = (props) => {
          const {category,data} = props ?? {};

          return  itemControllerUploadImage(category,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ItemControllerUploadImageMutationResult = NonNullable<Awaited<ReturnType<typeof itemControllerUploadImage>>>
    export type ItemControllerUploadImageMutationBody = BodyType<ItemControllerUploadImageBody>
    export type ItemControllerUploadImageMutationError = ErrorType<unknown>
    export type ItemControllerUploadImageMutationVariables = {category: 'AVATAR' | 'AVATAR_HEAD_ACCESSORY' | 'AVATAR_BACKGROUND';data: BodyType<ItemControllerUploadImageBody>}

    /**
 * @summary Upload item image to GCS (Admin)
 */
export const useItemControllerUploadImage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof itemControllerUploadImage>>, TError,ItemControllerUploadImageMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof itemControllerUploadImage>>,
        TError,
        ItemControllerUploadImageMutationVariables,
        TContext
      > => {
      return useMutation(getItemControllerUploadImageMutationOptions(options), queryClient);
    }

/**
 * @summary Get current user inventory items, optionally filtered by category
 */
export const userInventoryControllerGetUserItems = (
    params?: UserInventoryControllerGetUserItemsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserInventoryControllerGetUserItems200Item[]>(
      {url: `/user-inventory/me/items`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUserInventoryControllerGetUserItemsQueryKey = (params?: UserInventoryControllerGetUserItemsParams,) => {
    return [
    `/user-inventory/me/items`, ...(params ? [params] : [])
    ] as const;
    }


export const getUserInventoryControllerGetUserItemsQueryOptions = <TData = Awaited<ReturnType<typeof userInventoryControllerGetUserItems>>, TError = ErrorType<unknown>>(params?: UserInventoryControllerGetUserItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userInventoryControllerGetUserItems>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserInventoryControllerGetUserItemsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userInventoryControllerGetUserItems>>> = ({ signal }) => userInventoryControllerGetUserItems(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userInventoryControllerGetUserItems>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserInventoryControllerGetUserItemsQueryResult = NonNullable<Awaited<ReturnType<typeof userInventoryControllerGetUserItems>>>
export type UserInventoryControllerGetUserItemsQueryError = ErrorType<unknown>


export function useUserInventoryControllerGetUserItems<TData = Awaited<ReturnType<typeof userInventoryControllerGetUserItems>>, TError = ErrorType<unknown>>(
 params: undefined |  UserInventoryControllerGetUserItemsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userInventoryControllerGetUserItems>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userInventoryControllerGetUserItems>>,
          TError,
          Awaited<ReturnType<typeof userInventoryControllerGetUserItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserInventoryControllerGetUserItems<TData = Awaited<ReturnType<typeof userInventoryControllerGetUserItems>>, TError = ErrorType<unknown>>(
 params?: UserInventoryControllerGetUserItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userInventoryControllerGetUserItems>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userInventoryControllerGetUserItems>>,
          TError,
          Awaited<ReturnType<typeof userInventoryControllerGetUserItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserInventoryControllerGetUserItems<TData = Awaited<ReturnType<typeof userInventoryControllerGetUserItems>>, TError = ErrorType<unknown>>(
 params?: UserInventoryControllerGetUserItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userInventoryControllerGetUserItems>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current user inventory items, optionally filtered by category
 */

export function useUserInventoryControllerGetUserItems<TData = Awaited<ReturnType<typeof userInventoryControllerGetUserItems>>, TError = ErrorType<unknown>>(
 params?: UserInventoryControllerGetUserItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userInventoryControllerGetUserItems>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserInventoryControllerGetUserItemsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useUserInventoryControllerGetUserItems} query
 */
export const invalidateUserInventoryControllerGetUserItems = async (
 queryClient: QueryClient, params?: UserInventoryControllerGetUserItemsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getUserInventoryControllerGetUserItemsQueryKey(params) }, options);

  return queryClient;
}

/**
 * @summary Get current user inventory items, optionally filtered by category
 */
export const useSetUserInventoryControllerGetUserItemsQueryData = () => {
  const queryClient = useQueryClient();
  return (params: UserInventoryControllerGetUserItemsParams | undefined,updater: Awaited<ReturnType<typeof userInventoryControllerGetUserItems>> | undefined | ((old: Awaited<ReturnType<typeof userInventoryControllerGetUserItems>> | undefined) => Awaited<ReturnType<typeof userInventoryControllerGetUserItems>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof userInventoryControllerGetUserItems>>>({ exact: $exactMatch, queryKey: getUserInventoryControllerGetUserItemsQueryKey(params) }, updater);
  };
}

/**
 * @summary Get current user inventory items, optionally filtered by category
 */
export const useGetUserInventoryControllerGetUserItemsQueryData = () => {
  const queryClient = useQueryClient();
  return (params?: UserInventoryControllerGetUserItemsParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof userInventoryControllerGetUserItems>>>(getUserInventoryControllerGetUserItemsQueryKey(params));
}



/**
 * @summary Purchase an item and add it to the user inventory
 */
export const userInventoryControllerPurchaseItem = (
    itemId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserInventoryControllerPurchaseItem201>(
      {url: `/user-inventory/me/items/${itemId}/purchase`, method: 'POST', signal
    },
      options);
    }




export const getUserInventoryControllerPurchaseItemMutationKey = () => ['userInventoryControllerPurchaseItem'] as const;

export const getUserInventoryControllerPurchaseItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userInventoryControllerPurchaseItem>>, TError,UserInventoryControllerPurchaseItemMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userInventoryControllerPurchaseItem>>, TError,UserInventoryControllerPurchaseItemMutationVariables, TContext> => {

const mutationKey = getUserInventoryControllerPurchaseItemMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userInventoryControllerPurchaseItem>>, UserInventoryControllerPurchaseItemMutationVariables> = (props) => {
          const {itemId} = props ?? {};

          return  userInventoryControllerPurchaseItem(itemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserInventoryControllerPurchaseItemMutationResult = NonNullable<Awaited<ReturnType<typeof userInventoryControllerPurchaseItem>>>

    export type UserInventoryControllerPurchaseItemMutationError = ErrorType<unknown>
    export type UserInventoryControllerPurchaseItemMutationVariables = {itemId: string}

    /**
 * @summary Purchase an item and add it to the user inventory
 */
export const useUserInventoryControllerPurchaseItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userInventoryControllerPurchaseItem>>, TError,UserInventoryControllerPurchaseItemMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userInventoryControllerPurchaseItem>>,
        TError,
        UserInventoryControllerPurchaseItemMutationVariables,
        TContext
      > => {
      return useMutation(getUserInventoryControllerPurchaseItemMutationOptions(options), queryClient);
    }

export const userControllerCreate = (
    createUserWithMetadataDto: BodyType<CreateUserWithMetadataDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserWithMetadataDto, signal
    },
      options);
    }




export const getUserControllerCreateMutationKey = () => ['userControllerCreate'] as const;

export const getUserControllerCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerCreate>>, TError,UserControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userControllerCreate>>, TError,UserControllerCreateMutationVariables, TContext> => {

const mutationKey = getUserControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerCreate>>, UserControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  userControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerCreate>>>
    export type UserControllerCreateMutationBody = BodyType<CreateUserWithMetadataDto>
    export type UserControllerCreateMutationError = ErrorType<unknown>
    export type UserControllerCreateMutationVariables = {data: BodyType<CreateUserWithMetadataDto>}

    export const useUserControllerCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerCreate>>, TError,UserControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userControllerCreate>>,
        TError,
        UserControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getUserControllerCreateMutationOptions(options), queryClient);
    }

export const userControllerFindByQuery = (
    params?: UserControllerFindByQueryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/users`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUserControllerFindByQueryQueryKey = (params?: UserControllerFindByQueryParams,) => {
    return [
    `/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getUserControllerFindByQueryQueryOptions = <TData = Awaited<ReturnType<typeof userControllerFindByQuery>>, TError = ErrorType<unknown>>(params?: UserControllerFindByQueryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindByQuery>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerFindByQueryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerFindByQuery>>> = ({ signal }) => userControllerFindByQuery(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerFindByQuery>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserControllerFindByQueryQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerFindByQuery>>>
export type UserControllerFindByQueryQueryError = ErrorType<unknown>


export function useUserControllerFindByQuery<TData = Awaited<ReturnType<typeof userControllerFindByQuery>>, TError = ErrorType<unknown>>(
 params: undefined |  UserControllerFindByQueryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindByQuery>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerFindByQuery>>,
          TError,
          Awaited<ReturnType<typeof userControllerFindByQuery>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerFindByQuery<TData = Awaited<ReturnType<typeof userControllerFindByQuery>>, TError = ErrorType<unknown>>(
 params?: UserControllerFindByQueryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindByQuery>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerFindByQuery>>,
          TError,
          Awaited<ReturnType<typeof userControllerFindByQuery>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerFindByQuery<TData = Awaited<ReturnType<typeof userControllerFindByQuery>>, TError = ErrorType<unknown>>(
 params?: UserControllerFindByQueryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindByQuery>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserControllerFindByQuery<TData = Awaited<ReturnType<typeof userControllerFindByQuery>>, TError = ErrorType<unknown>>(
 params?: UserControllerFindByQueryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindByQuery>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserControllerFindByQueryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useUserControllerFindByQuery} query
 */
export const invalidateUserControllerFindByQuery = async (
 queryClient: QueryClient, params?: UserControllerFindByQueryParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getUserControllerFindByQueryQueryKey(params) }, options);

  return queryClient;
}

export const useSetUserControllerFindByQueryQueryData = () => {
  const queryClient = useQueryClient();
  return (params: UserControllerFindByQueryParams | undefined,updater: Awaited<ReturnType<typeof userControllerFindByQuery>> | undefined | ((old: Awaited<ReturnType<typeof userControllerFindByQuery>> | undefined) => Awaited<ReturnType<typeof userControllerFindByQuery>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof userControllerFindByQuery>>>({ exact: $exactMatch, queryKey: getUserControllerFindByQueryQueryKey(params) }, updater);
  };
}

export const useGetUserControllerFindByQueryQueryData = () => {
  const queryClient = useQueryClient();
  return (params?: UserControllerFindByQueryParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof userControllerFindByQuery>>>(getUserControllerFindByQueryQueryKey(params));
}



export const userControllerCreateWithEmailPassword = (
    createUserFromEmailPasswordWithMetadataDto: BodyType<CreateUserFromEmailPasswordWithMetadataDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/users/create-with-email-and-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserFromEmailPasswordWithMetadataDto, signal
    },
      options);
    }




export const getUserControllerCreateWithEmailPasswordMutationKey = () => ['userControllerCreateWithEmailPassword'] as const;

export const getUserControllerCreateWithEmailPasswordMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerCreateWithEmailPassword>>, TError,UserControllerCreateWithEmailPasswordMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userControllerCreateWithEmailPassword>>, TError,UserControllerCreateWithEmailPasswordMutationVariables, TContext> => {

const mutationKey = getUserControllerCreateWithEmailPasswordMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerCreateWithEmailPassword>>, UserControllerCreateWithEmailPasswordMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  userControllerCreateWithEmailPassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserControllerCreateWithEmailPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerCreateWithEmailPassword>>>
    export type UserControllerCreateWithEmailPasswordMutationBody = BodyType<CreateUserFromEmailPasswordWithMetadataDto>
    export type UserControllerCreateWithEmailPasswordMutationError = ErrorType<unknown>
    export type UserControllerCreateWithEmailPasswordMutationVariables = {data: BodyType<CreateUserFromEmailPasswordWithMetadataDto>}

    export const useUserControllerCreateWithEmailPassword = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerCreateWithEmailPassword>>, TError,UserControllerCreateWithEmailPasswordMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userControllerCreateWithEmailPassword>>,
        TError,
        UserControllerCreateWithEmailPasswordMutationVariables,
        TContext
      > => {
      return useMutation(getUserControllerCreateWithEmailPasswordMutationOptions(options), queryClient);
    }

/**
 * @summary Update current user avatar
 */
export const userControllerUpdateUserAvatar = (
    updateUserAvatarDto: BodyType<UpdateUserAvatarDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserResponseDto>(
      {url: `/users/avatar`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateUserAvatarDto, signal
    },
      options);
    }




export const getUserControllerUpdateUserAvatarMutationKey = () => ['userControllerUpdateUserAvatar'] as const;

export const getUserControllerUpdateUserAvatarMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdateUserAvatar>>, TError,UserControllerUpdateUserAvatarMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdateUserAvatar>>, TError,UserControllerUpdateUserAvatarMutationVariables, TContext> => {

const mutationKey = getUserControllerUpdateUserAvatarMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerUpdateUserAvatar>>, UserControllerUpdateUserAvatarMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  userControllerUpdateUserAvatar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserControllerUpdateUserAvatarMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerUpdateUserAvatar>>>
    export type UserControllerUpdateUserAvatarMutationBody = BodyType<UpdateUserAvatarDto>
    export type UserControllerUpdateUserAvatarMutationError = ErrorType<unknown>
    export type UserControllerUpdateUserAvatarMutationVariables = {data: BodyType<UpdateUserAvatarDto>}

    /**
 * @summary Update current user avatar
 */
export const useUserControllerUpdateUserAvatar = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdateUserAvatar>>, TError,UserControllerUpdateUserAvatarMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userControllerUpdateUserAvatar>>,
        TError,
        UserControllerUpdateUserAvatarMutationVariables,
        TContext
      > => {
      return useMutation(getUserControllerUpdateUserAvatarMutationOptions(options), queryClient);
    }

/**
 * @summary Update user by ID
 */
export const userControllerUpdate = (
    id: string,
    updateUserDto: BodyType<UpdateUserDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserResponseDto>(
      {url: `/users/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateUserDto, signal
    },
      options);
    }




export const getUserControllerUpdateMutationKey = () => ['userControllerUpdate'] as const;

export const getUserControllerUpdateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdate>>, TError,UserControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdate>>, TError,UserControllerUpdateMutationVariables, TContext> => {

const mutationKey = getUserControllerUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerUpdate>>, UserControllerUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  userControllerUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerUpdate>>>
    export type UserControllerUpdateMutationBody = BodyType<UpdateUserDto>
    export type UserControllerUpdateMutationError = ErrorType<unknown>
    export type UserControllerUpdateMutationVariables = {id: string;data: BodyType<UpdateUserDto>}

    /**
 * @summary Update user by ID
 */
export const useUserControllerUpdate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdate>>, TError,UserControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userControllerUpdate>>,
        TError,
        UserControllerUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getUserControllerUpdateMutationOptions(options), queryClient);
    }

export const userControllerFindById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/users/${id}`, method: 'GET', signal
    },
      options);
    }




export const getUserControllerFindByIdQueryKey = (id: string,) => {
    return [
    `/users/${id}`
    ] as const;
    }


export const getUserControllerFindByIdQueryOptions = <TData = Awaited<ReturnType<typeof userControllerFindById>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerFindByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerFindById>>> = ({ signal }) => userControllerFindById(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerFindById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserControllerFindByIdQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerFindById>>>
export type UserControllerFindByIdQueryError = ErrorType<unknown>


export function useUserControllerFindById<TData = Awaited<ReturnType<typeof userControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof userControllerFindById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerFindById<TData = Awaited<ReturnType<typeof userControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof userControllerFindById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerFindById<TData = Awaited<ReturnType<typeof userControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserControllerFindById<TData = Awaited<ReturnType<typeof userControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserControllerFindByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useUserControllerFindById} query
 */
export const invalidateUserControllerFindById = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getUserControllerFindByIdQueryKey(id) }, options);

  return queryClient;
}

export const useSetUserControllerFindByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof userControllerFindById>> | undefined | ((old: Awaited<ReturnType<typeof userControllerFindById>> | undefined) => Awaited<ReturnType<typeof userControllerFindById>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof userControllerFindById>>>({ exact: $exactMatch, queryKey: getUserControllerFindByIdQueryKey(id) }, updater);
  };
}

export const useGetUserControllerFindByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof userControllerFindById>>>(getUserControllerFindByIdQueryKey(id));
}



export const userControllerDeleteById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/users/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getUserControllerDeleteByIdMutationKey = () => ['userControllerDeleteById'] as const;

export const getUserControllerDeleteByIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerDeleteById>>, TError,UserControllerDeleteByIdMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userControllerDeleteById>>, TError,UserControllerDeleteByIdMutationVariables, TContext> => {

const mutationKey = getUserControllerDeleteByIdMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerDeleteById>>, UserControllerDeleteByIdMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  userControllerDeleteById(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserControllerDeleteByIdMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerDeleteById>>>

    export type UserControllerDeleteByIdMutationError = ErrorType<unknown>
    export type UserControllerDeleteByIdMutationVariables = {id: string}

    export const useUserControllerDeleteById = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerDeleteById>>, TError,UserControllerDeleteByIdMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userControllerDeleteById>>,
        TError,
        UserControllerDeleteByIdMutationVariables,
        TContext
      > => {
      return useMutation(getUserControllerDeleteByIdMutationOptions(options), queryClient);
    }

/**
 * @summary Get current user
 */
export const userControllerGetMe = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserResponseDto>(
      {url: `/users/me`, method: 'GET', signal
    },
      options);
    }




export const getUserControllerGetMeQueryKey = () => {
    return [
    `/users/me`
    ] as const;
    }


export const getUserControllerGetMeQueryOptions = <TData = Awaited<ReturnType<typeof userControllerGetMe>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerGetMe>>> = ({ signal }) => userControllerGetMe(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserControllerGetMeQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerGetMe>>>
export type UserControllerGetMeQueryError = ErrorType<unknown>


export function useUserControllerGetMe<TData = Awaited<ReturnType<typeof userControllerGetMe>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetMe>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetMe<TData = Awaited<ReturnType<typeof userControllerGetMe>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetMe>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetMe<TData = Awaited<ReturnType<typeof userControllerGetMe>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current user
 */

export function useUserControllerGetMe<TData = Awaited<ReturnType<typeof userControllerGetMe>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserControllerGetMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useUserControllerGetMe} query
 */
export const invalidateUserControllerGetMe = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getUserControllerGetMeQueryKey() }, options);

  return queryClient;
}

/**
 * @summary Get current user
 */
export const useSetUserControllerGetMeQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof userControllerGetMe>> | undefined | ((old: Awaited<ReturnType<typeof userControllerGetMe>> | undefined) => Awaited<ReturnType<typeof userControllerGetMe>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof userControllerGetMe>>>({ exact: $exactMatch, queryKey: getUserControllerGetMeQueryKey() }, updater);
  };
}

/**
 * @summary Get current user
 */
export const useGetUserControllerGetMeQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof userControllerGetMe>>>(getUserControllerGetMeQueryKey());
}



/**
 * @summary Get current user metadata
 */
export const userControllerGetMyMetadata = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserMetadataResponseDto>(
      {url: `/users/me/metadata`, method: 'GET', signal
    },
      options);
    }




export const getUserControllerGetMyMetadataQueryKey = () => {
    return [
    `/users/me/metadata`
    ] as const;
    }


export const getUserControllerGetMyMetadataQueryOptions = <TData = Awaited<ReturnType<typeof userControllerGetMyMetadata>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMyMetadata>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerGetMyMetadataQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerGetMyMetadata>>> = ({ signal }) => userControllerGetMyMetadata(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMyMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserControllerGetMyMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerGetMyMetadata>>>
export type UserControllerGetMyMetadataQueryError = ErrorType<unknown>


export function useUserControllerGetMyMetadata<TData = Awaited<ReturnType<typeof userControllerGetMyMetadata>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMyMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetMyMetadata>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetMyMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetMyMetadata<TData = Awaited<ReturnType<typeof userControllerGetMyMetadata>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMyMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetMyMetadata>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetMyMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetMyMetadata<TData = Awaited<ReturnType<typeof userControllerGetMyMetadata>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMyMetadata>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current user metadata
 */

export function useUserControllerGetMyMetadata<TData = Awaited<ReturnType<typeof userControllerGetMyMetadata>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetMyMetadata>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserControllerGetMyMetadataQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useUserControllerGetMyMetadata} query
 */
export const invalidateUserControllerGetMyMetadata = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getUserControllerGetMyMetadataQueryKey() }, options);

  return queryClient;
}

/**
 * @summary Get current user metadata
 */
export const useSetUserControllerGetMyMetadataQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof userControllerGetMyMetadata>> | undefined | ((old: Awaited<ReturnType<typeof userControllerGetMyMetadata>> | undefined) => Awaited<ReturnType<typeof userControllerGetMyMetadata>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof userControllerGetMyMetadata>>>({ exact: $exactMatch, queryKey: getUserControllerGetMyMetadataQueryKey() }, updater);
  };
}

/**
 * @summary Get current user metadata
 */
export const useGetUserControllerGetMyMetadataQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof userControllerGetMyMetadata>>>(getUserControllerGetMyMetadataQueryKey());
}



/**
 * @summary Update current user metadata
 */
export const userControllerUpdateMyMetadata = (
    updateUserMetadataForMeDto: BodyType<UpdateUserMetadataForMeDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserMetadataResponseDto>(
      {url: `/users/me/metadata`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateUserMetadataForMeDto, signal
    },
      options);
    }




export const getUserControllerUpdateMyMetadataMutationKey = () => ['userControllerUpdateMyMetadata'] as const;

export const getUserControllerUpdateMyMetadataMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdateMyMetadata>>, TError,UserControllerUpdateMyMetadataMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdateMyMetadata>>, TError,UserControllerUpdateMyMetadataMutationVariables, TContext> => {

const mutationKey = getUserControllerUpdateMyMetadataMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerUpdateMyMetadata>>, UserControllerUpdateMyMetadataMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  userControllerUpdateMyMetadata(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserControllerUpdateMyMetadataMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerUpdateMyMetadata>>>
    export type UserControllerUpdateMyMetadataMutationBody = BodyType<UpdateUserMetadataForMeDto>
    export type UserControllerUpdateMyMetadataMutationError = ErrorType<unknown>
    export type UserControllerUpdateMyMetadataMutationVariables = {data: BodyType<UpdateUserMetadataForMeDto>}

    /**
 * @summary Update current user metadata
 */
export const useUserControllerUpdateMyMetadata = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdateMyMetadata>>, TError,UserControllerUpdateMyMetadataMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userControllerUpdateMyMetadata>>,
        TError,
        UserControllerUpdateMyMetadataMutationVariables,
        TContext
      > => {
      return useMutation(getUserControllerUpdateMyMetadataMutationOptions(options), queryClient);
    }

export const userControllerSearchUsers = (
    params?: UserControllerSearchUsersParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/users/search`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUserControllerSearchUsersQueryKey = (params?: UserControllerSearchUsersParams,) => {
    return [
    `/users/search`, ...(params ? [params] : [])
    ] as const;
    }


export const getUserControllerSearchUsersQueryOptions = <TData = Awaited<ReturnType<typeof userControllerSearchUsers>>, TError = ErrorType<unknown>>(params?: UserControllerSearchUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerSearchUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerSearchUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerSearchUsers>>> = ({ signal }) => userControllerSearchUsers(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerSearchUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserControllerSearchUsersQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerSearchUsers>>>
export type UserControllerSearchUsersQueryError = ErrorType<unknown>


export function useUserControllerSearchUsers<TData = Awaited<ReturnType<typeof userControllerSearchUsers>>, TError = ErrorType<unknown>>(
 params: undefined |  UserControllerSearchUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerSearchUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerSearchUsers>>,
          TError,
          Awaited<ReturnType<typeof userControllerSearchUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerSearchUsers<TData = Awaited<ReturnType<typeof userControllerSearchUsers>>, TError = ErrorType<unknown>>(
 params?: UserControllerSearchUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerSearchUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerSearchUsers>>,
          TError,
          Awaited<ReturnType<typeof userControllerSearchUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerSearchUsers<TData = Awaited<ReturnType<typeof userControllerSearchUsers>>, TError = ErrorType<unknown>>(
 params?: UserControllerSearchUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerSearchUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserControllerSearchUsers<TData = Awaited<ReturnType<typeof userControllerSearchUsers>>, TError = ErrorType<unknown>>(
 params?: UserControllerSearchUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerSearchUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserControllerSearchUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useUserControllerSearchUsers} query
 */
export const invalidateUserControllerSearchUsers = async (
 queryClient: QueryClient, params?: UserControllerSearchUsersParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getUserControllerSearchUsersQueryKey(params) }, options);

  return queryClient;
}

export const useSetUserControllerSearchUsersQueryData = () => {
  const queryClient = useQueryClient();
  return (params: UserControllerSearchUsersParams | undefined,updater: Awaited<ReturnType<typeof userControllerSearchUsers>> | undefined | ((old: Awaited<ReturnType<typeof userControllerSearchUsers>> | undefined) => Awaited<ReturnType<typeof userControllerSearchUsers>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof userControllerSearchUsers>>>({ exact: $exactMatch, queryKey: getUserControllerSearchUsersQueryKey(params) }, updater);
  };
}

export const useGetUserControllerSearchUsersQueryData = () => {
  const queryClient = useQueryClient();
  return (params?: UserControllerSearchUsersParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof userControllerSearchUsers>>>(getUserControllerSearchUsersQueryKey(params));
}



export const userControllerSearchByCodesOrEmails = (
    searchUsersByCodesOrEmailsDto: BodyType<SearchUsersByCodesOrEmailsDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/users/search-by-codes-or-emails`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: searchUsersByCodesOrEmailsDto, signal
    },
      options);
    }




export const getUserControllerSearchByCodesOrEmailsMutationKey = () => ['userControllerSearchByCodesOrEmails'] as const;

export const getUserControllerSearchByCodesOrEmailsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerSearchByCodesOrEmails>>, TError,UserControllerSearchByCodesOrEmailsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userControllerSearchByCodesOrEmails>>, TError,UserControllerSearchByCodesOrEmailsMutationVariables, TContext> => {

const mutationKey = getUserControllerSearchByCodesOrEmailsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerSearchByCodesOrEmails>>, UserControllerSearchByCodesOrEmailsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  userControllerSearchByCodesOrEmails(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserControllerSearchByCodesOrEmailsMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerSearchByCodesOrEmails>>>
    export type UserControllerSearchByCodesOrEmailsMutationBody = BodyType<SearchUsersByCodesOrEmailsDto>
    export type UserControllerSearchByCodesOrEmailsMutationError = ErrorType<unknown>
    export type UserControllerSearchByCodesOrEmailsMutationVariables = {data: BodyType<SearchUsersByCodesOrEmailsDto>}

    export const useUserControllerSearchByCodesOrEmails = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerSearchByCodesOrEmails>>, TError,UserControllerSearchByCodesOrEmailsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userControllerSearchByCodesOrEmails>>,
        TError,
        UserControllerSearchByCodesOrEmailsMutationVariables,
        TContext
      > => {
      return useMutation(getUserControllerSearchByCodesOrEmailsMutationOptions(options), queryClient);
    }

export const userControllerGetUserClassrooms = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/users/${id}/classrooms`, method: 'GET', signal
    },
      options);
    }




export const getUserControllerGetUserClassroomsQueryKey = (id: string,) => {
    return [
    `/users/${id}/classrooms`
    ] as const;
    }


export const getUserControllerGetUserClassroomsQueryOptions = <TData = Awaited<ReturnType<typeof userControllerGetUserClassrooms>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserClassrooms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerGetUserClassroomsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerGetUserClassrooms>>> = ({ signal }) => userControllerGetUserClassrooms(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserClassrooms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserControllerGetUserClassroomsQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerGetUserClassrooms>>>
export type UserControllerGetUserClassroomsQueryError = ErrorType<unknown>


export function useUserControllerGetUserClassrooms<TData = Awaited<ReturnType<typeof userControllerGetUserClassrooms>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserClassrooms>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetUserClassrooms>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetUserClassrooms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetUserClassrooms<TData = Awaited<ReturnType<typeof userControllerGetUserClassrooms>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserClassrooms>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetUserClassrooms>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetUserClassrooms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetUserClassrooms<TData = Awaited<ReturnType<typeof userControllerGetUserClassrooms>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserClassrooms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserControllerGetUserClassrooms<TData = Awaited<ReturnType<typeof userControllerGetUserClassrooms>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserClassrooms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserControllerGetUserClassroomsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useUserControllerGetUserClassrooms} query
 */
export const invalidateUserControllerGetUserClassrooms = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getUserControllerGetUserClassroomsQueryKey(id) }, options);

  return queryClient;
}

export const useSetUserControllerGetUserClassroomsQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof userControllerGetUserClassrooms>> | undefined | ((old: Awaited<ReturnType<typeof userControllerGetUserClassrooms>> | undefined) => Awaited<ReturnType<typeof userControllerGetUserClassrooms>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof userControllerGetUserClassrooms>>>({ exact: $exactMatch, queryKey: getUserControllerGetUserClassroomsQueryKey(id) }, updater);
  };
}

export const useGetUserControllerGetUserClassroomsQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof userControllerGetUserClassrooms>>>(getUserControllerGetUserClassroomsQueryKey(id));
}



/**
 * @summary Get available user avatars
 */
export const userControllerGetUserAvatars = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserAvatarsResponseDto>(
      {url: `/users/avatars`, method: 'GET', signal
    },
      options);
    }




export const getUserControllerGetUserAvatarsQueryKey = () => {
    return [
    `/users/avatars`
    ] as const;
    }


export const getUserControllerGetUserAvatarsQueryOptions = <TData = Awaited<ReturnType<typeof userControllerGetUserAvatars>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserAvatars>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerGetUserAvatarsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerGetUserAvatars>>> = ({ signal }) => userControllerGetUserAvatars(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserAvatars>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserControllerGetUserAvatarsQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerGetUserAvatars>>>
export type UserControllerGetUserAvatarsQueryError = ErrorType<unknown>


export function useUserControllerGetUserAvatars<TData = Awaited<ReturnType<typeof userControllerGetUserAvatars>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserAvatars>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetUserAvatars>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetUserAvatars>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetUserAvatars<TData = Awaited<ReturnType<typeof userControllerGetUserAvatars>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserAvatars>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetUserAvatars>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetUserAvatars>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetUserAvatars<TData = Awaited<ReturnType<typeof userControllerGetUserAvatars>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserAvatars>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get available user avatars
 */

export function useUserControllerGetUserAvatars<TData = Awaited<ReturnType<typeof userControllerGetUserAvatars>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserAvatars>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserControllerGetUserAvatarsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useUserControllerGetUserAvatars} query
 */
export const invalidateUserControllerGetUserAvatars = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getUserControllerGetUserAvatarsQueryKey() }, options);

  return queryClient;
}

/**
 * @summary Get available user avatars
 */
export const useSetUserControllerGetUserAvatarsQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof userControllerGetUserAvatars>> | undefined | ((old: Awaited<ReturnType<typeof userControllerGetUserAvatars>> | undefined) => Awaited<ReturnType<typeof userControllerGetUserAvatars>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof userControllerGetUserAvatars>>>({ exact: $exactMatch, queryKey: getUserControllerGetUserAvatarsQueryKey() }, updater);
  };
}

/**
 * @summary Get available user avatars
 */
export const useGetUserControllerGetUserAvatarsQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof userControllerGetUserAvatars>>>(getUserControllerGetUserAvatarsQueryKey());
}



/**
 * @summary Get user metadata
 */
export const userControllerGetUserMetadataByUserId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserMetadataResponseDto>(
      {url: `/users/${id}/metadata`, method: 'GET', signal
    },
      options);
    }




export const getUserControllerGetUserMetadataByUserIdQueryKey = (id: string,) => {
    return [
    `/users/${id}/metadata`
    ] as const;
    }


export const getUserControllerGetUserMetadataByUserIdQueryOptions = <TData = Awaited<ReturnType<typeof userControllerGetUserMetadataByUserId>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserMetadataByUserId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerGetUserMetadataByUserIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerGetUserMetadataByUserId>>> = ({ signal }) => userControllerGetUserMetadataByUserId(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserMetadataByUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserControllerGetUserMetadataByUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerGetUserMetadataByUserId>>>
export type UserControllerGetUserMetadataByUserIdQueryError = ErrorType<unknown>


export function useUserControllerGetUserMetadataByUserId<TData = Awaited<ReturnType<typeof userControllerGetUserMetadataByUserId>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserMetadataByUserId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetUserMetadataByUserId>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetUserMetadataByUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetUserMetadataByUserId<TData = Awaited<ReturnType<typeof userControllerGetUserMetadataByUserId>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserMetadataByUserId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetUserMetadataByUserId>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetUserMetadataByUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetUserMetadataByUserId<TData = Awaited<ReturnType<typeof userControllerGetUserMetadataByUserId>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserMetadataByUserId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user metadata
 */

export function useUserControllerGetUserMetadataByUserId<TData = Awaited<ReturnType<typeof userControllerGetUserMetadataByUserId>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserMetadataByUserId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserControllerGetUserMetadataByUserIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useUserControllerGetUserMetadataByUserId} query
 */
export const invalidateUserControllerGetUserMetadataByUserId = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getUserControllerGetUserMetadataByUserIdQueryKey(id) }, options);

  return queryClient;
}

/**
 * @summary Get user metadata
 */
export const useSetUserControllerGetUserMetadataByUserIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof userControllerGetUserMetadataByUserId>> | undefined | ((old: Awaited<ReturnType<typeof userControllerGetUserMetadataByUserId>> | undefined) => Awaited<ReturnType<typeof userControllerGetUserMetadataByUserId>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof userControllerGetUserMetadataByUserId>>>({ exact: $exactMatch, queryKey: getUserControllerGetUserMetadataByUserIdQueryKey(id) }, updater);
  };
}

/**
 * @summary Get user metadata
 */
export const useGetUserControllerGetUserMetadataByUserIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof userControllerGetUserMetadataByUserId>>>(getUserControllerGetUserMetadataByUserIdQueryKey(id));
}



export const userControllerGetUserXP = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EdsyXPResponseDto>(
      {url: `/users/${id}/xp`, method: 'GET', signal
    },
      options);
    }




export const getUserControllerGetUserXPQueryKey = (id: string,) => {
    return [
    `/users/${id}/xp`
    ] as const;
    }


export const getUserControllerGetUserXPQueryOptions = <TData = Awaited<ReturnType<typeof userControllerGetUserXP>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserXP>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerGetUserXPQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerGetUserXP>>> = ({ signal }) => userControllerGetUserXP(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserXP>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserControllerGetUserXPQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerGetUserXP>>>
export type UserControllerGetUserXPQueryError = ErrorType<unknown>


export function useUserControllerGetUserXP<TData = Awaited<ReturnType<typeof userControllerGetUserXP>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserXP>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetUserXP>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetUserXP>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetUserXP<TData = Awaited<ReturnType<typeof userControllerGetUserXP>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserXP>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetUserXP>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetUserXP>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetUserXP<TData = Awaited<ReturnType<typeof userControllerGetUserXP>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserXP>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserControllerGetUserXP<TData = Awaited<ReturnType<typeof userControllerGetUserXP>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserXP>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserControllerGetUserXPQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useUserControllerGetUserXP} query
 */
export const invalidateUserControllerGetUserXP = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getUserControllerGetUserXPQueryKey(id) }, options);

  return queryClient;
}

export const useSetUserControllerGetUserXPQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof userControllerGetUserXP>> | undefined | ((old: Awaited<ReturnType<typeof userControllerGetUserXP>> | undefined) => Awaited<ReturnType<typeof userControllerGetUserXP>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof userControllerGetUserXP>>>({ exact: $exactMatch, queryKey: getUserControllerGetUserXPQueryKey(id) }, updater);
  };
}

export const useGetUserControllerGetUserXPQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof userControllerGetUserXP>>>(getUserControllerGetUserXPQueryKey(id));
}



export const userControllerGetUserCoin = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserCoinResponseDto>(
      {url: `/users/${id}/coin`, method: 'GET', signal
    },
      options);
    }




export const getUserControllerGetUserCoinQueryKey = (id: string,) => {
    return [
    `/users/${id}/coin`
    ] as const;
    }


export const getUserControllerGetUserCoinQueryOptions = <TData = Awaited<ReturnType<typeof userControllerGetUserCoin>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserCoin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerGetUserCoinQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerGetUserCoin>>> = ({ signal }) => userControllerGetUserCoin(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserCoin>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserControllerGetUserCoinQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerGetUserCoin>>>
export type UserControllerGetUserCoinQueryError = ErrorType<unknown>


export function useUserControllerGetUserCoin<TData = Awaited<ReturnType<typeof userControllerGetUserCoin>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserCoin>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetUserCoin>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetUserCoin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetUserCoin<TData = Awaited<ReturnType<typeof userControllerGetUserCoin>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserCoin>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerGetUserCoin>>,
          TError,
          Awaited<ReturnType<typeof userControllerGetUserCoin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerGetUserCoin<TData = Awaited<ReturnType<typeof userControllerGetUserCoin>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserCoin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserControllerGetUserCoin<TData = Awaited<ReturnType<typeof userControllerGetUserCoin>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUserCoin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserControllerGetUserCoinQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useUserControllerGetUserCoin} query
 */
export const invalidateUserControllerGetUserCoin = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getUserControllerGetUserCoinQueryKey(id) }, options);

  return queryClient;
}

export const useSetUserControllerGetUserCoinQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof userControllerGetUserCoin>> | undefined | ((old: Awaited<ReturnType<typeof userControllerGetUserCoin>> | undefined) => Awaited<ReturnType<typeof userControllerGetUserCoin>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof userControllerGetUserCoin>>>({ exact: $exactMatch, queryKey: getUserControllerGetUserCoinQueryKey(id) }, updater);
  };
}

export const useGetUserControllerGetUserCoinQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof userControllerGetUserCoin>>>(getUserControllerGetUserCoinQueryKey(id));
}



export const userMetadataControllerCreate = (
    createUserMetadataDto: BodyType<CreateUserMetadataDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserMetadataControllerCreate201>(
      {url: `/user-metadata`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserMetadataDto, signal
    },
      options);
    }




export const getUserMetadataControllerCreateMutationKey = () => ['userMetadataControllerCreate'] as const;

export const getUserMetadataControllerCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userMetadataControllerCreate>>, TError,UserMetadataControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userMetadataControllerCreate>>, TError,UserMetadataControllerCreateMutationVariables, TContext> => {

const mutationKey = getUserMetadataControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userMetadataControllerCreate>>, UserMetadataControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  userMetadataControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserMetadataControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof userMetadataControllerCreate>>>
    export type UserMetadataControllerCreateMutationBody = BodyType<CreateUserMetadataDto>
    export type UserMetadataControllerCreateMutationError = ErrorType<unknown>
    export type UserMetadataControllerCreateMutationVariables = {data: BodyType<CreateUserMetadataDto>}

    export const useUserMetadataControllerCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userMetadataControllerCreate>>, TError,UserMetadataControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userMetadataControllerCreate>>,
        TError,
        UserMetadataControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getUserMetadataControllerCreateMutationOptions(options), queryClient);
    }

/**
 * @deprecated
 * @summary Use PATCH /users/me/metadata instead
 */
export const userMetadataControllerUpdate = (
    id: string,
    updateUserMetadataDto: BodyType<UpdateUserMetadataDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserMetadataControllerUpdate200>(
      {url: `/user-metadata/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateUserMetadataDto, signal
    },
      options);
    }




export const getUserMetadataControllerUpdateMutationKey = () => ['userMetadataControllerUpdate'] as const;

export const getUserMetadataControllerUpdateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userMetadataControllerUpdate>>, TError,UserMetadataControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userMetadataControllerUpdate>>, TError,UserMetadataControllerUpdateMutationVariables, TContext> => {

const mutationKey = getUserMetadataControllerUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userMetadataControllerUpdate>>, UserMetadataControllerUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  userMetadataControllerUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserMetadataControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof userMetadataControllerUpdate>>>
    export type UserMetadataControllerUpdateMutationBody = BodyType<UpdateUserMetadataDto>
    export type UserMetadataControllerUpdateMutationError = ErrorType<unknown>
    export type UserMetadataControllerUpdateMutationVariables = {id: string;data: BodyType<UpdateUserMetadataDto>}

    /**
 * @deprecated
 * @summary Use PATCH /users/me/metadata instead
 */
export const useUserMetadataControllerUpdate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userMetadataControllerUpdate>>, TError,UserMetadataControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userMetadataControllerUpdate>>,
        TError,
        UserMetadataControllerUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getUserMetadataControllerUpdateMutationOptions(options), queryClient);
    }

/**
 * @deprecated
 * @summary Use GET /users/me/metadata instead
 */
export const userMetadataControllerFindById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserMetadataControllerFindById200>(
      {url: `/user-metadata/${id}`, method: 'GET', signal
    },
      options);
    }




export const getUserMetadataControllerFindByIdQueryKey = (id: string,) => {
    return [
    `/user-metadata/${id}`
    ] as const;
    }


export const getUserMetadataControllerFindByIdQueryOptions = <TData = Awaited<ReturnType<typeof userMetadataControllerFindById>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userMetadataControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserMetadataControllerFindByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userMetadataControllerFindById>>> = ({ signal }) => userMetadataControllerFindById(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userMetadataControllerFindById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserMetadataControllerFindByIdQueryResult = NonNullable<Awaited<ReturnType<typeof userMetadataControllerFindById>>>
export type UserMetadataControllerFindByIdQueryError = ErrorType<unknown>


export function useUserMetadataControllerFindById<TData = Awaited<ReturnType<typeof userMetadataControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userMetadataControllerFindById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userMetadataControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof userMetadataControllerFindById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserMetadataControllerFindById<TData = Awaited<ReturnType<typeof userMetadataControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userMetadataControllerFindById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userMetadataControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof userMetadataControllerFindById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserMetadataControllerFindById<TData = Awaited<ReturnType<typeof userMetadataControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userMetadataControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Use GET /users/me/metadata instead
 */

export function useUserMetadataControllerFindById<TData = Awaited<ReturnType<typeof userMetadataControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userMetadataControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserMetadataControllerFindByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @deprecated
 * @summary Invalidates the {@link useUserMetadataControllerFindById} query
 */
export const invalidateUserMetadataControllerFindById = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getUserMetadataControllerFindByIdQueryKey(id) }, options);

  return queryClient;
}

/**
 * @deprecated
 * @summary Use GET /users/me/metadata instead
 */
export const useSetUserMetadataControllerFindByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof userMetadataControllerFindById>> | undefined | ((old: Awaited<ReturnType<typeof userMetadataControllerFindById>> | undefined) => Awaited<ReturnType<typeof userMetadataControllerFindById>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof userMetadataControllerFindById>>>({ exact: $exactMatch, queryKey: getUserMetadataControllerFindByIdQueryKey(id) }, updater);
  };
}

/**
 * @deprecated
 * @summary Use GET /users/me/metadata instead
 */
export const useGetUserMetadataControllerFindByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof userMetadataControllerFindById>>>(getUserMetadataControllerFindByIdQueryKey(id));
}



/**
 * @summary Create a user action log for the current user
 */
export const userActionLogControllerCreateUserActionLog = (
    createUserActionLogDto: BodyType<CreateUserActionLogDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserActionLog>(
      {url: `/users/me/action-logs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserActionLogDto, signal
    },
      options);
    }




export const getUserActionLogControllerCreateUserActionLogMutationKey = () => ['userActionLogControllerCreateUserActionLog'] as const;

export const getUserActionLogControllerCreateUserActionLogMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userActionLogControllerCreateUserActionLog>>, TError,UserActionLogControllerCreateUserActionLogMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userActionLogControllerCreateUserActionLog>>, TError,UserActionLogControllerCreateUserActionLogMutationVariables, TContext> => {

const mutationKey = getUserActionLogControllerCreateUserActionLogMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userActionLogControllerCreateUserActionLog>>, UserActionLogControllerCreateUserActionLogMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  userActionLogControllerCreateUserActionLog(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserActionLogControllerCreateUserActionLogMutationResult = NonNullable<Awaited<ReturnType<typeof userActionLogControllerCreateUserActionLog>>>
    export type UserActionLogControllerCreateUserActionLogMutationBody = BodyType<CreateUserActionLogDto>
    export type UserActionLogControllerCreateUserActionLogMutationError = ErrorType<unknown>
    export type UserActionLogControllerCreateUserActionLogMutationVariables = {data: BodyType<CreateUserActionLogDto>}

    /**
 * @summary Create a user action log for the current user
 */
export const useUserActionLogControllerCreateUserActionLog = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userActionLogControllerCreateUserActionLog>>, TError,UserActionLogControllerCreateUserActionLogMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userActionLogControllerCreateUserActionLog>>,
        TError,
        UserActionLogControllerCreateUserActionLogMutationVariables,
        TContext
      > => {
      return useMutation(getUserActionLogControllerCreateUserActionLogMutationOptions(options), queryClient);
    }

/**
 * @summary Get action summary for the current user
 */
export const userActionLogControllerGetSummary = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserActionSummaryResponseDto>(
      {url: `/users/me/action-summaries`, method: 'GET', signal
    },
      options);
    }




export const getUserActionLogControllerGetSummaryQueryKey = () => {
    return [
    `/users/me/action-summaries`
    ] as const;
    }


export const getUserActionLogControllerGetSummaryQueryOptions = <TData = Awaited<ReturnType<typeof userActionLogControllerGetSummary>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userActionLogControllerGetSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserActionLogControllerGetSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userActionLogControllerGetSummary>>> = ({ signal }) => userActionLogControllerGetSummary(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userActionLogControllerGetSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserActionLogControllerGetSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof userActionLogControllerGetSummary>>>
export type UserActionLogControllerGetSummaryQueryError = ErrorType<unknown>


export function useUserActionLogControllerGetSummary<TData = Awaited<ReturnType<typeof userActionLogControllerGetSummary>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userActionLogControllerGetSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userActionLogControllerGetSummary>>,
          TError,
          Awaited<ReturnType<typeof userActionLogControllerGetSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserActionLogControllerGetSummary<TData = Awaited<ReturnType<typeof userActionLogControllerGetSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userActionLogControllerGetSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userActionLogControllerGetSummary>>,
          TError,
          Awaited<ReturnType<typeof userActionLogControllerGetSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserActionLogControllerGetSummary<TData = Awaited<ReturnType<typeof userActionLogControllerGetSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userActionLogControllerGetSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get action summary for the current user
 */

export function useUserActionLogControllerGetSummary<TData = Awaited<ReturnType<typeof userActionLogControllerGetSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userActionLogControllerGetSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserActionLogControllerGetSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useUserActionLogControllerGetSummary} query
 */
export const invalidateUserActionLogControllerGetSummary = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getUserActionLogControllerGetSummaryQueryKey() }, options);

  return queryClient;
}

/**
 * @summary Get action summary for the current user
 */
export const useSetUserActionLogControllerGetSummaryQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof userActionLogControllerGetSummary>> | undefined | ((old: Awaited<ReturnType<typeof userActionLogControllerGetSummary>> | undefined) => Awaited<ReturnType<typeof userActionLogControllerGetSummary>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof userActionLogControllerGetSummary>>>({ exact: $exactMatch, queryKey: getUserActionLogControllerGetSummaryQueryKey() }, updater);
  };
}

/**
 * @summary Get action summary for the current user
 */
export const useGetUserActionLogControllerGetSummaryQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof userActionLogControllerGetSummary>>>(getUserActionLogControllerGetSummaryQueryKey());
}



/**
 * @summary Get action summary by type for the current user
 */
export const userActionLogControllerGetSummaryByType = (
    actionType: 'LOGIN' | 'LOGOUT' | 'UPDATE_PROFILE_AVATAR' | 'AVATAR_CUSTOMIZATION_ANNOUNCEMENT_DISMISSED' | 'MIDTERM_AVATAR_CUSTOMIZATION_ANNOUNCEMENT_DISMISSED' | 'BACK_TO_SCHOOL_AVATAR_ANNOUNCEMENT_DISMISSED' | 'BACK_TO_SCHOOL_AVATAR_ANNOUNCEMENT_CTA_CLICKED' | 'SPLASH_SCREEN_SEEN' | 'CLASSROOM_NOTEBOOK_ONBOARDING_DISMISSED' | 'TASK_NOTEBOOK_ONBOARDING_DISMISSED',
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserActionSummaryEntryDto>(
      {url: `/users/me/action-summaries-by-type/${actionType}`, method: 'GET', signal
    },
      options);
    }




export const getUserActionLogControllerGetSummaryByTypeQueryKey = (actionType: 'LOGIN' | 'LOGOUT' | 'UPDATE_PROFILE_AVATAR' | 'AVATAR_CUSTOMIZATION_ANNOUNCEMENT_DISMISSED' | 'MIDTERM_AVATAR_CUSTOMIZATION_ANNOUNCEMENT_DISMISSED' | 'BACK_TO_SCHOOL_AVATAR_ANNOUNCEMENT_DISMISSED' | 'BACK_TO_SCHOOL_AVATAR_ANNOUNCEMENT_CTA_CLICKED' | 'SPLASH_SCREEN_SEEN' | 'CLASSROOM_NOTEBOOK_ONBOARDING_DISMISSED' | 'TASK_NOTEBOOK_ONBOARDING_DISMISSED',) => {
    return [
    `/users/me/action-summaries-by-type/${actionType}`
    ] as const;
    }


export const getUserActionLogControllerGetSummaryByTypeQueryOptions = <TData = Awaited<ReturnType<typeof userActionLogControllerGetSummaryByType>>, TError = ErrorType<unknown>>(actionType: 'LOGIN' | 'LOGOUT' | 'UPDATE_PROFILE_AVATAR' | 'AVATAR_CUSTOMIZATION_ANNOUNCEMENT_DISMISSED' | 'MIDTERM_AVATAR_CUSTOMIZATION_ANNOUNCEMENT_DISMISSED' | 'BACK_TO_SCHOOL_AVATAR_ANNOUNCEMENT_DISMISSED' | 'BACK_TO_SCHOOL_AVATAR_ANNOUNCEMENT_CTA_CLICKED' | 'SPLASH_SCREEN_SEEN' | 'CLASSROOM_NOTEBOOK_ONBOARDING_DISMISSED' | 'TASK_NOTEBOOK_ONBOARDING_DISMISSED', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userActionLogControllerGetSummaryByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserActionLogControllerGetSummaryByTypeQueryKey(actionType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userActionLogControllerGetSummaryByType>>> = ({ signal }) => userActionLogControllerGetSummaryByType(actionType, requestOptions, signal);





   return  { queryKey, queryFn, enabled: actionType !== null && actionType !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userActionLogControllerGetSummaryByType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserActionLogControllerGetSummaryByTypeQueryResult = NonNullable<Awaited<ReturnType<typeof userActionLogControllerGetSummaryByType>>>
export type UserActionLogControllerGetSummaryByTypeQueryError = ErrorType<unknown>


export function useUserActionLogControllerGetSummaryByType<TData = Awaited<ReturnType<typeof userActionLogControllerGetSummaryByType>>, TError = ErrorType<unknown>>(
 actionType: 'LOGIN' | 'LOGOUT' | 'UPDATE_PROFILE_AVATAR' | 'AVATAR_CUSTOMIZATION_ANNOUNCEMENT_DISMISSED' | 'MIDTERM_AVATAR_CUSTOMIZATION_ANNOUNCEMENT_DISMISSED' | 'BACK_TO_SCHOOL_AVATAR_ANNOUNCEMENT_DISMISSED' | 'BACK_TO_SCHOOL_AVATAR_ANNOUNCEMENT_CTA_CLICKED' | 'SPLASH_SCREEN_SEEN' | 'CLASSROOM_NOTEBOOK_ONBOARDING_DISMISSED' | 'TASK_NOTEBOOK_ONBOARDING_DISMISSED', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userActionLogControllerGetSummaryByType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userActionLogControllerGetSummaryByType>>,
          TError,
          Awaited<ReturnType<typeof userActionLogControllerGetSummaryByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserActionLogControllerGetSummaryByType<TData = Awaited<ReturnType<typeof userActionLogControllerGetSummaryByType>>, TError = ErrorType<unknown>>(
 actionType: 'LOGIN' | 'LOGOUT' | 'UPDATE_PROFILE_AVATAR' | 'AVATAR_CUSTOMIZATION_ANNOUNCEMENT_DISMISSED' | 'MIDTERM_AVATAR_CUSTOMIZATION_ANNOUNCEMENT_DISMISSED' | 'BACK_TO_SCHOOL_AVATAR_ANNOUNCEMENT_DISMISSED' | 'BACK_TO_SCHOOL_AVATAR_ANNOUNCEMENT_CTA_CLICKED' | 'SPLASH_SCREEN_SEEN' | 'CLASSROOM_NOTEBOOK_ONBOARDING_DISMISSED' | 'TASK_NOTEBOOK_ONBOARDING_DISMISSED', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userActionLogControllerGetSummaryByType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userActionLogControllerGetSummaryByType>>,
          TError,
          Awaited<ReturnType<typeof userActionLogControllerGetSummaryByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserActionLogControllerGetSummaryByType<TData = Awaited<ReturnType<typeof userActionLogControllerGetSummaryByType>>, TError = ErrorType<unknown>>(
 actionType: 'LOGIN' | 'LOGOUT' | 'UPDATE_PROFILE_AVATAR' | 'AVATAR_CUSTOMIZATION_ANNOUNCEMENT_DISMISSED' | 'MIDTERM_AVATAR_CUSTOMIZATION_ANNOUNCEMENT_DISMISSED' | 'BACK_TO_SCHOOL_AVATAR_ANNOUNCEMENT_DISMISSED' | 'BACK_TO_SCHOOL_AVATAR_ANNOUNCEMENT_CTA_CLICKED' | 'SPLASH_SCREEN_SEEN' | 'CLASSROOM_NOTEBOOK_ONBOARDING_DISMISSED' | 'TASK_NOTEBOOK_ONBOARDING_DISMISSED', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userActionLogControllerGetSummaryByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get action summary by type for the current user
 */

export function useUserActionLogControllerGetSummaryByType<TData = Awaited<ReturnType<typeof userActionLogControllerGetSummaryByType>>, TError = ErrorType<unknown>>(
 actionType: 'LOGIN' | 'LOGOUT' | 'UPDATE_PROFILE_AVATAR' | 'AVATAR_CUSTOMIZATION_ANNOUNCEMENT_DISMISSED' | 'MIDTERM_AVATAR_CUSTOMIZATION_ANNOUNCEMENT_DISMISSED' | 'BACK_TO_SCHOOL_AVATAR_ANNOUNCEMENT_DISMISSED' | 'BACK_TO_SCHOOL_AVATAR_ANNOUNCEMENT_CTA_CLICKED' | 'SPLASH_SCREEN_SEEN' | 'CLASSROOM_NOTEBOOK_ONBOARDING_DISMISSED' | 'TASK_NOTEBOOK_ONBOARDING_DISMISSED', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userActionLogControllerGetSummaryByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserActionLogControllerGetSummaryByTypeQueryOptions(actionType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useUserActionLogControllerGetSummaryByType} query
 */
export const invalidateUserActionLogControllerGetSummaryByType = async (
 queryClient: QueryClient, actionType: 'LOGIN' | 'LOGOUT' | 'UPDATE_PROFILE_AVATAR' | 'AVATAR_CUSTOMIZATION_ANNOUNCEMENT_DISMISSED' | 'MIDTERM_AVATAR_CUSTOMIZATION_ANNOUNCEMENT_DISMISSED' | 'BACK_TO_SCHOOL_AVATAR_ANNOUNCEMENT_DISMISSED' | 'BACK_TO_SCHOOL_AVATAR_ANNOUNCEMENT_CTA_CLICKED' | 'SPLASH_SCREEN_SEEN' | 'CLASSROOM_NOTEBOOK_ONBOARDING_DISMISSED' | 'TASK_NOTEBOOK_ONBOARDING_DISMISSED', options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getUserActionLogControllerGetSummaryByTypeQueryKey(actionType) }, options);

  return queryClient;
}

/**
 * @summary Get action summary by type for the current user
 */
export const useSetUserActionLogControllerGetSummaryByTypeQueryData = () => {
  const queryClient = useQueryClient();
  return (actionType: 'LOGIN' | 'LOGOUT' | 'UPDATE_PROFILE_AVATAR' | 'AVATAR_CUSTOMIZATION_ANNOUNCEMENT_DISMISSED' | 'MIDTERM_AVATAR_CUSTOMIZATION_ANNOUNCEMENT_DISMISSED' | 'BACK_TO_SCHOOL_AVATAR_ANNOUNCEMENT_DISMISSED' | 'BACK_TO_SCHOOL_AVATAR_ANNOUNCEMENT_CTA_CLICKED' | 'SPLASH_SCREEN_SEEN' | 'CLASSROOM_NOTEBOOK_ONBOARDING_DISMISSED' | 'TASK_NOTEBOOK_ONBOARDING_DISMISSED',updater: Awaited<ReturnType<typeof userActionLogControllerGetSummaryByType>> | undefined | ((old: Awaited<ReturnType<typeof userActionLogControllerGetSummaryByType>> | undefined) => Awaited<ReturnType<typeof userActionLogControllerGetSummaryByType>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof userActionLogControllerGetSummaryByType>>>({ exact: $exactMatch, queryKey: getUserActionLogControllerGetSummaryByTypeQueryKey(actionType) }, updater);
  };
}

/**
 * @summary Get action summary by type for the current user
 */
export const useGetUserActionLogControllerGetSummaryByTypeQueryData = () => {
  const queryClient = useQueryClient();
  return (actionType: 'LOGIN' | 'LOGOUT' | 'UPDATE_PROFILE_AVATAR' | 'AVATAR_CUSTOMIZATION_ANNOUNCEMENT_DISMISSED' | 'MIDTERM_AVATAR_CUSTOMIZATION_ANNOUNCEMENT_DISMISSED' | 'BACK_TO_SCHOOL_AVATAR_ANNOUNCEMENT_DISMISSED' | 'BACK_TO_SCHOOL_AVATAR_ANNOUNCEMENT_CTA_CLICKED' | 'SPLASH_SCREEN_SEEN' | 'CLASSROOM_NOTEBOOK_ONBOARDING_DISMISSED' | 'TASK_NOTEBOOK_ONBOARDING_DISMISSED',) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof userActionLogControllerGetSummaryByType>>>(getUserActionLogControllerGetSummaryByTypeQueryKey(actionType));
}



/**
 * @summary Preview recursive deletion of a lesson
 */
export const lessonDeletionControllerPreview = (
    lessonId: string,
    params: LessonDeletionControllerPreviewParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LessonDeletionPreviewResponseDto>(
      {url: `/lessons/${lessonId}/deletion-preview`, method: 'GET',
        params, signal
    },
      options);
    }




export const getLessonDeletionControllerPreviewQueryKey = (lessonId: string,
    params?: LessonDeletionControllerPreviewParams,) => {
    return [
    `/lessons/${lessonId}/deletion-preview`, ...(params ? [params] : [])
    ] as const;
    }


export const getLessonDeletionControllerPreviewQueryOptions = <TData = Awaited<ReturnType<typeof lessonDeletionControllerPreview>>, TError = ErrorType<unknown>>(lessonId: string,
    params: LessonDeletionControllerPreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonDeletionControllerPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLessonDeletionControllerPreviewQueryKey(lessonId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lessonDeletionControllerPreview>>> = ({ signal }) => lessonDeletionControllerPreview(lessonId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: lessonId !== null && lessonId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lessonDeletionControllerPreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LessonDeletionControllerPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof lessonDeletionControllerPreview>>>
export type LessonDeletionControllerPreviewQueryError = ErrorType<unknown>


export function useLessonDeletionControllerPreview<TData = Awaited<ReturnType<typeof lessonDeletionControllerPreview>>, TError = ErrorType<unknown>>(
 lessonId: string,
    params: LessonDeletionControllerPreviewParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonDeletionControllerPreview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonDeletionControllerPreview>>,
          TError,
          Awaited<ReturnType<typeof lessonDeletionControllerPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonDeletionControllerPreview<TData = Awaited<ReturnType<typeof lessonDeletionControllerPreview>>, TError = ErrorType<unknown>>(
 lessonId: string,
    params: LessonDeletionControllerPreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonDeletionControllerPreview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonDeletionControllerPreview>>,
          TError,
          Awaited<ReturnType<typeof lessonDeletionControllerPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonDeletionControllerPreview<TData = Awaited<ReturnType<typeof lessonDeletionControllerPreview>>, TError = ErrorType<unknown>>(
 lessonId: string,
    params: LessonDeletionControllerPreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonDeletionControllerPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Preview recursive deletion of a lesson
 */

export function useLessonDeletionControllerPreview<TData = Awaited<ReturnType<typeof lessonDeletionControllerPreview>>, TError = ErrorType<unknown>>(
 lessonId: string,
    params: LessonDeletionControllerPreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonDeletionControllerPreview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLessonDeletionControllerPreviewQueryOptions(lessonId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLessonDeletionControllerPreview} query
 */
export const invalidateLessonDeletionControllerPreview = async (
 queryClient: QueryClient, lessonId: string,
    params: LessonDeletionControllerPreviewParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLessonDeletionControllerPreviewQueryKey(lessonId,params) }, options);

  return queryClient;
}

/**
 * @summary Preview recursive deletion of a lesson
 */
export const useSetLessonDeletionControllerPreviewQueryData = () => {
  const queryClient = useQueryClient();
  return (lessonId: string,
    params: LessonDeletionControllerPreviewParams | undefined,updater: Awaited<ReturnType<typeof lessonDeletionControllerPreview>> | undefined | ((old: Awaited<ReturnType<typeof lessonDeletionControllerPreview>> | undefined) => Awaited<ReturnType<typeof lessonDeletionControllerPreview>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof lessonDeletionControllerPreview>>>({ exact: $exactMatch, queryKey: getLessonDeletionControllerPreviewQueryKey(lessonId,params) }, updater);
  };
}

/**
 * @summary Preview recursive deletion of a lesson
 */
export const useGetLessonDeletionControllerPreviewQueryData = () => {
  const queryClient = useQueryClient();
  return (lessonId: string,
    params: LessonDeletionControllerPreviewParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof lessonDeletionControllerPreview>>>(getLessonDeletionControllerPreviewQueryKey(lessonId,params));
}



/**
 * @summary Execute recursive deletion of a lesson
 */
export const lessonDeletionControllerExecute = (
    lessonId: string,
    executeLessonDeletionDto: BodyType<ExecuteLessonDeletionDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LessonDeletionExecutionResponseDto>(
      {url: `/lessons/${lessonId}/delete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: executeLessonDeletionDto, signal
    },
      options);
    }




export const getLessonDeletionControllerExecuteMutationKey = () => ['lessonDeletionControllerExecute'] as const;

export const getLessonDeletionControllerExecuteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonDeletionControllerExecute>>, TError,LessonDeletionControllerExecuteMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof lessonDeletionControllerExecute>>, TError,LessonDeletionControllerExecuteMutationVariables, TContext> => {

const mutationKey = getLessonDeletionControllerExecuteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof lessonDeletionControllerExecute>>, LessonDeletionControllerExecuteMutationVariables> = (props) => {
          const {lessonId,data} = props ?? {};

          return  lessonDeletionControllerExecute(lessonId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LessonDeletionControllerExecuteMutationResult = NonNullable<Awaited<ReturnType<typeof lessonDeletionControllerExecute>>>
    export type LessonDeletionControllerExecuteMutationBody = BodyType<ExecuteLessonDeletionDto>
    export type LessonDeletionControllerExecuteMutationError = ErrorType<unknown>
    export type LessonDeletionControllerExecuteMutationVariables = {lessonId: string;data: BodyType<ExecuteLessonDeletionDto>}

    /**
 * @summary Execute recursive deletion of a lesson
 */
export const useLessonDeletionControllerExecute = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonDeletionControllerExecute>>, TError,LessonDeletionControllerExecuteMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof lessonDeletionControllerExecute>>,
        TError,
        LessonDeletionControllerExecuteMutationVariables,
        TContext
      > => {
      return useMutation(getLessonDeletionControllerExecuteMutationOptions(options), queryClient);
    }

export const viewClassroomLessonSummaryControllerFind = (
    params?: ViewClassroomLessonSummaryControllerFindParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ViewClassroomLessonSummaryControllerFind200Item[]>(
      {url: `/view-collection/view-classroom-lesson-summary`, method: 'GET',
        params, signal
    },
      options);
    }




export const getViewClassroomLessonSummaryControllerFindQueryKey = (params?: ViewClassroomLessonSummaryControllerFindParams,) => {
    return [
    `/view-collection/view-classroom-lesson-summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getViewClassroomLessonSummaryControllerFindQueryOptions = <TData = Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerFind>>, TError = ErrorType<unknown>>(params?: ViewClassroomLessonSummaryControllerFindParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerFind>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getViewClassroomLessonSummaryControllerFindQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerFind>>> = ({ signal }) => viewClassroomLessonSummaryControllerFind(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerFind>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ViewClassroomLessonSummaryControllerFindQueryResult = NonNullable<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerFind>>>
export type ViewClassroomLessonSummaryControllerFindQueryError = ErrorType<unknown>


export function useViewClassroomLessonSummaryControllerFind<TData = Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerFind>>, TError = ErrorType<unknown>>(
 params: undefined |  ViewClassroomLessonSummaryControllerFindParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerFind>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerFind>>,
          TError,
          Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerFind>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useViewClassroomLessonSummaryControllerFind<TData = Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerFind>>, TError = ErrorType<unknown>>(
 params?: ViewClassroomLessonSummaryControllerFindParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerFind>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerFind>>,
          TError,
          Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerFind>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useViewClassroomLessonSummaryControllerFind<TData = Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerFind>>, TError = ErrorType<unknown>>(
 params?: ViewClassroomLessonSummaryControllerFindParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerFind>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useViewClassroomLessonSummaryControllerFind<TData = Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerFind>>, TError = ErrorType<unknown>>(
 params?: ViewClassroomLessonSummaryControllerFindParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerFind>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getViewClassroomLessonSummaryControllerFindQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useViewClassroomLessonSummaryControllerFind} query
 */
export const invalidateViewClassroomLessonSummaryControllerFind = async (
 queryClient: QueryClient, params?: ViewClassroomLessonSummaryControllerFindParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getViewClassroomLessonSummaryControllerFindQueryKey(params) }, options);

  return queryClient;
}

export const useSetViewClassroomLessonSummaryControllerFindQueryData = () => {
  const queryClient = useQueryClient();
  return (params: ViewClassroomLessonSummaryControllerFindParams | undefined,updater: Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerFind>> | undefined | ((old: Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerFind>> | undefined) => Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerFind>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerFind>>>({ exact: $exactMatch, queryKey: getViewClassroomLessonSummaryControllerFindQueryKey(params) }, updater);
  };
}

export const useGetViewClassroomLessonSummaryControllerFindQueryData = () => {
  const queryClient = useQueryClient();
  return (params?: ViewClassroomLessonSummaryControllerFindParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerFind>>>(getViewClassroomLessonSummaryControllerFindQueryKey(params));
}



export const viewClassroomLessonSummaryControllerRefreshViewsForClassroom = (
    params: ViewClassroomLessonSummaryControllerRefreshViewsForClassroomParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/view-collection/view-classroom-lesson-summary/refresh`, method: 'GET',
        params, signal
    },
      options);
    }




export const getViewClassroomLessonSummaryControllerRefreshViewsForClassroomQueryKey = (params?: ViewClassroomLessonSummaryControllerRefreshViewsForClassroomParams,) => {
    return [
    `/view-collection/view-classroom-lesson-summary/refresh`, ...(params ? [params] : [])
    ] as const;
    }


export const getViewClassroomLessonSummaryControllerRefreshViewsForClassroomQueryOptions = <TData = Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroom>>, TError = ErrorType<unknown>>(params: ViewClassroomLessonSummaryControllerRefreshViewsForClassroomParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getViewClassroomLessonSummaryControllerRefreshViewsForClassroomQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroom>>> = ({ signal }) => viewClassroomLessonSummaryControllerRefreshViewsForClassroom(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroom>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ViewClassroomLessonSummaryControllerRefreshViewsForClassroomQueryResult = NonNullable<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroom>>>
export type ViewClassroomLessonSummaryControllerRefreshViewsForClassroomQueryError = ErrorType<unknown>


export function useViewClassroomLessonSummaryControllerRefreshViewsForClassroom<TData = Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroom>>, TError = ErrorType<unknown>>(
 params: ViewClassroomLessonSummaryControllerRefreshViewsForClassroomParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroom>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroom>>,
          TError,
          Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useViewClassroomLessonSummaryControllerRefreshViewsForClassroom<TData = Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroom>>, TError = ErrorType<unknown>>(
 params: ViewClassroomLessonSummaryControllerRefreshViewsForClassroomParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroom>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroom>>,
          TError,
          Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useViewClassroomLessonSummaryControllerRefreshViewsForClassroom<TData = Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroom>>, TError = ErrorType<unknown>>(
 params: ViewClassroomLessonSummaryControllerRefreshViewsForClassroomParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useViewClassroomLessonSummaryControllerRefreshViewsForClassroom<TData = Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroom>>, TError = ErrorType<unknown>>(
 params: ViewClassroomLessonSummaryControllerRefreshViewsForClassroomParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getViewClassroomLessonSummaryControllerRefreshViewsForClassroomQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useViewClassroomLessonSummaryControllerRefreshViewsForClassroom} query
 */
export const invalidateViewClassroomLessonSummaryControllerRefreshViewsForClassroom = async (
 queryClient: QueryClient, params: ViewClassroomLessonSummaryControllerRefreshViewsForClassroomParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getViewClassroomLessonSummaryControllerRefreshViewsForClassroomQueryKey(params) }, options);

  return queryClient;
}

export const useSetViewClassroomLessonSummaryControllerRefreshViewsForClassroomQueryData = () => {
  const queryClient = useQueryClient();
  return (params: ViewClassroomLessonSummaryControllerRefreshViewsForClassroomParams | undefined,updater: Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroom>> | undefined | ((old: Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroom>> | undefined) => Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroom>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroom>>>({ exact: $exactMatch, queryKey: getViewClassroomLessonSummaryControllerRefreshViewsForClassroomQueryKey(params) }, updater);
  };
}

export const useGetViewClassroomLessonSummaryControllerRefreshViewsForClassroomQueryData = () => {
  const queryClient = useQueryClient();
  return (params: ViewClassroomLessonSummaryControllerRefreshViewsForClassroomParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroom>>>(getViewClassroomLessonSummaryControllerRefreshViewsForClassroomQueryKey(params));
}



export const viewClassroomLessonSummaryControllerRefreshViewsForClassroomFromPubSub = (
    pubSubMessageDto: BodyType<PubSubMessageDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ViewClassroomLessonSummaryControllerRefreshViewsForClassroomFromPubSub201>(
      {url: `/view-collection/view-classroom-lesson-summary/refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pubSubMessageDto, signal
    },
      options);
    }




export const getViewClassroomLessonSummaryControllerRefreshViewsForClassroomFromPubSubMutationKey = () => ['viewClassroomLessonSummaryControllerRefreshViewsForClassroomFromPubSub'] as const;

export const getViewClassroomLessonSummaryControllerRefreshViewsForClassroomFromPubSubMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroomFromPubSub>>, TError,ViewClassroomLessonSummaryControllerRefreshViewsForClassroomFromPubSubMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroomFromPubSub>>, TError,ViewClassroomLessonSummaryControllerRefreshViewsForClassroomFromPubSubMutationVariables, TContext> => {

const mutationKey = getViewClassroomLessonSummaryControllerRefreshViewsForClassroomFromPubSubMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroomFromPubSub>>, ViewClassroomLessonSummaryControllerRefreshViewsForClassroomFromPubSubMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  viewClassroomLessonSummaryControllerRefreshViewsForClassroomFromPubSub(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ViewClassroomLessonSummaryControllerRefreshViewsForClassroomFromPubSubMutationResult = NonNullable<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroomFromPubSub>>>
    export type ViewClassroomLessonSummaryControllerRefreshViewsForClassroomFromPubSubMutationBody = BodyType<PubSubMessageDto>
    export type ViewClassroomLessonSummaryControllerRefreshViewsForClassroomFromPubSubMutationError = ErrorType<unknown>
    export type ViewClassroomLessonSummaryControllerRefreshViewsForClassroomFromPubSubMutationVariables = {data: BodyType<PubSubMessageDto>}

    export const useViewClassroomLessonSummaryControllerRefreshViewsForClassroomFromPubSub = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroomFromPubSub>>, TError,ViewClassroomLessonSummaryControllerRefreshViewsForClassroomFromPubSubMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroomFromPubSub>>,
        TError,
        ViewClassroomLessonSummaryControllerRefreshViewsForClassroomFromPubSubMutationVariables,
        TContext
      > => {
      return useMutation(getViewClassroomLessonSummaryControllerRefreshViewsForClassroomFromPubSubMutationOptions(options), queryClient);
    }

export const viewClassroomLessonSummaryControllerRefreshViewsForClassroomLessonV2FromPubSub = (
    pubSubMessageDto: BodyType<PubSubMessageDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ViewClassroomLessonSummaryControllerRefreshViewsForClassroomLessonV2FromPubSub201>(
      {url: `/view-collection/view-classroom-lesson-summary/refresh-v2`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pubSubMessageDto, signal
    },
      options);
    }




export const getViewClassroomLessonSummaryControllerRefreshViewsForClassroomLessonV2FromPubSubMutationKey = () => ['viewClassroomLessonSummaryControllerRefreshViewsForClassroomLessonV2FromPubSub'] as const;

export const getViewClassroomLessonSummaryControllerRefreshViewsForClassroomLessonV2FromPubSubMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroomLessonV2FromPubSub>>, TError,ViewClassroomLessonSummaryControllerRefreshViewsForClassroomLessonV2FromPubSubMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroomLessonV2FromPubSub>>, TError,ViewClassroomLessonSummaryControllerRefreshViewsForClassroomLessonV2FromPubSubMutationVariables, TContext> => {

const mutationKey = getViewClassroomLessonSummaryControllerRefreshViewsForClassroomLessonV2FromPubSubMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroomLessonV2FromPubSub>>, ViewClassroomLessonSummaryControllerRefreshViewsForClassroomLessonV2FromPubSubMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  viewClassroomLessonSummaryControllerRefreshViewsForClassroomLessonV2FromPubSub(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ViewClassroomLessonSummaryControllerRefreshViewsForClassroomLessonV2FromPubSubMutationResult = NonNullable<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroomLessonV2FromPubSub>>>
    export type ViewClassroomLessonSummaryControllerRefreshViewsForClassroomLessonV2FromPubSubMutationBody = BodyType<PubSubMessageDto>
    export type ViewClassroomLessonSummaryControllerRefreshViewsForClassroomLessonV2FromPubSubMutationError = ErrorType<unknown>
    export type ViewClassroomLessonSummaryControllerRefreshViewsForClassroomLessonV2FromPubSubMutationVariables = {data: BodyType<PubSubMessageDto>}

    export const useViewClassroomLessonSummaryControllerRefreshViewsForClassroomLessonV2FromPubSub = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroomLessonV2FromPubSub>>, TError,ViewClassroomLessonSummaryControllerRefreshViewsForClassroomLessonV2FromPubSubMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof viewClassroomLessonSummaryControllerRefreshViewsForClassroomLessonV2FromPubSub>>,
        TError,
        ViewClassroomLessonSummaryControllerRefreshViewsForClassroomLessonV2FromPubSubMutationVariables,
        TContext
      > => {
      return useMutation(getViewClassroomLessonSummaryControllerRefreshViewsForClassroomLessonV2FromPubSubMutationOptions(options), queryClient);
    }

export const viewClassroomActivitySummaryControllerFind = (
    params?: ViewClassroomActivitySummaryControllerFindParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ViewClassroomActivitySummaryControllerFind200Item[]>(
      {url: `/view-collection/view-classroom-activity-summary`, method: 'GET',
        params, signal
    },
      options);
    }




export const getViewClassroomActivitySummaryControllerFindQueryKey = (params?: ViewClassroomActivitySummaryControllerFindParams,) => {
    return [
    `/view-collection/view-classroom-activity-summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getViewClassroomActivitySummaryControllerFindQueryOptions = <TData = Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerFind>>, TError = ErrorType<unknown>>(params?: ViewClassroomActivitySummaryControllerFindParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerFind>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getViewClassroomActivitySummaryControllerFindQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerFind>>> = ({ signal }) => viewClassroomActivitySummaryControllerFind(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerFind>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ViewClassroomActivitySummaryControllerFindQueryResult = NonNullable<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerFind>>>
export type ViewClassroomActivitySummaryControllerFindQueryError = ErrorType<unknown>


export function useViewClassroomActivitySummaryControllerFind<TData = Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerFind>>, TError = ErrorType<unknown>>(
 params: undefined |  ViewClassroomActivitySummaryControllerFindParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerFind>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerFind>>,
          TError,
          Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerFind>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useViewClassroomActivitySummaryControllerFind<TData = Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerFind>>, TError = ErrorType<unknown>>(
 params?: ViewClassroomActivitySummaryControllerFindParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerFind>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerFind>>,
          TError,
          Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerFind>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useViewClassroomActivitySummaryControllerFind<TData = Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerFind>>, TError = ErrorType<unknown>>(
 params?: ViewClassroomActivitySummaryControllerFindParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerFind>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useViewClassroomActivitySummaryControllerFind<TData = Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerFind>>, TError = ErrorType<unknown>>(
 params?: ViewClassroomActivitySummaryControllerFindParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerFind>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getViewClassroomActivitySummaryControllerFindQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useViewClassroomActivitySummaryControllerFind} query
 */
export const invalidateViewClassroomActivitySummaryControllerFind = async (
 queryClient: QueryClient, params?: ViewClassroomActivitySummaryControllerFindParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getViewClassroomActivitySummaryControllerFindQueryKey(params) }, options);

  return queryClient;
}

export const useSetViewClassroomActivitySummaryControllerFindQueryData = () => {
  const queryClient = useQueryClient();
  return (params: ViewClassroomActivitySummaryControllerFindParams | undefined,updater: Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerFind>> | undefined | ((old: Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerFind>> | undefined) => Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerFind>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerFind>>>({ exact: $exactMatch, queryKey: getViewClassroomActivitySummaryControllerFindQueryKey(params) }, updater);
  };
}

export const useGetViewClassroomActivitySummaryControllerFindQueryData = () => {
  const queryClient = useQueryClient();
  return (params?: ViewClassroomActivitySummaryControllerFindParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerFind>>>(getViewClassroomActivitySummaryControllerFindQueryKey(params));
}



export const viewClassroomActivitySummaryControllerRefreshViewsForClassroom = (
    params: ViewClassroomActivitySummaryControllerRefreshViewsForClassroomParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/view-collection/view-classroom-activity-summary/refresh`, method: 'GET',
        params, signal
    },
      options);
    }




export const getViewClassroomActivitySummaryControllerRefreshViewsForClassroomQueryKey = (params?: ViewClassroomActivitySummaryControllerRefreshViewsForClassroomParams,) => {
    return [
    `/view-collection/view-classroom-activity-summary/refresh`, ...(params ? [params] : [])
    ] as const;
    }


export const getViewClassroomActivitySummaryControllerRefreshViewsForClassroomQueryOptions = <TData = Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroom>>, TError = ErrorType<unknown>>(params: ViewClassroomActivitySummaryControllerRefreshViewsForClassroomParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getViewClassroomActivitySummaryControllerRefreshViewsForClassroomQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroom>>> = ({ signal }) => viewClassroomActivitySummaryControllerRefreshViewsForClassroom(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroom>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ViewClassroomActivitySummaryControllerRefreshViewsForClassroomQueryResult = NonNullable<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroom>>>
export type ViewClassroomActivitySummaryControllerRefreshViewsForClassroomQueryError = ErrorType<unknown>


export function useViewClassroomActivitySummaryControllerRefreshViewsForClassroom<TData = Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroom>>, TError = ErrorType<unknown>>(
 params: ViewClassroomActivitySummaryControllerRefreshViewsForClassroomParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroom>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroom>>,
          TError,
          Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useViewClassroomActivitySummaryControllerRefreshViewsForClassroom<TData = Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroom>>, TError = ErrorType<unknown>>(
 params: ViewClassroomActivitySummaryControllerRefreshViewsForClassroomParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroom>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroom>>,
          TError,
          Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useViewClassroomActivitySummaryControllerRefreshViewsForClassroom<TData = Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroom>>, TError = ErrorType<unknown>>(
 params: ViewClassroomActivitySummaryControllerRefreshViewsForClassroomParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useViewClassroomActivitySummaryControllerRefreshViewsForClassroom<TData = Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroom>>, TError = ErrorType<unknown>>(
 params: ViewClassroomActivitySummaryControllerRefreshViewsForClassroomParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getViewClassroomActivitySummaryControllerRefreshViewsForClassroomQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useViewClassroomActivitySummaryControllerRefreshViewsForClassroom} query
 */
export const invalidateViewClassroomActivitySummaryControllerRefreshViewsForClassroom = async (
 queryClient: QueryClient, params: ViewClassroomActivitySummaryControllerRefreshViewsForClassroomParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getViewClassroomActivitySummaryControllerRefreshViewsForClassroomQueryKey(params) }, options);

  return queryClient;
}

export const useSetViewClassroomActivitySummaryControllerRefreshViewsForClassroomQueryData = () => {
  const queryClient = useQueryClient();
  return (params: ViewClassroomActivitySummaryControllerRefreshViewsForClassroomParams | undefined,updater: Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroom>> | undefined | ((old: Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroom>> | undefined) => Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroom>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroom>>>({ exact: $exactMatch, queryKey: getViewClassroomActivitySummaryControllerRefreshViewsForClassroomQueryKey(params) }, updater);
  };
}

export const useGetViewClassroomActivitySummaryControllerRefreshViewsForClassroomQueryData = () => {
  const queryClient = useQueryClient();
  return (params: ViewClassroomActivitySummaryControllerRefreshViewsForClassroomParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroom>>>(getViewClassroomActivitySummaryControllerRefreshViewsForClassroomQueryKey(params));
}



export const viewClassroomActivitySummaryControllerRefreshViewsForClassroomFromPubSub = (
    pubSubMessageDto: BodyType<PubSubMessageDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ViewClassroomActivitySummaryControllerRefreshViewsForClassroomFromPubSub201>(
      {url: `/view-collection/view-classroom-activity-summary/refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pubSubMessageDto, signal
    },
      options);
    }




export const getViewClassroomActivitySummaryControllerRefreshViewsForClassroomFromPubSubMutationKey = () => ['viewClassroomActivitySummaryControllerRefreshViewsForClassroomFromPubSub'] as const;

export const getViewClassroomActivitySummaryControllerRefreshViewsForClassroomFromPubSubMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroomFromPubSub>>, TError,ViewClassroomActivitySummaryControllerRefreshViewsForClassroomFromPubSubMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroomFromPubSub>>, TError,ViewClassroomActivitySummaryControllerRefreshViewsForClassroomFromPubSubMutationVariables, TContext> => {

const mutationKey = getViewClassroomActivitySummaryControllerRefreshViewsForClassroomFromPubSubMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroomFromPubSub>>, ViewClassroomActivitySummaryControllerRefreshViewsForClassroomFromPubSubMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  viewClassroomActivitySummaryControllerRefreshViewsForClassroomFromPubSub(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ViewClassroomActivitySummaryControllerRefreshViewsForClassroomFromPubSubMutationResult = NonNullable<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroomFromPubSub>>>
    export type ViewClassroomActivitySummaryControllerRefreshViewsForClassroomFromPubSubMutationBody = BodyType<PubSubMessageDto>
    export type ViewClassroomActivitySummaryControllerRefreshViewsForClassroomFromPubSubMutationError = ErrorType<unknown>
    export type ViewClassroomActivitySummaryControllerRefreshViewsForClassroomFromPubSubMutationVariables = {data: BodyType<PubSubMessageDto>}

    export const useViewClassroomActivitySummaryControllerRefreshViewsForClassroomFromPubSub = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroomFromPubSub>>, TError,ViewClassroomActivitySummaryControllerRefreshViewsForClassroomFromPubSubMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroomFromPubSub>>,
        TError,
        ViewClassroomActivitySummaryControllerRefreshViewsForClassroomFromPubSubMutationVariables,
        TContext
      > => {
      return useMutation(getViewClassroomActivitySummaryControllerRefreshViewsForClassroomFromPubSubMutationOptions(options), queryClient);
    }

export const viewClassroomActivitySummaryControllerRefreshViewsForClassroomV2FromPubSub = (
    pubSubMessageDto: BodyType<PubSubMessageDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ViewClassroomActivitySummaryControllerRefreshViewsForClassroomV2FromPubSub201>(
      {url: `/view-collection/view-classroom-activity-summary/refresh-v2`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pubSubMessageDto, signal
    },
      options);
    }




export const getViewClassroomActivitySummaryControllerRefreshViewsForClassroomV2FromPubSubMutationKey = () => ['viewClassroomActivitySummaryControllerRefreshViewsForClassroomV2FromPubSub'] as const;

export const getViewClassroomActivitySummaryControllerRefreshViewsForClassroomV2FromPubSubMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroomV2FromPubSub>>, TError,ViewClassroomActivitySummaryControllerRefreshViewsForClassroomV2FromPubSubMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroomV2FromPubSub>>, TError,ViewClassroomActivitySummaryControllerRefreshViewsForClassroomV2FromPubSubMutationVariables, TContext> => {

const mutationKey = getViewClassroomActivitySummaryControllerRefreshViewsForClassroomV2FromPubSubMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroomV2FromPubSub>>, ViewClassroomActivitySummaryControllerRefreshViewsForClassroomV2FromPubSubMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  viewClassroomActivitySummaryControllerRefreshViewsForClassroomV2FromPubSub(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ViewClassroomActivitySummaryControllerRefreshViewsForClassroomV2FromPubSubMutationResult = NonNullable<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroomV2FromPubSub>>>
    export type ViewClassroomActivitySummaryControllerRefreshViewsForClassroomV2FromPubSubMutationBody = BodyType<PubSubMessageDto>
    export type ViewClassroomActivitySummaryControllerRefreshViewsForClassroomV2FromPubSubMutationError = ErrorType<unknown>
    export type ViewClassroomActivitySummaryControllerRefreshViewsForClassroomV2FromPubSubMutationVariables = {data: BodyType<PubSubMessageDto>}

    export const useViewClassroomActivitySummaryControllerRefreshViewsForClassroomV2FromPubSub = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroomV2FromPubSub>>, TError,ViewClassroomActivitySummaryControllerRefreshViewsForClassroomV2FromPubSubMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof viewClassroomActivitySummaryControllerRefreshViewsForClassroomV2FromPubSub>>,
        TError,
        ViewClassroomActivitySummaryControllerRefreshViewsForClassroomV2FromPubSubMutationVariables,
        TContext
      > => {
      return useMutation(getViewClassroomActivitySummaryControllerRefreshViewsForClassroomV2FromPubSubMutationOptions(options), queryClient);
    }

export const viewClassroomUserScoreControllerFind = (
    params?: ViewClassroomUserScoreControllerFindParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ViewClassroomUserScoreControllerFind200Item[]>(
      {url: `/view-collection/view-classroom-user-score`, method: 'GET',
        params, signal
    },
      options);
    }




export const getViewClassroomUserScoreControllerFindQueryKey = (params?: ViewClassroomUserScoreControllerFindParams,) => {
    return [
    `/view-collection/view-classroom-user-score`, ...(params ? [params] : [])
    ] as const;
    }


export const getViewClassroomUserScoreControllerFindQueryOptions = <TData = Awaited<ReturnType<typeof viewClassroomUserScoreControllerFind>>, TError = ErrorType<unknown>>(params?: ViewClassroomUserScoreControllerFindParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomUserScoreControllerFind>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getViewClassroomUserScoreControllerFindQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof viewClassroomUserScoreControllerFind>>> = ({ signal }) => viewClassroomUserScoreControllerFind(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof viewClassroomUserScoreControllerFind>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ViewClassroomUserScoreControllerFindQueryResult = NonNullable<Awaited<ReturnType<typeof viewClassroomUserScoreControllerFind>>>
export type ViewClassroomUserScoreControllerFindQueryError = ErrorType<unknown>


export function useViewClassroomUserScoreControllerFind<TData = Awaited<ReturnType<typeof viewClassroomUserScoreControllerFind>>, TError = ErrorType<unknown>>(
 params: undefined |  ViewClassroomUserScoreControllerFindParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomUserScoreControllerFind>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewClassroomUserScoreControllerFind>>,
          TError,
          Awaited<ReturnType<typeof viewClassroomUserScoreControllerFind>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useViewClassroomUserScoreControllerFind<TData = Awaited<ReturnType<typeof viewClassroomUserScoreControllerFind>>, TError = ErrorType<unknown>>(
 params?: ViewClassroomUserScoreControllerFindParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomUserScoreControllerFind>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewClassroomUserScoreControllerFind>>,
          TError,
          Awaited<ReturnType<typeof viewClassroomUserScoreControllerFind>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useViewClassroomUserScoreControllerFind<TData = Awaited<ReturnType<typeof viewClassroomUserScoreControllerFind>>, TError = ErrorType<unknown>>(
 params?: ViewClassroomUserScoreControllerFindParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomUserScoreControllerFind>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useViewClassroomUserScoreControllerFind<TData = Awaited<ReturnType<typeof viewClassroomUserScoreControllerFind>>, TError = ErrorType<unknown>>(
 params?: ViewClassroomUserScoreControllerFindParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomUserScoreControllerFind>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getViewClassroomUserScoreControllerFindQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useViewClassroomUserScoreControllerFind} query
 */
export const invalidateViewClassroomUserScoreControllerFind = async (
 queryClient: QueryClient, params?: ViewClassroomUserScoreControllerFindParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getViewClassroomUserScoreControllerFindQueryKey(params) }, options);

  return queryClient;
}

export const useSetViewClassroomUserScoreControllerFindQueryData = () => {
  const queryClient = useQueryClient();
  return (params: ViewClassroomUserScoreControllerFindParams | undefined,updater: Awaited<ReturnType<typeof viewClassroomUserScoreControllerFind>> | undefined | ((old: Awaited<ReturnType<typeof viewClassroomUserScoreControllerFind>> | undefined) => Awaited<ReturnType<typeof viewClassroomUserScoreControllerFind>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof viewClassroomUserScoreControllerFind>>>({ exact: $exactMatch, queryKey: getViewClassroomUserScoreControllerFindQueryKey(params) }, updater);
  };
}

export const useGetViewClassroomUserScoreControllerFindQueryData = () => {
  const queryClient = useQueryClient();
  return (params?: ViewClassroomUserScoreControllerFindParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof viewClassroomUserScoreControllerFind>>>(getViewClassroomUserScoreControllerFindQueryKey(params));
}



export const viewClassroomUserScoreControllerRefreshViewsForClassroom = (
    params: ViewClassroomUserScoreControllerRefreshViewsForClassroomParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/view-collection/view-classroom-user-score/refresh`, method: 'GET',
        params, signal
    },
      options);
    }




export const getViewClassroomUserScoreControllerRefreshViewsForClassroomQueryKey = (params?: ViewClassroomUserScoreControllerRefreshViewsForClassroomParams,) => {
    return [
    `/view-collection/view-classroom-user-score/refresh`, ...(params ? [params] : [])
    ] as const;
    }


export const getViewClassroomUserScoreControllerRefreshViewsForClassroomQueryOptions = <TData = Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroom>>, TError = ErrorType<unknown>>(params: ViewClassroomUserScoreControllerRefreshViewsForClassroomParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getViewClassroomUserScoreControllerRefreshViewsForClassroomQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroom>>> = ({ signal }) => viewClassroomUserScoreControllerRefreshViewsForClassroom(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroom>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ViewClassroomUserScoreControllerRefreshViewsForClassroomQueryResult = NonNullable<Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroom>>>
export type ViewClassroomUserScoreControllerRefreshViewsForClassroomQueryError = ErrorType<unknown>


export function useViewClassroomUserScoreControllerRefreshViewsForClassroom<TData = Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroom>>, TError = ErrorType<unknown>>(
 params: ViewClassroomUserScoreControllerRefreshViewsForClassroomParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroom>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroom>>,
          TError,
          Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useViewClassroomUserScoreControllerRefreshViewsForClassroom<TData = Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroom>>, TError = ErrorType<unknown>>(
 params: ViewClassroomUserScoreControllerRefreshViewsForClassroomParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroom>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroom>>,
          TError,
          Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useViewClassroomUserScoreControllerRefreshViewsForClassroom<TData = Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroom>>, TError = ErrorType<unknown>>(
 params: ViewClassroomUserScoreControllerRefreshViewsForClassroomParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useViewClassroomUserScoreControllerRefreshViewsForClassroom<TData = Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroom>>, TError = ErrorType<unknown>>(
 params: ViewClassroomUserScoreControllerRefreshViewsForClassroomParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getViewClassroomUserScoreControllerRefreshViewsForClassroomQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useViewClassroomUserScoreControllerRefreshViewsForClassroom} query
 */
export const invalidateViewClassroomUserScoreControllerRefreshViewsForClassroom = async (
 queryClient: QueryClient, params: ViewClassroomUserScoreControllerRefreshViewsForClassroomParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getViewClassroomUserScoreControllerRefreshViewsForClassroomQueryKey(params) }, options);

  return queryClient;
}

export const useSetViewClassroomUserScoreControllerRefreshViewsForClassroomQueryData = () => {
  const queryClient = useQueryClient();
  return (params: ViewClassroomUserScoreControllerRefreshViewsForClassroomParams | undefined,updater: Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroom>> | undefined | ((old: Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroom>> | undefined) => Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroom>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroom>>>({ exact: $exactMatch, queryKey: getViewClassroomUserScoreControllerRefreshViewsForClassroomQueryKey(params) }, updater);
  };
}

export const useGetViewClassroomUserScoreControllerRefreshViewsForClassroomQueryData = () => {
  const queryClient = useQueryClient();
  return (params: ViewClassroomUserScoreControllerRefreshViewsForClassroomParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroom>>>(getViewClassroomUserScoreControllerRefreshViewsForClassroomQueryKey(params));
}



export const viewClassroomUserScoreControllerRefreshViewsForClassroomFromPubSub = (
    pubSubMessageDto: BodyType<PubSubMessageDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ViewClassroomUserScoreControllerRefreshViewsForClassroomFromPubSub201>(
      {url: `/view-collection/view-classroom-user-score/refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pubSubMessageDto, signal
    },
      options);
    }




export const getViewClassroomUserScoreControllerRefreshViewsForClassroomFromPubSubMutationKey = () => ['viewClassroomUserScoreControllerRefreshViewsForClassroomFromPubSub'] as const;

export const getViewClassroomUserScoreControllerRefreshViewsForClassroomFromPubSubMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroomFromPubSub>>, TError,ViewClassroomUserScoreControllerRefreshViewsForClassroomFromPubSubMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroomFromPubSub>>, TError,ViewClassroomUserScoreControllerRefreshViewsForClassroomFromPubSubMutationVariables, TContext> => {

const mutationKey = getViewClassroomUserScoreControllerRefreshViewsForClassroomFromPubSubMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroomFromPubSub>>, ViewClassroomUserScoreControllerRefreshViewsForClassroomFromPubSubMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  viewClassroomUserScoreControllerRefreshViewsForClassroomFromPubSub(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ViewClassroomUserScoreControllerRefreshViewsForClassroomFromPubSubMutationResult = NonNullable<Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroomFromPubSub>>>
    export type ViewClassroomUserScoreControllerRefreshViewsForClassroomFromPubSubMutationBody = BodyType<PubSubMessageDto>
    export type ViewClassroomUserScoreControllerRefreshViewsForClassroomFromPubSubMutationError = ErrorType<unknown>
    export type ViewClassroomUserScoreControllerRefreshViewsForClassroomFromPubSubMutationVariables = {data: BodyType<PubSubMessageDto>}

    export const useViewClassroomUserScoreControllerRefreshViewsForClassroomFromPubSub = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroomFromPubSub>>, TError,ViewClassroomUserScoreControllerRefreshViewsForClassroomFromPubSubMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroomFromPubSub>>,
        TError,
        ViewClassroomUserScoreControllerRefreshViewsForClassroomFromPubSubMutationVariables,
        TContext
      > => {
      return useMutation(getViewClassroomUserScoreControllerRefreshViewsForClassroomFromPubSubMutationOptions(options), queryClient);
    }

export const viewClassroomUserScoreControllerRefreshViewsForClassroomV2FromPubSub = (
    pubSubMessageDto: BodyType<PubSubMessageDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ViewClassroomUserScoreControllerRefreshViewsForClassroomV2FromPubSub201>(
      {url: `/view-collection/view-classroom-user-score/refresh-v2`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pubSubMessageDto, signal
    },
      options);
    }




export const getViewClassroomUserScoreControllerRefreshViewsForClassroomV2FromPubSubMutationKey = () => ['viewClassroomUserScoreControllerRefreshViewsForClassroomV2FromPubSub'] as const;

export const getViewClassroomUserScoreControllerRefreshViewsForClassroomV2FromPubSubMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroomV2FromPubSub>>, TError,ViewClassroomUserScoreControllerRefreshViewsForClassroomV2FromPubSubMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroomV2FromPubSub>>, TError,ViewClassroomUserScoreControllerRefreshViewsForClassroomV2FromPubSubMutationVariables, TContext> => {

const mutationKey = getViewClassroomUserScoreControllerRefreshViewsForClassroomV2FromPubSubMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroomV2FromPubSub>>, ViewClassroomUserScoreControllerRefreshViewsForClassroomV2FromPubSubMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  viewClassroomUserScoreControllerRefreshViewsForClassroomV2FromPubSub(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ViewClassroomUserScoreControllerRefreshViewsForClassroomV2FromPubSubMutationResult = NonNullable<Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroomV2FromPubSub>>>
    export type ViewClassroomUserScoreControllerRefreshViewsForClassroomV2FromPubSubMutationBody = BodyType<PubSubMessageDto>
    export type ViewClassroomUserScoreControllerRefreshViewsForClassroomV2FromPubSubMutationError = ErrorType<unknown>
    export type ViewClassroomUserScoreControllerRefreshViewsForClassroomV2FromPubSubMutationVariables = {data: BodyType<PubSubMessageDto>}

    export const useViewClassroomUserScoreControllerRefreshViewsForClassroomV2FromPubSub = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroomV2FromPubSub>>, TError,ViewClassroomUserScoreControllerRefreshViewsForClassroomV2FromPubSubMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof viewClassroomUserScoreControllerRefreshViewsForClassroomV2FromPubSub>>,
        TError,
        ViewClassroomUserScoreControllerRefreshViewsForClassroomV2FromPubSubMutationVariables,
        TContext
      > => {
      return useMutation(getViewClassroomUserScoreControllerRefreshViewsForClassroomV2FromPubSubMutationOptions(options), queryClient);
    }

export const classroomReportControllerGetClassroomReportPrintingDataByClassroomId = (
    classroomId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ClassroomReportPrintingDataDto>(
      {url: `/classroom-report/classrooms/${classroomId}/printing-data`, method: 'GET', signal
    },
      options);
    }




export const getClassroomReportControllerGetClassroomReportPrintingDataByClassroomIdQueryKey = (classroomId: string,) => {
    return [
    `/classroom-report/classrooms/${classroomId}/printing-data`
    ] as const;
    }


export const getClassroomReportControllerGetClassroomReportPrintingDataByClassroomIdQueryOptions = <TData = Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportPrintingDataByClassroomId>>, TError = ErrorType<unknown>>(classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportPrintingDataByClassroomId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomReportControllerGetClassroomReportPrintingDataByClassroomIdQueryKey(classroomId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportPrintingDataByClassroomId>>> = ({ signal }) => classroomReportControllerGetClassroomReportPrintingDataByClassroomId(classroomId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportPrintingDataByClassroomId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomReportControllerGetClassroomReportPrintingDataByClassroomIdQueryResult = NonNullable<Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportPrintingDataByClassroomId>>>
export type ClassroomReportControllerGetClassroomReportPrintingDataByClassroomIdQueryError = ErrorType<unknown>


export function useClassroomReportControllerGetClassroomReportPrintingDataByClassroomId<TData = Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportPrintingDataByClassroomId>>, TError = ErrorType<unknown>>(
 classroomId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportPrintingDataByClassroomId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportPrintingDataByClassroomId>>,
          TError,
          Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportPrintingDataByClassroomId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomReportControllerGetClassroomReportPrintingDataByClassroomId<TData = Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportPrintingDataByClassroomId>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportPrintingDataByClassroomId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportPrintingDataByClassroomId>>,
          TError,
          Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportPrintingDataByClassroomId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomReportControllerGetClassroomReportPrintingDataByClassroomId<TData = Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportPrintingDataByClassroomId>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportPrintingDataByClassroomId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomReportControllerGetClassroomReportPrintingDataByClassroomId<TData = Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportPrintingDataByClassroomId>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportPrintingDataByClassroomId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomReportControllerGetClassroomReportPrintingDataByClassroomIdQueryOptions(classroomId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomReportControllerGetClassroomReportPrintingDataByClassroomId} query
 */
export const invalidateClassroomReportControllerGetClassroomReportPrintingDataByClassroomId = async (
 queryClient: QueryClient, classroomId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomReportControllerGetClassroomReportPrintingDataByClassroomIdQueryKey(classroomId) }, options);

  return queryClient;
}

export const useSetClassroomReportControllerGetClassroomReportPrintingDataByClassroomIdQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,updater: Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportPrintingDataByClassroomId>> | undefined | ((old: Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportPrintingDataByClassroomId>> | undefined) => Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportPrintingDataByClassroomId>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportPrintingDataByClassroomId>>>({ exact: $exactMatch, queryKey: getClassroomReportControllerGetClassroomReportPrintingDataByClassroomIdQueryKey(classroomId) }, updater);
  };
}

export const useGetClassroomReportControllerGetClassroomReportPrintingDataByClassroomIdQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportPrintingDataByClassroomId>>>(getClassroomReportControllerGetClassroomReportPrintingDataByClassroomIdQueryKey(classroomId));
}



export const classroomReportControllerGetClassroomScoreByClassroomId = (
    classroomId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<number>(
      {url: `/classroom-report/classrooms/${classroomId}/score`, method: 'GET', signal
    },
      options);
    }




export const getClassroomReportControllerGetClassroomScoreByClassroomIdQueryKey = (classroomId: string,) => {
    return [
    `/classroom-report/classrooms/${classroomId}/score`
    ] as const;
    }


export const getClassroomReportControllerGetClassroomScoreByClassroomIdQueryOptions = <TData = Awaited<ReturnType<typeof classroomReportControllerGetClassroomScoreByClassroomId>>, TError = ErrorType<unknown>>(classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetClassroomScoreByClassroomId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomReportControllerGetClassroomScoreByClassroomIdQueryKey(classroomId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomReportControllerGetClassroomScoreByClassroomId>>> = ({ signal }) => classroomReportControllerGetClassroomScoreByClassroomId(classroomId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetClassroomScoreByClassroomId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomReportControllerGetClassroomScoreByClassroomIdQueryResult = NonNullable<Awaited<ReturnType<typeof classroomReportControllerGetClassroomScoreByClassroomId>>>
export type ClassroomReportControllerGetClassroomScoreByClassroomIdQueryError = ErrorType<unknown>


export function useClassroomReportControllerGetClassroomScoreByClassroomId<TData = Awaited<ReturnType<typeof classroomReportControllerGetClassroomScoreByClassroomId>>, TError = ErrorType<unknown>>(
 classroomId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetClassroomScoreByClassroomId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomReportControllerGetClassroomScoreByClassroomId>>,
          TError,
          Awaited<ReturnType<typeof classroomReportControllerGetClassroomScoreByClassroomId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomReportControllerGetClassroomScoreByClassroomId<TData = Awaited<ReturnType<typeof classroomReportControllerGetClassroomScoreByClassroomId>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetClassroomScoreByClassroomId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomReportControllerGetClassroomScoreByClassroomId>>,
          TError,
          Awaited<ReturnType<typeof classroomReportControllerGetClassroomScoreByClassroomId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomReportControllerGetClassroomScoreByClassroomId<TData = Awaited<ReturnType<typeof classroomReportControllerGetClassroomScoreByClassroomId>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetClassroomScoreByClassroomId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomReportControllerGetClassroomScoreByClassroomId<TData = Awaited<ReturnType<typeof classroomReportControllerGetClassroomScoreByClassroomId>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetClassroomScoreByClassroomId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomReportControllerGetClassroomScoreByClassroomIdQueryOptions(classroomId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomReportControllerGetClassroomScoreByClassroomId} query
 */
export const invalidateClassroomReportControllerGetClassroomScoreByClassroomId = async (
 queryClient: QueryClient, classroomId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomReportControllerGetClassroomScoreByClassroomIdQueryKey(classroomId) }, options);

  return queryClient;
}

export const useSetClassroomReportControllerGetClassroomScoreByClassroomIdQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,updater: Awaited<ReturnType<typeof classroomReportControllerGetClassroomScoreByClassroomId>> | undefined | ((old: Awaited<ReturnType<typeof classroomReportControllerGetClassroomScoreByClassroomId>> | undefined) => Awaited<ReturnType<typeof classroomReportControllerGetClassroomScoreByClassroomId>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomReportControllerGetClassroomScoreByClassroomId>>>({ exact: $exactMatch, queryKey: getClassroomReportControllerGetClassroomScoreByClassroomIdQueryKey(classroomId) }, updater);
  };
}

export const useGetClassroomReportControllerGetClassroomScoreByClassroomIdQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomReportControllerGetClassroomScoreByClassroomId>>>(getClassroomReportControllerGetClassroomScoreByClassroomIdQueryKey(classroomId));
}



export const classroomReportControllerGetClassroomReportAllStudentScoreByClassroomId = (
    classroomId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/classroom-report/classrooms/${classroomId}/users/score`, method: 'GET', signal
    },
      options);
    }




export const getClassroomReportControllerGetClassroomReportAllStudentScoreByClassroomIdQueryKey = (classroomId: string,) => {
    return [
    `/classroom-report/classrooms/${classroomId}/users/score`
    ] as const;
    }


export const getClassroomReportControllerGetClassroomReportAllStudentScoreByClassroomIdQueryOptions = <TData = Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportAllStudentScoreByClassroomId>>, TError = ErrorType<unknown>>(classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportAllStudentScoreByClassroomId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomReportControllerGetClassroomReportAllStudentScoreByClassroomIdQueryKey(classroomId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportAllStudentScoreByClassroomId>>> = ({ signal }) => classroomReportControllerGetClassroomReportAllStudentScoreByClassroomId(classroomId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportAllStudentScoreByClassroomId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomReportControllerGetClassroomReportAllStudentScoreByClassroomIdQueryResult = NonNullable<Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportAllStudentScoreByClassroomId>>>
export type ClassroomReportControllerGetClassroomReportAllStudentScoreByClassroomIdQueryError = ErrorType<unknown>


export function useClassroomReportControllerGetClassroomReportAllStudentScoreByClassroomId<TData = Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportAllStudentScoreByClassroomId>>, TError = ErrorType<unknown>>(
 classroomId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportAllStudentScoreByClassroomId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportAllStudentScoreByClassroomId>>,
          TError,
          Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportAllStudentScoreByClassroomId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomReportControllerGetClassroomReportAllStudentScoreByClassroomId<TData = Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportAllStudentScoreByClassroomId>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportAllStudentScoreByClassroomId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportAllStudentScoreByClassroomId>>,
          TError,
          Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportAllStudentScoreByClassroomId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomReportControllerGetClassroomReportAllStudentScoreByClassroomId<TData = Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportAllStudentScoreByClassroomId>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportAllStudentScoreByClassroomId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomReportControllerGetClassroomReportAllStudentScoreByClassroomId<TData = Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportAllStudentScoreByClassroomId>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportAllStudentScoreByClassroomId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomReportControllerGetClassroomReportAllStudentScoreByClassroomIdQueryOptions(classroomId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomReportControllerGetClassroomReportAllStudentScoreByClassroomId} query
 */
export const invalidateClassroomReportControllerGetClassroomReportAllStudentScoreByClassroomId = async (
 queryClient: QueryClient, classroomId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomReportControllerGetClassroomReportAllStudentScoreByClassroomIdQueryKey(classroomId) }, options);

  return queryClient;
}

export const useSetClassroomReportControllerGetClassroomReportAllStudentScoreByClassroomIdQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,updater: Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportAllStudentScoreByClassroomId>> | undefined | ((old: Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportAllStudentScoreByClassroomId>> | undefined) => Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportAllStudentScoreByClassroomId>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportAllStudentScoreByClassroomId>>>({ exact: $exactMatch, queryKey: getClassroomReportControllerGetClassroomReportAllStudentScoreByClassroomIdQueryKey(classroomId) }, updater);
  };
}

export const useGetClassroomReportControllerGetClassroomReportAllStudentScoreByClassroomIdQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomReportControllerGetClassroomReportAllStudentScoreByClassroomId>>>(getClassroomReportControllerGetClassroomReportAllStudentScoreByClassroomIdQueryKey(classroomId));
}



export const classroomReportControllerGetEoSReportData = (
    params: ClassroomReportControllerGetEoSReportDataParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/classroom-report/eos/data`, method: 'GET',
        params, signal
    },
      options);
    }




export const getClassroomReportControllerGetEoSReportDataQueryKey = (params?: ClassroomReportControllerGetEoSReportDataParams,) => {
    return [
    `/classroom-report/eos/data`, ...(params ? [params] : [])
    ] as const;
    }


export const getClassroomReportControllerGetEoSReportDataQueryOptions = <TData = Awaited<ReturnType<typeof classroomReportControllerGetEoSReportData>>, TError = ErrorType<unknown>>(params: ClassroomReportControllerGetEoSReportDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetEoSReportData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomReportControllerGetEoSReportDataQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomReportControllerGetEoSReportData>>> = ({ signal }) => classroomReportControllerGetEoSReportData(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetEoSReportData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomReportControllerGetEoSReportDataQueryResult = NonNullable<Awaited<ReturnType<typeof classroomReportControllerGetEoSReportData>>>
export type ClassroomReportControllerGetEoSReportDataQueryError = ErrorType<unknown>


export function useClassroomReportControllerGetEoSReportData<TData = Awaited<ReturnType<typeof classroomReportControllerGetEoSReportData>>, TError = ErrorType<unknown>>(
 params: ClassroomReportControllerGetEoSReportDataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetEoSReportData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomReportControllerGetEoSReportData>>,
          TError,
          Awaited<ReturnType<typeof classroomReportControllerGetEoSReportData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomReportControllerGetEoSReportData<TData = Awaited<ReturnType<typeof classroomReportControllerGetEoSReportData>>, TError = ErrorType<unknown>>(
 params: ClassroomReportControllerGetEoSReportDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetEoSReportData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomReportControllerGetEoSReportData>>,
          TError,
          Awaited<ReturnType<typeof classroomReportControllerGetEoSReportData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomReportControllerGetEoSReportData<TData = Awaited<ReturnType<typeof classroomReportControllerGetEoSReportData>>, TError = ErrorType<unknown>>(
 params: ClassroomReportControllerGetEoSReportDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetEoSReportData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomReportControllerGetEoSReportData<TData = Awaited<ReturnType<typeof classroomReportControllerGetEoSReportData>>, TError = ErrorType<unknown>>(
 params: ClassroomReportControllerGetEoSReportDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetEoSReportData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomReportControllerGetEoSReportDataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomReportControllerGetEoSReportData} query
 */
export const invalidateClassroomReportControllerGetEoSReportData = async (
 queryClient: QueryClient, params: ClassroomReportControllerGetEoSReportDataParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomReportControllerGetEoSReportDataQueryKey(params) }, options);

  return queryClient;
}

export const useSetClassroomReportControllerGetEoSReportDataQueryData = () => {
  const queryClient = useQueryClient();
  return (params: ClassroomReportControllerGetEoSReportDataParams | undefined,updater: Awaited<ReturnType<typeof classroomReportControllerGetEoSReportData>> | undefined | ((old: Awaited<ReturnType<typeof classroomReportControllerGetEoSReportData>> | undefined) => Awaited<ReturnType<typeof classroomReportControllerGetEoSReportData>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomReportControllerGetEoSReportData>>>({ exact: $exactMatch, queryKey: getClassroomReportControllerGetEoSReportDataQueryKey(params) }, updater);
  };
}

export const useGetClassroomReportControllerGetEoSReportDataQueryData = () => {
  const queryClient = useQueryClient();
  return (params: ClassroomReportControllerGetEoSReportDataParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomReportControllerGetEoSReportData>>>(getClassroomReportControllerGetEoSReportDataQueryKey(params));
}



export const classroomReportControllerCreateEoSReport = (
    createEoSReportDto: BodyType<CreateEoSReportDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/classroom-report/eos`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createEoSReportDto, signal
    },
      options);
    }




export const getClassroomReportControllerCreateEoSReportMutationKey = () => ['classroomReportControllerCreateEoSReport'] as const;

export const getClassroomReportControllerCreateEoSReportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomReportControllerCreateEoSReport>>, TError,ClassroomReportControllerCreateEoSReportMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof classroomReportControllerCreateEoSReport>>, TError,ClassroomReportControllerCreateEoSReportMutationVariables, TContext> => {

const mutationKey = getClassroomReportControllerCreateEoSReportMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof classroomReportControllerCreateEoSReport>>, ClassroomReportControllerCreateEoSReportMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  classroomReportControllerCreateEoSReport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClassroomReportControllerCreateEoSReportMutationResult = NonNullable<Awaited<ReturnType<typeof classroomReportControllerCreateEoSReport>>>
    export type ClassroomReportControllerCreateEoSReportMutationBody = BodyType<CreateEoSReportDto>
    export type ClassroomReportControllerCreateEoSReportMutationError = ErrorType<unknown>
    export type ClassroomReportControllerCreateEoSReportMutationVariables = {data: BodyType<CreateEoSReportDto>}

    export const useClassroomReportControllerCreateEoSReport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomReportControllerCreateEoSReport>>, TError,ClassroomReportControllerCreateEoSReportMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof classroomReportControllerCreateEoSReport>>,
        TError,
        ClassroomReportControllerCreateEoSReportMutationVariables,
        TContext
      > => {
      return useMutation(getClassroomReportControllerCreateEoSReportMutationOptions(options), queryClient);
    }

/**
 * @summary Create a combined individual PDF and CSV report archive
 */
export const classroomReportControllerCreateIndividualReport = (
    createIndividualReportDto: BodyType<CreateIndividualReportDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Blob>(
      {url: `/classroom-report/individual`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createIndividualReportDto,
        responseType: 'blob', signal
    },
      options);
    }




export const getClassroomReportControllerCreateIndividualReportMutationKey = () => ['classroomReportControllerCreateIndividualReport'] as const;

export const getClassroomReportControllerCreateIndividualReportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomReportControllerCreateIndividualReport>>, TError,ClassroomReportControllerCreateIndividualReportMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof classroomReportControllerCreateIndividualReport>>, TError,ClassroomReportControllerCreateIndividualReportMutationVariables, TContext> => {

const mutationKey = getClassroomReportControllerCreateIndividualReportMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof classroomReportControllerCreateIndividualReport>>, ClassroomReportControllerCreateIndividualReportMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  classroomReportControllerCreateIndividualReport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClassroomReportControllerCreateIndividualReportMutationResult = NonNullable<Awaited<ReturnType<typeof classroomReportControllerCreateIndividualReport>>>
    export type ClassroomReportControllerCreateIndividualReportMutationBody = BodyType<CreateIndividualReportDto>
    export type ClassroomReportControllerCreateIndividualReportMutationError = ErrorType<unknown>
    export type ClassroomReportControllerCreateIndividualReportMutationVariables = {data: BodyType<CreateIndividualReportDto>}

    /**
 * @summary Create a combined individual PDF and CSV report archive
 */
export const useClassroomReportControllerCreateIndividualReport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomReportControllerCreateIndividualReport>>, TError,ClassroomReportControllerCreateIndividualReportMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof classroomReportControllerCreateIndividualReport>>,
        TError,
        ClassroomReportControllerCreateIndividualReportMutationVariables,
        TContext
      > => {
      return useMutation(getClassroomReportControllerCreateIndividualReportMutationOptions(options), queryClient);
    }

export const classroomReportControllerGetIndividualReportData = (
    params: ClassroomReportControllerGetIndividualReportDataParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ClassroomIndividualReportDataResponseDto>(
      {url: `/classroom-report/individual/data`, method: 'GET',
        params, signal
    },
      options);
    }




export const getClassroomReportControllerGetIndividualReportDataQueryKey = (params?: ClassroomReportControllerGetIndividualReportDataParams,) => {
    return [
    `/classroom-report/individual/data`, ...(params ? [params] : [])
    ] as const;
    }


export const getClassroomReportControllerGetIndividualReportDataQueryOptions = <TData = Awaited<ReturnType<typeof classroomReportControllerGetIndividualReportData>>, TError = ErrorType<unknown>>(params: ClassroomReportControllerGetIndividualReportDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetIndividualReportData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomReportControllerGetIndividualReportDataQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomReportControllerGetIndividualReportData>>> = ({ signal }) => classroomReportControllerGetIndividualReportData(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetIndividualReportData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomReportControllerGetIndividualReportDataQueryResult = NonNullable<Awaited<ReturnType<typeof classroomReportControllerGetIndividualReportData>>>
export type ClassroomReportControllerGetIndividualReportDataQueryError = ErrorType<unknown>


export function useClassroomReportControllerGetIndividualReportData<TData = Awaited<ReturnType<typeof classroomReportControllerGetIndividualReportData>>, TError = ErrorType<unknown>>(
 params: ClassroomReportControllerGetIndividualReportDataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetIndividualReportData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomReportControllerGetIndividualReportData>>,
          TError,
          Awaited<ReturnType<typeof classroomReportControllerGetIndividualReportData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomReportControllerGetIndividualReportData<TData = Awaited<ReturnType<typeof classroomReportControllerGetIndividualReportData>>, TError = ErrorType<unknown>>(
 params: ClassroomReportControllerGetIndividualReportDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetIndividualReportData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomReportControllerGetIndividualReportData>>,
          TError,
          Awaited<ReturnType<typeof classroomReportControllerGetIndividualReportData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomReportControllerGetIndividualReportData<TData = Awaited<ReturnType<typeof classroomReportControllerGetIndividualReportData>>, TError = ErrorType<unknown>>(
 params: ClassroomReportControllerGetIndividualReportDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetIndividualReportData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomReportControllerGetIndividualReportData<TData = Awaited<ReturnType<typeof classroomReportControllerGetIndividualReportData>>, TError = ErrorType<unknown>>(
 params: ClassroomReportControllerGetIndividualReportDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomReportControllerGetIndividualReportData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomReportControllerGetIndividualReportDataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomReportControllerGetIndividualReportData} query
 */
export const invalidateClassroomReportControllerGetIndividualReportData = async (
 queryClient: QueryClient, params: ClassroomReportControllerGetIndividualReportDataParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomReportControllerGetIndividualReportDataQueryKey(params) }, options);

  return queryClient;
}

export const useSetClassroomReportControllerGetIndividualReportDataQueryData = () => {
  const queryClient = useQueryClient();
  return (params: ClassroomReportControllerGetIndividualReportDataParams | undefined,updater: Awaited<ReturnType<typeof classroomReportControllerGetIndividualReportData>> | undefined | ((old: Awaited<ReturnType<typeof classroomReportControllerGetIndividualReportData>> | undefined) => Awaited<ReturnType<typeof classroomReportControllerGetIndividualReportData>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomReportControllerGetIndividualReportData>>>({ exact: $exactMatch, queryKey: getClassroomReportControllerGetIndividualReportDataQueryKey(params) }, updater);
  };
}

export const useGetClassroomReportControllerGetIndividualReportDataQueryData = () => {
  const queryClient = useQueryClient();
  return (params: ClassroomReportControllerGetIndividualReportDataParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomReportControllerGetIndividualReportData>>>(getClassroomReportControllerGetIndividualReportDataQueryKey(params));
}



export const portfolioAdminControllerCreatePasscode = (
    createPortfolioPasscodeDto: BodyType<CreatePortfolioPasscodeDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortfolioPasscodeResponseDto>(
      {url: `/portfolio/passcodes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPortfolioPasscodeDto, signal
    },
      options);
    }




export const getPortfolioAdminControllerCreatePasscodeMutationKey = () => ['portfolioAdminControllerCreatePasscode'] as const;

export const getPortfolioAdminControllerCreatePasscodeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof portfolioAdminControllerCreatePasscode>>, TError,PortfolioAdminControllerCreatePasscodeMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof portfolioAdminControllerCreatePasscode>>, TError,PortfolioAdminControllerCreatePasscodeMutationVariables, TContext> => {

const mutationKey = getPortfolioAdminControllerCreatePasscodeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof portfolioAdminControllerCreatePasscode>>, PortfolioAdminControllerCreatePasscodeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  portfolioAdminControllerCreatePasscode(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PortfolioAdminControllerCreatePasscodeMutationResult = NonNullable<Awaited<ReturnType<typeof portfolioAdminControllerCreatePasscode>>>
    export type PortfolioAdminControllerCreatePasscodeMutationBody = BodyType<CreatePortfolioPasscodeDto>
    export type PortfolioAdminControllerCreatePasscodeMutationError = ErrorType<unknown>
    export type PortfolioAdminControllerCreatePasscodeMutationVariables = {data: BodyType<CreatePortfolioPasscodeDto>}

    export const usePortfolioAdminControllerCreatePasscode = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof portfolioAdminControllerCreatePasscode>>, TError,PortfolioAdminControllerCreatePasscodeMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof portfolioAdminControllerCreatePasscode>>,
        TError,
        PortfolioAdminControllerCreatePasscodeMutationVariables,
        TContext
      > => {
      return useMutation(getPortfolioAdminControllerCreatePasscodeMutationOptions(options), queryClient);
    }

/**
 * @summary Authenticate with a portfolio passcode
 */
export const portfolioControllerLogin = (
    portfolioLoginDto: BodyType<PortfolioLoginDto>,
 options?: SecondParameter<typeof portfolioCustomInstance>,signal?: AbortSignal
) => {


      return portfolioCustomInstance<PortfolioLoginResponseDto>(
      {url: `/portfolio/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: portfolioLoginDto, signal
    },
      options);
    }




export const getPortfolioControllerLoginMutationKey = () => ['portfolioControllerLogin'] as const;

export const getPortfolioControllerLoginMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof portfolioControllerLogin>>, TError,PortfolioControllerLoginMutationVariables, TContext>, request?: SecondParameter<typeof portfolioCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof portfolioControllerLogin>>, TError,PortfolioControllerLoginMutationVariables, TContext> => {

const mutationKey = getPortfolioControllerLoginMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof portfolioControllerLogin>>, PortfolioControllerLoginMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  portfolioControllerLogin(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PortfolioControllerLoginMutationResult = NonNullable<Awaited<ReturnType<typeof portfolioControllerLogin>>>
    export type PortfolioControllerLoginMutationBody = BodyType<PortfolioLoginDto>
    export type PortfolioControllerLoginMutationError = ErrorType<unknown>
    export type PortfolioControllerLoginMutationVariables = {data: BodyType<PortfolioLoginDto>}

    /**
 * @summary Authenticate with a portfolio passcode
 */
export const usePortfolioControllerLogin = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof portfolioControllerLogin>>, TError,PortfolioControllerLoginMutationVariables, TContext>, request?: SecondParameter<typeof portfolioCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof portfolioControllerLogin>>,
        TError,
        PortfolioControllerLoginMutationVariables,
        TContext
      > => {
      return useMutation(getPortfolioControllerLoginMutationOptions(options), queryClient);
    }

export const portfolioControllerGetProgress = (

 options?: SecondParameter<typeof portfolioCustomInstance>,signal?: AbortSignal
) => {


      return portfolioCustomInstance<PortfolioProgressResponseDto>(
      {url: `/portfolio/progress`, method: 'GET', signal
    },
      options);
    }




export const getPortfolioControllerGetProgressQueryKey = () => {
    return [
    `/portfolio/progress`
    ] as const;
    }


export const getPortfolioControllerGetProgressQueryOptions = <TData = Awaited<ReturnType<typeof portfolioControllerGetProgress>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portfolioControllerGetProgress>>, TError, TData>>, request?: SecondParameter<typeof portfolioCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPortfolioControllerGetProgressQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof portfolioControllerGetProgress>>> = ({ signal }) => portfolioControllerGetProgress(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof portfolioControllerGetProgress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PortfolioControllerGetProgressQueryResult = NonNullable<Awaited<ReturnType<typeof portfolioControllerGetProgress>>>
export type PortfolioControllerGetProgressQueryError = ErrorType<void>


export function usePortfolioControllerGetProgress<TData = Awaited<ReturnType<typeof portfolioControllerGetProgress>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof portfolioControllerGetProgress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof portfolioControllerGetProgress>>,
          TError,
          Awaited<ReturnType<typeof portfolioControllerGetProgress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof portfolioCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePortfolioControllerGetProgress<TData = Awaited<ReturnType<typeof portfolioControllerGetProgress>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portfolioControllerGetProgress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof portfolioControllerGetProgress>>,
          TError,
          Awaited<ReturnType<typeof portfolioControllerGetProgress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof portfolioCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePortfolioControllerGetProgress<TData = Awaited<ReturnType<typeof portfolioControllerGetProgress>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portfolioControllerGetProgress>>, TError, TData>>, request?: SecondParameter<typeof portfolioCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePortfolioControllerGetProgress<TData = Awaited<ReturnType<typeof portfolioControllerGetProgress>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portfolioControllerGetProgress>>, TError, TData>>, request?: SecondParameter<typeof portfolioCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPortfolioControllerGetProgressQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link usePortfolioControllerGetProgress} query
 */
export const invalidatePortfolioControllerGetProgress = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getPortfolioControllerGetProgressQueryKey() }, options);

  return queryClient;
}

export const useSetPortfolioControllerGetProgressQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof portfolioControllerGetProgress>> | undefined | ((old: Awaited<ReturnType<typeof portfolioControllerGetProgress>> | undefined) => Awaited<ReturnType<typeof portfolioControllerGetProgress>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof portfolioControllerGetProgress>>>({ exact: $exactMatch, queryKey: getPortfolioControllerGetProgressQueryKey() }, updater);
  };
}

export const useGetPortfolioControllerGetProgressQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof portfolioControllerGetProgress>>>(getPortfolioControllerGetProgressQueryKey());
}



/**
 * @summary Get activity report for a portfolio lesson attempt
 */
export const portfolioControllerGetActivityReport = (
    lessonInstanceId: string,
    activityInstanceId: string,
 options?: SecondParameter<typeof portfolioCustomInstance>,signal?: AbortSignal
) => {


      return portfolioCustomInstance<PortfolioOESimpleActivityReportDto | PortfolioSimpleTwoWayActivityReportDto>(
      {url: `/portfolio/lesson-instances/${lessonInstanceId}/activity-instances/${activityInstanceId}/activity-report`, method: 'GET', signal
    },
      options);
    }




export const getPortfolioControllerGetActivityReportQueryKey = (lessonInstanceId: string,
    activityInstanceId: string,) => {
    return [
    `/portfolio/lesson-instances/${lessonInstanceId}/activity-instances/${activityInstanceId}/activity-report`
    ] as const;
    }


export const getPortfolioControllerGetActivityReportQueryOptions = <TData = Awaited<ReturnType<typeof portfolioControllerGetActivityReport>>, TError = ErrorType<void>>(lessonInstanceId: string,
    activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portfolioControllerGetActivityReport>>, TError, TData>>, request?: SecondParameter<typeof portfolioCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPortfolioControllerGetActivityReportQueryKey(lessonInstanceId,activityInstanceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof portfolioControllerGetActivityReport>>> = ({ signal }) => portfolioControllerGetActivityReport(lessonInstanceId,activityInstanceId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: lessonInstanceId !== null && lessonInstanceId !== undefined && activityInstanceId !== null && activityInstanceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof portfolioControllerGetActivityReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PortfolioControllerGetActivityReportQueryResult = NonNullable<Awaited<ReturnType<typeof portfolioControllerGetActivityReport>>>
export type PortfolioControllerGetActivityReportQueryError = ErrorType<void>


export function usePortfolioControllerGetActivityReport<TData = Awaited<ReturnType<typeof portfolioControllerGetActivityReport>>, TError = ErrorType<void>>(
 lessonInstanceId: string,
    activityInstanceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof portfolioControllerGetActivityReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof portfolioControllerGetActivityReport>>,
          TError,
          Awaited<ReturnType<typeof portfolioControllerGetActivityReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof portfolioCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePortfolioControllerGetActivityReport<TData = Awaited<ReturnType<typeof portfolioControllerGetActivityReport>>, TError = ErrorType<void>>(
 lessonInstanceId: string,
    activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portfolioControllerGetActivityReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof portfolioControllerGetActivityReport>>,
          TError,
          Awaited<ReturnType<typeof portfolioControllerGetActivityReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof portfolioCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePortfolioControllerGetActivityReport<TData = Awaited<ReturnType<typeof portfolioControllerGetActivityReport>>, TError = ErrorType<void>>(
 lessonInstanceId: string,
    activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portfolioControllerGetActivityReport>>, TError, TData>>, request?: SecondParameter<typeof portfolioCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get activity report for a portfolio lesson attempt
 */

export function usePortfolioControllerGetActivityReport<TData = Awaited<ReturnType<typeof portfolioControllerGetActivityReport>>, TError = ErrorType<void>>(
 lessonInstanceId: string,
    activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portfolioControllerGetActivityReport>>, TError, TData>>, request?: SecondParameter<typeof portfolioCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPortfolioControllerGetActivityReportQueryOptions(lessonInstanceId,activityInstanceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link usePortfolioControllerGetActivityReport} query
 */
export const invalidatePortfolioControllerGetActivityReport = async (
 queryClient: QueryClient, lessonInstanceId: string,
    activityInstanceId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getPortfolioControllerGetActivityReportQueryKey(lessonInstanceId,activityInstanceId) }, options);

  return queryClient;
}

/**
 * @summary Get activity report for a portfolio lesson attempt
 */
export const useSetPortfolioControllerGetActivityReportQueryData = () => {
  const queryClient = useQueryClient();
  return (lessonInstanceId: string,
    activityInstanceId: string,updater: Awaited<ReturnType<typeof portfolioControllerGetActivityReport>> | undefined | ((old: Awaited<ReturnType<typeof portfolioControllerGetActivityReport>> | undefined) => Awaited<ReturnType<typeof portfolioControllerGetActivityReport>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof portfolioControllerGetActivityReport>>>({ exact: $exactMatch, queryKey: getPortfolioControllerGetActivityReportQueryKey(lessonInstanceId,activityInstanceId) }, updater);
  };
}

/**
 * @summary Get activity report for a portfolio lesson attempt
 */
export const useGetPortfolioControllerGetActivityReportQueryData = () => {
  const queryClient = useQueryClient();
  return (lessonInstanceId: string,
    activityInstanceId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof portfolioControllerGetActivityReport>>>(getPortfolioControllerGetActivityReportQueryKey(lessonInstanceId,activityInstanceId));
}



/**
 * @summary Download audio file for portfolio session
 */
export const portfolioControllerGetAudio = (
    params: PortfolioControllerGetAudioParams,
 options?: SecondParameter<typeof portfolioCustomInstance>,signal?: AbortSignal
) => {


      return portfolioCustomInstance<Blob>(
      {url: `/portfolio/audio`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }




export const getPortfolioControllerGetAudioQueryKey = (params?: PortfolioControllerGetAudioParams,) => {
    return [
    `/portfolio/audio`, ...(params ? [params] : [])
    ] as const;
    }


export const getPortfolioControllerGetAudioQueryOptions = <TData = Awaited<ReturnType<typeof portfolioControllerGetAudio>>, TError = ErrorType<void>>(params: PortfolioControllerGetAudioParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portfolioControllerGetAudio>>, TError, TData>>, request?: SecondParameter<typeof portfolioCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPortfolioControllerGetAudioQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof portfolioControllerGetAudio>>> = ({ signal }) => portfolioControllerGetAudio(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof portfolioControllerGetAudio>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PortfolioControllerGetAudioQueryResult = NonNullable<Awaited<ReturnType<typeof portfolioControllerGetAudio>>>
export type PortfolioControllerGetAudioQueryError = ErrorType<void>


export function usePortfolioControllerGetAudio<TData = Awaited<ReturnType<typeof portfolioControllerGetAudio>>, TError = ErrorType<void>>(
 params: PortfolioControllerGetAudioParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof portfolioControllerGetAudio>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof portfolioControllerGetAudio>>,
          TError,
          Awaited<ReturnType<typeof portfolioControllerGetAudio>>
        > , 'initialData'
      >, request?: SecondParameter<typeof portfolioCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePortfolioControllerGetAudio<TData = Awaited<ReturnType<typeof portfolioControllerGetAudio>>, TError = ErrorType<void>>(
 params: PortfolioControllerGetAudioParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portfolioControllerGetAudio>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof portfolioControllerGetAudio>>,
          TError,
          Awaited<ReturnType<typeof portfolioControllerGetAudio>>
        > , 'initialData'
      >, request?: SecondParameter<typeof portfolioCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePortfolioControllerGetAudio<TData = Awaited<ReturnType<typeof portfolioControllerGetAudio>>, TError = ErrorType<void>>(
 params: PortfolioControllerGetAudioParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portfolioControllerGetAudio>>, TError, TData>>, request?: SecondParameter<typeof portfolioCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download audio file for portfolio session
 */

export function usePortfolioControllerGetAudio<TData = Awaited<ReturnType<typeof portfolioControllerGetAudio>>, TError = ErrorType<void>>(
 params: PortfolioControllerGetAudioParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portfolioControllerGetAudio>>, TError, TData>>, request?: SecondParameter<typeof portfolioCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPortfolioControllerGetAudioQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link usePortfolioControllerGetAudio} query
 */
export const invalidatePortfolioControllerGetAudio = async (
 queryClient: QueryClient, params: PortfolioControllerGetAudioParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getPortfolioControllerGetAudioQueryKey(params) }, options);

  return queryClient;
}

/**
 * @summary Download audio file for portfolio session
 */
export const useSetPortfolioControllerGetAudioQueryData = () => {
  const queryClient = useQueryClient();
  return (params: PortfolioControllerGetAudioParams | undefined,updater: Awaited<ReturnType<typeof portfolioControllerGetAudio>> | undefined | ((old: Awaited<ReturnType<typeof portfolioControllerGetAudio>> | undefined) => Awaited<ReturnType<typeof portfolioControllerGetAudio>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof portfolioControllerGetAudio>>>({ exact: $exactMatch, queryKey: getPortfolioControllerGetAudioQueryKey(params) }, updater);
  };
}

/**
 * @summary Download audio file for portfolio session
 */
export const useGetPortfolioControllerGetAudioQueryData = () => {
  const queryClient = useQueryClient();
  return (params: PortfolioControllerGetAudioParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof portfolioControllerGetAudio>>>(getPortfolioControllerGetAudioQueryKey(params));
}



/**
 * @summary Synthesize speech from text for portfolio sessions
 */
export const portfolioControllerSynthesizeSpeech = (
    getSpeechDto: BodyType<GetSpeechDto>,
 options?: SecondParameter<typeof portfolioCustomInstance>,signal?: AbortSignal
) => {


      return portfolioCustomInstance<Blob>(
      {url: `/portfolio/speech/synthesis`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getSpeechDto,
        responseType: 'blob', signal
    },
      options);
    }




export const getPortfolioControllerSynthesizeSpeechMutationKey = () => ['portfolioControllerSynthesizeSpeech'] as const;

export const getPortfolioControllerSynthesizeSpeechMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof portfolioControllerSynthesizeSpeech>>, TError,PortfolioControllerSynthesizeSpeechMutationVariables, TContext>, request?: SecondParameter<typeof portfolioCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof portfolioControllerSynthesizeSpeech>>, TError,PortfolioControllerSynthesizeSpeechMutationVariables, TContext> => {

const mutationKey = getPortfolioControllerSynthesizeSpeechMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof portfolioControllerSynthesizeSpeech>>, PortfolioControllerSynthesizeSpeechMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  portfolioControllerSynthesizeSpeech(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PortfolioControllerSynthesizeSpeechMutationResult = NonNullable<Awaited<ReturnType<typeof portfolioControllerSynthesizeSpeech>>>
    export type PortfolioControllerSynthesizeSpeechMutationBody = BodyType<GetSpeechDto>
    export type PortfolioControllerSynthesizeSpeechMutationError = ErrorType<void>
    export type PortfolioControllerSynthesizeSpeechMutationVariables = {data: BodyType<GetSpeechDto>}

    /**
 * @summary Synthesize speech from text for portfolio sessions
 */
export const usePortfolioControllerSynthesizeSpeech = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof portfolioControllerSynthesizeSpeech>>, TError,PortfolioControllerSynthesizeSpeechMutationVariables, TContext>, request?: SecondParameter<typeof portfolioCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof portfolioControllerSynthesizeSpeech>>,
        TError,
        PortfolioControllerSynthesizeSpeechMutationVariables,
        TContext
      > => {
      return useMutation(getPortfolioControllerSynthesizeSpeechMutationOptions(options), queryClient);
    }

export const lessonReportControllerGetLessonInstanceActivityReports = (
    lessonInstanceId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LessonReportControllerGetLessonInstanceActivityReports200Item[]>(
      {url: `/lesson-report/lesson-instance/${lessonInstanceId}/activity-reports`, method: 'GET', signal
    },
      options);
    }




export const getLessonReportControllerGetLessonInstanceActivityReportsQueryKey = (lessonInstanceId: string,) => {
    return [
    `/lesson-report/lesson-instance/${lessonInstanceId}/activity-reports`
    ] as const;
    }


export const getLessonReportControllerGetLessonInstanceActivityReportsQueryOptions = <TData = Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceActivityReports>>, TError = ErrorType<unknown>>(lessonInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceActivityReports>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLessonReportControllerGetLessonInstanceActivityReportsQueryKey(lessonInstanceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceActivityReports>>> = ({ signal }) => lessonReportControllerGetLessonInstanceActivityReports(lessonInstanceId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: lessonInstanceId !== null && lessonInstanceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceActivityReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LessonReportControllerGetLessonInstanceActivityReportsQueryResult = NonNullable<Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceActivityReports>>>
export type LessonReportControllerGetLessonInstanceActivityReportsQueryError = ErrorType<unknown>


export function useLessonReportControllerGetLessonInstanceActivityReports<TData = Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceActivityReports>>, TError = ErrorType<unknown>>(
 lessonInstanceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceActivityReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceActivityReports>>,
          TError,
          Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceActivityReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonReportControllerGetLessonInstanceActivityReports<TData = Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceActivityReports>>, TError = ErrorType<unknown>>(
 lessonInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceActivityReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceActivityReports>>,
          TError,
          Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceActivityReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonReportControllerGetLessonInstanceActivityReports<TData = Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceActivityReports>>, TError = ErrorType<unknown>>(
 lessonInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceActivityReports>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLessonReportControllerGetLessonInstanceActivityReports<TData = Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceActivityReports>>, TError = ErrorType<unknown>>(
 lessonInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceActivityReports>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLessonReportControllerGetLessonInstanceActivityReportsQueryOptions(lessonInstanceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLessonReportControllerGetLessonInstanceActivityReports} query
 */
export const invalidateLessonReportControllerGetLessonInstanceActivityReports = async (
 queryClient: QueryClient, lessonInstanceId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLessonReportControllerGetLessonInstanceActivityReportsQueryKey(lessonInstanceId) }, options);

  return queryClient;
}

export const useSetLessonReportControllerGetLessonInstanceActivityReportsQueryData = () => {
  const queryClient = useQueryClient();
  return (lessonInstanceId: string,updater: Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceActivityReports>> | undefined | ((old: Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceActivityReports>> | undefined) => Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceActivityReports>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceActivityReports>>>({ exact: $exactMatch, queryKey: getLessonReportControllerGetLessonInstanceActivityReportsQueryKey(lessonInstanceId) }, updater);
  };
}

export const useGetLessonReportControllerGetLessonInstanceActivityReportsQueryData = () => {
  const queryClient = useQueryClient();
  return (lessonInstanceId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceActivityReports>>>(getLessonReportControllerGetLessonInstanceActivityReportsQueryKey(lessonInstanceId));
}



export const lessonReportControllerGetActivityInstanceInstanceActivityReport = (
    lessonInstanceId: string,
    activityInstanceId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LessonReportControllerGetActivityInstanceInstanceActivityReport200>(
      {url: `/lesson-report/lesson-instance/${lessonInstanceId}/activity-instances/${activityInstanceId}/activity-report`, method: 'GET', signal
    },
      options);
    }




export const getLessonReportControllerGetActivityInstanceInstanceActivityReportQueryKey = (lessonInstanceId: string,
    activityInstanceId: string,) => {
    return [
    `/lesson-report/lesson-instance/${lessonInstanceId}/activity-instances/${activityInstanceId}/activity-report`
    ] as const;
    }


export const getLessonReportControllerGetActivityInstanceInstanceActivityReportQueryOptions = <TData = Awaited<ReturnType<typeof lessonReportControllerGetActivityInstanceInstanceActivityReport>>, TError = ErrorType<unknown>>(lessonInstanceId: string,
    activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonReportControllerGetActivityInstanceInstanceActivityReport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLessonReportControllerGetActivityInstanceInstanceActivityReportQueryKey(lessonInstanceId,activityInstanceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lessonReportControllerGetActivityInstanceInstanceActivityReport>>> = ({ signal }) => lessonReportControllerGetActivityInstanceInstanceActivityReport(lessonInstanceId,activityInstanceId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: lessonInstanceId !== null && lessonInstanceId !== undefined && activityInstanceId !== null && activityInstanceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lessonReportControllerGetActivityInstanceInstanceActivityReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LessonReportControllerGetActivityInstanceInstanceActivityReportQueryResult = NonNullable<Awaited<ReturnType<typeof lessonReportControllerGetActivityInstanceInstanceActivityReport>>>
export type LessonReportControllerGetActivityInstanceInstanceActivityReportQueryError = ErrorType<unknown>


export function useLessonReportControllerGetActivityInstanceInstanceActivityReport<TData = Awaited<ReturnType<typeof lessonReportControllerGetActivityInstanceInstanceActivityReport>>, TError = ErrorType<unknown>>(
 lessonInstanceId: string,
    activityInstanceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonReportControllerGetActivityInstanceInstanceActivityReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonReportControllerGetActivityInstanceInstanceActivityReport>>,
          TError,
          Awaited<ReturnType<typeof lessonReportControllerGetActivityInstanceInstanceActivityReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonReportControllerGetActivityInstanceInstanceActivityReport<TData = Awaited<ReturnType<typeof lessonReportControllerGetActivityInstanceInstanceActivityReport>>, TError = ErrorType<unknown>>(
 lessonInstanceId: string,
    activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonReportControllerGetActivityInstanceInstanceActivityReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonReportControllerGetActivityInstanceInstanceActivityReport>>,
          TError,
          Awaited<ReturnType<typeof lessonReportControllerGetActivityInstanceInstanceActivityReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonReportControllerGetActivityInstanceInstanceActivityReport<TData = Awaited<ReturnType<typeof lessonReportControllerGetActivityInstanceInstanceActivityReport>>, TError = ErrorType<unknown>>(
 lessonInstanceId: string,
    activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonReportControllerGetActivityInstanceInstanceActivityReport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLessonReportControllerGetActivityInstanceInstanceActivityReport<TData = Awaited<ReturnType<typeof lessonReportControllerGetActivityInstanceInstanceActivityReport>>, TError = ErrorType<unknown>>(
 lessonInstanceId: string,
    activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonReportControllerGetActivityInstanceInstanceActivityReport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLessonReportControllerGetActivityInstanceInstanceActivityReportQueryOptions(lessonInstanceId,activityInstanceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLessonReportControllerGetActivityInstanceInstanceActivityReport} query
 */
export const invalidateLessonReportControllerGetActivityInstanceInstanceActivityReport = async (
 queryClient: QueryClient, lessonInstanceId: string,
    activityInstanceId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLessonReportControllerGetActivityInstanceInstanceActivityReportQueryKey(lessonInstanceId,activityInstanceId) }, options);

  return queryClient;
}

export const useSetLessonReportControllerGetActivityInstanceInstanceActivityReportQueryData = () => {
  const queryClient = useQueryClient();
  return (lessonInstanceId: string,
    activityInstanceId: string,updater: Awaited<ReturnType<typeof lessonReportControllerGetActivityInstanceInstanceActivityReport>> | undefined | ((old: Awaited<ReturnType<typeof lessonReportControllerGetActivityInstanceInstanceActivityReport>> | undefined) => Awaited<ReturnType<typeof lessonReportControllerGetActivityInstanceInstanceActivityReport>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof lessonReportControllerGetActivityInstanceInstanceActivityReport>>>({ exact: $exactMatch, queryKey: getLessonReportControllerGetActivityInstanceInstanceActivityReportQueryKey(lessonInstanceId,activityInstanceId) }, updater);
  };
}

export const useGetLessonReportControllerGetActivityInstanceInstanceActivityReportQueryData = () => {
  const queryClient = useQueryClient();
  return (lessonInstanceId: string,
    activityInstanceId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof lessonReportControllerGetActivityInstanceInstanceActivityReport>>>(getLessonReportControllerGetActivityInstanceInstanceActivityReportQueryKey(lessonInstanceId,activityInstanceId));
}



export const lessonReportControllerGetLessonInstanceVoiceResponseByStudent = (
    lessonInstanceId: string,
    taskTransactionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/lesson-report/lessonInstances/${lessonInstanceId}/taskTransaction/${taskTransactionId}/voice-response`, method: 'GET', signal
    },
      options);
    }




export const getLessonReportControllerGetLessonInstanceVoiceResponseByStudentQueryKey = (lessonInstanceId: string,
    taskTransactionId: string,) => {
    return [
    `/lesson-report/lessonInstances/${lessonInstanceId}/taskTransaction/${taskTransactionId}/voice-response`
    ] as const;
    }


export const getLessonReportControllerGetLessonInstanceVoiceResponseByStudentQueryOptions = <TData = Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceVoiceResponseByStudent>>, TError = ErrorType<unknown>>(lessonInstanceId: string,
    taskTransactionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceVoiceResponseByStudent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLessonReportControllerGetLessonInstanceVoiceResponseByStudentQueryKey(lessonInstanceId,taskTransactionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceVoiceResponseByStudent>>> = ({ signal }) => lessonReportControllerGetLessonInstanceVoiceResponseByStudent(lessonInstanceId,taskTransactionId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: lessonInstanceId !== null && lessonInstanceId !== undefined && taskTransactionId !== null && taskTransactionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceVoiceResponseByStudent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LessonReportControllerGetLessonInstanceVoiceResponseByStudentQueryResult = NonNullable<Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceVoiceResponseByStudent>>>
export type LessonReportControllerGetLessonInstanceVoiceResponseByStudentQueryError = ErrorType<unknown>


export function useLessonReportControllerGetLessonInstanceVoiceResponseByStudent<TData = Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceVoiceResponseByStudent>>, TError = ErrorType<unknown>>(
 lessonInstanceId: string,
    taskTransactionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceVoiceResponseByStudent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceVoiceResponseByStudent>>,
          TError,
          Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceVoiceResponseByStudent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonReportControllerGetLessonInstanceVoiceResponseByStudent<TData = Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceVoiceResponseByStudent>>, TError = ErrorType<unknown>>(
 lessonInstanceId: string,
    taskTransactionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceVoiceResponseByStudent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceVoiceResponseByStudent>>,
          TError,
          Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceVoiceResponseByStudent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonReportControllerGetLessonInstanceVoiceResponseByStudent<TData = Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceVoiceResponseByStudent>>, TError = ErrorType<unknown>>(
 lessonInstanceId: string,
    taskTransactionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceVoiceResponseByStudent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLessonReportControllerGetLessonInstanceVoiceResponseByStudent<TData = Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceVoiceResponseByStudent>>, TError = ErrorType<unknown>>(
 lessonInstanceId: string,
    taskTransactionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceVoiceResponseByStudent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLessonReportControllerGetLessonInstanceVoiceResponseByStudentQueryOptions(lessonInstanceId,taskTransactionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLessonReportControllerGetLessonInstanceVoiceResponseByStudent} query
 */
export const invalidateLessonReportControllerGetLessonInstanceVoiceResponseByStudent = async (
 queryClient: QueryClient, lessonInstanceId: string,
    taskTransactionId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLessonReportControllerGetLessonInstanceVoiceResponseByStudentQueryKey(lessonInstanceId,taskTransactionId) }, options);

  return queryClient;
}

export const useSetLessonReportControllerGetLessonInstanceVoiceResponseByStudentQueryData = () => {
  const queryClient = useQueryClient();
  return (lessonInstanceId: string,
    taskTransactionId: string,updater: Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceVoiceResponseByStudent>> | undefined | ((old: Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceVoiceResponseByStudent>> | undefined) => Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceVoiceResponseByStudent>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceVoiceResponseByStudent>>>({ exact: $exactMatch, queryKey: getLessonReportControllerGetLessonInstanceVoiceResponseByStudentQueryKey(lessonInstanceId,taskTransactionId) }, updater);
  };
}

export const useGetLessonReportControllerGetLessonInstanceVoiceResponseByStudentQueryData = () => {
  const queryClient = useQueryClient();
  return (lessonInstanceId: string,
    taskTransactionId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof lessonReportControllerGetLessonInstanceVoiceResponseByStudent>>>(getLessonReportControllerGetLessonInstanceVoiceResponseByStudentQueryKey(lessonInstanceId,taskTransactionId));
}



/**
 * @summary Synthesize speech from text
 */
export const speechControllerSpeech = (
    getSpeechDto: BodyType<GetSpeechDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Blob>(
      {url: `/speech/synthesis`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getSpeechDto,
        responseType: 'blob', signal
    },
      options);
    }




export const getSpeechControllerSpeechMutationKey = () => ['speechControllerSpeech'] as const;

export const getSpeechControllerSpeechMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof speechControllerSpeech>>, TError,SpeechControllerSpeechMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof speechControllerSpeech>>, TError,SpeechControllerSpeechMutationVariables, TContext> => {

const mutationKey = getSpeechControllerSpeechMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof speechControllerSpeech>>, SpeechControllerSpeechMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  speechControllerSpeech(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SpeechControllerSpeechMutationResult = NonNullable<Awaited<ReturnType<typeof speechControllerSpeech>>>
    export type SpeechControllerSpeechMutationBody = BodyType<GetSpeechDto>
    export type SpeechControllerSpeechMutationError = ErrorType<unknown>
    export type SpeechControllerSpeechMutationVariables = {data: BodyType<GetSpeechDto>}

    /**
 * @summary Synthesize speech from text
 */
export const useSpeechControllerSpeech = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof speechControllerSpeech>>, TError,SpeechControllerSpeechMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof speechControllerSpeech>>,
        TError,
        SpeechControllerSpeechMutationVariables,
        TContext
      > => {
      return useMutation(getSpeechControllerSpeechMutationOptions(options), queryClient);
    }

/**
 * @summary Login with an Edsy access code
 */
export const authControllerLoginWithAccessCode = (
    loginBodyDto: BodyType<LoginBodyDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AccessCodeLoginResponseDto>(
      {url: `/auth/login/access-code`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginBodyDto, signal
    },
      options);
    }




export const getAuthControllerLoginWithAccessCodeMutationKey = () => ['authControllerLoginWithAccessCode'] as const;

export const getAuthControllerLoginWithAccessCodeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerLoginWithAccessCode>>, TError,AuthControllerLoginWithAccessCodeMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof authControllerLoginWithAccessCode>>, TError,AuthControllerLoginWithAccessCodeMutationVariables, TContext> => {

const mutationKey = getAuthControllerLoginWithAccessCodeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerLoginWithAccessCode>>, AuthControllerLoginWithAccessCodeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authControllerLoginWithAccessCode(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerLoginWithAccessCodeMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerLoginWithAccessCode>>>
    export type AuthControllerLoginWithAccessCodeMutationBody = BodyType<LoginBodyDto>
    export type AuthControllerLoginWithAccessCodeMutationError = ErrorType<unknown>
    export type AuthControllerLoginWithAccessCodeMutationVariables = {data: BodyType<LoginBodyDto>}

    /**
 * @summary Login with an Edsy access code
 */
export const useAuthControllerLoginWithAccessCode = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerLoginWithAccessCode>>, TError,AuthControllerLoginWithAccessCodeMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authControllerLoginWithAccessCode>>,
        TError,
        AuthControllerLoginWithAccessCodeMutationVariables,
        TContext
      > => {
      return useMutation(getAuthControllerLoginWithAccessCodeMutationOptions(options), queryClient);
    }

/**
 * @summary Create an account from the enrollment sheet
 */
export const authControllerSignup = (
    signupDto: BodyType<SignupDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SignupResponseDto>(
      {url: `/auth/signup`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: signupDto, signal
    },
      options);
    }




export const getAuthControllerSignupMutationKey = () => ['authControllerSignup'] as const;

export const getAuthControllerSignupMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerSignup>>, TError,AuthControllerSignupMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof authControllerSignup>>, TError,AuthControllerSignupMutationVariables, TContext> => {

const mutationKey = getAuthControllerSignupMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerSignup>>, AuthControllerSignupMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authControllerSignup(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerSignupMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerSignup>>>
    export type AuthControllerSignupMutationBody = BodyType<SignupDto>
    export type AuthControllerSignupMutationError = ErrorType<unknown>
    export type AuthControllerSignupMutationVariables = {data: BodyType<SignupDto>}

    /**
 * @summary Create an account from the enrollment sheet
 */
export const useAuthControllerSignup = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerSignup>>, TError,AuthControllerSignupMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authControllerSignup>>,
        TError,
        AuthControllerSignupMutationVariables,
        TContext
      > => {
      return useMutation(getAuthControllerSignupMutationOptions(options), queryClient);
    }

export const authControllerGetLoginMethods = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LoginMethodsResponseDto>(
      {url: `/auth/login-methods`, method: 'GET', signal
    },
      options);
    }




export const getAuthControllerGetLoginMethodsQueryKey = () => {
    return [
    `/auth/login-methods`
    ] as const;
    }


export const getAuthControllerGetLoginMethodsQueryOptions = <TData = Awaited<ReturnType<typeof authControllerGetLoginMethods>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerGetLoginMethods>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthControllerGetLoginMethodsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authControllerGetLoginMethods>>> = ({ signal }) => authControllerGetLoginMethods(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authControllerGetLoginMethods>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthControllerGetLoginMethodsQueryResult = NonNullable<Awaited<ReturnType<typeof authControllerGetLoginMethods>>>
export type AuthControllerGetLoginMethodsQueryError = ErrorType<unknown>


export function useAuthControllerGetLoginMethods<TData = Awaited<ReturnType<typeof authControllerGetLoginMethods>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerGetLoginMethods>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerGetLoginMethods>>,
          TError,
          Awaited<ReturnType<typeof authControllerGetLoginMethods>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthControllerGetLoginMethods<TData = Awaited<ReturnType<typeof authControllerGetLoginMethods>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerGetLoginMethods>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerGetLoginMethods>>,
          TError,
          Awaited<ReturnType<typeof authControllerGetLoginMethods>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthControllerGetLoginMethods<TData = Awaited<ReturnType<typeof authControllerGetLoginMethods>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerGetLoginMethods>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAuthControllerGetLoginMethods<TData = Awaited<ReturnType<typeof authControllerGetLoginMethods>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerGetLoginMethods>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthControllerGetLoginMethodsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useAuthControllerGetLoginMethods} query
 */
export const invalidateAuthControllerGetLoginMethods = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getAuthControllerGetLoginMethodsQueryKey() }, options);

  return queryClient;
}

export const useSetAuthControllerGetLoginMethodsQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof authControllerGetLoginMethods>> | undefined | ((old: Awaited<ReturnType<typeof authControllerGetLoginMethods>> | undefined) => Awaited<ReturnType<typeof authControllerGetLoginMethods>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof authControllerGetLoginMethods>>>({ exact: $exactMatch, queryKey: getAuthControllerGetLoginMethodsQueryKey() }, updater);
  };
}

export const useGetAuthControllerGetLoginMethodsQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof authControllerGetLoginMethods>>>(getAuthControllerGetLoginMethodsQueryKey());
}



export const authControllerUpdateLoginMethods = (
    updateLoginMethodsDto: BodyType<UpdateLoginMethodsDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LoginMethodsResponseDto>(
      {url: `/auth/login-methods`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateLoginMethodsDto, signal
    },
      options);
    }




export const getAuthControllerUpdateLoginMethodsMutationKey = () => ['authControllerUpdateLoginMethods'] as const;

export const getAuthControllerUpdateLoginMethodsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerUpdateLoginMethods>>, TError,AuthControllerUpdateLoginMethodsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof authControllerUpdateLoginMethods>>, TError,AuthControllerUpdateLoginMethodsMutationVariables, TContext> => {

const mutationKey = getAuthControllerUpdateLoginMethodsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerUpdateLoginMethods>>, AuthControllerUpdateLoginMethodsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authControllerUpdateLoginMethods(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerUpdateLoginMethodsMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerUpdateLoginMethods>>>
    export type AuthControllerUpdateLoginMethodsMutationBody = BodyType<UpdateLoginMethodsDto>
    export type AuthControllerUpdateLoginMethodsMutationError = ErrorType<unknown>
    export type AuthControllerUpdateLoginMethodsMutationVariables = {data: BodyType<UpdateLoginMethodsDto>}

    export const useAuthControllerUpdateLoginMethods = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerUpdateLoginMethods>>, TError,AuthControllerUpdateLoginMethodsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authControllerUpdateLoginMethods>>,
        TError,
        AuthControllerUpdateLoginMethodsMutationVariables,
        TContext
      > => {
      return useMutation(getAuthControllerUpdateLoginMethodsMutationOptions(options), queryClient);
    }

export const authControllerConfirmEmailLink = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LoginMethodsResponseDto>(
      {url: `/auth/link/email/confirm`, method: 'POST', signal
    },
      options);
    }




export const getAuthControllerConfirmEmailLinkMutationKey = () => ['authControllerConfirmEmailLink'] as const;

export const getAuthControllerConfirmEmailLinkMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerConfirmEmailLink>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof authControllerConfirmEmailLink>>, TError,void, TContext> => {

const mutationKey = getAuthControllerConfirmEmailLinkMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerConfirmEmailLink>>, void> = () => {


          return  authControllerConfirmEmailLink(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerConfirmEmailLinkMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerConfirmEmailLink>>>

    export type AuthControllerConfirmEmailLinkMutationError = ErrorType<unknown>


    export const useAuthControllerConfirmEmailLink = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerConfirmEmailLink>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authControllerConfirmEmailLink>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAuthControllerConfirmEmailLinkMutationOptions(options), queryClient);
    }

export const authControllerConfirmGoogleLink = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LoginMethodsResponseDto>(
      {url: `/auth/link/google/confirm`, method: 'POST', signal
    },
      options);
    }




export const getAuthControllerConfirmGoogleLinkMutationKey = () => ['authControllerConfirmGoogleLink'] as const;

export const getAuthControllerConfirmGoogleLinkMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerConfirmGoogleLink>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof authControllerConfirmGoogleLink>>, TError,void, TContext> => {

const mutationKey = getAuthControllerConfirmGoogleLinkMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerConfirmGoogleLink>>, void> = () => {


          return  authControllerConfirmGoogleLink(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerConfirmGoogleLinkMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerConfirmGoogleLink>>>

    export type AuthControllerConfirmGoogleLinkMutationError = ErrorType<unknown>


    export const useAuthControllerConfirmGoogleLink = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerConfirmGoogleLink>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authControllerConfirmGoogleLink>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAuthControllerConfirmGoogleLinkMutationOptions(options), queryClient);
    }

export const authControllerChangePassword = (
    changePasswordDto: BodyType<ChangePasswordDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/auth/password/change`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: changePasswordDto, signal
    },
      options);
    }




export const getAuthControllerChangePasswordMutationKey = () => ['authControllerChangePassword'] as const;

export const getAuthControllerChangePasswordMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerChangePassword>>, TError,AuthControllerChangePasswordMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof authControllerChangePassword>>, TError,AuthControllerChangePasswordMutationVariables, TContext> => {

const mutationKey = getAuthControllerChangePasswordMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerChangePassword>>, AuthControllerChangePasswordMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authControllerChangePassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerChangePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerChangePassword>>>
    export type AuthControllerChangePasswordMutationBody = BodyType<ChangePasswordDto>
    export type AuthControllerChangePasswordMutationError = ErrorType<unknown>
    export type AuthControllerChangePasswordMutationVariables = {data: BodyType<ChangePasswordDto>}

    export const useAuthControllerChangePassword = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerChangePassword>>, TError,AuthControllerChangePasswordMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authControllerChangePassword>>,
        TError,
        AuthControllerChangePasswordMutationVariables,
        TContext
      > => {
      return useMutation(getAuthControllerChangePasswordMutationOptions(options), queryClient);
    }

export const courseControllerCreate = (
    createCourseDto: BodyType<CreateCourseDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CourseResponseDto>(
      {url: `/courses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCourseDto, signal
    },
      options);
    }




export const getCourseControllerCreateMutationKey = () => ['courseControllerCreate'] as const;

export const getCourseControllerCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof courseControllerCreate>>, TError,CourseControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof courseControllerCreate>>, TError,CourseControllerCreateMutationVariables, TContext> => {

const mutationKey = getCourseControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof courseControllerCreate>>, CourseControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  courseControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CourseControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof courseControllerCreate>>>
    export type CourseControllerCreateMutationBody = BodyType<CreateCourseDto>
    export type CourseControllerCreateMutationError = ErrorType<unknown>
    export type CourseControllerCreateMutationVariables = {data: BodyType<CreateCourseDto>}

    export const useCourseControllerCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof courseControllerCreate>>, TError,CourseControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof courseControllerCreate>>,
        TError,
        CourseControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getCourseControllerCreateMutationOptions(options), queryClient);
    }

export const courseControllerFindAll = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CourseResponseDto[]>(
      {url: `/courses`, method: 'GET', signal
    },
      options);
    }




export const getCourseControllerFindAllQueryKey = () => {
    return [
    `/courses`
    ] as const;
    }


export const getCourseControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof courseControllerFindAll>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof courseControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCourseControllerFindAllQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof courseControllerFindAll>>> = ({ signal }) => courseControllerFindAll(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof courseControllerFindAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CourseControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof courseControllerFindAll>>>
export type CourseControllerFindAllQueryError = ErrorType<unknown>


export function useCourseControllerFindAll<TData = Awaited<ReturnType<typeof courseControllerFindAll>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof courseControllerFindAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof courseControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof courseControllerFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCourseControllerFindAll<TData = Awaited<ReturnType<typeof courseControllerFindAll>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof courseControllerFindAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof courseControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof courseControllerFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCourseControllerFindAll<TData = Awaited<ReturnType<typeof courseControllerFindAll>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof courseControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCourseControllerFindAll<TData = Awaited<ReturnType<typeof courseControllerFindAll>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof courseControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCourseControllerFindAllQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useCourseControllerFindAll} query
 */
export const invalidateCourseControllerFindAll = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getCourseControllerFindAllQueryKey() }, options);

  return queryClient;
}

export const useSetCourseControllerFindAllQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof courseControllerFindAll>> | undefined | ((old: Awaited<ReturnType<typeof courseControllerFindAll>> | undefined) => Awaited<ReturnType<typeof courseControllerFindAll>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof courseControllerFindAll>>>({ exact: $exactMatch, queryKey: getCourseControllerFindAllQueryKey() }, updater);
  };
}

export const useGetCourseControllerFindAllQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof courseControllerFindAll>>>(getCourseControllerFindAllQueryKey());
}



export const courseControllerFindById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CourseResponseDto>(
      {url: `/courses/${id}`, method: 'GET', signal
    },
      options);
    }




export const getCourseControllerFindByIdQueryKey = (id: string,) => {
    return [
    `/courses/${id}`
    ] as const;
    }


export const getCourseControllerFindByIdQueryOptions = <TData = Awaited<ReturnType<typeof courseControllerFindById>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof courseControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCourseControllerFindByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof courseControllerFindById>>> = ({ signal }) => courseControllerFindById(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof courseControllerFindById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CourseControllerFindByIdQueryResult = NonNullable<Awaited<ReturnType<typeof courseControllerFindById>>>
export type CourseControllerFindByIdQueryError = ErrorType<unknown>


export function useCourseControllerFindById<TData = Awaited<ReturnType<typeof courseControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof courseControllerFindById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof courseControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof courseControllerFindById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCourseControllerFindById<TData = Awaited<ReturnType<typeof courseControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof courseControllerFindById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof courseControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof courseControllerFindById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCourseControllerFindById<TData = Awaited<ReturnType<typeof courseControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof courseControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCourseControllerFindById<TData = Awaited<ReturnType<typeof courseControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof courseControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCourseControllerFindByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useCourseControllerFindById} query
 */
export const invalidateCourseControllerFindById = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getCourseControllerFindByIdQueryKey(id) }, options);

  return queryClient;
}

export const useSetCourseControllerFindByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof courseControllerFindById>> | undefined | ((old: Awaited<ReturnType<typeof courseControllerFindById>> | undefined) => Awaited<ReturnType<typeof courseControllerFindById>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof courseControllerFindById>>>({ exact: $exactMatch, queryKey: getCourseControllerFindByIdQueryKey(id) }, updater);
  };
}

export const useGetCourseControllerFindByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof courseControllerFindById>>>(getCourseControllerFindByIdQueryKey(id));
}



export const courseControllerUpdate = (
    id: string,
    updateCourseDto: BodyType<UpdateCourseDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CourseResponseDto>(
      {url: `/courses/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCourseDto, signal
    },
      options);
    }




export const getCourseControllerUpdateMutationKey = () => ['courseControllerUpdate'] as const;

export const getCourseControllerUpdateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof courseControllerUpdate>>, TError,CourseControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof courseControllerUpdate>>, TError,CourseControllerUpdateMutationVariables, TContext> => {

const mutationKey = getCourseControllerUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof courseControllerUpdate>>, CourseControllerUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  courseControllerUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CourseControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof courseControllerUpdate>>>
    export type CourseControllerUpdateMutationBody = BodyType<UpdateCourseDto>
    export type CourseControllerUpdateMutationError = ErrorType<unknown>
    export type CourseControllerUpdateMutationVariables = {id: string;data: BodyType<UpdateCourseDto>}

    export const useCourseControllerUpdate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof courseControllerUpdate>>, TError,CourseControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof courseControllerUpdate>>,
        TError,
        CourseControllerUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getCourseControllerUpdateMutationOptions(options), queryClient);
    }

/**
 * @summary Upload course cover image to GCS (Admin)
 */
export const courseControllerUploadCoverImage = (
    courseControllerUploadCoverImageBody: BodyType<CourseControllerUploadCoverImageBody>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {

      const formData = new FormData();
if(courseControllerUploadCoverImageBody.file !== undefined) {
 formData.append(`file`, courseControllerUploadCoverImageBody.file);
 }

      return customInstance<void>(
      {url: `/courses/upload-cover-image`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getCourseControllerUploadCoverImageMutationKey = () => ['courseControllerUploadCoverImage'] as const;

export const getCourseControllerUploadCoverImageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof courseControllerUploadCoverImage>>, TError,CourseControllerUploadCoverImageMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof courseControllerUploadCoverImage>>, TError,CourseControllerUploadCoverImageMutationVariables, TContext> => {

const mutationKey = getCourseControllerUploadCoverImageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof courseControllerUploadCoverImage>>, CourseControllerUploadCoverImageMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  courseControllerUploadCoverImage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CourseControllerUploadCoverImageMutationResult = NonNullable<Awaited<ReturnType<typeof courseControllerUploadCoverImage>>>
    export type CourseControllerUploadCoverImageMutationBody = BodyType<CourseControllerUploadCoverImageBody>
    export type CourseControllerUploadCoverImageMutationError = ErrorType<unknown>
    export type CourseControllerUploadCoverImageMutationVariables = {data: BodyType<CourseControllerUploadCoverImageBody>}

    /**
 * @summary Upload course cover image to GCS (Admin)
 */
export const useCourseControllerUploadCoverImage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof courseControllerUploadCoverImage>>, TError,CourseControllerUploadCoverImageMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof courseControllerUploadCoverImage>>,
        TError,
        CourseControllerUploadCoverImageMutationVariables,
        TContext
      > => {
      return useMutation(getCourseControllerUploadCoverImageMutationOptions(options), queryClient);
    }

export const courseControllerValidate = (
    code: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ValidCourseResponseDto | InvalidCourseResponseDto>(
      {url: `/courses/validate/${code}`, method: 'POST', signal
    },
      options);
    }




export const getCourseControllerValidateMutationKey = () => ['courseControllerValidate'] as const;

export const getCourseControllerValidateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof courseControllerValidate>>, TError,CourseControllerValidateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof courseControllerValidate>>, TError,CourseControllerValidateMutationVariables, TContext> => {

const mutationKey = getCourseControllerValidateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof courseControllerValidate>>, CourseControllerValidateMutationVariables> = (props) => {
          const {code} = props ?? {};

          return  courseControllerValidate(code,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CourseControllerValidateMutationResult = NonNullable<Awaited<ReturnType<typeof courseControllerValidate>>>

    export type CourseControllerValidateMutationError = ErrorType<unknown>
    export type CourseControllerValidateMutationVariables = {code: string}

    export const useCourseControllerValidate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof courseControllerValidate>>, TError,CourseControllerValidateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof courseControllerValidate>>,
        TError,
        CourseControllerValidateMutationVariables,
        TContext
      > => {
      return useMutation(getCourseControllerValidateMutationOptions(options), queryClient);
    }

export const summaryControllerGetLeaderboard = (
    classroomId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SummaryControllerGetLeaderboard200Item[]>(
      {url: `/summary/leaderboard/${classroomId}`, method: 'GET', signal
    },
      options);
    }




export const getSummaryControllerGetLeaderboardQueryKey = (classroomId: string,) => {
    return [
    `/summary/leaderboard/${classroomId}`
    ] as const;
    }


export const getSummaryControllerGetLeaderboardQueryOptions = <TData = Awaited<ReturnType<typeof summaryControllerGetLeaderboard>>, TError = ErrorType<unknown>>(classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof summaryControllerGetLeaderboard>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSummaryControllerGetLeaderboardQueryKey(classroomId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof summaryControllerGetLeaderboard>>> = ({ signal }) => summaryControllerGetLeaderboard(classroomId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof summaryControllerGetLeaderboard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SummaryControllerGetLeaderboardQueryResult = NonNullable<Awaited<ReturnType<typeof summaryControllerGetLeaderboard>>>
export type SummaryControllerGetLeaderboardQueryError = ErrorType<unknown>


export function useSummaryControllerGetLeaderboard<TData = Awaited<ReturnType<typeof summaryControllerGetLeaderboard>>, TError = ErrorType<unknown>>(
 classroomId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof summaryControllerGetLeaderboard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof summaryControllerGetLeaderboard>>,
          TError,
          Awaited<ReturnType<typeof summaryControllerGetLeaderboard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSummaryControllerGetLeaderboard<TData = Awaited<ReturnType<typeof summaryControllerGetLeaderboard>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof summaryControllerGetLeaderboard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof summaryControllerGetLeaderboard>>,
          TError,
          Awaited<ReturnType<typeof summaryControllerGetLeaderboard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSummaryControllerGetLeaderboard<TData = Awaited<ReturnType<typeof summaryControllerGetLeaderboard>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof summaryControllerGetLeaderboard>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSummaryControllerGetLeaderboard<TData = Awaited<ReturnType<typeof summaryControllerGetLeaderboard>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof summaryControllerGetLeaderboard>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSummaryControllerGetLeaderboardQueryOptions(classroomId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useSummaryControllerGetLeaderboard} query
 */
export const invalidateSummaryControllerGetLeaderboard = async (
 queryClient: QueryClient, classroomId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getSummaryControllerGetLeaderboardQueryKey(classroomId) }, options);

  return queryClient;
}

export const useSetSummaryControllerGetLeaderboardQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,updater: Awaited<ReturnType<typeof summaryControllerGetLeaderboard>> | undefined | ((old: Awaited<ReturnType<typeof summaryControllerGetLeaderboard>> | undefined) => Awaited<ReturnType<typeof summaryControllerGetLeaderboard>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof summaryControllerGetLeaderboard>>>({ exact: $exactMatch, queryKey: getSummaryControllerGetLeaderboardQueryKey(classroomId) }, updater);
  };
}

export const useGetSummaryControllerGetLeaderboardQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof summaryControllerGetLeaderboard>>>(getSummaryControllerGetLeaderboardQueryKey(classroomId));
}



export const summaryControllerGetScoreLeaderboard = (
    classroomId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SummaryControllerGetScoreLeaderboard200Item[]>(
      {url: `/summary/score-leaderboard/${classroomId}`, method: 'GET', signal
    },
      options);
    }




export const getSummaryControllerGetScoreLeaderboardQueryKey = (classroomId: string,) => {
    return [
    `/summary/score-leaderboard/${classroomId}`
    ] as const;
    }


export const getSummaryControllerGetScoreLeaderboardQueryOptions = <TData = Awaited<ReturnType<typeof summaryControllerGetScoreLeaderboard>>, TError = ErrorType<unknown>>(classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof summaryControllerGetScoreLeaderboard>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSummaryControllerGetScoreLeaderboardQueryKey(classroomId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof summaryControllerGetScoreLeaderboard>>> = ({ signal }) => summaryControllerGetScoreLeaderboard(classroomId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof summaryControllerGetScoreLeaderboard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SummaryControllerGetScoreLeaderboardQueryResult = NonNullable<Awaited<ReturnType<typeof summaryControllerGetScoreLeaderboard>>>
export type SummaryControllerGetScoreLeaderboardQueryError = ErrorType<unknown>


export function useSummaryControllerGetScoreLeaderboard<TData = Awaited<ReturnType<typeof summaryControllerGetScoreLeaderboard>>, TError = ErrorType<unknown>>(
 classroomId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof summaryControllerGetScoreLeaderboard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof summaryControllerGetScoreLeaderboard>>,
          TError,
          Awaited<ReturnType<typeof summaryControllerGetScoreLeaderboard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSummaryControllerGetScoreLeaderboard<TData = Awaited<ReturnType<typeof summaryControllerGetScoreLeaderboard>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof summaryControllerGetScoreLeaderboard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof summaryControllerGetScoreLeaderboard>>,
          TError,
          Awaited<ReturnType<typeof summaryControllerGetScoreLeaderboard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSummaryControllerGetScoreLeaderboard<TData = Awaited<ReturnType<typeof summaryControllerGetScoreLeaderboard>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof summaryControllerGetScoreLeaderboard>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSummaryControllerGetScoreLeaderboard<TData = Awaited<ReturnType<typeof summaryControllerGetScoreLeaderboard>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof summaryControllerGetScoreLeaderboard>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSummaryControllerGetScoreLeaderboardQueryOptions(classroomId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useSummaryControllerGetScoreLeaderboard} query
 */
export const invalidateSummaryControllerGetScoreLeaderboard = async (
 queryClient: QueryClient, classroomId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getSummaryControllerGetScoreLeaderboardQueryKey(classroomId) }, options);

  return queryClient;
}

export const useSetSummaryControllerGetScoreLeaderboardQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,updater: Awaited<ReturnType<typeof summaryControllerGetScoreLeaderboard>> | undefined | ((old: Awaited<ReturnType<typeof summaryControllerGetScoreLeaderboard>> | undefined) => Awaited<ReturnType<typeof summaryControllerGetScoreLeaderboard>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof summaryControllerGetScoreLeaderboard>>>({ exact: $exactMatch, queryKey: getSummaryControllerGetScoreLeaderboardQueryKey(classroomId) }, updater);
  };
}

export const useGetSummaryControllerGetScoreLeaderboardQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof summaryControllerGetScoreLeaderboard>>>(getSummaryControllerGetScoreLeaderboardQueryKey(classroomId));
}



export const summaryControllerGetUserSummary = (
    userId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SummaryControllerGetUserSummary200>(
      {url: `/summary/users/${userId}`, method: 'GET', signal
    },
      options);
    }




export const getSummaryControllerGetUserSummaryQueryKey = (userId: string,) => {
    return [
    `/summary/users/${userId}`
    ] as const;
    }


export const getSummaryControllerGetUserSummaryQueryOptions = <TData = Awaited<ReturnType<typeof summaryControllerGetUserSummary>>, TError = ErrorType<unknown>>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof summaryControllerGetUserSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSummaryControllerGetUserSummaryQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof summaryControllerGetUserSummary>>> = ({ signal }) => summaryControllerGetUserSummary(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof summaryControllerGetUserSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SummaryControllerGetUserSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof summaryControllerGetUserSummary>>>
export type SummaryControllerGetUserSummaryQueryError = ErrorType<unknown>


export function useSummaryControllerGetUserSummary<TData = Awaited<ReturnType<typeof summaryControllerGetUserSummary>>, TError = ErrorType<unknown>>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof summaryControllerGetUserSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof summaryControllerGetUserSummary>>,
          TError,
          Awaited<ReturnType<typeof summaryControllerGetUserSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSummaryControllerGetUserSummary<TData = Awaited<ReturnType<typeof summaryControllerGetUserSummary>>, TError = ErrorType<unknown>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof summaryControllerGetUserSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof summaryControllerGetUserSummary>>,
          TError,
          Awaited<ReturnType<typeof summaryControllerGetUserSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSummaryControllerGetUserSummary<TData = Awaited<ReturnType<typeof summaryControllerGetUserSummary>>, TError = ErrorType<unknown>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof summaryControllerGetUserSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSummaryControllerGetUserSummary<TData = Awaited<ReturnType<typeof summaryControllerGetUserSummary>>, TError = ErrorType<unknown>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof summaryControllerGetUserSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSummaryControllerGetUserSummaryQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useSummaryControllerGetUserSummary} query
 */
export const invalidateSummaryControllerGetUserSummary = async (
 queryClient: QueryClient, userId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getSummaryControllerGetUserSummaryQueryKey(userId) }, options);

  return queryClient;
}

export const useSetSummaryControllerGetUserSummaryQueryData = () => {
  const queryClient = useQueryClient();
  return (userId: string,updater: Awaited<ReturnType<typeof summaryControllerGetUserSummary>> | undefined | ((old: Awaited<ReturnType<typeof summaryControllerGetUserSummary>> | undefined) => Awaited<ReturnType<typeof summaryControllerGetUserSummary>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof summaryControllerGetUserSummary>>>({ exact: $exactMatch, queryKey: getSummaryControllerGetUserSummaryQueryKey(userId) }, updater);
  };
}

export const useGetSummaryControllerGetUserSummaryQueryData = () => {
  const queryClient = useQueryClient();
  return (userId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof summaryControllerGetUserSummary>>>(getSummaryControllerGetUserSummaryQueryKey(userId));
}



export const registrationControllerCreateUserWithAccessCode = (
    createUserWithAccessCodeDto: BodyType<CreateUserWithAccessCodeDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/registration/user-with-access-code`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserWithAccessCodeDto, signal
    },
      options);
    }




export const getRegistrationControllerCreateUserWithAccessCodeMutationKey = () => ['registrationControllerCreateUserWithAccessCode'] as const;

export const getRegistrationControllerCreateUserWithAccessCodeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registrationControllerCreateUserWithAccessCode>>, TError,RegistrationControllerCreateUserWithAccessCodeMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof registrationControllerCreateUserWithAccessCode>>, TError,RegistrationControllerCreateUserWithAccessCodeMutationVariables, TContext> => {

const mutationKey = getRegistrationControllerCreateUserWithAccessCodeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registrationControllerCreateUserWithAccessCode>>, RegistrationControllerCreateUserWithAccessCodeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  registrationControllerCreateUserWithAccessCode(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegistrationControllerCreateUserWithAccessCodeMutationResult = NonNullable<Awaited<ReturnType<typeof registrationControllerCreateUserWithAccessCode>>>
    export type RegistrationControllerCreateUserWithAccessCodeMutationBody = BodyType<CreateUserWithAccessCodeDto>
    export type RegistrationControllerCreateUserWithAccessCodeMutationError = ErrorType<unknown>
    export type RegistrationControllerCreateUserWithAccessCodeMutationVariables = {data: BodyType<CreateUserWithAccessCodeDto>}

    export const useRegistrationControllerCreateUserWithAccessCode = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registrationControllerCreateUserWithAccessCode>>, TError,RegistrationControllerCreateUserWithAccessCodeMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof registrationControllerCreateUserWithAccessCode>>,
        TError,
        RegistrationControllerCreateUserWithAccessCodeMutationVariables,
        TContext
      > => {
      return useMutation(getRegistrationControllerCreateUserWithAccessCodeMutationOptions(options), queryClient);
    }

export const registrationControllerCreateBatchUserWithAccessCode = (
    createBatchUserWithAccessCodeDto: BodyType<CreateBatchUserWithAccessCodeDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/registration/create-batch-user-with-access-code`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createBatchUserWithAccessCodeDto, signal
    },
      options);
    }




export const getRegistrationControllerCreateBatchUserWithAccessCodeMutationKey = () => ['registrationControllerCreateBatchUserWithAccessCode'] as const;

export const getRegistrationControllerCreateBatchUserWithAccessCodeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registrationControllerCreateBatchUserWithAccessCode>>, TError,RegistrationControllerCreateBatchUserWithAccessCodeMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof registrationControllerCreateBatchUserWithAccessCode>>, TError,RegistrationControllerCreateBatchUserWithAccessCodeMutationVariables, TContext> => {

const mutationKey = getRegistrationControllerCreateBatchUserWithAccessCodeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registrationControllerCreateBatchUserWithAccessCode>>, RegistrationControllerCreateBatchUserWithAccessCodeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  registrationControllerCreateBatchUserWithAccessCode(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegistrationControllerCreateBatchUserWithAccessCodeMutationResult = NonNullable<Awaited<ReturnType<typeof registrationControllerCreateBatchUserWithAccessCode>>>
    export type RegistrationControllerCreateBatchUserWithAccessCodeMutationBody = BodyType<CreateBatchUserWithAccessCodeDto>
    export type RegistrationControllerCreateBatchUserWithAccessCodeMutationError = ErrorType<unknown>
    export type RegistrationControllerCreateBatchUserWithAccessCodeMutationVariables = {data: BodyType<CreateBatchUserWithAccessCodeDto>}

    export const useRegistrationControllerCreateBatchUserWithAccessCode = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registrationControllerCreateBatchUserWithAccessCode>>, TError,RegistrationControllerCreateBatchUserWithAccessCodeMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof registrationControllerCreateBatchUserWithAccessCode>>,
        TError,
        RegistrationControllerCreateBatchUserWithAccessCodeMutationVariables,
        TContext
      > => {
      return useMutation(getRegistrationControllerCreateBatchUserWithAccessCodeMutationOptions(options), queryClient);
    }

export const registrationControllerCreateClassroomUsersWithEmailPassword = (
    createUsersInClassroomDto: BodyType<CreateUsersInClassroomDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/registration/users-in-classroom`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUsersInClassroomDto, signal
    },
      options);
    }




export const getRegistrationControllerCreateClassroomUsersWithEmailPasswordMutationKey = () => ['registrationControllerCreateClassroomUsersWithEmailPassword'] as const;

export const getRegistrationControllerCreateClassroomUsersWithEmailPasswordMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registrationControllerCreateClassroomUsersWithEmailPassword>>, TError,RegistrationControllerCreateClassroomUsersWithEmailPasswordMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof registrationControllerCreateClassroomUsersWithEmailPassword>>, TError,RegistrationControllerCreateClassroomUsersWithEmailPasswordMutationVariables, TContext> => {

const mutationKey = getRegistrationControllerCreateClassroomUsersWithEmailPasswordMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registrationControllerCreateClassroomUsersWithEmailPassword>>, RegistrationControllerCreateClassroomUsersWithEmailPasswordMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  registrationControllerCreateClassroomUsersWithEmailPassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegistrationControllerCreateClassroomUsersWithEmailPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof registrationControllerCreateClassroomUsersWithEmailPassword>>>
    export type RegistrationControllerCreateClassroomUsersWithEmailPasswordMutationBody = BodyType<CreateUsersInClassroomDto>
    export type RegistrationControllerCreateClassroomUsersWithEmailPasswordMutationError = ErrorType<unknown>
    export type RegistrationControllerCreateClassroomUsersWithEmailPasswordMutationVariables = {data: BodyType<CreateUsersInClassroomDto>}

    export const useRegistrationControllerCreateClassroomUsersWithEmailPassword = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registrationControllerCreateClassroomUsersWithEmailPassword>>, TError,RegistrationControllerCreateClassroomUsersWithEmailPasswordMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof registrationControllerCreateClassroomUsersWithEmailPassword>>,
        TError,
        RegistrationControllerCreateClassroomUsersWithEmailPasswordMutationVariables,
        TContext
      > => {
      return useMutation(getRegistrationControllerCreateClassroomUsersWithEmailPasswordMutationOptions(options), queryClient);
    }

export const registrationControllerCreateClassroomsAndUsers = (
    bulkCreateClassroomsUsersDto: BodyType<BulkCreateClassroomsUsersDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/registration/bulk-classrooms-users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkCreateClassroomsUsersDto, signal
    },
      options);
    }




export const getRegistrationControllerCreateClassroomsAndUsersMutationKey = () => ['registrationControllerCreateClassroomsAndUsers'] as const;

export const getRegistrationControllerCreateClassroomsAndUsersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registrationControllerCreateClassroomsAndUsers>>, TError,RegistrationControllerCreateClassroomsAndUsersMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof registrationControllerCreateClassroomsAndUsers>>, TError,RegistrationControllerCreateClassroomsAndUsersMutationVariables, TContext> => {

const mutationKey = getRegistrationControllerCreateClassroomsAndUsersMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registrationControllerCreateClassroomsAndUsers>>, RegistrationControllerCreateClassroomsAndUsersMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  registrationControllerCreateClassroomsAndUsers(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegistrationControllerCreateClassroomsAndUsersMutationResult = NonNullable<Awaited<ReturnType<typeof registrationControllerCreateClassroomsAndUsers>>>
    export type RegistrationControllerCreateClassroomsAndUsersMutationBody = BodyType<BulkCreateClassroomsUsersDto>
    export type RegistrationControllerCreateClassroomsAndUsersMutationError = ErrorType<unknown>
    export type RegistrationControllerCreateClassroomsAndUsersMutationVariables = {data: BodyType<BulkCreateClassroomsUsersDto>}

    export const useRegistrationControllerCreateClassroomsAndUsers = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registrationControllerCreateClassroomsAndUsers>>, TError,RegistrationControllerCreateClassroomsAndUsersMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof registrationControllerCreateClassroomsAndUsers>>,
        TError,
        RegistrationControllerCreateClassroomsAndUsersMutationVariables,
        TContext
      > => {
      return useMutation(getRegistrationControllerCreateClassroomsAndUsersMutationOptions(options), queryClient);
    }

export const translationControllerTranslateArrayWord = (
    translateTextsDto: BodyType<TranslateTextsDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<(TranslationResponseDto | null)[]>(
      {url: `/translation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: translateTextsDto, signal
    },
      options);
    }




export const getTranslationControllerTranslateArrayWordMutationKey = () => ['translationControllerTranslateArrayWord'] as const;

export const getTranslationControllerTranslateArrayWordMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerTranslateArrayWord>>, TError,TranslationControllerTranslateArrayWordMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof translationControllerTranslateArrayWord>>, TError,TranslationControllerTranslateArrayWordMutationVariables, TContext> => {

const mutationKey = getTranslationControllerTranslateArrayWordMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof translationControllerTranslateArrayWord>>, TranslationControllerTranslateArrayWordMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  translationControllerTranslateArrayWord(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TranslationControllerTranslateArrayWordMutationResult = NonNullable<Awaited<ReturnType<typeof translationControllerTranslateArrayWord>>>
    export type TranslationControllerTranslateArrayWordMutationBody = BodyType<TranslateTextsDto>
    export type TranslationControllerTranslateArrayWordMutationError = ErrorType<unknown>
    export type TranslationControllerTranslateArrayWordMutationVariables = {data: BodyType<TranslateTextsDto>}

    export const useTranslationControllerTranslateArrayWord = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerTranslateArrayWord>>, TError,TranslationControllerTranslateArrayWordMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof translationControllerTranslateArrayWord>>,
        TError,
        TranslationControllerTranslateArrayWordMutationVariables,
        TContext
      > => {
      return useMutation(getTranslationControllerTranslateArrayWordMutationOptions(options), queryClient);
    }

export const translationControllerTranslateWord = (
    translateTextDto: BodyType<TranslateTextDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TranslationControllerTranslateWord201>(
      {url: `/translation/text`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: translateTextDto, signal
    },
      options);
    }




export const getTranslationControllerTranslateWordMutationKey = () => ['translationControllerTranslateWord'] as const;

export const getTranslationControllerTranslateWordMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerTranslateWord>>, TError,TranslationControllerTranslateWordMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof translationControllerTranslateWord>>, TError,TranslationControllerTranslateWordMutationVariables, TContext> => {

const mutationKey = getTranslationControllerTranslateWordMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof translationControllerTranslateWord>>, TranslationControllerTranslateWordMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  translationControllerTranslateWord(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TranslationControllerTranslateWordMutationResult = NonNullable<Awaited<ReturnType<typeof translationControllerTranslateWord>>>
    export type TranslationControllerTranslateWordMutationBody = BodyType<TranslateTextDto>
    export type TranslationControllerTranslateWordMutationError = ErrorType<unknown>
    export type TranslationControllerTranslateWordMutationVariables = {data: BodyType<TranslateTextDto>}

    export const useTranslationControllerTranslateWord = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerTranslateWord>>, TError,TranslationControllerTranslateWordMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof translationControllerTranslateWord>>,
        TError,
        TranslationControllerTranslateWordMutationVariables,
        TContext
      > => {
      return useMutation(getTranslationControllerTranslateWordMutationOptions(options), queryClient);
    }

export const translationControllerContextualTranslateByVocabIds = (
    contextualTranslateByVocabIdsDto: BodyType<ContextualTranslateByVocabIdsDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TranslationResponseDto[]>(
      {url: `/translation/contextual-by-vocab-ids`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: contextualTranslateByVocabIdsDto, signal
    },
      options);
    }




export const getTranslationControllerContextualTranslateByVocabIdsMutationKey = () => ['translationControllerContextualTranslateByVocabIds'] as const;

export const getTranslationControllerContextualTranslateByVocabIdsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerContextualTranslateByVocabIds>>, TError,TranslationControllerContextualTranslateByVocabIdsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof translationControllerContextualTranslateByVocabIds>>, TError,TranslationControllerContextualTranslateByVocabIdsMutationVariables, TContext> => {

const mutationKey = getTranslationControllerContextualTranslateByVocabIdsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof translationControllerContextualTranslateByVocabIds>>, TranslationControllerContextualTranslateByVocabIdsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  translationControllerContextualTranslateByVocabIds(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TranslationControllerContextualTranslateByVocabIdsMutationResult = NonNullable<Awaited<ReturnType<typeof translationControllerContextualTranslateByVocabIds>>>
    export type TranslationControllerContextualTranslateByVocabIdsMutationBody = BodyType<ContextualTranslateByVocabIdsDto>
    export type TranslationControllerContextualTranslateByVocabIdsMutationError = ErrorType<unknown>
    export type TranslationControllerContextualTranslateByVocabIdsMutationVariables = {data: BodyType<ContextualTranslateByVocabIdsDto>}

    export const useTranslationControllerContextualTranslateByVocabIds = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerContextualTranslateByVocabIds>>, TError,TranslationControllerContextualTranslateByVocabIdsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof translationControllerContextualTranslateByVocabIds>>,
        TError,
        TranslationControllerContextualTranslateByVocabIdsMutationVariables,
        TContext
      > => {
      return useMutation(getTranslationControllerContextualTranslateByVocabIdsMutationOptions(options), queryClient);
    }

export const translationControllerContextualTranslateBySearchVocabsDto = (
    contextualTranslateBySearchVocabsDto: BodyType<ContextualTranslateBySearchVocabsDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TranslationResponseDto[]>(
      {url: `/translation/contextual-by-search-vocabs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: contextualTranslateBySearchVocabsDto, signal
    },
      options);
    }




export const getTranslationControllerContextualTranslateBySearchVocabsDtoMutationKey = () => ['translationControllerContextualTranslateBySearchVocabsDto'] as const;

export const getTranslationControllerContextualTranslateBySearchVocabsDtoMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerContextualTranslateBySearchVocabsDto>>, TError,TranslationControllerContextualTranslateBySearchVocabsDtoMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof translationControllerContextualTranslateBySearchVocabsDto>>, TError,TranslationControllerContextualTranslateBySearchVocabsDtoMutationVariables, TContext> => {

const mutationKey = getTranslationControllerContextualTranslateBySearchVocabsDtoMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof translationControllerContextualTranslateBySearchVocabsDto>>, TranslationControllerContextualTranslateBySearchVocabsDtoMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  translationControllerContextualTranslateBySearchVocabsDto(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TranslationControllerContextualTranslateBySearchVocabsDtoMutationResult = NonNullable<Awaited<ReturnType<typeof translationControllerContextualTranslateBySearchVocabsDto>>>
    export type TranslationControllerContextualTranslateBySearchVocabsDtoMutationBody = BodyType<ContextualTranslateBySearchVocabsDto>
    export type TranslationControllerContextualTranslateBySearchVocabsDtoMutationError = ErrorType<unknown>
    export type TranslationControllerContextualTranslateBySearchVocabsDtoMutationVariables = {data: BodyType<ContextualTranslateBySearchVocabsDto>}

    export const useTranslationControllerContextualTranslateBySearchVocabsDto = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof translationControllerContextualTranslateBySearchVocabsDto>>, TError,TranslationControllerContextualTranslateBySearchVocabsDtoMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof translationControllerContextualTranslateBySearchVocabsDto>>,
        TError,
        TranslationControllerContextualTranslateBySearchVocabsDtoMutationVariables,
        TContext
      > => {
      return useMutation(getTranslationControllerContextualTranslateBySearchVocabsDtoMutationOptions(options), queryClient);
    }

/**
 * @summary Typeahead across vocab forms (exact/prefix + fuzzy fallback on no exact hit) with optional POS/language context
 */
export const vocabV2ControllerSearch = (
    params: VocabV2ControllerSearchParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SearchVocabV2ResponseItemDto[]>(
      {url: `/vocab-v2/search`, method: 'GET',
        params, signal
    },
      options);
    }




export const getVocabV2ControllerSearchQueryKey = (params?: VocabV2ControllerSearchParams,) => {
    return [
    `/vocab-v2/search`, ...(params ? [params] : [])
    ] as const;
    }


export const getVocabV2ControllerSearchQueryOptions = <TData = Awaited<ReturnType<typeof vocabV2ControllerSearch>>, TError = ErrorType<unknown>>(params: VocabV2ControllerSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vocabV2ControllerSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVocabV2ControllerSearchQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vocabV2ControllerSearch>>> = ({ signal }) => vocabV2ControllerSearch(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vocabV2ControllerSearch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VocabV2ControllerSearchQueryResult = NonNullable<Awaited<ReturnType<typeof vocabV2ControllerSearch>>>
export type VocabV2ControllerSearchQueryError = ErrorType<unknown>


export function useVocabV2ControllerSearch<TData = Awaited<ReturnType<typeof vocabV2ControllerSearch>>, TError = ErrorType<unknown>>(
 params: VocabV2ControllerSearchParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vocabV2ControllerSearch>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vocabV2ControllerSearch>>,
          TError,
          Awaited<ReturnType<typeof vocabV2ControllerSearch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVocabV2ControllerSearch<TData = Awaited<ReturnType<typeof vocabV2ControllerSearch>>, TError = ErrorType<unknown>>(
 params: VocabV2ControllerSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vocabV2ControllerSearch>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vocabV2ControllerSearch>>,
          TError,
          Awaited<ReturnType<typeof vocabV2ControllerSearch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVocabV2ControllerSearch<TData = Awaited<ReturnType<typeof vocabV2ControllerSearch>>, TError = ErrorType<unknown>>(
 params: VocabV2ControllerSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vocabV2ControllerSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Typeahead across vocab forms (exact/prefix + fuzzy fallback on no exact hit) with optional POS/language context
 */

export function useVocabV2ControllerSearch<TData = Awaited<ReturnType<typeof vocabV2ControllerSearch>>, TError = ErrorType<unknown>>(
 params: VocabV2ControllerSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vocabV2ControllerSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVocabV2ControllerSearchQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useVocabV2ControllerSearch} query
 */
export const invalidateVocabV2ControllerSearch = async (
 queryClient: QueryClient, params: VocabV2ControllerSearchParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getVocabV2ControllerSearchQueryKey(params) }, options);

  return queryClient;
}

/**
 * @summary Typeahead across vocab forms (exact/prefix + fuzzy fallback on no exact hit) with optional POS/language context
 */
export const useSetVocabV2ControllerSearchQueryData = () => {
  const queryClient = useQueryClient();
  return (params: VocabV2ControllerSearchParams | undefined,updater: Awaited<ReturnType<typeof vocabV2ControllerSearch>> | undefined | ((old: Awaited<ReturnType<typeof vocabV2ControllerSearch>> | undefined) => Awaited<ReturnType<typeof vocabV2ControllerSearch>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof vocabV2ControllerSearch>>>({ exact: $exactMatch, queryKey: getVocabV2ControllerSearchQueryKey(params) }, updater);
  };
}

/**
 * @summary Typeahead across vocab forms (exact/prefix + fuzzy fallback on no exact hit) with optional POS/language context
 */
export const useGetVocabV2ControllerSearchQueryData = () => {
  const queryClient = useQueryClient();
  return (params: VocabV2ControllerSearchParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof vocabV2ControllerSearch>>>(getVocabV2ControllerSearchQueryKey(params));
}



/**
 * @summary Check raw candidate text for possible semantic duplicate senses
 */
export const vocabV2ControllerCheckSemanticDuplicates = (
    semanticDuplicateCheckVocabV2Dto: BodyType<SemanticDuplicateCheckVocabV2Dto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SemanticDuplicateMatchVocabV2ResponseDto[]>(
      {url: `/vocab-v2/semantic-duplicate-check`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: semanticDuplicateCheckVocabV2Dto, signal
    },
      options);
    }




export const getVocabV2ControllerCheckSemanticDuplicatesMutationKey = () => ['vocabV2ControllerCheckSemanticDuplicates'] as const;

export const getVocabV2ControllerCheckSemanticDuplicatesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabV2ControllerCheckSemanticDuplicates>>, TError,VocabV2ControllerCheckSemanticDuplicatesMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof vocabV2ControllerCheckSemanticDuplicates>>, TError,VocabV2ControllerCheckSemanticDuplicatesMutationVariables, TContext> => {

const mutationKey = getVocabV2ControllerCheckSemanticDuplicatesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vocabV2ControllerCheckSemanticDuplicates>>, VocabV2ControllerCheckSemanticDuplicatesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vocabV2ControllerCheckSemanticDuplicates(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VocabV2ControllerCheckSemanticDuplicatesMutationResult = NonNullable<Awaited<ReturnType<typeof vocabV2ControllerCheckSemanticDuplicates>>>
    export type VocabV2ControllerCheckSemanticDuplicatesMutationBody = BodyType<SemanticDuplicateCheckVocabV2Dto>
    export type VocabV2ControllerCheckSemanticDuplicatesMutationError = ErrorType<unknown>
    export type VocabV2ControllerCheckSemanticDuplicatesMutationVariables = {data: BodyType<SemanticDuplicateCheckVocabV2Dto>}

    /**
 * @summary Check raw candidate text for possible semantic duplicate senses
 */
export const useVocabV2ControllerCheckSemanticDuplicates = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabV2ControllerCheckSemanticDuplicates>>, TError,VocabV2ControllerCheckSemanticDuplicatesMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vocabV2ControllerCheckSemanticDuplicates>>,
        TError,
        VocabV2ControllerCheckSemanticDuplicatesMutationVariables,
        TContext
      > => {
      return useMutation(getVocabV2ControllerCheckSemanticDuplicatesMutationOptions(options), queryClient);
    }

/**
 * @summary Bulk-resolve tagged ids to their deduplicated full sense subtrees
 */
export const vocabV2ControllerResolve = (
    resolveVocabV2RequestDto: BodyType<ResolveVocabV2RequestDto>,
    params?: VocabV2ControllerResolveParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ResolveVocabV2ResponseItemDto[]>(
      {url: `/vocab-v2/resolve`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resolveVocabV2RequestDto,
        params, signal
    },
      options);
    }




export const getVocabV2ControllerResolveMutationKey = () => ['vocabV2ControllerResolve'] as const;

export const getVocabV2ControllerResolveMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabV2ControllerResolve>>, TError,VocabV2ControllerResolveMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof vocabV2ControllerResolve>>, TError,VocabV2ControllerResolveMutationVariables, TContext> => {

const mutationKey = getVocabV2ControllerResolveMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vocabV2ControllerResolve>>, VocabV2ControllerResolveMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  vocabV2ControllerResolve(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VocabV2ControllerResolveMutationResult = NonNullable<Awaited<ReturnType<typeof vocabV2ControllerResolve>>>
    export type VocabV2ControllerResolveMutationBody = BodyType<ResolveVocabV2RequestDto>
    export type VocabV2ControllerResolveMutationError = ErrorType<unknown>
    export type VocabV2ControllerResolveMutationVariables = {data: BodyType<ResolveVocabV2RequestDto>;params?: VocabV2ControllerResolveParams}

    /**
 * @summary Bulk-resolve tagged ids to their deduplicated full sense subtrees
 */
export const useVocabV2ControllerResolve = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabV2ControllerResolve>>, TError,VocabV2ControllerResolveMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vocabV2ControllerResolve>>,
        TError,
        VocabV2ControllerResolveMutationVariables,
        TContext
      > => {
      return useMutation(getVocabV2ControllerResolveMutationOptions(options), queryClient);
    }

/**
 * @summary Semantic sense-candidate search with full subtrees (AI vocab picker)
 */
export const vocabV2ControllerSenseCandidates = (
    senseCandidatesVocabV2RequestDto: BodyType<SenseCandidatesVocabV2RequestDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SenseCandidatesVocabV2ResponseItemDto[]>(
      {url: `/vocab-v2/sense-candidates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: senseCandidatesVocabV2RequestDto, signal
    },
      options);
    }




export const getVocabV2ControllerSenseCandidatesMutationKey = () => ['vocabV2ControllerSenseCandidates'] as const;

export const getVocabV2ControllerSenseCandidatesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabV2ControllerSenseCandidates>>, TError,VocabV2ControllerSenseCandidatesMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof vocabV2ControllerSenseCandidates>>, TError,VocabV2ControllerSenseCandidatesMutationVariables, TContext> => {

const mutationKey = getVocabV2ControllerSenseCandidatesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vocabV2ControllerSenseCandidates>>, VocabV2ControllerSenseCandidatesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vocabV2ControllerSenseCandidates(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VocabV2ControllerSenseCandidatesMutationResult = NonNullable<Awaited<ReturnType<typeof vocabV2ControllerSenseCandidates>>>
    export type VocabV2ControllerSenseCandidatesMutationBody = BodyType<SenseCandidatesVocabV2RequestDto>
    export type VocabV2ControllerSenseCandidatesMutationError = ErrorType<void>
    export type VocabV2ControllerSenseCandidatesMutationVariables = {data: BodyType<SenseCandidatesVocabV2RequestDto>}

    /**
 * @summary Semantic sense-candidate search with full subtrees (AI vocab picker)
 */
export const useVocabV2ControllerSenseCandidates = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabV2ControllerSenseCandidates>>, TError,VocabV2ControllerSenseCandidatesMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vocabV2ControllerSenseCandidates>>,
        TError,
        VocabV2ControllerSenseCandidatesMutationVariables,
        TContext
      > => {
      return useMutation(getVocabV2ControllerSenseCandidatesMutationOptions(options), queryClient);
    }

/**
 * Returns audio, engine, voice, phonemes, duration and timing without writing a vocab row. Pass the returned generatedAudioId when saving a pronunciation to attach this exact recording and its timing. AU is unsupported.
 * @summary Generate pronunciation data from a word without an existing pronunciation (admin)
 */
export const vocabV2ControllerGeneratePronunciationDraft = (
    generatePronunciationDraftVocabV2Dto: BodyType<GeneratePronunciationDraftVocabV2Dto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GeneratePronunciationDraftVocabV2ResponseDto>(
      {url: `/vocab-v2/pronunciations/generate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generatePronunciationDraftVocabV2Dto, signal
    },
      options);
    }




export const getVocabV2ControllerGeneratePronunciationDraftMutationKey = () => ['vocabV2ControllerGeneratePronunciationDraft'] as const;

export const getVocabV2ControllerGeneratePronunciationDraftMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabV2ControllerGeneratePronunciationDraft>>, TError,VocabV2ControllerGeneratePronunciationDraftMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof vocabV2ControllerGeneratePronunciationDraft>>, TError,VocabV2ControllerGeneratePronunciationDraftMutationVariables, TContext> => {

const mutationKey = getVocabV2ControllerGeneratePronunciationDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vocabV2ControllerGeneratePronunciationDraft>>, VocabV2ControllerGeneratePronunciationDraftMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vocabV2ControllerGeneratePronunciationDraft(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VocabV2ControllerGeneratePronunciationDraftMutationResult = NonNullable<Awaited<ReturnType<typeof vocabV2ControllerGeneratePronunciationDraft>>>
    export type VocabV2ControllerGeneratePronunciationDraftMutationBody = BodyType<GeneratePronunciationDraftVocabV2Dto>
    export type VocabV2ControllerGeneratePronunciationDraftMutationError = ErrorType<void>
    export type VocabV2ControllerGeneratePronunciationDraftMutationVariables = {data: BodyType<GeneratePronunciationDraftVocabV2Dto>}

    /**
 * @summary Generate pronunciation data from a word without an existing pronunciation (admin)
 */
export const useVocabV2ControllerGeneratePronunciationDraft = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabV2ControllerGeneratePronunciationDraft>>, TError,VocabV2ControllerGeneratePronunciationDraftMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vocabV2ControllerGeneratePronunciationDraft>>,
        TError,
        VocabV2ControllerGeneratePronunciationDraftMutationVariables,
        TContext
      > => {
      return useMutation(getVocabV2ControllerGeneratePronunciationDraftMutationOptions(options), queryClient);
    }

/**
 * Synthesises the pronunciation's own form and accent via Eddy Audio AI, then writes the audio and its timing rows in one audited transaction, replacing every generated audio row of this pronunciation (human recordings are kept). AU is rejected (no en-AU voice exists).
 * @summary Generate pronunciation audio for a pronunciation (admin)
 */
export const vocabV2ControllerGeneratePronunciation = (
    pronunciationId: string,
    generatePronunciationVocabV2Dto: BodyType<GeneratePronunciationVocabV2Dto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GeneratePronunciationVocabV2ResponseDto>(
      {url: `/vocab-v2/pronunciations/${pronunciationId}/generate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generatePronunciationVocabV2Dto, signal
    },
      options);
    }




export const getVocabV2ControllerGeneratePronunciationMutationKey = () => ['vocabV2ControllerGeneratePronunciation'] as const;

export const getVocabV2ControllerGeneratePronunciationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabV2ControllerGeneratePronunciation>>, TError,VocabV2ControllerGeneratePronunciationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof vocabV2ControllerGeneratePronunciation>>, TError,VocabV2ControllerGeneratePronunciationMutationVariables, TContext> => {

const mutationKey = getVocabV2ControllerGeneratePronunciationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vocabV2ControllerGeneratePronunciation>>, VocabV2ControllerGeneratePronunciationMutationVariables> = (props) => {
          const {pronunciationId,data} = props ?? {};

          return  vocabV2ControllerGeneratePronunciation(pronunciationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VocabV2ControllerGeneratePronunciationMutationResult = NonNullable<Awaited<ReturnType<typeof vocabV2ControllerGeneratePronunciation>>>
    export type VocabV2ControllerGeneratePronunciationMutationBody = BodyType<GeneratePronunciationVocabV2Dto>
    export type VocabV2ControllerGeneratePronunciationMutationError = ErrorType<void>
    export type VocabV2ControllerGeneratePronunciationMutationVariables = {pronunciationId: string;data: BodyType<GeneratePronunciationVocabV2Dto>}

    /**
 * @summary Generate pronunciation audio for a pronunciation (admin)
 */
export const useVocabV2ControllerGeneratePronunciation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabV2ControllerGeneratePronunciation>>, TError,VocabV2ControllerGeneratePronunciationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vocabV2ControllerGeneratePronunciation>>,
        TError,
        VocabV2ControllerGeneratePronunciationMutationVariables,
        TContext
      > => {
      return useMutation(getVocabV2ControllerGeneratePronunciationMutationOptions(options), queryClient);
    }

/**
 * @summary List vocab senses (admin) — paginated, sense-anchored, with library counts
 */
export const vocabV2ControllerListSenses = (
    params: VocabV2ControllerListSensesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<VocabV2ListResponseDto>(
      {url: `/vocab-v2/senses`, method: 'GET',
        params, signal
    },
      options);
    }




export const getVocabV2ControllerListSensesQueryKey = (params?: VocabV2ControllerListSensesParams,) => {
    return [
    `/vocab-v2/senses`, ...(params ? [params] : [])
    ] as const;
    }


export const getVocabV2ControllerListSensesQueryOptions = <TData = Awaited<ReturnType<typeof vocabV2ControllerListSenses>>, TError = ErrorType<unknown>>(params: VocabV2ControllerListSensesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vocabV2ControllerListSenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVocabV2ControllerListSensesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vocabV2ControllerListSenses>>> = ({ signal }) => vocabV2ControllerListSenses(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vocabV2ControllerListSenses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VocabV2ControllerListSensesQueryResult = NonNullable<Awaited<ReturnType<typeof vocabV2ControllerListSenses>>>
export type VocabV2ControllerListSensesQueryError = ErrorType<unknown>


export function useVocabV2ControllerListSenses<TData = Awaited<ReturnType<typeof vocabV2ControllerListSenses>>, TError = ErrorType<unknown>>(
 params: VocabV2ControllerListSensesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vocabV2ControllerListSenses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vocabV2ControllerListSenses>>,
          TError,
          Awaited<ReturnType<typeof vocabV2ControllerListSenses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVocabV2ControllerListSenses<TData = Awaited<ReturnType<typeof vocabV2ControllerListSenses>>, TError = ErrorType<unknown>>(
 params: VocabV2ControllerListSensesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vocabV2ControllerListSenses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vocabV2ControllerListSenses>>,
          TError,
          Awaited<ReturnType<typeof vocabV2ControllerListSenses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVocabV2ControllerListSenses<TData = Awaited<ReturnType<typeof vocabV2ControllerListSenses>>, TError = ErrorType<unknown>>(
 params: VocabV2ControllerListSensesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vocabV2ControllerListSenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List vocab senses (admin) — paginated, sense-anchored, with library counts
 */

export function useVocabV2ControllerListSenses<TData = Awaited<ReturnType<typeof vocabV2ControllerListSenses>>, TError = ErrorType<unknown>>(
 params: VocabV2ControllerListSensesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vocabV2ControllerListSenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVocabV2ControllerListSensesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useVocabV2ControllerListSenses} query
 */
export const invalidateVocabV2ControllerListSenses = async (
 queryClient: QueryClient, params: VocabV2ControllerListSensesParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getVocabV2ControllerListSensesQueryKey(params) }, options);

  return queryClient;
}

/**
 * @summary List vocab senses (admin) — paginated, sense-anchored, with library counts
 */
export const useSetVocabV2ControllerListSensesQueryData = () => {
  const queryClient = useQueryClient();
  return (params: VocabV2ControllerListSensesParams | undefined,updater: Awaited<ReturnType<typeof vocabV2ControllerListSenses>> | undefined | ((old: Awaited<ReturnType<typeof vocabV2ControllerListSenses>> | undefined) => Awaited<ReturnType<typeof vocabV2ControllerListSenses>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof vocabV2ControllerListSenses>>>({ exact: $exactMatch, queryKey: getVocabV2ControllerListSensesQueryKey(params) }, updater);
  };
}

/**
 * @summary List vocab senses (admin) — paginated, sense-anchored, with library counts
 */
export const useGetVocabV2ControllerListSensesQueryData = () => {
  const queryClient = useQueryClient();
  return (params: VocabV2ControllerListSensesParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof vocabV2ControllerListSenses>>>(getVocabV2ControllerListSensesQueryKey(params));
}



/**
 * @summary Get sense detail (admin) — full nested tree, all translation sources
 */
export const vocabV2ControllerGetSense = (
    senseId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SenseDetailVocabV2ResponseDto>(
      {url: `/vocab-v2/senses/${senseId}`, method: 'GET', signal
    },
      options);
    }




export const getVocabV2ControllerGetSenseQueryKey = (senseId: string,) => {
    return [
    `/vocab-v2/senses/${senseId}`
    ] as const;
    }


export const getVocabV2ControllerGetSenseQueryOptions = <TData = Awaited<ReturnType<typeof vocabV2ControllerGetSense>>, TError = ErrorType<void>>(senseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vocabV2ControllerGetSense>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVocabV2ControllerGetSenseQueryKey(senseId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vocabV2ControllerGetSense>>> = ({ signal }) => vocabV2ControllerGetSense(senseId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: senseId !== null && senseId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vocabV2ControllerGetSense>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VocabV2ControllerGetSenseQueryResult = NonNullable<Awaited<ReturnType<typeof vocabV2ControllerGetSense>>>
export type VocabV2ControllerGetSenseQueryError = ErrorType<void>


export function useVocabV2ControllerGetSense<TData = Awaited<ReturnType<typeof vocabV2ControllerGetSense>>, TError = ErrorType<void>>(
 senseId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vocabV2ControllerGetSense>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vocabV2ControllerGetSense>>,
          TError,
          Awaited<ReturnType<typeof vocabV2ControllerGetSense>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVocabV2ControllerGetSense<TData = Awaited<ReturnType<typeof vocabV2ControllerGetSense>>, TError = ErrorType<void>>(
 senseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vocabV2ControllerGetSense>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vocabV2ControllerGetSense>>,
          TError,
          Awaited<ReturnType<typeof vocabV2ControllerGetSense>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVocabV2ControllerGetSense<TData = Awaited<ReturnType<typeof vocabV2ControllerGetSense>>, TError = ErrorType<void>>(
 senseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vocabV2ControllerGetSense>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get sense detail (admin) — full nested tree, all translation sources
 */

export function useVocabV2ControllerGetSense<TData = Awaited<ReturnType<typeof vocabV2ControllerGetSense>>, TError = ErrorType<void>>(
 senseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vocabV2ControllerGetSense>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVocabV2ControllerGetSenseQueryOptions(senseId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useVocabV2ControllerGetSense} query
 */
export const invalidateVocabV2ControllerGetSense = async (
 queryClient: QueryClient, senseId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getVocabV2ControllerGetSenseQueryKey(senseId) }, options);

  return queryClient;
}

/**
 * @summary Get sense detail (admin) — full nested tree, all translation sources
 */
export const useSetVocabV2ControllerGetSenseQueryData = () => {
  const queryClient = useQueryClient();
  return (senseId: string,updater: Awaited<ReturnType<typeof vocabV2ControllerGetSense>> | undefined | ((old: Awaited<ReturnType<typeof vocabV2ControllerGetSense>> | undefined) => Awaited<ReturnType<typeof vocabV2ControllerGetSense>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof vocabV2ControllerGetSense>>>({ exact: $exactMatch, queryKey: getVocabV2ControllerGetSenseQueryKey(senseId) }, updater);
  };
}

/**
 * @summary Get sense detail (admin) — full nested tree, all translation sources
 */
export const useGetVocabV2ControllerGetSenseQueryData = () => {
  const queryClient = useQueryClient();
  return (senseId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof vocabV2ControllerGetSense>>>(getVocabV2ControllerGetSenseQueryKey(senseId));
}



/**
 * Sense-anchored: lemma/partOfSpeech belong to the shared vocab_entry, so editing them also changes every sibling sense (returned as affectedSiblingSenseIds). An omitted array is left untouched; a present array is authoritative — rows it does not carry are soft-deleted.
 * @summary Update a vocab sense (admin) — whole-tree nested diff
 */
export const vocabV2ControllerUpdateSense = (
    senseId: string,
    updateSenseVocabV2Dto: BodyType<UpdateSenseVocabV2Dto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UpdateSenseVocabV2ResponseDto>(
      {url: `/vocab-v2/senses/${senseId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateSenseVocabV2Dto, signal
    },
      options);
    }




export const getVocabV2ControllerUpdateSenseMutationKey = () => ['vocabV2ControllerUpdateSense'] as const;

export const getVocabV2ControllerUpdateSenseMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabV2ControllerUpdateSense>>, TError,VocabV2ControllerUpdateSenseMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof vocabV2ControllerUpdateSense>>, TError,VocabV2ControllerUpdateSenseMutationVariables, TContext> => {

const mutationKey = getVocabV2ControllerUpdateSenseMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vocabV2ControllerUpdateSense>>, VocabV2ControllerUpdateSenseMutationVariables> = (props) => {
          const {senseId,data} = props ?? {};

          return  vocabV2ControllerUpdateSense(senseId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VocabV2ControllerUpdateSenseMutationResult = NonNullable<Awaited<ReturnType<typeof vocabV2ControllerUpdateSense>>>
    export type VocabV2ControllerUpdateSenseMutationBody = BodyType<UpdateSenseVocabV2Dto>
    export type VocabV2ControllerUpdateSenseMutationError = ErrorType<void>
    export type VocabV2ControllerUpdateSenseMutationVariables = {senseId: string;data: BodyType<UpdateSenseVocabV2Dto>}

    /**
 * @summary Update a vocab sense (admin) — whole-tree nested diff
 */
export const useVocabV2ControllerUpdateSense = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabV2ControllerUpdateSense>>, TError,VocabV2ControllerUpdateSenseMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vocabV2ControllerUpdateSense>>,
        TError,
        VocabV2ControllerUpdateSenseMutationVariables,
        TContext
      > => {
      return useMutation(getVocabV2ControllerUpdateSenseMutationOptions(options), queryClient);
    }

/**
 * Stamps deleted_at on the sense, its forms → pronunciations → audio, translations, images, sentence examples → their translations, and any vocab_sense_relation referencing it from either direction. Siblings and the parent entry are untouched.
 * @summary Delete a vocab sense (admin) — soft-deletes the sense and its whole subtree
 */
export const vocabV2ControllerDeleteSense = (
    senseId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/vocab-v2/senses/${senseId}`, method: 'DELETE', signal
    },
      options);
    }




export const getVocabV2ControllerDeleteSenseMutationKey = () => ['vocabV2ControllerDeleteSense'] as const;

export const getVocabV2ControllerDeleteSenseMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabV2ControllerDeleteSense>>, TError,VocabV2ControllerDeleteSenseMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof vocabV2ControllerDeleteSense>>, TError,VocabV2ControllerDeleteSenseMutationVariables, TContext> => {

const mutationKey = getVocabV2ControllerDeleteSenseMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vocabV2ControllerDeleteSense>>, VocabV2ControllerDeleteSenseMutationVariables> = (props) => {
          const {senseId} = props ?? {};

          return  vocabV2ControllerDeleteSense(senseId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VocabV2ControllerDeleteSenseMutationResult = NonNullable<Awaited<ReturnType<typeof vocabV2ControllerDeleteSense>>>

    export type VocabV2ControllerDeleteSenseMutationError = ErrorType<void>
    export type VocabV2ControllerDeleteSenseMutationVariables = {senseId: string}

    /**
 * @summary Delete a vocab sense (admin) — soft-deletes the sense and its whole subtree
 */
export const useVocabV2ControllerDeleteSense = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabV2ControllerDeleteSense>>, TError,VocabV2ControllerDeleteSenseMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vocabV2ControllerDeleteSense>>,
        TError,
        VocabV2ControllerDeleteSenseMutationVariables,
        TContext
      > => {
      return useMutation(getVocabV2ControllerDeleteSenseMutationOptions(options), queryClient);
    }

/**
 * Manual creation (no auto-generation): lemma + part of speech + one sense, with translations, forms/pronunciations (audio per pronunciation), media and sentence examples nested in the same payload. One transaction, all-or-nothing; every created record gets an edit_log row. Optional entryId attaches the sense to that existing entry instead of inserting one — the entry must be live and match lemma + part of speech.
 * @summary Create a vocab entry (admin) — entry + first sense + whole tree in one request
 */
export const vocabV2ControllerCreateEntry = (
    createVocabV2Dto: BodyType<CreateVocabV2Dto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SenseDetailVocabV2ResponseDto>(
      {url: `/vocab-v2/entries`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createVocabV2Dto, signal
    },
      options);
    }




export const getVocabV2ControllerCreateEntryMutationKey = () => ['vocabV2ControllerCreateEntry'] as const;

export const getVocabV2ControllerCreateEntryMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabV2ControllerCreateEntry>>, TError,VocabV2ControllerCreateEntryMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof vocabV2ControllerCreateEntry>>, TError,VocabV2ControllerCreateEntryMutationVariables, TContext> => {

const mutationKey = getVocabV2ControllerCreateEntryMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vocabV2ControllerCreateEntry>>, VocabV2ControllerCreateEntryMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vocabV2ControllerCreateEntry(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VocabV2ControllerCreateEntryMutationResult = NonNullable<Awaited<ReturnType<typeof vocabV2ControllerCreateEntry>>>
    export type VocabV2ControllerCreateEntryMutationBody = BodyType<CreateVocabV2Dto>
    export type VocabV2ControllerCreateEntryMutationError = ErrorType<void>
    export type VocabV2ControllerCreateEntryMutationVariables = {data: BodyType<CreateVocabV2Dto>}

    /**
 * @summary Create a vocab entry (admin) — entry + first sense + whole tree in one request
 */
export const useVocabV2ControllerCreateEntry = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabV2ControllerCreateEntry>>, TError,VocabV2ControllerCreateEntryMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vocabV2ControllerCreateEntry>>,
        TError,
        VocabV2ControllerCreateEntryMutationVariables,
        TContext
      > => {
      return useMutation(getVocabV2ControllerCreateEntryMutationOptions(options), queryClient);
    }

/**
 * Same cascade as sense delete, applied to every sense of the entry, plus the vocab_entry row itself.
 * @summary Delete a vocab entry (admin) — soft-deletes every sense of the entry, plus the entry row
 */
export const vocabV2ControllerDeleteEntry = (
    entryId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/vocab-v2/entries/${entryId}`, method: 'DELETE', signal
    },
      options);
    }




export const getVocabV2ControllerDeleteEntryMutationKey = () => ['vocabV2ControllerDeleteEntry'] as const;

export const getVocabV2ControllerDeleteEntryMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabV2ControllerDeleteEntry>>, TError,VocabV2ControllerDeleteEntryMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof vocabV2ControllerDeleteEntry>>, TError,VocabV2ControllerDeleteEntryMutationVariables, TContext> => {

const mutationKey = getVocabV2ControllerDeleteEntryMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vocabV2ControllerDeleteEntry>>, VocabV2ControllerDeleteEntryMutationVariables> = (props) => {
          const {entryId} = props ?? {};

          return  vocabV2ControllerDeleteEntry(entryId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VocabV2ControllerDeleteEntryMutationResult = NonNullable<Awaited<ReturnType<typeof vocabV2ControllerDeleteEntry>>>

    export type VocabV2ControllerDeleteEntryMutationError = ErrorType<void>
    export type VocabV2ControllerDeleteEntryMutationVariables = {entryId: string}

    /**
 * @summary Delete a vocab entry (admin) — soft-deletes every sense of the entry, plus the entry row
 */
export const useVocabV2ControllerDeleteEntry = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vocabV2ControllerDeleteEntry>>, TError,VocabV2ControllerDeleteEntryMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vocabV2ControllerDeleteEntry>>,
        TError,
        VocabV2ControllerDeleteEntryMutationVariables,
        TContext
      > => {
      return useMutation(getVocabV2ControllerDeleteEntryMutationOptions(options), queryClient);
    }

export const classroomLessonControllerCreate = (
    createClassroomLessonDto: BodyType<CreateClassroomLessonDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ClassroomLesson>(
      {url: `/classroom-lessons`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createClassroomLessonDto, signal
    },
      options);
    }




export const getClassroomLessonControllerCreateMutationKey = () => ['classroomLessonControllerCreate'] as const;

export const getClassroomLessonControllerCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomLessonControllerCreate>>, TError,ClassroomLessonControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof classroomLessonControllerCreate>>, TError,ClassroomLessonControllerCreateMutationVariables, TContext> => {

const mutationKey = getClassroomLessonControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof classroomLessonControllerCreate>>, ClassroomLessonControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  classroomLessonControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClassroomLessonControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof classroomLessonControllerCreate>>>
    export type ClassroomLessonControllerCreateMutationBody = BodyType<CreateClassroomLessonDto>
    export type ClassroomLessonControllerCreateMutationError = ErrorType<unknown>
    export type ClassroomLessonControllerCreateMutationVariables = {data: BodyType<CreateClassroomLessonDto>}

    export const useClassroomLessonControllerCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomLessonControllerCreate>>, TError,ClassroomLessonControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof classroomLessonControllerCreate>>,
        TError,
        ClassroomLessonControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getClassroomLessonControllerCreateMutationOptions(options), queryClient);
    }

export const classroomLessonControllerSearch = (
    params?: ClassroomLessonControllerSearchParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/classroom-lessons`, method: 'GET',
        params, signal
    },
      options);
    }




export const getClassroomLessonControllerSearchQueryKey = (params?: ClassroomLessonControllerSearchParams,) => {
    return [
    `/classroom-lessons`, ...(params ? [params] : [])
    ] as const;
    }


export const getClassroomLessonControllerSearchQueryOptions = <TData = Awaited<ReturnType<typeof classroomLessonControllerSearch>>, TError = ErrorType<unknown>>(params?: ClassroomLessonControllerSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonControllerSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomLessonControllerSearchQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomLessonControllerSearch>>> = ({ signal }) => classroomLessonControllerSearch(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomLessonControllerSearch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomLessonControllerSearchQueryResult = NonNullable<Awaited<ReturnType<typeof classroomLessonControllerSearch>>>
export type ClassroomLessonControllerSearchQueryError = ErrorType<unknown>


export function useClassroomLessonControllerSearch<TData = Awaited<ReturnType<typeof classroomLessonControllerSearch>>, TError = ErrorType<unknown>>(
 params: undefined |  ClassroomLessonControllerSearchParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonControllerSearch>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomLessonControllerSearch>>,
          TError,
          Awaited<ReturnType<typeof classroomLessonControllerSearch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomLessonControllerSearch<TData = Awaited<ReturnType<typeof classroomLessonControllerSearch>>, TError = ErrorType<unknown>>(
 params?: ClassroomLessonControllerSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonControllerSearch>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomLessonControllerSearch>>,
          TError,
          Awaited<ReturnType<typeof classroomLessonControllerSearch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomLessonControllerSearch<TData = Awaited<ReturnType<typeof classroomLessonControllerSearch>>, TError = ErrorType<unknown>>(
 params?: ClassroomLessonControllerSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonControllerSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomLessonControllerSearch<TData = Awaited<ReturnType<typeof classroomLessonControllerSearch>>, TError = ErrorType<unknown>>(
 params?: ClassroomLessonControllerSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonControllerSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomLessonControllerSearchQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomLessonControllerSearch} query
 */
export const invalidateClassroomLessonControllerSearch = async (
 queryClient: QueryClient, params?: ClassroomLessonControllerSearchParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomLessonControllerSearchQueryKey(params) }, options);

  return queryClient;
}

export const useSetClassroomLessonControllerSearchQueryData = () => {
  const queryClient = useQueryClient();
  return (params: ClassroomLessonControllerSearchParams | undefined,updater: Awaited<ReturnType<typeof classroomLessonControllerSearch>> | undefined | ((old: Awaited<ReturnType<typeof classroomLessonControllerSearch>> | undefined) => Awaited<ReturnType<typeof classroomLessonControllerSearch>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomLessonControllerSearch>>>({ exact: $exactMatch, queryKey: getClassroomLessonControllerSearchQueryKey(params) }, updater);
  };
}

export const useGetClassroomLessonControllerSearchQueryData = () => {
  const queryClient = useQueryClient();
  return (params?: ClassroomLessonControllerSearchParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomLessonControllerSearch>>>(getClassroomLessonControllerSearchQueryKey(params));
}



export const classroomLessonControllerBatchUpdate = (
    classroomLessonControllerBatchUpdateBody: BodyType<string[]>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/classroom-lessons`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: classroomLessonControllerBatchUpdateBody, signal
    },
      options);
    }




export const getClassroomLessonControllerBatchUpdateMutationKey = () => ['classroomLessonControllerBatchUpdate'] as const;

export const getClassroomLessonControllerBatchUpdateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomLessonControllerBatchUpdate>>, TError,ClassroomLessonControllerBatchUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof classroomLessonControllerBatchUpdate>>, TError,ClassroomLessonControllerBatchUpdateMutationVariables, TContext> => {

const mutationKey = getClassroomLessonControllerBatchUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof classroomLessonControllerBatchUpdate>>, ClassroomLessonControllerBatchUpdateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  classroomLessonControllerBatchUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClassroomLessonControllerBatchUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof classroomLessonControllerBatchUpdate>>>
    export type ClassroomLessonControllerBatchUpdateMutationBody = BodyType<string[]>
    export type ClassroomLessonControllerBatchUpdateMutationError = ErrorType<unknown>
    export type ClassroomLessonControllerBatchUpdateMutationVariables = {data: BodyType<string[]>}

    export const useClassroomLessonControllerBatchUpdate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomLessonControllerBatchUpdate>>, TError,ClassroomLessonControllerBatchUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof classroomLessonControllerBatchUpdate>>,
        TError,
        ClassroomLessonControllerBatchUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getClassroomLessonControllerBatchUpdateMutationOptions(options), queryClient);
    }

export const classroomLessonControllerFindById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/classroom-lessons/${id}`, method: 'GET', signal
    },
      options);
    }




export const getClassroomLessonControllerFindByIdQueryKey = (id: string,) => {
    return [
    `/classroom-lessons/${id}`
    ] as const;
    }


export const getClassroomLessonControllerFindByIdQueryOptions = <TData = Awaited<ReturnType<typeof classroomLessonControllerFindById>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomLessonControllerFindByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomLessonControllerFindById>>> = ({ signal }) => classroomLessonControllerFindById(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomLessonControllerFindById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomLessonControllerFindByIdQueryResult = NonNullable<Awaited<ReturnType<typeof classroomLessonControllerFindById>>>
export type ClassroomLessonControllerFindByIdQueryError = ErrorType<unknown>


export function useClassroomLessonControllerFindById<TData = Awaited<ReturnType<typeof classroomLessonControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonControllerFindById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomLessonControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof classroomLessonControllerFindById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomLessonControllerFindById<TData = Awaited<ReturnType<typeof classroomLessonControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonControllerFindById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomLessonControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof classroomLessonControllerFindById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomLessonControllerFindById<TData = Awaited<ReturnType<typeof classroomLessonControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomLessonControllerFindById<TData = Awaited<ReturnType<typeof classroomLessonControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomLessonControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomLessonControllerFindByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomLessonControllerFindById} query
 */
export const invalidateClassroomLessonControllerFindById = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomLessonControllerFindByIdQueryKey(id) }, options);

  return queryClient;
}

export const useSetClassroomLessonControllerFindByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof classroomLessonControllerFindById>> | undefined | ((old: Awaited<ReturnType<typeof classroomLessonControllerFindById>> | undefined) => Awaited<ReturnType<typeof classroomLessonControllerFindById>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomLessonControllerFindById>>>({ exact: $exactMatch, queryKey: getClassroomLessonControllerFindByIdQueryKey(id) }, updater);
  };
}

export const useGetClassroomLessonControllerFindByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomLessonControllerFindById>>>(getClassroomLessonControllerFindByIdQueryKey(id));
}



export const classroomLessonControllerUpdate = (
    id: string,
    updateClassroomLessonDto: BodyType<UpdateClassroomLessonDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/classroom-lessons/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateClassroomLessonDto, signal
    },
      options);
    }




export const getClassroomLessonControllerUpdateMutationKey = () => ['classroomLessonControllerUpdate'] as const;

export const getClassroomLessonControllerUpdateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomLessonControllerUpdate>>, TError,ClassroomLessonControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof classroomLessonControllerUpdate>>, TError,ClassroomLessonControllerUpdateMutationVariables, TContext> => {

const mutationKey = getClassroomLessonControllerUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof classroomLessonControllerUpdate>>, ClassroomLessonControllerUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  classroomLessonControllerUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClassroomLessonControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof classroomLessonControllerUpdate>>>
    export type ClassroomLessonControllerUpdateMutationBody = BodyType<UpdateClassroomLessonDto>
    export type ClassroomLessonControllerUpdateMutationError = ErrorType<unknown>
    export type ClassroomLessonControllerUpdateMutationVariables = {id: string;data: BodyType<UpdateClassroomLessonDto>}

    export const useClassroomLessonControllerUpdate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomLessonControllerUpdate>>, TError,ClassroomLessonControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof classroomLessonControllerUpdate>>,
        TError,
        ClassroomLessonControllerUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getClassroomLessonControllerUpdateMutationOptions(options), queryClient);
    }

export const lessonBlueprintControllerCreateRun = (
    createGroupingRunDto: BodyType<CreateGroupingRunDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RunWithBlueprintsResponseDto>(
      {url: `/lesson-blueprints/runs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createGroupingRunDto, signal
    },
      options);
    }




export const getLessonBlueprintControllerCreateRunMutationKey = () => ['lessonBlueprintControllerCreateRun'] as const;

export const getLessonBlueprintControllerCreateRunMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonBlueprintControllerCreateRun>>, TError,LessonBlueprintControllerCreateRunMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof lessonBlueprintControllerCreateRun>>, TError,LessonBlueprintControllerCreateRunMutationVariables, TContext> => {

const mutationKey = getLessonBlueprintControllerCreateRunMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof lessonBlueprintControllerCreateRun>>, LessonBlueprintControllerCreateRunMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  lessonBlueprintControllerCreateRun(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LessonBlueprintControllerCreateRunMutationResult = NonNullable<Awaited<ReturnType<typeof lessonBlueprintControllerCreateRun>>>
    export type LessonBlueprintControllerCreateRunMutationBody = BodyType<CreateGroupingRunDto>
    export type LessonBlueprintControllerCreateRunMutationError = ErrorType<unknown>
    export type LessonBlueprintControllerCreateRunMutationVariables = {data: BodyType<CreateGroupingRunDto>}

    export const useLessonBlueprintControllerCreateRun = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonBlueprintControllerCreateRun>>, TError,LessonBlueprintControllerCreateRunMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof lessonBlueprintControllerCreateRun>>,
        TError,
        LessonBlueprintControllerCreateRunMutationVariables,
        TContext
      > => {
      return useMutation(getLessonBlueprintControllerCreateRunMutationOptions(options), queryClient);
    }

export const lessonBlueprintControllerListRuns = (
    params?: LessonBlueprintControllerListRunsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GroupingRunResponseDto[]>(
      {url: `/lesson-blueprints/runs`, method: 'GET',
        params, signal
    },
      options);
    }




export const getLessonBlueprintControllerListRunsQueryKey = (params?: LessonBlueprintControllerListRunsParams,) => {
    return [
    `/lesson-blueprints/runs`, ...(params ? [params] : [])
    ] as const;
    }


export const getLessonBlueprintControllerListRunsQueryOptions = <TData = Awaited<ReturnType<typeof lessonBlueprintControllerListRuns>>, TError = ErrorType<unknown>>(params?: LessonBlueprintControllerListRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonBlueprintControllerListRuns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLessonBlueprintControllerListRunsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lessonBlueprintControllerListRuns>>> = ({ signal }) => lessonBlueprintControllerListRuns(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lessonBlueprintControllerListRuns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LessonBlueprintControllerListRunsQueryResult = NonNullable<Awaited<ReturnType<typeof lessonBlueprintControllerListRuns>>>
export type LessonBlueprintControllerListRunsQueryError = ErrorType<unknown>


export function useLessonBlueprintControllerListRuns<TData = Awaited<ReturnType<typeof lessonBlueprintControllerListRuns>>, TError = ErrorType<unknown>>(
 params: undefined |  LessonBlueprintControllerListRunsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonBlueprintControllerListRuns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonBlueprintControllerListRuns>>,
          TError,
          Awaited<ReturnType<typeof lessonBlueprintControllerListRuns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonBlueprintControllerListRuns<TData = Awaited<ReturnType<typeof lessonBlueprintControllerListRuns>>, TError = ErrorType<unknown>>(
 params?: LessonBlueprintControllerListRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonBlueprintControllerListRuns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonBlueprintControllerListRuns>>,
          TError,
          Awaited<ReturnType<typeof lessonBlueprintControllerListRuns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonBlueprintControllerListRuns<TData = Awaited<ReturnType<typeof lessonBlueprintControllerListRuns>>, TError = ErrorType<unknown>>(
 params?: LessonBlueprintControllerListRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonBlueprintControllerListRuns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLessonBlueprintControllerListRuns<TData = Awaited<ReturnType<typeof lessonBlueprintControllerListRuns>>, TError = ErrorType<unknown>>(
 params?: LessonBlueprintControllerListRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonBlueprintControllerListRuns>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLessonBlueprintControllerListRunsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLessonBlueprintControllerListRuns} query
 */
export const invalidateLessonBlueprintControllerListRuns = async (
 queryClient: QueryClient, params?: LessonBlueprintControllerListRunsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLessonBlueprintControllerListRunsQueryKey(params) }, options);

  return queryClient;
}

export const useSetLessonBlueprintControllerListRunsQueryData = () => {
  const queryClient = useQueryClient();
  return (params: LessonBlueprintControllerListRunsParams | undefined,updater: Awaited<ReturnType<typeof lessonBlueprintControllerListRuns>> | undefined | ((old: Awaited<ReturnType<typeof lessonBlueprintControllerListRuns>> | undefined) => Awaited<ReturnType<typeof lessonBlueprintControllerListRuns>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof lessonBlueprintControllerListRuns>>>({ exact: $exactMatch, queryKey: getLessonBlueprintControllerListRunsQueryKey(params) }, updater);
  };
}

export const useGetLessonBlueprintControllerListRunsQueryData = () => {
  const queryClient = useQueryClient();
  return (params?: LessonBlueprintControllerListRunsParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof lessonBlueprintControllerListRuns>>>(getLessonBlueprintControllerListRunsQueryKey(params));
}



export const lessonBlueprintControllerGetRun = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RunWithBlueprintsResponseDto>(
      {url: `/lesson-blueprints/runs/${id}`, method: 'GET', signal
    },
      options);
    }




export const getLessonBlueprintControllerGetRunQueryKey = (id: string,) => {
    return [
    `/lesson-blueprints/runs/${id}`
    ] as const;
    }


export const getLessonBlueprintControllerGetRunQueryOptions = <TData = Awaited<ReturnType<typeof lessonBlueprintControllerGetRun>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonBlueprintControllerGetRun>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLessonBlueprintControllerGetRunQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lessonBlueprintControllerGetRun>>> = ({ signal }) => lessonBlueprintControllerGetRun(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lessonBlueprintControllerGetRun>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LessonBlueprintControllerGetRunQueryResult = NonNullable<Awaited<ReturnType<typeof lessonBlueprintControllerGetRun>>>
export type LessonBlueprintControllerGetRunQueryError = ErrorType<unknown>


export function useLessonBlueprintControllerGetRun<TData = Awaited<ReturnType<typeof lessonBlueprintControllerGetRun>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonBlueprintControllerGetRun>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonBlueprintControllerGetRun>>,
          TError,
          Awaited<ReturnType<typeof lessonBlueprintControllerGetRun>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonBlueprintControllerGetRun<TData = Awaited<ReturnType<typeof lessonBlueprintControllerGetRun>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonBlueprintControllerGetRun>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonBlueprintControllerGetRun>>,
          TError,
          Awaited<ReturnType<typeof lessonBlueprintControllerGetRun>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonBlueprintControllerGetRun<TData = Awaited<ReturnType<typeof lessonBlueprintControllerGetRun>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonBlueprintControllerGetRun>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLessonBlueprintControllerGetRun<TData = Awaited<ReturnType<typeof lessonBlueprintControllerGetRun>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonBlueprintControllerGetRun>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLessonBlueprintControllerGetRunQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLessonBlueprintControllerGetRun} query
 */
export const invalidateLessonBlueprintControllerGetRun = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLessonBlueprintControllerGetRunQueryKey(id) }, options);

  return queryClient;
}

export const useSetLessonBlueprintControllerGetRunQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof lessonBlueprintControllerGetRun>> | undefined | ((old: Awaited<ReturnType<typeof lessonBlueprintControllerGetRun>> | undefined) => Awaited<ReturnType<typeof lessonBlueprintControllerGetRun>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof lessonBlueprintControllerGetRun>>>({ exact: $exactMatch, queryKey: getLessonBlueprintControllerGetRunQueryKey(id) }, updater);
  };
}

export const useGetLessonBlueprintControllerGetRunQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof lessonBlueprintControllerGetRun>>>(getLessonBlueprintControllerGetRunQueryKey(id));
}



export const lessonBlueprintControllerRenameRun = (
    id: string,
    renameRunDto: BodyType<RenameRunDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GroupingRunResponseDto>(
      {url: `/lesson-blueprints/runs/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: renameRunDto, signal
    },
      options);
    }




export const getLessonBlueprintControllerRenameRunMutationKey = () => ['lessonBlueprintControllerRenameRun'] as const;

export const getLessonBlueprintControllerRenameRunMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonBlueprintControllerRenameRun>>, TError,LessonBlueprintControllerRenameRunMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof lessonBlueprintControllerRenameRun>>, TError,LessonBlueprintControllerRenameRunMutationVariables, TContext> => {

const mutationKey = getLessonBlueprintControllerRenameRunMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof lessonBlueprintControllerRenameRun>>, LessonBlueprintControllerRenameRunMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  lessonBlueprintControllerRenameRun(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LessonBlueprintControllerRenameRunMutationResult = NonNullable<Awaited<ReturnType<typeof lessonBlueprintControllerRenameRun>>>
    export type LessonBlueprintControllerRenameRunMutationBody = BodyType<RenameRunDto>
    export type LessonBlueprintControllerRenameRunMutationError = ErrorType<unknown>
    export type LessonBlueprintControllerRenameRunMutationVariables = {id: string;data: BodyType<RenameRunDto>}

    export const useLessonBlueprintControllerRenameRun = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonBlueprintControllerRenameRun>>, TError,LessonBlueprintControllerRenameRunMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof lessonBlueprintControllerRenameRun>>,
        TError,
        LessonBlueprintControllerRenameRunMutationVariables,
        TContext
      > => {
      return useMutation(getLessonBlueprintControllerRenameRunMutationOptions(options), queryClient);
    }

export const lessonBlueprintControllerDeleteRun = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DeleteRunResultDto>(
      {url: `/lesson-blueprints/runs/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getLessonBlueprintControllerDeleteRunMutationKey = () => ['lessonBlueprintControllerDeleteRun'] as const;

export const getLessonBlueprintControllerDeleteRunMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonBlueprintControllerDeleteRun>>, TError,LessonBlueprintControllerDeleteRunMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof lessonBlueprintControllerDeleteRun>>, TError,LessonBlueprintControllerDeleteRunMutationVariables, TContext> => {

const mutationKey = getLessonBlueprintControllerDeleteRunMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof lessonBlueprintControllerDeleteRun>>, LessonBlueprintControllerDeleteRunMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  lessonBlueprintControllerDeleteRun(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LessonBlueprintControllerDeleteRunMutationResult = NonNullable<Awaited<ReturnType<typeof lessonBlueprintControllerDeleteRun>>>

    export type LessonBlueprintControllerDeleteRunMutationError = ErrorType<unknown>
    export type LessonBlueprintControllerDeleteRunMutationVariables = {id: string}

    export const useLessonBlueprintControllerDeleteRun = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonBlueprintControllerDeleteRun>>, TError,LessonBlueprintControllerDeleteRunMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof lessonBlueprintControllerDeleteRun>>,
        TError,
        LessonBlueprintControllerDeleteRunMutationVariables,
        TContext
      > => {
      return useMutation(getLessonBlueprintControllerDeleteRunMutationOptions(options), queryClient);
    }

/**
 * @summary Extract the blueprints the author ticked; a failure is recorded per blueprint.
 */
export const lessonBlueprintControllerExtract = (
    extractBlueprintsDto: BodyType<ExtractBlueprintsDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LessonBlueprintResponseDto[]>(
      {url: `/lesson-blueprints/extract`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: extractBlueprintsDto, signal
    },
      options);
    }




export const getLessonBlueprintControllerExtractMutationKey = () => ['lessonBlueprintControllerExtract'] as const;

export const getLessonBlueprintControllerExtractMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonBlueprintControllerExtract>>, TError,LessonBlueprintControllerExtractMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof lessonBlueprintControllerExtract>>, TError,LessonBlueprintControllerExtractMutationVariables, TContext> => {

const mutationKey = getLessonBlueprintControllerExtractMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof lessonBlueprintControllerExtract>>, LessonBlueprintControllerExtractMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  lessonBlueprintControllerExtract(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LessonBlueprintControllerExtractMutationResult = NonNullable<Awaited<ReturnType<typeof lessonBlueprintControllerExtract>>>
    export type LessonBlueprintControllerExtractMutationBody = BodyType<ExtractBlueprintsDto>
    export type LessonBlueprintControllerExtractMutationError = ErrorType<unknown>
    export type LessonBlueprintControllerExtractMutationVariables = {data: BodyType<ExtractBlueprintsDto>}

    /**
 * @summary Extract the blueprints the author ticked; a failure is recorded per blueprint.
 */
export const useLessonBlueprintControllerExtract = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonBlueprintControllerExtract>>, TError,LessonBlueprintControllerExtractMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof lessonBlueprintControllerExtract>>,
        TError,
        LessonBlueprintControllerExtractMutationVariables,
        TContext
      > => {
      return useMutation(getLessonBlueprintControllerExtractMutationOptions(options), queryClient);
    }

export const lessonBlueprintControllerGetBlueprint = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LessonBlueprintResponseDto>(
      {url: `/lesson-blueprints/${id}`, method: 'GET', signal
    },
      options);
    }




export const getLessonBlueprintControllerGetBlueprintQueryKey = (id: string,) => {
    return [
    `/lesson-blueprints/${id}`
    ] as const;
    }


export const getLessonBlueprintControllerGetBlueprintQueryOptions = <TData = Awaited<ReturnType<typeof lessonBlueprintControllerGetBlueprint>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonBlueprintControllerGetBlueprint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLessonBlueprintControllerGetBlueprintQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lessonBlueprintControllerGetBlueprint>>> = ({ signal }) => lessonBlueprintControllerGetBlueprint(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lessonBlueprintControllerGetBlueprint>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LessonBlueprintControllerGetBlueprintQueryResult = NonNullable<Awaited<ReturnType<typeof lessonBlueprintControllerGetBlueprint>>>
export type LessonBlueprintControllerGetBlueprintQueryError = ErrorType<unknown>


export function useLessonBlueprintControllerGetBlueprint<TData = Awaited<ReturnType<typeof lessonBlueprintControllerGetBlueprint>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonBlueprintControllerGetBlueprint>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonBlueprintControllerGetBlueprint>>,
          TError,
          Awaited<ReturnType<typeof lessonBlueprintControllerGetBlueprint>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonBlueprintControllerGetBlueprint<TData = Awaited<ReturnType<typeof lessonBlueprintControllerGetBlueprint>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonBlueprintControllerGetBlueprint>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lessonBlueprintControllerGetBlueprint>>,
          TError,
          Awaited<ReturnType<typeof lessonBlueprintControllerGetBlueprint>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLessonBlueprintControllerGetBlueprint<TData = Awaited<ReturnType<typeof lessonBlueprintControllerGetBlueprint>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonBlueprintControllerGetBlueprint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLessonBlueprintControllerGetBlueprint<TData = Awaited<ReturnType<typeof lessonBlueprintControllerGetBlueprint>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lessonBlueprintControllerGetBlueprint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLessonBlueprintControllerGetBlueprintQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLessonBlueprintControllerGetBlueprint} query
 */
export const invalidateLessonBlueprintControllerGetBlueprint = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLessonBlueprintControllerGetBlueprintQueryKey(id) }, options);

  return queryClient;
}

export const useSetLessonBlueprintControllerGetBlueprintQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof lessonBlueprintControllerGetBlueprint>> | undefined | ((old: Awaited<ReturnType<typeof lessonBlueprintControllerGetBlueprint>> | undefined) => Awaited<ReturnType<typeof lessonBlueprintControllerGetBlueprint>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof lessonBlueprintControllerGetBlueprint>>>({ exact: $exactMatch, queryKey: getLessonBlueprintControllerGetBlueprintQueryKey(id) }, updater);
  };
}

export const useGetLessonBlueprintControllerGetBlueprintQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof lessonBlueprintControllerGetBlueprint>>>(getLessonBlueprintControllerGetBlueprintQueryKey(id));
}



export const lessonBlueprintControllerDeleteBlueprint = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/lesson-blueprints/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getLessonBlueprintControllerDeleteBlueprintMutationKey = () => ['lessonBlueprintControllerDeleteBlueprint'] as const;

export const getLessonBlueprintControllerDeleteBlueprintMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonBlueprintControllerDeleteBlueprint>>, TError,LessonBlueprintControllerDeleteBlueprintMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof lessonBlueprintControllerDeleteBlueprint>>, TError,LessonBlueprintControllerDeleteBlueprintMutationVariables, TContext> => {

const mutationKey = getLessonBlueprintControllerDeleteBlueprintMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof lessonBlueprintControllerDeleteBlueprint>>, LessonBlueprintControllerDeleteBlueprintMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  lessonBlueprintControllerDeleteBlueprint(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LessonBlueprintControllerDeleteBlueprintMutationResult = NonNullable<Awaited<ReturnType<typeof lessonBlueprintControllerDeleteBlueprint>>>

    export type LessonBlueprintControllerDeleteBlueprintMutationError = ErrorType<unknown>
    export type LessonBlueprintControllerDeleteBlueprintMutationVariables = {id: string}

    export const useLessonBlueprintControllerDeleteBlueprint = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonBlueprintControllerDeleteBlueprint>>, TError,LessonBlueprintControllerDeleteBlueprintMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof lessonBlueprintControllerDeleteBlueprint>>,
        TError,
        LessonBlueprintControllerDeleteBlueprintMutationVariables,
        TContext
      > => {
      return useMutation(getLessonBlueprintControllerDeleteBlueprintMutationOptions(options), queryClient);
    }

/**
 * @summary The pre-flight, from the edit form, before a build is paid for.
 */
export const lessonBlueprintControllerResolveSenses = (
    id: string,
    resolveSensesDto: BodyType<ResolveSensesDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ResolveVocabSensesResponseDto>(
      {url: `/lesson-blueprints/${id}/resolve-senses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resolveSensesDto, signal
    },
      options);
    }




export const getLessonBlueprintControllerResolveSensesMutationKey = () => ['lessonBlueprintControllerResolveSenses'] as const;

export const getLessonBlueprintControllerResolveSensesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonBlueprintControllerResolveSenses>>, TError,LessonBlueprintControllerResolveSensesMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof lessonBlueprintControllerResolveSenses>>, TError,LessonBlueprintControllerResolveSensesMutationVariables, TContext> => {

const mutationKey = getLessonBlueprintControllerResolveSensesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof lessonBlueprintControllerResolveSenses>>, LessonBlueprintControllerResolveSensesMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  lessonBlueprintControllerResolveSenses(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LessonBlueprintControllerResolveSensesMutationResult = NonNullable<Awaited<ReturnType<typeof lessonBlueprintControllerResolveSenses>>>
    export type LessonBlueprintControllerResolveSensesMutationBody = BodyType<ResolveSensesDto>
    export type LessonBlueprintControllerResolveSensesMutationError = ErrorType<unknown>
    export type LessonBlueprintControllerResolveSensesMutationVariables = {id: string;data: BodyType<ResolveSensesDto>}

    /**
 * @summary The pre-flight, from the edit form, before a build is paid for.
 */
export const useLessonBlueprintControllerResolveSenses = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonBlueprintControllerResolveSenses>>, TError,LessonBlueprintControllerResolveSensesMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof lessonBlueprintControllerResolveSenses>>,
        TError,
        LessonBlueprintControllerResolveSensesMutationVariables,
        TContext
      > => {
      return useMutation(getLessonBlueprintControllerResolveSensesMutationOptions(options), queryClient);
    }

export const lessonBlueprintControllerBuild = (
    id: string,
    buildBlueprintDto: BodyType<BuildBlueprintDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LessonBlueprintResponseDto>(
      {url: `/lesson-blueprints/${id}/build`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: buildBlueprintDto, signal
    },
      options);
    }




export const getLessonBlueprintControllerBuildMutationKey = () => ['lessonBlueprintControllerBuild'] as const;

export const getLessonBlueprintControllerBuildMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonBlueprintControllerBuild>>, TError,LessonBlueprintControllerBuildMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof lessonBlueprintControllerBuild>>, TError,LessonBlueprintControllerBuildMutationVariables, TContext> => {

const mutationKey = getLessonBlueprintControllerBuildMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof lessonBlueprintControllerBuild>>, LessonBlueprintControllerBuildMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  lessonBlueprintControllerBuild(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LessonBlueprintControllerBuildMutationResult = NonNullable<Awaited<ReturnType<typeof lessonBlueprintControllerBuild>>>
    export type LessonBlueprintControllerBuildMutationBody = BodyType<BuildBlueprintDto>
    export type LessonBlueprintControllerBuildMutationError = ErrorType<unknown>
    export type LessonBlueprintControllerBuildMutationVariables = {id: string;data: BodyType<BuildBlueprintDto>}

    export const useLessonBlueprintControllerBuild = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonBlueprintControllerBuild>>, TError,LessonBlueprintControllerBuildMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof lessonBlueprintControllerBuild>>,
        TError,
        LessonBlueprintControllerBuildMutationVariables,
        TContext
      > => {
      return useMutation(getLessonBlueprintControllerBuildMutationOptions(options), queryClient);
    }

/**
 * @summary Content Builder's edits, saved so Activity Preview -- which reads the blueprint -- sees them.
 */
export const lessonBlueprintControllerSaveLesson = (
    id: string,
    saveBlueprintLessonDto: BodyType<SaveBlueprintLessonDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LessonBlueprintResponseDto>(
      {url: `/lesson-blueprints/${id}/lesson`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveBlueprintLessonDto, signal
    },
      options);
    }




export const getLessonBlueprintControllerSaveLessonMutationKey = () => ['lessonBlueprintControllerSaveLesson'] as const;

export const getLessonBlueprintControllerSaveLessonMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonBlueprintControllerSaveLesson>>, TError,LessonBlueprintControllerSaveLessonMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof lessonBlueprintControllerSaveLesson>>, TError,LessonBlueprintControllerSaveLessonMutationVariables, TContext> => {

const mutationKey = getLessonBlueprintControllerSaveLessonMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof lessonBlueprintControllerSaveLesson>>, LessonBlueprintControllerSaveLessonMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  lessonBlueprintControllerSaveLesson(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LessonBlueprintControllerSaveLessonMutationResult = NonNullable<Awaited<ReturnType<typeof lessonBlueprintControllerSaveLesson>>>
    export type LessonBlueprintControllerSaveLessonMutationBody = BodyType<SaveBlueprintLessonDto>
    export type LessonBlueprintControllerSaveLessonMutationError = ErrorType<unknown>
    export type LessonBlueprintControllerSaveLessonMutationVariables = {id: string;data: BodyType<SaveBlueprintLessonDto>}

    /**
 * @summary Content Builder's edits, saved so Activity Preview -- which reads the blueprint -- sees them.
 */
export const useLessonBlueprintControllerSaveLesson = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lessonBlueprintControllerSaveLesson>>, TError,LessonBlueprintControllerSaveLessonMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof lessonBlueprintControllerSaveLesson>>,
        TError,
        LessonBlueprintControllerSaveLessonMutationVariables,
        TContext
      > => {
      return useMutation(getLessonBlueprintControllerSaveLessonMutationOptions(options), queryClient);
    }

export const edetControllerCreateAccessCodes = (
    edetCreateAccessCodesDto: BodyType<EdetCreateAccessCodesDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/edet/admin/access-codes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: edetCreateAccessCodesDto, signal
    },
      options);
    }




export const getEdetControllerCreateAccessCodesMutationKey = () => ['edetControllerCreateAccessCodes'] as const;

export const getEdetControllerCreateAccessCodesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof edetControllerCreateAccessCodes>>, TError,EdetControllerCreateAccessCodesMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof edetControllerCreateAccessCodes>>, TError,EdetControllerCreateAccessCodesMutationVariables, TContext> => {

const mutationKey = getEdetControllerCreateAccessCodesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof edetControllerCreateAccessCodes>>, EdetControllerCreateAccessCodesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  edetControllerCreateAccessCodes(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EdetControllerCreateAccessCodesMutationResult = NonNullable<Awaited<ReturnType<typeof edetControllerCreateAccessCodes>>>
    export type EdetControllerCreateAccessCodesMutationBody = BodyType<EdetCreateAccessCodesDto>
    export type EdetControllerCreateAccessCodesMutationError = ErrorType<unknown>
    export type EdetControllerCreateAccessCodesMutationVariables = {data: BodyType<EdetCreateAccessCodesDto>}

    export const useEdetControllerCreateAccessCodes = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof edetControllerCreateAccessCodes>>, TError,EdetControllerCreateAccessCodesMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof edetControllerCreateAccessCodes>>,
        TError,
        EdetControllerCreateAccessCodesMutationVariables,
        TContext
      > => {
      return useMutation(getEdetControllerCreateAccessCodesMutationOptions(options), queryClient);
    }

export const edetControllerGetAccessCodeGroupWithDetails = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EdetControllerGetAccessCodeGroupWithDetails200>(
      {url: `/edet/admin/access-code-groups/${id}`, method: 'GET', signal
    },
      options);
    }




export const getEdetControllerGetAccessCodeGroupWithDetailsQueryKey = (id: string,) => {
    return [
    `/edet/admin/access-code-groups/${id}`
    ] as const;
    }


export const getEdetControllerGetAccessCodeGroupWithDetailsQueryOptions = <TData = Awaited<ReturnType<typeof edetControllerGetAccessCodeGroupWithDetails>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edetControllerGetAccessCodeGroupWithDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEdetControllerGetAccessCodeGroupWithDetailsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof edetControllerGetAccessCodeGroupWithDetails>>> = ({ signal }) => edetControllerGetAccessCodeGroupWithDetails(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof edetControllerGetAccessCodeGroupWithDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EdetControllerGetAccessCodeGroupWithDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof edetControllerGetAccessCodeGroupWithDetails>>>
export type EdetControllerGetAccessCodeGroupWithDetailsQueryError = ErrorType<unknown>


export function useEdetControllerGetAccessCodeGroupWithDetails<TData = Awaited<ReturnType<typeof edetControllerGetAccessCodeGroupWithDetails>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof edetControllerGetAccessCodeGroupWithDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof edetControllerGetAccessCodeGroupWithDetails>>,
          TError,
          Awaited<ReturnType<typeof edetControllerGetAccessCodeGroupWithDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEdetControllerGetAccessCodeGroupWithDetails<TData = Awaited<ReturnType<typeof edetControllerGetAccessCodeGroupWithDetails>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edetControllerGetAccessCodeGroupWithDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof edetControllerGetAccessCodeGroupWithDetails>>,
          TError,
          Awaited<ReturnType<typeof edetControllerGetAccessCodeGroupWithDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEdetControllerGetAccessCodeGroupWithDetails<TData = Awaited<ReturnType<typeof edetControllerGetAccessCodeGroupWithDetails>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edetControllerGetAccessCodeGroupWithDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useEdetControllerGetAccessCodeGroupWithDetails<TData = Awaited<ReturnType<typeof edetControllerGetAccessCodeGroupWithDetails>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edetControllerGetAccessCodeGroupWithDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEdetControllerGetAccessCodeGroupWithDetailsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useEdetControllerGetAccessCodeGroupWithDetails} query
 */
export const invalidateEdetControllerGetAccessCodeGroupWithDetails = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getEdetControllerGetAccessCodeGroupWithDetailsQueryKey(id) }, options);

  return queryClient;
}

export const useSetEdetControllerGetAccessCodeGroupWithDetailsQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof edetControllerGetAccessCodeGroupWithDetails>> | undefined | ((old: Awaited<ReturnType<typeof edetControllerGetAccessCodeGroupWithDetails>> | undefined) => Awaited<ReturnType<typeof edetControllerGetAccessCodeGroupWithDetails>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof edetControllerGetAccessCodeGroupWithDetails>>>({ exact: $exactMatch, queryKey: getEdetControllerGetAccessCodeGroupWithDetailsQueryKey(id) }, updater);
  };
}

export const useGetEdetControllerGetAccessCodeGroupWithDetailsQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof edetControllerGetAccessCodeGroupWithDetails>>>(getEdetControllerGetAccessCodeGroupWithDetailsQueryKey(id));
}



export const edetControllerGetAccessCodeGroups = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EdetControllerGetAccessCodeGroups200Item[]>(
      {url: `/edet/admin/access-code-groups`, method: 'GET', signal
    },
      options);
    }




export const getEdetControllerGetAccessCodeGroupsQueryKey = () => {
    return [
    `/edet/admin/access-code-groups`
    ] as const;
    }


export const getEdetControllerGetAccessCodeGroupsQueryOptions = <TData = Awaited<ReturnType<typeof edetControllerGetAccessCodeGroups>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edetControllerGetAccessCodeGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEdetControllerGetAccessCodeGroupsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof edetControllerGetAccessCodeGroups>>> = ({ signal }) => edetControllerGetAccessCodeGroups(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof edetControllerGetAccessCodeGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EdetControllerGetAccessCodeGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof edetControllerGetAccessCodeGroups>>>
export type EdetControllerGetAccessCodeGroupsQueryError = ErrorType<unknown>


export function useEdetControllerGetAccessCodeGroups<TData = Awaited<ReturnType<typeof edetControllerGetAccessCodeGroups>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof edetControllerGetAccessCodeGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof edetControllerGetAccessCodeGroups>>,
          TError,
          Awaited<ReturnType<typeof edetControllerGetAccessCodeGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEdetControllerGetAccessCodeGroups<TData = Awaited<ReturnType<typeof edetControllerGetAccessCodeGroups>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edetControllerGetAccessCodeGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof edetControllerGetAccessCodeGroups>>,
          TError,
          Awaited<ReturnType<typeof edetControllerGetAccessCodeGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEdetControllerGetAccessCodeGroups<TData = Awaited<ReturnType<typeof edetControllerGetAccessCodeGroups>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edetControllerGetAccessCodeGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useEdetControllerGetAccessCodeGroups<TData = Awaited<ReturnType<typeof edetControllerGetAccessCodeGroups>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof edetControllerGetAccessCodeGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEdetControllerGetAccessCodeGroupsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useEdetControllerGetAccessCodeGroups} query
 */
export const invalidateEdetControllerGetAccessCodeGroups = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getEdetControllerGetAccessCodeGroupsQueryKey() }, options);

  return queryClient;
}

export const useSetEdetControllerGetAccessCodeGroupsQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof edetControllerGetAccessCodeGroups>> | undefined | ((old: Awaited<ReturnType<typeof edetControllerGetAccessCodeGroups>> | undefined) => Awaited<ReturnType<typeof edetControllerGetAccessCodeGroups>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof edetControllerGetAccessCodeGroups>>>({ exact: $exactMatch, queryKey: getEdetControllerGetAccessCodeGroupsQueryKey() }, updater);
  };
}

export const useGetEdetControllerGetAccessCodeGroupsQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof edetControllerGetAccessCodeGroups>>>(getEdetControllerGetAccessCodeGroupsQueryKey());
}



export const dataExportControllerGetStudentActivityResultCsvByClassroom = (
    classroomId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<string>(
      {url: `/data-exports/student-activity-data-by-classroom/${classroomId}`, method: 'GET', signal
    },
      options);
    }




export const getDataExportControllerGetStudentActivityResultCsvByClassroomQueryKey = (classroomId: string,) => {
    return [
    `/data-exports/student-activity-data-by-classroom/${classroomId}`
    ] as const;
    }


export const getDataExportControllerGetStudentActivityResultCsvByClassroomQueryOptions = <TData = Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByClassroom>>, TError = ErrorType<unknown>>(classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDataExportControllerGetStudentActivityResultCsvByClassroomQueryKey(classroomId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByClassroom>>> = ({ signal }) => dataExportControllerGetStudentActivityResultCsvByClassroom(classroomId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByClassroom>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DataExportControllerGetStudentActivityResultCsvByClassroomQueryResult = NonNullable<Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByClassroom>>>
export type DataExportControllerGetStudentActivityResultCsvByClassroomQueryError = ErrorType<unknown>


export function useDataExportControllerGetStudentActivityResultCsvByClassroom<TData = Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByClassroom>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByClassroom>>,
          TError,
          Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByClassroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDataExportControllerGetStudentActivityResultCsvByClassroom<TData = Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByClassroom>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByClassroom>>,
          TError,
          Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByClassroom>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDataExportControllerGetStudentActivityResultCsvByClassroom<TData = Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDataExportControllerGetStudentActivityResultCsvByClassroom<TData = Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByClassroom>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByClassroom>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDataExportControllerGetStudentActivityResultCsvByClassroomQueryOptions(classroomId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useDataExportControllerGetStudentActivityResultCsvByClassroom} query
 */
export const invalidateDataExportControllerGetStudentActivityResultCsvByClassroom = async (
 queryClient: QueryClient, classroomId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getDataExportControllerGetStudentActivityResultCsvByClassroomQueryKey(classroomId) }, options);

  return queryClient;
}

export const useSetDataExportControllerGetStudentActivityResultCsvByClassroomQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,updater: Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByClassroom>> | undefined | ((old: Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByClassroom>> | undefined) => Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByClassroom>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByClassroom>>>({ exact: $exactMatch, queryKey: getDataExportControllerGetStudentActivityResultCsvByClassroomQueryKey(classroomId) }, updater);
  };
}

export const useGetDataExportControllerGetStudentActivityResultCsvByClassroomQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByClassroom>>>(getDataExportControllerGetStudentActivityResultCsvByClassroomQueryKey(classroomId));
}



export const dataExportControllerGetStudentActivityResultCsvByLesson = (
    classroomId: string,
    lessonId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<string>(
      {url: `/data-exports/student-activity-data-by-classroom-and-lesson/${classroomId}/lessons/${lessonId}`, method: 'GET', signal
    },
      options);
    }




export const getDataExportControllerGetStudentActivityResultCsvByLessonQueryKey = (classroomId: string,
    lessonId: string,) => {
    return [
    `/data-exports/student-activity-data-by-classroom-and-lesson/${classroomId}/lessons/${lessonId}`
    ] as const;
    }


export const getDataExportControllerGetStudentActivityResultCsvByLessonQueryOptions = <TData = Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByLesson>>, TError = ErrorType<unknown>>(classroomId: string,
    lessonId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByLesson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDataExportControllerGetStudentActivityResultCsvByLessonQueryKey(classroomId,lessonId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByLesson>>> = ({ signal }) => dataExportControllerGetStudentActivityResultCsvByLesson(classroomId,lessonId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined && lessonId !== null && lessonId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByLesson>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DataExportControllerGetStudentActivityResultCsvByLessonQueryResult = NonNullable<Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByLesson>>>
export type DataExportControllerGetStudentActivityResultCsvByLessonQueryError = ErrorType<unknown>


export function useDataExportControllerGetStudentActivityResultCsvByLesson<TData = Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByLesson>>, TError = ErrorType<unknown>>(
 classroomId: string,
    lessonId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByLesson>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByLesson>>,
          TError,
          Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByLesson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDataExportControllerGetStudentActivityResultCsvByLesson<TData = Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByLesson>>, TError = ErrorType<unknown>>(
 classroomId: string,
    lessonId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByLesson>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByLesson>>,
          TError,
          Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByLesson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDataExportControllerGetStudentActivityResultCsvByLesson<TData = Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByLesson>>, TError = ErrorType<unknown>>(
 classroomId: string,
    lessonId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByLesson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDataExportControllerGetStudentActivityResultCsvByLesson<TData = Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByLesson>>, TError = ErrorType<unknown>>(
 classroomId: string,
    lessonId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByLesson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDataExportControllerGetStudentActivityResultCsvByLessonQueryOptions(classroomId,lessonId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useDataExportControllerGetStudentActivityResultCsvByLesson} query
 */
export const invalidateDataExportControllerGetStudentActivityResultCsvByLesson = async (
 queryClient: QueryClient, classroomId: string,
    lessonId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getDataExportControllerGetStudentActivityResultCsvByLessonQueryKey(classroomId,lessonId) }, options);

  return queryClient;
}

export const useSetDataExportControllerGetStudentActivityResultCsvByLessonQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    lessonId: string,updater: Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByLesson>> | undefined | ((old: Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByLesson>> | undefined) => Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByLesson>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByLesson>>>({ exact: $exactMatch, queryKey: getDataExportControllerGetStudentActivityResultCsvByLessonQueryKey(classroomId,lessonId) }, updater);
  };
}

export const useGetDataExportControllerGetStudentActivityResultCsvByLessonQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    lessonId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof dataExportControllerGetStudentActivityResultCsvByLesson>>>(getDataExportControllerGetStudentActivityResultCsvByLessonQueryKey(classroomId,lessonId));
}



export const dataExportControllerGetShoolProgressCsvByClassroomDate = (
    params: DataExportControllerGetShoolProgressCsvByClassroomDateParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<string>(
      {url: `/data-exports/school-progress-by-classroom-date`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDataExportControllerGetShoolProgressCsvByClassroomDateQueryKey = (params?: DataExportControllerGetShoolProgressCsvByClassroomDateParams,) => {
    return [
    `/data-exports/school-progress-by-classroom-date`, ...(params ? [params] : [])
    ] as const;
    }


export const getDataExportControllerGetShoolProgressCsvByClassroomDateQueryOptions = <TData = Awaited<ReturnType<typeof dataExportControllerGetShoolProgressCsvByClassroomDate>>, TError = ErrorType<unknown>>(params: DataExportControllerGetShoolProgressCsvByClassroomDateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dataExportControllerGetShoolProgressCsvByClassroomDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDataExportControllerGetShoolProgressCsvByClassroomDateQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof dataExportControllerGetShoolProgressCsvByClassroomDate>>> = ({ signal }) => dataExportControllerGetShoolProgressCsvByClassroomDate(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dataExportControllerGetShoolProgressCsvByClassroomDate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DataExportControllerGetShoolProgressCsvByClassroomDateQueryResult = NonNullable<Awaited<ReturnType<typeof dataExportControllerGetShoolProgressCsvByClassroomDate>>>
export type DataExportControllerGetShoolProgressCsvByClassroomDateQueryError = ErrorType<unknown>


export function useDataExportControllerGetShoolProgressCsvByClassroomDate<TData = Awaited<ReturnType<typeof dataExportControllerGetShoolProgressCsvByClassroomDate>>, TError = ErrorType<unknown>>(
 params: DataExportControllerGetShoolProgressCsvByClassroomDateParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof dataExportControllerGetShoolProgressCsvByClassroomDate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dataExportControllerGetShoolProgressCsvByClassroomDate>>,
          TError,
          Awaited<ReturnType<typeof dataExportControllerGetShoolProgressCsvByClassroomDate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDataExportControllerGetShoolProgressCsvByClassroomDate<TData = Awaited<ReturnType<typeof dataExportControllerGetShoolProgressCsvByClassroomDate>>, TError = ErrorType<unknown>>(
 params: DataExportControllerGetShoolProgressCsvByClassroomDateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dataExportControllerGetShoolProgressCsvByClassroomDate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dataExportControllerGetShoolProgressCsvByClassroomDate>>,
          TError,
          Awaited<ReturnType<typeof dataExportControllerGetShoolProgressCsvByClassroomDate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDataExportControllerGetShoolProgressCsvByClassroomDate<TData = Awaited<ReturnType<typeof dataExportControllerGetShoolProgressCsvByClassroomDate>>, TError = ErrorType<unknown>>(
 params: DataExportControllerGetShoolProgressCsvByClassroomDateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dataExportControllerGetShoolProgressCsvByClassroomDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDataExportControllerGetShoolProgressCsvByClassroomDate<TData = Awaited<ReturnType<typeof dataExportControllerGetShoolProgressCsvByClassroomDate>>, TError = ErrorType<unknown>>(
 params: DataExportControllerGetShoolProgressCsvByClassroomDateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dataExportControllerGetShoolProgressCsvByClassroomDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDataExportControllerGetShoolProgressCsvByClassroomDateQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useDataExportControllerGetShoolProgressCsvByClassroomDate} query
 */
export const invalidateDataExportControllerGetShoolProgressCsvByClassroomDate = async (
 queryClient: QueryClient, params: DataExportControllerGetShoolProgressCsvByClassroomDateParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getDataExportControllerGetShoolProgressCsvByClassroomDateQueryKey(params) }, options);

  return queryClient;
}

export const useSetDataExportControllerGetShoolProgressCsvByClassroomDateQueryData = () => {
  const queryClient = useQueryClient();
  return (params: DataExportControllerGetShoolProgressCsvByClassroomDateParams | undefined,updater: Awaited<ReturnType<typeof dataExportControllerGetShoolProgressCsvByClassroomDate>> | undefined | ((old: Awaited<ReturnType<typeof dataExportControllerGetShoolProgressCsvByClassroomDate>> | undefined) => Awaited<ReturnType<typeof dataExportControllerGetShoolProgressCsvByClassroomDate>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof dataExportControllerGetShoolProgressCsvByClassroomDate>>>({ exact: $exactMatch, queryKey: getDataExportControllerGetShoolProgressCsvByClassroomDateQueryKey(params) }, updater);
  };
}

export const useGetDataExportControllerGetShoolProgressCsvByClassroomDateQueryData = () => {
  const queryClient = useQueryClient();
  return (params: DataExportControllerGetShoolProgressCsvByClassroomDateParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof dataExportControllerGetShoolProgressCsvByClassroomDate>>>(getDataExportControllerGetShoolProgressCsvByClassroomDateQueryKey(params));
}



export const userResourceAccessControllerGetResourceUsers = (
    resourceType: 'classrooms' | 'schools',
    resourceId: string,
    params?: UserResourceAccessControllerGetResourceUsersParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/user-resource-access/resource-users/${resourceType}/${resourceId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUserResourceAccessControllerGetResourceUsersQueryKey = (resourceType: 'classrooms' | 'schools',
    resourceId: string,
    params?: UserResourceAccessControllerGetResourceUsersParams,) => {
    return [
    `/user-resource-access/resource-users/${resourceType}/${resourceId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getUserResourceAccessControllerGetResourceUsersQueryOptions = <TData = Awaited<ReturnType<typeof userResourceAccessControllerGetResourceUsers>>, TError = ErrorType<unknown>>(resourceType: 'classrooms' | 'schools',
    resourceId: string,
    params?: UserResourceAccessControllerGetResourceUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetResourceUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserResourceAccessControllerGetResourceUsersQueryKey(resourceType,resourceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userResourceAccessControllerGetResourceUsers>>> = ({ signal }) => userResourceAccessControllerGetResourceUsers(resourceType,resourceId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: resourceType !== null && resourceType !== undefined && resourceId !== null && resourceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetResourceUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserResourceAccessControllerGetResourceUsersQueryResult = NonNullable<Awaited<ReturnType<typeof userResourceAccessControllerGetResourceUsers>>>
export type UserResourceAccessControllerGetResourceUsersQueryError = ErrorType<unknown>


export function useUserResourceAccessControllerGetResourceUsers<TData = Awaited<ReturnType<typeof userResourceAccessControllerGetResourceUsers>>, TError = ErrorType<unknown>>(
 resourceType: 'classrooms' | 'schools',
    resourceId: string,
    params: undefined |  UserResourceAccessControllerGetResourceUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetResourceUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userResourceAccessControllerGetResourceUsers>>,
          TError,
          Awaited<ReturnType<typeof userResourceAccessControllerGetResourceUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserResourceAccessControllerGetResourceUsers<TData = Awaited<ReturnType<typeof userResourceAccessControllerGetResourceUsers>>, TError = ErrorType<unknown>>(
 resourceType: 'classrooms' | 'schools',
    resourceId: string,
    params?: UserResourceAccessControllerGetResourceUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetResourceUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userResourceAccessControllerGetResourceUsers>>,
          TError,
          Awaited<ReturnType<typeof userResourceAccessControllerGetResourceUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserResourceAccessControllerGetResourceUsers<TData = Awaited<ReturnType<typeof userResourceAccessControllerGetResourceUsers>>, TError = ErrorType<unknown>>(
 resourceType: 'classrooms' | 'schools',
    resourceId: string,
    params?: UserResourceAccessControllerGetResourceUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetResourceUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserResourceAccessControllerGetResourceUsers<TData = Awaited<ReturnType<typeof userResourceAccessControllerGetResourceUsers>>, TError = ErrorType<unknown>>(
 resourceType: 'classrooms' | 'schools',
    resourceId: string,
    params?: UserResourceAccessControllerGetResourceUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetResourceUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserResourceAccessControllerGetResourceUsersQueryOptions(resourceType,resourceId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useUserResourceAccessControllerGetResourceUsers} query
 */
export const invalidateUserResourceAccessControllerGetResourceUsers = async (
 queryClient: QueryClient, resourceType: 'classrooms' | 'schools',
    resourceId: string,
    params?: UserResourceAccessControllerGetResourceUsersParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getUserResourceAccessControllerGetResourceUsersQueryKey(resourceType,resourceId,params) }, options);

  return queryClient;
}

export const useSetUserResourceAccessControllerGetResourceUsersQueryData = () => {
  const queryClient = useQueryClient();
  return (resourceType: 'classrooms' | 'schools',
    resourceId: string,
    params: UserResourceAccessControllerGetResourceUsersParams | undefined,updater: Awaited<ReturnType<typeof userResourceAccessControllerGetResourceUsers>> | undefined | ((old: Awaited<ReturnType<typeof userResourceAccessControllerGetResourceUsers>> | undefined) => Awaited<ReturnType<typeof userResourceAccessControllerGetResourceUsers>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof userResourceAccessControllerGetResourceUsers>>>({ exact: $exactMatch, queryKey: getUserResourceAccessControllerGetResourceUsersQueryKey(resourceType,resourceId,params) }, updater);
  };
}

export const useGetUserResourceAccessControllerGetResourceUsersQueryData = () => {
  const queryClient = useQueryClient();
  return (resourceType: 'classrooms' | 'schools',
    resourceId: string,
    params?: UserResourceAccessControllerGetResourceUsersParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof userResourceAccessControllerGetResourceUsers>>>(getUserResourceAccessControllerGetResourceUsersQueryKey(resourceType,resourceId,params));
}



export const userResourceAccessControllerGetMyAccessibleSchools = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<School[]>(
      {url: `/user-resource-access/users/me/schools`, method: 'GET', signal
    },
      options);
    }




export const getUserResourceAccessControllerGetMyAccessibleSchoolsQueryKey = () => {
    return [
    `/user-resource-access/users/me/schools`
    ] as const;
    }


export const getUserResourceAccessControllerGetMyAccessibleSchoolsQueryOptions = <TData = Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleSchools>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleSchools>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserResourceAccessControllerGetMyAccessibleSchoolsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleSchools>>> = ({ signal }) => userResourceAccessControllerGetMyAccessibleSchools(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleSchools>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserResourceAccessControllerGetMyAccessibleSchoolsQueryResult = NonNullable<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleSchools>>>
export type UserResourceAccessControllerGetMyAccessibleSchoolsQueryError = ErrorType<unknown>


export function useUserResourceAccessControllerGetMyAccessibleSchools<TData = Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleSchools>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleSchools>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleSchools>>,
          TError,
          Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleSchools>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserResourceAccessControllerGetMyAccessibleSchools<TData = Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleSchools>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleSchools>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleSchools>>,
          TError,
          Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleSchools>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserResourceAccessControllerGetMyAccessibleSchools<TData = Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleSchools>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleSchools>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserResourceAccessControllerGetMyAccessibleSchools<TData = Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleSchools>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleSchools>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserResourceAccessControllerGetMyAccessibleSchoolsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useUserResourceAccessControllerGetMyAccessibleSchools} query
 */
export const invalidateUserResourceAccessControllerGetMyAccessibleSchools = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getUserResourceAccessControllerGetMyAccessibleSchoolsQueryKey() }, options);

  return queryClient;
}

export const useSetUserResourceAccessControllerGetMyAccessibleSchoolsQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleSchools>> | undefined | ((old: Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleSchools>> | undefined) => Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleSchools>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleSchools>>>({ exact: $exactMatch, queryKey: getUserResourceAccessControllerGetMyAccessibleSchoolsQueryKey() }, updater);
  };
}

export const useGetUserResourceAccessControllerGetMyAccessibleSchoolsQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleSchools>>>(getUserResourceAccessControllerGetMyAccessibleSchoolsQueryKey());
}



export const userResourceAccessControllerGetMyAccessibleClassrooms = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Classroom[]>(
      {url: `/user-resource-access/users/me/classrooms`, method: 'GET', signal
    },
      options);
    }




export const getUserResourceAccessControllerGetMyAccessibleClassroomsQueryKey = () => {
    return [
    `/user-resource-access/users/me/classrooms`
    ] as const;
    }


export const getUserResourceAccessControllerGetMyAccessibleClassroomsQueryOptions = <TData = Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleClassrooms>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleClassrooms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserResourceAccessControllerGetMyAccessibleClassroomsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleClassrooms>>> = ({ signal }) => userResourceAccessControllerGetMyAccessibleClassrooms(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleClassrooms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserResourceAccessControllerGetMyAccessibleClassroomsQueryResult = NonNullable<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleClassrooms>>>
export type UserResourceAccessControllerGetMyAccessibleClassroomsQueryError = ErrorType<unknown>


export function useUserResourceAccessControllerGetMyAccessibleClassrooms<TData = Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleClassrooms>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleClassrooms>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleClassrooms>>,
          TError,
          Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleClassrooms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserResourceAccessControllerGetMyAccessibleClassrooms<TData = Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleClassrooms>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleClassrooms>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleClassrooms>>,
          TError,
          Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleClassrooms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserResourceAccessControllerGetMyAccessibleClassrooms<TData = Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleClassrooms>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleClassrooms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserResourceAccessControllerGetMyAccessibleClassrooms<TData = Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleClassrooms>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleClassrooms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserResourceAccessControllerGetMyAccessibleClassroomsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useUserResourceAccessControllerGetMyAccessibleClassrooms} query
 */
export const invalidateUserResourceAccessControllerGetMyAccessibleClassrooms = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getUserResourceAccessControllerGetMyAccessibleClassroomsQueryKey() }, options);

  return queryClient;
}

export const useSetUserResourceAccessControllerGetMyAccessibleClassroomsQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleClassrooms>> | undefined | ((old: Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleClassrooms>> | undefined) => Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleClassrooms>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleClassrooms>>>({ exact: $exactMatch, queryKey: getUserResourceAccessControllerGetMyAccessibleClassroomsQueryKey() }, updater);
  };
}

export const useGetUserResourceAccessControllerGetMyAccessibleClassroomsQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleClassrooms>>>(getUserResourceAccessControllerGetMyAccessibleClassroomsQueryKey());
}



export const userResourceAccessControllerGetMyAccessibleUsers = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<User[]>(
      {url: `/user-resource-access/users/me/users`, method: 'GET', signal
    },
      options);
    }




export const getUserResourceAccessControllerGetMyAccessibleUsersQueryKey = () => {
    return [
    `/user-resource-access/users/me/users`
    ] as const;
    }


export const getUserResourceAccessControllerGetMyAccessibleUsersQueryOptions = <TData = Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleUsers>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserResourceAccessControllerGetMyAccessibleUsersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleUsers>>> = ({ signal }) => userResourceAccessControllerGetMyAccessibleUsers(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserResourceAccessControllerGetMyAccessibleUsersQueryResult = NonNullable<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleUsers>>>
export type UserResourceAccessControllerGetMyAccessibleUsersQueryError = ErrorType<unknown>


export function useUserResourceAccessControllerGetMyAccessibleUsers<TData = Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleUsers>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleUsers>>,
          TError,
          Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserResourceAccessControllerGetMyAccessibleUsers<TData = Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleUsers>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleUsers>>,
          TError,
          Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserResourceAccessControllerGetMyAccessibleUsers<TData = Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleUsers>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserResourceAccessControllerGetMyAccessibleUsers<TData = Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleUsers>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserResourceAccessControllerGetMyAccessibleUsersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useUserResourceAccessControllerGetMyAccessibleUsers} query
 */
export const invalidateUserResourceAccessControllerGetMyAccessibleUsers = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getUserResourceAccessControllerGetMyAccessibleUsersQueryKey() }, options);

  return queryClient;
}

export const useSetUserResourceAccessControllerGetMyAccessibleUsersQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleUsers>> | undefined | ((old: Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleUsers>> | undefined) => Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleUsers>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleUsers>>>({ exact: $exactMatch, queryKey: getUserResourceAccessControllerGetMyAccessibleUsersQueryKey() }, updater);
  };
}

export const useGetUserResourceAccessControllerGetMyAccessibleUsersQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof userResourceAccessControllerGetMyAccessibleUsers>>>(getUserResourceAccessControllerGetMyAccessibleUsersQueryKey());
}



export const userResourceAccessControllerGetMyWebappRoutesAccess = (
    params?: UserResourceAccessControllerGetMyWebappRoutesAccessParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/user-resource-access/users/me/webapp-routes-access`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUserResourceAccessControllerGetMyWebappRoutesAccessQueryKey = (params?: UserResourceAccessControllerGetMyWebappRoutesAccessParams,) => {
    return [
    `/user-resource-access/users/me/webapp-routes-access`, ...(params ? [params] : [])
    ] as const;
    }


export const getUserResourceAccessControllerGetMyWebappRoutesAccessQueryOptions = <TData = Awaited<ReturnType<typeof userResourceAccessControllerGetMyWebappRoutesAccess>>, TError = ErrorType<unknown>>(params?: UserResourceAccessControllerGetMyWebappRoutesAccessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetMyWebappRoutesAccess>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserResourceAccessControllerGetMyWebappRoutesAccessQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userResourceAccessControllerGetMyWebappRoutesAccess>>> = ({ signal }) => userResourceAccessControllerGetMyWebappRoutesAccess(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetMyWebappRoutesAccess>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserResourceAccessControllerGetMyWebappRoutesAccessQueryResult = NonNullable<Awaited<ReturnType<typeof userResourceAccessControllerGetMyWebappRoutesAccess>>>
export type UserResourceAccessControllerGetMyWebappRoutesAccessQueryError = ErrorType<unknown>


export function useUserResourceAccessControllerGetMyWebappRoutesAccess<TData = Awaited<ReturnType<typeof userResourceAccessControllerGetMyWebappRoutesAccess>>, TError = ErrorType<unknown>>(
 params: undefined |  UserResourceAccessControllerGetMyWebappRoutesAccessParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetMyWebappRoutesAccess>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userResourceAccessControllerGetMyWebappRoutesAccess>>,
          TError,
          Awaited<ReturnType<typeof userResourceAccessControllerGetMyWebappRoutesAccess>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserResourceAccessControllerGetMyWebappRoutesAccess<TData = Awaited<ReturnType<typeof userResourceAccessControllerGetMyWebappRoutesAccess>>, TError = ErrorType<unknown>>(
 params?: UserResourceAccessControllerGetMyWebappRoutesAccessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetMyWebappRoutesAccess>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userResourceAccessControllerGetMyWebappRoutesAccess>>,
          TError,
          Awaited<ReturnType<typeof userResourceAccessControllerGetMyWebappRoutesAccess>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserResourceAccessControllerGetMyWebappRoutesAccess<TData = Awaited<ReturnType<typeof userResourceAccessControllerGetMyWebappRoutesAccess>>, TError = ErrorType<unknown>>(
 params?: UserResourceAccessControllerGetMyWebappRoutesAccessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetMyWebappRoutesAccess>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserResourceAccessControllerGetMyWebappRoutesAccess<TData = Awaited<ReturnType<typeof userResourceAccessControllerGetMyWebappRoutesAccess>>, TError = ErrorType<unknown>>(
 params?: UserResourceAccessControllerGetMyWebappRoutesAccessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetMyWebappRoutesAccess>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserResourceAccessControllerGetMyWebappRoutesAccessQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useUserResourceAccessControllerGetMyWebappRoutesAccess} query
 */
export const invalidateUserResourceAccessControllerGetMyWebappRoutesAccess = async (
 queryClient: QueryClient, params?: UserResourceAccessControllerGetMyWebappRoutesAccessParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getUserResourceAccessControllerGetMyWebappRoutesAccessQueryKey(params) }, options);

  return queryClient;
}

export const useSetUserResourceAccessControllerGetMyWebappRoutesAccessQueryData = () => {
  const queryClient = useQueryClient();
  return (params: UserResourceAccessControllerGetMyWebappRoutesAccessParams | undefined,updater: Awaited<ReturnType<typeof userResourceAccessControllerGetMyWebappRoutesAccess>> | undefined | ((old: Awaited<ReturnType<typeof userResourceAccessControllerGetMyWebappRoutesAccess>> | undefined) => Awaited<ReturnType<typeof userResourceAccessControllerGetMyWebappRoutesAccess>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof userResourceAccessControllerGetMyWebappRoutesAccess>>>({ exact: $exactMatch, queryKey: getUserResourceAccessControllerGetMyWebappRoutesAccessQueryKey(params) }, updater);
  };
}

export const useGetUserResourceAccessControllerGetMyWebappRoutesAccessQueryData = () => {
  const queryClient = useQueryClient();
  return (params?: UserResourceAccessControllerGetMyWebappRoutesAccessParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof userResourceAccessControllerGetMyWebappRoutesAccess>>>(getUserResourceAccessControllerGetMyWebappRoutesAccessQueryKey(params));
}



export const userResourceAccessControllerGetUserAccessibleSchools = (
    userId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<School[]>(
      {url: `/user-resource-access/users/${userId}/schools`, method: 'GET', signal
    },
      options);
    }




export const getUserResourceAccessControllerGetUserAccessibleSchoolsQueryKey = (userId: string,) => {
    return [
    `/user-resource-access/users/${userId}/schools`
    ] as const;
    }


export const getUserResourceAccessControllerGetUserAccessibleSchoolsQueryOptions = <TData = Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleSchools>>, TError = ErrorType<unknown>>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleSchools>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserResourceAccessControllerGetUserAccessibleSchoolsQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleSchools>>> = ({ signal }) => userResourceAccessControllerGetUserAccessibleSchools(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleSchools>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserResourceAccessControllerGetUserAccessibleSchoolsQueryResult = NonNullable<Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleSchools>>>
export type UserResourceAccessControllerGetUserAccessibleSchoolsQueryError = ErrorType<unknown>


export function useUserResourceAccessControllerGetUserAccessibleSchools<TData = Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleSchools>>, TError = ErrorType<unknown>>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleSchools>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleSchools>>,
          TError,
          Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleSchools>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserResourceAccessControllerGetUserAccessibleSchools<TData = Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleSchools>>, TError = ErrorType<unknown>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleSchools>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleSchools>>,
          TError,
          Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleSchools>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserResourceAccessControllerGetUserAccessibleSchools<TData = Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleSchools>>, TError = ErrorType<unknown>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleSchools>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserResourceAccessControllerGetUserAccessibleSchools<TData = Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleSchools>>, TError = ErrorType<unknown>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleSchools>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserResourceAccessControllerGetUserAccessibleSchoolsQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useUserResourceAccessControllerGetUserAccessibleSchools} query
 */
export const invalidateUserResourceAccessControllerGetUserAccessibleSchools = async (
 queryClient: QueryClient, userId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getUserResourceAccessControllerGetUserAccessibleSchoolsQueryKey(userId) }, options);

  return queryClient;
}

export const useSetUserResourceAccessControllerGetUserAccessibleSchoolsQueryData = () => {
  const queryClient = useQueryClient();
  return (userId: string,updater: Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleSchools>> | undefined | ((old: Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleSchools>> | undefined) => Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleSchools>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleSchools>>>({ exact: $exactMatch, queryKey: getUserResourceAccessControllerGetUserAccessibleSchoolsQueryKey(userId) }, updater);
  };
}

export const useGetUserResourceAccessControllerGetUserAccessibleSchoolsQueryData = () => {
  const queryClient = useQueryClient();
  return (userId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleSchools>>>(getUserResourceAccessControllerGetUserAccessibleSchoolsQueryKey(userId));
}



export const userResourceAccessControllerGetUserAccessibleClassrooms = (
    userId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Classroom[]>(
      {url: `/user-resource-access/users/${userId}/classrooms`, method: 'GET', signal
    },
      options);
    }




export const getUserResourceAccessControllerGetUserAccessibleClassroomsQueryKey = (userId: string,) => {
    return [
    `/user-resource-access/users/${userId}/classrooms`
    ] as const;
    }


export const getUserResourceAccessControllerGetUserAccessibleClassroomsQueryOptions = <TData = Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleClassrooms>>, TError = ErrorType<unknown>>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleClassrooms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserResourceAccessControllerGetUserAccessibleClassroomsQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleClassrooms>>> = ({ signal }) => userResourceAccessControllerGetUserAccessibleClassrooms(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleClassrooms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserResourceAccessControllerGetUserAccessibleClassroomsQueryResult = NonNullable<Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleClassrooms>>>
export type UserResourceAccessControllerGetUserAccessibleClassroomsQueryError = ErrorType<unknown>


export function useUserResourceAccessControllerGetUserAccessibleClassrooms<TData = Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleClassrooms>>, TError = ErrorType<unknown>>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleClassrooms>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleClassrooms>>,
          TError,
          Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleClassrooms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserResourceAccessControllerGetUserAccessibleClassrooms<TData = Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleClassrooms>>, TError = ErrorType<unknown>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleClassrooms>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleClassrooms>>,
          TError,
          Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleClassrooms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserResourceAccessControllerGetUserAccessibleClassrooms<TData = Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleClassrooms>>, TError = ErrorType<unknown>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleClassrooms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserResourceAccessControllerGetUserAccessibleClassrooms<TData = Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleClassrooms>>, TError = ErrorType<unknown>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleClassrooms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserResourceAccessControllerGetUserAccessibleClassroomsQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useUserResourceAccessControllerGetUserAccessibleClassrooms} query
 */
export const invalidateUserResourceAccessControllerGetUserAccessibleClassrooms = async (
 queryClient: QueryClient, userId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getUserResourceAccessControllerGetUserAccessibleClassroomsQueryKey(userId) }, options);

  return queryClient;
}

export const useSetUserResourceAccessControllerGetUserAccessibleClassroomsQueryData = () => {
  const queryClient = useQueryClient();
  return (userId: string,updater: Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleClassrooms>> | undefined | ((old: Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleClassrooms>> | undefined) => Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleClassrooms>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleClassrooms>>>({ exact: $exactMatch, queryKey: getUserResourceAccessControllerGetUserAccessibleClassroomsQueryKey(userId) }, updater);
  };
}

export const useGetUserResourceAccessControllerGetUserAccessibleClassroomsQueryData = () => {
  const queryClient = useQueryClient();
  return (userId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof userResourceAccessControllerGetUserAccessibleClassrooms>>>(getUserResourceAccessControllerGetUserAccessibleClassroomsQueryKey(userId));
}



/**
 * @summary Admin create an UserClassroomAccess
I.E., grant a user access to a classroom with activation method `EDSY_ADMIN`
 */
export const userResourceAccessControllerAddUserToClassroom = (
    userClassroomAccessAddUserToClassroomDto: BodyType<UserClassroomAccessAddUserToClassroomDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/user-resource-access/classroom`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userClassroomAccessAddUserToClassroomDto, signal
    },
      options);
    }




export const getUserResourceAccessControllerAddUserToClassroomMutationKey = () => ['userResourceAccessControllerAddUserToClassroom'] as const;

export const getUserResourceAccessControllerAddUserToClassroomMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userResourceAccessControllerAddUserToClassroom>>, TError,UserResourceAccessControllerAddUserToClassroomMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userResourceAccessControllerAddUserToClassroom>>, TError,UserResourceAccessControllerAddUserToClassroomMutationVariables, TContext> => {

const mutationKey = getUserResourceAccessControllerAddUserToClassroomMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userResourceAccessControllerAddUserToClassroom>>, UserResourceAccessControllerAddUserToClassroomMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  userResourceAccessControllerAddUserToClassroom(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserResourceAccessControllerAddUserToClassroomMutationResult = NonNullable<Awaited<ReturnType<typeof userResourceAccessControllerAddUserToClassroom>>>
    export type UserResourceAccessControllerAddUserToClassroomMutationBody = BodyType<UserClassroomAccessAddUserToClassroomDto>
    export type UserResourceAccessControllerAddUserToClassroomMutationError = ErrorType<unknown>
    export type UserResourceAccessControllerAddUserToClassroomMutationVariables = {data: BodyType<UserClassroomAccessAddUserToClassroomDto>}

    /**
 * @summary Admin create an UserClassroomAccess
I.E., grant a user access to a classroom with activation method `EDSY_ADMIN`
 */
export const useUserResourceAccessControllerAddUserToClassroom = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userResourceAccessControllerAddUserToClassroom>>, TError,UserResourceAccessControllerAddUserToClassroomMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userResourceAccessControllerAddUserToClassroom>>,
        TError,
        UserResourceAccessControllerAddUserToClassroomMutationVariables,
        TContext
      > => {
      return useMutation(getUserResourceAccessControllerAddUserToClassroomMutationOptions(options), queryClient);
    }

/**
 * @summary Admin create an UserClassroomAccess
I.E., grant a user access to a classroom with activation method `EDSY_ADMIN`
 */
export const userResourceAccessControllerAddUsersToClassrooms = (
    userResourceAccessControllerAddUsersToClassroomsBody: BodyType<string[]>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/user-resource-access/classrooms`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userResourceAccessControllerAddUsersToClassroomsBody, signal
    },
      options);
    }




export const getUserResourceAccessControllerAddUsersToClassroomsMutationKey = () => ['userResourceAccessControllerAddUsersToClassrooms'] as const;

export const getUserResourceAccessControllerAddUsersToClassroomsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userResourceAccessControllerAddUsersToClassrooms>>, TError,UserResourceAccessControllerAddUsersToClassroomsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userResourceAccessControllerAddUsersToClassrooms>>, TError,UserResourceAccessControllerAddUsersToClassroomsMutationVariables, TContext> => {

const mutationKey = getUserResourceAccessControllerAddUsersToClassroomsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userResourceAccessControllerAddUsersToClassrooms>>, UserResourceAccessControllerAddUsersToClassroomsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  userResourceAccessControllerAddUsersToClassrooms(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserResourceAccessControllerAddUsersToClassroomsMutationResult = NonNullable<Awaited<ReturnType<typeof userResourceAccessControllerAddUsersToClassrooms>>>
    export type UserResourceAccessControllerAddUsersToClassroomsMutationBody = BodyType<string[]>
    export type UserResourceAccessControllerAddUsersToClassroomsMutationError = ErrorType<unknown>
    export type UserResourceAccessControllerAddUsersToClassroomsMutationVariables = {data: BodyType<string[]>}

    /**
 * @summary Admin create an UserClassroomAccess
I.E., grant a user access to a classroom with activation method `EDSY_ADMIN`
 */
export const useUserResourceAccessControllerAddUsersToClassrooms = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userResourceAccessControllerAddUsersToClassrooms>>, TError,UserResourceAccessControllerAddUsersToClassroomsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userResourceAccessControllerAddUsersToClassrooms>>,
        TError,
        UserResourceAccessControllerAddUsersToClassroomsMutationVariables,
        TContext
      > => {
      return useMutation(getUserResourceAccessControllerAddUsersToClassroomsMutationOptions(options), queryClient);
    }

export const userResourceAccessControllerRemoveUserFromClassroom = (
    classroomId: string,
    userId: string,
    params: UserResourceAccessControllerRemoveUserFromClassroomParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/user-resource-access/classrooms/${classroomId}/users/${userId}`, method: 'DELETE',
        params, signal
    },
      options);
    }




export const getUserResourceAccessControllerRemoveUserFromClassroomMutationKey = () => ['userResourceAccessControllerRemoveUserFromClassroom'] as const;

export const getUserResourceAccessControllerRemoveUserFromClassroomMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userResourceAccessControllerRemoveUserFromClassroom>>, TError,UserResourceAccessControllerRemoveUserFromClassroomMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userResourceAccessControllerRemoveUserFromClassroom>>, TError,UserResourceAccessControllerRemoveUserFromClassroomMutationVariables, TContext> => {

const mutationKey = getUserResourceAccessControllerRemoveUserFromClassroomMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userResourceAccessControllerRemoveUserFromClassroom>>, UserResourceAccessControllerRemoveUserFromClassroomMutationVariables> = (props) => {
          const {classroomId,userId,params} = props ?? {};

          return  userResourceAccessControllerRemoveUserFromClassroom(classroomId,userId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserResourceAccessControllerRemoveUserFromClassroomMutationResult = NonNullable<Awaited<ReturnType<typeof userResourceAccessControllerRemoveUserFromClassroom>>>

    export type UserResourceAccessControllerRemoveUserFromClassroomMutationError = ErrorType<unknown>
    export type UserResourceAccessControllerRemoveUserFromClassroomMutationVariables = {classroomId: string;userId: string;params: UserResourceAccessControllerRemoveUserFromClassroomParams}

    export const useUserResourceAccessControllerRemoveUserFromClassroom = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userResourceAccessControllerRemoveUserFromClassroom>>, TError,UserResourceAccessControllerRemoveUserFromClassroomMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userResourceAccessControllerRemoveUserFromClassroom>>,
        TError,
        UserResourceAccessControllerRemoveUserFromClassroomMutationVariables,
        TContext
      > => {
      return useMutation(getUserResourceAccessControllerRemoveUserFromClassroomMutationOptions(options), queryClient);
    }

export const classroomActivationCodeControllerCreate = (
    createClassroomActivationCodeDto: BodyType<CreateClassroomActivationCodeDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ClassroomActivationCode>(
      {url: `/classroom-activation-codes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createClassroomActivationCodeDto, signal
    },
      options);
    }




export const getClassroomActivationCodeControllerCreateMutationKey = () => ['classroomActivationCodeControllerCreate'] as const;

export const getClassroomActivationCodeControllerCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomActivationCodeControllerCreate>>, TError,ClassroomActivationCodeControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof classroomActivationCodeControllerCreate>>, TError,ClassroomActivationCodeControllerCreateMutationVariables, TContext> => {

const mutationKey = getClassroomActivationCodeControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof classroomActivationCodeControllerCreate>>, ClassroomActivationCodeControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  classroomActivationCodeControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClassroomActivationCodeControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof classroomActivationCodeControllerCreate>>>
    export type ClassroomActivationCodeControllerCreateMutationBody = BodyType<CreateClassroomActivationCodeDto>
    export type ClassroomActivationCodeControllerCreateMutationError = ErrorType<unknown>
    export type ClassroomActivationCodeControllerCreateMutationVariables = {data: BodyType<CreateClassroomActivationCodeDto>}

    export const useClassroomActivationCodeControllerCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomActivationCodeControllerCreate>>, TError,ClassroomActivationCodeControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof classroomActivationCodeControllerCreate>>,
        TError,
        ClassroomActivationCodeControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getClassroomActivationCodeControllerCreateMutationOptions(options), queryClient);
    }

export const classroomActivationCodeControllerGetByCode = (
    code: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ClassroomActivationCodeControllerGetByCode201>(
      {url: `/classroom-activation-codes/validate/${code}`, method: 'POST', signal
    },
      options);
    }




export const getClassroomActivationCodeControllerGetByCodeMutationKey = () => ['classroomActivationCodeControllerGetByCode'] as const;

export const getClassroomActivationCodeControllerGetByCodeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomActivationCodeControllerGetByCode>>, TError,ClassroomActivationCodeControllerGetByCodeMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof classroomActivationCodeControllerGetByCode>>, TError,ClassroomActivationCodeControllerGetByCodeMutationVariables, TContext> => {

const mutationKey = getClassroomActivationCodeControllerGetByCodeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof classroomActivationCodeControllerGetByCode>>, ClassroomActivationCodeControllerGetByCodeMutationVariables> = (props) => {
          const {code} = props ?? {};

          return  classroomActivationCodeControllerGetByCode(code,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClassroomActivationCodeControllerGetByCodeMutationResult = NonNullable<Awaited<ReturnType<typeof classroomActivationCodeControllerGetByCode>>>

    export type ClassroomActivationCodeControllerGetByCodeMutationError = ErrorType<unknown>
    export type ClassroomActivationCodeControllerGetByCodeMutationVariables = {code: string}

    export const useClassroomActivationCodeControllerGetByCode = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomActivationCodeControllerGetByCode>>, TError,ClassroomActivationCodeControllerGetByCodeMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof classroomActivationCodeControllerGetByCode>>,
        TError,
        ClassroomActivationCodeControllerGetByCodeMutationVariables,
        TContext
      > => {
      return useMutation(getClassroomActivationCodeControllerGetByCodeMutationOptions(options), queryClient);
    }

export const classroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId = (
    params: ClassroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomIdParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserClassroomAccess[]>(
      {url: `/classroom-activation-codes/current-usage-activation-code`, method: 'GET',
        params, signal
    },
      options);
    }




export const getClassroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomIdQueryKey = (params?: ClassroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomIdParams,) => {
    return [
    `/classroom-activation-codes/current-usage-activation-code`, ...(params ? [params] : [])
    ] as const;
    }


export const getClassroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomIdQueryOptions = <TData = Awaited<ReturnType<typeof classroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId>>, TError = ErrorType<unknown>>(params: ClassroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomIdQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId>>> = ({ signal }) => classroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomIdQueryResult = NonNullable<Awaited<ReturnType<typeof classroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId>>>
export type ClassroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomIdQueryError = ErrorType<unknown>


export function useClassroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId<TData = Awaited<ReturnType<typeof classroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId>>, TError = ErrorType<unknown>>(
 params: ClassroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId>>,
          TError,
          Awaited<ReturnType<typeof classroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId<TData = Awaited<ReturnType<typeof classroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId>>, TError = ErrorType<unknown>>(
 params: ClassroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId>>,
          TError,
          Awaited<ReturnType<typeof classroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId<TData = Awaited<ReturnType<typeof classroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId>>, TError = ErrorType<unknown>>(
 params: ClassroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId<TData = Awaited<ReturnType<typeof classroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId>>, TError = ErrorType<unknown>>(
 params: ClassroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomIdQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId} query
 */
export const invalidateClassroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId = async (
 queryClient: QueryClient, params: ClassroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomIdParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomIdQueryKey(params) }, options);

  return queryClient;
}

export const useSetClassroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomIdQueryData = () => {
  const queryClient = useQueryClient();
  return (params: ClassroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomIdParams | undefined,updater: Awaited<ReturnType<typeof classroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId>> | undefined | ((old: Awaited<ReturnType<typeof classroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId>> | undefined) => Awaited<ReturnType<typeof classroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId>>>({ exact: $exactMatch, queryKey: getClassroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomIdQueryKey(params) }, updater);
  };
}

export const useGetClassroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomIdQueryData = () => {
  const queryClient = useQueryClient();
  return (params: ClassroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomIdParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomId>>>(getClassroomActivationCodeControllerGetCurrentUsageActivationCodeByClassroomIdQueryKey(params));
}



export const classroomActivationCodeControllerGetById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ClassroomActivationCode>(
      {url: `/classroom-activation-codes/${id}`, method: 'GET', signal
    },
      options);
    }




export const getClassroomActivationCodeControllerGetByIdQueryKey = (id: string,) => {
    return [
    `/classroom-activation-codes/${id}`
    ] as const;
    }


export const getClassroomActivationCodeControllerGetByIdQueryOptions = <TData = Awaited<ReturnType<typeof classroomActivationCodeControllerGetById>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomActivationCodeControllerGetById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomActivationCodeControllerGetByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomActivationCodeControllerGetById>>> = ({ signal }) => classroomActivationCodeControllerGetById(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomActivationCodeControllerGetById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomActivationCodeControllerGetByIdQueryResult = NonNullable<Awaited<ReturnType<typeof classroomActivationCodeControllerGetById>>>
export type ClassroomActivationCodeControllerGetByIdQueryError = ErrorType<unknown>


export function useClassroomActivationCodeControllerGetById<TData = Awaited<ReturnType<typeof classroomActivationCodeControllerGetById>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomActivationCodeControllerGetById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomActivationCodeControllerGetById>>,
          TError,
          Awaited<ReturnType<typeof classroomActivationCodeControllerGetById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomActivationCodeControllerGetById<TData = Awaited<ReturnType<typeof classroomActivationCodeControllerGetById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomActivationCodeControllerGetById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomActivationCodeControllerGetById>>,
          TError,
          Awaited<ReturnType<typeof classroomActivationCodeControllerGetById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomActivationCodeControllerGetById<TData = Awaited<ReturnType<typeof classroomActivationCodeControllerGetById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomActivationCodeControllerGetById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomActivationCodeControllerGetById<TData = Awaited<ReturnType<typeof classroomActivationCodeControllerGetById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomActivationCodeControllerGetById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomActivationCodeControllerGetByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomActivationCodeControllerGetById} query
 */
export const invalidateClassroomActivationCodeControllerGetById = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomActivationCodeControllerGetByIdQueryKey(id) }, options);

  return queryClient;
}

export const useSetClassroomActivationCodeControllerGetByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof classroomActivationCodeControllerGetById>> | undefined | ((old: Awaited<ReturnType<typeof classroomActivationCodeControllerGetById>> | undefined) => Awaited<ReturnType<typeof classroomActivationCodeControllerGetById>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomActivationCodeControllerGetById>>>({ exact: $exactMatch, queryKey: getClassroomActivationCodeControllerGetByIdQueryKey(id) }, updater);
  };
}

export const useGetClassroomActivationCodeControllerGetByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomActivationCodeControllerGetById>>>(getClassroomActivationCodeControllerGetByIdQueryKey(id));
}



export const classroomActivationCodeControllerUpdate = (
    id: string,
    createClassroomActivationCodeDto: BodyType<CreateClassroomActivationCodeDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ClassroomActivationCode>(
      {url: `/classroom-activation-codes/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: createClassroomActivationCodeDto, signal
    },
      options);
    }




export const getClassroomActivationCodeControllerUpdateMutationKey = () => ['classroomActivationCodeControllerUpdate'] as const;

export const getClassroomActivationCodeControllerUpdateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomActivationCodeControllerUpdate>>, TError,ClassroomActivationCodeControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof classroomActivationCodeControllerUpdate>>, TError,ClassroomActivationCodeControllerUpdateMutationVariables, TContext> => {

const mutationKey = getClassroomActivationCodeControllerUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof classroomActivationCodeControllerUpdate>>, ClassroomActivationCodeControllerUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  classroomActivationCodeControllerUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClassroomActivationCodeControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof classroomActivationCodeControllerUpdate>>>
    export type ClassroomActivationCodeControllerUpdateMutationBody = BodyType<CreateClassroomActivationCodeDto>
    export type ClassroomActivationCodeControllerUpdateMutationError = ErrorType<unknown>
    export type ClassroomActivationCodeControllerUpdateMutationVariables = {id: string;data: BodyType<CreateClassroomActivationCodeDto>}

    export const useClassroomActivationCodeControllerUpdate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomActivationCodeControllerUpdate>>, TError,ClassroomActivationCodeControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof classroomActivationCodeControllerUpdate>>,
        TError,
        ClassroomActivationCodeControllerUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getClassroomActivationCodeControllerUpdateMutationOptions(options), queryClient);
    }

export const classroomActivationCodeControllerSignupWithClassroomActivationCode = (
    signupWithClassroomActivationCodeDto: BodyType<SignupWithClassroomActivationCodeDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<User>(
      {url: `/classroom-activation-codes/signup-with-classroom-activation-code`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: signupWithClassroomActivationCodeDto, signal
    },
      options);
    }




export const getClassroomActivationCodeControllerSignupWithClassroomActivationCodeMutationKey = () => ['classroomActivationCodeControllerSignupWithClassroomActivationCode'] as const;

export const getClassroomActivationCodeControllerSignupWithClassroomActivationCodeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomActivationCodeControllerSignupWithClassroomActivationCode>>, TError,ClassroomActivationCodeControllerSignupWithClassroomActivationCodeMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof classroomActivationCodeControllerSignupWithClassroomActivationCode>>, TError,ClassroomActivationCodeControllerSignupWithClassroomActivationCodeMutationVariables, TContext> => {

const mutationKey = getClassroomActivationCodeControllerSignupWithClassroomActivationCodeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof classroomActivationCodeControllerSignupWithClassroomActivationCode>>, ClassroomActivationCodeControllerSignupWithClassroomActivationCodeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  classroomActivationCodeControllerSignupWithClassroomActivationCode(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClassroomActivationCodeControllerSignupWithClassroomActivationCodeMutationResult = NonNullable<Awaited<ReturnType<typeof classroomActivationCodeControllerSignupWithClassroomActivationCode>>>
    export type ClassroomActivationCodeControllerSignupWithClassroomActivationCodeMutationBody = BodyType<SignupWithClassroomActivationCodeDto>
    export type ClassroomActivationCodeControllerSignupWithClassroomActivationCodeMutationError = ErrorType<unknown>
    export type ClassroomActivationCodeControllerSignupWithClassroomActivationCodeMutationVariables = {data: BodyType<SignupWithClassroomActivationCodeDto>}

    export const useClassroomActivationCodeControllerSignupWithClassroomActivationCode = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classroomActivationCodeControllerSignupWithClassroomActivationCode>>, TError,ClassroomActivationCodeControllerSignupWithClassroomActivationCodeMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof classroomActivationCodeControllerSignupWithClassroomActivationCode>>,
        TError,
        ClassroomActivationCodeControllerSignupWithClassroomActivationCodeMutationVariables,
        TContext
      > => {
      return useMutation(getClassroomActivationCodeControllerSignupWithClassroomActivationCodeMutationOptions(options), queryClient);
    }

export const classroomStateControllerGetUserAllClassroomStates = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/classroom-states/me`, method: 'GET', signal
    },
      options);
    }




export const getClassroomStateControllerGetUserAllClassroomStatesQueryKey = () => {
    return [
    `/classroom-states/me`
    ] as const;
    }


export const getClassroomStateControllerGetUserAllClassroomStatesQueryOptions = <TData = Awaited<ReturnType<typeof classroomStateControllerGetUserAllClassroomStates>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomStateControllerGetUserAllClassroomStates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClassroomStateControllerGetUserAllClassroomStatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof classroomStateControllerGetUserAllClassroomStates>>> = ({ signal }) => classroomStateControllerGetUserAllClassroomStates(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof classroomStateControllerGetUserAllClassroomStates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClassroomStateControllerGetUserAllClassroomStatesQueryResult = NonNullable<Awaited<ReturnType<typeof classroomStateControllerGetUserAllClassroomStates>>>
export type ClassroomStateControllerGetUserAllClassroomStatesQueryError = ErrorType<unknown>


export function useClassroomStateControllerGetUserAllClassroomStates<TData = Awaited<ReturnType<typeof classroomStateControllerGetUserAllClassroomStates>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomStateControllerGetUserAllClassroomStates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomStateControllerGetUserAllClassroomStates>>,
          TError,
          Awaited<ReturnType<typeof classroomStateControllerGetUserAllClassroomStates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomStateControllerGetUserAllClassroomStates<TData = Awaited<ReturnType<typeof classroomStateControllerGetUserAllClassroomStates>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomStateControllerGetUserAllClassroomStates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof classroomStateControllerGetUserAllClassroomStates>>,
          TError,
          Awaited<ReturnType<typeof classroomStateControllerGetUserAllClassroomStates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClassroomStateControllerGetUserAllClassroomStates<TData = Awaited<ReturnType<typeof classroomStateControllerGetUserAllClassroomStates>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomStateControllerGetUserAllClassroomStates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClassroomStateControllerGetUserAllClassroomStates<TData = Awaited<ReturnType<typeof classroomStateControllerGetUserAllClassroomStates>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof classroomStateControllerGetUserAllClassroomStates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClassroomStateControllerGetUserAllClassroomStatesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useClassroomStateControllerGetUserAllClassroomStates} query
 */
export const invalidateClassroomStateControllerGetUserAllClassroomStates = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getClassroomStateControllerGetUserAllClassroomStatesQueryKey() }, options);

  return queryClient;
}

export const useSetClassroomStateControllerGetUserAllClassroomStatesQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof classroomStateControllerGetUserAllClassroomStates>> | undefined | ((old: Awaited<ReturnType<typeof classroomStateControllerGetUserAllClassroomStates>> | undefined) => Awaited<ReturnType<typeof classroomStateControllerGetUserAllClassroomStates>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof classroomStateControllerGetUserAllClassroomStates>>>({ exact: $exactMatch, queryKey: getClassroomStateControllerGetUserAllClassroomStatesQueryKey() }, updater);
  };
}

export const useGetClassroomStateControllerGetUserAllClassroomStatesQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof classroomStateControllerGetUserAllClassroomStates>>>(getClassroomStateControllerGetUserAllClassroomStatesQueryKey());
}



/**
 * @summary Get current task and transaction of the activity instance.
This is the main endpoint to get the task in the session.
 */
export const activitySessionControllerGetCurrentTaskAndTaskTransaction = (
    activityInstanceId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/activity-sessions/${activityInstanceId}/current-task-and-task-transaction`, method: 'GET', signal
    },
      options);
    }




export const getActivitySessionControllerGetCurrentTaskAndTaskTransactionQueryKey = (activityInstanceId: string,) => {
    return [
    `/activity-sessions/${activityInstanceId}/current-task-and-task-transaction`
    ] as const;
    }


export const getActivitySessionControllerGetCurrentTaskAndTaskTransactionQueryOptions = <TData = Awaited<ReturnType<typeof activitySessionControllerGetCurrentTaskAndTaskTransaction>>, TError = ErrorType<unknown>>(activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitySessionControllerGetCurrentTaskAndTaskTransaction>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivitySessionControllerGetCurrentTaskAndTaskTransactionQueryKey(activityInstanceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activitySessionControllerGetCurrentTaskAndTaskTransaction>>> = ({ signal }) => activitySessionControllerGetCurrentTaskAndTaskTransaction(activityInstanceId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: activityInstanceId !== null && activityInstanceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activitySessionControllerGetCurrentTaskAndTaskTransaction>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivitySessionControllerGetCurrentTaskAndTaskTransactionQueryResult = NonNullable<Awaited<ReturnType<typeof activitySessionControllerGetCurrentTaskAndTaskTransaction>>>
export type ActivitySessionControllerGetCurrentTaskAndTaskTransactionQueryError = ErrorType<unknown>


export function useActivitySessionControllerGetCurrentTaskAndTaskTransaction<TData = Awaited<ReturnType<typeof activitySessionControllerGetCurrentTaskAndTaskTransaction>>, TError = ErrorType<unknown>>(
 activityInstanceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitySessionControllerGetCurrentTaskAndTaskTransaction>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activitySessionControllerGetCurrentTaskAndTaskTransaction>>,
          TError,
          Awaited<ReturnType<typeof activitySessionControllerGetCurrentTaskAndTaskTransaction>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivitySessionControllerGetCurrentTaskAndTaskTransaction<TData = Awaited<ReturnType<typeof activitySessionControllerGetCurrentTaskAndTaskTransaction>>, TError = ErrorType<unknown>>(
 activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitySessionControllerGetCurrentTaskAndTaskTransaction>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activitySessionControllerGetCurrentTaskAndTaskTransaction>>,
          TError,
          Awaited<ReturnType<typeof activitySessionControllerGetCurrentTaskAndTaskTransaction>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivitySessionControllerGetCurrentTaskAndTaskTransaction<TData = Awaited<ReturnType<typeof activitySessionControllerGetCurrentTaskAndTaskTransaction>>, TError = ErrorType<unknown>>(
 activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitySessionControllerGetCurrentTaskAndTaskTransaction>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current task and transaction of the activity instance.
This is the main endpoint to get the task in the session.
 */

export function useActivitySessionControllerGetCurrentTaskAndTaskTransaction<TData = Awaited<ReturnType<typeof activitySessionControllerGetCurrentTaskAndTaskTransaction>>, TError = ErrorType<unknown>>(
 activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitySessionControllerGetCurrentTaskAndTaskTransaction>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivitySessionControllerGetCurrentTaskAndTaskTransactionQueryOptions(activityInstanceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivitySessionControllerGetCurrentTaskAndTaskTransaction} query
 */
export const invalidateActivitySessionControllerGetCurrentTaskAndTaskTransaction = async (
 queryClient: QueryClient, activityInstanceId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivitySessionControllerGetCurrentTaskAndTaskTransactionQueryKey(activityInstanceId) }, options);

  return queryClient;
}

/**
 * @summary Get current task and transaction of the activity instance.
This is the main endpoint to get the task in the session.
 */
export const useSetActivitySessionControllerGetCurrentTaskAndTaskTransactionQueryData = () => {
  const queryClient = useQueryClient();
  return (activityInstanceId: string,updater: Awaited<ReturnType<typeof activitySessionControllerGetCurrentTaskAndTaskTransaction>> | undefined | ((old: Awaited<ReturnType<typeof activitySessionControllerGetCurrentTaskAndTaskTransaction>> | undefined) => Awaited<ReturnType<typeof activitySessionControllerGetCurrentTaskAndTaskTransaction>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activitySessionControllerGetCurrentTaskAndTaskTransaction>>>({ exact: $exactMatch, queryKey: getActivitySessionControllerGetCurrentTaskAndTaskTransactionQueryKey(activityInstanceId) }, updater);
  };
}

/**
 * @summary Get current task and transaction of the activity instance.
This is the main endpoint to get the task in the session.
 */
export const useGetActivitySessionControllerGetCurrentTaskAndTaskTransactionQueryData = () => {
  const queryClient = useQueryClient();
  return (activityInstanceId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activitySessionControllerGetCurrentTaskAndTaskTransaction>>>(getActivitySessionControllerGetCurrentTaskAndTaskTransactionQueryKey(activityInstanceId));
}



export const activitySessionControllerGetAllTasksAndTaskTransactions = (
    activityInstanceId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/activity-sessions/${activityInstanceId}/all-tasks-and-task-transactions`, method: 'GET', signal
    },
      options);
    }




export const getActivitySessionControllerGetAllTasksAndTaskTransactionsQueryKey = (activityInstanceId: string,) => {
    return [
    `/activity-sessions/${activityInstanceId}/all-tasks-and-task-transactions`
    ] as const;
    }


export const getActivitySessionControllerGetAllTasksAndTaskTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof activitySessionControllerGetAllTasksAndTaskTransactions>>, TError = ErrorType<unknown>>(activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitySessionControllerGetAllTasksAndTaskTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivitySessionControllerGetAllTasksAndTaskTransactionsQueryKey(activityInstanceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activitySessionControllerGetAllTasksAndTaskTransactions>>> = ({ signal }) => activitySessionControllerGetAllTasksAndTaskTransactions(activityInstanceId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: activityInstanceId !== null && activityInstanceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activitySessionControllerGetAllTasksAndTaskTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivitySessionControllerGetAllTasksAndTaskTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof activitySessionControllerGetAllTasksAndTaskTransactions>>>
export type ActivitySessionControllerGetAllTasksAndTaskTransactionsQueryError = ErrorType<unknown>


export function useActivitySessionControllerGetAllTasksAndTaskTransactions<TData = Awaited<ReturnType<typeof activitySessionControllerGetAllTasksAndTaskTransactions>>, TError = ErrorType<unknown>>(
 activityInstanceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitySessionControllerGetAllTasksAndTaskTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activitySessionControllerGetAllTasksAndTaskTransactions>>,
          TError,
          Awaited<ReturnType<typeof activitySessionControllerGetAllTasksAndTaskTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivitySessionControllerGetAllTasksAndTaskTransactions<TData = Awaited<ReturnType<typeof activitySessionControllerGetAllTasksAndTaskTransactions>>, TError = ErrorType<unknown>>(
 activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitySessionControllerGetAllTasksAndTaskTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activitySessionControllerGetAllTasksAndTaskTransactions>>,
          TError,
          Awaited<ReturnType<typeof activitySessionControllerGetAllTasksAndTaskTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivitySessionControllerGetAllTasksAndTaskTransactions<TData = Awaited<ReturnType<typeof activitySessionControllerGetAllTasksAndTaskTransactions>>, TError = ErrorType<unknown>>(
 activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitySessionControllerGetAllTasksAndTaskTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivitySessionControllerGetAllTasksAndTaskTransactions<TData = Awaited<ReturnType<typeof activitySessionControllerGetAllTasksAndTaskTransactions>>, TError = ErrorType<unknown>>(
 activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitySessionControllerGetAllTasksAndTaskTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivitySessionControllerGetAllTasksAndTaskTransactionsQueryOptions(activityInstanceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivitySessionControllerGetAllTasksAndTaskTransactions} query
 */
export const invalidateActivitySessionControllerGetAllTasksAndTaskTransactions = async (
 queryClient: QueryClient, activityInstanceId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivitySessionControllerGetAllTasksAndTaskTransactionsQueryKey(activityInstanceId) }, options);

  return queryClient;
}

export const useSetActivitySessionControllerGetAllTasksAndTaskTransactionsQueryData = () => {
  const queryClient = useQueryClient();
  return (activityInstanceId: string,updater: Awaited<ReturnType<typeof activitySessionControllerGetAllTasksAndTaskTransactions>> | undefined | ((old: Awaited<ReturnType<typeof activitySessionControllerGetAllTasksAndTaskTransactions>> | undefined) => Awaited<ReturnType<typeof activitySessionControllerGetAllTasksAndTaskTransactions>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activitySessionControllerGetAllTasksAndTaskTransactions>>>({ exact: $exactMatch, queryKey: getActivitySessionControllerGetAllTasksAndTaskTransactionsQueryKey(activityInstanceId) }, updater);
  };
}

export const useGetActivitySessionControllerGetAllTasksAndTaskTransactionsQueryData = () => {
  const queryClient = useQueryClient();
  return (activityInstanceId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activitySessionControllerGetAllTasksAndTaskTransactions>>>(getActivitySessionControllerGetAllTasksAndTaskTransactionsQueryKey(activityInstanceId));
}



export const activitySessionControllerSubmitTaskWithAudio = (
    activityInstanceId: string,
    taskId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ActivitySessionControllerSubmitTaskWithAudio201>(
      {url: `/activity-sessions/${activityInstanceId}/tasks/${taskId}/submit-audio`, method: 'POST', signal
    },
      options);
    }




export const getActivitySessionControllerSubmitTaskWithAudioMutationKey = () => ['activitySessionControllerSubmitTaskWithAudio'] as const;

export const getActivitySessionControllerSubmitTaskWithAudioMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitySessionControllerSubmitTaskWithAudio>>, TError,ActivitySessionControllerSubmitTaskWithAudioMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activitySessionControllerSubmitTaskWithAudio>>, TError,ActivitySessionControllerSubmitTaskWithAudioMutationVariables, TContext> => {

const mutationKey = getActivitySessionControllerSubmitTaskWithAudioMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activitySessionControllerSubmitTaskWithAudio>>, ActivitySessionControllerSubmitTaskWithAudioMutationVariables> = (props) => {
          const {activityInstanceId,taskId} = props ?? {};

          return  activitySessionControllerSubmitTaskWithAudio(activityInstanceId,taskId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivitySessionControllerSubmitTaskWithAudioMutationResult = NonNullable<Awaited<ReturnType<typeof activitySessionControllerSubmitTaskWithAudio>>>

    export type ActivitySessionControllerSubmitTaskWithAudioMutationError = ErrorType<unknown>
    export type ActivitySessionControllerSubmitTaskWithAudioMutationVariables = {activityInstanceId: string;taskId: string}

    export const useActivitySessionControllerSubmitTaskWithAudio = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitySessionControllerSubmitTaskWithAudio>>, TError,ActivitySessionControllerSubmitTaskWithAudioMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activitySessionControllerSubmitTaskWithAudio>>,
        TError,
        ActivitySessionControllerSubmitTaskWithAudioMutationVariables,
        TContext
      > => {
      return useMutation(getActivitySessionControllerSubmitTaskWithAudioMutationOptions(options), queryClient);
    }

/**
 * @summary An endpoint responsible for submitting tasks that do not required an audio file.
BaseSubmitTaskDto is basically an empty class. We should validate dto types in each session type.
 */
export const activitySessionControllerSubmitTask = (
    activityInstanceId: string,
    taskId: string,
    baseSubmitTaskDto: BodyType<BaseSubmitTaskDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ActivitySessionControllerSubmitTask201>(
      {url: `/activity-sessions/${activityInstanceId}/tasks/${taskId}/submit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: baseSubmitTaskDto, signal
    },
      options);
    }




export const getActivitySessionControllerSubmitTaskMutationKey = () => ['activitySessionControllerSubmitTask'] as const;

export const getActivitySessionControllerSubmitTaskMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitySessionControllerSubmitTask>>, TError,ActivitySessionControllerSubmitTaskMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activitySessionControllerSubmitTask>>, TError,ActivitySessionControllerSubmitTaskMutationVariables, TContext> => {

const mutationKey = getActivitySessionControllerSubmitTaskMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activitySessionControllerSubmitTask>>, ActivitySessionControllerSubmitTaskMutationVariables> = (props) => {
          const {activityInstanceId,taskId,data} = props ?? {};

          return  activitySessionControllerSubmitTask(activityInstanceId,taskId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivitySessionControllerSubmitTaskMutationResult = NonNullable<Awaited<ReturnType<typeof activitySessionControllerSubmitTask>>>
    export type ActivitySessionControllerSubmitTaskMutationBody = BodyType<BaseSubmitTaskDto>
    export type ActivitySessionControllerSubmitTaskMutationError = ErrorType<unknown>
    export type ActivitySessionControllerSubmitTaskMutationVariables = {activityInstanceId: string;taskId: string;data: BodyType<BaseSubmitTaskDto>}

    /**
 * @summary An endpoint responsible for submitting tasks that do not required an audio file.
BaseSubmitTaskDto is basically an empty class. We should validate dto types in each session type.
 */
export const useActivitySessionControllerSubmitTask = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitySessionControllerSubmitTask>>, TError,ActivitySessionControllerSubmitTaskMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activitySessionControllerSubmitTask>>,
        TError,
        ActivitySessionControllerSubmitTaskMutationVariables,
        TContext
      > => {
      return useMutation(getActivitySessionControllerSubmitTaskMutationOptions(options), queryClient);
    }

/**
 * @summary An endpoint responsible for completing taskTransaction.
BaseCompleteTaskTransactionDto is basically an empty class. We should validate dto types in each session type.
 */
export const activitySessionControllerCompleteTaskTransaction = (
    activityInstanceId: string,
    taskTransactionId: string,
    baseCompleteTaskTransactionDto: BodyType<BaseCompleteTaskTransactionDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/activity-sessions/${activityInstanceId}/task-transactions/${taskTransactionId}/complete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: baseCompleteTaskTransactionDto, signal
    },
      options);
    }




export const getActivitySessionControllerCompleteTaskTransactionMutationKey = () => ['activitySessionControllerCompleteTaskTransaction'] as const;

export const getActivitySessionControllerCompleteTaskTransactionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitySessionControllerCompleteTaskTransaction>>, TError,ActivitySessionControllerCompleteTaskTransactionMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activitySessionControllerCompleteTaskTransaction>>, TError,ActivitySessionControllerCompleteTaskTransactionMutationVariables, TContext> => {

const mutationKey = getActivitySessionControllerCompleteTaskTransactionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activitySessionControllerCompleteTaskTransaction>>, ActivitySessionControllerCompleteTaskTransactionMutationVariables> = (props) => {
          const {activityInstanceId,taskTransactionId,data} = props ?? {};

          return  activitySessionControllerCompleteTaskTransaction(activityInstanceId,taskTransactionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivitySessionControllerCompleteTaskTransactionMutationResult = NonNullable<Awaited<ReturnType<typeof activitySessionControllerCompleteTaskTransaction>>>
    export type ActivitySessionControllerCompleteTaskTransactionMutationBody = BodyType<BaseCompleteTaskTransactionDto>
    export type ActivitySessionControllerCompleteTaskTransactionMutationError = ErrorType<unknown>
    export type ActivitySessionControllerCompleteTaskTransactionMutationVariables = {activityInstanceId: string;taskTransactionId: string;data: BodyType<BaseCompleteTaskTransactionDto>}

    /**
 * @summary An endpoint responsible for completing taskTransaction.
BaseCompleteTaskTransactionDto is basically an empty class. We should validate dto types in each session type.
 */
export const useActivitySessionControllerCompleteTaskTransaction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitySessionControllerCompleteTaskTransaction>>, TError,ActivitySessionControllerCompleteTaskTransactionMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activitySessionControllerCompleteTaskTransaction>>,
        TError,
        ActivitySessionControllerCompleteTaskTransactionMutationVariables,
        TContext
      > => {
      return useMutation(getActivitySessionControllerCompleteTaskTransactionMutationOptions(options), queryClient);
    }

/**
 * @summary An endpoint responsible for completing taskTransaction.
BaseCompleteTaskTransactionDto is basically an empty class. We should validate dto types in each session type.
 */
export const activitySessionControllerCompleteAndGetNextTask = (
    activityInstanceId: string,
    taskTransactionId: string,
    baseCompleteTaskTransactionDto: BodyType<BaseCompleteTaskTransactionDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/activity-sessions/${activityInstanceId}/task-transactions/${taskTransactionId}/complete-and-get-next-task`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: baseCompleteTaskTransactionDto, signal
    },
      options);
    }




export const getActivitySessionControllerCompleteAndGetNextTaskMutationKey = () => ['activitySessionControllerCompleteAndGetNextTask'] as const;

export const getActivitySessionControllerCompleteAndGetNextTaskMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitySessionControllerCompleteAndGetNextTask>>, TError,ActivitySessionControllerCompleteAndGetNextTaskMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activitySessionControllerCompleteAndGetNextTask>>, TError,ActivitySessionControllerCompleteAndGetNextTaskMutationVariables, TContext> => {

const mutationKey = getActivitySessionControllerCompleteAndGetNextTaskMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activitySessionControllerCompleteAndGetNextTask>>, ActivitySessionControllerCompleteAndGetNextTaskMutationVariables> = (props) => {
          const {activityInstanceId,taskTransactionId,data} = props ?? {};

          return  activitySessionControllerCompleteAndGetNextTask(activityInstanceId,taskTransactionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivitySessionControllerCompleteAndGetNextTaskMutationResult = NonNullable<Awaited<ReturnType<typeof activitySessionControllerCompleteAndGetNextTask>>>
    export type ActivitySessionControllerCompleteAndGetNextTaskMutationBody = BodyType<BaseCompleteTaskTransactionDto>
    export type ActivitySessionControllerCompleteAndGetNextTaskMutationError = ErrorType<unknown>
    export type ActivitySessionControllerCompleteAndGetNextTaskMutationVariables = {activityInstanceId: string;taskTransactionId: string;data: BodyType<BaseCompleteTaskTransactionDto>}

    /**
 * @summary An endpoint responsible for completing taskTransaction.
BaseCompleteTaskTransactionDto is basically an empty class. We should validate dto types in each session type.
 */
export const useActivitySessionControllerCompleteAndGetNextTask = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitySessionControllerCompleteAndGetNextTask>>, TError,ActivitySessionControllerCompleteAndGetNextTaskMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activitySessionControllerCompleteAndGetNextTask>>,
        TError,
        ActivitySessionControllerCompleteAndGetNextTaskMutationVariables,
        TContext
      > => {
      return useMutation(getActivitySessionControllerCompleteAndGetNextTaskMutationOptions(options), queryClient);
    }

export const activitySessionControllerGetGradingCriteriaConfig = (
    id: string,
    params: ActivitySessionControllerGetGradingCriteriaConfigParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ActivitySessionControllerGetGradingCriteriaConfig200>(
      {url: `/activity-sessions/${id}/grading-criteria-config`, method: 'GET',
        params, signal
    },
      options);
    }




export const getActivitySessionControllerGetGradingCriteriaConfigQueryKey = (id: string,
    params?: ActivitySessionControllerGetGradingCriteriaConfigParams,) => {
    return [
    `/activity-sessions/${id}/grading-criteria-config`, ...(params ? [params] : [])
    ] as const;
    }


export const getActivitySessionControllerGetGradingCriteriaConfigQueryOptions = <TData = Awaited<ReturnType<typeof activitySessionControllerGetGradingCriteriaConfig>>, TError = ErrorType<unknown>>(id: string,
    params: ActivitySessionControllerGetGradingCriteriaConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitySessionControllerGetGradingCriteriaConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivitySessionControllerGetGradingCriteriaConfigQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activitySessionControllerGetGradingCriteriaConfig>>> = ({ signal }) => activitySessionControllerGetGradingCriteriaConfig(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activitySessionControllerGetGradingCriteriaConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivitySessionControllerGetGradingCriteriaConfigQueryResult = NonNullable<Awaited<ReturnType<typeof activitySessionControllerGetGradingCriteriaConfig>>>
export type ActivitySessionControllerGetGradingCriteriaConfigQueryError = ErrorType<unknown>


export function useActivitySessionControllerGetGradingCriteriaConfig<TData = Awaited<ReturnType<typeof activitySessionControllerGetGradingCriteriaConfig>>, TError = ErrorType<unknown>>(
 id: string,
    params: ActivitySessionControllerGetGradingCriteriaConfigParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitySessionControllerGetGradingCriteriaConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activitySessionControllerGetGradingCriteriaConfig>>,
          TError,
          Awaited<ReturnType<typeof activitySessionControllerGetGradingCriteriaConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivitySessionControllerGetGradingCriteriaConfig<TData = Awaited<ReturnType<typeof activitySessionControllerGetGradingCriteriaConfig>>, TError = ErrorType<unknown>>(
 id: string,
    params: ActivitySessionControllerGetGradingCriteriaConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitySessionControllerGetGradingCriteriaConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activitySessionControllerGetGradingCriteriaConfig>>,
          TError,
          Awaited<ReturnType<typeof activitySessionControllerGetGradingCriteriaConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivitySessionControllerGetGradingCriteriaConfig<TData = Awaited<ReturnType<typeof activitySessionControllerGetGradingCriteriaConfig>>, TError = ErrorType<unknown>>(
 id: string,
    params: ActivitySessionControllerGetGradingCriteriaConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitySessionControllerGetGradingCriteriaConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivitySessionControllerGetGradingCriteriaConfig<TData = Awaited<ReturnType<typeof activitySessionControllerGetGradingCriteriaConfig>>, TError = ErrorType<unknown>>(
 id: string,
    params: ActivitySessionControllerGetGradingCriteriaConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitySessionControllerGetGradingCriteriaConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivitySessionControllerGetGradingCriteriaConfigQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivitySessionControllerGetGradingCriteriaConfig} query
 */
export const invalidateActivitySessionControllerGetGradingCriteriaConfig = async (
 queryClient: QueryClient, id: string,
    params: ActivitySessionControllerGetGradingCriteriaConfigParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivitySessionControllerGetGradingCriteriaConfigQueryKey(id,params) }, options);

  return queryClient;
}

export const useSetActivitySessionControllerGetGradingCriteriaConfigQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,
    params: ActivitySessionControllerGetGradingCriteriaConfigParams | undefined,updater: Awaited<ReturnType<typeof activitySessionControllerGetGradingCriteriaConfig>> | undefined | ((old: Awaited<ReturnType<typeof activitySessionControllerGetGradingCriteriaConfig>> | undefined) => Awaited<ReturnType<typeof activitySessionControllerGetGradingCriteriaConfig>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activitySessionControllerGetGradingCriteriaConfig>>>({ exact: $exactMatch, queryKey: getActivitySessionControllerGetGradingCriteriaConfigQueryKey(id,params) }, updater);
  };
}

export const useGetActivitySessionControllerGetGradingCriteriaConfigQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,
    params: ActivitySessionControllerGetGradingCriteriaConfigParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activitySessionControllerGetGradingCriteriaConfig>>>(getActivitySessionControllerGetGradingCriteriaConfigQueryKey(id,params));
}



export const activitySessionControllerGetActivitySessionProgress = (
    activityInstanceId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ActivitySessionControllerGetActivitySessionProgress200>(
      {url: `/activity-sessions/${activityInstanceId}/progress`, method: 'GET', signal
    },
      options);
    }




export const getActivitySessionControllerGetActivitySessionProgressQueryKey = (activityInstanceId: string,) => {
    return [
    `/activity-sessions/${activityInstanceId}/progress`
    ] as const;
    }


export const getActivitySessionControllerGetActivitySessionProgressQueryOptions = <TData = Awaited<ReturnType<typeof activitySessionControllerGetActivitySessionProgress>>, TError = ErrorType<unknown>>(activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitySessionControllerGetActivitySessionProgress>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivitySessionControllerGetActivitySessionProgressQueryKey(activityInstanceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activitySessionControllerGetActivitySessionProgress>>> = ({ signal }) => activitySessionControllerGetActivitySessionProgress(activityInstanceId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: activityInstanceId !== null && activityInstanceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activitySessionControllerGetActivitySessionProgress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivitySessionControllerGetActivitySessionProgressQueryResult = NonNullable<Awaited<ReturnType<typeof activitySessionControllerGetActivitySessionProgress>>>
export type ActivitySessionControllerGetActivitySessionProgressQueryError = ErrorType<unknown>


export function useActivitySessionControllerGetActivitySessionProgress<TData = Awaited<ReturnType<typeof activitySessionControllerGetActivitySessionProgress>>, TError = ErrorType<unknown>>(
 activityInstanceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitySessionControllerGetActivitySessionProgress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activitySessionControllerGetActivitySessionProgress>>,
          TError,
          Awaited<ReturnType<typeof activitySessionControllerGetActivitySessionProgress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivitySessionControllerGetActivitySessionProgress<TData = Awaited<ReturnType<typeof activitySessionControllerGetActivitySessionProgress>>, TError = ErrorType<unknown>>(
 activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitySessionControllerGetActivitySessionProgress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activitySessionControllerGetActivitySessionProgress>>,
          TError,
          Awaited<ReturnType<typeof activitySessionControllerGetActivitySessionProgress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivitySessionControllerGetActivitySessionProgress<TData = Awaited<ReturnType<typeof activitySessionControllerGetActivitySessionProgress>>, TError = ErrorType<unknown>>(
 activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitySessionControllerGetActivitySessionProgress>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivitySessionControllerGetActivitySessionProgress<TData = Awaited<ReturnType<typeof activitySessionControllerGetActivitySessionProgress>>, TError = ErrorType<unknown>>(
 activityInstanceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitySessionControllerGetActivitySessionProgress>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivitySessionControllerGetActivitySessionProgressQueryOptions(activityInstanceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivitySessionControllerGetActivitySessionProgress} query
 */
export const invalidateActivitySessionControllerGetActivitySessionProgress = async (
 queryClient: QueryClient, activityInstanceId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivitySessionControllerGetActivitySessionProgressQueryKey(activityInstanceId) }, options);

  return queryClient;
}

export const useSetActivitySessionControllerGetActivitySessionProgressQueryData = () => {
  const queryClient = useQueryClient();
  return (activityInstanceId: string,updater: Awaited<ReturnType<typeof activitySessionControllerGetActivitySessionProgress>> | undefined | ((old: Awaited<ReturnType<typeof activitySessionControllerGetActivitySessionProgress>> | undefined) => Awaited<ReturnType<typeof activitySessionControllerGetActivitySessionProgress>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activitySessionControllerGetActivitySessionProgress>>>({ exact: $exactMatch, queryKey: getActivitySessionControllerGetActivitySessionProgressQueryKey(activityInstanceId) }, updater);
  };
}

export const useGetActivitySessionControllerGetActivitySessionProgressQueryData = () => {
  const queryClient = useQueryClient();
  return (activityInstanceId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activitySessionControllerGetActivitySessionProgress>>>(getActivitySessionControllerGetActivitySessionProgressQueryKey(activityInstanceId));
}



/**
 * @summary Event-Stream variant of submitTaskWithAudio.
Progressively streams task transaction data as each processing step completes.

@dev only supports OpenAnswerWithMission task as a PoC.
 */
export const activitySessionSseControllerSubmitTaskWithAudioSse = (
    activityInstanceId: string,
    taskId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/activity-sessions/${activityInstanceId}/tasks/${taskId}/submit-audio-sse`, method: 'POST', signal
    },
      options);
    }




export const getActivitySessionSseControllerSubmitTaskWithAudioSseMutationKey = () => ['activitySessionSseControllerSubmitTaskWithAudioSse'] as const;

export const getActivitySessionSseControllerSubmitTaskWithAudioSseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitySessionSseControllerSubmitTaskWithAudioSse>>, TError,ActivitySessionSseControllerSubmitTaskWithAudioSseMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activitySessionSseControllerSubmitTaskWithAudioSse>>, TError,ActivitySessionSseControllerSubmitTaskWithAudioSseMutationVariables, TContext> => {

const mutationKey = getActivitySessionSseControllerSubmitTaskWithAudioSseMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activitySessionSseControllerSubmitTaskWithAudioSse>>, ActivitySessionSseControllerSubmitTaskWithAudioSseMutationVariables> = (props) => {
          const {activityInstanceId,taskId} = props ?? {};

          return  activitySessionSseControllerSubmitTaskWithAudioSse(activityInstanceId,taskId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivitySessionSseControllerSubmitTaskWithAudioSseMutationResult = NonNullable<Awaited<ReturnType<typeof activitySessionSseControllerSubmitTaskWithAudioSse>>>

    export type ActivitySessionSseControllerSubmitTaskWithAudioSseMutationError = ErrorType<unknown>
    export type ActivitySessionSseControllerSubmitTaskWithAudioSseMutationVariables = {activityInstanceId: string;taskId: string}

    /**
 * @summary Event-Stream variant of submitTaskWithAudio.
Progressively streams task transaction data as each processing step completes.

@dev only supports OpenAnswerWithMission task as a PoC.
 */
export const useActivitySessionSseControllerSubmitTaskWithAudioSse = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitySessionSseControllerSubmitTaskWithAudioSse>>, TError,ActivitySessionSseControllerSubmitTaskWithAudioSseMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activitySessionSseControllerSubmitTaskWithAudioSse>>,
        TError,
        ActivitySessionSseControllerSubmitTaskWithAudioSseMutationVariables,
        TContext
      > => {
      return useMutation(getActivitySessionSseControllerSubmitTaskWithAudioSseMutationOptions(options), queryClient);
    }

/**
 * @summary Event-Stream submission of a typed answer: JSON body `{ text }`, the same events as
`submit-audio-sse`, with no recording behind them.

@dev only supports OpenAnswerWithMission task.
 */
export const activitySessionSseControllerSubmitTaskTextSse = (
    activityInstanceId: string,
    taskId: string,
    submitAnswerTextDto: BodyType<SubmitAnswerTextDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/activity-sessions/${activityInstanceId}/tasks/${taskId}/submit-text-sse`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitAnswerTextDto, signal
    },
      options);
    }




export const getActivitySessionSseControllerSubmitTaskTextSseMutationKey = () => ['activitySessionSseControllerSubmitTaskTextSse'] as const;

export const getActivitySessionSseControllerSubmitTaskTextSseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitySessionSseControllerSubmitTaskTextSse>>, TError,ActivitySessionSseControllerSubmitTaskTextSseMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activitySessionSseControllerSubmitTaskTextSse>>, TError,ActivitySessionSseControllerSubmitTaskTextSseMutationVariables, TContext> => {

const mutationKey = getActivitySessionSseControllerSubmitTaskTextSseMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activitySessionSseControllerSubmitTaskTextSse>>, ActivitySessionSseControllerSubmitTaskTextSseMutationVariables> = (props) => {
          const {activityInstanceId,taskId,data} = props ?? {};

          return  activitySessionSseControllerSubmitTaskTextSse(activityInstanceId,taskId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivitySessionSseControllerSubmitTaskTextSseMutationResult = NonNullable<Awaited<ReturnType<typeof activitySessionSseControllerSubmitTaskTextSse>>>
    export type ActivitySessionSseControllerSubmitTaskTextSseMutationBody = BodyType<SubmitAnswerTextDto>
    export type ActivitySessionSseControllerSubmitTaskTextSseMutationError = ErrorType<unknown>
    export type ActivitySessionSseControllerSubmitTaskTextSseMutationVariables = {activityInstanceId: string;taskId: string;data: BodyType<SubmitAnswerTextDto>}

    /**
 * @summary Event-Stream submission of a typed answer: JSON body `{ text }`, the same events as
`submit-audio-sse`, with no recording behind them.

@dev only supports OpenAnswerWithMission task.
 */
export const useActivitySessionSseControllerSubmitTaskTextSse = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activitySessionSseControllerSubmitTaskTextSse>>, TError,ActivitySessionSseControllerSubmitTaskTextSseMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activitySessionSseControllerSubmitTaskTextSse>>,
        TError,
        ActivitySessionSseControllerSubmitTaskTextSseMutationVariables,
        TContext
      > => {
      return useMutation(getActivitySessionSseControllerSubmitTaskTextSseMutationOptions(options), queryClient);
    }

export const orderControllerCreate = (
    createOrderDto: BodyType<CreateOrderDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<OrderResponseDto>(
      {url: `/enroll/orders`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrderDto, signal
    },
      options);
    }




export const getOrderControllerCreateMutationKey = () => ['orderControllerCreate'] as const;

export const getOrderControllerCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orderControllerCreate>>, TError,OrderControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof orderControllerCreate>>, TError,OrderControllerCreateMutationVariables, TContext> => {

const mutationKey = getOrderControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof orderControllerCreate>>, OrderControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  orderControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OrderControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof orderControllerCreate>>>
    export type OrderControllerCreateMutationBody = BodyType<CreateOrderDto>
    export type OrderControllerCreateMutationError = ErrorType<unknown>
    export type OrderControllerCreateMutationVariables = {data: BodyType<CreateOrderDto>}

    export const useOrderControllerCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orderControllerCreate>>, TError,OrderControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof orderControllerCreate>>,
        TError,
        OrderControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getOrderControllerCreateMutationOptions(options), queryClient);
    }

export const orderControllerCheckout = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CheckoutOrderResponseDto>(
      {url: `/enroll/orders/${id}/checkout`, method: 'POST', signal
    },
      options);
    }




export const getOrderControllerCheckoutMutationKey = () => ['orderControllerCheckout'] as const;

export const getOrderControllerCheckoutMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orderControllerCheckout>>, TError,OrderControllerCheckoutMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof orderControllerCheckout>>, TError,OrderControllerCheckoutMutationVariables, TContext> => {

const mutationKey = getOrderControllerCheckoutMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof orderControllerCheckout>>, OrderControllerCheckoutMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  orderControllerCheckout(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OrderControllerCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof orderControllerCheckout>>>

    export type OrderControllerCheckoutMutationError = ErrorType<unknown>
    export type OrderControllerCheckoutMutationVariables = {id: string}

    export const useOrderControllerCheckout = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orderControllerCheckout>>, TError,OrderControllerCheckoutMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof orderControllerCheckout>>,
        TError,
        OrderControllerCheckoutMutationVariables,
        TContext
      > => {
      return useMutation(getOrderControllerCheckoutMutationOptions(options), queryClient);
    }

export const orderControllerFindByCourse = (
    code: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<OrderStatusResponseDto>(
      {url: `/enroll/orders/by-course/${code}`, method: 'GET', signal
    },
      options);
    }




export const getOrderControllerFindByCourseQueryKey = (code: string,) => {
    return [
    `/enroll/orders/by-course/${code}`
    ] as const;
    }


export const getOrderControllerFindByCourseQueryOptions = <TData = Awaited<ReturnType<typeof orderControllerFindByCourse>>, TError = ErrorType<unknown>>(code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof orderControllerFindByCourse>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrderControllerFindByCourseQueryKey(code);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof orderControllerFindByCourse>>> = ({ signal }) => orderControllerFindByCourse(code, requestOptions, signal);





   return  { queryKey, queryFn, enabled: code !== null && code !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof orderControllerFindByCourse>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrderControllerFindByCourseQueryResult = NonNullable<Awaited<ReturnType<typeof orderControllerFindByCourse>>>
export type OrderControllerFindByCourseQueryError = ErrorType<unknown>


export function useOrderControllerFindByCourse<TData = Awaited<ReturnType<typeof orderControllerFindByCourse>>, TError = ErrorType<unknown>>(
 code: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof orderControllerFindByCourse>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof orderControllerFindByCourse>>,
          TError,
          Awaited<ReturnType<typeof orderControllerFindByCourse>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrderControllerFindByCourse<TData = Awaited<ReturnType<typeof orderControllerFindByCourse>>, TError = ErrorType<unknown>>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof orderControllerFindByCourse>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof orderControllerFindByCourse>>,
          TError,
          Awaited<ReturnType<typeof orderControllerFindByCourse>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrderControllerFindByCourse<TData = Awaited<ReturnType<typeof orderControllerFindByCourse>>, TError = ErrorType<unknown>>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof orderControllerFindByCourse>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOrderControllerFindByCourse<TData = Awaited<ReturnType<typeof orderControllerFindByCourse>>, TError = ErrorType<unknown>>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof orderControllerFindByCourse>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrderControllerFindByCourseQueryOptions(code,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useOrderControllerFindByCourse} query
 */
export const invalidateOrderControllerFindByCourse = async (
 queryClient: QueryClient, code: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getOrderControllerFindByCourseQueryKey(code) }, options);

  return queryClient;
}

export const useSetOrderControllerFindByCourseQueryData = () => {
  const queryClient = useQueryClient();
  return (code: string,updater: Awaited<ReturnType<typeof orderControllerFindByCourse>> | undefined | ((old: Awaited<ReturnType<typeof orderControllerFindByCourse>> | undefined) => Awaited<ReturnType<typeof orderControllerFindByCourse>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof orderControllerFindByCourse>>>({ exact: $exactMatch, queryKey: getOrderControllerFindByCourseQueryKey(code) }, updater);
  };
}

export const useGetOrderControllerFindByCourseQueryData = () => {
  const queryClient = useQueryClient();
  return (code: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof orderControllerFindByCourse>>>(getOrderControllerFindByCourseQueryKey(code));
}



export const orderControllerFindById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<OrderStatusResponseDto>(
      {url: `/enroll/orders/${id}`, method: 'GET', signal
    },
      options);
    }




export const getOrderControllerFindByIdQueryKey = (id: string,) => {
    return [
    `/enroll/orders/${id}`
    ] as const;
    }


export const getOrderControllerFindByIdQueryOptions = <TData = Awaited<ReturnType<typeof orderControllerFindById>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof orderControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrderControllerFindByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof orderControllerFindById>>> = ({ signal }) => orderControllerFindById(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof orderControllerFindById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrderControllerFindByIdQueryResult = NonNullable<Awaited<ReturnType<typeof orderControllerFindById>>>
export type OrderControllerFindByIdQueryError = ErrorType<unknown>


export function useOrderControllerFindById<TData = Awaited<ReturnType<typeof orderControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof orderControllerFindById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof orderControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof orderControllerFindById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrderControllerFindById<TData = Awaited<ReturnType<typeof orderControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof orderControllerFindById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof orderControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof orderControllerFindById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrderControllerFindById<TData = Awaited<ReturnType<typeof orderControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof orderControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOrderControllerFindById<TData = Awaited<ReturnType<typeof orderControllerFindById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof orderControllerFindById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrderControllerFindByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useOrderControllerFindById} query
 */
export const invalidateOrderControllerFindById = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getOrderControllerFindByIdQueryKey(id) }, options);

  return queryClient;
}

export const useSetOrderControllerFindByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof orderControllerFindById>> | undefined | ((old: Awaited<ReturnType<typeof orderControllerFindById>> | undefined) => Awaited<ReturnType<typeof orderControllerFindById>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof orderControllerFindById>>>({ exact: $exactMatch, queryKey: getOrderControllerFindByIdQueryKey(id) }, updater);
  };
}

export const useGetOrderControllerFindByIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof orderControllerFindById>>>(getOrderControllerFindByIdQueryKey(id));
}



export const activityBankControllerGetSimpleQuizLessons = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/activity-banks/simple-quiz-templates`, method: 'GET', signal
    },
      options);
    }




export const getActivityBankControllerGetSimpleQuizLessonsQueryKey = () => {
    return [
    `/activity-banks/simple-quiz-templates`
    ] as const;
    }


export const getActivityBankControllerGetSimpleQuizLessonsQueryOptions = <TData = Awaited<ReturnType<typeof activityBankControllerGetSimpleQuizLessons>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimpleQuizLessons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityBankControllerGetSimpleQuizLessonsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityBankControllerGetSimpleQuizLessons>>> = ({ signal }) => activityBankControllerGetSimpleQuizLessons(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimpleQuizLessons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivityBankControllerGetSimpleQuizLessonsQueryResult = NonNullable<Awaited<ReturnType<typeof activityBankControllerGetSimpleQuizLessons>>>
export type ActivityBankControllerGetSimpleQuizLessonsQueryError = ErrorType<unknown>


export function useActivityBankControllerGetSimpleQuizLessons<TData = Awaited<ReturnType<typeof activityBankControllerGetSimpleQuizLessons>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimpleQuizLessons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityBankControllerGetSimpleQuizLessons>>,
          TError,
          Awaited<ReturnType<typeof activityBankControllerGetSimpleQuizLessons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityBankControllerGetSimpleQuizLessons<TData = Awaited<ReturnType<typeof activityBankControllerGetSimpleQuizLessons>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimpleQuizLessons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityBankControllerGetSimpleQuizLessons>>,
          TError,
          Awaited<ReturnType<typeof activityBankControllerGetSimpleQuizLessons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityBankControllerGetSimpleQuizLessons<TData = Awaited<ReturnType<typeof activityBankControllerGetSimpleQuizLessons>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimpleQuizLessons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivityBankControllerGetSimpleQuizLessons<TData = Awaited<ReturnType<typeof activityBankControllerGetSimpleQuizLessons>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimpleQuizLessons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivityBankControllerGetSimpleQuizLessonsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivityBankControllerGetSimpleQuizLessons} query
 */
export const invalidateActivityBankControllerGetSimpleQuizLessons = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivityBankControllerGetSimpleQuizLessonsQueryKey() }, options);

  return queryClient;
}

export const useSetActivityBankControllerGetSimpleQuizLessonsQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof activityBankControllerGetSimpleQuizLessons>> | undefined | ((old: Awaited<ReturnType<typeof activityBankControllerGetSimpleQuizLessons>> | undefined) => Awaited<ReturnType<typeof activityBankControllerGetSimpleQuizLessons>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activityBankControllerGetSimpleQuizLessons>>>({ exact: $exactMatch, queryKey: getActivityBankControllerGetSimpleQuizLessonsQueryKey() }, updater);
  };
}

export const useGetActivityBankControllerGetSimpleQuizLessonsQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activityBankControllerGetSimpleQuizLessons>>>(getActivityBankControllerGetSimpleQuizLessonsQueryKey());
}



export const activityBankControllerConvertAcademicToActivity = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/activity-banks/convert-academic-to-lesson-dtos`, method: 'POST', signal
    },
      options);
    }




export const getActivityBankControllerConvertAcademicToActivityMutationKey = () => ['activityBankControllerConvertAcademicToActivity'] as const;

export const getActivityBankControllerConvertAcademicToActivityMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityBankControllerConvertAcademicToActivity>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activityBankControllerConvertAcademicToActivity>>, TError,void, TContext> => {

const mutationKey = getActivityBankControllerConvertAcademicToActivityMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activityBankControllerConvertAcademicToActivity>>, void> = () => {


          return  activityBankControllerConvertAcademicToActivity(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivityBankControllerConvertAcademicToActivityMutationResult = NonNullable<Awaited<ReturnType<typeof activityBankControllerConvertAcademicToActivity>>>

    export type ActivityBankControllerConvertAcademicToActivityMutationError = ErrorType<unknown>


    export const useActivityBankControllerConvertAcademicToActivity = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityBankControllerConvertAcademicToActivity>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activityBankControllerConvertAcademicToActivity>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getActivityBankControllerConvertAcademicToActivityMutationOptions(options), queryClient);
    }

/**
 * @summary Upload an image/audio asset, processed server-side, to the public asset bucket (Admin)
 */
export const activityBankControllerUploadAsset = (
    activityBankControllerUploadAssetBody: BodyType<ActivityBankControllerUploadAssetBody>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {

      const formData = new FormData();
if(activityBankControllerUploadAssetBody.file !== undefined) {
 formData.append(`file`, activityBankControllerUploadAssetBody.file);
 }

      return customInstance<UploadedActivityBankAssetDto>(
      {url: `/activity-banks/assets`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getActivityBankControllerUploadAssetMutationKey = () => ['activityBankControllerUploadAsset'] as const;

export const getActivityBankControllerUploadAssetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityBankControllerUploadAsset>>, TError,ActivityBankControllerUploadAssetMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activityBankControllerUploadAsset>>, TError,ActivityBankControllerUploadAssetMutationVariables, TContext> => {

const mutationKey = getActivityBankControllerUploadAssetMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activityBankControllerUploadAsset>>, ActivityBankControllerUploadAssetMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  activityBankControllerUploadAsset(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivityBankControllerUploadAssetMutationResult = NonNullable<Awaited<ReturnType<typeof activityBankControllerUploadAsset>>>
    export type ActivityBankControllerUploadAssetMutationBody = BodyType<ActivityBankControllerUploadAssetBody>
    export type ActivityBankControllerUploadAssetMutationError = ErrorType<unknown>
    export type ActivityBankControllerUploadAssetMutationVariables = {data: BodyType<ActivityBankControllerUploadAssetBody>}

    /**
 * @summary Upload an image/audio asset, processed server-side, to the public asset bucket (Admin)
 */
export const useActivityBankControllerUploadAsset = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityBankControllerUploadAsset>>, TError,ActivityBankControllerUploadAssetMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activityBankControllerUploadAsset>>,
        TError,
        ActivityBankControllerUploadAssetMutationVariables,
        TContext
      > => {
      return useMutation(getActivityBankControllerUploadAssetMutationOptions(options), queryClient);
    }

export const activityBankControllerValidateCreateLessonsWithActivities = (
    activityBankControllerValidateCreateLessonsWithActivitiesBody: BodyType<string[]>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/activity-banks/validate-create-lessons-with-activities`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: activityBankControllerValidateCreateLessonsWithActivitiesBody, signal
    },
      options);
    }




export const getActivityBankControllerValidateCreateLessonsWithActivitiesMutationKey = () => ['activityBankControllerValidateCreateLessonsWithActivities'] as const;

export const getActivityBankControllerValidateCreateLessonsWithActivitiesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityBankControllerValidateCreateLessonsWithActivities>>, TError,ActivityBankControllerValidateCreateLessonsWithActivitiesMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activityBankControllerValidateCreateLessonsWithActivities>>, TError,ActivityBankControllerValidateCreateLessonsWithActivitiesMutationVariables, TContext> => {

const mutationKey = getActivityBankControllerValidateCreateLessonsWithActivitiesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activityBankControllerValidateCreateLessonsWithActivities>>, ActivityBankControllerValidateCreateLessonsWithActivitiesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  activityBankControllerValidateCreateLessonsWithActivities(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivityBankControllerValidateCreateLessonsWithActivitiesMutationResult = NonNullable<Awaited<ReturnType<typeof activityBankControllerValidateCreateLessonsWithActivities>>>
    export type ActivityBankControllerValidateCreateLessonsWithActivitiesMutationBody = BodyType<string[]>
    export type ActivityBankControllerValidateCreateLessonsWithActivitiesMutationError = ErrorType<unknown>
    export type ActivityBankControllerValidateCreateLessonsWithActivitiesMutationVariables = {data: BodyType<string[]>}

    export const useActivityBankControllerValidateCreateLessonsWithActivities = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityBankControllerValidateCreateLessonsWithActivities>>, TError,ActivityBankControllerValidateCreateLessonsWithActivitiesMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activityBankControllerValidateCreateLessonsWithActivities>>,
        TError,
        ActivityBankControllerValidateCreateLessonsWithActivitiesMutationVariables,
        TContext
      > => {
      return useMutation(getActivityBankControllerValidateCreateLessonsWithActivitiesMutationOptions(options), queryClient);
    }

export const activityBankControllerGetTemplateOpsFromGoogleSheet = (
    sheetId: string,
    sheetName: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ActivityBankControllerGetTemplateOpsFromGoogleSheet200Item[]>(
      {url: `/activity-banks/google-sheet-ops-template/sheetId/${sheetId}/sheetName/${sheetName}`, method: 'GET', signal
    },
      options);
    }




export const getActivityBankControllerGetTemplateOpsFromGoogleSheetQueryKey = (sheetId: string,
    sheetName: string,) => {
    return [
    `/activity-banks/google-sheet-ops-template/sheetId/${sheetId}/sheetName/${sheetName}`
    ] as const;
    }


export const getActivityBankControllerGetTemplateOpsFromGoogleSheetQueryOptions = <TData = Awaited<ReturnType<typeof activityBankControllerGetTemplateOpsFromGoogleSheet>>, TError = ErrorType<unknown>>(sheetId: string,
    sheetName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetTemplateOpsFromGoogleSheet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityBankControllerGetTemplateOpsFromGoogleSheetQueryKey(sheetId,sheetName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityBankControllerGetTemplateOpsFromGoogleSheet>>> = ({ signal }) => activityBankControllerGetTemplateOpsFromGoogleSheet(sheetId,sheetName, requestOptions, signal);





   return  { queryKey, queryFn, enabled: sheetId !== null && sheetId !== undefined && sheetName !== null && sheetName !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetTemplateOpsFromGoogleSheet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivityBankControllerGetTemplateOpsFromGoogleSheetQueryResult = NonNullable<Awaited<ReturnType<typeof activityBankControllerGetTemplateOpsFromGoogleSheet>>>
export type ActivityBankControllerGetTemplateOpsFromGoogleSheetQueryError = ErrorType<unknown>


export function useActivityBankControllerGetTemplateOpsFromGoogleSheet<TData = Awaited<ReturnType<typeof activityBankControllerGetTemplateOpsFromGoogleSheet>>, TError = ErrorType<unknown>>(
 sheetId: string,
    sheetName: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetTemplateOpsFromGoogleSheet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityBankControllerGetTemplateOpsFromGoogleSheet>>,
          TError,
          Awaited<ReturnType<typeof activityBankControllerGetTemplateOpsFromGoogleSheet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityBankControllerGetTemplateOpsFromGoogleSheet<TData = Awaited<ReturnType<typeof activityBankControllerGetTemplateOpsFromGoogleSheet>>, TError = ErrorType<unknown>>(
 sheetId: string,
    sheetName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetTemplateOpsFromGoogleSheet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityBankControllerGetTemplateOpsFromGoogleSheet>>,
          TError,
          Awaited<ReturnType<typeof activityBankControllerGetTemplateOpsFromGoogleSheet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityBankControllerGetTemplateOpsFromGoogleSheet<TData = Awaited<ReturnType<typeof activityBankControllerGetTemplateOpsFromGoogleSheet>>, TError = ErrorType<unknown>>(
 sheetId: string,
    sheetName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetTemplateOpsFromGoogleSheet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivityBankControllerGetTemplateOpsFromGoogleSheet<TData = Awaited<ReturnType<typeof activityBankControllerGetTemplateOpsFromGoogleSheet>>, TError = ErrorType<unknown>>(
 sheetId: string,
    sheetName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetTemplateOpsFromGoogleSheet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivityBankControllerGetTemplateOpsFromGoogleSheetQueryOptions(sheetId,sheetName,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivityBankControllerGetTemplateOpsFromGoogleSheet} query
 */
export const invalidateActivityBankControllerGetTemplateOpsFromGoogleSheet = async (
 queryClient: QueryClient, sheetId: string,
    sheetName: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivityBankControllerGetTemplateOpsFromGoogleSheetQueryKey(sheetId,sheetName) }, options);

  return queryClient;
}

export const useSetActivityBankControllerGetTemplateOpsFromGoogleSheetQueryData = () => {
  const queryClient = useQueryClient();
  return (sheetId: string,
    sheetName: string,updater: Awaited<ReturnType<typeof activityBankControllerGetTemplateOpsFromGoogleSheet>> | undefined | ((old: Awaited<ReturnType<typeof activityBankControllerGetTemplateOpsFromGoogleSheet>> | undefined) => Awaited<ReturnType<typeof activityBankControllerGetTemplateOpsFromGoogleSheet>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activityBankControllerGetTemplateOpsFromGoogleSheet>>>({ exact: $exactMatch, queryKey: getActivityBankControllerGetTemplateOpsFromGoogleSheetQueryKey(sheetId,sheetName) }, updater);
  };
}

export const useGetActivityBankControllerGetTemplateOpsFromGoogleSheetQueryData = () => {
  const queryClient = useQueryClient();
  return (sheetId: string,
    sheetName: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activityBankControllerGetTemplateOpsFromGoogleSheet>>>(getActivityBankControllerGetTemplateOpsFromGoogleSheetQueryKey(sheetId,sheetName));
}



export const activityBankControllerGetLessonDtosFromGoogleSheet = (
    sheetId: string,
    sheetName: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CreateLessonAndActivitiesDto[]>(
      {url: `/activity-banks/google-sheet-lesson-template/sheetId/${sheetId}/sheetName/${sheetName}`, method: 'GET', signal
    },
      options);
    }




export const getActivityBankControllerGetLessonDtosFromGoogleSheetQueryKey = (sheetId: string,
    sheetName: string,) => {
    return [
    `/activity-banks/google-sheet-lesson-template/sheetId/${sheetId}/sheetName/${sheetName}`
    ] as const;
    }


export const getActivityBankControllerGetLessonDtosFromGoogleSheetQueryOptions = <TData = Awaited<ReturnType<typeof activityBankControllerGetLessonDtosFromGoogleSheet>>, TError = ErrorType<unknown>>(sheetId: string,
    sheetName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetLessonDtosFromGoogleSheet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityBankControllerGetLessonDtosFromGoogleSheetQueryKey(sheetId,sheetName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityBankControllerGetLessonDtosFromGoogleSheet>>> = ({ signal }) => activityBankControllerGetLessonDtosFromGoogleSheet(sheetId,sheetName, requestOptions, signal);





   return  { queryKey, queryFn, enabled: sheetId !== null && sheetId !== undefined && sheetName !== null && sheetName !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetLessonDtosFromGoogleSheet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivityBankControllerGetLessonDtosFromGoogleSheetQueryResult = NonNullable<Awaited<ReturnType<typeof activityBankControllerGetLessonDtosFromGoogleSheet>>>
export type ActivityBankControllerGetLessonDtosFromGoogleSheetQueryError = ErrorType<unknown>


export function useActivityBankControllerGetLessonDtosFromGoogleSheet<TData = Awaited<ReturnType<typeof activityBankControllerGetLessonDtosFromGoogleSheet>>, TError = ErrorType<unknown>>(
 sheetId: string,
    sheetName: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetLessonDtosFromGoogleSheet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityBankControllerGetLessonDtosFromGoogleSheet>>,
          TError,
          Awaited<ReturnType<typeof activityBankControllerGetLessonDtosFromGoogleSheet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityBankControllerGetLessonDtosFromGoogleSheet<TData = Awaited<ReturnType<typeof activityBankControllerGetLessonDtosFromGoogleSheet>>, TError = ErrorType<unknown>>(
 sheetId: string,
    sheetName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetLessonDtosFromGoogleSheet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityBankControllerGetLessonDtosFromGoogleSheet>>,
          TError,
          Awaited<ReturnType<typeof activityBankControllerGetLessonDtosFromGoogleSheet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityBankControllerGetLessonDtosFromGoogleSheet<TData = Awaited<ReturnType<typeof activityBankControllerGetLessonDtosFromGoogleSheet>>, TError = ErrorType<unknown>>(
 sheetId: string,
    sheetName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetLessonDtosFromGoogleSheet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivityBankControllerGetLessonDtosFromGoogleSheet<TData = Awaited<ReturnType<typeof activityBankControllerGetLessonDtosFromGoogleSheet>>, TError = ErrorType<unknown>>(
 sheetId: string,
    sheetName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetLessonDtosFromGoogleSheet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivityBankControllerGetLessonDtosFromGoogleSheetQueryOptions(sheetId,sheetName,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivityBankControllerGetLessonDtosFromGoogleSheet} query
 */
export const invalidateActivityBankControllerGetLessonDtosFromGoogleSheet = async (
 queryClient: QueryClient, sheetId: string,
    sheetName: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivityBankControllerGetLessonDtosFromGoogleSheetQueryKey(sheetId,sheetName) }, options);

  return queryClient;
}

export const useSetActivityBankControllerGetLessonDtosFromGoogleSheetQueryData = () => {
  const queryClient = useQueryClient();
  return (sheetId: string,
    sheetName: string,updater: Awaited<ReturnType<typeof activityBankControllerGetLessonDtosFromGoogleSheet>> | undefined | ((old: Awaited<ReturnType<typeof activityBankControllerGetLessonDtosFromGoogleSheet>> | undefined) => Awaited<ReturnType<typeof activityBankControllerGetLessonDtosFromGoogleSheet>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activityBankControllerGetLessonDtosFromGoogleSheet>>>({ exact: $exactMatch, queryKey: getActivityBankControllerGetLessonDtosFromGoogleSheetQueryKey(sheetId,sheetName) }, updater);
  };
}

export const useGetActivityBankControllerGetLessonDtosFromGoogleSheetQueryData = () => {
  const queryClient = useQueryClient();
  return (sheetId: string,
    sheetName: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activityBankControllerGetLessonDtosFromGoogleSheet>>>(getActivityBankControllerGetLessonDtosFromGoogleSheetQueryKey(sheetId,sheetName));
}



export const activityBankControllerExportLessonTemplates = (
    exportLessonTemplatesDto: BodyType<ExportLessonTemplatesDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CreateLessonAndActivitiesDto[]>(
      {url: `/activity-banks/lesson-template/lessons/export`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exportLessonTemplatesDto, signal
    },
      options);
    }




export const getActivityBankControllerExportLessonTemplatesMutationKey = () => ['activityBankControllerExportLessonTemplates'] as const;

export const getActivityBankControllerExportLessonTemplatesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityBankControllerExportLessonTemplates>>, TError,ActivityBankControllerExportLessonTemplatesMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activityBankControllerExportLessonTemplates>>, TError,ActivityBankControllerExportLessonTemplatesMutationVariables, TContext> => {

const mutationKey = getActivityBankControllerExportLessonTemplatesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activityBankControllerExportLessonTemplates>>, ActivityBankControllerExportLessonTemplatesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  activityBankControllerExportLessonTemplates(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivityBankControllerExportLessonTemplatesMutationResult = NonNullable<Awaited<ReturnType<typeof activityBankControllerExportLessonTemplates>>>
    export type ActivityBankControllerExportLessonTemplatesMutationBody = BodyType<ExportLessonTemplatesDto>
    export type ActivityBankControllerExportLessonTemplatesMutationError = ErrorType<unknown>
    export type ActivityBankControllerExportLessonTemplatesMutationVariables = {data: BodyType<ExportLessonTemplatesDto>}

    export const useActivityBankControllerExportLessonTemplates = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityBankControllerExportLessonTemplates>>, TError,ActivityBankControllerExportLessonTemplatesMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activityBankControllerExportLessonTemplates>>,
        TError,
        ActivityBankControllerExportLessonTemplatesMutationVariables,
        TContext
      > => {
      return useMutation(getActivityBankControllerExportLessonTemplatesMutationOptions(options), queryClient);
    }

export const activityBankControllerGetSimplifyModularSheetNames = (
    sheetId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SimplifyModularSheetNameDto[]>(
      {url: `/activity-banks/simplify-modular/google-sheet/sheetId/${sheetId}/sheet-names`, method: 'GET', signal
    },
      options);
    }




export const getActivityBankControllerGetSimplifyModularSheetNamesQueryKey = (sheetId: string,) => {
    return [
    `/activity-banks/simplify-modular/google-sheet/sheetId/${sheetId}/sheet-names`
    ] as const;
    }


export const getActivityBankControllerGetSimplifyModularSheetNamesQueryOptions = <TData = Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularSheetNames>>, TError = ErrorType<unknown>>(sheetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularSheetNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityBankControllerGetSimplifyModularSheetNamesQueryKey(sheetId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularSheetNames>>> = ({ signal }) => activityBankControllerGetSimplifyModularSheetNames(sheetId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: sheetId !== null && sheetId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularSheetNames>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivityBankControllerGetSimplifyModularSheetNamesQueryResult = NonNullable<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularSheetNames>>>
export type ActivityBankControllerGetSimplifyModularSheetNamesQueryError = ErrorType<unknown>


export function useActivityBankControllerGetSimplifyModularSheetNames<TData = Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularSheetNames>>, TError = ErrorType<unknown>>(
 sheetId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularSheetNames>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularSheetNames>>,
          TError,
          Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularSheetNames>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityBankControllerGetSimplifyModularSheetNames<TData = Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularSheetNames>>, TError = ErrorType<unknown>>(
 sheetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularSheetNames>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularSheetNames>>,
          TError,
          Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularSheetNames>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityBankControllerGetSimplifyModularSheetNames<TData = Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularSheetNames>>, TError = ErrorType<unknown>>(
 sheetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularSheetNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivityBankControllerGetSimplifyModularSheetNames<TData = Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularSheetNames>>, TError = ErrorType<unknown>>(
 sheetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularSheetNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivityBankControllerGetSimplifyModularSheetNamesQueryOptions(sheetId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivityBankControllerGetSimplifyModularSheetNames} query
 */
export const invalidateActivityBankControllerGetSimplifyModularSheetNames = async (
 queryClient: QueryClient, sheetId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivityBankControllerGetSimplifyModularSheetNamesQueryKey(sheetId) }, options);

  return queryClient;
}

export const useSetActivityBankControllerGetSimplifyModularSheetNamesQueryData = () => {
  const queryClient = useQueryClient();
  return (sheetId: string,updater: Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularSheetNames>> | undefined | ((old: Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularSheetNames>> | undefined) => Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularSheetNames>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularSheetNames>>>({ exact: $exactMatch, queryKey: getActivityBankControllerGetSimplifyModularSheetNamesQueryKey(sheetId) }, updater);
  };
}

export const useGetActivityBankControllerGetSimplifyModularSheetNamesQueryData = () => {
  const queryClient = useQueryClient();
  return (sheetId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularSheetNames>>>(getActivityBankControllerGetSimplifyModularSheetNamesQueryKey(sheetId));
}



export const activityBankControllerGetSimplifyModularLessonsFromAllSheets = (
    sheetId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SimplifyModularLessonDto[]>(
      {url: `/activity-banks/simplify-modular/google-sheet/sheetId/${sheetId}`, method: 'GET', signal
    },
      options);
    }




export const getActivityBankControllerGetSimplifyModularLessonsFromAllSheetsQueryKey = (sheetId: string,) => {
    return [
    `/activity-banks/simplify-modular/google-sheet/sheetId/${sheetId}`
    ] as const;
    }


export const getActivityBankControllerGetSimplifyModularLessonsFromAllSheetsQueryOptions = <TData = Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromAllSheets>>, TError = ErrorType<unknown>>(sheetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromAllSheets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityBankControllerGetSimplifyModularLessonsFromAllSheetsQueryKey(sheetId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromAllSheets>>> = ({ signal }) => activityBankControllerGetSimplifyModularLessonsFromAllSheets(sheetId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: sheetId !== null && sheetId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromAllSheets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivityBankControllerGetSimplifyModularLessonsFromAllSheetsQueryResult = NonNullable<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromAllSheets>>>
export type ActivityBankControllerGetSimplifyModularLessonsFromAllSheetsQueryError = ErrorType<unknown>


export function useActivityBankControllerGetSimplifyModularLessonsFromAllSheets<TData = Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromAllSheets>>, TError = ErrorType<unknown>>(
 sheetId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromAllSheets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromAllSheets>>,
          TError,
          Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromAllSheets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityBankControllerGetSimplifyModularLessonsFromAllSheets<TData = Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromAllSheets>>, TError = ErrorType<unknown>>(
 sheetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromAllSheets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromAllSheets>>,
          TError,
          Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromAllSheets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityBankControllerGetSimplifyModularLessonsFromAllSheets<TData = Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromAllSheets>>, TError = ErrorType<unknown>>(
 sheetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromAllSheets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivityBankControllerGetSimplifyModularLessonsFromAllSheets<TData = Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromAllSheets>>, TError = ErrorType<unknown>>(
 sheetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromAllSheets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivityBankControllerGetSimplifyModularLessonsFromAllSheetsQueryOptions(sheetId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivityBankControllerGetSimplifyModularLessonsFromAllSheets} query
 */
export const invalidateActivityBankControllerGetSimplifyModularLessonsFromAllSheets = async (
 queryClient: QueryClient, sheetId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivityBankControllerGetSimplifyModularLessonsFromAllSheetsQueryKey(sheetId) }, options);

  return queryClient;
}

export const useSetActivityBankControllerGetSimplifyModularLessonsFromAllSheetsQueryData = () => {
  const queryClient = useQueryClient();
  return (sheetId: string,updater: Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromAllSheets>> | undefined | ((old: Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromAllSheets>> | undefined) => Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromAllSheets>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromAllSheets>>>({ exact: $exactMatch, queryKey: getActivityBankControllerGetSimplifyModularLessonsFromAllSheetsQueryKey(sheetId) }, updater);
  };
}

export const useGetActivityBankControllerGetSimplifyModularLessonsFromAllSheetsQueryData = () => {
  const queryClient = useQueryClient();
  return (sheetId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromAllSheets>>>(getActivityBankControllerGetSimplifyModularLessonsFromAllSheetsQueryKey(sheetId));
}



export const activityBankControllerGetSimplifyModularLessonsFromGoogleSheet = (
    sheetId: string,
    sheetName: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SimplifyModularLessonDto[]>(
      {url: `/activity-banks/simplify-modular/google-sheet/sheetId/${sheetId}/sheetName/${sheetName}`, method: 'GET', signal
    },
      options);
    }




export const getActivityBankControllerGetSimplifyModularLessonsFromGoogleSheetQueryKey = (sheetId: string,
    sheetName: string,) => {
    return [
    `/activity-banks/simplify-modular/google-sheet/sheetId/${sheetId}/sheetName/${sheetName}`
    ] as const;
    }


export const getActivityBankControllerGetSimplifyModularLessonsFromGoogleSheetQueryOptions = <TData = Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromGoogleSheet>>, TError = ErrorType<unknown>>(sheetId: string,
    sheetName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromGoogleSheet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityBankControllerGetSimplifyModularLessonsFromGoogleSheetQueryKey(sheetId,sheetName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromGoogleSheet>>> = ({ signal }) => activityBankControllerGetSimplifyModularLessonsFromGoogleSheet(sheetId,sheetName, requestOptions, signal);





   return  { queryKey, queryFn, enabled: sheetId !== null && sheetId !== undefined && sheetName !== null && sheetName !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromGoogleSheet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivityBankControllerGetSimplifyModularLessonsFromGoogleSheetQueryResult = NonNullable<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromGoogleSheet>>>
export type ActivityBankControllerGetSimplifyModularLessonsFromGoogleSheetQueryError = ErrorType<unknown>


export function useActivityBankControllerGetSimplifyModularLessonsFromGoogleSheet<TData = Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromGoogleSheet>>, TError = ErrorType<unknown>>(
 sheetId: string,
    sheetName: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromGoogleSheet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromGoogleSheet>>,
          TError,
          Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromGoogleSheet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityBankControllerGetSimplifyModularLessonsFromGoogleSheet<TData = Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromGoogleSheet>>, TError = ErrorType<unknown>>(
 sheetId: string,
    sheetName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromGoogleSheet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromGoogleSheet>>,
          TError,
          Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromGoogleSheet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityBankControllerGetSimplifyModularLessonsFromGoogleSheet<TData = Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromGoogleSheet>>, TError = ErrorType<unknown>>(
 sheetId: string,
    sheetName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromGoogleSheet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivityBankControllerGetSimplifyModularLessonsFromGoogleSheet<TData = Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromGoogleSheet>>, TError = ErrorType<unknown>>(
 sheetId: string,
    sheetName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromGoogleSheet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivityBankControllerGetSimplifyModularLessonsFromGoogleSheetQueryOptions(sheetId,sheetName,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivityBankControllerGetSimplifyModularLessonsFromGoogleSheet} query
 */
export const invalidateActivityBankControllerGetSimplifyModularLessonsFromGoogleSheet = async (
 queryClient: QueryClient, sheetId: string,
    sheetName: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivityBankControllerGetSimplifyModularLessonsFromGoogleSheetQueryKey(sheetId,sheetName) }, options);

  return queryClient;
}

export const useSetActivityBankControllerGetSimplifyModularLessonsFromGoogleSheetQueryData = () => {
  const queryClient = useQueryClient();
  return (sheetId: string,
    sheetName: string,updater: Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromGoogleSheet>> | undefined | ((old: Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromGoogleSheet>> | undefined) => Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromGoogleSheet>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromGoogleSheet>>>({ exact: $exactMatch, queryKey: getActivityBankControllerGetSimplifyModularLessonsFromGoogleSheetQueryKey(sheetId,sheetName) }, updater);
  };
}

export const useGetActivityBankControllerGetSimplifyModularLessonsFromGoogleSheetQueryData = () => {
  const queryClient = useQueryClient();
  return (sheetId: string,
    sheetName: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activityBankControllerGetSimplifyModularLessonsFromGoogleSheet>>>(getActivityBankControllerGetSimplifyModularLessonsFromGoogleSheetQueryKey(sheetId,sheetName));
}



export const activityBankControllerValidateSimplifyModularLesson = (
    simplifyModularLessonDto: BodyType<SimplifyModularLessonDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ValidateLessonResponseDto>(
      {url: `/activity-banks/simplify-modular/validate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: simplifyModularLessonDto, signal
    },
      options);
    }




export const getActivityBankControllerValidateSimplifyModularLessonMutationKey = () => ['activityBankControllerValidateSimplifyModularLesson'] as const;

export const getActivityBankControllerValidateSimplifyModularLessonMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityBankControllerValidateSimplifyModularLesson>>, TError,ActivityBankControllerValidateSimplifyModularLessonMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activityBankControllerValidateSimplifyModularLesson>>, TError,ActivityBankControllerValidateSimplifyModularLessonMutationVariables, TContext> => {

const mutationKey = getActivityBankControllerValidateSimplifyModularLessonMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activityBankControllerValidateSimplifyModularLesson>>, ActivityBankControllerValidateSimplifyModularLessonMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  activityBankControllerValidateSimplifyModularLesson(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivityBankControllerValidateSimplifyModularLessonMutationResult = NonNullable<Awaited<ReturnType<typeof activityBankControllerValidateSimplifyModularLesson>>>
    export type ActivityBankControllerValidateSimplifyModularLessonMutationBody = BodyType<SimplifyModularLessonDto>
    export type ActivityBankControllerValidateSimplifyModularLessonMutationError = ErrorType<unknown>
    export type ActivityBankControllerValidateSimplifyModularLessonMutationVariables = {data: BodyType<SimplifyModularLessonDto>}

    export const useActivityBankControllerValidateSimplifyModularLesson = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityBankControllerValidateSimplifyModularLesson>>, TError,ActivityBankControllerValidateSimplifyModularLessonMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activityBankControllerValidateSimplifyModularLesson>>,
        TError,
        ActivityBankControllerValidateSimplifyModularLessonMutationVariables,
        TContext
      > => {
      return useMutation(getActivityBankControllerValidateSimplifyModularLessonMutationOptions(options), queryClient);
    }

export const activityBankControllerConvertSimplifyModular = (
    simplifyModularLessonDto: BodyType<SimplifyModularLessonDto[]>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CreateLessonAndActivitiesDto[]>(
      {url: `/activity-banks/simplify-modular/convert`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: simplifyModularLessonDto, signal
    },
      options);
    }




export const getActivityBankControllerConvertSimplifyModularMutationKey = () => ['activityBankControllerConvertSimplifyModular'] as const;

export const getActivityBankControllerConvertSimplifyModularMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityBankControllerConvertSimplifyModular>>, TError,ActivityBankControllerConvertSimplifyModularMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activityBankControllerConvertSimplifyModular>>, TError,ActivityBankControllerConvertSimplifyModularMutationVariables, TContext> => {

const mutationKey = getActivityBankControllerConvertSimplifyModularMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activityBankControllerConvertSimplifyModular>>, ActivityBankControllerConvertSimplifyModularMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  activityBankControllerConvertSimplifyModular(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivityBankControllerConvertSimplifyModularMutationResult = NonNullable<Awaited<ReturnType<typeof activityBankControllerConvertSimplifyModular>>>
    export type ActivityBankControllerConvertSimplifyModularMutationBody = BodyType<SimplifyModularLessonDto[]>
    export type ActivityBankControllerConvertSimplifyModularMutationError = ErrorType<unknown>
    export type ActivityBankControllerConvertSimplifyModularMutationVariables = {data: BodyType<SimplifyModularLessonDto[]>}

    export const useActivityBankControllerConvertSimplifyModular = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityBankControllerConvertSimplifyModular>>, TError,ActivityBankControllerConvertSimplifyModularMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activityBankControllerConvertSimplifyModular>>,
        TError,
        ActivityBankControllerConvertSimplifyModularMutationVariables,
        TContext
      > => {
      return useMutation(getActivityBankControllerConvertSimplifyModularMutationOptions(options), queryClient);
    }

export const activityBankControllerGetSimplify2026Sem2SheetNames = (
    sheetId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SimplifyModularSheetNameDto[]>(
      {url: `/activity-banks/simplify-modular-2026-2/google-sheet/sheetId/${sheetId}/sheet-names`, method: 'GET', signal
    },
      options);
    }




export const getActivityBankControllerGetSimplify2026Sem2SheetNamesQueryKey = (sheetId: string,) => {
    return [
    `/activity-banks/simplify-modular-2026-2/google-sheet/sheetId/${sheetId}/sheet-names`
    ] as const;
    }


export const getActivityBankControllerGetSimplify2026Sem2SheetNamesQueryOptions = <TData = Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2SheetNames>>, TError = ErrorType<unknown>>(sheetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2SheetNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityBankControllerGetSimplify2026Sem2SheetNamesQueryKey(sheetId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2SheetNames>>> = ({ signal }) => activityBankControllerGetSimplify2026Sem2SheetNames(sheetId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: sheetId !== null && sheetId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2SheetNames>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivityBankControllerGetSimplify2026Sem2SheetNamesQueryResult = NonNullable<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2SheetNames>>>
export type ActivityBankControllerGetSimplify2026Sem2SheetNamesQueryError = ErrorType<unknown>


export function useActivityBankControllerGetSimplify2026Sem2SheetNames<TData = Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2SheetNames>>, TError = ErrorType<unknown>>(
 sheetId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2SheetNames>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2SheetNames>>,
          TError,
          Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2SheetNames>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityBankControllerGetSimplify2026Sem2SheetNames<TData = Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2SheetNames>>, TError = ErrorType<unknown>>(
 sheetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2SheetNames>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2SheetNames>>,
          TError,
          Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2SheetNames>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityBankControllerGetSimplify2026Sem2SheetNames<TData = Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2SheetNames>>, TError = ErrorType<unknown>>(
 sheetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2SheetNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivityBankControllerGetSimplify2026Sem2SheetNames<TData = Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2SheetNames>>, TError = ErrorType<unknown>>(
 sheetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2SheetNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivityBankControllerGetSimplify2026Sem2SheetNamesQueryOptions(sheetId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivityBankControllerGetSimplify2026Sem2SheetNames} query
 */
export const invalidateActivityBankControllerGetSimplify2026Sem2SheetNames = async (
 queryClient: QueryClient, sheetId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivityBankControllerGetSimplify2026Sem2SheetNamesQueryKey(sheetId) }, options);

  return queryClient;
}

export const useSetActivityBankControllerGetSimplify2026Sem2SheetNamesQueryData = () => {
  const queryClient = useQueryClient();
  return (sheetId: string,updater: Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2SheetNames>> | undefined | ((old: Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2SheetNames>> | undefined) => Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2SheetNames>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2SheetNames>>>({ exact: $exactMatch, queryKey: getActivityBankControllerGetSimplify2026Sem2SheetNamesQueryKey(sheetId) }, updater);
  };
}

export const useGetActivityBankControllerGetSimplify2026Sem2SheetNamesQueryData = () => {
  const queryClient = useQueryClient();
  return (sheetId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2SheetNames>>>(getActivityBankControllerGetSimplify2026Sem2SheetNamesQueryKey(sheetId));
}



export const activityBankControllerGetSimplify2026Sem2LessonsFromAllSheets = (
    sheetId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Simplify2026Sem2LessonDto[]>(
      {url: `/activity-banks/simplify-modular-2026-2/google-sheet/sheetId/${sheetId}`, method: 'GET', signal
    },
      options);
    }




export const getActivityBankControllerGetSimplify2026Sem2LessonsFromAllSheetsQueryKey = (sheetId: string,) => {
    return [
    `/activity-banks/simplify-modular-2026-2/google-sheet/sheetId/${sheetId}`
    ] as const;
    }


export const getActivityBankControllerGetSimplify2026Sem2LessonsFromAllSheetsQueryOptions = <TData = Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromAllSheets>>, TError = ErrorType<unknown>>(sheetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromAllSheets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityBankControllerGetSimplify2026Sem2LessonsFromAllSheetsQueryKey(sheetId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromAllSheets>>> = ({ signal }) => activityBankControllerGetSimplify2026Sem2LessonsFromAllSheets(sheetId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: sheetId !== null && sheetId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromAllSheets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivityBankControllerGetSimplify2026Sem2LessonsFromAllSheetsQueryResult = NonNullable<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromAllSheets>>>
export type ActivityBankControllerGetSimplify2026Sem2LessonsFromAllSheetsQueryError = ErrorType<unknown>


export function useActivityBankControllerGetSimplify2026Sem2LessonsFromAllSheets<TData = Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromAllSheets>>, TError = ErrorType<unknown>>(
 sheetId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromAllSheets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromAllSheets>>,
          TError,
          Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromAllSheets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityBankControllerGetSimplify2026Sem2LessonsFromAllSheets<TData = Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromAllSheets>>, TError = ErrorType<unknown>>(
 sheetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromAllSheets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromAllSheets>>,
          TError,
          Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromAllSheets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityBankControllerGetSimplify2026Sem2LessonsFromAllSheets<TData = Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromAllSheets>>, TError = ErrorType<unknown>>(
 sheetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromAllSheets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivityBankControllerGetSimplify2026Sem2LessonsFromAllSheets<TData = Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromAllSheets>>, TError = ErrorType<unknown>>(
 sheetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromAllSheets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivityBankControllerGetSimplify2026Sem2LessonsFromAllSheetsQueryOptions(sheetId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivityBankControllerGetSimplify2026Sem2LessonsFromAllSheets} query
 */
export const invalidateActivityBankControllerGetSimplify2026Sem2LessonsFromAllSheets = async (
 queryClient: QueryClient, sheetId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivityBankControllerGetSimplify2026Sem2LessonsFromAllSheetsQueryKey(sheetId) }, options);

  return queryClient;
}

export const useSetActivityBankControllerGetSimplify2026Sem2LessonsFromAllSheetsQueryData = () => {
  const queryClient = useQueryClient();
  return (sheetId: string,updater: Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromAllSheets>> | undefined | ((old: Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromAllSheets>> | undefined) => Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromAllSheets>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromAllSheets>>>({ exact: $exactMatch, queryKey: getActivityBankControllerGetSimplify2026Sem2LessonsFromAllSheetsQueryKey(sheetId) }, updater);
  };
}

export const useGetActivityBankControllerGetSimplify2026Sem2LessonsFromAllSheetsQueryData = () => {
  const queryClient = useQueryClient();
  return (sheetId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromAllSheets>>>(getActivityBankControllerGetSimplify2026Sem2LessonsFromAllSheetsQueryKey(sheetId));
}



export const activityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet = (
    sheetId: string,
    sheetName: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Simplify2026Sem2LessonDto[]>(
      {url: `/activity-banks/simplify-modular-2026-2/google-sheet/sheetId/${sheetId}/sheetName/${sheetName}`, method: 'GET', signal
    },
      options);
    }




export const getActivityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheetQueryKey = (sheetId: string,
    sheetName: string,) => {
    return [
    `/activity-banks/simplify-modular-2026-2/google-sheet/sheetId/${sheetId}/sheetName/${sheetName}`
    ] as const;
    }


export const getActivityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheetQueryOptions = <TData = Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet>>, TError = ErrorType<unknown>>(sheetId: string,
    sheetName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheetQueryKey(sheetId,sheetName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet>>> = ({ signal }) => activityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet(sheetId,sheetName, requestOptions, signal);





   return  { queryKey, queryFn, enabled: sheetId !== null && sheetId !== undefined && sheetName !== null && sheetName !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheetQueryResult = NonNullable<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet>>>
export type ActivityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheetQueryError = ErrorType<unknown>


export function useActivityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet<TData = Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet>>, TError = ErrorType<unknown>>(
 sheetId: string,
    sheetName: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet>>,
          TError,
          Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet<TData = Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet>>, TError = ErrorType<unknown>>(
 sheetId: string,
    sheetName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet>>,
          TError,
          Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet<TData = Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet>>, TError = ErrorType<unknown>>(
 sheetId: string,
    sheetName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet<TData = Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet>>, TError = ErrorType<unknown>>(
 sheetId: string,
    sheetName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheetQueryOptions(sheetId,sheetName,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet} query
 */
export const invalidateActivityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet = async (
 queryClient: QueryClient, sheetId: string,
    sheetName: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheetQueryKey(sheetId,sheetName) }, options);

  return queryClient;
}

export const useSetActivityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheetQueryData = () => {
  const queryClient = useQueryClient();
  return (sheetId: string,
    sheetName: string,updater: Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet>> | undefined | ((old: Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet>> | undefined) => Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet>>>({ exact: $exactMatch, queryKey: getActivityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheetQueryKey(sheetId,sheetName) }, updater);
  };
}

export const useGetActivityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheetQueryData = () => {
  const queryClient = useQueryClient();
  return (sheetId: string,
    sheetName: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheet>>>(getActivityBankControllerGetSimplify2026Sem2LessonsFromGoogleSheetQueryKey(sheetId,sheetName));
}



export const activityBankControllerValidateSimplify2026Sem2Lesson = (
    simplify2026Sem2LessonDto: BodyType<Simplify2026Sem2LessonDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ValidateLessonResponseDto>(
      {url: `/activity-banks/simplify-modular-2026-2/validate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: simplify2026Sem2LessonDto, signal
    },
      options);
    }




export const getActivityBankControllerValidateSimplify2026Sem2LessonMutationKey = () => ['activityBankControllerValidateSimplify2026Sem2Lesson'] as const;

export const getActivityBankControllerValidateSimplify2026Sem2LessonMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityBankControllerValidateSimplify2026Sem2Lesson>>, TError,ActivityBankControllerValidateSimplify2026Sem2LessonMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activityBankControllerValidateSimplify2026Sem2Lesson>>, TError,ActivityBankControllerValidateSimplify2026Sem2LessonMutationVariables, TContext> => {

const mutationKey = getActivityBankControllerValidateSimplify2026Sem2LessonMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activityBankControllerValidateSimplify2026Sem2Lesson>>, ActivityBankControllerValidateSimplify2026Sem2LessonMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  activityBankControllerValidateSimplify2026Sem2Lesson(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivityBankControllerValidateSimplify2026Sem2LessonMutationResult = NonNullable<Awaited<ReturnType<typeof activityBankControllerValidateSimplify2026Sem2Lesson>>>
    export type ActivityBankControllerValidateSimplify2026Sem2LessonMutationBody = BodyType<Simplify2026Sem2LessonDto>
    export type ActivityBankControllerValidateSimplify2026Sem2LessonMutationError = ErrorType<unknown>
    export type ActivityBankControllerValidateSimplify2026Sem2LessonMutationVariables = {data: BodyType<Simplify2026Sem2LessonDto>}

    export const useActivityBankControllerValidateSimplify2026Sem2Lesson = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityBankControllerValidateSimplify2026Sem2Lesson>>, TError,ActivityBankControllerValidateSimplify2026Sem2LessonMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activityBankControllerValidateSimplify2026Sem2Lesson>>,
        TError,
        ActivityBankControllerValidateSimplify2026Sem2LessonMutationVariables,
        TContext
      > => {
      return useMutation(getActivityBankControllerValidateSimplify2026Sem2LessonMutationOptions(options), queryClient);
    }

export const activityBankControllerConvertSimplify2026Sem2 = (
    simplify2026Sem2LessonDto: BodyType<Simplify2026Sem2LessonDto[]>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CreateLessonAndActivitiesDto[]>(
      {url: `/activity-banks/simplify-modular-2026-2/convert`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: simplify2026Sem2LessonDto, signal
    },
      options);
    }




export const getActivityBankControllerConvertSimplify2026Sem2MutationKey = () => ['activityBankControllerConvertSimplify2026Sem2'] as const;

export const getActivityBankControllerConvertSimplify2026Sem2MutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityBankControllerConvertSimplify2026Sem2>>, TError,ActivityBankControllerConvertSimplify2026Sem2MutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activityBankControllerConvertSimplify2026Sem2>>, TError,ActivityBankControllerConvertSimplify2026Sem2MutationVariables, TContext> => {

const mutationKey = getActivityBankControllerConvertSimplify2026Sem2MutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activityBankControllerConvertSimplify2026Sem2>>, ActivityBankControllerConvertSimplify2026Sem2MutationVariables> = (props) => {
          const {data} = props ?? {};

          return  activityBankControllerConvertSimplify2026Sem2(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivityBankControllerConvertSimplify2026Sem2MutationResult = NonNullable<Awaited<ReturnType<typeof activityBankControllerConvertSimplify2026Sem2>>>
    export type ActivityBankControllerConvertSimplify2026Sem2MutationBody = BodyType<Simplify2026Sem2LessonDto[]>
    export type ActivityBankControllerConvertSimplify2026Sem2MutationError = ErrorType<unknown>
    export type ActivityBankControllerConvertSimplify2026Sem2MutationVariables = {data: BodyType<Simplify2026Sem2LessonDto[]>}

    export const useActivityBankControllerConvertSimplify2026Sem2 = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityBankControllerConvertSimplify2026Sem2>>, TError,ActivityBankControllerConvertSimplify2026Sem2MutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activityBankControllerConvertSimplify2026Sem2>>,
        TError,
        ActivityBankControllerConvertSimplify2026Sem2MutationVariables,
        TContext
      > => {
      return useMutation(getActivityBankControllerConvertSimplify2026Sem2MutationOptions(options), queryClient);
    }

export const activityBankControllerGetSaintGabriel2026SheetNames = (
    sheetId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SimplifyModularSheetNameDto[]>(
      {url: `/activity-banks/simplify-modular-saintgabriel-2026/google-sheet/sheetId/${sheetId}/sheet-names`, method: 'GET', signal
    },
      options);
    }




export const getActivityBankControllerGetSaintGabriel2026SheetNamesQueryKey = (sheetId: string,) => {
    return [
    `/activity-banks/simplify-modular-saintgabriel-2026/google-sheet/sheetId/${sheetId}/sheet-names`
    ] as const;
    }


export const getActivityBankControllerGetSaintGabriel2026SheetNamesQueryOptions = <TData = Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026SheetNames>>, TError = ErrorType<unknown>>(sheetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026SheetNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityBankControllerGetSaintGabriel2026SheetNamesQueryKey(sheetId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026SheetNames>>> = ({ signal }) => activityBankControllerGetSaintGabriel2026SheetNames(sheetId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: sheetId !== null && sheetId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026SheetNames>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivityBankControllerGetSaintGabriel2026SheetNamesQueryResult = NonNullable<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026SheetNames>>>
export type ActivityBankControllerGetSaintGabriel2026SheetNamesQueryError = ErrorType<unknown>


export function useActivityBankControllerGetSaintGabriel2026SheetNames<TData = Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026SheetNames>>, TError = ErrorType<unknown>>(
 sheetId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026SheetNames>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026SheetNames>>,
          TError,
          Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026SheetNames>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityBankControllerGetSaintGabriel2026SheetNames<TData = Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026SheetNames>>, TError = ErrorType<unknown>>(
 sheetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026SheetNames>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026SheetNames>>,
          TError,
          Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026SheetNames>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityBankControllerGetSaintGabriel2026SheetNames<TData = Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026SheetNames>>, TError = ErrorType<unknown>>(
 sheetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026SheetNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivityBankControllerGetSaintGabriel2026SheetNames<TData = Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026SheetNames>>, TError = ErrorType<unknown>>(
 sheetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026SheetNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivityBankControllerGetSaintGabriel2026SheetNamesQueryOptions(sheetId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivityBankControllerGetSaintGabriel2026SheetNames} query
 */
export const invalidateActivityBankControllerGetSaintGabriel2026SheetNames = async (
 queryClient: QueryClient, sheetId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivityBankControllerGetSaintGabriel2026SheetNamesQueryKey(sheetId) }, options);

  return queryClient;
}

export const useSetActivityBankControllerGetSaintGabriel2026SheetNamesQueryData = () => {
  const queryClient = useQueryClient();
  return (sheetId: string,updater: Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026SheetNames>> | undefined | ((old: Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026SheetNames>> | undefined) => Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026SheetNames>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026SheetNames>>>({ exact: $exactMatch, queryKey: getActivityBankControllerGetSaintGabriel2026SheetNamesQueryKey(sheetId) }, updater);
  };
}

export const useGetActivityBankControllerGetSaintGabriel2026SheetNamesQueryData = () => {
  const queryClient = useQueryClient();
  return (sheetId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026SheetNames>>>(getActivityBankControllerGetSaintGabriel2026SheetNamesQueryKey(sheetId));
}



export const activityBankControllerGetSaintGabriel2026LessonsFromAllSheets = (
    sheetId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SaintGabriel2026LessonDto[]>(
      {url: `/activity-banks/simplify-modular-saintgabriel-2026/google-sheet/sheetId/${sheetId}`, method: 'GET', signal
    },
      options);
    }




export const getActivityBankControllerGetSaintGabriel2026LessonsFromAllSheetsQueryKey = (sheetId: string,) => {
    return [
    `/activity-banks/simplify-modular-saintgabriel-2026/google-sheet/sheetId/${sheetId}`
    ] as const;
    }


export const getActivityBankControllerGetSaintGabriel2026LessonsFromAllSheetsQueryOptions = <TData = Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromAllSheets>>, TError = ErrorType<unknown>>(sheetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromAllSheets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityBankControllerGetSaintGabriel2026LessonsFromAllSheetsQueryKey(sheetId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromAllSheets>>> = ({ signal }) => activityBankControllerGetSaintGabriel2026LessonsFromAllSheets(sheetId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: sheetId !== null && sheetId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromAllSheets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivityBankControllerGetSaintGabriel2026LessonsFromAllSheetsQueryResult = NonNullable<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromAllSheets>>>
export type ActivityBankControllerGetSaintGabriel2026LessonsFromAllSheetsQueryError = ErrorType<unknown>


export function useActivityBankControllerGetSaintGabriel2026LessonsFromAllSheets<TData = Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromAllSheets>>, TError = ErrorType<unknown>>(
 sheetId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromAllSheets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromAllSheets>>,
          TError,
          Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromAllSheets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityBankControllerGetSaintGabriel2026LessonsFromAllSheets<TData = Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromAllSheets>>, TError = ErrorType<unknown>>(
 sheetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromAllSheets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromAllSheets>>,
          TError,
          Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromAllSheets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityBankControllerGetSaintGabriel2026LessonsFromAllSheets<TData = Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromAllSheets>>, TError = ErrorType<unknown>>(
 sheetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromAllSheets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivityBankControllerGetSaintGabriel2026LessonsFromAllSheets<TData = Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromAllSheets>>, TError = ErrorType<unknown>>(
 sheetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromAllSheets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivityBankControllerGetSaintGabriel2026LessonsFromAllSheetsQueryOptions(sheetId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivityBankControllerGetSaintGabriel2026LessonsFromAllSheets} query
 */
export const invalidateActivityBankControllerGetSaintGabriel2026LessonsFromAllSheets = async (
 queryClient: QueryClient, sheetId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivityBankControllerGetSaintGabriel2026LessonsFromAllSheetsQueryKey(sheetId) }, options);

  return queryClient;
}

export const useSetActivityBankControllerGetSaintGabriel2026LessonsFromAllSheetsQueryData = () => {
  const queryClient = useQueryClient();
  return (sheetId: string,updater: Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromAllSheets>> | undefined | ((old: Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromAllSheets>> | undefined) => Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromAllSheets>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromAllSheets>>>({ exact: $exactMatch, queryKey: getActivityBankControllerGetSaintGabriel2026LessonsFromAllSheetsQueryKey(sheetId) }, updater);
  };
}

export const useGetActivityBankControllerGetSaintGabriel2026LessonsFromAllSheetsQueryData = () => {
  const queryClient = useQueryClient();
  return (sheetId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromAllSheets>>>(getActivityBankControllerGetSaintGabriel2026LessonsFromAllSheetsQueryKey(sheetId));
}



export const activityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet = (
    sheetId: string,
    sheetName: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SaintGabriel2026LessonDto[]>(
      {url: `/activity-banks/simplify-modular-saintgabriel-2026/google-sheet/sheetId/${sheetId}/sheetName/${sheetName}`, method: 'GET', signal
    },
      options);
    }




export const getActivityBankControllerGetSaintGabriel2026LessonsFromGoogleSheetQueryKey = (sheetId: string,
    sheetName: string,) => {
    return [
    `/activity-banks/simplify-modular-saintgabriel-2026/google-sheet/sheetId/${sheetId}/sheetName/${sheetName}`
    ] as const;
    }


export const getActivityBankControllerGetSaintGabriel2026LessonsFromGoogleSheetQueryOptions = <TData = Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet>>, TError = ErrorType<unknown>>(sheetId: string,
    sheetName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityBankControllerGetSaintGabriel2026LessonsFromGoogleSheetQueryKey(sheetId,sheetName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet>>> = ({ signal }) => activityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet(sheetId,sheetName, requestOptions, signal);





   return  { queryKey, queryFn, enabled: sheetId !== null && sheetId !== undefined && sheetName !== null && sheetName !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivityBankControllerGetSaintGabriel2026LessonsFromGoogleSheetQueryResult = NonNullable<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet>>>
export type ActivityBankControllerGetSaintGabriel2026LessonsFromGoogleSheetQueryError = ErrorType<unknown>


export function useActivityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet<TData = Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet>>, TError = ErrorType<unknown>>(
 sheetId: string,
    sheetName: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet>>,
          TError,
          Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet<TData = Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet>>, TError = ErrorType<unknown>>(
 sheetId: string,
    sheetName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet>>,
          TError,
          Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet<TData = Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet>>, TError = ErrorType<unknown>>(
 sheetId: string,
    sheetName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActivityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet<TData = Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet>>, TError = ErrorType<unknown>>(
 sheetId: string,
    sheetName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivityBankControllerGetSaintGabriel2026LessonsFromGoogleSheetQueryOptions(sheetId,sheetName,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useActivityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet} query
 */
export const invalidateActivityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet = async (
 queryClient: QueryClient, sheetId: string,
    sheetName: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getActivityBankControllerGetSaintGabriel2026LessonsFromGoogleSheetQueryKey(sheetId,sheetName) }, options);

  return queryClient;
}

export const useSetActivityBankControllerGetSaintGabriel2026LessonsFromGoogleSheetQueryData = () => {
  const queryClient = useQueryClient();
  return (sheetId: string,
    sheetName: string,updater: Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet>> | undefined | ((old: Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet>> | undefined) => Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet>>>({ exact: $exactMatch, queryKey: getActivityBankControllerGetSaintGabriel2026LessonsFromGoogleSheetQueryKey(sheetId,sheetName) }, updater);
  };
}

export const useGetActivityBankControllerGetSaintGabriel2026LessonsFromGoogleSheetQueryData = () => {
  const queryClient = useQueryClient();
  return (sheetId: string,
    sheetName: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof activityBankControllerGetSaintGabriel2026LessonsFromGoogleSheet>>>(getActivityBankControllerGetSaintGabriel2026LessonsFromGoogleSheetQueryKey(sheetId,sheetName));
}



export const activityBankControllerConvertSaintGabriel2026 = (
    saintGabriel2026LessonDto: BodyType<SaintGabriel2026LessonDto[]>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CreateLessonAndActivitiesDto[]>(
      {url: `/activity-banks/simplify-modular-saintgabriel-2026/convert`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: saintGabriel2026LessonDto, signal
    },
      options);
    }




export const getActivityBankControllerConvertSaintGabriel2026MutationKey = () => ['activityBankControllerConvertSaintGabriel2026'] as const;

export const getActivityBankControllerConvertSaintGabriel2026MutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityBankControllerConvertSaintGabriel2026>>, TError,ActivityBankControllerConvertSaintGabriel2026MutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activityBankControllerConvertSaintGabriel2026>>, TError,ActivityBankControllerConvertSaintGabriel2026MutationVariables, TContext> => {

const mutationKey = getActivityBankControllerConvertSaintGabriel2026MutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activityBankControllerConvertSaintGabriel2026>>, ActivityBankControllerConvertSaintGabriel2026MutationVariables> = (props) => {
          const {data} = props ?? {};

          return  activityBankControllerConvertSaintGabriel2026(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivityBankControllerConvertSaintGabriel2026MutationResult = NonNullable<Awaited<ReturnType<typeof activityBankControllerConvertSaintGabriel2026>>>
    export type ActivityBankControllerConvertSaintGabriel2026MutationBody = BodyType<SaintGabriel2026LessonDto[]>
    export type ActivityBankControllerConvertSaintGabriel2026MutationError = ErrorType<unknown>
    export type ActivityBankControllerConvertSaintGabriel2026MutationVariables = {data: BodyType<SaintGabriel2026LessonDto[]>}

    export const useActivityBankControllerConvertSaintGabriel2026 = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityBankControllerConvertSaintGabriel2026>>, TError,ActivityBankControllerConvertSaintGabriel2026MutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activityBankControllerConvertSaintGabriel2026>>,
        TError,
        ActivityBankControllerConvertSaintGabriel2026MutationVariables,
        TContext
      > => {
      return useMutation(getActivityBankControllerConvertSaintGabriel2026MutationOptions(options), queryClient);
    }

export const schoolGroupControllerGet = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SchoolGroup[]>(
      {url: `/school-groups`, method: 'GET', signal
    },
      options);
    }




export const getSchoolGroupControllerGetQueryKey = () => {
    return [
    `/school-groups`
    ] as const;
    }


export const getSchoolGroupControllerGetQueryOptions = <TData = Awaited<ReturnType<typeof schoolGroupControllerGet>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSchoolGroupControllerGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof schoolGroupControllerGet>>> = ({ signal }) => schoolGroupControllerGet(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SchoolGroupControllerGetQueryResult = NonNullable<Awaited<ReturnType<typeof schoolGroupControllerGet>>>
export type SchoolGroupControllerGetQueryError = ErrorType<unknown>


export function useSchoolGroupControllerGet<TData = Awaited<ReturnType<typeof schoolGroupControllerGet>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolGroupControllerGet>>,
          TError,
          Awaited<ReturnType<typeof schoolGroupControllerGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolGroupControllerGet<TData = Awaited<ReturnType<typeof schoolGroupControllerGet>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolGroupControllerGet>>,
          TError,
          Awaited<ReturnType<typeof schoolGroupControllerGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolGroupControllerGet<TData = Awaited<ReturnType<typeof schoolGroupControllerGet>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSchoolGroupControllerGet<TData = Awaited<ReturnType<typeof schoolGroupControllerGet>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSchoolGroupControllerGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useSchoolGroupControllerGet} query
 */
export const invalidateSchoolGroupControllerGet = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getSchoolGroupControllerGetQueryKey() }, options);

  return queryClient;
}

export const useSetSchoolGroupControllerGetQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof schoolGroupControllerGet>> | undefined | ((old: Awaited<ReturnType<typeof schoolGroupControllerGet>> | undefined) => Awaited<ReturnType<typeof schoolGroupControllerGet>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof schoolGroupControllerGet>>>({ exact: $exactMatch, queryKey: getSchoolGroupControllerGetQueryKey() }, updater);
  };
}

export const useGetSchoolGroupControllerGetQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof schoolGroupControllerGet>>>(getSchoolGroupControllerGetQueryKey());
}



export const schoolGroupControllerCreate = (
    createSchoolGroupDto: BodyType<CreateSchoolGroupDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/school-groups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSchoolGroupDto, signal
    },
      options);
    }




export const getSchoolGroupControllerCreateMutationKey = () => ['schoolGroupControllerCreate'] as const;

export const getSchoolGroupControllerCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof schoolGroupControllerCreate>>, TError,SchoolGroupControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof schoolGroupControllerCreate>>, TError,SchoolGroupControllerCreateMutationVariables, TContext> => {

const mutationKey = getSchoolGroupControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof schoolGroupControllerCreate>>, SchoolGroupControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  schoolGroupControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SchoolGroupControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof schoolGroupControllerCreate>>>
    export type SchoolGroupControllerCreateMutationBody = BodyType<CreateSchoolGroupDto>
    export type SchoolGroupControllerCreateMutationError = ErrorType<unknown>
    export type SchoolGroupControllerCreateMutationVariables = {data: BodyType<CreateSchoolGroupDto>}

    export const useSchoolGroupControllerCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof schoolGroupControllerCreate>>, TError,SchoolGroupControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof schoolGroupControllerCreate>>,
        TError,
        SchoolGroupControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSchoolGroupControllerCreateMutationOptions(options), queryClient);
    }

export const schoolGroupControllerGetUserActivityInstances = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/school-groups/me`, method: 'GET', signal
    },
      options);
    }




export const getSchoolGroupControllerGetUserActivityInstancesQueryKey = () => {
    return [
    `/school-groups/me`
    ] as const;
    }


export const getSchoolGroupControllerGetUserActivityInstancesQueryOptions = <TData = Awaited<ReturnType<typeof schoolGroupControllerGetUserActivityInstances>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetUserActivityInstances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSchoolGroupControllerGetUserActivityInstancesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof schoolGroupControllerGetUserActivityInstances>>> = ({ signal }) => schoolGroupControllerGetUserActivityInstances(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetUserActivityInstances>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SchoolGroupControllerGetUserActivityInstancesQueryResult = NonNullable<Awaited<ReturnType<typeof schoolGroupControllerGetUserActivityInstances>>>
export type SchoolGroupControllerGetUserActivityInstancesQueryError = ErrorType<unknown>


export function useSchoolGroupControllerGetUserActivityInstances<TData = Awaited<ReturnType<typeof schoolGroupControllerGetUserActivityInstances>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetUserActivityInstances>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolGroupControllerGetUserActivityInstances>>,
          TError,
          Awaited<ReturnType<typeof schoolGroupControllerGetUserActivityInstances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolGroupControllerGetUserActivityInstances<TData = Awaited<ReturnType<typeof schoolGroupControllerGetUserActivityInstances>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetUserActivityInstances>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolGroupControllerGetUserActivityInstances>>,
          TError,
          Awaited<ReturnType<typeof schoolGroupControllerGetUserActivityInstances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolGroupControllerGetUserActivityInstances<TData = Awaited<ReturnType<typeof schoolGroupControllerGetUserActivityInstances>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetUserActivityInstances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSchoolGroupControllerGetUserActivityInstances<TData = Awaited<ReturnType<typeof schoolGroupControllerGetUserActivityInstances>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetUserActivityInstances>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSchoolGroupControllerGetUserActivityInstancesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useSchoolGroupControllerGetUserActivityInstances} query
 */
export const invalidateSchoolGroupControllerGetUserActivityInstances = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getSchoolGroupControllerGetUserActivityInstancesQueryKey() }, options);

  return queryClient;
}

export const useSetSchoolGroupControllerGetUserActivityInstancesQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof schoolGroupControllerGetUserActivityInstances>> | undefined | ((old: Awaited<ReturnType<typeof schoolGroupControllerGetUserActivityInstances>> | undefined) => Awaited<ReturnType<typeof schoolGroupControllerGetUserActivityInstances>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof schoolGroupControllerGetUserActivityInstances>>>({ exact: $exactMatch, queryKey: getSchoolGroupControllerGetUserActivityInstancesQueryKey() }, updater);
  };
}

export const useGetSchoolGroupControllerGetUserActivityInstancesQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof schoolGroupControllerGetUserActivityInstances>>>(getSchoolGroupControllerGetUserActivityInstancesQueryKey());
}



export const schoolGroupControllerGetUserInSchoolGroup = (
    params?: SchoolGroupControllerGetUserInSchoolGroupParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/school-groups/user`, method: 'GET',
        params, signal
    },
      options);
    }




export const getSchoolGroupControllerGetUserInSchoolGroupQueryKey = (params?: SchoolGroupControllerGetUserInSchoolGroupParams,) => {
    return [
    `/school-groups/user`, ...(params ? [params] : [])
    ] as const;
    }


export const getSchoolGroupControllerGetUserInSchoolGroupQueryOptions = <TData = Awaited<ReturnType<typeof schoolGroupControllerGetUserInSchoolGroup>>, TError = ErrorType<unknown>>(params?: SchoolGroupControllerGetUserInSchoolGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetUserInSchoolGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSchoolGroupControllerGetUserInSchoolGroupQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof schoolGroupControllerGetUserInSchoolGroup>>> = ({ signal }) => schoolGroupControllerGetUserInSchoolGroup(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetUserInSchoolGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SchoolGroupControllerGetUserInSchoolGroupQueryResult = NonNullable<Awaited<ReturnType<typeof schoolGroupControllerGetUserInSchoolGroup>>>
export type SchoolGroupControllerGetUserInSchoolGroupQueryError = ErrorType<unknown>


export function useSchoolGroupControllerGetUserInSchoolGroup<TData = Awaited<ReturnType<typeof schoolGroupControllerGetUserInSchoolGroup>>, TError = ErrorType<unknown>>(
 params: undefined |  SchoolGroupControllerGetUserInSchoolGroupParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetUserInSchoolGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolGroupControllerGetUserInSchoolGroup>>,
          TError,
          Awaited<ReturnType<typeof schoolGroupControllerGetUserInSchoolGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolGroupControllerGetUserInSchoolGroup<TData = Awaited<ReturnType<typeof schoolGroupControllerGetUserInSchoolGroup>>, TError = ErrorType<unknown>>(
 params?: SchoolGroupControllerGetUserInSchoolGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetUserInSchoolGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolGroupControllerGetUserInSchoolGroup>>,
          TError,
          Awaited<ReturnType<typeof schoolGroupControllerGetUserInSchoolGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolGroupControllerGetUserInSchoolGroup<TData = Awaited<ReturnType<typeof schoolGroupControllerGetUserInSchoolGroup>>, TError = ErrorType<unknown>>(
 params?: SchoolGroupControllerGetUserInSchoolGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetUserInSchoolGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSchoolGroupControllerGetUserInSchoolGroup<TData = Awaited<ReturnType<typeof schoolGroupControllerGetUserInSchoolGroup>>, TError = ErrorType<unknown>>(
 params?: SchoolGroupControllerGetUserInSchoolGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetUserInSchoolGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSchoolGroupControllerGetUserInSchoolGroupQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useSchoolGroupControllerGetUserInSchoolGroup} query
 */
export const invalidateSchoolGroupControllerGetUserInSchoolGroup = async (
 queryClient: QueryClient, params?: SchoolGroupControllerGetUserInSchoolGroupParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getSchoolGroupControllerGetUserInSchoolGroupQueryKey(params) }, options);

  return queryClient;
}

export const useSetSchoolGroupControllerGetUserInSchoolGroupQueryData = () => {
  const queryClient = useQueryClient();
  return (params: SchoolGroupControllerGetUserInSchoolGroupParams | undefined,updater: Awaited<ReturnType<typeof schoolGroupControllerGetUserInSchoolGroup>> | undefined | ((old: Awaited<ReturnType<typeof schoolGroupControllerGetUserInSchoolGroup>> | undefined) => Awaited<ReturnType<typeof schoolGroupControllerGetUserInSchoolGroup>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof schoolGroupControllerGetUserInSchoolGroup>>>({ exact: $exactMatch, queryKey: getSchoolGroupControllerGetUserInSchoolGroupQueryKey(params) }, updater);
  };
}

export const useGetSchoolGroupControllerGetUserInSchoolGroupQueryData = () => {
  const queryClient = useQueryClient();
  return (params?: SchoolGroupControllerGetUserInSchoolGroupParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof schoolGroupControllerGetUserInSchoolGroup>>>(getSchoolGroupControllerGetUserInSchoolGroupQueryKey(params));
}



export const schoolGroupControllerGetSchoolWithClassroomInSchoolGroup = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/school-groups/school-with-classroom`, method: 'GET', signal
    },
      options);
    }




export const getSchoolGroupControllerGetSchoolWithClassroomInSchoolGroupQueryKey = () => {
    return [
    `/school-groups/school-with-classroom`
    ] as const;
    }


export const getSchoolGroupControllerGetSchoolWithClassroomInSchoolGroupQueryOptions = <TData = Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomInSchoolGroup>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomInSchoolGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSchoolGroupControllerGetSchoolWithClassroomInSchoolGroupQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomInSchoolGroup>>> = ({ signal }) => schoolGroupControllerGetSchoolWithClassroomInSchoolGroup(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomInSchoolGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SchoolGroupControllerGetSchoolWithClassroomInSchoolGroupQueryResult = NonNullable<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomInSchoolGroup>>>
export type SchoolGroupControllerGetSchoolWithClassroomInSchoolGroupQueryError = ErrorType<unknown>


export function useSchoolGroupControllerGetSchoolWithClassroomInSchoolGroup<TData = Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomInSchoolGroup>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomInSchoolGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomInSchoolGroup>>,
          TError,
          Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomInSchoolGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolGroupControllerGetSchoolWithClassroomInSchoolGroup<TData = Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomInSchoolGroup>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomInSchoolGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomInSchoolGroup>>,
          TError,
          Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomInSchoolGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolGroupControllerGetSchoolWithClassroomInSchoolGroup<TData = Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomInSchoolGroup>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomInSchoolGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSchoolGroupControllerGetSchoolWithClassroomInSchoolGroup<TData = Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomInSchoolGroup>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomInSchoolGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSchoolGroupControllerGetSchoolWithClassroomInSchoolGroupQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useSchoolGroupControllerGetSchoolWithClassroomInSchoolGroup} query
 */
export const invalidateSchoolGroupControllerGetSchoolWithClassroomInSchoolGroup = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getSchoolGroupControllerGetSchoolWithClassroomInSchoolGroupQueryKey() }, options);

  return queryClient;
}

export const useSetSchoolGroupControllerGetSchoolWithClassroomInSchoolGroupQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomInSchoolGroup>> | undefined | ((old: Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomInSchoolGroup>> | undefined) => Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomInSchoolGroup>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomInSchoolGroup>>>({ exact: $exactMatch, queryKey: getSchoolGroupControllerGetSchoolWithClassroomInSchoolGroupQueryKey() }, updater);
  };
}

export const useGetSchoolGroupControllerGetSchoolWithClassroomInSchoolGroupQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomInSchoolGroup>>>(getSchoolGroupControllerGetSchoolWithClassroomInSchoolGroupQueryKey());
}



export const schoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/school-groups/classroom-summary`, method: 'GET', signal
    },
      options);
    }




export const getSchoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroupQueryKey = () => {
    return [
    `/school-groups/classroom-summary`
    ] as const;
    }


export const getSchoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroupQueryOptions = <TData = Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSchoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroupQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup>>> = ({ signal }) => schoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SchoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroupQueryResult = NonNullable<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup>>>
export type SchoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroupQueryError = ErrorType<unknown>


export function useSchoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup<TData = Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup>>,
          TError,
          Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup<TData = Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup>>,
          TError,
          Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup<TData = Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSchoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup<TData = Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSchoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroupQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useSchoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup} query
 */
export const invalidateSchoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getSchoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroupQueryKey() }, options);

  return queryClient;
}

export const useSetSchoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroupQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup>> | undefined | ((old: Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup>> | undefined) => Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup>>>({ exact: $exactMatch, queryKey: getSchoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroupQueryKey() }, updater);
  };
}

export const useGetSchoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroupQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroup>>>(getSchoolGroupControllerGetSchoolWithClassroomSummaryInSchoolGroupQueryKey());
}



export const schoolGroupControllerUpdateSchoolGroup = (
    id: string,
    updateSchoolGroupDto: BodyType<UpdateSchoolGroupDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/school-groups/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateSchoolGroupDto, signal
    },
      options);
    }




export const getSchoolGroupControllerUpdateSchoolGroupMutationKey = () => ['schoolGroupControllerUpdateSchoolGroup'] as const;

export const getSchoolGroupControllerUpdateSchoolGroupMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof schoolGroupControllerUpdateSchoolGroup>>, TError,SchoolGroupControllerUpdateSchoolGroupMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof schoolGroupControllerUpdateSchoolGroup>>, TError,SchoolGroupControllerUpdateSchoolGroupMutationVariables, TContext> => {

const mutationKey = getSchoolGroupControllerUpdateSchoolGroupMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof schoolGroupControllerUpdateSchoolGroup>>, SchoolGroupControllerUpdateSchoolGroupMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  schoolGroupControllerUpdateSchoolGroup(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SchoolGroupControllerUpdateSchoolGroupMutationResult = NonNullable<Awaited<ReturnType<typeof schoolGroupControllerUpdateSchoolGroup>>>
    export type SchoolGroupControllerUpdateSchoolGroupMutationBody = BodyType<UpdateSchoolGroupDto>
    export type SchoolGroupControllerUpdateSchoolGroupMutationError = ErrorType<unknown>
    export type SchoolGroupControllerUpdateSchoolGroupMutationVariables = {id: string;data: BodyType<UpdateSchoolGroupDto>}

    export const useSchoolGroupControllerUpdateSchoolGroup = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof schoolGroupControllerUpdateSchoolGroup>>, TError,SchoolGroupControllerUpdateSchoolGroupMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof schoolGroupControllerUpdateSchoolGroup>>,
        TError,
        SchoolGroupControllerUpdateSchoolGroupMutationVariables,
        TContext
      > => {
      return useMutation(getSchoolGroupControllerUpdateSchoolGroupMutationOptions(options), queryClient);
    }

export const schoolGroupControllerGetSchoolGroup = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/school-groups/${id}`, method: 'GET', signal
    },
      options);
    }




export const getSchoolGroupControllerGetSchoolGroupQueryKey = (id: string,) => {
    return [
    `/school-groups/${id}`
    ] as const;
    }


export const getSchoolGroupControllerGetSchoolGroupQueryOptions = <TData = Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroup>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSchoolGroupControllerGetSchoolGroupQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroup>>> = ({ signal }) => schoolGroupControllerGetSchoolGroup(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SchoolGroupControllerGetSchoolGroupQueryResult = NonNullable<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroup>>>
export type SchoolGroupControllerGetSchoolGroupQueryError = ErrorType<unknown>


export function useSchoolGroupControllerGetSchoolGroup<TData = Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroup>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroup>>,
          TError,
          Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolGroupControllerGetSchoolGroup<TData = Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroup>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroup>>,
          TError,
          Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolGroupControllerGetSchoolGroup<TData = Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroup>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSchoolGroupControllerGetSchoolGroup<TData = Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroup>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSchoolGroupControllerGetSchoolGroupQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useSchoolGroupControllerGetSchoolGroup} query
 */
export const invalidateSchoolGroupControllerGetSchoolGroup = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getSchoolGroupControllerGetSchoolGroupQueryKey(id) }, options);

  return queryClient;
}

export const useSetSchoolGroupControllerGetSchoolGroupQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroup>> | undefined | ((old: Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroup>> | undefined) => Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroup>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroup>>>({ exact: $exactMatch, queryKey: getSchoolGroupControllerGetSchoolGroupQueryKey(id) }, updater);
  };
}

export const useGetSchoolGroupControllerGetSchoolGroupQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroup>>>(getSchoolGroupControllerGetSchoolGroupQueryKey(id));
}



export const schoolGroupControllerGetSchoolsInSchoolGroup = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/school-groups/${id}/schools`, method: 'GET', signal
    },
      options);
    }




export const getSchoolGroupControllerGetSchoolsInSchoolGroupQueryKey = (id: string,) => {
    return [
    `/school-groups/${id}/schools`
    ] as const;
    }


export const getSchoolGroupControllerGetSchoolsInSchoolGroupQueryOptions = <TData = Awaited<ReturnType<typeof schoolGroupControllerGetSchoolsInSchoolGroup>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolsInSchoolGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSchoolGroupControllerGetSchoolsInSchoolGroupQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolsInSchoolGroup>>> = ({ signal }) => schoolGroupControllerGetSchoolsInSchoolGroup(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolsInSchoolGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SchoolGroupControllerGetSchoolsInSchoolGroupQueryResult = NonNullable<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolsInSchoolGroup>>>
export type SchoolGroupControllerGetSchoolsInSchoolGroupQueryError = ErrorType<unknown>


export function useSchoolGroupControllerGetSchoolsInSchoolGroup<TData = Awaited<ReturnType<typeof schoolGroupControllerGetSchoolsInSchoolGroup>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolsInSchoolGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolGroupControllerGetSchoolsInSchoolGroup>>,
          TError,
          Awaited<ReturnType<typeof schoolGroupControllerGetSchoolsInSchoolGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolGroupControllerGetSchoolsInSchoolGroup<TData = Awaited<ReturnType<typeof schoolGroupControllerGetSchoolsInSchoolGroup>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolsInSchoolGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolGroupControllerGetSchoolsInSchoolGroup>>,
          TError,
          Awaited<ReturnType<typeof schoolGroupControllerGetSchoolsInSchoolGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolGroupControllerGetSchoolsInSchoolGroup<TData = Awaited<ReturnType<typeof schoolGroupControllerGetSchoolsInSchoolGroup>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolsInSchoolGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSchoolGroupControllerGetSchoolsInSchoolGroup<TData = Awaited<ReturnType<typeof schoolGroupControllerGetSchoolsInSchoolGroup>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolsInSchoolGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSchoolGroupControllerGetSchoolsInSchoolGroupQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useSchoolGroupControllerGetSchoolsInSchoolGroup} query
 */
export const invalidateSchoolGroupControllerGetSchoolsInSchoolGroup = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getSchoolGroupControllerGetSchoolsInSchoolGroupQueryKey(id) }, options);

  return queryClient;
}

export const useSetSchoolGroupControllerGetSchoolsInSchoolGroupQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof schoolGroupControllerGetSchoolsInSchoolGroup>> | undefined | ((old: Awaited<ReturnType<typeof schoolGroupControllerGetSchoolsInSchoolGroup>> | undefined) => Awaited<ReturnType<typeof schoolGroupControllerGetSchoolsInSchoolGroup>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolsInSchoolGroup>>>({ exact: $exactMatch, queryKey: getSchoolGroupControllerGetSchoolsInSchoolGroupQueryKey(id) }, updater);
  };
}

export const useGetSchoolGroupControllerGetSchoolsInSchoolGroupQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolsInSchoolGroup>>>(getSchoolGroupControllerGetSchoolsInSchoolGroupQueryKey(id));
}



export const schoolGroupControllerAddSchoolToSchoolGroup = (
    id: string,
    schoolId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/school-groups/${id}/schools/${schoolId}`, method: 'POST', signal
    },
      options);
    }




export const getSchoolGroupControllerAddSchoolToSchoolGroupMutationKey = () => ['schoolGroupControllerAddSchoolToSchoolGroup'] as const;

export const getSchoolGroupControllerAddSchoolToSchoolGroupMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof schoolGroupControllerAddSchoolToSchoolGroup>>, TError,SchoolGroupControllerAddSchoolToSchoolGroupMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof schoolGroupControllerAddSchoolToSchoolGroup>>, TError,SchoolGroupControllerAddSchoolToSchoolGroupMutationVariables, TContext> => {

const mutationKey = getSchoolGroupControllerAddSchoolToSchoolGroupMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof schoolGroupControllerAddSchoolToSchoolGroup>>, SchoolGroupControllerAddSchoolToSchoolGroupMutationVariables> = (props) => {
          const {id,schoolId} = props ?? {};

          return  schoolGroupControllerAddSchoolToSchoolGroup(id,schoolId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SchoolGroupControllerAddSchoolToSchoolGroupMutationResult = NonNullable<Awaited<ReturnType<typeof schoolGroupControllerAddSchoolToSchoolGroup>>>

    export type SchoolGroupControllerAddSchoolToSchoolGroupMutationError = ErrorType<unknown>
    export type SchoolGroupControllerAddSchoolToSchoolGroupMutationVariables = {id: string;schoolId: string}

    export const useSchoolGroupControllerAddSchoolToSchoolGroup = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof schoolGroupControllerAddSchoolToSchoolGroup>>, TError,SchoolGroupControllerAddSchoolToSchoolGroupMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof schoolGroupControllerAddSchoolToSchoolGroup>>,
        TError,
        SchoolGroupControllerAddSchoolToSchoolGroupMutationVariables,
        TContext
      > => {
      return useMutation(getSchoolGroupControllerAddSchoolToSchoolGroupMutationOptions(options), queryClient);
    }

export const schoolGroupControllerAddUserToSchoolGroupAdmin = (
    id: string,
    addUserToSchoolGroupAdminDto: BodyType<AddUserToSchoolGroupAdminDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<User>(
      {url: `/school-groups/${id}/user`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addUserToSchoolGroupAdminDto, signal
    },
      options);
    }




export const getSchoolGroupControllerAddUserToSchoolGroupAdminMutationKey = () => ['schoolGroupControllerAddUserToSchoolGroupAdmin'] as const;

export const getSchoolGroupControllerAddUserToSchoolGroupAdminMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof schoolGroupControllerAddUserToSchoolGroupAdmin>>, TError,SchoolGroupControllerAddUserToSchoolGroupAdminMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof schoolGroupControllerAddUserToSchoolGroupAdmin>>, TError,SchoolGroupControllerAddUserToSchoolGroupAdminMutationVariables, TContext> => {

const mutationKey = getSchoolGroupControllerAddUserToSchoolGroupAdminMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof schoolGroupControllerAddUserToSchoolGroupAdmin>>, SchoolGroupControllerAddUserToSchoolGroupAdminMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  schoolGroupControllerAddUserToSchoolGroupAdmin(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SchoolGroupControllerAddUserToSchoolGroupAdminMutationResult = NonNullable<Awaited<ReturnType<typeof schoolGroupControllerAddUserToSchoolGroupAdmin>>>
    export type SchoolGroupControllerAddUserToSchoolGroupAdminMutationBody = BodyType<AddUserToSchoolGroupAdminDto>
    export type SchoolGroupControllerAddUserToSchoolGroupAdminMutationError = ErrorType<unknown>
    export type SchoolGroupControllerAddUserToSchoolGroupAdminMutationVariables = {id: string;data: BodyType<AddUserToSchoolGroupAdminDto>}

    export const useSchoolGroupControllerAddUserToSchoolGroupAdmin = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof schoolGroupControllerAddUserToSchoolGroupAdmin>>, TError,SchoolGroupControllerAddUserToSchoolGroupAdminMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof schoolGroupControllerAddUserToSchoolGroupAdmin>>,
        TError,
        SchoolGroupControllerAddUserToSchoolGroupAdminMutationVariables,
        TContext
      > => {
      return useMutation(getSchoolGroupControllerAddUserToSchoolGroupAdminMutationOptions(options), queryClient);
    }

export const schoolGroupControllerGetSchoolGroupBySchoolId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/school-groups/school/${id}`, method: 'GET', signal
    },
      options);
    }




export const getSchoolGroupControllerGetSchoolGroupBySchoolIdQueryKey = (id: string,) => {
    return [
    `/school-groups/school/${id}`
    ] as const;
    }


export const getSchoolGroupControllerGetSchoolGroupBySchoolIdQueryOptions = <TData = Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroupBySchoolId>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroupBySchoolId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSchoolGroupControllerGetSchoolGroupBySchoolIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroupBySchoolId>>> = ({ signal }) => schoolGroupControllerGetSchoolGroupBySchoolId(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroupBySchoolId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SchoolGroupControllerGetSchoolGroupBySchoolIdQueryResult = NonNullable<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroupBySchoolId>>>
export type SchoolGroupControllerGetSchoolGroupBySchoolIdQueryError = ErrorType<unknown>


export function useSchoolGroupControllerGetSchoolGroupBySchoolId<TData = Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroupBySchoolId>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroupBySchoolId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroupBySchoolId>>,
          TError,
          Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroupBySchoolId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolGroupControllerGetSchoolGroupBySchoolId<TData = Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroupBySchoolId>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroupBySchoolId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroupBySchoolId>>,
          TError,
          Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroupBySchoolId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSchoolGroupControllerGetSchoolGroupBySchoolId<TData = Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroupBySchoolId>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroupBySchoolId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSchoolGroupControllerGetSchoolGroupBySchoolId<TData = Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroupBySchoolId>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroupBySchoolId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSchoolGroupControllerGetSchoolGroupBySchoolIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useSchoolGroupControllerGetSchoolGroupBySchoolId} query
 */
export const invalidateSchoolGroupControllerGetSchoolGroupBySchoolId = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getSchoolGroupControllerGetSchoolGroupBySchoolIdQueryKey(id) }, options);

  return queryClient;
}

export const useSetSchoolGroupControllerGetSchoolGroupBySchoolIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,updater: Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroupBySchoolId>> | undefined | ((old: Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroupBySchoolId>> | undefined) => Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroupBySchoolId>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroupBySchoolId>>>({ exact: $exactMatch, queryKey: getSchoolGroupControllerGetSchoolGroupBySchoolIdQueryKey(id) }, updater);
  };
}

export const useGetSchoolGroupControllerGetSchoolGroupBySchoolIdQueryData = () => {
  const queryClient = useQueryClient();
  return (id: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof schoolGroupControllerGetSchoolGroupBySchoolId>>>(getSchoolGroupControllerGetSchoolGroupBySchoolIdQueryKey(id));
}



/**
 * @summary Nightly tick. Cloud Scheduler mints the OIDC token; audience is this path.
 */
export const pubSubControllerCancelStaleLiveSessions = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CancelStaleLiveSessionsResultDto>(
      {url: `/pubsub/cancel-stale-live-sessions`, method: 'POST', signal
    },
      options);
    }




export const getPubSubControllerCancelStaleLiveSessionsMutationKey = () => ['pubSubControllerCancelStaleLiveSessions'] as const;

export const getPubSubControllerCancelStaleLiveSessionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pubSubControllerCancelStaleLiveSessions>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof pubSubControllerCancelStaleLiveSessions>>, TError,void, TContext> => {

const mutationKey = getPubSubControllerCancelStaleLiveSessionsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pubSubControllerCancelStaleLiveSessions>>, void> = () => {


          return  pubSubControllerCancelStaleLiveSessions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PubSubControllerCancelStaleLiveSessionsMutationResult = NonNullable<Awaited<ReturnType<typeof pubSubControllerCancelStaleLiveSessions>>>

    export type PubSubControllerCancelStaleLiveSessionsMutationError = ErrorType<unknown>


    /**
 * @summary Nightly tick. Cloud Scheduler mints the OIDC token; audience is this path.
 */
export const usePubSubControllerCancelStaleLiveSessions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pubSubControllerCancelStaleLiveSessions>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pubSubControllerCancelStaleLiveSessions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPubSubControllerCancelStaleLiveSessionsMutationOptions(options), queryClient);
    }

export const pubSubControllerReplayViewReconcileOutbox = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/pubsub/replay-view-reconcile-outbox`, method: 'POST', signal
    },
      options);
    }




export const getPubSubControllerReplayViewReconcileOutboxMutationKey = () => ['pubSubControllerReplayViewReconcileOutbox'] as const;

export const getPubSubControllerReplayViewReconcileOutboxMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pubSubControllerReplayViewReconcileOutbox>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof pubSubControllerReplayViewReconcileOutbox>>, TError,void, TContext> => {

const mutationKey = getPubSubControllerReplayViewReconcileOutboxMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pubSubControllerReplayViewReconcileOutbox>>, void> = () => {


          return  pubSubControllerReplayViewReconcileOutbox(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PubSubControllerReplayViewReconcileOutboxMutationResult = NonNullable<Awaited<ReturnType<typeof pubSubControllerReplayViewReconcileOutbox>>>

    export type PubSubControllerReplayViewReconcileOutboxMutationError = ErrorType<unknown>


    export const usePubSubControllerReplayViewReconcileOutbox = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pubSubControllerReplayViewReconcileOutbox>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pubSubControllerReplayViewReconcileOutbox>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPubSubControllerReplayViewReconcileOutboxMutationOptions(options), queryClient);
    }

export const pubSubControllerActivityComplete = (
    pubSubMessageDto: BodyType<PubSubMessageDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/pubsub/activity-complete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pubSubMessageDto, signal
    },
      options);
    }




export const getPubSubControllerActivityCompleteMutationKey = () => ['pubSubControllerActivityComplete'] as const;

export const getPubSubControllerActivityCompleteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pubSubControllerActivityComplete>>, TError,PubSubControllerActivityCompleteMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof pubSubControllerActivityComplete>>, TError,PubSubControllerActivityCompleteMutationVariables, TContext> => {

const mutationKey = getPubSubControllerActivityCompleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pubSubControllerActivityComplete>>, PubSubControllerActivityCompleteMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  pubSubControllerActivityComplete(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PubSubControllerActivityCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof pubSubControllerActivityComplete>>>
    export type PubSubControllerActivityCompleteMutationBody = BodyType<PubSubMessageDto>
    export type PubSubControllerActivityCompleteMutationError = ErrorType<unknown>
    export type PubSubControllerActivityCompleteMutationVariables = {data: BodyType<PubSubMessageDto>}

    export const usePubSubControllerActivityComplete = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pubSubControllerActivityComplete>>, TError,PubSubControllerActivityCompleteMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pubSubControllerActivityComplete>>,
        TError,
        PubSubControllerActivityCompleteMutationVariables,
        TContext
      > => {
      return useMutation(getPubSubControllerActivityCompleteMutationOptions(options), queryClient);
    }

/**
 * @summary Ordered subscription (key `classroomId:activityId`): one completion per key at a time.
 */
export const pubSubControllerActivityCompleteTaskPerformance = (
    pubSubMessageDto: BodyType<PubSubMessageDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/pubsub/activity-complete-task-performance`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pubSubMessageDto, signal
    },
      options);
    }




export const getPubSubControllerActivityCompleteTaskPerformanceMutationKey = () => ['pubSubControllerActivityCompleteTaskPerformance'] as const;

export const getPubSubControllerActivityCompleteTaskPerformanceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pubSubControllerActivityCompleteTaskPerformance>>, TError,PubSubControllerActivityCompleteTaskPerformanceMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof pubSubControllerActivityCompleteTaskPerformance>>, TError,PubSubControllerActivityCompleteTaskPerformanceMutationVariables, TContext> => {

const mutationKey = getPubSubControllerActivityCompleteTaskPerformanceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pubSubControllerActivityCompleteTaskPerformance>>, PubSubControllerActivityCompleteTaskPerformanceMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  pubSubControllerActivityCompleteTaskPerformance(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PubSubControllerActivityCompleteTaskPerformanceMutationResult = NonNullable<Awaited<ReturnType<typeof pubSubControllerActivityCompleteTaskPerformance>>>
    export type PubSubControllerActivityCompleteTaskPerformanceMutationBody = BodyType<PubSubMessageDto>
    export type PubSubControllerActivityCompleteTaskPerformanceMutationError = ErrorType<unknown>
    export type PubSubControllerActivityCompleteTaskPerformanceMutationVariables = {data: BodyType<PubSubMessageDto>}

    /**
 * @summary Ordered subscription (key `classroomId:activityId`): one completion per key at a time.
 */
export const usePubSubControllerActivityCompleteTaskPerformance = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pubSubControllerActivityCompleteTaskPerformance>>, TError,PubSubControllerActivityCompleteTaskPerformanceMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pubSubControllerActivityCompleteTaskPerformance>>,
        TError,
        PubSubControllerActivityCompleteTaskPerformanceMutationVariables,
        TContext
      > => {
      return useMutation(getPubSubControllerActivityCompleteTaskPerformanceMutationOptions(options), queryClient);
    }

export const pubSubControllerPublishTaxonomyTagCalculations = (
    pubSubMessageDto: BodyType<PubSubMessageDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/pubsub/activity-completions/taxonomy-tag-publisher`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pubSubMessageDto, signal
    },
      options);
    }




export const getPubSubControllerPublishTaxonomyTagCalculationsMutationKey = () => ['pubSubControllerPublishTaxonomyTagCalculations'] as const;

export const getPubSubControllerPublishTaxonomyTagCalculationsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pubSubControllerPublishTaxonomyTagCalculations>>, TError,PubSubControllerPublishTaxonomyTagCalculationsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof pubSubControllerPublishTaxonomyTagCalculations>>, TError,PubSubControllerPublishTaxonomyTagCalculationsMutationVariables, TContext> => {

const mutationKey = getPubSubControllerPublishTaxonomyTagCalculationsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pubSubControllerPublishTaxonomyTagCalculations>>, PubSubControllerPublishTaxonomyTagCalculationsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  pubSubControllerPublishTaxonomyTagCalculations(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PubSubControllerPublishTaxonomyTagCalculationsMutationResult = NonNullable<Awaited<ReturnType<typeof pubSubControllerPublishTaxonomyTagCalculations>>>
    export type PubSubControllerPublishTaxonomyTagCalculationsMutationBody = BodyType<PubSubMessageDto>
    export type PubSubControllerPublishTaxonomyTagCalculationsMutationError = ErrorType<unknown>
    export type PubSubControllerPublishTaxonomyTagCalculationsMutationVariables = {data: BodyType<PubSubMessageDto>}

    export const usePubSubControllerPublishTaxonomyTagCalculations = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pubSubControllerPublishTaxonomyTagCalculations>>, TError,PubSubControllerPublishTaxonomyTagCalculationsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pubSubControllerPublishTaxonomyTagCalculations>>,
        TError,
        PubSubControllerPublishTaxonomyTagCalculationsMutationVariables,
        TContext
      > => {
      return useMutation(getPubSubControllerPublishTaxonomyTagCalculationsMutationOptions(options), queryClient);
    }

export const pubSubControllerApplyTaxonomyTagCalculated = (
    pubSubMessageDto: BodyType<PubSubMessageDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/pubsub/taxonomy-tag-calculations/progress-writer`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pubSubMessageDto, signal
    },
      options);
    }




export const getPubSubControllerApplyTaxonomyTagCalculatedMutationKey = () => ['pubSubControllerApplyTaxonomyTagCalculated'] as const;

export const getPubSubControllerApplyTaxonomyTagCalculatedMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pubSubControllerApplyTaxonomyTagCalculated>>, TError,PubSubControllerApplyTaxonomyTagCalculatedMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof pubSubControllerApplyTaxonomyTagCalculated>>, TError,PubSubControllerApplyTaxonomyTagCalculatedMutationVariables, TContext> => {

const mutationKey = getPubSubControllerApplyTaxonomyTagCalculatedMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pubSubControllerApplyTaxonomyTagCalculated>>, PubSubControllerApplyTaxonomyTagCalculatedMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  pubSubControllerApplyTaxonomyTagCalculated(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PubSubControllerApplyTaxonomyTagCalculatedMutationResult = NonNullable<Awaited<ReturnType<typeof pubSubControllerApplyTaxonomyTagCalculated>>>
    export type PubSubControllerApplyTaxonomyTagCalculatedMutationBody = BodyType<PubSubMessageDto>
    export type PubSubControllerApplyTaxonomyTagCalculatedMutationError = ErrorType<unknown>
    export type PubSubControllerApplyTaxonomyTagCalculatedMutationVariables = {data: BodyType<PubSubMessageDto>}

    export const usePubSubControllerApplyTaxonomyTagCalculated = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pubSubControllerApplyTaxonomyTagCalculated>>, TError,PubSubControllerApplyTaxonomyTagCalculatedMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pubSubControllerApplyTaxonomyTagCalculated>>,
        TError,
        PubSubControllerApplyTaxonomyTagCalculatedMutationVariables,
        TContext
      > => {
      return useMutation(getPubSubControllerApplyTaxonomyTagCalculatedMutationOptions(options), queryClient);
    }

export const pubSubControllerVocabSenseEmbed = (
    pubSubMessageDto: BodyType<PubSubMessageDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/pubsub/vocab-sense-embed`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pubSubMessageDto, signal
    },
      options);
    }




export const getPubSubControllerVocabSenseEmbedMutationKey = () => ['pubSubControllerVocabSenseEmbed'] as const;

export const getPubSubControllerVocabSenseEmbedMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pubSubControllerVocabSenseEmbed>>, TError,PubSubControllerVocabSenseEmbedMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof pubSubControllerVocabSenseEmbed>>, TError,PubSubControllerVocabSenseEmbedMutationVariables, TContext> => {

const mutationKey = getPubSubControllerVocabSenseEmbedMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pubSubControllerVocabSenseEmbed>>, PubSubControllerVocabSenseEmbedMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  pubSubControllerVocabSenseEmbed(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PubSubControllerVocabSenseEmbedMutationResult = NonNullable<Awaited<ReturnType<typeof pubSubControllerVocabSenseEmbed>>>
    export type PubSubControllerVocabSenseEmbedMutationBody = BodyType<PubSubMessageDto>
    export type PubSubControllerVocabSenseEmbedMutationError = ErrorType<unknown>
    export type PubSubControllerVocabSenseEmbedMutationVariables = {data: BodyType<PubSubMessageDto>}

    export const usePubSubControllerVocabSenseEmbed = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pubSubControllerVocabSenseEmbed>>, TError,PubSubControllerVocabSenseEmbedMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pubSubControllerVocabSenseEmbed>>,
        TError,
        PubSubControllerVocabSenseEmbedMutationVariables,
        TContext
      > => {
      return useMutation(getPubSubControllerVocabSenseEmbedMutationOptions(options), queryClient);
    }

export const viewClassroomLessonStatusByUserControllerFind = (
    params: ViewClassroomLessonStatusByUserControllerFindParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ViewClassroomLessonStatusByUserV2[]>(
      {url: `/view-collection/view-classroom-lesson-status-by-user`, method: 'GET',
        params, signal
    },
      options);
    }




export const getViewClassroomLessonStatusByUserControllerFindQueryKey = (params?: ViewClassroomLessonStatusByUserControllerFindParams,) => {
    return [
    `/view-collection/view-classroom-lesson-status-by-user`, ...(params ? [params] : [])
    ] as const;
    }


export const getViewClassroomLessonStatusByUserControllerFindQueryOptions = <TData = Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerFind>>, TError = ErrorType<unknown>>(params: ViewClassroomLessonStatusByUserControllerFindParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerFind>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getViewClassroomLessonStatusByUserControllerFindQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerFind>>> = ({ signal }) => viewClassroomLessonStatusByUserControllerFind(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerFind>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ViewClassroomLessonStatusByUserControllerFindQueryResult = NonNullable<Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerFind>>>
export type ViewClassroomLessonStatusByUserControllerFindQueryError = ErrorType<unknown>


export function useViewClassroomLessonStatusByUserControllerFind<TData = Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerFind>>, TError = ErrorType<unknown>>(
 params: ViewClassroomLessonStatusByUserControllerFindParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerFind>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerFind>>,
          TError,
          Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerFind>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useViewClassroomLessonStatusByUserControllerFind<TData = Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerFind>>, TError = ErrorType<unknown>>(
 params: ViewClassroomLessonStatusByUserControllerFindParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerFind>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerFind>>,
          TError,
          Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerFind>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useViewClassroomLessonStatusByUserControllerFind<TData = Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerFind>>, TError = ErrorType<unknown>>(
 params: ViewClassroomLessonStatusByUserControllerFindParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerFind>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useViewClassroomLessonStatusByUserControllerFind<TData = Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerFind>>, TError = ErrorType<unknown>>(
 params: ViewClassroomLessonStatusByUserControllerFindParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerFind>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getViewClassroomLessonStatusByUserControllerFindQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useViewClassroomLessonStatusByUserControllerFind} query
 */
export const invalidateViewClassroomLessonStatusByUserControllerFind = async (
 queryClient: QueryClient, params: ViewClassroomLessonStatusByUserControllerFindParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getViewClassroomLessonStatusByUserControllerFindQueryKey(params) }, options);

  return queryClient;
}

export const useSetViewClassroomLessonStatusByUserControllerFindQueryData = () => {
  const queryClient = useQueryClient();
  return (params: ViewClassroomLessonStatusByUserControllerFindParams | undefined,updater: Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerFind>> | undefined | ((old: Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerFind>> | undefined) => Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerFind>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerFind>>>({ exact: $exactMatch, queryKey: getViewClassroomLessonStatusByUserControllerFindQueryKey(params) }, updater);
  };
}

export const useGetViewClassroomLessonStatusByUserControllerFindQueryData = () => {
  const queryClient = useQueryClient();
  return (params: ViewClassroomLessonStatusByUserControllerFindParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerFind>>>(getViewClassroomLessonStatusByUserControllerFindQueryKey(params));
}



export const viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2 = (
    params: ViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2Params,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/view-collection/view-classroom-lesson-status-by-user/refresh-v2`, method: 'GET',
        params, signal
    },
      options);
    }




export const getViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2QueryKey = (params?: ViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2Params,) => {
    return [
    `/view-collection/view-classroom-lesson-status-by-user/refresh-v2`, ...(params ? [params] : [])
    ] as const;
    }


export const getViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2QueryOptions = <TData = Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2>>, TError = ErrorType<unknown>>(params: ViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2>>> = ({ signal }) => viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2QueryResult = NonNullable<Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2>>>
export type ViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2QueryError = ErrorType<unknown>


export function useViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2<TData = Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2>>, TError = ErrorType<unknown>>(
 params: ViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2>>,
          TError,
          Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2<TData = Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2>>, TError = ErrorType<unknown>>(
 params: ViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2>>,
          TError,
          Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2<TData = Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2>>, TError = ErrorType<unknown>>(
 params: ViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2<TData = Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2>>, TError = ErrorType<unknown>>(
 params: ViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2} query
 */
export const invalidateViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2 = async (
 queryClient: QueryClient, params: ViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2Params, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2QueryKey(params) }, options);

  return queryClient;
}

export const useSetViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2QueryData = () => {
  const queryClient = useQueryClient();
  return (params: ViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2Params | undefined,updater: Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2>> | undefined | ((old: Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2>> | undefined) => Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2>>>({ exact: $exactMatch, queryKey: getViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2QueryKey(params) }, updater);
  };
}

export const useGetViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2QueryData = () => {
  const queryClient = useQueryClient();
  return (params: ViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2Params,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2>>>(getViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2QueryKey(params));
}



export const viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2FromPubSub = (
    pubSubMessageDto: BodyType<PubSubMessageDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2FromPubSub201>(
      {url: `/view-collection/view-classroom-lesson-status-by-user/refresh-v2`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pubSubMessageDto, signal
    },
      options);
    }




export const getViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2FromPubSubMutationKey = () => ['viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2FromPubSub'] as const;

export const getViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2FromPubSubMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2FromPubSub>>, TError,ViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2FromPubSubMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2FromPubSub>>, TError,ViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2FromPubSubMutationVariables, TContext> => {

const mutationKey = getViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2FromPubSubMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2FromPubSub>>, ViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2FromPubSubMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2FromPubSub(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2FromPubSubMutationResult = NonNullable<Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2FromPubSub>>>
    export type ViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2FromPubSubMutationBody = BodyType<PubSubMessageDto>
    export type ViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2FromPubSubMutationError = ErrorType<unknown>
    export type ViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2FromPubSubMutationVariables = {data: BodyType<PubSubMessageDto>}

    export const useViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2FromPubSub = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2FromPubSub>>, TError,ViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2FromPubSubMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof viewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2FromPubSub>>,
        TError,
        ViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2FromPubSubMutationVariables,
        TContext
      > => {
      return useMutation(getViewClassroomLessonStatusByUserControllerRefreshViewClassroomLessonStatusByUserV2FromPubSubMutationOptions(options), queryClient);
    }

/**
 * @summary Search task performance views for a classroom
 */
export const viewTaskPerformanceControllerFind = (
    classroomId: string,
    params?: ViewTaskPerformanceControllerFindParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ViewTaskPerformanceResponseDto>(
      {url: `/view-collection/view-task-performance/classrooms/${classroomId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getViewTaskPerformanceControllerFindQueryKey = (classroomId: string,
    params?: ViewTaskPerformanceControllerFindParams,) => {
    return [
    `/view-collection/view-task-performance/classrooms/${classroomId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getViewTaskPerformanceControllerFindQueryOptions = <TData = Awaited<ReturnType<typeof viewTaskPerformanceControllerFind>>, TError = ErrorType<unknown>>(classroomId: string,
    params?: ViewTaskPerformanceControllerFindParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewTaskPerformanceControllerFind>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getViewTaskPerformanceControllerFindQueryKey(classroomId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof viewTaskPerformanceControllerFind>>> = ({ signal }) => viewTaskPerformanceControllerFind(classroomId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof viewTaskPerformanceControllerFind>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ViewTaskPerformanceControllerFindQueryResult = NonNullable<Awaited<ReturnType<typeof viewTaskPerformanceControllerFind>>>
export type ViewTaskPerformanceControllerFindQueryError = ErrorType<unknown>


export function useViewTaskPerformanceControllerFind<TData = Awaited<ReturnType<typeof viewTaskPerformanceControllerFind>>, TError = ErrorType<unknown>>(
 classroomId: string,
    params: undefined |  ViewTaskPerformanceControllerFindParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewTaskPerformanceControllerFind>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewTaskPerformanceControllerFind>>,
          TError,
          Awaited<ReturnType<typeof viewTaskPerformanceControllerFind>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useViewTaskPerformanceControllerFind<TData = Awaited<ReturnType<typeof viewTaskPerformanceControllerFind>>, TError = ErrorType<unknown>>(
 classroomId: string,
    params?: ViewTaskPerformanceControllerFindParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewTaskPerformanceControllerFind>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewTaskPerformanceControllerFind>>,
          TError,
          Awaited<ReturnType<typeof viewTaskPerformanceControllerFind>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useViewTaskPerformanceControllerFind<TData = Awaited<ReturnType<typeof viewTaskPerformanceControllerFind>>, TError = ErrorType<unknown>>(
 classroomId: string,
    params?: ViewTaskPerformanceControllerFindParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewTaskPerformanceControllerFind>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Search task performance views for a classroom
 */

export function useViewTaskPerformanceControllerFind<TData = Awaited<ReturnType<typeof viewTaskPerformanceControllerFind>>, TError = ErrorType<unknown>>(
 classroomId: string,
    params?: ViewTaskPerformanceControllerFindParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewTaskPerformanceControllerFind>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getViewTaskPerformanceControllerFindQueryOptions(classroomId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useViewTaskPerformanceControllerFind} query
 */
export const invalidateViewTaskPerformanceControllerFind = async (
 queryClient: QueryClient, classroomId: string,
    params?: ViewTaskPerformanceControllerFindParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getViewTaskPerformanceControllerFindQueryKey(classroomId,params) }, options);

  return queryClient;
}

/**
 * @summary Search task performance views for a classroom
 */
export const useSetViewTaskPerformanceControllerFindQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    params: ViewTaskPerformanceControllerFindParams | undefined,updater: Awaited<ReturnType<typeof viewTaskPerformanceControllerFind>> | undefined | ((old: Awaited<ReturnType<typeof viewTaskPerformanceControllerFind>> | undefined) => Awaited<ReturnType<typeof viewTaskPerformanceControllerFind>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof viewTaskPerformanceControllerFind>>>({ exact: $exactMatch, queryKey: getViewTaskPerformanceControllerFindQueryKey(classroomId,params) }, updater);
  };
}

/**
 * @summary Search task performance views for a classroom
 */
export const useGetViewTaskPerformanceControllerFindQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    params?: ViewTaskPerformanceControllerFindParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof viewTaskPerformanceControllerFind>>>(getViewTaskPerformanceControllerFindQueryKey(classroomId,params));
}



/**
 * @summary Get student summaries for a specific task template
 */
export const viewTaskPerformanceControllerGetStudentSummaries = (
    classroomId: string,
    taskTemplateId: string,
    params: ViewTaskPerformanceControllerGetStudentSummariesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TaskPerformanceStudentSummaryDto[]>(
      {url: `/view-collection/view-task-performance/classrooms/${classroomId}/tasks/${taskTemplateId}/students`, method: 'GET',
        params, signal
    },
      options);
    }




export const getViewTaskPerformanceControllerGetStudentSummariesQueryKey = (classroomId: string,
    taskTemplateId: string,
    params?: ViewTaskPerformanceControllerGetStudentSummariesParams,) => {
    return [
    `/view-collection/view-task-performance/classrooms/${classroomId}/tasks/${taskTemplateId}/students`, ...(params ? [params] : [])
    ] as const;
    }


export const getViewTaskPerformanceControllerGetStudentSummariesQueryOptions = <TData = Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentSummaries>>, TError = ErrorType<unknown>>(classroomId: string,
    taskTemplateId: string,
    params: ViewTaskPerformanceControllerGetStudentSummariesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentSummaries>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getViewTaskPerformanceControllerGetStudentSummariesQueryKey(classroomId,taskTemplateId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentSummaries>>> = ({ signal }) => viewTaskPerformanceControllerGetStudentSummaries(classroomId,taskTemplateId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined && taskTemplateId !== null && taskTemplateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentSummaries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ViewTaskPerformanceControllerGetStudentSummariesQueryResult = NonNullable<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentSummaries>>>
export type ViewTaskPerformanceControllerGetStudentSummariesQueryError = ErrorType<unknown>


export function useViewTaskPerformanceControllerGetStudentSummaries<TData = Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentSummaries>>, TError = ErrorType<unknown>>(
 classroomId: string,
    taskTemplateId: string,
    params: ViewTaskPerformanceControllerGetStudentSummariesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentSummaries>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentSummaries>>,
          TError,
          Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentSummaries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useViewTaskPerformanceControllerGetStudentSummaries<TData = Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentSummaries>>, TError = ErrorType<unknown>>(
 classroomId: string,
    taskTemplateId: string,
    params: ViewTaskPerformanceControllerGetStudentSummariesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentSummaries>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentSummaries>>,
          TError,
          Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentSummaries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useViewTaskPerformanceControllerGetStudentSummaries<TData = Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentSummaries>>, TError = ErrorType<unknown>>(
 classroomId: string,
    taskTemplateId: string,
    params: ViewTaskPerformanceControllerGetStudentSummariesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentSummaries>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get student summaries for a specific task template
 */

export function useViewTaskPerformanceControllerGetStudentSummaries<TData = Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentSummaries>>, TError = ErrorType<unknown>>(
 classroomId: string,
    taskTemplateId: string,
    params: ViewTaskPerformanceControllerGetStudentSummariesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentSummaries>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getViewTaskPerformanceControllerGetStudentSummariesQueryOptions(classroomId,taskTemplateId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useViewTaskPerformanceControllerGetStudentSummaries} query
 */
export const invalidateViewTaskPerformanceControllerGetStudentSummaries = async (
 queryClient: QueryClient, classroomId: string,
    taskTemplateId: string,
    params: ViewTaskPerformanceControllerGetStudentSummariesParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getViewTaskPerformanceControllerGetStudentSummariesQueryKey(classroomId,taskTemplateId,params) }, options);

  return queryClient;
}

/**
 * @summary Get student summaries for a specific task template
 */
export const useSetViewTaskPerformanceControllerGetStudentSummariesQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    taskTemplateId: string,
    params: ViewTaskPerformanceControllerGetStudentSummariesParams | undefined,updater: Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentSummaries>> | undefined | ((old: Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentSummaries>> | undefined) => Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentSummaries>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentSummaries>>>({ exact: $exactMatch, queryKey: getViewTaskPerformanceControllerGetStudentSummariesQueryKey(classroomId,taskTemplateId,params) }, updater);
  };
}

/**
 * @summary Get student summaries for a specific task template
 */
export const useGetViewTaskPerformanceControllerGetStudentSummariesQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    taskTemplateId: string,
    params: ViewTaskPerformanceControllerGetStudentSummariesParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentSummaries>>>(getViewTaskPerformanceControllerGetStudentSummariesQueryKey(classroomId,taskTemplateId,params));
}



/**
 * @summary Get student attempt details for a task template
 */
export const viewTaskPerformanceControllerGetStudentAttempts = (
    classroomId: string,
    taskTemplateId: string,
    studentId: string,
    params: ViewTaskPerformanceControllerGetStudentAttemptsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TaskPerformanceAttemptDetailDto[]>(
      {url: `/view-collection/view-task-performance/classrooms/${classroomId}/tasks/${taskTemplateId}/students/${studentId}/attempts`, method: 'GET',
        params, signal
    },
      options);
    }




export const getViewTaskPerformanceControllerGetStudentAttemptsQueryKey = (classroomId: string,
    taskTemplateId: string,
    studentId: string,
    params?: ViewTaskPerformanceControllerGetStudentAttemptsParams,) => {
    return [
    `/view-collection/view-task-performance/classrooms/${classroomId}/tasks/${taskTemplateId}/students/${studentId}/attempts`, ...(params ? [params] : [])
    ] as const;
    }


export const getViewTaskPerformanceControllerGetStudentAttemptsQueryOptions = <TData = Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentAttempts>>, TError = ErrorType<unknown>>(classroomId: string,
    taskTemplateId: string,
    studentId: string,
    params: ViewTaskPerformanceControllerGetStudentAttemptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentAttempts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getViewTaskPerformanceControllerGetStudentAttemptsQueryKey(classroomId,taskTemplateId,studentId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentAttempts>>> = ({ signal }) => viewTaskPerformanceControllerGetStudentAttempts(classroomId,taskTemplateId,studentId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined && taskTemplateId !== null && taskTemplateId !== undefined && studentId !== null && studentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentAttempts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ViewTaskPerformanceControllerGetStudentAttemptsQueryResult = NonNullable<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentAttempts>>>
export type ViewTaskPerformanceControllerGetStudentAttemptsQueryError = ErrorType<unknown>


export function useViewTaskPerformanceControllerGetStudentAttempts<TData = Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentAttempts>>, TError = ErrorType<unknown>>(
 classroomId: string,
    taskTemplateId: string,
    studentId: string,
    params: ViewTaskPerformanceControllerGetStudentAttemptsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentAttempts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentAttempts>>,
          TError,
          Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentAttempts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useViewTaskPerformanceControllerGetStudentAttempts<TData = Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentAttempts>>, TError = ErrorType<unknown>>(
 classroomId: string,
    taskTemplateId: string,
    studentId: string,
    params: ViewTaskPerformanceControllerGetStudentAttemptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentAttempts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentAttempts>>,
          TError,
          Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentAttempts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useViewTaskPerformanceControllerGetStudentAttempts<TData = Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentAttempts>>, TError = ErrorType<unknown>>(
 classroomId: string,
    taskTemplateId: string,
    studentId: string,
    params: ViewTaskPerformanceControllerGetStudentAttemptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentAttempts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get student attempt details for a task template
 */

export function useViewTaskPerformanceControllerGetStudentAttempts<TData = Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentAttempts>>, TError = ErrorType<unknown>>(
 classroomId: string,
    taskTemplateId: string,
    studentId: string,
    params: ViewTaskPerformanceControllerGetStudentAttemptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentAttempts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getViewTaskPerformanceControllerGetStudentAttemptsQueryOptions(classroomId,taskTemplateId,studentId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useViewTaskPerformanceControllerGetStudentAttempts} query
 */
export const invalidateViewTaskPerformanceControllerGetStudentAttempts = async (
 queryClient: QueryClient, classroomId: string,
    taskTemplateId: string,
    studentId: string,
    params: ViewTaskPerformanceControllerGetStudentAttemptsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getViewTaskPerformanceControllerGetStudentAttemptsQueryKey(classroomId,taskTemplateId,studentId,params) }, options);

  return queryClient;
}

/**
 * @summary Get student attempt details for a task template
 */
export const useSetViewTaskPerformanceControllerGetStudentAttemptsQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    taskTemplateId: string,
    studentId: string,
    params: ViewTaskPerformanceControllerGetStudentAttemptsParams | undefined,updater: Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentAttempts>> | undefined | ((old: Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentAttempts>> | undefined) => Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentAttempts>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentAttempts>>>({ exact: $exactMatch, queryKey: getViewTaskPerformanceControllerGetStudentAttemptsQueryKey(classroomId,taskTemplateId,studentId,params) }, updater);
  };
}

/**
 * @summary Get student attempt details for a task template
 */
export const useGetViewTaskPerformanceControllerGetStudentAttemptsQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    taskTemplateId: string,
    studentId: string,
    params: ViewTaskPerformanceControllerGetStudentAttemptsParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetStudentAttempts>>>(getViewTaskPerformanceControllerGetStudentAttemptsQueryKey(classroomId,taskTemplateId,studentId,params));
}



/**
 * @summary Get representative task content for a task template
 */
export const viewTaskPerformanceControllerGetRepresentativeTaskContent = (
    classroomId: string,
    taskTemplateId: string,
    params: ViewTaskPerformanceControllerGetRepresentativeTaskContentParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RepresentativeTaskContentResponseDto>(
      {url: `/view-collection/view-task-performance/classrooms/${classroomId}/tasks/${taskTemplateId}/content`, method: 'GET',
        params, signal
    },
      options);
    }




export const getViewTaskPerformanceControllerGetRepresentativeTaskContentQueryKey = (classroomId: string,
    taskTemplateId: string,
    params?: ViewTaskPerformanceControllerGetRepresentativeTaskContentParams,) => {
    return [
    `/view-collection/view-task-performance/classrooms/${classroomId}/tasks/${taskTemplateId}/content`, ...(params ? [params] : [])
    ] as const;
    }


export const getViewTaskPerformanceControllerGetRepresentativeTaskContentQueryOptions = <TData = Awaited<ReturnType<typeof viewTaskPerformanceControllerGetRepresentativeTaskContent>>, TError = ErrorType<unknown>>(classroomId: string,
    taskTemplateId: string,
    params: ViewTaskPerformanceControllerGetRepresentativeTaskContentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetRepresentativeTaskContent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getViewTaskPerformanceControllerGetRepresentativeTaskContentQueryKey(classroomId,taskTemplateId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetRepresentativeTaskContent>>> = ({ signal }) => viewTaskPerformanceControllerGetRepresentativeTaskContent(classroomId,taskTemplateId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined && taskTemplateId !== null && taskTemplateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetRepresentativeTaskContent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ViewTaskPerformanceControllerGetRepresentativeTaskContentQueryResult = NonNullable<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetRepresentativeTaskContent>>>
export type ViewTaskPerformanceControllerGetRepresentativeTaskContentQueryError = ErrorType<unknown>


export function useViewTaskPerformanceControllerGetRepresentativeTaskContent<TData = Awaited<ReturnType<typeof viewTaskPerformanceControllerGetRepresentativeTaskContent>>, TError = ErrorType<unknown>>(
 classroomId: string,
    taskTemplateId: string,
    params: ViewTaskPerformanceControllerGetRepresentativeTaskContentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetRepresentativeTaskContent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewTaskPerformanceControllerGetRepresentativeTaskContent>>,
          TError,
          Awaited<ReturnType<typeof viewTaskPerformanceControllerGetRepresentativeTaskContent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useViewTaskPerformanceControllerGetRepresentativeTaskContent<TData = Awaited<ReturnType<typeof viewTaskPerformanceControllerGetRepresentativeTaskContent>>, TError = ErrorType<unknown>>(
 classroomId: string,
    taskTemplateId: string,
    params: ViewTaskPerformanceControllerGetRepresentativeTaskContentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetRepresentativeTaskContent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewTaskPerformanceControllerGetRepresentativeTaskContent>>,
          TError,
          Awaited<ReturnType<typeof viewTaskPerformanceControllerGetRepresentativeTaskContent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useViewTaskPerformanceControllerGetRepresentativeTaskContent<TData = Awaited<ReturnType<typeof viewTaskPerformanceControllerGetRepresentativeTaskContent>>, TError = ErrorType<unknown>>(
 classroomId: string,
    taskTemplateId: string,
    params: ViewTaskPerformanceControllerGetRepresentativeTaskContentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetRepresentativeTaskContent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get representative task content for a task template
 */

export function useViewTaskPerformanceControllerGetRepresentativeTaskContent<TData = Awaited<ReturnType<typeof viewTaskPerformanceControllerGetRepresentativeTaskContent>>, TError = ErrorType<unknown>>(
 classroomId: string,
    taskTemplateId: string,
    params: ViewTaskPerformanceControllerGetRepresentativeTaskContentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetRepresentativeTaskContent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getViewTaskPerformanceControllerGetRepresentativeTaskContentQueryOptions(classroomId,taskTemplateId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useViewTaskPerformanceControllerGetRepresentativeTaskContent} query
 */
export const invalidateViewTaskPerformanceControllerGetRepresentativeTaskContent = async (
 queryClient: QueryClient, classroomId: string,
    taskTemplateId: string,
    params: ViewTaskPerformanceControllerGetRepresentativeTaskContentParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getViewTaskPerformanceControllerGetRepresentativeTaskContentQueryKey(classroomId,taskTemplateId,params) }, options);

  return queryClient;
}

/**
 * @summary Get representative task content for a task template
 */
export const useSetViewTaskPerformanceControllerGetRepresentativeTaskContentQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    taskTemplateId: string,
    params: ViewTaskPerformanceControllerGetRepresentativeTaskContentParams | undefined,updater: Awaited<ReturnType<typeof viewTaskPerformanceControllerGetRepresentativeTaskContent>> | undefined | ((old: Awaited<ReturnType<typeof viewTaskPerformanceControllerGetRepresentativeTaskContent>> | undefined) => Awaited<ReturnType<typeof viewTaskPerformanceControllerGetRepresentativeTaskContent>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetRepresentativeTaskContent>>>({ exact: $exactMatch, queryKey: getViewTaskPerformanceControllerGetRepresentativeTaskContentQueryKey(classroomId,taskTemplateId,params) }, updater);
  };
}

/**
 * @summary Get representative task content for a task template
 */
export const useGetViewTaskPerformanceControllerGetRepresentativeTaskContentQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,
    taskTemplateId: string,
    params: ViewTaskPerformanceControllerGetRepresentativeTaskContentParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof viewTaskPerformanceControllerGetRepresentativeTaskContent>>>(getViewTaskPerformanceControllerGetRepresentativeTaskContentQueryKey(classroomId,taskTemplateId,params));
}



/**
 * @summary Trigger view refresh for classroom task performance
 */
export const viewTaskPerformanceControllerRefresh = (
    refreshViewTaskPerformanceDto: BodyType<RefreshViewTaskPerformanceDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/view-collection/view-task-performance/refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: refreshViewTaskPerformanceDto, signal
    },
      options);
    }




export const getViewTaskPerformanceControllerRefreshMutationKey = () => ['viewTaskPerformanceControllerRefresh'] as const;

export const getViewTaskPerformanceControllerRefreshMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof viewTaskPerformanceControllerRefresh>>, TError,ViewTaskPerformanceControllerRefreshMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof viewTaskPerformanceControllerRefresh>>, TError,ViewTaskPerformanceControllerRefreshMutationVariables, TContext> => {

const mutationKey = getViewTaskPerformanceControllerRefreshMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof viewTaskPerformanceControllerRefresh>>, ViewTaskPerformanceControllerRefreshMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  viewTaskPerformanceControllerRefresh(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ViewTaskPerformanceControllerRefreshMutationResult = NonNullable<Awaited<ReturnType<typeof viewTaskPerformanceControllerRefresh>>>
    export type ViewTaskPerformanceControllerRefreshMutationBody = BodyType<RefreshViewTaskPerformanceDto>
    export type ViewTaskPerformanceControllerRefreshMutationError = ErrorType<unknown>
    export type ViewTaskPerformanceControllerRefreshMutationVariables = {data: BodyType<RefreshViewTaskPerformanceDto>}

    /**
 * @summary Trigger view refresh for classroom task performance
 */
export const useViewTaskPerformanceControllerRefresh = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof viewTaskPerformanceControllerRefresh>>, TError,ViewTaskPerformanceControllerRefreshMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof viewTaskPerformanceControllerRefresh>>,
        TError,
        ViewTaskPerformanceControllerRefreshMutationVariables,
        TContext
      > => {
      return useMutation(getViewTaskPerformanceControllerRefreshMutationOptions(options), queryClient);
    }

/**
 * @summary Rebuild taxonomy tag progress views for the classroom from source data
 */
export const taxonomyTagProgressAdminControllerRefreshProgress = (
    classroomId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RefreshTaxonomyTagProgressResponseDto>(
      {url: `/classrooms/${classroomId}/taxonomy-tags/refresh-progress`, method: 'POST', signal
    },
      options);
    }




export const getTaxonomyTagProgressAdminControllerRefreshProgressMutationKey = () => ['taxonomyTagProgressAdminControllerRefreshProgress'] as const;

export const getTaxonomyTagProgressAdminControllerRefreshProgressMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taxonomyTagProgressAdminControllerRefreshProgress>>, TError,TaxonomyTagProgressAdminControllerRefreshProgressMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof taxonomyTagProgressAdminControllerRefreshProgress>>, TError,TaxonomyTagProgressAdminControllerRefreshProgressMutationVariables, TContext> => {

const mutationKey = getTaxonomyTagProgressAdminControllerRefreshProgressMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof taxonomyTagProgressAdminControllerRefreshProgress>>, TaxonomyTagProgressAdminControllerRefreshProgressMutationVariables> = (props) => {
          const {classroomId} = props ?? {};

          return  taxonomyTagProgressAdminControllerRefreshProgress(classroomId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TaxonomyTagProgressAdminControllerRefreshProgressMutationResult = NonNullable<Awaited<ReturnType<typeof taxonomyTagProgressAdminControllerRefreshProgress>>>

    export type TaxonomyTagProgressAdminControllerRefreshProgressMutationError = ErrorType<unknown>
    export type TaxonomyTagProgressAdminControllerRefreshProgressMutationVariables = {classroomId: string}

    /**
 * @summary Rebuild taxonomy tag progress views for the classroom from source data
 */
export const useTaxonomyTagProgressAdminControllerRefreshProgress = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof taxonomyTagProgressAdminControllerRefreshProgress>>, TError,TaxonomyTagProgressAdminControllerRefreshProgressMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof taxonomyTagProgressAdminControllerRefreshProgress>>,
        TError,
        TaxonomyTagProgressAdminControllerRefreshProgressMutationVariables,
        TContext
      > => {
      return useMutation(getTaxonomyTagProgressAdminControllerRefreshProgressMutationOptions(options), queryClient);
    }

export const emailControllerSendWeeklyLessonProgressVsClassroomAvgEmailToClassrooms = (
    sendStudentWeeklyProgressEmailDto: BodyType<SendStudentWeeklyProgressEmailDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/email/student-weekly-progress`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendStudentWeeklyProgressEmailDto, signal
    },
      options);
    }




export const getEmailControllerSendWeeklyLessonProgressVsClassroomAvgEmailToClassroomsMutationKey = () => ['emailControllerSendWeeklyLessonProgressVsClassroomAvgEmailToClassrooms'] as const;

export const getEmailControllerSendWeeklyLessonProgressVsClassroomAvgEmailToClassroomsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof emailControllerSendWeeklyLessonProgressVsClassroomAvgEmailToClassrooms>>, TError,EmailControllerSendWeeklyLessonProgressVsClassroomAvgEmailToClassroomsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof emailControllerSendWeeklyLessonProgressVsClassroomAvgEmailToClassrooms>>, TError,EmailControllerSendWeeklyLessonProgressVsClassroomAvgEmailToClassroomsMutationVariables, TContext> => {

const mutationKey = getEmailControllerSendWeeklyLessonProgressVsClassroomAvgEmailToClassroomsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof emailControllerSendWeeklyLessonProgressVsClassroomAvgEmailToClassrooms>>, EmailControllerSendWeeklyLessonProgressVsClassroomAvgEmailToClassroomsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  emailControllerSendWeeklyLessonProgressVsClassroomAvgEmailToClassrooms(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EmailControllerSendWeeklyLessonProgressVsClassroomAvgEmailToClassroomsMutationResult = NonNullable<Awaited<ReturnType<typeof emailControllerSendWeeklyLessonProgressVsClassroomAvgEmailToClassrooms>>>
    export type EmailControllerSendWeeklyLessonProgressVsClassroomAvgEmailToClassroomsMutationBody = BodyType<SendStudentWeeklyProgressEmailDto>
    export type EmailControllerSendWeeklyLessonProgressVsClassroomAvgEmailToClassroomsMutationError = ErrorType<unknown>
    export type EmailControllerSendWeeklyLessonProgressVsClassroomAvgEmailToClassroomsMutationVariables = {data: BodyType<SendStudentWeeklyProgressEmailDto>}

    export const useEmailControllerSendWeeklyLessonProgressVsClassroomAvgEmailToClassrooms = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof emailControllerSendWeeklyLessonProgressVsClassroomAvgEmailToClassrooms>>, TError,EmailControllerSendWeeklyLessonProgressVsClassroomAvgEmailToClassroomsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof emailControllerSendWeeklyLessonProgressVsClassroomAvgEmailToClassrooms>>,
        TError,
        EmailControllerSendWeeklyLessonProgressVsClassroomAvgEmailToClassroomsMutationVariables,
        TContext
      > => {
      return useMutation(getEmailControllerSendWeeklyLessonProgressVsClassroomAvgEmailToClassroomsMutationOptions(options), queryClient);
    }

/**
 * @summary Get leaderboard for a classroom, sorted by XP
 */
export const leaderboardControllerGetXpLeaderboardByClassroomId = (
    classroomId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UsersLeaderboardDto[]>(
      {url: `/leaderboard/${classroomId}`, method: 'GET', signal
    },
      options);
    }




export const getLeaderboardControllerGetXpLeaderboardByClassroomIdQueryKey = (classroomId: string,) => {
    return [
    `/leaderboard/${classroomId}`
    ] as const;
    }


export const getLeaderboardControllerGetXpLeaderboardByClassroomIdQueryOptions = <TData = Awaited<ReturnType<typeof leaderboardControllerGetXpLeaderboardByClassroomId>>, TError = ErrorType<unknown>>(classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof leaderboardControllerGetXpLeaderboardByClassroomId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLeaderboardControllerGetXpLeaderboardByClassroomIdQueryKey(classroomId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof leaderboardControllerGetXpLeaderboardByClassroomId>>> = ({ signal }) => leaderboardControllerGetXpLeaderboardByClassroomId(classroomId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: classroomId !== null && classroomId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof leaderboardControllerGetXpLeaderboardByClassroomId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LeaderboardControllerGetXpLeaderboardByClassroomIdQueryResult = NonNullable<Awaited<ReturnType<typeof leaderboardControllerGetXpLeaderboardByClassroomId>>>
export type LeaderboardControllerGetXpLeaderboardByClassroomIdQueryError = ErrorType<unknown>


export function useLeaderboardControllerGetXpLeaderboardByClassroomId<TData = Awaited<ReturnType<typeof leaderboardControllerGetXpLeaderboardByClassroomId>>, TError = ErrorType<unknown>>(
 classroomId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof leaderboardControllerGetXpLeaderboardByClassroomId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof leaderboardControllerGetXpLeaderboardByClassroomId>>,
          TError,
          Awaited<ReturnType<typeof leaderboardControllerGetXpLeaderboardByClassroomId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLeaderboardControllerGetXpLeaderboardByClassroomId<TData = Awaited<ReturnType<typeof leaderboardControllerGetXpLeaderboardByClassroomId>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof leaderboardControllerGetXpLeaderboardByClassroomId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof leaderboardControllerGetXpLeaderboardByClassroomId>>,
          TError,
          Awaited<ReturnType<typeof leaderboardControllerGetXpLeaderboardByClassroomId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLeaderboardControllerGetXpLeaderboardByClassroomId<TData = Awaited<ReturnType<typeof leaderboardControllerGetXpLeaderboardByClassroomId>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof leaderboardControllerGetXpLeaderboardByClassroomId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get leaderboard for a classroom, sorted by XP
 */

export function useLeaderboardControllerGetXpLeaderboardByClassroomId<TData = Awaited<ReturnType<typeof leaderboardControllerGetXpLeaderboardByClassroomId>>, TError = ErrorType<unknown>>(
 classroomId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof leaderboardControllerGetXpLeaderboardByClassroomId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLeaderboardControllerGetXpLeaderboardByClassroomIdQueryOptions(classroomId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useLeaderboardControllerGetXpLeaderboardByClassroomId} query
 */
export const invalidateLeaderboardControllerGetXpLeaderboardByClassroomId = async (
 queryClient: QueryClient, classroomId: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getLeaderboardControllerGetXpLeaderboardByClassroomIdQueryKey(classroomId) }, options);

  return queryClient;
}

/**
 * @summary Get leaderboard for a classroom, sorted by XP
 */
export const useSetLeaderboardControllerGetXpLeaderboardByClassroomIdQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,updater: Awaited<ReturnType<typeof leaderboardControllerGetXpLeaderboardByClassroomId>> | undefined | ((old: Awaited<ReturnType<typeof leaderboardControllerGetXpLeaderboardByClassroomId>> | undefined) => Awaited<ReturnType<typeof leaderboardControllerGetXpLeaderboardByClassroomId>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof leaderboardControllerGetXpLeaderboardByClassroomId>>>({ exact: $exactMatch, queryKey: getLeaderboardControllerGetXpLeaderboardByClassroomIdQueryKey(classroomId) }, updater);
  };
}

/**
 * @summary Get leaderboard for a classroom, sorted by XP
 */
export const useGetLeaderboardControllerGetXpLeaderboardByClassroomIdQueryData = () => {
  const queryClient = useQueryClient();
  return (classroomId: string,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof leaderboardControllerGetXpLeaderboardByClassroomId>>>(getLeaderboardControllerGetXpLeaderboardByClassroomIdQueryKey(classroomId));
}



/**
 * @summary Judge whether a mic-test clip is speech or noise (EDSY-1892)
 */
export const testMicControllerCheckNoise = (
    checkNoiseDto: BodyType<CheckNoiseDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {

      const formData = new FormData();
if(checkNoiseDto.file !== undefined) {
 formData.append(`file`, checkNoiseDto.file);
 }

      return customInstance<CheckNoiseResponseDto>(
      {url: `/test-mic/check-noise`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getTestMicControllerCheckNoiseMutationKey = () => ['testMicControllerCheckNoise'] as const;

export const getTestMicControllerCheckNoiseMutationOptions = <TError = ErrorType<void | TestMicErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testMicControllerCheckNoise>>, TError,TestMicControllerCheckNoiseMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof testMicControllerCheckNoise>>, TError,TestMicControllerCheckNoiseMutationVariables, TContext> => {

const mutationKey = getTestMicControllerCheckNoiseMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testMicControllerCheckNoise>>, TestMicControllerCheckNoiseMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  testMicControllerCheckNoise(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestMicControllerCheckNoiseMutationResult = NonNullable<Awaited<ReturnType<typeof testMicControllerCheckNoise>>>
    export type TestMicControllerCheckNoiseMutationBody = BodyType<CheckNoiseDto>
    export type TestMicControllerCheckNoiseMutationError = ErrorType<void | TestMicErrorDto>
    export type TestMicControllerCheckNoiseMutationVariables = {data: BodyType<CheckNoiseDto>}

    /**
 * @summary Judge whether a mic-test clip is speech or noise (EDSY-1892)
 */
export const useTestMicControllerCheckNoise = <TError = ErrorType<void | TestMicErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testMicControllerCheckNoise>>, TError,TestMicControllerCheckNoiseMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testMicControllerCheckNoise>>,
        TError,
        TestMicControllerCheckNoiseMutationVariables,
        TContext
      > => {
      return useMutation(getTestMicControllerCheckNoiseMutationOptions(options), queryClient);
    }

/**
 * @summary Get all active notebook items for the current user by notebook type
 */
export const userNotebookControllerGetItems = (
    notebookType: 'english',
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<(VocabUserEnglishNotebookItem | SentenceUserEnglishNotebookItem)[]>(
      {url: `/user-notebook/${notebookType}/items`, method: 'GET', signal
    },
      options);
    }




export const getUserNotebookControllerGetItemsQueryKey = (notebookType: 'english',) => {
    return [
    `/user-notebook/${notebookType}/items`
    ] as const;
    }


export const getUserNotebookControllerGetItemsQueryOptions = <TData = Awaited<ReturnType<typeof userNotebookControllerGetItems>>, TError = ErrorType<unknown>>(notebookType: 'english', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userNotebookControllerGetItems>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserNotebookControllerGetItemsQueryKey(notebookType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userNotebookControllerGetItems>>> = ({ signal }) => userNotebookControllerGetItems(notebookType, requestOptions, signal);





   return  { queryKey, queryFn, enabled: notebookType !== null && notebookType !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userNotebookControllerGetItems>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserNotebookControllerGetItemsQueryResult = NonNullable<Awaited<ReturnType<typeof userNotebookControllerGetItems>>>
export type UserNotebookControllerGetItemsQueryError = ErrorType<unknown>


export function useUserNotebookControllerGetItems<TData = Awaited<ReturnType<typeof userNotebookControllerGetItems>>, TError = ErrorType<unknown>>(
 notebookType: 'english', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userNotebookControllerGetItems>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userNotebookControllerGetItems>>,
          TError,
          Awaited<ReturnType<typeof userNotebookControllerGetItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserNotebookControllerGetItems<TData = Awaited<ReturnType<typeof userNotebookControllerGetItems>>, TError = ErrorType<unknown>>(
 notebookType: 'english', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userNotebookControllerGetItems>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userNotebookControllerGetItems>>,
          TError,
          Awaited<ReturnType<typeof userNotebookControllerGetItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserNotebookControllerGetItems<TData = Awaited<ReturnType<typeof userNotebookControllerGetItems>>, TError = ErrorType<unknown>>(
 notebookType: 'english', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userNotebookControllerGetItems>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all active notebook items for the current user by notebook type
 */

export function useUserNotebookControllerGetItems<TData = Awaited<ReturnType<typeof userNotebookControllerGetItems>>, TError = ErrorType<unknown>>(
 notebookType: 'english', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userNotebookControllerGetItems>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserNotebookControllerGetItemsQueryOptions(notebookType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useUserNotebookControllerGetItems} query
 */
export const invalidateUserNotebookControllerGetItems = async (
 queryClient: QueryClient, notebookType: 'english', options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getUserNotebookControllerGetItemsQueryKey(notebookType) }, options);

  return queryClient;
}

/**
 * @summary Get all active notebook items for the current user by notebook type
 */
export const useSetUserNotebookControllerGetItemsQueryData = () => {
  const queryClient = useQueryClient();
  return (notebookType: 'english',updater: Awaited<ReturnType<typeof userNotebookControllerGetItems>> | undefined | ((old: Awaited<ReturnType<typeof userNotebookControllerGetItems>> | undefined) => Awaited<ReturnType<typeof userNotebookControllerGetItems>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof userNotebookControllerGetItems>>>({ exact: $exactMatch, queryKey: getUserNotebookControllerGetItemsQueryKey(notebookType) }, updater);
  };
}

/**
 * @summary Get all active notebook items for the current user by notebook type
 */
export const useGetUserNotebookControllerGetItemsQueryData = () => {
  const queryClient = useQueryClient();
  return (notebookType: 'english',) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof userNotebookControllerGetItems>>>(getUserNotebookControllerGetItemsQueryKey(notebookType));
}



/**
 * @summary Save (upsert) a notebook item for the current user by notebook type
 */
export const userNotebookControllerSaveItem = (
    notebookType: 'english',
    saveVocabUserEnglishNotebookItemDtoSaveSentenceUserEnglishNotebookItemDto: BodyType<SaveVocabUserEnglishNotebookItemDto | SaveSentenceUserEnglishNotebookItemDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<VocabUserEnglishNotebookItem | SentenceUserEnglishNotebookItem>(
      {url: `/user-notebook/${notebookType}/items`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: saveVocabUserEnglishNotebookItemDtoSaveSentenceUserEnglishNotebookItemDto, signal
    },
      options);
    }




export const getUserNotebookControllerSaveItemMutationKey = () => ['userNotebookControllerSaveItem'] as const;

export const getUserNotebookControllerSaveItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userNotebookControllerSaveItem>>, TError,UserNotebookControllerSaveItemMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userNotebookControllerSaveItem>>, TError,UserNotebookControllerSaveItemMutationVariables, TContext> => {

const mutationKey = getUserNotebookControllerSaveItemMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userNotebookControllerSaveItem>>, UserNotebookControllerSaveItemMutationVariables> = (props) => {
          const {notebookType,data} = props ?? {};

          return  userNotebookControllerSaveItem(notebookType,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserNotebookControllerSaveItemMutationResult = NonNullable<Awaited<ReturnType<typeof userNotebookControllerSaveItem>>>
    export type UserNotebookControllerSaveItemMutationBody = BodyType<SaveVocabUserEnglishNotebookItemDto | SaveSentenceUserEnglishNotebookItemDto>
    export type UserNotebookControllerSaveItemMutationError = ErrorType<unknown>
    export type UserNotebookControllerSaveItemMutationVariables = {notebookType: 'english';data: BodyType<SaveVocabUserEnglishNotebookItemDto | SaveSentenceUserEnglishNotebookItemDto>}

    /**
 * @summary Save (upsert) a notebook item for the current user by notebook type
 */
export const useUserNotebookControllerSaveItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userNotebookControllerSaveItem>>, TError,UserNotebookControllerSaveItemMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userNotebookControllerSaveItem>>,
        TError,
        UserNotebookControllerSaveItemMutationVariables,
        TContext
      > => {
      return useMutation(getUserNotebookControllerSaveItemMutationOptions(options), queryClient);
    }

/**
 * @summary Submit vocab notebook item audio for pronunciation grading
 */
export const userNotebookControllerSubmitVocabAudio = (
    notebookType: 'english',
    submitUserNotebookVocabAudioDto: BodyType<SubmitUserNotebookVocabAudioDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {

      const formData = new FormData();
formData.append(`file`, submitUserNotebookVocabAudioDto.file);
formData.append(`level`, submitUserNotebookVocabAudioDto.level);
formData.append(`key`, submitUserNotebookVocabAudioDto.key);

      return customInstance<SubmitUserNotebookVocabAudioResponseDto>(
      {url: `/user-notebook/${notebookType}/items/vocab/submit-audio`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getUserNotebookControllerSubmitVocabAudioMutationKey = () => ['userNotebookControllerSubmitVocabAudio'] as const;

export const getUserNotebookControllerSubmitVocabAudioMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userNotebookControllerSubmitVocabAudio>>, TError,UserNotebookControllerSubmitVocabAudioMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userNotebookControllerSubmitVocabAudio>>, TError,UserNotebookControllerSubmitVocabAudioMutationVariables, TContext> => {

const mutationKey = getUserNotebookControllerSubmitVocabAudioMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userNotebookControllerSubmitVocabAudio>>, UserNotebookControllerSubmitVocabAudioMutationVariables> = (props) => {
          const {notebookType,data} = props ?? {};

          return  userNotebookControllerSubmitVocabAudio(notebookType,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserNotebookControllerSubmitVocabAudioMutationResult = NonNullable<Awaited<ReturnType<typeof userNotebookControllerSubmitVocabAudio>>>
    export type UserNotebookControllerSubmitVocabAudioMutationBody = BodyType<SubmitUserNotebookVocabAudioDto>
    export type UserNotebookControllerSubmitVocabAudioMutationError = ErrorType<unknown>
    export type UserNotebookControllerSubmitVocabAudioMutationVariables = {notebookType: 'english';data: BodyType<SubmitUserNotebookVocabAudioDto>}

    /**
 * @summary Submit vocab notebook item audio for pronunciation grading
 */
export const useUserNotebookControllerSubmitVocabAudio = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userNotebookControllerSubmitVocabAudio>>, TError,UserNotebookControllerSubmitVocabAudioMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userNotebookControllerSubmitVocabAudio>>,
        TError,
        UserNotebookControllerSubmitVocabAudioMutationVariables,
        TContext
      > => {
      return useMutation(getUserNotebookControllerSubmitVocabAudioMutationOptions(options), queryClient);
    }

/**
 * @summary Submit sentence notebook item audio for pronunciation grading
 */
export const userNotebookControllerSubmitSentenceAudio = (
    notebookType: 'english',
    submitUserNotebookSentenceAudioDto: BodyType<SubmitUserNotebookSentenceAudioDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {

      const formData = new FormData();
formData.append(`file`, submitUserNotebookSentenceAudioDto.file);
formData.append(`key`, submitUserNotebookSentenceAudioDto.key);

      return customInstance<SubmitUserNotebookSentenceAudioResponseDto>(
      {url: `/user-notebook/${notebookType}/items/sentence/submit-audio`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getUserNotebookControllerSubmitSentenceAudioMutationKey = () => ['userNotebookControllerSubmitSentenceAudio'] as const;

export const getUserNotebookControllerSubmitSentenceAudioMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userNotebookControllerSubmitSentenceAudio>>, TError,UserNotebookControllerSubmitSentenceAudioMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userNotebookControllerSubmitSentenceAudio>>, TError,UserNotebookControllerSubmitSentenceAudioMutationVariables, TContext> => {

const mutationKey = getUserNotebookControllerSubmitSentenceAudioMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userNotebookControllerSubmitSentenceAudio>>, UserNotebookControllerSubmitSentenceAudioMutationVariables> = (props) => {
          const {notebookType,data} = props ?? {};

          return  userNotebookControllerSubmitSentenceAudio(notebookType,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserNotebookControllerSubmitSentenceAudioMutationResult = NonNullable<Awaited<ReturnType<typeof userNotebookControllerSubmitSentenceAudio>>>
    export type UserNotebookControllerSubmitSentenceAudioMutationBody = BodyType<SubmitUserNotebookSentenceAudioDto>
    export type UserNotebookControllerSubmitSentenceAudioMutationError = ErrorType<unknown>
    export type UserNotebookControllerSubmitSentenceAudioMutationVariables = {notebookType: 'english';data: BodyType<SubmitUserNotebookSentenceAudioDto>}

    /**
 * @summary Submit sentence notebook item audio for pronunciation grading
 */
export const useUserNotebookControllerSubmitSentenceAudio = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userNotebookControllerSubmitSentenceAudio>>, TError,UserNotebookControllerSubmitSentenceAudioMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userNotebookControllerSubmitSentenceAudio>>,
        TError,
        UserNotebookControllerSubmitSentenceAudioMutationVariables,
        TContext
      > => {
      return useMutation(getUserNotebookControllerSubmitSentenceAudioMutationOptions(options), queryClient);
    }

/**
 * @summary Unsave a notebook item for the current user by notebook type
 */
export const userNotebookControllerUnsaveItem = (
    notebookType: 'english',
    unsaveUserNotebookItemDto: BodyType<UnsaveUserNotebookItemDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/user-notebook/${notebookType}/items/unsave`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: unsaveUserNotebookItemDto, signal
    },
      options);
    }




export const getUserNotebookControllerUnsaveItemMutationKey = () => ['userNotebookControllerUnsaveItem'] as const;

export const getUserNotebookControllerUnsaveItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userNotebookControllerUnsaveItem>>, TError,UserNotebookControllerUnsaveItemMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userNotebookControllerUnsaveItem>>, TError,UserNotebookControllerUnsaveItemMutationVariables, TContext> => {

const mutationKey = getUserNotebookControllerUnsaveItemMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userNotebookControllerUnsaveItem>>, UserNotebookControllerUnsaveItemMutationVariables> = (props) => {
          const {notebookType,data} = props ?? {};

          return  userNotebookControllerUnsaveItem(notebookType,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserNotebookControllerUnsaveItemMutationResult = NonNullable<Awaited<ReturnType<typeof userNotebookControllerUnsaveItem>>>
    export type UserNotebookControllerUnsaveItemMutationBody = BodyType<UnsaveUserNotebookItemDto>
    export type UserNotebookControllerUnsaveItemMutationError = ErrorType<unknown>
    export type UserNotebookControllerUnsaveItemMutationVariables = {notebookType: 'english';data: BodyType<UnsaveUserNotebookItemDto>}

    /**
 * @summary Unsave a notebook item for the current user by notebook type
 */
export const useUserNotebookControllerUnsaveItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userNotebookControllerUnsaveItem>>, TError,UserNotebookControllerUnsaveItemMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userNotebookControllerUnsaveItem>>,
        TError,
        UserNotebookControllerUnsaveItemMutationVariables,
        TContext
      > => {
      return useMutation(getUserNotebookControllerUnsaveItemMutationOptions(options), queryClient);
    }

/**
 * @summary Get available items for avatar customization, optionally filtered by category
 */
export const avatarControllerGetCatalog = (
    params?: AvatarControllerGetCatalogParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Item[]>(
      {url: `/avatar/catalog`, method: 'GET',
        params, signal
    },
      options);
    }




export const getAvatarControllerGetCatalogQueryKey = (params?: AvatarControllerGetCatalogParams,) => {
    return [
    `/avatar/catalog`, ...(params ? [params] : [])
    ] as const;
    }


export const getAvatarControllerGetCatalogQueryOptions = <TData = Awaited<ReturnType<typeof avatarControllerGetCatalog>>, TError = ErrorType<unknown>>(params?: AvatarControllerGetCatalogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof avatarControllerGetCatalog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAvatarControllerGetCatalogQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof avatarControllerGetCatalog>>> = ({ signal }) => avatarControllerGetCatalog(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof avatarControllerGetCatalog>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AvatarControllerGetCatalogQueryResult = NonNullable<Awaited<ReturnType<typeof avatarControllerGetCatalog>>>
export type AvatarControllerGetCatalogQueryError = ErrorType<unknown>


export function useAvatarControllerGetCatalog<TData = Awaited<ReturnType<typeof avatarControllerGetCatalog>>, TError = ErrorType<unknown>>(
 params: undefined |  AvatarControllerGetCatalogParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof avatarControllerGetCatalog>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof avatarControllerGetCatalog>>,
          TError,
          Awaited<ReturnType<typeof avatarControllerGetCatalog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAvatarControllerGetCatalog<TData = Awaited<ReturnType<typeof avatarControllerGetCatalog>>, TError = ErrorType<unknown>>(
 params?: AvatarControllerGetCatalogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof avatarControllerGetCatalog>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof avatarControllerGetCatalog>>,
          TError,
          Awaited<ReturnType<typeof avatarControllerGetCatalog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAvatarControllerGetCatalog<TData = Awaited<ReturnType<typeof avatarControllerGetCatalog>>, TError = ErrorType<unknown>>(
 params?: AvatarControllerGetCatalogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof avatarControllerGetCatalog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get available items for avatar customization, optionally filtered by category
 */

export function useAvatarControllerGetCatalog<TData = Awaited<ReturnType<typeof avatarControllerGetCatalog>>, TError = ErrorType<unknown>>(
 params?: AvatarControllerGetCatalogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof avatarControllerGetCatalog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAvatarControllerGetCatalogQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useAvatarControllerGetCatalog} query
 */
export const invalidateAvatarControllerGetCatalog = async (
 queryClient: QueryClient, params?: AvatarControllerGetCatalogParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getAvatarControllerGetCatalogQueryKey(params) }, options);

  return queryClient;
}

/**
 * @summary Get available items for avatar customization, optionally filtered by category
 */
export const useSetAvatarControllerGetCatalogQueryData = () => {
  const queryClient = useQueryClient();
  return (params: AvatarControllerGetCatalogParams | undefined,updater: Awaited<ReturnType<typeof avatarControllerGetCatalog>> | undefined | ((old: Awaited<ReturnType<typeof avatarControllerGetCatalog>> | undefined) => Awaited<ReturnType<typeof avatarControllerGetCatalog>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof avatarControllerGetCatalog>>>({ exact: $exactMatch, queryKey: getAvatarControllerGetCatalogQueryKey(params) }, updater);
  };
}

/**
 * @summary Get available items for avatar customization, optionally filtered by category
 */
export const useGetAvatarControllerGetCatalogQueryData = () => {
  const queryClient = useQueryClient();
  return (params?: AvatarControllerGetCatalogParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof avatarControllerGetCatalog>>>(getAvatarControllerGetCatalogQueryKey(params));
}



/**
 * @summary Get current user's owned avatar items, optionally filtered by category
 */
export const avatarControllerGetInventory = (
    params?: AvatarControllerGetInventoryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserInventoryItem[]>(
      {url: `/avatar/inventory`, method: 'GET',
        params, signal
    },
      options);
    }




export const getAvatarControllerGetInventoryQueryKey = (params?: AvatarControllerGetInventoryParams,) => {
    return [
    `/avatar/inventory`, ...(params ? [params] : [])
    ] as const;
    }


export const getAvatarControllerGetInventoryQueryOptions = <TData = Awaited<ReturnType<typeof avatarControllerGetInventory>>, TError = ErrorType<unknown>>(params?: AvatarControllerGetInventoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof avatarControllerGetInventory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAvatarControllerGetInventoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof avatarControllerGetInventory>>> = ({ signal }) => avatarControllerGetInventory(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof avatarControllerGetInventory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AvatarControllerGetInventoryQueryResult = NonNullable<Awaited<ReturnType<typeof avatarControllerGetInventory>>>
export type AvatarControllerGetInventoryQueryError = ErrorType<unknown>


export function useAvatarControllerGetInventory<TData = Awaited<ReturnType<typeof avatarControllerGetInventory>>, TError = ErrorType<unknown>>(
 params: undefined |  AvatarControllerGetInventoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof avatarControllerGetInventory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof avatarControllerGetInventory>>,
          TError,
          Awaited<ReturnType<typeof avatarControllerGetInventory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAvatarControllerGetInventory<TData = Awaited<ReturnType<typeof avatarControllerGetInventory>>, TError = ErrorType<unknown>>(
 params?: AvatarControllerGetInventoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof avatarControllerGetInventory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof avatarControllerGetInventory>>,
          TError,
          Awaited<ReturnType<typeof avatarControllerGetInventory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAvatarControllerGetInventory<TData = Awaited<ReturnType<typeof avatarControllerGetInventory>>, TError = ErrorType<unknown>>(
 params?: AvatarControllerGetInventoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof avatarControllerGetInventory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current user's owned avatar items, optionally filtered by category
 */

export function useAvatarControllerGetInventory<TData = Awaited<ReturnType<typeof avatarControllerGetInventory>>, TError = ErrorType<unknown>>(
 params?: AvatarControllerGetInventoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof avatarControllerGetInventory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAvatarControllerGetInventoryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useAvatarControllerGetInventory} query
 */
export const invalidateAvatarControllerGetInventory = async (
 queryClient: QueryClient, params?: AvatarControllerGetInventoryParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getAvatarControllerGetInventoryQueryKey(params) }, options);

  return queryClient;
}

/**
 * @summary Get current user's owned avatar items, optionally filtered by category
 */
export const useSetAvatarControllerGetInventoryQueryData = () => {
  const queryClient = useQueryClient();
  return (params: AvatarControllerGetInventoryParams | undefined,updater: Awaited<ReturnType<typeof avatarControllerGetInventory>> | undefined | ((old: Awaited<ReturnType<typeof avatarControllerGetInventory>> | undefined) => Awaited<ReturnType<typeof avatarControllerGetInventory>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof avatarControllerGetInventory>>>({ exact: $exactMatch, queryKey: getAvatarControllerGetInventoryQueryKey(params) }, updater);
  };
}

/**
 * @summary Get current user's owned avatar items, optionally filtered by category
 */
export const useGetAvatarControllerGetInventoryQueryData = () => {
  const queryClient = useQueryClient();
  return (params?: AvatarControllerGetInventoryParams,) =>
    queryClient.getQueryData<Awaited<ReturnType<typeof avatarControllerGetInventory>>>(getAvatarControllerGetInventoryQueryKey(params));
}



/**
 * @summary Purchase an avatar item
 */
export const avatarControllerPurchaseItem = (
    itemIdDto: BodyType<ItemIdDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserInventoryItem>(
      {url: `/avatar/inventory/purchase`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: itemIdDto, signal
    },
      options);
    }




export const getAvatarControllerPurchaseItemMutationKey = () => ['avatarControllerPurchaseItem'] as const;

export const getAvatarControllerPurchaseItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof avatarControllerPurchaseItem>>, TError,AvatarControllerPurchaseItemMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof avatarControllerPurchaseItem>>, TError,AvatarControllerPurchaseItemMutationVariables, TContext> => {

const mutationKey = getAvatarControllerPurchaseItemMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof avatarControllerPurchaseItem>>, AvatarControllerPurchaseItemMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  avatarControllerPurchaseItem(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AvatarControllerPurchaseItemMutationResult = NonNullable<Awaited<ReturnType<typeof avatarControllerPurchaseItem>>>
    export type AvatarControllerPurchaseItemMutationBody = BodyType<ItemIdDto>
    export type AvatarControllerPurchaseItemMutationError = ErrorType<unknown>
    export type AvatarControllerPurchaseItemMutationVariables = {data: BodyType<ItemIdDto>}

    /**
 * @summary Purchase an avatar item
 */
export const useAvatarControllerPurchaseItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof avatarControllerPurchaseItem>>, TError,AvatarControllerPurchaseItemMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof avatarControllerPurchaseItem>>,
        TError,
        AvatarControllerPurchaseItemMutationVariables,
        TContext
      > => {
      return useMutation(getAvatarControllerPurchaseItemMutationOptions(options), queryClient);
    }

/**
 * @summary Get current user's equipped avatar selection, creating an empty one if it does not exist
 */
export const avatarControllerGetSelection = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AvatarSelectionWithItemsDto>(
      {url: `/avatar/selection`, method: 'GET', signal
    },
      options);
    }




export const getAvatarControllerGetSelectionQueryKey = () => {
    return [
    `/avatar/selection`
    ] as const;
    }


export const getAvatarControllerGetSelectionQueryOptions = <TData = Awaited<ReturnType<typeof avatarControllerGetSelection>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof avatarControllerGetSelection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAvatarControllerGetSelectionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof avatarControllerGetSelection>>> = ({ signal }) => avatarControllerGetSelection(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof avatarControllerGetSelection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AvatarControllerGetSelectionQueryResult = NonNullable<Awaited<ReturnType<typeof avatarControllerGetSelection>>>
export type AvatarControllerGetSelectionQueryError = ErrorType<unknown>


export function useAvatarControllerGetSelection<TData = Awaited<ReturnType<typeof avatarControllerGetSelection>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof avatarControllerGetSelection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof avatarControllerGetSelection>>,
          TError,
          Awaited<ReturnType<typeof avatarControllerGetSelection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAvatarControllerGetSelection<TData = Awaited<ReturnType<typeof avatarControllerGetSelection>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof avatarControllerGetSelection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof avatarControllerGetSelection>>,
          TError,
          Awaited<ReturnType<typeof avatarControllerGetSelection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAvatarControllerGetSelection<TData = Awaited<ReturnType<typeof avatarControllerGetSelection>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof avatarControllerGetSelection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current user's equipped avatar selection, creating an empty one if it does not exist
 */

export function useAvatarControllerGetSelection<TData = Awaited<ReturnType<typeof avatarControllerGetSelection>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof avatarControllerGetSelection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAvatarControllerGetSelectionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}


/**
 * @summary Invalidates the {@link useAvatarControllerGetSelection} query
 */
export const invalidateAvatarControllerGetSelection = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: getAvatarControllerGetSelectionQueryKey() }, options);

  return queryClient;
}

/**
 * @summary Get current user's equipped avatar selection, creating an empty one if it does not exist
 */
export const useSetAvatarControllerGetSelectionQueryData = () => {
  const queryClient = useQueryClient();
  return (updater: Awaited<ReturnType<typeof avatarControllerGetSelection>> | undefined | ((old: Awaited<ReturnType<typeof avatarControllerGetSelection>> | undefined) => Awaited<ReturnType<typeof avatarControllerGetSelection>> | undefined), $exactMatch: boolean = true) => {
    queryClient.setQueriesData<Awaited<ReturnType<typeof avatarControllerGetSelection>>>({ exact: $exactMatch, queryKey: getAvatarControllerGetSelectionQueryKey() }, updater);
  };
}

/**
 * @summary Get current user's equipped avatar selection, creating an empty one if it does not exist
 */
export const useGetAvatarControllerGetSelectionQueryData = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.getQueryData<Awaited<ReturnType<typeof avatarControllerGetSelection>>>(getAvatarControllerGetSelectionQueryKey());
}



/**
 * @summary Equip an owned item into its avatar slot
 */
export const avatarControllerEquipItem = (
    itemIdDto: BodyType<ItemIdDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AvatarSelectionWithItemsDto>(
      {url: `/avatar/selection/equip`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: itemIdDto, signal
    },
      options);
    }




export const getAvatarControllerEquipItemMutationKey = () => ['avatarControllerEquipItem'] as const;

export const getAvatarControllerEquipItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof avatarControllerEquipItem>>, TError,AvatarControllerEquipItemMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof avatarControllerEquipItem>>, TError,AvatarControllerEquipItemMutationVariables, TContext> => {

const mutationKey = getAvatarControllerEquipItemMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof avatarControllerEquipItem>>, AvatarControllerEquipItemMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  avatarControllerEquipItem(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AvatarControllerEquipItemMutationResult = NonNullable<Awaited<ReturnType<typeof avatarControllerEquipItem>>>
    export type AvatarControllerEquipItemMutationBody = BodyType<ItemIdDto>
    export type AvatarControllerEquipItemMutationError = ErrorType<unknown>
    export type AvatarControllerEquipItemMutationVariables = {data: BodyType<ItemIdDto>}

    /**
 * @summary Equip an owned item into its avatar slot
 */
export const useAvatarControllerEquipItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof avatarControllerEquipItem>>, TError,AvatarControllerEquipItemMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof avatarControllerEquipItem>>,
        TError,
        AvatarControllerEquipItemMutationVariables,
        TContext
      > => {
      return useMutation(getAvatarControllerEquipItemMutationOptions(options), queryClient);
    }

/**
 * @summary Unequip an item from its avatar slot
 */
export const avatarControllerUnequipItem = (
    itemIdDto: BodyType<ItemIdDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AvatarSelectionWithItemsDto>(
      {url: `/avatar/selection/unequip`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: itemIdDto, signal
    },
      options);
    }




export const getAvatarControllerUnequipItemMutationKey = () => ['avatarControllerUnequipItem'] as const;

export const getAvatarControllerUnequipItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof avatarControllerUnequipItem>>, TError,AvatarControllerUnequipItemMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof avatarControllerUnequipItem>>, TError,AvatarControllerUnequipItemMutationVariables, TContext> => {

const mutationKey = getAvatarControllerUnequipItemMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof avatarControllerUnequipItem>>, AvatarControllerUnequipItemMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  avatarControllerUnequipItem(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AvatarControllerUnequipItemMutationResult = NonNullable<Awaited<ReturnType<typeof avatarControllerUnequipItem>>>
    export type AvatarControllerUnequipItemMutationBody = BodyType<ItemIdDto>
    export type AvatarControllerUnequipItemMutationError = ErrorType<unknown>
    export type AvatarControllerUnequipItemMutationVariables = {data: BodyType<ItemIdDto>}

    /**
 * @summary Unequip an item from its avatar slot
 */
export const useAvatarControllerUnequipItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof avatarControllerUnequipItem>>, TError,AvatarControllerUnequipItemMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof avatarControllerUnequipItem>>,
        TError,
        AvatarControllerUnequipItemMutationVariables,
        TContext
      > => {
      return useMutation(getAvatarControllerUnequipItemMutationOptions(options), queryClient);
    }
